(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("react-dom")) : factory(root["React"], root["ReactDOM"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__48__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 94);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyCode", function() { return KeyCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArrowKey", function() { return isArrowKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunctionalChildren", function() { return isFunctionalChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "childCount", function() { return childCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSafeId", function() { return getSafeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSafeIdSelector", function() { return getSafeIdSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getParents", function() { return getParents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eventTargetContainsNode", function() { return eventTargetContainsNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementRelationship", function() { return ElementRelationship; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRelationship", function() { return getRelationship; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "preventDefault", function() { return preventDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shimRef", function() { return shimRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFocusVisible", function() { return getFocusVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFocusVisible", function() { return setFocusVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mouse", function() { return Mouse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return Touch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pointer", function() { return Pointer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPointByEventType", function() { return getPointByEventType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayEquals", function() { return arrayEquals; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

/**
 * Set of KeyCodes that are used in the platform.
 */
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["backspace"] = 8] = "backspace";
    KeyCode[KeyCode["tab"] = 9] = "tab";
    KeyCode[KeyCode["enter"] = 13] = "enter";
    KeyCode[KeyCode["shift"] = 16] = "shift";
    KeyCode[KeyCode["ctrl"] = 17] = "ctrl";
    KeyCode[KeyCode["alt"] = 18] = "alt";
    KeyCode[KeyCode["pause"] = 19] = "pause";
    KeyCode[KeyCode["capsLock"] = 20] = "capsLock";
    KeyCode[KeyCode["escape"] = 27] = "escape";
    KeyCode[KeyCode["space"] = 32] = "space";
    KeyCode[KeyCode["pageUp"] = 33] = "pageUp";
    KeyCode[KeyCode["pageDown"] = 34] = "pageDown";
    KeyCode[KeyCode["end"] = 35] = "end";
    KeyCode[KeyCode["home"] = 36] = "home";
    KeyCode[KeyCode["leftArrow"] = 37] = "leftArrow";
    KeyCode[KeyCode["upArrow"] = 38] = "upArrow";
    KeyCode[KeyCode["rightArrow"] = 39] = "rightArrow";
    KeyCode[KeyCode["downArrow"] = 40] = "downArrow";
    KeyCode[KeyCode["delete"] = 46] = "delete";
    KeyCode[KeyCode["b"] = 66] = "b";
    KeyCode[KeyCode["i"] = 73] = "i";
    KeyCode[KeyCode["k"] = 75] = "k";
    KeyCode[KeyCode["q"] = 81] = "q";
    KeyCode[KeyCode["t"] = 84] = "t";
    KeyCode[KeyCode["windowsKey"] = 91] = "windowsKey";
    KeyCode[KeyCode["macCommand"] = 91] = "macCommand";
    KeyCode[KeyCode["F10"] = 121] = "F10";
    KeyCode[KeyCode["numLock"] = 144] = "numLock";
    KeyCode[KeyCode["scrollLock"] = 145] = "scrollLock";
    KeyCode[KeyCode["comma"] = 188] = "comma";
})(KeyCode || (KeyCode = {}));
/**
 * Determines whether or not a keystroke is an arrow key or not.
 */
function isArrowKey(event) {
    return (event.which === KeyCode.downArrow ||
        event.which === KeyCode.upArrow ||
        event.which === KeyCode.leftArrow ||
        event.which === KeyCode.rightArrow);
}
/**
 * Type guard function to determine if children are defined as a function
 * @param children (usually from this.props.children)
 */
function isFunctionalChildren(children) {
    return typeof children === "function";
}
/**
 * childCount is used to determine the number of defined renderable children within
 * a standard set of React.Children. This is different than React.Children.length
 * which includes children that are null or undefined.
 */
function childCount(children) {
    var childCount = 0;
    react__WEBPACK_IMPORTED_MODULE_0__["Children"].forEach(children, function (child) {
        if (child) {
            childCount++;
        }
    });
    return childCount;
}
/**
 * getSafeId is designed to create a string from the input id that is safe for use
 * as the id attribute of a component. The ids appear in the global javscript namespace.
 * This means if you create an element and assign the "id" property to a value
 * the element is accessible by doing window.<id>. This causes problems when the
 * id of the element collides with other global objects. Using a SafeId adds a prefix
 * intended to avoid conflicts.
 *
 * This should be called anytime a DOM elements property is being set that refers to
 * the components id. This should not be called when passing the id as a prop to a
 * component. It is the components responsibility to make the Id safe when attaching
 * it to an element.
 *
 * This includes but is not limited to properties like:
 *  aria-controls, aria-describedby, aria-labelledby, id, htmlFor, ...
 *
 * @param id The root id that is being made "Safe".
 */
function getSafeId(id) {
    if (false) {}
    // querySelector won't select id's with .'s in them replace them with '-'.
    return id ? "__bolt-" + id.replace(/[^0-9A-Za-z_]/g, "-") : undefined;
}
/**
 * getSafeIdSelector will return the string that can use used to denote the selector
 * for elements that use this id.
 *
 * @param id The root id that is being made "Safe".
 */
function getSafeIdSelector(id) {
    return "#" + getSafeId(id);
}
/**
 * function that does nothing and accepts any set of arguments.
 */
function noop() { }
/**
 * Basic function for building a css classlist string from and array of classes, where
 * one of more of the arguments may be null or undefined.
 *
 * @param classes Array of strings the represents the css class list.
 *
 * @example css("base", "active", x === 42 && "optional") will return "base active optional" if x === 42 or "base active" otherwise
 */
function css() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes
        .filter(function (c) { return c; })
        .join(" ")
        .trim();
}
/**
 * Returns the set of parent elements with index 0 the root and the last
 * element is either the direct parent or itself based on includeSelf.
 *
 * @param element The element to get the parent element hierarchy from.
 * @param includeSelf Should the element supplied be included in the parent list.
 * @param rootElement Optional root element to stop processing
 * @param includeRoot Should the root element supplied be included in the parent list.
 */
function getParents(element, includeSelf, rootElement, includeRoot) {
    var parentElements = [];
    if (includeSelf) {
        parentElements.push(element);
    }
    while (element.parentElement && element.parentElement !== rootElement) {
        parentElements.splice(0, 0, element.parentElement);
        element = element.parentElement;
    }
    if (element.parentElement && includeRoot) {
        parentElements.splice(0, 0, element.parentElement);
    }
    return parentElements;
}
/**
 * Determines if the target element of an event (or its ancestry) has a particular node name.
 *
 * @param event The initial element is pulled off of this event.
 * @param nodeNames A list of DOM node names ("A", "INPUT", etc.) to check for the presence
 * @param rootAncestor If provided, build a list of ancestors from the event's element, to this element to check. Otherwise,
 * only check the element from the event.
 */
function eventTargetContainsNode(event, nodeNames, rootAncestor) {
    var targetElement = event.target;
    var ancestors = rootAncestor ? getParents(targetElement, true, rootAncestor, true) : [targetElement];
    return ancestors.some(function (element) { return nodeNames.indexOf(element.nodeName) !== -1; });
}
/**
 * ElementRelationship is used to define how two elements in the same
 * document are related in position to each other.
 */
var ElementRelationship;
(function (ElementRelationship) {
    ElementRelationship[ElementRelationship["Unrelated"] = 0] = "Unrelated";
    ElementRelationship[ElementRelationship["Before"] = 1] = "Before";
    ElementRelationship[ElementRelationship["After"] = 2] = "After";
    ElementRelationship[ElementRelationship["Child"] = 3] = "Child";
    ElementRelationship[ElementRelationship["Parent"] = 4] = "Parent";
})(ElementRelationship || (ElementRelationship = {}));
/**
 * getRelationship returns the relationship of the two specified elements.
 *
 * @param element1
 * @param element2
 */
function getRelationship(element1, element2) {
    // If the second element is a child of the first element, then element1 occurs before element2.
    if (element1.contains(element2)) {
        return ElementRelationship.Parent;
    }
    // If the first element is a child of the second element, then element1 occurs after element2.
    if (element2.contains(element1)) {
        return ElementRelationship.Child;
    }
    // Retrieve the parents of both the elements.
    var parents1 = getParents(element1, true);
    var parents2 = getParents(element2, true);
    for (var elementIndex = 0;; elementIndex++) {
        if (parents1[elementIndex] !== parents2[elementIndex]) {
            var siblings = parents1[elementIndex - 1].children;
            for (var siblingIndex = 0; siblingIndex < siblings.length; siblingIndex++) {
                if (siblings[siblingIndex] === parents1[elementIndex]) {
                    return ElementRelationship.Before;
                }
                if (siblings[siblingIndex] === parents2[elementIndex]) {
                    return ElementRelationship.After;
                }
            }
        }
    }
}
/**
 * preventDefault is used as a standard delegate to prevent the default behavior
 * for a given event.
 *
 * @param event Synthetic event that should have its default action prevented.
 */
function preventDefault(event) {
    event.preventDefault();
}
/**
 * shimRef is used to acquire a React Ref from a child component. If the child
 * has an existing ref, it will return the existing ref, if not it will
 * create a new one.
 */
function shimRef(child) {
    // @HACK: This uses an internal property on the created element which is the
    //  forwarded ref property of the element. If React ever changes the implementation
    //  removing this property this code will need to be updated.
    // @NOTE: The ref MUST be a React.createRef if the a ref property is specified,
    //  otherwise we will not be able to share the ref.
    var ref = child.ref;
    // If no ref was created by the element owner we will add one.
    if (!ref) {
        ref = react__WEBPACK_IMPORTED_MODULE_0__["createRef"]();
    }
    else {
        // @DEBUG: Ensure the ref is a React.createRef by validated the current property
        if (!ref.hasOwnProperty("current")) {
            throw Error("Children of a focus zone MUST use React.createRef to obtain child references");
        }
        // @DEBUG
    }
    return ref;
}
var focusVisible = false;
/**
 * Determine whether or not focus is currently visible to the user. This generally
 * means the user is using the keyboard to manage focus instead of the mouse.
 */
function getFocusVisible() {
    return focusVisible;
}
/**
 * Make sure the focus treatment is enabled and disabled based on
 * the state of mouse and keyboard usage.
 */
function setFocusVisible(visible) {
    if ((focusVisible = visible) === true) {
        document.body && document.body.classList.add("bolt-focus-visible");
    }
    else {
        document.body && document.body.classList.remove("bolt-focus-visible");
    }
}
/* Setup the set of non-focus keys, when these are pressed it doesnt start showing focus treatment */
var nonFocusKeys = new Array(255);
nonFocusKeys[KeyCode.alt] = true;
nonFocusKeys[KeyCode.capsLock] = true;
nonFocusKeys[KeyCode.ctrl] = true;
nonFocusKeys[KeyCode.numLock] = true;
nonFocusKeys[KeyCode.pause] = true;
nonFocusKeys[KeyCode.scrollLock] = true;
nonFocusKeys[KeyCode.shift] = true;
nonFocusKeys[KeyCode.windowsKey] = true;
document.addEventListener("keydown", function (event) {
    if (!nonFocusKeys[event.which]) {
        setFocusVisible(true);
    }
}, true);
var mouseCapture;
// MouseCaptureFunction is the global mouse handler we use to trap events and forward
// them to the current capture if one exists.
var mouseCaptureFunction = function (event) {
    // Track the position of the mouse as it moves.
    Mouse.position.x = event.clientX;
    Mouse.position.y = event.clientY;
    // Notify the mouse capture of the mouse movement and mouseup if one is signed up.
    if (mouseCapture && mouseCapture.callback && mouseCapture.button === event.button) {
        mouseCapture.callback(event);
        if (event.type === "mouseup") {
            Mouse.releaseCapture(mouseCapture.callback);
        }
    }
};
var Mouse = {
    position: {
        x: 0,
        y: 0
    },
    releaseCapture: function releaseCapture(callback) {
        if (mouseCapture && mouseCapture.callback === callback) {
            mouseCapture = undefined;
        }
    },
    setCapture: function setCapture(callback, button) {
        if (button === void 0) { button = 0; }
        // Before starting a new capture, we will release the current capture.
        if (mouseCapture) {
            Mouse.releaseCapture(mouseCapture.callback);
        }
        // Update the mouseCapture to the new capture.
        mouseCapture = { button: button, callback: callback };
    }
};
document.addEventListener("mousemove", mouseCaptureFunction);
document.addEventListener("mouseup", mouseCaptureFunction);
document.addEventListener("mousedown", function (event) {
    // Screen readers on scan mode trigger some key strokes as Mouse events.
    // We can easily identify those events because they have no coordinates.
    if (event.button === 0 &&
        event.clientX === 0 &&
        event.clientY === 0 &&
        event.screenX === 0 &&
        event.screenY === 0 &&
        event.pageX === 0 &&
        event.pageY === 0) {
        return;
    }
    setFocusVisible(false);
}, true);
var touchCapture;
// touchCaptureFunction is the global touch handler we use to trap events and forward
// them to the current capture if one exists.
var touchCaptureFunction = function (event) {
    var touch = event.changedTouches && event.changedTouches.length ? event.changedTouches[0] : event.touches[0];
    // Track the position of the touch as it moves.
    Touch.position.x = touch.clientX;
    Touch.position.y = touch.clientY;
    // Notify the touch capture of the touch movement and touchend if one is signed up.
    if (touchCapture && touchCapture.callback) {
        touchCapture.callback(event);
        if (event.type === "touchend") {
            Touch.releaseCapture(touchCapture.callback);
        }
    }
};
/**
 * Currently only basic touch support - assumes a single touch
 * throughout the touch operation.
 */
var Touch = {
    position: {
        x: 0,
        y: 0
    },
    releaseCapture: function releaseCapture(callback) {
        if (touchCapture && touchCapture.callback === callback) {
            touchCapture = undefined;
        }
    },
    setCapture: function setCapture(callback) {
        // Before starting a new capture, we will release the current capture.
        if (touchCapture) {
            Touch.releaseCapture(touchCapture.callback);
        }
        // Update the touchCapture to the new capture.
        touchCapture = { callback: callback };
    }
};
document.addEventListener("touchmove", touchCaptureFunction);
document.addEventListener("touchend", touchCaptureFunction);
document.addEventListener("touchstart", function () { return setFocusVisible(false); }, true);
var pointerCaptures = [];
// PointerCaptureFunction is the global pointer handler we use to trap events and forward
// them to the current capture if one exists.
var pointerCaptureFunction = function (event) {
    // Track the position of the pointer as it moves.
    Pointer.position.x = event.clientX;
    Pointer.position.y = event.clientY;
    // Notify the pointer capture of the pointer movement and pointerup if one is signed up.
    for (var i = pointerCaptures.length - 1; i >= 0; i--) {
        var pointerCapture = pointerCaptures[i];
        if (pointerCapture && pointerCapture.callback) {
            pointerCapture.callback(event);
            if (event.type === "pointerup") {
                Pointer.releaseCapture(pointerCapture.callback);
            }
        }
    }
};
var Pointer = {
    position: {
        x: 0,
        y: 0
    },
    releaseCapture: function releaseCapture(callback) {
        var pointerCaptureIndex = pointerCaptures.findIndex(function (pointerCapture) { return pointerCapture.callback === callback; });
        if (pointerCaptureIndex > -1) {
            pointerCaptures.splice(pointerCaptureIndex, 1);
        }
    },
    setCapture: function setCapture(callback) {
        // Update the pointerCapture to the new capture.
        pointerCaptures.push({ callback: callback });
    }
};
document.addEventListener("pointermove", pointerCaptureFunction);
document.addEventListener("pointerup", pointerCaptureFunction);
document.addEventListener("pointerdown", function (event) {
    // Screen readers on scan mode trigger some key strokes as Pointer events.
    // We can easily identify those events because they have no coordinates.
    if (event.button === 0 &&
        event.clientX === 0 &&
        event.clientY === 0 &&
        event.screenX === 0 &&
        event.screenY === 0 &&
        event.pageX === 0 &&
        event.pageY === 0) {
        return;
    }
    setFocusVisible(false);
}, true);
/**
 * Returns the coordinates of a native event. For mouse / touch events, uses the
 * Mouse/Touch helpers. For a keyboard event, will return undefined.
 * @param event
 */
function getPointByEventType(event) {
    if (event.clientX !== undefined) {
        return { x: Pointer.position.x, y: Pointer.position.y };
    }
    else if (event.changedTouches || event.touches) {
        // If the event has a changedTouches or touches property, it is a touch event.
        return { x: Touch.position.x, y: Touch.position.y };
    }
    else if (event.clientX !== undefined) {
        // If the event has a clientX, it is not a keyboard event, so treat it as a mouse event.
        return { x: Mouse.position.x, y: Mouse.position.y };
    }
    return undefined;
}
/**
 * Checks two arrays to see they contain equal elements in the same order.
 *
 * @param array1 First array to check.
 * @param array2 Second array to check.
 * @param comparer Optional comparer to check whether array items are equal. If not specified, items are compared using strict equals.
 * @returns {boolean}
 */
function arrayEquals(array1, array2, comparer) {
    if (comparer === void 0) { comparer = function (item1, item2) { return item1 === item2; }; }
    if (!array1 && !array2) {
        return true;
    }
    if (!array1 || !array2) {
        return false;
    }
    if (array1.length !== array2.length) {
        return false;
    }
    for (var i = 0; i < array1.length; i++) {
        if (!comparer(array1[i], array2[i])) {
            return false;
        }
    }
    return true;
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __rest; });
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __spreadArrays; });
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(process, global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$mobx", function() { return $mobx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FlowCancellationError", function() { return FlowCancellationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IDerivationState", function() { return IDerivationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableMap", function() { return ObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableSet", function() { return ObservableSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Reaction", function() { return Reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_allowStateChanges", function() { return allowStateChanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_allowStateChangesInsideComputed", function() { return allowStateChangesInsideComputed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_allowStateReadsEnd", function() { return allowStateReadsEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_allowStateReadsStart", function() { return allowStateReadsStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_endAction", function() { return _endAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_getAdministration", function() { return getAdministration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_getGlobalState", function() { return getGlobalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_interceptReads", function() { return interceptReads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_isComputingDerivation", function() { return isComputingDerivation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_resetGlobalState", function() { return resetGlobalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_startAction", function() { return _startAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "action", function() { return action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autorun", function() { return autorun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "comparer", function() { return comparer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computed", function() { return computed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "configure", function() { return configure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAtom", function() { return createAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decorate", function() { return decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entries", function() { return entries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendObservable", function() { return extendObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flow", function() { return flow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAtom", function() { return getAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDebugName", function() { return getDebugName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDependencyTree", function() { return getDependencyTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getObserverTree", function() { return getObserverTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "has", function() { return has; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intercept", function() { return intercept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAction", function() { return isAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayLike", function() { return isArrayLike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBoxedObservable", function() { return isObservableValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isComputed", function() { return isComputed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isComputedProp", function() { return isComputedProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFlowCancellationError", function() { return isFlowCancellationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservable", function() { return isObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableArray", function() { return isObservableArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableMap", function() { return isObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableObject", function() { return isObservableObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableProp", function() { return isObservableProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableSet", function() { return isObservableSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return keys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observable", function() { return observable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observe", function() { return observe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBecomeObserved", function() { return onBecomeObserved; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBecomeUnobserved", function() { return onBecomeUnobserved; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onReactionError", function() { return onReactionError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reaction", function() { return reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runInAction", function() { return runInAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "spy", function() { return spy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toJS", function() { return toJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trace", function() { return trace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transaction", function() { return transaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "untracked", function() { return untracked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "values", function() { return values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "when", function() { return when; });
/** MobX - (c) Michel Weststrate 2015 - 2020 - MIT Licensed */
var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is a production build.";
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message) {
    invariant(false, message);
    throw "X"; // unreachable
}
function invariant(check, message) {
    if (!check)
        throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg, thing) {
    if (true)
        return false;
    if (thing) {
        return deprecated("'" + msg + "', use '" + thing + "' instead.");
    }
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) {
        return dataStructure;
    }
    else if (Array.isArray(dataStructure)) {
        return new Map(dataStructure);
    }
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for (var key in dataStructure) {
            map.set(key, dataStructure[key]);
        }
        return map;
    }
    else {
        return fail("Cannot convert to map from '" + dataStructure + "'");
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    if (false)
        {}
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
/**
 * Returns the following: own keys, prototype keys & own symbol keys, if they are enumerable.
 */
function getPlainObjectKeys(object) {
    var enumerables = new Set();
    for (var key in object)
        enumerables.add(key); // *all* enumerables
    Object.getOwnPropertySymbols(object).forEach(function (k) {
        if (Object.getOwnPropertyDescriptor(object, k).enumerable)
            enumerables.add(k);
    }); // *own* symbols
    // Note: this implementation is missing enumerable, inherited, symbolic property names! That would however pretty expensive to add,
    // as there is no efficient iterator that returns *all* properties
    return Array.from(enumerables);
}
function stringifyKey(key) {
    if (key && key.toString)
        return key.toString();
    else
        return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys
    ? Reflect.ownKeys
    : Object.getOwnPropertySymbols
        ? function (obj) { return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj)); }
        : /* istanbul ignore next */ Object.getOwnPropertyNames;

var $mobx = Symbol("mobx administration");
var Atom = /** @class */ (function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom(name) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        this.name = name;
        this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.isBeingObserved = false;
        this.observers = new Set();
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    Atom.prototype.onBecomeObserved = function () {
        if (this.onBecomeObservedListeners) {
            this.onBecomeObservedListeners.forEach(function (listener) { return listener(); });
        }
    };
    Atom.prototype.onBecomeUnobserved = function () {
        if (this.onBecomeUnobservedListeners) {
            this.onBecomeUnobservedListeners.forEach(function (listener) { return listener(); });
        }
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     * Returns true if there is currently a reactive context.
     */
    Atom.prototype.reportObserved = function () {
        return reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    Atom.prototype.reportChanged = function () {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    Atom.prototype.toString = function () {
        return this.name;
    };
    return Atom;
}());
var isAtom = createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
    if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) {
        onBecomeObserved(atom, onBecomeObservedHandler);
    }
    if (onBecomeUnobservedHandler !== noop) {
        onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    }
    return atom;
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    return Object.is(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer,
    shallow: shallowComparer
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var mobxDidRunLazyInitializersSymbol = Symbol("mobx did run lazy initializers");
var mobxPendingDecorators = Symbol("mobx pending decorators");
var enumerableDescriptorCache = {};
var nonEnumerableDescriptorCache = {};
function createPropertyInitializerDescriptor(prop, enumerable) {
    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
    return (cache[prop] ||
        (cache[prop] = {
            configurable: true,
            enumerable: enumerable,
            get: function () {
                initializeInstance(this);
                return this[prop];
            },
            set: function (value) {
                initializeInstance(this);
                this[prop] = value;
            }
        }));
}
function initializeInstance(target) {
    var e_1, _a;
    if (target[mobxDidRunLazyInitializersSymbol] === true)
        return;
    var decorators = target[mobxPendingDecorators];
    if (decorators) {
        addHiddenProp(target, mobxDidRunLazyInitializersSymbol, true);
        // Build property key array from both strings and symbols
        var keys = __spread(Object.getOwnPropertySymbols(decorators), Object.keys(decorators));
        try {
            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var key = keys_1_1.value;
                var d = decorators[key];
                d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
}
function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
    return function decoratorFactory() {
        var decoratorArguments;
        var decorator = function decorate(target, prop, descriptor, applyImmediately
        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
        // as the instance to apply the decorator to equals the target
        ) {
            if (applyImmediately === true) {
                propertyCreator(target, prop, descriptor, target, decoratorArguments);
                return null;
            }
            if (false)
                {}
            if (!Object.prototype.hasOwnProperty.call(target, mobxPendingDecorators)) {
                var inheritedDecorators = target[mobxPendingDecorators];
                addHiddenProp(target, mobxPendingDecorators, __assign({}, inheritedDecorators));
            }
            target[mobxPendingDecorators][prop] = {
                prop: prop,
                propertyCreator: propertyCreator,
                descriptor: descriptor,
                decoratorTarget: target,
                decoratorArguments: decoratorArguments
            };
            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
        };
        if (quacksLikeADecorator(arguments)) {
            // @decorator
            decoratorArguments = EMPTY_ARRAY;
            return decorator.apply(null, arguments);
        }
        else {
            // @decorator(args)
            decoratorArguments = Array.prototype.slice.call(arguments);
            return decorator;
        }
    };
}
function quacksLikeADecorator(args) {
    return (((args.length === 2 || args.length === 3) &&
        (typeof args[1] === "string" || typeof args[1] === "symbol")) ||
        (args.length === 4 && args[3] === true));
}

function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, { name: name });
    if (isPlainObject(v))
        return observable.object(v, undefined, { name: name });
    if (isES6Map(v))
        return observable.map(v, { name: name });
    if (isES6Set(v))
        return observable.set(v, { name: name });
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v))
        return v;
    if (Array.isArray(v))
        return observable.array(v, { name: name, deep: false });
    if (isPlainObject(v))
        return observable.object(v, undefined, { name: name, deep: false });
    if (isES6Map(v))
        return observable.map(v, { name: name, deep: false });
    if (isES6Set(v))
        return observable.set(v, { name: name, deep: false });
    return fail( false &&
        false);
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue, name) {
    if (false)
        {}
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}

function createDecoratorForEnhancer(enhancer) {
    invariant(enhancer);
    var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
        if (false) {}
        var initialValue = descriptor
            ? descriptor.initializer
                ? descriptor.initializer.call(target)
                : descriptor.value
            : undefined;
        asObservableObject(target).addObservableProp(propertyName, initialValue, enhancer);
    });
    var res = 
    // Extra process checks, as this happens during module initialization
    typeof process !== "undefined" && process.env && "production" !== "production"
        ? function observableDecorator() {
            // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
            // and simply return the created prop decorator
            if (arguments.length < 2)
                return fail("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
            return decorator.apply(null, arguments);
        }
        : decorator;
    res.enhancer = enhancer;
    return res;
}

// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function assertValidOption(key) {
    if (!/^(deep|name|equals|defaultDecorator|proxy)$/.test(key))
        fail("invalid option for (extend)observable: " + key);
}
function asCreateObservableOptions(thing) {
    if (thing === null || thing === undefined)
        return defaultCreateObservableOptions;
    if (typeof thing === "string")
        return { name: thing, deep: true, proxy: true };
    if (false) {}
    return thing;
}
var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
function getEnhancerFromOptions(options) {
    return options.defaultDecorator
        ? options.defaultDecorator.enhancer
        : options.deep === false
            ? referenceEnhancer
            : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v, arg2, arg3) {
    // @observable someProp;
    if (typeof arguments[1] === "string" || typeof arguments[1] === "symbol") {
        return deepDecorator.apply(null, arguments);
    }
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = isPlainObject(v)
        ? observable.object(v, arg2, arg3)
        : Array.isArray(v)
            ? observable.array(v, arg2)
            : isES6Map(v)
                ? observable.map(v, arg2)
                : isES6Set(v)
                    ? observable.set(v, arg2)
                    : v;
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    fail( false &&
        false);
}
var observableFactories = {
    box: function (value, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        var o = asCreateObservableOptions(options);
        return createObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("set");
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function (props, decorators, options) {
        if (typeof arguments[1] === "string")
            incorrectlyUsedAsDecorator("object");
        var o = asCreateObservableOptions(options);
        if (o.proxy === false) {
            return extendObservable({}, props, decorators, o);
        }
        else {
            var defaultDecorator = getDefaultDecoratorFromObjectOptions(o);
            var base = extendObservable({}, undefined, undefined, o);
            var proxy = createDynamicObservableObject(base);
            extendObservableObjectWithProperties(proxy, props, decorators, defaultDecorator);
            return proxy;
        }
    },
    ref: refDecorator,
    shallow: shallowDecorator,
    deep: deepDecorator,
    struct: refStructDecorator
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
function incorrectlyUsedAsDecorator(methodName) {
    fail(
    // process.env.NODE_ENV !== "production" &&
    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
    if (false) {}
    var get = descriptor.get, set = descriptor.set; // initialValue is the descriptor for get / set props
    // Optimization: faster on decorator target or instance? Assuming target
    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
    // Forcing instance now, fixes hot reloadig issues on React Native:
    var options = decoratorArgs[0] || {};
    asObservableObject(instance).addComputedProp(instance, propertyName, __assign({ get: get,
        set: set, context: instance }, options));
});
var computedStructDecorator = computedDecorator({ equals: comparer.structural });
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        // @computed
        return computedDecorator.apply(null, arguments);
    }
    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
        // @computed({ options })
        return computedDecorator.apply(null, arguments);
    }
    // computed(expr, options?)
    if (false) {}
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.get = arg1;
    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
    opts.name = opts.name || arg1.name || ""; /* for generated name */
    return new ComputedValue(opts);
};
computed.struct = computedStructDecorator;

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */ (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) {
                        obj.get();
                    }
                    else {
                        try {
                            obj.get();
                        }
                        catch (e) {
                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                            untrackedEnd(prevUntracked);
                            allowStateReadsEnd(prevAllowStateReads);
                            return true;
                        }
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
        }
    }
}
// function invariantShouldCompute(derivation: IDerivation) {
//     const newDepState = (derivation as any).dependenciesState
//     if (
//         process.env.NODE_ENV === "production" &&
//         (newDepState === IDerivationState.POSSIBLY_STALE ||
//             newDepState === IDerivationState.NOT_TRACKING)
//     )
//         fail("Illegal dependency state")
// }
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers = atom.observers.size > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers)
        fail( false &&
            false);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "strict"))
        fail( false &&
            false);
}
function checkIfStateReadsAreAllowed(observable) {
    if (false) {}
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    if (globalState.disableErrorBoundaries === true) {
        result = f.call(context);
    }
    else {
        try {
            result = f.call(context);
        }
        catch (e) {
            result = new CaughtException(e);
        }
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    if (true)
        return;
    if (derivation.observing.length !== 0)
        return;
    if (globalState.reactionRequiresObservable || derivation.requiresObservable) {
        console.warn("[mobx] Derivation " + derivation.name + " is created/updated without reading any observable value");
    }
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    }
    finally {
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var functionNameDescriptor = Object.getOwnPropertyDescriptor(function () { }, "name");
var isFunctionNameConfigurable = functionNameDescriptor && functionNameDescriptor.configurable;
function createAction(actionName, fn, ref) {
    if (false) {}
    var res = function () {
        return executeAction(actionName, fn, ref || this, arguments);
    };
    res.isMobxAction = true;
    if (false) {}
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = _startAction(actionName, scope, args);
    try {
        return fn.apply(scope, args);
    }
    catch (err) {
        runInfo.error = err;
        throw err;
    }
    finally {
        _endAction(runInfo);
    }
}
function _startAction(actionName, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy && "production" !== "production") {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    var prevAllowStateReads = allowStateReadsStart(true);
    var runInfo = {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        prevAllowStateReads: prevAllowStateReads,
        notifySpy: notifySpy,
        startTime: startTime,
        actionId: nextActionId++,
        parentActionId: currentActionId
    };
    currentActionId = runInfo.actionId;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId) {
        fail("invalid action stack. did you forget to finish an action?");
    }
    currentActionId = runInfo.parentActionId;
    if (runInfo.error !== undefined) {
        globalState.suppressReactionErrors = true;
    }
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    allowStateReadsEnd(runInfo.prevAllowStateReads);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy && "production" !== "production") {
        spyReportEnd({ time: Date.now() - runInfo.startTime });
    }
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
function allowStateChangesInsideComputed(func) {
    var prev = globalState.computationDepth;
    globalState.computationDepth = 0;
    var res;
    try {
        res = func();
    }
    finally {
        globalState.computationDepth = prev;
    }
    return res;
}

var ObservableValue = /** @class */ (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy, equals) {
        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
        if (notifySpy === void 0) { notifySpy = true; }
        if (equals === void 0) { equals = comparer.default; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.name = name;
        _this.equals = equals;
        _this.hasUnreportedChange = false;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled() && "production" !== "production") {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy && "production" !== "production") {
                spyReportStart({
                    type: "update",
                    name: this.name,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.equals(this.value, newValue) ? globalState.UNCHANGED : newValue;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ObservableValue.prototype[Symbol.toPrimitive] = function () {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom));
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /** @class */ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce a new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(options) {
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isBeingObserved = false;
        this.isPendingUnobservation = false;
        this.observers = new Set();
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        invariant(options.get, "missing option for computed: get");
        this.derivation = options.get;
        this.name = options.name || "ComputedValue@" + getNextId();
        if (options.set)
            this.setter = createAction(this.name + "-setter", options.set);
        this.equals =
            options.equals ||
                (options.compareStructural || options.struct
                    ? comparer.structural
                    : comparer.default);
        this.scope = options.context;
        this.requiresReaction = !!options.requiresReaction;
        this.keepAlive = !!options.keepAlive;
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeObserved = function () {
        if (this.onBecomeObservedListeners) {
            this.onBecomeObservedListeners.forEach(function (listener) { return listener(); });
        }
    };
    ComputedValue.prototype.onBecomeUnobserved = function () {
        if (this.onBecomeUnobservedListeners) {
            this.onBecomeUnobservedListeners.forEach(function (listener) { return listener(); });
        }
    };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        if (this.isComputing)
            fail("Cycle detected in computation " + this.name + ": " + this.derivation);
        if (globalState.inBatch === 0 && this.observers.size === 0 && !this.keepAlive) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead();
                startBatch(); // See perf test 'computed memoization'
                this.value = this.computeValue(false);
                endBatch();
            }
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false,  false &&
                false);
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled() && "production" !== "production") {
            spyReport({
                object: this.scope,
                type: "compute",
                name: this.name
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = this.computeValue(true);
        var changed = wasSuspended ||
            isCaughtException(oldValue) ||
            isCaughtException(newValue) ||
            !this.equals(oldValue, newValue);
        if (changed) {
            this.value = newValue;
        }
        return changed;
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            if (globalState.disableErrorBoundaries === true) {
                res = this.derivation.call(this.scope);
            }
            else {
                try {
                    res = this.derivation.call(this.scope);
                }
                catch (e) {
                    res = new CaughtException(e);
                }
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.suspend = function () {
        if (!this.keepAlive) {
            clearObserving(this);
            this.value = undefined; // don't hold on to computed value!
        }
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.warnAboutUntrackedRead = function () {
        if (true)
            return;
        if (this.requiresReaction === true) {
            fail("[mobx] Computed value " + this.name + " is read outside a reactive context");
        }
        if (this.isTracing !== TraceMode.NONE) {
            console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute");
        }
        if (globalState.computedRequiresReaction) {
            console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute");
        }
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ComputedValue.prototype[Symbol.toPrimitive] = function () {
        return this.valueOf();
    };
    return ComputedValue;
}());
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

/**
 * These values will persist if global state is reset
 */
var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED"
];
var MobXGlobals = /** @class */ (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         *
         * N.B: this version is unrelated to the package version of MobX, and is only the version of the
         * internal state storage of MobX, and can be the same across many different package versions
         */
        this.version = 5;
        /**
         * globally unique token to signal unchanged
         */
        this.UNCHANGED = {};
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * Is it allowed to read observables at this point?
         * Used to hold the state needed for `observableRequiresReaction`
         */
        this.allowStateReads = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.enforceActions = false;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
        /**
         * Warn if computed values are accessed outside a reactive context
         */
        this.computedRequiresReaction = false;
        /**
         * (Experimental)
         * Warn if you try to create to derivation / reactive context without accessing any observable.
         */
        this.reactionRequiresObservable = false;
        /**
         * (Experimental)
         * Warn if observables are accessed outside a reactive context
         */
        this.observableRequiresReaction = false;
        /**
         * Allows overwriting of computed properties, useful in tests but not prod as it can cause
         * memory leaks. See https://github.com/mobxjs/mobx/issues/1867
         */
        this.computedConfigurable = false;
        /*
         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
         * the stack when an exception occurs while debugging.
         */
        this.disableErrorBoundaries = false;
        /*
         * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
         * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
         */
        this.suppressReactionErrors = false;
    }
    return MobXGlobals;
}());
var mockGlobal = {};
function getGlobal() {
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    return mockGlobal;
}
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = (function () {
    var global = getGlobal();
    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals)
        canMergeGlobalState = false;
    if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals().version)
        canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        setTimeout(function () {
            if (!isolateCalled) {
                fail("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
            }
        }, 1);
        return new MobXGlobals();
    }
    else if (global.__mobxGlobals) {
        global.__mobxInstanceCount += 1;
        if (!global.__mobxGlobals.UNCHANGED)
            global.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible
        return global.__mobxGlobals;
    }
    else {
        global.__mobxInstanceCount = 1;
        return (global.__mobxGlobals = new MobXGlobals());
    }
})();
function isolateGlobalState() {
    if (globalState.pendingReactions.length ||
        globalState.inBatch ||
        globalState.isRunningReactions)
        fail("isolateGlobalState should be called before MobX is running any reactions");
    isolateCalled = true;
    if (canMergeGlobalState) {
        if (--getGlobal().__mobxInstanceCount === 0)
            getGlobal().__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.size > 0;
}
function getObservers(observable) {
    return observable.observers;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers.add(node);
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers.delete(node);
    if (observable.observers.size === 0) {
        // deleting last observer
        queueForUnobservation(observable);
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBecomeUnobserved();
                }
                if (observable instanceof ComputedValue) {
                    // computed values are automatically teared down when the last observer leaves
                    // this process happens recursively, this computed might be the last observable of another, etc..
                    observable.suspend();
                }
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
            if (!observable.isBeingObserved) {
                observable.isBeingObserved = true;
                observable.onBecomeObserved();
            }
        }
        return true;
    }
    else if (observable.observers.size === 0 && globalState.inBatch > 0) {
        queueForUnobservation(observable);
    }
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    });
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    });
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    });
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}

var Reaction = /** @class */ (function () {
    function Reaction(name, onInvalidate, errorHandler, requiresObservable) {
        if (name === void 0) { name = "Reaction@" + getNextId(); }
        if (requiresObservable === void 0) { requiresObservable = false; }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.errorHandler = errorHandler;
        this.requiresObservable = requiresObservable;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                try {
                    this.onInvalidate();
                    if (this._isTrackPending &&
                        isSpyEnabled() &&
                        "production" !== "production") {
                        // onInvalidate didn't trigger track right away..
                        spyReport({
                            name: this.name,
                            type: "scheduled-reaction"
                        });
                    }
                }
                catch (e) {
                    this.reportExceptionInDerivation(e);
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        if (this.isDisposed) {
            return;
            // console.warn("Reaction already disposed") // Note: Not a warning / error in mobx 4 either
        }
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify && "production" !== "production") {
            startTime = Date.now();
            spyReportStart({
                name: this.name,
                type: "reaction"
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify && "production" !== "production") {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries)
            throw error;
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
        if (globalState.suppressReactionErrors) {
            console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)"); // prettier-ignore
        }
        else {
            console.error(message, error);
            /** If debugging brought you here, please, read the above message :-). Tnx! */
        }
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                name: this.name,
                message: message,
                error: "" + error
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r[$mobx] = this;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}());
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function isSpyEnabled() {
    return  false && false;
}
function spyReport(event) {
    if (true)
        return; // dead code elimination can do the rest
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    if (true)
        return;
    var change = __assign(__assign({}, event), { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (true)
        return;
    if (change)
        spyReport(__assign(__assign({}, change), { spyReportEnd: true }));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    if (true) {
        console.warn("[mobx.spy] Is a no-op in production builds");
        return function () { };
    }
    else {}
}

function dontReassignFields() {
    fail( false && false);
}
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor) {
            if (false) {}
            // babel / typescript
            // @action method() { }
            if (descriptor.value) {
                // typescript
                return {
                    value: createAction(name, descriptor.value),
                    enumerable: false,
                    configurable: true,
                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
                };
            }
            // babel only: @action method = () => {}
            var initializer_1 = descriptor.initializer;
            return {
                enumerable: false,
                configurable: true,
                writable: true,
                initializer: function () {
                    // N.B: we can't immediately invoke initializer; this would be wrong
                    return createAction(name, initializer_1.call(this));
                }
            };
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function actionFieldDecorator(name) {
    // Simple property that writes on first invocation to the current instance
    return function (target, prop, descriptor) {
        Object.defineProperty(target, prop, {
            configurable: true,
            enumerable: false,
            get: function () {
                return undefined;
            },
            set: function (value) {
                addHiddenProp(this, prop, action(name, value));
            }
        });
    };
}
function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
    if (applyToInstance === true) {
        defineBoundAction(target, propertyName, descriptor.value);
        return null;
    }
    if (descriptor) {
        // if (descriptor.value)
        // Typescript / Babel: @action.bound method() { }
        // also: babel @action.bound method = () => {}
        return {
            configurable: true,
            enumerable: false,
            get: function () {
                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
                return this[propertyName];
            },
            set: dontReassignFields
        };
    }
    // field decorator Typescript @action.bound method = () => {}
    return {
        enumerable: false,
        configurable: true,
        set: function (v) {
            defineBoundAction(this, propertyName, v);
        },
        get: function () {
            return undefined;
        }
    };
}

var action = function action(arg1, arg2, arg3, arg4) {
    // action(fn() {})
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    // action("name", fn() {})
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    // @action("name") fn() {}
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    // @action fn() {}
    if (arg4 === true) {
        // apply to instance immediately
        addHiddenProp(arg1, arg2, createAction(arg1.name || arg2, arg3.value, this));
    }
    else {
        return namedActionDecorator(arg2).apply(null, arguments);
    }
};
action.bound = boundActionDecorator;
function runInAction(arg1, arg2) {
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    if (false) {}
    return executeAction(actionName, fn, this, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
}

/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */
function autorun(view, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT; }
    if (false) {}
    var name = (opts && opts.name) || view.name || "Autorun@" + getNextId();
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) {
        // normal autorun
        reaction = new Reaction(name, function () {
            this.track(reactionRunner);
        }, opts.onError, opts.requiresObservable);
    }
    else {
        var scheduler_1 = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled_1 = false;
        reaction = new Reaction(name, function () {
            if (!isScheduled_1) {
                isScheduled_1 = true;
                scheduler_1(function () {
                    isScheduled_1 = false;
                    if (!reaction.isDisposed)
                        reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
var run = function (f) { return f(); };
function createSchedulerFromOptions(opts) {
    return opts.scheduler
        ? opts.scheduler
        : opts.delay
            ? function (f) { return setTimeout(f, opts.delay); }
            : run;
}
function reaction(expression, effect, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT; }
    if (false) {}
    var name = opts.name || "Reaction@" + getNextId();
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural
        ? comparer.structural
        : opts.equals || comparer.default;
    var r = new Reaction(name, function () {
        if (firstTime || runSync) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false; // Q: move into reaction runner?
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effectAction(value, r);
        if (!firstTime && changed === true)
            effectAction(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function () {
        try {
            return baseFn.apply(this, arguments);
        }
        catch (e) {
            errorHandler.call(this, e);
        }
    };
}

function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook("onBecomeObserved", thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = typeof arg3 === "function" ? arg3 : arg2;
    var listenersKey = hook + "Listeners";
    if (atom[listenersKey]) {
        atom[listenersKey].add(cb);
    }
    else {
        atom[listenersKey] = new Set([cb]);
    }
    var orig = atom[hook];
    if (typeof orig !== "function")
        return fail( false && false);
    return function () {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners.delete(cb);
            if (hookListeners.size === 0) {
                delete atom[listenersKey];
            }
        }
    };
}

function configure(options) {
    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, computedConfigurable = options.computedConfigurable, disableErrorBoundaries = options.disableErrorBoundaries, reactionScheduler = options.reactionScheduler, reactionRequiresObservable = options.reactionRequiresObservable, observableRequiresReaction = options.observableRequiresReaction;
    if (options.isolateGlobalState === true) {
        isolateGlobalState();
    }
    if (enforceActions !== undefined) {
        if (typeof enforceActions === "boolean" || enforceActions === "strict")
            deprecated("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
        var ea = void 0;
        switch (enforceActions) {
            case true:
            case "observed":
                ea = true;
                break;
            case false:
            case "never":
                ea = false;
                break;
            case "strict":
            case "always":
                ea = "strict";
                break;
            default:
                fail("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
        }
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === "strict" ? false : true;
    }
    if (computedRequiresReaction !== undefined) {
        globalState.computedRequiresReaction = !!computedRequiresReaction;
    }
    if (reactionRequiresObservable !== undefined) {
        globalState.reactionRequiresObservable = !!reactionRequiresObservable;
    }
    if (observableRequiresReaction !== undefined) {
        globalState.observableRequiresReaction = !!observableRequiresReaction;
        globalState.allowStateReads = !globalState.observableRequiresReaction;
    }
    if (computedConfigurable !== undefined) {
        globalState.computedConfigurable = !!computedConfigurable;
    }
    if (disableErrorBoundaries !== undefined) {
        if (disableErrorBoundaries === true)
            console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled.");
        globalState.disableErrorBoundaries = !!disableErrorBoundaries;
    }
    if (reactionScheduler) {
        setReactionScheduler(reactionScheduler);
    }
}

function decorate(thing, decorators) {
     false &&
        false;
    var target = typeof thing === "function" ? thing.prototype : thing;
    var _loop_1 = function (prop) {
        var propertyDecorators = decorators[prop];
        if (!Array.isArray(propertyDecorators)) {
            propertyDecorators = [propertyDecorators];
        }
         false &&
            false;
        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
        var newDescriptor = propertyDecorators.reduce(function (accDescriptor, decorator) { return decorator(target, prop, accDescriptor); }, descriptor);
        if (newDescriptor)
            Object.defineProperty(target, prop, newDescriptor);
    };
    for (var prop in decorators) {
        _loop_1(prop);
    }
    return thing;
}

function extendObservable(target, properties, decorators, options) {
    if (false) {}
    options = asCreateObservableOptions(options);
    var defaultDecorator = getDefaultDecoratorFromObjectOptions(options);
    initializeInstance(target); // Fixes #1740
    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
    if (properties)
        extendObservableObjectWithProperties(target, properties, decorators, defaultDecorator);
    return target;
}
function getDefaultDecoratorFromObjectOptions(options) {
    return options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
}
function extendObservableObjectWithProperties(target, properties, decorators, defaultDecorator) {
    var e_1, _a, e_2, _b;
    if (false) { var key, keys_1, keys_1_1, keys; }
    startBatch();
    try {
        var keys = ownKeys(properties);
        try {
            for (var keys_2 = __values(keys), keys_2_1 = keys_2.next(); !keys_2_1.done; keys_2_1 = keys_2.next()) {
                var key = keys_2_1.value;
                var descriptor = Object.getOwnPropertyDescriptor(properties, key);
                if (false) {}
                var decorator = decorators && key in decorators
                    ? decorators[key]
                    : descriptor.get
                        ? computedDecorator
                        : defaultDecorator;
                if (false)
                    {}
                var resultDescriptor = decorator(target, key, descriptor, true);
                if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
                )
                    Object.defineProperty(target, key, resultDescriptor);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (keys_2_1 && !keys_2_1.done && (_b = keys_2.return)) _b.call(keys_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    finally {
        endBatch();
    }
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}

var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
function flow(generator) {
    if (arguments.length !== 1)
        fail( true && "Flow expects 1 argument and cannot be used as decorator");
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    return function () {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function (resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (ret && typeof ret.then === "function") {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done)
                    return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function () {
            try {
                if (pendingPromise)
                    cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var res = gen.return(undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            }
            catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
}
function cancelPromise(promise) {
    if (typeof promise.cancel === "function")
        promise.cancel();
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail( false &&
                false);
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail( false &&
            false);
    }
    if (target.dehancer !== undefined)
        return fail( false && false);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

function _isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        if (!value[$mobx].values.has(property))
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}
function isComputed(value) {
    if (arguments.length > 1)
        return fail( false &&
            false);
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    if (typeof propName !== "string")
        return fail( false &&
            false);
    return _isComputed(value, propName);
}

function _isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (false)
            {}
        if (isObservableObject(value)) {
            return value[$mobx].values.has(property);
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject(value) ||
        !!value[$mobx] ||
        isAtom(value) ||
        isReaction(value) ||
        isComputedValue(value));
}
function isObservable(value) {
    if (arguments.length !== 1)
        fail( false &&
            false);
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    if (typeof propName !== "string")
        return fail( false && false);
    return _isObservable(value, propName);
}

function keys(obj) {
    if (isObservableObject(obj)) {
        return obj[$mobx].getKeys();
    }
    if (isObservableMap(obj)) {
        return Array.from(obj.keys());
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.keys());
    }
    if (isObservableArray(obj)) {
        return obj.map(function (_, index) { return index; });
    }
    return fail( false &&
        false);
}
function values(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) { return obj[key]; });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) { return obj.get(key); });
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.values());
    }
    if (isObservableArray(obj)) {
        return obj.slice();
    }
    return fail( false &&
        false);
}
function entries(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) { return [key, obj[key]]; });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) { return [key, obj.get(key)]; });
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.entries());
    }
    if (isObservableArray(obj)) {
        return obj.map(function (key, index) { return [index, key]; });
    }
    return fail( false &&
        false);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var values_1 = key;
        try {
            for (var key_1 in values_1)
                set(obj, key_1, values_1[key_1]);
        }
        finally {
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) {
        var adm = obj[$mobx];
        var existingObservable = adm.values.get(key);
        if (existingObservable) {
            adm.write(key, value);
        }
        else {
            adm.addObservableProp(key, value, adm.defaultEnhancer);
        }
    }
    else if (isObservableMap(obj)) {
        obj.set(key, value);
    }
    else if (isObservableSet(obj)) {
        obj.add(key);
    }
    else if (isObservableArray(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        startBatch();
        if (key >= obj.length)
            obj.length = key + 1;
        obj[key] = value;
        endBatch();
    }
    else {
        return fail( false &&
            false);
    }
}
function remove(obj, key) {
    if (isObservableObject(obj)) {
        obj[$mobx].remove(key);
    }
    else if (isObservableMap(obj)) {
        obj.delete(key);
    }
    else if (isObservableSet(obj)) {
        obj.delete(key);
    }
    else if (isObservableArray(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        obj.splice(key, 1);
    }
    else {
        return fail( false &&
            false);
    }
}
function has(obj, key) {
    if (isObservableObject(obj)) {
        // return keys(obj).indexOf(key) >= 0
        var adm = getAdministration(obj);
        return adm.has(key);
    }
    else if (isObservableMap(obj)) {
        return obj.has(key);
    }
    else if (isObservableSet(obj)) {
        return obj.has(key);
    }
    else if (isObservableArray(obj)) {
        return key >= 0 && key < obj.length;
    }
    else {
        return fail( false &&
            false);
    }
}
function get(obj, key) {
    if (!has(obj, key))
        return undefined;
    if (isObservableObject(obj)) {
        return obj[key];
    }
    else if (isObservableMap(obj)) {
        return obj.get(key);
    }
    else if (isObservableArray(obj)) {
        return obj[key];
    }
    else {
        return fail( false &&
            false);
    }
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

var defaultOptions = {
    detectCycles: true,
    exportMapsAsObjects: true,
    recurseEverything: false
};
function cache(map, key, value, options) {
    if (options.detectCycles)
        map.set(key, value);
    return value;
}
function toJSHelper(source, options, __alreadySeen) {
    if (!options.recurseEverything && !isObservable(source))
        return source;
    if (typeof source !== "object")
        return source;
    // Directly return null if source is null
    if (source === null)
        return null;
    // Directly return the Date object itself if contained in the observable
    if (source instanceof Date)
        return source;
    if (isObservableValue(source))
        return toJSHelper(source.get(), options, __alreadySeen);
    // make sure we track the keys of the object
    if (isObservable(source))
        keys(source);
    var detectCycles = options.detectCycles === true;
    if (detectCycles && source !== null && __alreadySeen.has(source)) {
        return __alreadySeen.get(source);
    }
    if (isObservableArray(source) || Array.isArray(source)) {
        var res_1 = cache(__alreadySeen, source, [], options);
        var toAdd = source.map(function (value) { return toJSHelper(value, options, __alreadySeen); });
        res_1.length = toAdd.length;
        for (var i = 0, l = toAdd.length; i < l; i++)
            res_1[i] = toAdd[i];
        return res_1;
    }
    if (isObservableSet(source) || Object.getPrototypeOf(source) === Set.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_2 = cache(__alreadySeen, source, new Set(), options);
            source.forEach(function (value) {
                res_2.add(toJSHelper(value, options, __alreadySeen));
            });
            return res_2;
        }
        else {
            var res_3 = cache(__alreadySeen, source, [], options);
            source.forEach(function (value) {
                res_3.push(toJSHelper(value, options, __alreadySeen));
            });
            return res_3;
        }
    }
    if (isObservableMap(source) || Object.getPrototypeOf(source) === Map.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_4 = cache(__alreadySeen, source, new Map(), options);
            source.forEach(function (value, key) {
                res_4.set(key, toJSHelper(value, options, __alreadySeen));
            });
            return res_4;
        }
        else {
            var res_5 = cache(__alreadySeen, source, {}, options);
            source.forEach(function (value, key) {
                res_5[key] = toJSHelper(value, options, __alreadySeen);
            });
            return res_5;
        }
    }
    // Fallback to the situation that source is an ObservableObject or a plain object
    var res = cache(__alreadySeen, source, {}, options);
    getPlainObjectKeys(source).forEach(function (key) {
        res[key] = toJSHelper(source[key], options, __alreadySeen);
    });
    return res;
}
function toJS(source, options) {
    // backward compatibility
    if (typeof options === "boolean")
        options = { detectCycles: options };
    if (!options)
        options = defaultOptions;
    options.detectCycles =
        options.detectCycles === undefined
            ? options.recurseEverything === true
            : options.detectCycles === true;
    var __alreadySeen;
    if (options.detectCycles)
        __alreadySeen = new Map();
    return toJSHelper(source, options, __alreadySeen);
}

function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail( false &&
            false);
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch();
    try {
        return action.apply(thisArg);
    }
    finally {
        endBatch();
    }
}

function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || (arg1 && typeof arg1 === "object"))
        return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        timeoutHandle = setTimeout(function () {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                var error = new Error("WHEN_TIMEOUT");
                if (opts.onError)
                    opts.onError(error);
                else
                    throw error;
            }
        }, opts.timeout);
    }
    opts.name = opts.name || "When@" + getNextId();
    var effectAction = createAction(opts.name + "-effect", effect);
    var disposer = autorun(function (r) {
        if (predicate()) {
            r.dispose();
            if (timeoutHandle)
                clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    if (false)
        {}
    var cancel;
    var res = new Promise(function (resolve, reject) {
        var disposer = _when(predicate, resolve, __assign(__assign({}, opts), { onError: reject }));
        cancel = function () {
            disposer();
            reject("WHEN_CANCELLED");
        };
    });
    res.cancel = cancel;
    return res;
}

function getAdm(target) {
    return target[$mobx];
}
function isPropertyKey(val) {
    return typeof val === "string" || typeof val === "number" || typeof val === "symbol";
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function (target, name) {
        if (name === $mobx || name === "constructor" || name === mobxDidRunLazyInitializersSymbol)
            return true;
        var adm = getAdm(target);
        // MWE: should `in` operator be reactive? If not, below code path will be faster / more memory efficient
        // TODO: check performance stats!
        // if (adm.values.get(name as string)) return true
        if (isPropertyKey(name))
            return adm.has(name);
        return name in target;
    },
    get: function (target, name) {
        if (name === $mobx || name === "constructor" || name === mobxDidRunLazyInitializersSymbol)
            return target[name];
        var adm = getAdm(target);
        var observable = adm.values.get(name);
        if (observable instanceof Atom) {
            var result = observable.get();
            if (result === undefined) {
                // This fixes #1796, because deleting a prop that has an
                // undefined value won't retrigger a observer (no visible effect),
                // the autorun wouldn't subscribe to future key changes (see also next comment)
                adm.has(name);
            }
            return result;
        }
        // make sure we start listening to future keys
        // note that we only do this here for optimization
        if (isPropertyKey(name))
            adm.has(name);
        return target[name];
    },
    set: function (target, name, value) {
        if (!isPropertyKey(name))
            return false;
        set(target, name, value);
        return true;
    },
    deleteProperty: function (target, name) {
        if (!isPropertyKey(name))
            return false;
        var adm = getAdm(target);
        adm.remove(name);
        return true;
    },
    ownKeys: function (target) {
        var adm = getAdm(target);
        adm.keysAtom.reportObserved();
        return Reflect.ownKeys(target);
    },
    preventExtensions: function (target) {
        fail("Dynamic observable objects cannot be frozen");
        return false;
    }
};
function createDynamicObservableObject(base) {
    var proxy = new Proxy(base, objectProxyTraps);
    base[$mobx].proxy = proxy;
    return proxy;
}

function hasInterceptors(interceptable) {
    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = __spread((interceptable.interceptors || []));
        for (var i = 0, l = interceptors.length; i < l; i++) {
            change = interceptors[i](change);
            invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
            if (!change)
                break;
        }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function (target, name) {
        if (name === $mobx)
            return target[$mobx];
        if (name === "length")
            return target[$mobx].getArrayLength();
        if (typeof name === "number") {
            return arrayExtensions.get.call(target, name);
        }
        if (typeof name === "string" && !isNaN(name)) {
            return arrayExtensions.get.call(target, parseInt(name));
        }
        if (arrayExtensions.hasOwnProperty(name)) {
            return arrayExtensions[name];
        }
        return target[name];
    },
    set: function (target, name, value) {
        if (name === "length") {
            target[$mobx].setArrayLength(value);
        }
        if (typeof name === "number") {
            arrayExtensions.set.call(target, name, value);
        }
        if (typeof name === "symbol" || isNaN(name)) {
            target[name] = value;
        }
        else {
            // numeric string
            arrayExtensions.set.call(target, parseInt(name), value);
        }
        return true;
    },
    preventExtensions: function (target) {
        fail("Observable arrays cannot be frozen");
        return false;
    }
};
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) { name = "ObservableArray@" + getNextId(); }
    if (owned === void 0) { owned = false; }
    var adm = new ObservableArrayAdministration(name, enhancer, owned);
    addHiddenFinalProp(adm.values, $mobx, adm);
    var proxy = new Proxy(adm.values, arrayTraps);
    adm.proxy = proxy;
    if (initialValues && initialValues.length) {
        var prev = allowStateChangesStart(true);
        adm.spliceWithArray(0, 0, initialValues);
        allowStateChangesEnd(prev);
    }
    return proxy;
}
var ObservableArrayAdministration = /** @class */ (function () {
    function ObservableArrayAdministration(name, enhancer, owned) {
        this.owned = owned;
        this.values = [];
        this.proxy = undefined;
        this.lastKnownLength = 0;
        this.atom = new Atom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined && values.length > 0)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.proxy,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed.");
        this.lastKnownLength += delta;
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function (v) { return _this.enhancer(v, undefined); });
        if (false) { var lengthDelta; }
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        var _a;
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.proxy,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
        // cause any runtime overhead in development mode without NODE_ENV set, unless spying is enabled
        if (notifySpy && "production" !== "production")
            spyReportStart(__assign(__assign({}, change), { name: this.atom.name }));
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy && "production" !== "production")
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.proxy,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy && "production" !== "production")
            spyReportStart(__assign(__assign({}, change), { name: this.atom.name }));
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy && "production" !== "production")
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var arrayExtensions = {
    intercept: function (handler) {
        return this[$mobx].intercept(handler);
    },
    observe: function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        var adm = this[$mobx];
        return adm.observe(listener, fireImmediately);
    },
    clear: function () {
        return this.splice(0);
    },
    replace: function (newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray(0, adm.values.length, newItems);
    },
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    toJS: function () {
        return this.slice();
    },
    toJSON: function () {
        // Used by JSON.stringify
        return this.toJS();
    },
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    splice: function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        var adm = this[$mobx];
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray(index);
            case 2:
                return adm.spliceWithArray(index, deleteCount);
        }
        return adm.spliceWithArray(index, deleteCount, newItems);
    },
    spliceWithArray: function (index, deleteCount, newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray(index, deleteCount, newItems);
    },
    push: function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this[$mobx];
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    },
    pop: function () {
        return this.splice(Math.max(this[$mobx].values.length - 1, 0), 1)[0];
    },
    shift: function () {
        return this.splice(0, 1)[0];
    },
    unshift: function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this[$mobx];
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    },
    reverse: function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        if (false) {}
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    },
    sort: function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (false) {}
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    },
    remove: function (value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues(adm.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    },
    get: function (index) {
        var adm = this[$mobx];
        if (adm) {
            if (index < adm.values.length) {
                adm.atom.reportObserved();
                return adm.dehanceValue(adm.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + adm.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    },
    set: function (index, newValue) {
        var adm = this[$mobx];
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: adm.proxy,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    }
};
[
    "concat",
    "flat",
    "includes",
    "indexOf",
    "join",
    "lastIndexOf",
    "slice",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    // Feature detection (eg flat may not be available)
    if (typeof Array.prototype[funcName] !== "function") {
        return;
    }
    arrayExtensions[funcName] = function () {
        var adm = this[$mobx];
        adm.atom.reportObserved();
        var dehancedValues = adm.dehanceValues(adm.values);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
});
["every", "filter", "find", "findIndex", "flatMap", "forEach", "map", "some"].forEach(function (funcName) {
    // Feature detection (eg flatMap may not be available)
    if (typeof Array.prototype[funcName] !== "function") {
        return;
    }
    arrayExtensions[funcName] = function (callback, thisArg) {
        var _this = this;
        var adm = this[$mobx];
        adm.atom.reportObserved();
        var dehancedValues = adm.dehanceValues(adm.values);
        return dehancedValues[funcName](function (element, index) {
            return callback.call(thisArg, element, index, _this);
        }, thisArg);
    };
});
["reduce", "reduceRight"].forEach(function (funcName) {
    arrayExtensions[funcName] = function () {
        var _this = this;
        var adm = this[$mobx];
        adm.atom.reportObserved();
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function (accumulator, currentValue, index) {
            currentValue = adm.dehanceValue(currentValue);
            return callback(accumulator, currentValue, index, _this);
        };
        return adm.values[funcName].apply(adm.values, arguments);
    };
});
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}

var _a;
var ObservableMapMarker = {};
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /** @class */ (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
        this.enhancer = enhancer;
        this.name = name;
        this[_a] = ObservableMapMarker;
        this._keysAtom = createAtom(this.name + ".keys()");
        this[Symbol.toStringTag] = "Map";
        if (typeof Map !== "function") {
            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
        }
        this._data = new Map();
        this._hasMap = new Map();
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return this._data.has(key);
    };
    ObservableMap.prototype.has = function (key) {
        var _this = this;
        if (!globalState.trackingDerivation)
            return this._has(key);
        var entry = this._hasMap.get(key);
        if (!entry) {
            // todo: replace with atom (breaking change)
            var newEntry = (entry = new ObservableValue(this._has(key), referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false));
            this._hasMap.set(key, newEntry);
            onBecomeUnobserved(newEntry, function () { return _this._hasMap.delete(key); });
        }
        return entry.get();
    };
    ObservableMap.prototype.set = function (key, value) {
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._keysAtom);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data.get(key).value,
                    name: key
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            transaction(function () {
                _this._keysAtom.reportChanged();
                _this._updateHasMapEntry(key, false);
                var observable = _this._data.get(key);
                observable.setNewValue(undefined);
                _this._data.delete(key);
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        var entry = this._hasMap.get(key);
        if (entry) {
            entry.setNewValue(value);
        }
    };
    ObservableMap.prototype._updateValue = function (key, newValue) {
        var observable = this._data.get(key);
        newValue = observable.prepareNewValue(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (key, newValue) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._keysAtom);
        transaction(function () {
            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + stringifyKey(key), false);
            _this._data.set(key, observable);
            newValue = observable.value; // value might have been changed
            _this._updateHasMapEntry(key, true);
            _this._keysAtom.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: key,
                newValue: newValue
            }
            : null;
        if (notifySpy && "production" !== "production")
            spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
        if (notify)
            notifyListeners(this, change);
        if (notifySpy && "production" !== "production")
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        if (this.has(key))
            return this.dehanceValue(this._data.get(key).get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        this._keysAtom.reportObserved();
        return this._data.keys();
    };
    ObservableMap.prototype.values = function () {
        var self = this;
        var keys = this.keys();
        return makeIterable({
            next: function () {
                var _b = keys.next(), done = _b.done, value = _b.value;
                return {
                    done: done,
                    value: done ? undefined : self.get(value)
                };
            }
        });
    };
    ObservableMap.prototype.entries = function () {
        var self = this;
        var keys = this.keys();
        return makeIterable({
            next: function () {
                var _b = keys.next(), done = _b.done, value = _b.value;
                return {
                    done: done,
                    value: done ? undefined : [value, self.get(value)]
                };
            }
        });
    };
    ObservableMap.prototype[(_a = $mobx, Symbol.iterator)] = function () {
        return this.entries();
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var e_1, _b;
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
                callback.call(thisArg, value, key, this);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            var prev = allowStateChangesStart(true);
            try {
                if (isPlainObject(other))
                    getPlainObjectKeys(other).forEach(function (key) {
                        return _this.set(key, other[key]);
                    });
                else if (Array.isArray(other))
                    other.forEach(function (_b) {
                        var _c = __read(_b, 2), key = _c[0], value = _c[1];
                        return _this.set(key, value);
                    });
                else if (isES6Map(other)) {
                    if (other.constructor !== Map)
                        fail("Cannot initialize from classes that inherit from Map: " + other.constructor.name); // prettier-ignore
                    other.forEach(function (value, key) { return _this.set(key, value); });
                }
                else if (other !== null && other !== undefined)
                    fail("Cannot initialize map from " + other);
            }
            finally {
                allowStateChangesEnd(prev);
            }
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                var e_2, _b;
                try {
                    for (var _c = __values(_this.keys()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var key = _d.value;
                        _this.delete(key);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function () {
            var e_3, _b, e_4, _c;
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            try {
                // Delete keys that don't exist in replacement map
                // if the key deletion is prevented by interceptor
                // add entry at the beginning of the result map
                for (var _d = __values(_this._data.keys()), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var key = _e.value;
                    // Concurrently iterating/deleting keys
                    // iterator should handle this correctly
                    if (!replacementMap.has(key)) {
                        var deleted = _this.delete(key);
                        // Was the key removed?
                        if (deleted) {
                            // _keysAtom.reportChanged() was already called
                            keysReportChangedCalled = true;
                        }
                        else {
                            // Delete prevented by interceptor
                            var value = _this._data.get(key);
                            orderedData.set(key, value);
                        }
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                }
                finally { if (e_3) throw e_3.error; }
            }
            try {
                // Merge entries
                for (var _f = __values(replacementMap.entries()), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var _h = __read(_g.value, 2), key = _h[0], value = _h[1];
                    // We will want to know whether a new key is added
                    var keyExisted = _this._data.has(key);
                    // Add or update value
                    _this.set(key, value);
                    // The addition could have been prevent by interceptor
                    if (_this._data.has(key)) {
                        // The update could have been prevented by interceptor
                        // and also we want to preserve existing values
                        // so use value from _data map (instead of replacement map)
                        var value_1 = _this._data.get(key);
                        orderedData.set(key, value_1);
                        // Was a new key added?
                        if (!keyExisted) {
                            // _keysAtom.reportChanged() was already called
                            keysReportChangedCalled = true;
                        }
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                }
                finally { if (e_4) throw e_4.error; }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this._data.size !== orderedData.size) {
                    // If size differs, keys are definitely modified
                    _this._keysAtom.reportChanged();
                }
                else {
                    var iter1 = _this._data.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while (!next1.done) {
                        if (next1.value !== next2.value) {
                            _this._keysAtom.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this._data = orderedData;
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            this._keysAtom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a plain object that represents this map.
     * Note that all the keys being stringified.
     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
     */
    ObservableMap.prototype.toPOJO = function () {
        var e_5, _b;
        var res = {};
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
                // We lie about symbol key types due to https://github.com/Microsoft/TypeScript/issues/1863
                res[typeof key === "symbol" ? key : stringifyKey(key)] = value;
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return res;
    };
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        return new Map(this);
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toPOJO();
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            Array.from(this.keys())
                .map(function (key) { return stringifyKey(key) + ": " + ("" + _this.get(key)); })
                .join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
         false &&
            false;
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

var _a$1;
var ObservableSetMarker = {};
var ObservableSet = /** @class */ (function () {
    function ObservableSet(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableSet@" + getNextId(); }
        this.name = name;
        this[_a$1] = ObservableSetMarker;
        this._data = new Set();
        this._atom = createAtom(this.name);
        this[Symbol.toStringTag] = "Set";
        if (typeof Set !== "function") {
            throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
        }
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name); };
        if (initialData) {
            this.replace(initialData);
        }
    }
    ObservableSet.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableSet.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                var e_1, _b;
                try {
                    for (var _c = __values(_this._data.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var value = _d.value;
                        _this.delete(value);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            });
        });
    };
    ObservableSet.prototype.forEach = function (callbackFn, thisArg) {
        var e_2, _b;
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var value = _d.value;
                callbackFn.call(thisArg, value, value, this);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    Object.defineProperty(ObservableSet.prototype, "size", {
        get: function () {
            this._atom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    ObservableSet.prototype.add = function (value) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._atom);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "add",
                object: this,
                newValue: value
            });
            if (!change)
                return this;
            // TODO: ideally, value = change.value would be done here, so that values can be
            // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function () {
                _this._data.add(_this.enhancer(value, undefined));
                _this._atom.reportChanged();
            });
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "add",
                    object: this,
                    newValue: value
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart(change);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
        }
        return this;
    };
    ObservableSet.prototype.delete = function (value) {
        var _this = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                oldValue: value
            });
            if (!change)
                return false;
        }
        if (this.has(value)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: value
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name }));
            transaction(function () {
                _this._atom.reportChanged();
                _this._data.delete(value);
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableSet.prototype.has = function (value) {
        this._atom.reportObserved();
        return this._data.has(this.dehanceValue(value));
    };
    ObservableSet.prototype.entries = function () {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function () {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length
                    ? { value: [keys[index], values[index]], done: false }
                    : { done: true };
            }
        });
    };
    ObservableSet.prototype.keys = function () {
        return this.values();
    };
    ObservableSet.prototype.values = function () {
        this._atom.reportObserved();
        var self = this;
        var nextIndex = 0;
        var observableValues = Array.from(this._data.values());
        return makeIterable({
            next: function () {
                return nextIndex < observableValues.length
                    ? { value: self.dehanceValue(observableValues[nextIndex++]), done: false }
                    : { done: true };
            }
        });
    };
    ObservableSet.prototype.replace = function (other) {
        var _this = this;
        if (isObservableSet(other)) {
            other = other.toJS();
        }
        transaction(function () {
            var prev = allowStateChangesStart(true);
            try {
                if (Array.isArray(other)) {
                    _this.clear();
                    other.forEach(function (value) { return _this.add(value); });
                }
                else if (isES6Set(other)) {
                    _this.clear();
                    other.forEach(function (value) { return _this.add(value); });
                }
                else if (other !== null && other !== undefined) {
                    fail("Cannot initialize set from " + other);
                }
            }
            finally {
                allowStateChangesEnd(prev);
            }
        });
        return this;
    };
    ObservableSet.prototype.observe = function (listener, fireImmediately) {
        // TODO 'fireImmediately' can be true?
         false &&
            false;
        return registerListener(this, listener);
    };
    ObservableSet.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableSet.prototype.toJS = function () {
        return new Set(this);
    };
    ObservableSet.prototype.toString = function () {
        return this.name + "[ " + Array.from(this).join(", ") + " ]";
    };
    ObservableSet.prototype[(_a$1 = $mobx, Symbol.iterator)] = function () {
        return this.values();
    };
    return ObservableSet;
}());
var isObservableSet = createInstanceofPredicate("ObservableSet", ObservableSet);

var ObservableObjectAdministration = /** @class */ (function () {
    function ObservableObjectAdministration(target, values, name, defaultEnhancer) {
        if (values === void 0) { values = new Map(); }
        this.target = target;
        this.values = values;
        this.name = name;
        this.defaultEnhancer = defaultEnhancer;
        this.keysAtom = new Atom(name + ".keys");
    }
    ObservableObjectAdministration.prototype.read = function (key) {
        return this.values.get(key).get();
    };
    ObservableObjectAdministration.prototype.write = function (key, newValue) {
        var instance = this.target;
        var observable = this.values.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "update",
                object: this.proxy || instance,
                name: key,
                newValue: newValue
            });
            if (!change)
                return;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this.proxy || instance,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
        }
    };
    ObservableObjectAdministration.prototype.has = function (key) {
        var map = this.pendingKeys || (this.pendingKeys = new Map());
        var entry = map.get(key);
        if (entry)
            return entry.get();
        else {
            var exists = !!this.values.get(key);
            // Possible optimization: Don't have a separate map for non existing keys,
            // but store them in the values map instead, using a special symbol to denote "not existing"
            entry = new ObservableValue(exists, referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false);
            map.set(key, entry);
            return entry.get(); // read to subscribe
        }
    };
    ObservableObjectAdministration.prototype.addObservableProp = function (propName, newValue, enhancer) {
        if (enhancer === void 0) { enhancer = this.defaultEnhancer; }
        var target = this.target;
        assertPropertyConfigurable(target, propName);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy || target,
                name: propName,
                type: "add",
                newValue: newValue
            });
            if (!change)
                return;
            newValue = change.newValue;
        }
        var observable = new ObservableValue(newValue, enhancer, this.name + "." + stringifyKey(propName), false);
        this.values.set(propName, observable);
        newValue = observable.value; // observableValue might have changed it
        Object.defineProperty(target, propName, generateObservablePropConfig(propName));
        this.notifyPropertyAddition(propName, newValue);
    };
    ObservableObjectAdministration.prototype.addComputedProp = function (propertyOwner, // where is the property declared?
    propName, options) {
        var target = this.target;
        options.name = options.name || this.name + "." + stringifyKey(propName);
        this.values.set(propName, new ComputedValue(options));
        if (propertyOwner === target || isPropertyConfigurable(propertyOwner, propName))
            Object.defineProperty(propertyOwner, propName, generateComputedPropConfig(propName));
    };
    ObservableObjectAdministration.prototype.remove = function (key) {
        if (!this.values.has(key))
            return;
        var target = this.target;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy || target,
                name: key,
                type: "remove"
            });
            if (!change)
                return;
        }
        try {
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var oldObservable = this.values.get(key);
            var oldValue = oldObservable && oldObservable.get();
            oldObservable && oldObservable.set(undefined);
            // notify key and keyset listeners
            this.keysAtom.reportChanged();
            this.values.delete(key);
            if (this.pendingKeys) {
                var entry = this.pendingKeys.get(key);
                if (entry)
                    entry.set(false);
            }
            // delete the prop
            delete this.target[key];
            var change = notify || notifySpy
                ? {
                    type: "remove",
                    object: this.proxy || target,
                    oldValue: oldValue,
                    name: key
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
        }
        finally {
            endBatch();
        }
    };
    ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
        /**
         * This happens if a property is accessed through the prototype chain, but the property was
         * declared directly as own property on the prototype.
         *
         * E.g.:
         * class A {
         * }
         * extendObservable(A.prototype, { x: 1 })
         *
         * classB extens A {
         * }
         * console.log(new B().x)
         *
         * It is unclear whether the property should be considered 'static' or inherited.
         * Either use `console.log(A.x)`
         * or: decorate(A, { x: observable })
         *
         * When using decorate, the property will always be redeclared as own property on the actual instance
         */
        console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
         false &&
            false;
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableObjectAdministration.prototype.notifyPropertyAddition = function (key, newValue) {
        var notify = hasListeners(this);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this.proxy || this.target,
                name: key,
                newValue: newValue
            }
            : null;
        if (notifySpy && "production" !== "production")
            spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
        if (notify)
            notifyListeners(this, change);
        if (notifySpy && "production" !== "production")
            spyReportEnd();
        if (this.pendingKeys) {
            var entry = this.pendingKeys.get(key);
            if (entry)
                entry.set(true);
        }
        this.keysAtom.reportChanged();
    };
    ObservableObjectAdministration.prototype.getKeys = function () {
        var e_1, _a;
        this.keysAtom.reportObserved();
        // return Reflect.ownKeys(this.values) as any
        var res = [];
        try {
            for (var _b = __values(this.values), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                if (value instanceof ObservableValue)
                    res.push(key);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return res;
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name, defaultEnhancer) {
    if (name === void 0) { name = ""; }
    if (defaultEnhancer === void 0) { defaultEnhancer = deepEnhancer; }
    if (Object.prototype.hasOwnProperty.call(target, $mobx))
        return target[$mobx];
     false &&
        false;
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    var adm = new ObservableObjectAdministration(target, new Map(), stringifyKey(name), defaultEnhancer);
    addHiddenProp(target, $mobx, adm);
    return adm;
}
var observablePropertyConfigs = Object.create(null);
var computedPropertyConfigs = Object.create(null);
function generateObservablePropConfig(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this[$mobx].read(propName);
            },
            set: function (v) {
                this[$mobx].write(propName, v);
            }
        }));
}
function getAdministrationForComputedPropOwner(owner) {
    var adm = owner[$mobx];
    if (!adm) {
        // because computed props are declared on proty,
        // the current instance might not have been initialized yet
        initializeInstance(owner);
        return owner[$mobx];
    }
    return adm;
}
function generateComputedPropConfig(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: globalState.computedConfigurable,
            enumerable: false,
            get: function () {
                return getAdministrationForComputedPropOwner(this).read(propName);
            },
            set: function (v) {
                getAdministrationForComputedPropOwner(this).write(propName, v);
            }
        }));
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        return isObservableObjectAdministration(thing[$mobx]);
    }
    return false;
}

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined)
                fail( false &&
                    false);
            return thing[$mobx].atom;
        }
        if (isObservableSet(thing)) {
            return thing[$mobx];
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return anyThing._keysAtom;
            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
            if (!observable)
                fail( false &&
                    false);
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        if (property && !thing[$mobx])
            thing[property]; // See #1072
        if (isObservableObject(thing)) {
            if (!property)
                return fail( false && false);
            var observable = thing[$mobx].values.get(property);
            if (!observable)
                fail( false &&
                    false);
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing[$mobx])) {
            // disposer function
            return thing[$mobx];
        }
    }
    return fail( false && false);
}
function getAdministration(thing, property) {
    if (!thing)
        fail("Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing) || isObservableSet(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    initializeInstance(thing);
    if (thing[$mobx])
        return thing[$mobx];
    fail( false && false);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}

var toString = Object.prototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) { depth = -1; }
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) {
                depth++;
            }
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    if (depth === 0) {
        return false;
    }
    else if (depth < 0) {
        depth = -1;
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], depth - 1, aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key = void 0;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys[length];
            if (!(has$1(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a))
        return a.slice();
    if (isES6Map(a) || isObservableMap(a))
        return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a))
        return Array.from(a.entries());
    return a;
}
function has$1(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}

/**
 * (c) Michel Weststrate 2015 - 2018
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
if (typeof Proxy === "undefined" || typeof Symbol === "undefined") {
    throw new Error("[mobx] MobX 5+ requires Proxy and Symbol objects. If your environment doesn't support Symbol or Proxy objects, please downgrade to MobX 4. For React Native Android, consider upgrading JSCore.");
}
try {
    // define process.env if needed
    // if this is not a production build in the first place
    // (in which case the expression below would be substituted with 'production')
    "production";
}
catch (e) {
    var g = getGlobal();
    if (typeof process === "undefined")
        g.process = {};
    g.process.env = {};
}
(function () {
    function testCodeMinification() { }
    if (testCodeMinification.name !== "testCodeMinification" &&
        "production" !== "production" &&
        typeof process !== 'undefined' && process.env.IGNORE_MOBX_MINIFY_WARNING !== "true") {
        // trick so it doesn't get replaced
        var varName = ["process", "env", "NODE_ENV"].join(".");
        console.warn("[mobx] you are running a minified build, but '" + varName + "' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
    }
})();
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    // See: https://github.com/andykog/mobx-devtools/
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
        spy: spy,
        extras: {
            getDebugName: getDebugName
        },
        $mobx: $mobx
    });
}



/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(50), __webpack_require__(95)))

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Observable", function() { return Observable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableLike", function() { return ObservableLike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableValue", function() { return ObservableValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableObject", function() { return ObservableObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableArray", function() { return ObservableArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableCollection", function() { return ObservableCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReadyableObservableArray", function() { return ReadyableObservableArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useObservable", function() { return useObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useObservableArray", function() { return useObservableArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useDerivedObservable", function() { return useDerivedObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useSubscription", function() { return useSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useDebouncedSubscription", function() { return useDebouncedSubscription; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);


/**
 * An Observable implementation that will track a set of subscribers and supports
 * notifications when the underlying system changes.
 */
var Observable = /** @class */ (function () {
    function Observable() {
        this.observers = {};
        this.subscriberCount = 0;
    }
    /**
     * notify is used to send the event to all subscribers that have signed up for this events
     * action. This means they have subscribed directly to this action, or to all actions.
     * If the caller requested the event be persisted the event will be fired in order to new
     * subscribers as well when they subscribe.
     *
     * @param value - The object that represents the event data.
     *
     * @param action - The action that happened on this observable to produce the event.
     *
     * @param persistEvent - Optional value that determines if all future subscribers will
     *  recieve the event as well.
     */
    Observable.prototype.notify = function (value, action, persistEvent) {
        var executeObserverAction = function (observer, value, action) {
            try {
                observer(value, action);
            }
            catch (ex) {
                console.warn(ex);
                if (ex && typeof ErrorEvent === "function") {
                    window.dispatchEvent(new ErrorEvent("error", {
                        error: ex,
                        filename: "Observable.ts",
                        message: ex.message
                    }));
                }
            }
        };
        // NOTE: We need to make a copy of the observers since they may change during notification.
        if (this.observers[action]) {
            var observers = this.observers[action].slice();
            for (var observerIndex = 0; observerIndex < observers.length; observerIndex++) {
                executeObserverAction(observers[observerIndex], value, action);
            }
        }
        if (this.observers[""]) {
            var observers = this.observers[""].slice();
            for (var observerIndex = 0; observerIndex < observers.length; observerIndex++) {
                executeObserverAction(observers[observerIndex], value, action);
            }
        }
        // If the caller wants this event sent to all subscribers, even future ones, track it.
        if (persistEvent) {
            if (!this.events) {
                this.events = [];
            }
            this.events.push({ action: action, value: value });
        }
    };
    Observable.prototype.subscribe = function (observer, action) {
        action = action || "";
        if (!this.observers[action]) {
            this.observers[action] = [];
        }
        this.observers[action].push(observer);
        this.subscriberCount++;
        // Fire the callback for any events that were persisted when they were sent.
        if (this.events) {
            for (var _i = 0, _a = this.events; _i < _a.length; _i++) {
                var event_1 = _a[_i];
                if (!action || event_1.action === action) {
                    observer(event_1.value, event_1.action);
                }
            }
        }
        return observer;
    };
    Observable.prototype.unsubscribe = function (observer, action) {
        action = action || "";
        if (this.observers[action]) {
            var observerIndex = this.observers[action].indexOf(observer);
            if (observerIndex >= 0) {
                this.observers[action].splice(observerIndex, 1);
                this.subscriberCount--;
            }
        }
    };
    return Observable;
}());

var ObservableLike;
(function (ObservableLike) {
    /**
     * Check whether the specified object is an observable or not.
     *
     * @param observableLike Object to perform observable check.
     */
    function isObservable(observableLike) {
        return observableLike && typeof observableLike.subscribe === "function";
    }
    ObservableLike.isObservable = isObservable;
    function getValue(observableLike) {
        if (isObservable(observableLike)) {
            return observableLike.value;
        }
        return observableLike;
    }
    ObservableLike.getValue = getValue;
    /**
     * Subscribes to the specified object if it is an observable.
     *
     * @param observableLike Object to subscribe its value change if applicable.
     * @param observer Delegate to be executed when the underlying data changes.
     * @param action Optional argument that allows the consumer to supply a action
     *  with the delegate. If the action is supplied only those actions are delievered,
     *  while all actions are delivered is no action is supplied.
     * @returns observer
     */
    function subscribe(observableLike, observer, action) {
        if (isObservable(observableLike)) {
            return observableLike.subscribe(observer, action);
        }
        return function () { };
    }
    ObservableLike.subscribe = subscribe;
    /**
     * Unsubscribes from the specified object if it is an observable.
     *
     * @param observableLike Object to subscribe its value change if applicable.
     * @param observer Delegate to be executed when the underlying data changes.
     * @param action Optional argument that allows the consumer to supply a action
     *  with the delegate. If the action is supplied only those actions are delievered,
     *  while all actions are delivered is no action is supplied.
     */
    function unsubscribe(observableLike, observer, action) {
        if (isObservable(observableLike)) {
            observableLike.unsubscribe(observer, action);
        }
    }
    ObservableLike.unsubscribe = unsubscribe;
})(ObservableLike || (ObservableLike = {}));
var ObservableValue = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(ObservableValue, _super);
    function ObservableValue(value) {
        var _this = _super.call(this) || this;
        _this.v = value;
        return _this;
    }
    Object.defineProperty(ObservableValue.prototype, "value", {
        get: function () {
            return this.v;
        },
        set: function (value) {
            this.v = value;
            this.notify(this.v, "set");
        },
        enumerable: true,
        configurable: true
    });
    return ObservableValue;
}(Observable));

/**
 * An ObservableObject can be used to key a named collection of properties
 * and offer an observable endpoint.
 */
var ObservableObject = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(ObservableObject, _super);
    function ObservableObject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.objects = {};
        return _this;
    }
    ObservableObject.prototype.add = function (objectName, objectDefinition) {
        if (!this.objects.hasOwnProperty(objectName)) {
            this.objects[objectName] = objectDefinition;
            this.notify({ key: objectName, value: objectDefinition }, "add");
        }
    };
    ObservableObject.prototype.get = function (objectName) {
        return this.objects[objectName];
    };
    ObservableObject.prototype.set = function (objectName, objectDefinition) {
        if (this.objects.hasOwnProperty(objectName)) {
            this.objects[objectName] = objectDefinition;
            this.notify({ key: objectName, value: objectDefinition }, "replace");
        }
        else {
            this.add(objectName, objectDefinition);
        }
    };
    ObservableObject.prototype.keys = function () {
        return Object.keys(this.objects);
    };
    return ObservableObject;
}(Observable));

/**
 * EventTypes:
 *  change - { changedItems, index }
 *  push - {addedItems, index }
 *  pop - { index, removedItems}
 *  removeAll - {index, removedItems }
 *  splice - { addedItems, index, removedItems }
 */
var ObservableArray = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(ObservableArray, _super);
    function ObservableArray(items) {
        if (items === void 0) { items = []; }
        var _this = _super.call(this) || this;
        _this.internalItems = items || [];
        return _this;
    }
    ObservableArray.prototype.change = function (start) {
        var _a;
        var items = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            items[_i - 1] = arguments[_i];
        }
        (_a = this.internalItems).splice.apply(_a, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])([start, items.length], items));
        this.notify({ index: start, changedItems: items }, "change");
        return items.length;
    };
    Object.defineProperty(ObservableArray.prototype, "length", {
        get: function () {
            return this.internalItems.length;
        },
        enumerable: true,
        configurable: true
    });
    ObservableArray.prototype.push = function () {
        var _a;
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        if (items.length) {
            var index = this.internalItems.length;
            (_a = this.internalItems).push.apply(_a, items);
            this.notify({ addedItems: items, index: index }, "push");
        }
        return items.length;
    };
    ObservableArray.prototype.pop = function () {
        var item = this.internalItems.pop();
        if (item !== undefined) {
            this.notify({ index: this.internalItems.length, removedItems: [item] }, "pop");
        }
        return item;
    };
    ObservableArray.prototype.removeAll = function (filter) {
        var removedItems = [];
        var remainingItems = [];
        for (var _i = 0, _a = this.internalItems; _i < _a.length; _i++) {
            var item = _a[_i];
            if (!filter || filter(item)) {
                removedItems.push(item);
            }
            else {
                remainingItems.push(item);
            }
        }
        if (removedItems.length > 0) {
            this.internalItems.splice(0, this.internalItems.length);
            for (var _b = 0, remainingItems_1 = remainingItems; _b < remainingItems_1.length; _b++) {
                var item = remainingItems_1[_b];
                this.internalItems.push(item);
            }
            this.notify({ index: 0, removedItems: removedItems }, "removeAll");
        }
        return removedItems;
    };
    ObservableArray.prototype.splice = function (start, deleteCount) {
        var _a;
        var itemsToAdd = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            itemsToAdd[_i - 2] = arguments[_i];
        }
        var removedItems = (_a = this.internalItems).splice.apply(_a, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])([start, deleteCount], itemsToAdd));
        this.notify({ addedItems: itemsToAdd, index: start, removedItems: removedItems }, "splice");
        return removedItems;
    };
    Object.defineProperty(ObservableArray.prototype, "value", {
        get: function () {
            return this.internalItems;
        },
        set: function (items) {
            // Preserve the original array, but avoid the "..." arguments issue with splice/push
            var removedItems;
            if (items === this.internalItems) {
                // Special case for someone passing us the same internal array that we are already using
                // We don't need to modify the internalItems. The "removedItems" in the event is
                // not going to be accurate in the case that someone modified this internal array
                // outside of the observable -- we won't know the prior state in that case.
                removedItems = this.internalItems;
            }
            else {
                // Clear out the existing items
                removedItems = this.internalItems.slice();
                this.internalItems.length = 0;
                // Add all new items
                if (items.length) {
                    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                        var item = items_1[_i];
                        this.internalItems.push(item);
                    }
                }
            }
            this.notify({ addedItems: items, index: 0, removedItems: removedItems }, "splice");
        },
        enumerable: true,
        configurable: true
    });
    return ObservableArray;
}(Observable));

/**
 * An Observable Collection takes an arry of arrays or observable arrays
 * and flattens out the items into a single readonly observable array
 * (with all the underlying array values aggregated together).
 *
 * This handles subscribing to any underlying observable arrays and
 * updating the aggregate array as appropriate (and notifying subscribers)
 */
var ObservableCollection = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(ObservableCollection, _super);
    function ObservableCollection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.collections = [];
        _this.items = [];
        return _this;
    }
    Object.defineProperty(ObservableCollection.prototype, "length", {
        get: function () {
            if (!this.subscriberCount) {
                this.recalculateItems();
            }
            return this.items.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObservableCollection.prototype, "value", {
        get: function () {
            if (!this.subscriberCount) {
                this.recalculateItems();
            }
            return this.items;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds an additional collection of items to the end of the array
     *
     * @param collection Array of items or an observable array of items
     * @params transformItems Delegate to process each item that is pulled from the given collection
     */
    ObservableCollection.prototype.push = function (collection, transformItems) {
        var collectionEntry;
        var pushedItems;
        if (ObservableLike.isObservable(collection)) {
            var observable = collection;
            var subscriber = this.getSubscriber(this.collections.length, transformItems);
            collectionEntry = { observable: observable, subscriber: subscriber, transformItems: transformItems, items: [] };
            pushedItems = observable.value;
            if (this.subscriberCount) {
                ObservableLike.subscribe(collectionEntry.observable, subscriber);
            }
        }
        else if (collection.length) {
            pushedItems = collection;
            collectionEntry = { items: this.transformItems(pushedItems, transformItems) };
        }
        if (collectionEntry) {
            this.collections.push(collectionEntry);
            if (this.subscriberCount && pushedItems.length) {
                var newItems = this.transformItems(pushedItems, transformItems);
                for (var _i = 0, newItems_1 = newItems; _i < newItems_1.length; _i++) {
                    var newItem = newItems_1[_i];
                    this.items.push(newItem);
                }
                this.notify({ addedItems: newItems, index: this.items.length - newItems.length }, "push");
            }
        }
    };
    ObservableCollection.prototype.subscribe = function (observer, action) {
        var subscription = _super.prototype.subscribe.call(this, observer, action);
        if (this.subscriberCount === 1) {
            this.recalculateItems();
            for (var _i = 0, _a = this.collections; _i < _a.length; _i++) {
                var collection = _a[_i];
                if (collection.subscriber) {
                    collection.observable.subscribe(collection.subscriber);
                }
            }
        }
        return subscription;
    };
    ObservableCollection.prototype.unsubscribe = function (observer, action) {
        _super.prototype.unsubscribe.call(this, observer, action);
        if (this.subscriberCount === 0) {
            for (var _i = 0, _a = this.collections; _i < _a.length; _i++) {
                var collection = _a[_i];
                if (collection.subscriber) {
                    collection.observable.unsubscribe(collection.subscriber);
                }
            }
        }
    };
    /**
     * Recalculate items. This is necessary while we work without subscribers, as we're not listening to changes in observable inner collections.
     * Once the first subscriber joins, items collection will be in sync real-time.
     */
    ObservableCollection.prototype.recalculateItems = function () {
        this.items.length = 0;
        for (var _i = 0, _a = this.collections; _i < _a.length; _i++) {
            var collection = _a[_i];
            if (collection.observable) {
                collection.items = this.transformItems(collection.observable.value, collection.transformItems);
            }
            for (var _b = 0, _c = collection.items; _b < _c.length; _b++) {
                var item = _c[_b];
                this.items.push(item);
            }
        }
    };
    ObservableCollection.prototype.transformItems = function (inputItems, transformInput) {
        var transformedItems;
        if (!inputItems) {
            transformedItems = [];
        }
        else if (transformInput) {
            transformedItems = [];
            for (var _i = 0, inputItems_1 = inputItems; _i < inputItems_1.length; _i++) {
                var inputItem = inputItems_1[_i];
                var transformedItem = transformInput(inputItem);
                if (transformedItem !== undefined) {
                    transformedItems.push(transformedItem);
                }
            }
        }
        else {
            transformedItems = inputItems;
        }
        return transformedItems;
    };
    ObservableCollection.prototype.getSubscriber = function (collectionIndex, transformInput) {
        var _this = this;
        return function (args) {
            var _a;
            // Find the index in our aggregate array
            var index = args.index;
            for (var i = 0; i < collectionIndex; i++) {
                index += _this.collections[i].items.length;
            }
            if (args.changedItems) {
                // Handle change event
                var changedItems = _this.transformItems(args.changedItems, transformInput);
                (_a = _this.items).splice.apply(_a, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])([index, args.changedItems.length], changedItems));
                _this.notify({ changedItems: changedItems, index: index }, "change");
            }
            else {
                // Handle splice, push, pop events
                var removedItems = _this.transformItems(args.removedItems, transformInput);
                var addedItems = _this.transformItems(args.addedItems, transformInput);
                // We would normally just call splice here with 3 arguments, but splice takes a "..." argument for added items
                // which passes array elements on the stack and is therefore limited (to 32K/64K on some browsers)
                // Remove the removedItems first
                _this.items.splice(index, removedItems.length);
                // Slice-off any remaining items past where we want to insert
                var endItems = _this.items.splice(index);
                // Push the addedItems followed by the endItems that we just removed
                for (var _i = 0, addedItems_1 = addedItems; _i < addedItems_1.length; _i++) {
                    var item = addedItems_1[_i];
                    _this.items.push(item);
                }
                for (var _b = 0, endItems_1 = endItems; _b < endItems_1.length; _b++) {
                    var item = endItems_1[_b];
                    _this.items.push(item);
                }
                _this.notify({ removedItems: removedItems, addedItems: addedItems, index: index }, "splice");
            }
        };
    };
    return ObservableCollection;
}(Observable));

var ReadyableObservableArray = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(ReadyableObservableArray, _super);
    function ReadyableObservableArray(items, ready) {
        if (items === void 0) { items = []; }
        if (ready === void 0) { ready = false; }
        var _this = _super.call(this, items) || this;
        _this.ready = new ObservableValue(ready);
        return _this;
    }
    return ReadyableObservableArray;
}(ObservableArray));

/**
 * React Hooks extension that allows the consumer to track Observables with a useState like
 * hooks API.
 *
 * @param initialState Initial value for the state, or a function that will resolve the value
 * the when the value is initialized.
 */
function useObservable(initialState) {
    var underlyingState = react__WEBPACK_IMPORTED_MODULE_1__["useState"](initialState)[0];
    var observable = react__WEBPACK_IMPORTED_MODULE_1__["useState"](function () { return new ObservableValue(underlyingState); })[0];
    var updateState = function (updatedState) {
        if (typeof updatedState === "function") {
            observable.value = updatedState(observable.value);
        }
        else {
            observable.value = updatedState;
        }
    };
    return [observable, updateState];
}
/**
 * React Hooks extension that allows the consmer to track ObservableArrays with a useState like
 * hooks API.
 *
 * @param initialState Initial value for the state, or a function that will resolve the value
 * the when the value is initialized.
 */
function useObservableArray(initialState) {
    var underlyingState = react__WEBPACK_IMPORTED_MODULE_1__["useState"](initialState)[0];
    var reactState = react__WEBPACK_IMPORTED_MODULE_1__["useState"](new ObservableArray(underlyingState));
    var updateState = function (updatedState) {
        if (typeof updatedState === "function") {
            reactState[0].value = updatedState(reactState[0].value);
        }
        else {
            reactState[0].value = updatedState;
        }
    };
    return [reactState[0], updateState];
}
/**
 * React Hooks extension that provides a constant reference to an ObservableValue which will update
 * based on another observable.
 *
 * @remarks
 * The subscription will be safely unsubscribed any time:
 * - The source observable points to a new object
 * - The callback dependencies array changes
 * - The component is unmounted
 *
 * @param sourceObservable
 * @param getDerivedValue
 * @param callbackDependencies
 */
function useDerivedObservable(sourceObservable, getDerivedValue, callbackDependencies) {
    var initialValue = getDerivedValue(sourceObservable.value);
    var _a = useObservable(initialValue), observable = _a[0], setValue = _a[1];
    var getDerivedValueCallback = react__WEBPACK_IMPORTED_MODULE_1__["useCallback"](getDerivedValue, callbackDependencies);
    // Update the observable's value when the source observable changes its value
    useSubscription(sourceObservable, function (newValue) {
        var derivedValue = getDerivedValueCallback(newValue);
        setValue(derivedValue);
    }, callbackDependencies);
    return observable;
}
function useSubscription(sourceObservable, callbackFn, callbackDependencies) {
    if (callbackDependencies === void 0) { callbackDependencies = []; }
    var callback = react__WEBPACK_IMPORTED_MODULE_1__["useCallback"](callbackFn, callbackDependencies);
    // Call the callback when the source observable points to a new object
    react__WEBPACK_IMPORTED_MODULE_1__["useEffect"](function () { return callback(sourceObservable.value); }, [sourceObservable]);
    // Call the callback when the source observable changes its value
    react__WEBPACK_IMPORTED_MODULE_1__["useEffect"](function () {
        var doCallback = function () { return callback(sourceObservable.value); };
        sourceObservable.subscribe(doCallback);
        return function () { return sourceObservable.unsubscribe(doCallback); };
    }, [sourceObservable, callback]);
}
function useDebouncedSubscription(sourceObservable, debounceMs, callbackFn, callbackDependencies) {
    if (callbackDependencies === void 0) { callbackDependencies = []; }
    var timeoutRef = react__WEBPACK_IMPORTED_MODULE_1__["useRef"](null);
    useSubscription(sourceObservable, function (value) {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(function () {
            callbackFn(value);
            timeoutRef.current = null;
        }, debounceMs);
    }, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])([debounceMs], callbackDependencies));
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var es6_promise_auto__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(211);
/* harmony import */ var es6_promise_auto__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(es6_promise_auto__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var es6_object_assign_auto__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(213);
/* harmony import */ var es6_object_assign_auto__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(es6_object_assign_auto__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var es6_string_polyfills__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(215);
/* harmony import */ var es6_string_polyfills__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(es6_string_polyfills__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(216);
/* harmony import */ var intersection_observer__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(intersection_observer__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Core_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(217);
/* harmony import */ var _Core_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Core_find__WEBPACK_IMPORTED_MODULE_4__);





if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
var global = window;
if (typeof global.false === "undefined") {
    global.false = false;
}
// Polyfill MAX_SAFE_INTEGER and MIN_SAFE_INTEGER
if (!Number.MAX_SAFE_INTEGER) {
    Number.MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;
}
if (!Number.MIN_SAFE_INTEGER) {
    Number.MIN_SAFE_INTEGER = -(Math.pow(2, 53) - 1);
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(218);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ FocusZoneContext; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ FocusZone_FocusZone; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ FocusZoneDirection; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ FocusZoneKeyStroke; });

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/FocusGroup.js
var FocusGroup = __webpack_require__(31);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/FocusZone/FocusZone.Props.js
/**
 * Which direction focus moves within a FocusZone
 */
var FocusZoneDirection;
(function (FocusZoneDirection) {
    FocusZoneDirection[FocusZoneDirection["Horizontal"] = 1] = "Horizontal";
    FocusZoneDirection[FocusZoneDirection["Vertical"] = 2] = "Vertical";
})(FocusZoneDirection || (FocusZoneDirection = {}));
/**
 * The preprocessKeyStroke method can return one of the following values
 * to modify how the current and parent focus zones treat the keystroke.
 */
var FocusZoneKeyStroke;
(function (FocusZoneKeyStroke) {
    /**
     * Dont alter the keystroke in any way.
     */
    FocusZoneKeyStroke[FocusZoneKeyStroke["IgnoreNone"] = 1] = "IgnoreNone";
    /**
     * All parent focus zones should ignore the keystroke, but it should be
     * processed normally by the current focuszone.
     */
    FocusZoneKeyStroke[FocusZoneKeyStroke["IgnoreParents"] = 2] = "IgnoreParents";
    /**
     * All focuszones that receive the keystroke should ignore it.
     */
    FocusZoneKeyStroke[FocusZoneKeyStroke["IgnoreAll"] = 3] = "IgnoreAll";
})(FocusZoneKeyStroke || (FocusZoneKeyStroke = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/FocusZone/FocusZone.js







// The FocusZoneContext carries the identifier for the current FocusZone.
var FocusZoneContext = external_commonjs_react_commonjs2_react_amd_React_root_React_["createContext"]({ direction: undefined, focuszoneId: undefined });
// As an event propagates through the hierarchy of focus zones it may
// be marked as ignored. This allows a child focus zone to mark an event
// as "pass-through" for all of its parents.
var ignoreEvent = false;
// An internal identifier used to created unique focuszoneId's.
var focuszoneId = 1;
var FocusZone_FocusZone = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(FocusZone, _super);
    function FocusZone(props) {
        var _this = _super.call(this, props) || this;
        _this.rootElements = [];
        _this.state = {
            focuszoneId: "focuszone-" + focuszoneId++
        };
        return _this;
    }
    FocusZone.prototype.render = function () {
        var _this = this;
        // We need to shim the KeyDown event on each of the children. This allows us to capture
        // the event and process it for focus changes.
        var content = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusZoneContext.Consumer, null, function (parentContext) { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusZoneContext.Provider, { value: { direction: _this.props.direction, focuszoneId: _this.state.focuszoneId } }, external_commonjs_react_commonjs2_react_amd_React_root_React_["Children"].map(_this.props.children, function (child, index) {
            if (child === null || typeof child === "string" || typeof child === "number") {
                return child;
            }
            // All direct children MUST be DOM elements.
            if (typeof child.type !== "string") {
                throw Error("Children of a focus zone MUST be DOM elements");
            }
            // Save the supplied keydown event handler so we can forward the event to it.
            var existingOnKeyDown = child.props.onKeyDown;
            var existingOnFocus = child.props.onFocus;
            // Save the component reference for this element, either the one from the original
            // component or the one we added.
            _this.rootElements[index] = Object(Util["shimRef"])(child);
            return external_commonjs_react_commonjs2_react_amd_React_root_React_["cloneElement"](child, Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({ key: index }, child.props), { ref: _this.rootElements[index], onFocus: function (event) {
                    var _a;
                    if (existingOnFocus) {
                        existingOnFocus(event);
                    }
                    var focusCurrent = document.activeElement;
                    for (var index_1 = 0; index_1 < _this.rootElements.length; index_1++) {
                        var rootElement = (_a = _this.rootElements[index_1]) === null || _a === void 0 ? void 0 : _a.current;
                        if (rootElement && (rootElement.contains(focusCurrent) || rootElement === focusCurrent)) {
                            _this.lastFocusElement = event.target;
                        }
                    }
                }, onKeyDown: function (event) {
                    var ignoreKeystroke = FocusZoneKeyStroke.IgnoreNone;
                    if (existingOnKeyDown) {
                        existingOnKeyDown(event);
                    }
                    // Determine whether or not this focuszone wants to preprocess this keystroke
                    // and mark the current propagation as ignored.
                    if (!ignoreEvent && _this.props.preprocessKeyStroke) {
                        ignoreKeystroke = _this.props.preprocessKeyStroke(event);
                        if (ignoreKeystroke === FocusZoneKeyStroke.IgnoreAll) {
                            ignoreEvent = true;
                        }
                    }
                    if (!ignoreEvent) {
                        if (!event.defaultPrevented && !_this.props.disabled) {
                            var nodeName = event.target.nodeName;
                            var offset = void 0;
                            // Logic to handle input / text area tags
                            var inputPosition = void 0;
                            var inputLength = void 0;
                            if (nodeName === "INPUT" || nodeName === "TEXTAREA") {
                                var input = event.target;
                                try {
                                    inputPosition = typeof input.selectionStart === "number" ? input.selectionStart : undefined;
                                }
                                catch (_a) {
                                    // Microsoft Edge throws InvalidStateError when calling 'input.selectionStart' on non-supported input element types
                                    // according to https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement
                                    // Ignore this error
                                }
                                inputLength = input.value.length;
                            }
                            var allowLeftArrow = inputPosition === undefined || (inputPosition === 0 && _this.props.allowArrowOutOfInputs);
                            var allowRightArrow = inputPosition === undefined ||
                                inputLength === undefined ||
                                (inputPosition === inputLength && _this.props.allowArrowOutOfInputs);
                            switch (event.which) {
                                case Util["KeyCode"].upArrow:
                                    if (nodeName !== "TEXTAREA") {
                                        if (_this.props.direction === FocusZoneDirection.Vertical) {
                                            offset = -1;
                                        }
                                    }
                                    break;
                                case Util["KeyCode"].downArrow:
                                    if (nodeName !== "TEXTAREA") {
                                        if (_this.props.direction === FocusZoneDirection.Vertical) {
                                            offset = 1;
                                        }
                                    }
                                    break;
                                case Util["KeyCode"].rightArrow:
                                    if (allowRightArrow) {
                                        if (_this.props.direction === FocusZoneDirection.Horizontal) {
                                            offset = 1;
                                        }
                                    }
                                    break;
                                case Util["KeyCode"].leftArrow:
                                    if (allowLeftArrow) {
                                        if (_this.props.direction === FocusZoneDirection.Horizontal) {
                                            offset = -1;
                                        }
                                    }
                                    break;
                                case Util["KeyCode"].tab:
                                    if (_this.props.handleTabKey) {
                                        offset = event.shiftKey ? -1 : 1;
                                    }
                                    break;
                                case Util["KeyCode"].enter:
                                    if (_this.props.activateOnEnter) {
                                        event.target.click();
                                    }
                            }
                            if (offset) {
                                if (_this.focusNextElement(event, offset)) {
                                    event.preventDefault();
                                }
                            }
                        }
                    }
                    if (ignoreKeystroke === FocusZoneKeyStroke.IgnoreParents) {
                        ignoreEvent = true;
                    }
                    // Perform any supplied event post processing.
                    if (!ignoreEvent && _this.props.postprocessKeyStroke) {
                        if (_this.props.postprocessKeyStroke(event) === FocusZoneKeyStroke.IgnoreParents) {
                            ignoreEvent = true;
                        }
                    }
                    // Once we reach the root focuszone we need to clear the ignoredEvent.
                    if (!parentContext.focuszoneId) {
                        ignoreEvent = false;
                    }
                } }));
        }))); }));
        if (this.props.focusGroupProps) {
            content = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusGroup["FocusGroup"], Object(tslib_es6["a" /* __assign */])({}, this.props.focusGroupProps), content);
        }
        return content;
    };
    FocusZone.prototype.componentDidMount = function () {
        var focusElement;
        // If a defaultActiveElement is supplied we will focus it. It is not required to
        // be member of the focus zone, it can be any element.
        if (this.props.focusOnMount) {
            var defaultActiveElement = this.props.defaultActiveElement;
            var focusElements = this.getFocusElements(typeof defaultActiveElement === "function" ? defaultActiveElement() : defaultActiveElement);
            if (focusElements.length > 0) {
                focusElement = focusElements[0];
            }
        }
        if (focusElement) {
            focusElement.focus();
        }
    };
    FocusZone.prototype.focusNextElement = function (event, offset) {
        var focusElements = this.getFocusElements();
        if (focusElements.length > 0) {
            var focusCurrent = document.activeElement;
            var rootElements = this.rootElements;
            // Determine if an element in the focus zone has focus.
            var focusIndex = focusElements.indexOf(focusCurrent);
            // Focus may not be on an element in the zone so we need to
            // figure out which one we are between in this case.
            if (focusIndex === -1) {
                var index = 0;
                // Determine if the element is in a portal or directly within a focuszone root.
                for (index = 0; index < rootElements.length; index++) {
                    var elementRef = rootElements[index];
                    if (elementRef.current) {
                        if (elementRef.current.contains(event.target)) {
                            break;
                        }
                    }
                }
                // If this is coming from a portal, we will use the element that last had focus.
                if (index === this.rootElements.length && this.lastFocusElement) {
                    focusIndex = focusElements.indexOf(this.lastFocusElement);
                }
                else {
                    for (index = 0; index < focusElements.length; index++) {
                        var relationship = Object(Util["getRelationship"])(focusCurrent, focusElements[index]);
                        if (relationship === Util["ElementRelationship"].Before) {
                            focusIndex = index - (offset > 0 ? 1 : 0);
                            break;
                        }
                        else if (relationship === Util["ElementRelationship"].Child) {
                            focusIndex = index;
                            break;
                        }
                        else if (relationship === Util["ElementRelationship"].After && index === focusElements.length - 1) {
                            focusIndex = focusElements.length;
                        }
                    }
                }
            }
            // Move to the next component in the set of focus zone components.
            focusIndex += offset;
            // If the FocusZone supports circular navigation and we are on the end
            // we will move to the element on the opposite end.
            if (this.props.circularNavigation) {
                if (focusIndex < 0) {
                    focusIndex = focusElements.length - 1;
                }
                else if (focusIndex >= focusElements.length) {
                    focusIndex = 0;
                }
            }
            // If we ended up on a focusable element update the focus.
            if (focusIndex > -1 && focusIndex < focusElements.length) {
                focusElements[focusIndex].focus();
                return true;
            }
        }
        return false;
    };
    FocusZone.prototype.getFocusElements = function (customSelector) {
        var focusElements = [];
        var selector = customSelector;
        // If a custom selector was supplied we will use it.
        if (!selector) {
            // The default selector will just pick up items tagged with this focuszone id.
            selector = "[data-focuszone~=" + this.state.focuszoneId + "]";
            // If we are including the default elements from the DOM we will add the
            // default selector to our list of selectors.
            if (this.props.includeDefaults) {
                selector += ",a[href],button,iframe,input,select,textarea,[tabIndex]";
            }
        }
        // Filter the elements that matched our query to the elements that are elligible
        // for receiving focus in this focuszone.
        for (var _i = 0, _a = this.rootElements; _i < _a.length; _i++) {
            var rootElement = _a[_i];
            if (rootElement.current) {
                var focusChildren = rootElement.current.querySelectorAll(selector);
                // Check if the root element matches our selector.
                if (rootElement.current.matches(selector) && this.isFocusElement(rootElement.current, customSelector)) {
                    focusElements.push(rootElement.current);
                }
                // Check all the children of the root that are potential focus elements.
                for (var rootIndex = 0; rootIndex < focusChildren.length; rootIndex++) {
                    var element = focusChildren[rootIndex];
                    if (this.isFocusElement(element, customSelector)) {
                        focusElements.push(element);
                    }
                }
            }
        }
        return focusElements;
    };
    /**
     * isFocusElement is used to determine whether or not an element should participate
     * in this focus zone.
     *
     * @param element HTML Element that you are testing as a valid focus element.
     *
     * @param customSelector A custom selector that is used to match elements with
     *  negative tabIndex. These wont match normally unless targetted by the custom
     *  selector.
     */
    FocusZone.prototype.isFocusElement = function (element, customSelector) {
        // Filter out elements that are disabled.
        if (element.hasAttribute("disabled")) {
            return false;
        }
        if (!customSelector) {
            // Filter out elements that are not visible.
            if (!this.props.skipHiddenCheck) {
                var style = window.getComputedStyle(element);
                if (style.visibility === "hidden" ||
                    style.display === "none" ||
                    !(element.offsetWidth || element.offsetHeight || element.getClientRects().length)) {
                    return false;
                }
            }
            // Filter out elements with negative tabIndex that aren't
            // explicity marked for this focuszone.
            var tabIndex = element.getAttribute("tabindex");
            if (tabIndex && parseInt(tabIndex) < 0) {
                var focuszoneId_1 = element.getAttribute("data-focuszone");
                if (!focuszoneId_1 || focuszoneId_1.indexOf(this.state.focuszoneId) < 0) {
                    return false;
                }
            }
        }
        return true;
    };
    return FocusZone;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/FocusZone.js

// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present



/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Components_Observer_ItemsObserver__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ItemsObserver", function() { return _Components_Observer_ItemsObserver__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_Observer_ItemsObserver_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(117);
/* harmony import */ var _Components_Observer_ItemsObserver_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_Observer_ItemsObserver_Props__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_Observer_ItemsObserver_Props__WEBPACK_IMPORTED_MODULE_1__) if(["default","ItemsObserver"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_Observer_ItemsObserver_Props__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _Components_Observer_Observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Observer", function() { return _Components_Observer_Observer__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _Components_Observer_Observer_Props__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(118);
/* harmony import */ var _Components_Observer_Observer_Props__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Components_Observer_Observer_Props__WEBPACK_IMPORTED_MODULE_3__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_Observer_Observer_Props__WEBPACK_IMPORTED_MODULE_3__) if(["default","ItemsObserver","Observer"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_Observer_Observer_Props__WEBPACK_IMPORTED_MODULE_3__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _Components_Observer_ReadyableArrayObserver__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(119);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReadyableArrayObserver", function() { return _Components_Observer_ReadyableArrayObserver__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony import */ var _Components_Observer_ReadyableArrayObserver_Props__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(120);
/* harmony import */ var _Components_Observer_ReadyableArrayObserver_Props__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Components_Observer_ReadyableArrayObserver_Props__WEBPACK_IMPORTED_MODULE_5__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_Observer_ReadyableArrayObserver_Props__WEBPACK_IMPORTED_MODULE_5__) if(["default","ItemsObserver","Observer","ReadyableArrayObserver"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_Observer_ReadyableArrayObserver_Props__WEBPACK_IMPORTED_MODULE_5__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _Components_Observer_SelectionObserver__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(121);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SelectionObserver", function() { return _Components_Observer_SelectionObserver__WEBPACK_IMPORTED_MODULE_6__["a"]; });

/* harmony import */ var _Components_Observer_SelectionObserver_Props__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(122);
/* harmony import */ var _Components_Observer_SelectionObserver_Props__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Components_Observer_SelectionObserver_Props__WEBPACK_IMPORTED_MODULE_7__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_Observer_SelectionObserver_Props__WEBPACK_IMPORTED_MODULE_7__) if(["default","ItemsObserver","Observer","ReadyableArrayObserver","SelectionObserver"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_Observer_SelectionObserver_Props__WEBPACK_IMPORTED_MODULE_7__[key]; }) }(__WEBPACK_IMPORT_KEY__));










/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Icon", function() { return /* reexport */ Icon; });
__webpack_require__.d(__webpack_exports__, "IconSize", function() { return /* reexport */ IconSize; });

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Icon/FabricIcons.css
var FabricIcons = __webpack_require__(222);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/TooltipEx.js
var TooltipEx = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Icon/Icon.js







function Icon(props) {
    if (props.render) {
        return props.render(props.className);
    }
    var iconWrapperProps = {
        id: Object(Util["getSafeId"])(props.id),
        onClick: props.onClick,
        onMouseDown: props.onMouseDown,
        onKeyDown: props.onKeyDown,
        role: props.role ? props.role : props.ariaLabel || props.ariaLabelledBy ? "img" : undefined,
        style: props.style,
        tabIndex: props.tabIndex,
        title: props.title
    };
    var iconClassName = Object(Util["css"])(props.className, "flex-noshrink", props.iconName && "fabric-icon", props.iconName && "ms-Icon--" + props.iconName, props.size);
    var ariaHidden = props.ariaHidden !== undefined ? props.ariaHidden : "true";
    var icon = props.ariaLabel || props.ariaLabelledBy || props.ariaExpanded !== undefined ? (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("span", Object(tslib_es6["a" /* __assign */])({ "aria-expanded": props.ariaExpanded, "aria-label": props.ariaLabel, "aria-labelledby": Object(Util["getSafeId"])(props.ariaLabelledBy), className: props.wrapperClass }, iconWrapperProps),
        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("span", { "aria-hidden": ariaHidden, className: iconClassName }))) : (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("span", Object(tslib_es6["a" /* __assign */])({ "aria-hidden": ariaHidden, className: iconClassName }, iconWrapperProps)));
    if (props.tooltipProps) {
        icon = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TooltipEx["Tooltip"], Object(tslib_es6["a" /* __assign */])({}, props.tooltipProps), icon);
    }
    return icon;
}

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Icon/Icon.Props.js
/**
 * Note the default IconSize when a custom size is not specified matches
 * the standard body-m font or 0.875rem - 14px.
 */
var IconSize;
(function (IconSize) {
    /**
     * Inherit has the icon take on the current text size.
     */
    IconSize["inherit"] = "";
    /**
     * 1.5rem - 24px
     */
    IconSize["large"] = "large";
    /**
     * 1rem - 16px
     */
    IconSize["medium"] = "medium";
    /**
     * 0.75rem - 12px
     */
    IconSize["small"] = "small";
})(IconSize || (IconSize = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Icon.js




/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return '@media ' + item[2] + '{' + content + '}';
      } else {
        return content;
      }
    }).join('');
  }; // import a list of modules into the list


  list.i = function (modules, mediaQuery) {
    if (typeof modules === 'string') {
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    for (var i = 0; i < this.length; i++) {
      var id = this[i][0];

      if (id != null) {
        alreadyImportedModules[id] = true;
      }
    }

    for (i = 0; i < modules.length; i++) {
      var item = modules[i]; // skip already imported module
      // this implementation is not 100% perfect for weird media query combinations
      // when a module is imported multiple times with different media queries.
      // I hope this will never occur (Hey this way we have smaller bundles)

      if (item[0] == null || !alreadyImportedModules[item[0]]) {
        if (mediaQuery && !item[2]) {
          item[2] = mediaQuery;
        } else if (mediaQuery) {
          item[2] = '(' + item[2] + ') and (' + mediaQuery + ')';
        }

        list.push(item);
      }
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || '';
  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
  return '/*# ' + data + ' */';
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target, parent) {
  if (parent){
    return parent.querySelector(target);
  }
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target, parent) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target, parent);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(206);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertAt.before, target);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	if(options.attrs.nonce === undefined) {
		var nonce = getNonce();
		if (nonce) {
			options.attrs.nonce = nonce;
		}
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function getNonce() {
	if (false) {}

	return __webpack_require__.nc;
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = typeof options.transform === 'function'
		 ? options.transform(obj.css) 
		 : options.transform.default(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Location; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return distance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return position; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateLayout; });
var LAYOUT_CALCULATION_MAX_TIMES = 5;
var TOOLTIP_OFFSET = 10;
var Location;
(function (Location) {
    Location["start"] = "start";
    Location["center"] = "center";
    Location["end"] = "end";
})(Location || (Location = {}));
/**
 * Calculates the distance between two points
 * @param pointA First point
 * @param pointB Second point
 */
function distance(pointA, pointB) {
    return Math.sqrt(Math.pow(pointA.x - pointB.x, 2) + Math.pow(pointA.y - pointB.y, 2));
}
/**
 * The position method is used to set the location of an absolutely positioned element
 * using the standard positioning properties. The names of these properties conform to
 * the naming patterns used in the Material Popover https://material-ui.com. They
 * are not exact but follow the same pattern.
 *
 * For an example usage, look at the Callout component and how it uses this method to
 * position the element in the page.
 *
 * @param transformElement The element that is being positioned/transformed.
 * @param transformOrigin The origin within the transformed element to align with the
 *  anchor position.
 * @param anchorOffset Offset on the anchorElement that is applied to the computed location
 *  given the element/origin/point.
 * @param anchorElement The element used to anchor the position of the transformed element.
 *  The caller must supply either an anchorElement and anchorOrigin, or anchorPoint.
 * @param anchorOrigin When an anchorElement is supplied the anchorOrigin defines the location
 *  on the anchorElement used for positioning.
 * @param anchorPoint Instead of an anchorElement the caller can use an explicit point
 *  to be used as the basis for the anchorLocation. The anchorOffset will still be applied.
 * @param extraSpaceSize Sets the value of how much the container is larger than the window in all directions.
 */
function position(transformElement, transformOrigin, anchorOffset, anchorElement, anchorOrigin, anchorPoint, extraSpaceSize) {
    if (extraSpaceSize === void 0) { extraSpaceSize = 5000; }
    // Translate the anchor location information to a point on the anchor element
    // if a specific point was not supplied.
    if (!anchorPoint) {
        if (anchorElement && anchorOrigin) {
            anchorPoint = pointFromOrigin(anchorOrigin, anchorElement.getBoundingClientRect());
        }
        else {
            return;
        }
    }
    var xPosition = anchorPoint.x;
    var yPosition = anchorPoint.y;
    var translateXFactor = 0;
    var translateYFactor = 0;
    // Update the anchorPoint by the anchorOffset if one was supplied.
    if (anchorOffset) {
        xPosition += anchorOffset.horizontal;
        yPosition += anchorOffset.vertical;
    }
    // Special case Start/Start since we dont need the parent rect.
    if (transformOrigin.horizontal !== Location.start || transformOrigin.vertical !== Location.start) {
        var windowHeight = document.documentElement.clientHeight;
        var windowWidth = document.documentElement.clientWidth;
        // Compute the effective horizontal position of the element.
        switch (transformOrigin.horizontal) {
            case Location.end:
                xPosition = windowWidth - xPosition;
                break;
            case Location.center:
                translateXFactor = -50;
                break;
            default:
        }
        // Compute the effective vertical position of the element.
        switch (transformOrigin.vertical) {
            case Location.end:
                yPosition = windowHeight - yPosition;
                break;
            case Location.center:
                translateYFactor = -50;
                break;
            default:
        }
    }
    // Update the transform elements position (it needs to be absolutely positioned in the window).
    // Void out other styles in case this is a re-call
    if (transformOrigin.horizontal !== Location.end) {
        transformElement.style.left = xPosition + extraSpaceSize + "px";
        transformElement.style.right = "";
    }
    else {
        transformElement.style.left = "";
        transformElement.style.right = xPosition + extraSpaceSize + "px";
    }
    if (transformOrigin.vertical !== Location.end) {
        transformElement.style.top = yPosition + extraSpaceSize + "px";
        transformElement.style.bottom = "";
    }
    else {
        transformElement.style.top = "";
        transformElement.style.bottom = yPosition + extraSpaceSize + "px";
    }
    // Apply centering as necessary
    if (translateXFactor !== 0 || translateYFactor !== 0) {
        transformElement.style.transform = "translate(" + translateXFactor + "%, " + translateYFactor + "%)";
    }
    else {
        transformElement.style.transform = "";
    }
}
/**
 * updateLayout is used to move an element to the "best" location based on it
 * layout. This will look at all the positioning attributes and move the
 * transformElement to a new location based on its size. This is usually done
 * after an initial call to position. After the element is positioned the
 * caller determines if the transformElement is in the desired location, which
 * generally translates to, is it clipped in the window.
 *
 * This is delayed because when position is called the transformElement is
 * frequently not fully laid out and we need to wait other a force reflow will
 * happen and cause performance issues.
 *
 * @param transformElement The element that is being positioned/transformed.
 * @param transformOrigin The origin within the transformed element to align with the
 *  anchor position.
 * @param anchorOffset Offset on the anchorElement that is applied to the computed location
 *  given the element/origin/point.
 * @param anchorElement The element used to anchor the position of the transformed element.
 *  The caller must supply either an anchorElement and anchorOrigin, or anchorPoint.
 * @param anchorOrigin When an anchorElement is supplie the anchorOrigin defines the location
 *  on the anchorElement used for positioning.
 * @param anchorPoint Instead of an anchorElement the caller can use an explicit point
 *  to be used as the basis for the anchorLocation. The anchorOffset will still be applied.
 * @param extraSpaceSize Sets the value of how much the container is larger than the window in all directions.
 * @param recursionControl Use it to avoid infinite loop and call this function LAYOUT_CALCULATION_MAX_TIMES times at most.
 */
function updateLayout(transformElement, transformOrigin, anchorOffset, anchorElement, anchorOrigin, anchorPoint, extraSpaceSize, recursionControl) {
    if (extraSpaceSize === void 0) { extraSpaceSize = 5000; }
    if (recursionControl === void 0) { recursionControl = 0; }
    var windowHeight = document.documentElement.clientHeight;
    var windowWidth = document.documentElement.clientWidth;
    // Get the current layout for the transformElement to determine the best layout.
    var transformElementRect = transformElement.getBoundingClientRect();
    // Determine which edges of the transform element are clipped by the window.
    var clippedBottom = Math.floor(transformElementRect.bottom) > windowHeight;
    var clippedRight = Math.floor(transformElementRect.right) > windowWidth;
    var clippedLeft = Math.floor(transformElementRect.left) < 0;
    var clippedTop = Math.floor(transformElementRect.top) < 0;
    // If any of the edges are clipped we will update the layout to a better layout if available.
    if (clippedBottom || clippedRight || clippedLeft || clippedTop) {
        // If we are positioned based on a point and and offset we will flip over
        // the clipped edge.
        if (anchorPoint) {
            // Flip vertically top/bottom depending on the clipping edges.
            if (clippedTop !== clippedBottom) {
                if (clippedTop) {
                    // Before we flip lets make sure we have at least TOOLTIP_OFFSET more pixels the other direction.
                    if (transformElementRect.bottom < windowHeight / 2 - TOOLTIP_OFFSET) {
                        if (transformOrigin.vertical === Location.end) {
                            transformOrigin.vertical = Location.start;
                        }
                    }
                }
                else {
                    // Before we flip lets make sure we have at least TOOLTIP_OFFSET more pixels the other direction.
                    if (transformElementRect.top > windowHeight / 2 + TOOLTIP_OFFSET) {
                        if (transformOrigin.vertical === Location.start) {
                            transformOrigin.vertical = Location.end;
                        }
                    }
                }
                if (anchorOffset) {
                    anchorOffset.vertical = -anchorOffset.vertical;
                }
            }
            // Flip hoizontally left/right depending on the clipping edges.
            if (clippedLeft !== clippedRight) {
                if (clippedLeft) {
                    // Before we flip lets make sure we have at least TOOLTIP_OFFSET more pixels the other direction.
                    if (transformElementRect.right < windowWidth / 2 - TOOLTIP_OFFSET) {
                        if (transformOrigin.horizontal === Location.end) {
                            transformOrigin.horizontal = Location.start;
                        }
                    }
                }
                else {
                    // Before we flip lets make sure we have at least TOOLTIP_OFFSET more pixels the other direction.
                    if (transformElementRect.left > windowWidth / 2 + TOOLTIP_OFFSET) {
                        if (transformOrigin.horizontal === Location.start) {
                            transformOrigin.horizontal = Location.end;
                        }
                    }
                }
                if (anchorOffset) {
                    anchorOffset.horizontal = -anchorOffset.horizontal;
                }
            }
        }
        // If the element is positioned based on an anchorElement/anchorOrigin
        // we need to look determine if the element can slide along any axis.
        else if (anchorOrigin && anchorElement) {
            // Flip vertically top/bottom depending on the clipping edges.
            if (clippedTop !== clippedBottom) {
                if (clippedTop) {
                    // Before we flip lets make sure we have at least TOOLTIP_OFFSET more pixels the other direction.
                    if (transformElementRect.bottom < windowHeight / 2 - TOOLTIP_OFFSET) {
                        if (transformOrigin.vertical === Location.end && anchorOrigin.vertical === Location.start) {
                            transformOrigin.vertical = Location.start;
                            anchorOrigin.vertical = Location.end;
                        }
                        else if (transformOrigin.vertical === Location.center ||
                            (transformOrigin.vertical === Location.end && anchorOrigin.vertical === Location.end)) {
                            transformOrigin.vertical = Location.start;
                            anchorOrigin.vertical = Location.start;
                        }
                    }
                }
                else {
                    // Before we flip lets make sure we have at least TOOLTIP_OFFSET more pixels the other direction.
                    if (transformElementRect.top > windowHeight / 2 + TOOLTIP_OFFSET) {
                        if (transformOrigin.vertical === Location.start && anchorOrigin.vertical === Location.end) {
                            transformOrigin.vertical = Location.end;
                            anchorOrigin.vertical = Location.start;
                        }
                        else if (transformOrigin.vertical === Location.center ||
                            (transformOrigin.vertical === Location.start && anchorOrigin.vertical === Location.start)) {
                            transformOrigin.vertical = Location.end;
                            anchorOrigin.vertical = Location.end;
                        }
                    }
                }
                if (anchorOffset) {
                    anchorOffset.vertical = -anchorOffset.vertical;
                }
            }
            if (clippedLeft !== clippedRight) {
                // Flip hoizontally left/right depending on the clipping edges.
                if (clippedLeft) {
                    // Before we flip lets make sure we have at least TOOLTIP_OFFSET more pixels the other direction.
                    if (transformElementRect.right < windowWidth / 2 - TOOLTIP_OFFSET) {
                        if (transformOrigin.horizontal === Location.end && anchorOrigin.horizontal === Location.start) {
                            transformOrigin.horizontal = Location.start;
                            anchorOrigin.horizontal = Location.end;
                        }
                        else if (transformOrigin.horizontal === Location.center ||
                            (transformOrigin.horizontal === Location.end && anchorOrigin.horizontal === Location.end)) {
                            transformOrigin.horizontal = Location.start;
                            anchorOrigin.horizontal = Location.start;
                        }
                    }
                }
                else {
                    // Before we flip lets make sure we have at least TOOLTIP_OFFSET more pixels the other direction.
                    if (transformElementRect.left > windowWidth / 2 + TOOLTIP_OFFSET) {
                        if (transformOrigin.horizontal === Location.start && anchorOrigin.horizontal === Location.end) {
                            transformOrigin.horizontal = Location.end;
                            anchorOrigin.horizontal = Location.start;
                        }
                        else if (transformOrigin.horizontal === Location.center ||
                            (transformOrigin.horizontal === Location.start && anchorOrigin.horizontal === Location.start)) {
                            transformOrigin.horizontal = Location.end;
                            anchorOrigin.horizontal = Location.end;
                        }
                    }
                }
                if (anchorOffset) {
                    anchorOffset.horizontal = -anchorOffset.horizontal;
                }
            }
        }
        // Update the position based on the changes made to the location details.
        position(transformElement, transformOrigin, anchorOffset, anchorElement, anchorOrigin, anchorPoint, extraSpaceSize);
        // If the repositioned element doesnt fit, we will put max-height/max-width to
        // force the entire element into the viewport.
        transformElementRect = transformElement.getBoundingClientRect();
        // Determine which edges of the transform element are clipped by the window.
        clippedBottom = Math.floor(transformElementRect.bottom) > windowHeight;
        clippedRight = Math.floor(transformElementRect.right) > windowWidth;
        clippedLeft = Math.floor(transformElementRect.left) < 0;
        clippedTop = Math.floor(transformElementRect.top) < 0;
        // Since we are clipped compute the updated sizes and position a second time.
        if (clippedTop || clippedBottom || clippedLeft || clippedRight) {
            if (clippedTop || clippedBottom) {
                var maxHeight = transformElementRect.height -
                    (clippedTop ? -transformElementRect.top : 0) -
                    (clippedBottom ? transformElementRect.bottom - windowHeight : 0) -
                    5;
                transformElement.style.maxHeight = maxHeight + "px";
            }
            if (clippedLeft || clippedRight) {
                var maxWidth = transformElementRect.width -
                    (clippedLeft ? -transformElementRect.left : 0) -
                    (clippedRight ? transformElementRect.right - windowWidth : 0) -
                    5;
                transformElement.style.maxWidth = maxWidth + "px";
            }
            // Note the change to the component with the overflow className.
            transformElement.classList.add("overflow");
            position(transformElement, transformOrigin, anchorOffset, anchorElement, anchorOrigin, anchorPoint, extraSpaceSize);
            if (recursionControl < LAYOUT_CALCULATION_MAX_TIMES) {
                // Since we changed width/height of the control, let's check if it's cut-off.
                transformElementRect = transformElement.getBoundingClientRect();
                clippedBottom = Math.floor(transformElementRect.bottom) > windowHeight;
                clippedRight = Math.floor(transformElementRect.right) > windowWidth;
                clippedLeft = Math.floor(transformElementRect.left) < 0;
                clippedTop = Math.floor(transformElementRect.top) < 0;
                // Go through all the logic one more time if tooltip doesn't fit in.
                if (clippedBottom || clippedRight || clippedLeft || clippedTop) {
                    updateLayout(transformElement, transformOrigin, anchorOffset, anchorElement, anchorOrigin, anchorPoint, extraSpaceSize, ++recursionControl);
                }
            }
        }
    }
}
function pointFromOrigin(location, rect) {
    var x;
    var y;
    // Compute the horizontal position based on the rectangle.
    switch (location.horizontal) {
        case Location.start:
            x = rect.left;
            break;
        case Location.end:
            x = rect.right;
            break;
        default:
            x = rect.left + rect.width / 2;
    }
    // Compute the vertical position based on the rectangle.
    switch (location.vertical) {
        case Location.start:
            y = rect.top;
            break;
        case Location.end:
            y = rect.bottom;
            break;
        default:
            y = rect.top + rect.height / 2;
    }
    return { x: x, y: y };
}


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TableColumnLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TableColumnStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SortOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColumnJustification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IMeasurementStyle; });
/**
 * TableColumnLayout is used to define the general shape of the data for a given
 * column. One of the purposes of this is an animation when the rows are loaded
 * asynchronously.
 *
 * If the caller wants non-standard shapes a custom loading row function will need
 * to be implemented. For any columns that fit the standard shapes the exported
 * functions can be used.
 */
var TableColumnLayout;
(function (TableColumnLayout) {
    /**
     * If a column is noted as none, when an asynchronous row is loaded no
     * animation will be added to this column.
     */
    TableColumnLayout[TableColumnLayout["none"] = 0] = "none";
    /**
     * The row uses a single line of text. This is the default for a column that
     * doesnt explicitly define a column layout
     */
    TableColumnLayout[TableColumnLayout["singleLine"] = 1] = "singleLine";
    /**
     * The row uses a single line of text with a small prefix.
     */
    TableColumnLayout[TableColumnLayout["singleLinePrefix"] = 2] = "singleLinePrefix";
    /**
     * The row uses two lines of text.
     */
    TableColumnLayout[TableColumnLayout["twoLine"] = 3] = "twoLine";
    /**
     * The row uses two lines of text with a large prefex.
     */
    TableColumnLayout[TableColumnLayout["twoLinePrefix"] = 4] = "twoLinePrefix";
})(TableColumnLayout || (TableColumnLayout = {}));
/**
 * The ColumnStyles effect how the values for the column should be rendered.
 */
var TableColumnStyle;
(function (TableColumnStyle) {
    /**
     * Secondary colums should be rendered normally.
     */
    TableColumnStyle[TableColumnStyle["Secondary"] = 1] = "Secondary";
    /**
     * Primary columns should be rendered with emphasis.
     */
    TableColumnStyle[TableColumnStyle["Primary"] = 2] = "Primary";
    /**
     * Tertiary columns should be rendered de-emphasized.
     */
    TableColumnStyle[TableColumnStyle["Tertiary"] = 3] = "Tertiary";
})(TableColumnStyle || (TableColumnStyle = {}));
/**
 * Sorting order for columns
 */
var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["ascending"] = 0] = "ascending";
    SortOrder[SortOrder["descending"] = 1] = "descending";
})(SortOrder || (SortOrder = {}));
/**
 * Justification of the content within a column
 */
var ColumnJustification;
(function (ColumnJustification) {
    ColumnJustification[ColumnJustification["Left"] = 0] = "Left";
    ColumnJustification[ColumnJustification["Right"] = 1] = "Right";
})(ColumnJustification || (ColumnJustification = {}));
/**
 * An IMeasurementStyle is used to represent a fixed size. The fixed size may be
 * based on a number of base measurement values.
 */
var IMeasurementStyle;
(function (IMeasurementStyle) {
    /**
     * Pixels represented by the 'px' css measurement.
     */
    IMeasurementStyle[IMeasurementStyle["Pixel"] = 0] = "Pixel";
    /**
     * RootEMs represented by the 'rem' css measurement.
     */
    IMeasurementStyle[IMeasurementStyle["REM"] = 1] = "REM";
})(IMeasurementStyle || (IMeasurementStyle = {}));


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_Button_Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return _Components_Button_Button__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_Button_Button_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(140);
/* harmony import */ var _Components_Button_Button_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_Button_Button_Props__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_Components_Button_Button_Props__WEBPACK_IMPORTED_MODULE_1__, "ExpandableButton")) __webpack_require__.d(__webpack_exports__, "ExpandableButton", function() { return _Components_Button_Button_Props__WEBPACK_IMPORTED_MODULE_1__["ExpandableButton"]; });

/* harmony import */ var _Components_Button_ExpandableButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(141);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpandableButton", function() { return _Components_Button_ExpandableButton__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _Components_Button_ExpandableButton_Props__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(144);
/* harmony import */ var _Components_Button_ExpandableButton_Props__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Components_Button_ExpandableButton_Props__WEBPACK_IMPORTED_MODULE_3__);






/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return announce; });
/* unused harmony export ProgressAnnouncer */
/**
 * Maximum number of messages to have in the containers that announce() uses.
 */
var MaxAnnounceChildren = 1;
/**
 * Maximum number of containers for announce() to have per assertiveness level.
 */
var MaxAnnounceContainers = 10;
/**
 * Default number of milliseconds to wait before announcing the start of an operation.
 */
var DefaultAnnounceDelay = 1000;
/**
 * ID of the container for the announce() containers.
 */
var ParentContainerId = "utils-accessibility-announce";
var nextId = 0;
/**
 * Gets the parent container for all the announce containers.
 */
function getAnnounceContainer() {
    var container = document.getElementById(ParentContainerId);
    if (!container) {
        container = document.createElement("div");
        container.id = ParentContainerId;
        container.classList.add("visually-hidden");
        document.body.appendChild(container);
    }
    return container;
}
/**
 * Causes screen readers to read the given message.
 * @param message
 * @param assertive if true, the screen reader will read the announcement immediately, instead of waiting for "the next graceful opportunity"
 */
function announce(message, assertive, pause) {
    if (assertive === void 0) { assertive = false; }
    if (pause === void 0) { pause = 100; }
    if (!message) {
        return;
    }
    var assertiveness = assertive ? "assertive" : "polite";
    var parentContainer = getAnnounceContainer();
    var containerList = parentContainer.getElementsByClassName(assertiveness);
    var container = (containerList.length > 0 ? containerList[containerList.length - 1] : null);
    if (!container || container.childElementCount >= MaxAnnounceChildren) {
        container = document.createElement("div");
        container.id = ParentContainerId + nextId++;
        container.setAttribute("aria-live", assertiveness);
        container.classList.add(assertiveness);
        container.setAttribute("aria-relevant", "additions");
        parentContainer.appendChild(container);
        // getElementsByClassName() returns a live list so the new container is already in this list
        if (containerList.length > MaxAnnounceContainers) {
            // remove old containers
            parentContainer.removeChild(containerList[0]);
        }
        window.setTimeout(function () {
            // live regions get announced on update not create, so wait a bit and then update
            announce(message, assertive);
        }, pause);
    }
    else {
        var child = document.createElement("p");
        child.textContent = message;
        container.appendChild(child);
        // toggling the visibility like this seems to help Edge
        container.style.visibility = "hidden";
        container.style.visibility = "visible";
    }
}
/**
 * Class for announcing, through a screen reader, when a single operation begins and ends. Supports
 * a delay before the starting announcement so that quick operations don't trigger announcements.
 *
 * To use, create a ProgressAnnouncer, and call completed()
 */
var ProgressAnnouncer = /** @class */ (function () {
    function ProgressAnnouncer(options) {
        this._startAnnounced = false;
        this._completed = false;
        this._options = options;
        this._start();
    }
    /**
     * Create a ProgressAnnouncer for a promise that will announce promise start and completion/rejection.
     * @param promise
     * @param options
     */
    ProgressAnnouncer.forPromise = function (promise, options) {
        var announcer = new ProgressAnnouncer(options);
        promise.then(function () {
            announcer.announceCompleted();
        }, function () {
            announcer.announceError();
        });
        return announcer;
    };
    /**
     * Call this method when the operation has completed. This will cause the end message to be
     * announced if the start message was announced.
     */
    ProgressAnnouncer.prototype.announceCompleted = function () {
        if (!this._completed) {
            this._completed = true;
            if (this._startAnnounced) {
                announce(this._options.announceEndMessage);
            }
        }
    };
    /**
     * Call this method if the operation completes with an error. This will cause the error message
     * to be announced regardless of whether or not the start message was announced.
     */
    ProgressAnnouncer.prototype.announceError = function () {
        if (!this._completed) {
            this._completed = true;
            announce(this._options.announceErrorMessage);
        }
    };
    /**
     * Call this method to stop any announcements from being made
     */
    ProgressAnnouncer.prototype.cancel = function () {
        this._completed = true;
    };
    ProgressAnnouncer.prototype._start = function () {
        var _this = this;
        // this._announceDelay = Utils_Core.delay(this, this._options.announceStartDelay !== undefined ? this._options.announceStartDelay : DefaultAnnounceDelay, () => {
        window.setTimeout(function () {
            if (!_this._completed) {
                announce(_this._options.announceStartMessage);
            }
            _this._startAnnounced = true;
        }, this._options.announceStartDelay !== undefined ? this._options.announceStartDelay : DefaultAnnounceDelay);
    };
    return ProgressAnnouncer;
}());



/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export localeComparer */
/* unused harmony export localeIgnoreCaseComparer */
/* unused harmony export equals */
/* unused harmony export startsWith */
/* unused harmony export endsWith */
/* unused harmony export caseInsensitiveContains */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* unused harmony export localeFormat */
/* unused harmony export dateToString */
/* unused harmony export EmptyGuidString */
/* unused harmony export isGuid */
/* unused harmony export newGuid */
/* unused harmony export containsControlChars */
/* unused harmony export containsMismatchedSurrogateChars */
function prepareForComparison(value, upperCase) {
    return value ? (upperCase ? value.toLocaleUpperCase() : value) : "";
}
function comparer(a, b, ignoreCase) {
    // Optimization: if the strings are equal no need to convert and perform a locale compare.
    if (a === b) {
        return 0;
    }
    return prepareForComparison(a, ignoreCase).localeCompare(prepareForComparison(b, ignoreCase));
}
/**
 * String comparer (to use for sorting) which is case-sensitive
 *
 * @param a First string to compare
 * @param b Second string to compare
 */
function localeComparer(a, b) {
    return comparer(a, b, false);
}
/**
 * String comparer (to use for sorting) which is case-insensitive
 *
 * @param a First string to compare
 * @param b Second string to compare
 */
function localeIgnoreCaseComparer(a, b) {
    return comparer(a, b, true);
}
/**
 * Compares 2 strings for equality.
 *
 * @param a First string to compare
 * @param b Second string to compare
 * @param ignoreCase If true, do a case-insensitive comparison.
 */
function equals(a, b, ignoreCase) {
    if (ignoreCase) {
        return localeIgnoreCaseComparer(a, b) === 0;
    }
    else {
        return localeComparer(a, b) === 0;
    }
}
/**
 * Checks whether the given string starts with the specified prefix.
 *
 * @param str String to check
 * @param prefix Substring that the {str} argument must start with in order to return true
 * @param ignoreCase If true, do a case insensitive comparison
 */
function startsWith(str, prefix, ignoreCase) {
    var comparer = ignoreCase ? localeIgnoreCaseComparer : localeComparer;
    return comparer(prefix, str.substr(0, prefix.length)) === 0;
}
/**
 * Checks whether the given string ends with the specified suffix.
 *
 * @param str String to check
 * @param suffix Substring that the {str} argument must end with in order to return true
 * @param ignoreCase If true, do a case insensitive comparison
 */
function endsWith(str, suffix, ignoreCase) {
    var comparer = ignoreCase ? localeIgnoreCaseComparer : localeComparer;
    return comparer(suffix, str.substr(str.length - suffix.length, suffix.length)) === 0;
}
/**
 * Performs a case-insensitive contains operation
 *
 * @param str String to check if it contains {subStr}
 * @param subStr The string that the {str} argument must contain in order to return true
 */
function caseInsensitiveContains(str, subStr) {
    return str.toLocaleLowerCase().indexOf(subStr.toLocaleLowerCase()) !== -1;
}
/**
 * Generate a string using a format string and arguments.
 *
 * @param format Format string
 * @param args Arguments to use as replacements
 */
function format(format) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return _stringFormat(false, format, args);
}
/**
 * Generate a string using a format string and arguments, using locale-aware argument replacements.
 *
 * @param format Format string
 * @param args Arguments to use as replacements
 */
function localeFormat(format) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return _stringFormat(true, format, args);
}
function _stringFormat(useLocale, format, args) {
    var result = "";
    for (var i = 0;;) {
        var open_1 = format.indexOf("{", i);
        var close_1 = format.indexOf("}", i);
        if (open_1 < 0 && close_1 < 0) {
            result += format.slice(i);
            break;
        }
        if (close_1 > 0 && (close_1 < open_1 || open_1 < 0)) {
            if (format.charAt(close_1 + 1) !== "}") {
                throw new Error("The format string contains an unmatched opening or closing brace.");
            }
            result += format.slice(i, close_1 + 1);
            i = close_1 + 2;
            continue;
        }
        result += format.slice(i, open_1);
        i = open_1 + 1;
        if (format.charAt(i) === "{") {
            result += "{";
            i++;
            continue;
        }
        if (close_1 < 0) {
            throw new Error("The format string contains an unmatched opening or closing brace.");
        }
        var brace = format.substring(i, close_1);
        var colonIndex = brace.indexOf(":");
        var argNumber = parseInt(colonIndex < 0 ? brace : brace.substring(0, colonIndex), 10);
        if (isNaN(argNumber)) {
            throw new Error("The format string is invalid.");
        }
        var argFormat = colonIndex < 0 ? "" : brace.substring(colonIndex + 1);
        var arg = args[argNumber];
        if (typeof arg === "undefined" || arg === null) {
            arg = "";
        }
        if (arg.toFormattedString) {
            result += arg.toFormattedString(argFormat);
        }
        else if (arg instanceof Date) {
            result += dateToString(arg, useLocale);
        }
        else if (arg.format) {
            result += arg.format(argFormat);
        }
        else {
            result += arg.toString();
        }
        i = close_1 + 1;
    }
    return result;
}
var localeFormatters = ("Intl" in window) ? {
    date: new Intl.DateTimeFormat(),
    dateTime: new Intl.DateTimeFormat(undefined, {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    })
} : {};
/**
 * Converts a date to a string, optionally using the locale formatter
 *
 * @param value date to convert to a string
 * @param useLocale use the locale formatter when converting to a string
 */
function dateToString(value, useLocale) {
    var localeKey = typeof useLocale === "string" ? useLocale : "dateTime";
    if (useLocale) {
        var formatter = localeFormatters[localeKey];
        if (!formatter) {
            if (false) {}
            else {
                formatter = localeFormatters["dateTime"];
            }
        }
        return formatter.format(value);
    }
    else {
        return value.toString();
    }
}
/**
 * String representation of the empty guid
 */
var EmptyGuidString = "00000000-0000-0000-0000-000000000000";
/**
 * Is the given string in the format of a GUID
 *
 * @param str String to check
 */
function isGuid(str) {
    return /^\{?([\dA-F]{8})-?([\dA-F]{4})-?([\dA-F]{4})-?([\dA-F]{4})-?([\dA-F]{12})\}?$/i.test(str);
}
/**
 * Returns a GUID such as xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx.
 * @return New GUID.(UUID version 4 = xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx)
 * @notes Disclaimer: This implementation uses non-cryptographic random number generator so absolute uniqueness is not guarantee.
 */
function newGuid() {
    // c.f. rfc4122 (UUID version 4 = xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx)
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = (128 + Math.floor(Math.random() * 64)).toString(16);
    return oct(8) + "-" + oct(4) + "-4" + oct(3) + "-" + clockSequenceHi + oct(2) + "-" + oct(12);
}
var controlChars = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F]/;
function containsControlChars(str) {
    return controlChars.test(str);
}
var surrogateChars = /(^[\uD800-\uDFFF]$)|[^\uD800-\uDBFF](?=[\uDC00-\uDFFF])|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/;
function containsMismatchedSurrogateChars(str) {
    return surrogateChars.test(str);
}
/**
 * Generated non-zero octet sequences for use with GUID generation.
 *
 * @param length Length required.
 * @return Non-Zero hex sequences.
 */
function oct(length) {
    var result = "";
    for (var i = 0; i < length; i++) {
        result += Math.floor(Math.random() * 0x10).toString(16);
    }
    return result;
}


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnnounceFilterCleared; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AnnounceFilterResultCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AnnounceFinishedLoadingItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AnnounceItemCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AnnounceLoadingItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ClearText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Close; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DropdownCalloutRoleDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DropdownClearActionText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DropdownExpandableRoleDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return HeaderAriaLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ListboxAriaLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return Loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NoFilterResults; });
/* unused harmony export NoItemsFound */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SearchAriaLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return Searching; });
/* unused harmony export UseItem */
var AnnounceFilterCleared = "Filter selection cleared";
var AnnounceFilterResultCount = "Showing {0} filtered items.";
var AnnounceFinishedLoadingItems = "Finished loading items";
var AnnounceItemCount = "Showing {0} items.";
var AnnounceLoadingItems = "Loading items";
var ClearText = "Clear text";
var Close = "Close";
var DropdownCalloutRoleDescription = "Expanded dropdown";
var DropdownClearActionText = "Clear";
var DropdownExpandableRoleDescription = "Dropdown";
var HeaderAriaLabel = "Header {0}";
var ListboxAriaLabel = "Listbox";
var Loading = "Loading...";
var NoFilterResults = "No items matched the supplied filter";
var NoItemsFound = "No items found";
var SearchAriaLabel = "Search";
var Searching = "Searching...";
var UseItem = "Use \"{0}\"";


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "SurfaceContext", function() { return /* reexport */ SurfaceContext; });
__webpack_require__.d(__webpack_exports__, "Surface", function() { return /* reexport */ Surface_Surface; });
__webpack_require__.d(__webpack_exports__, "Spacing", function() { return /* reexport */ Spacing; });
__webpack_require__.d(__webpack_exports__, "SurfaceBackground", function() { return /* reexport */ SurfaceBackground; });

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Surface/Surface.css
var Surface = __webpack_require__(232);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Surface/Surface.Props.js
/**
 * Defines how spacing should be applied to the children of a container.
 */
var Spacing;
(function (Spacing) {
    Spacing[Spacing["condensed"] = 0] = "condensed";
    Spacing[Spacing["default"] = 1] = "default";
    Spacing[Spacing["relaxed"] = 2] = "relaxed";
})(Spacing || (Spacing = {}));
var SurfaceBackground;
(function (SurfaceBackground) {
    SurfaceBackground[SurfaceBackground["normal"] = 0] = "normal";
    SurfaceBackground[SurfaceBackground["neutral"] = 1] = "neutral";
    SurfaceBackground[SurfaceBackground["callout"] = 2] = "callout";
})(SurfaceBackground || (SurfaceBackground = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Surface/Surface.js





var SurfaceContext = external_commonjs_react_commonjs2_react_amd_React_root_React_["createContext"]({
    background: SurfaceBackground.normal,
    horizontalClassName: undefined,
    spacing: undefined,
    verticalClassName: undefined
});
var Surface_Surface = function (props) {
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](SurfaceContext.Provider, { value: {
            background: props.background,
            horizontalClassName: getHorizontalSpacingClassName(props.spacing),
            spacing: props.spacing
        } }, props.children));
};
function getHorizontalSpacingClassName(spacing) {
    if (spacing !== undefined) {
        return horizontalSpacingClassNames[spacing];
    }
    return undefined;
}
var horizontalSpacingClassNames = [
    "bolt-condensed-horizontal-spacing",
    "bolt-default-horizontal-spacing",
    "bolt-relaxed-horizontal-spacing"
];

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Surface.js




/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Components_TooltipEx_Tooltip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(124);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TooltipStatus", function() { return _Components_TooltipEx_Tooltip__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return _Components_TooltipEx_Tooltip__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_TooltipEx_Tooltip_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(129);
/* harmony import */ var _Components_TooltipEx_Tooltip_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_TooltipEx_Tooltip_Props__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_TooltipEx_Tooltip_Props__WEBPACK_IMPORTED_MODULE_1__) if(["default","TooltipStatus","Tooltip"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_TooltipEx_Tooltip_Props__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));




/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AllRowsSelectedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AllRowsUnselectedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ClickableRowAnnouncement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ClickableRowAnnouncementWithSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ColumnSizerLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EmptyColumnHeaderLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MoreActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MoreTooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NoMoreActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RemovePillLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RowAnnouncement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RowAnnouncementWithSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SelectAllRowsLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SelectRowLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SizerLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SizerValueChanged; });
/* unused harmony export Started */
var AllRowsSelectedMessage = "All rows got selected";
var AllRowsUnselectedMessage = "All rows got unselected";
var ClickableRowAnnouncement = "Row {0}. Clickable";
var ClickableRowAnnouncementWithSize = "Row {0} of {1}. Clickable";
var ColumnSizerLabel = "{0} column sizer";
var EmptyColumnHeaderLabel = "Blank";
var ListItem = "listitem";
var MoreActions = "More actions";
var MoreTooltip = "More options";
var NoMoreActions = "No actions";
var RemovePillLabel = "Remove {0}";
var RowAnnouncement = "Row {0}";
var RowAnnouncementWithSize = "Row {0} of {1}";
var SelectAllRowsLabel = "Select all rows";
var SelectRowLabel = "Select row with checkbox";
var SizerLabel = "Current value {0}, minimum value {1}, maximum value {2}";
var SizerValueChanged = "New size value {0}";
var Started = "Started {0}";


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Components_List_FixedHeightList__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(109);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FixedHeightList", function() { return _Components_List_FixedHeightList__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "rowFromElement", function() { return _Components_List_FixedHeightList__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "rowFromEvent", function() { return _Components_List_FixedHeightList__WEBPACK_IMPORTED_MODULE_0__["c"]; });

/* harmony import */ var _Components_List_FixedHeightList_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(123);
/* harmony import */ var _Components_List_FixedHeightList_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_List_FixedHeightList_Props__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_List_FixedHeightList_Props__WEBPACK_IMPORTED_MODULE_1__) if(["default","FixedHeightList","rowFromElement","rowFromEvent"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_List_FixedHeightList_Props__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _Components_List_List__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "List", function() { return _Components_List_List__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScrollableList", function() { return _Components_List_List__WEBPACK_IMPORTED_MODULE_2__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SimpleList", function() { return _Components_List_List__WEBPACK_IMPORTED_MODULE_2__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderListItem", function() { return _Components_List_List__WEBPACK_IMPORTED_MODULE_2__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ListItem", function() { return _Components_List_List__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderListCell", function() { return _Components_List_List__WEBPACK_IMPORTED_MODULE_2__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "cellFromElement", function() { return _Components_List_List__WEBPACK_IMPORTED_MODULE_2__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "cellFromEvent", function() { return _Components_List_List__WEBPACK_IMPORTED_MODULE_2__["f"]; });

/* harmony import */ var _Components_List_List_Props__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(133);
/* harmony import */ var _Components_List_List_Props__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Components_List_List_Props__WEBPACK_IMPORTED_MODULE_3__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_List_List_Props__WEBPACK_IMPORTED_MODULE_3__) if(["default","FixedHeightList","rowFromElement","rowFromEvent","List","ScrollableList","SimpleList","renderListItem","ListItem","renderListCell","cellFromElement","cellFromEvent"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_List_List_Props__WEBPACK_IMPORTED_MODULE_3__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _Components_List_ListDragDropBehavior__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(134);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ListDragDropBehavior", function() { return _Components_List_ListDragDropBehavior__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony import */ var _Components_List_ListDragImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(135);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ListDragImage", function() { return _Components_List_ListDragImage__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony import */ var _Components_List_ListDragSourceBehavior__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ListDragSourceBehavior", function() { return _Components_List_ListDragSourceBehavior__WEBPACK_IMPORTED_MODULE_6__["a"]; });

/* harmony import */ var _Components_List_ListDropTargetBehavior__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ListDropTargetBehavior", function() { return _Components_List_ListDropTargetBehavior__WEBPACK_IMPORTED_MODULE_7__["a"]; });

/* harmony import */ var _Components_List_ListSelection__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(136);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ListSelection", function() { return _Components_List_ListSelection__WEBPACK_IMPORTED_MODULE_8__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilteredListSelection", function() { return _Components_List_ListSelection__WEBPACK_IMPORTED_MODULE_8__["a"]; });












/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ ListBox_ListBox_ListBox; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ ListBox_getUnselectableRanges; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ wrapListBoxItems; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ getListBoxItemsValue; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ ListBoxItemType; });

// UNUSED EXPORTS: DefaultListBoxWidth, renderListBoxCell, listBoxItemSelectable, convertListBoxItemsToTreeItems, LoadingCell, isListBoxItemVisible

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/ListBox/ListBox.css
var ListBox_ListBox = __webpack_require__(236);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Observable.js
var Observable = __webpack_require__(4);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Util/Accessibility.js
var Accessibility = __webpack_require__(15);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Util/String.js
var Util_String = __webpack_require__(16);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Icon.js + 2 modules
var Icon = __webpack_require__(9);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/List.js
var List = __webpack_require__(21);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Observer.js
var Observer = __webpack_require__(8);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Resources.Dropdown.js
var Resources_Dropdown = __webpack_require__(17);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Spinner/Spinner.css
var Spinner = __webpack_require__(238);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Spinner/Spinner.Props.js
var SpinnerSize;
(function (SpinnerSize) {
    /**
     * 12px diameter
     */
    SpinnerSize["xSmall"] = "xsmall";
    /**
     * 16px diameter
     */
    SpinnerSize["small"] = "small";
    /**
     * 20px diameter
     */
    SpinnerSize["medium"] = "medium";
    /**
     * 28px diameter
     */
    SpinnerSize["large"] = "large";
})(SpinnerSize || (SpinnerSize = {}));
var SpinnerOrientation;
(function (SpinnerOrientation) {
    /**
     * When a label is used render the label and animation in a row (label to the right).
     */
    SpinnerOrientation[SpinnerOrientation["row"] = 0] = "row";
    /**
     * When a label is used render the label and animation in a column (label below).
     */
    SpinnerOrientation[SpinnerOrientation["column"] = 1] = "column";
})(SpinnerOrientation || (SpinnerOrientation = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Spinner/Spinner.js







var Spinner_Spinner = function (props) {
    var ariaLabel = props.ariaLabel, ariaLive = props.ariaLive, className = props.className, id = props.id, label = props.label, _a = props.orientation, orientation = _a === void 0 ? SpinnerOrientation.column : _a, _b = props.size, size = _b === void 0 ? SpinnerSize.medium : _b;
    // Only do this on mount; the aria-live region will handle any updates to props
    external_commonjs_react_commonjs2_react_amd_React_root_React_["useEffect"](function () {
        if (ariaLive === "assertive" || ariaLive === "polite") {
            Object(Accessibility["a" /* announce */])(ariaLabel || label, ariaLive === "assertive");
        }
    }, []);
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { "aria-label": ariaLabel, "aria-live": ariaLive, className: Object(Util["css"])(className, "bolt-spinner", orientation === SpinnerOrientation.column ? "flex-column text-center rhythm-vertical-8" : "flex-row flex-center rhythm-horizontal-8"), id: Object(Util["getSafeId"])(id) },
        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])("bolt-spinner-circle", size) }),
        label && external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-spinner-label" }, label)));
};
// TODO: Remove if we fix Jest issue
Spinner_Spinner.displayName = "Spinner";

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Spinner.js



// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Table.js
var Table = __webpack_require__(24);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/TreeEx.js
var TreeEx = __webpack_require__(60);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Utilities/DropdownSelection.js
var DropdownSelection = __webpack_require__(46);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Utilities/Provider.js
var Provider = __webpack_require__(36);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Utilities/TreeItemProvider.js
var TreeItemProvider = __webpack_require__(107);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/ListBox/ListBox.Props.js
var ListBoxItemType;
(function (ListBoxItemType) {
    ListBoxItemType[ListBoxItemType["Row"] = 1] = "Row";
    ListBoxItemType[ListBoxItemType["Header"] = 2] = "Header";
    ListBoxItemType[ListBoxItemType["Divider"] = 3] = "Divider";
    ListBoxItemType[ListBoxItemType["Loading"] = 4] = "Loading";
})(ListBoxItemType || (ListBoxItemType = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/ListBox/ListBox.js




















var DefaultListBoxWidth = -100;
var ListBox_ListBox_ListBox = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(ListBox, _super);
    function ListBox(props) {
        var _this = _super.call(this, props) || this;
        _this.tabbableIndex = -1;
        _this.positions = [];
        _this.count = 0;
        _this.table = external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"]();
        _this.tree = external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"]();
        _this.getItemWidth = function () {
            var width = _this.props.width;
            return _this.multiSelect && width && width > 0 ? width - 40 /* TODO: Remove this, 40 is only correct with default font-size */ : width;
        };
        _this.loadingChanged = function () {
            if (Observable["ObservableLike"].getValue(_this.props.loading)) {
                Accessibility["a" /* announce */](Resources_Dropdown["e" /* AnnounceLoadingItems */]);
            }
            else {
                Accessibility["a" /* announce */](Resources_Dropdown["c" /* AnnounceFinishedLoadingItems */]);
                var itemCount = _this.props.items.length;
                Accessibility["a" /* announce */](Object(Util_String["a" /* format */])(itemCount > 0 ? Object(Util_String["a" /* format */])(Resources_Dropdown["d" /* AnnounceItemCount */], itemCount) : Resources_Dropdown["n" /* NoFilterResults */]), true);
            }
            return true;
        };
        _this.searchingChanged = function () {
            if (Observable["ObservableLike"].getValue(_this.props.searching)) {
                Accessibility["a" /* announce */](Resources_Dropdown["p" /* Searching */]);
            }
            else if (Observable["ObservableLike"].getValue(_this.props.searching) === false) {
                var resultCount = _this.props.items.length;
                Accessibility["a" /* announce */](resultCount > 0 ? Object(Util_String["a" /* format */])(Resources_Dropdown["b" /* AnnounceFilterResultCount */], resultCount) : Resources_Dropdown["n" /* NoFilterResults */], true);
            }
            return true;
        };
        _this.onItemsChanged = function () {
            var items = getListBoxItemsValue(_this.wrappedItems || _this.props.items);
            _this.tabbableIndex = -1;
            _this.positions = [];
            _this.count = 0;
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var item = items_1[_i];
                var itemValue = Observable["ObservableLike"].getValue(item);
                if (itemValue && !listBoxItemSelectable(itemValue)) {
                    _this.positions.push(-1);
                }
                else {
                    if (_this.tabbableIndex === -1 && _this.selection.selectable(_this.positions.length)) {
                        _this.tabbableIndex = _this.positions.length;
                    }
                    _this.positions.push(++_this.count);
                }
            }
            return true;
        };
        _this.onActivate = function (event, tableRow) {
            if (_this.props.onActivate) {
                _this.props.onActivate(event, tableRow.data);
            }
        };
        _this.onSelect = function (event, tableRow) {
            if (_this.props.onSelect) {
                _this.props.onSelect(event, tableRow.data);
            }
        };
        _this.onTreeActivate = function (event, treeRow) {
            var items = _this.getListBoxItems();
            if (_this.props.onActivate && items) {
                var treeItem_1 = treeRow.data.underlyingItem;
                var item = items.find(function (item) { return item.id === treeItem_1.id; });
                item && _this.props.onActivate(event, item);
            }
        };
        _this.onTreeSelect = function (event, treeRow) {
            var items = _this.getListBoxItems();
            if (_this.props.onSelect && items) {
                var treeItem_2 = treeRow.data.underlyingItem;
                var item = items.find(function (item) { return item.id === treeItem_2.id; });
                item && _this.props.onSelect(event, item);
            }
        };
        _this.renderListBoxRow = function (index, item, details) {
            var _a = _this.props, excludeFocusZone = _a.excludeFocusZone, excludeTabStop = _a.excludeTabStop;
            var items = getListBoxItemsValue(_this.wrappedItems || _this.props.items);
            var ariaDescribedBy = index > 0 && items[index - 1].type === ListBoxItemType.Header ? "header-" + items[index - 1].id : details.ariaDescribedBy;
            var focusable = !excludeFocusZone && _this.selection.selectable(index);
            var rowDetails = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({ tooltipProps: item.tooltipProps || { text: item.text, overflowOnly: true, overflowDetected: overflowDetected } }, details), { ariaDescribedBy: ariaDescribedBy, ariaPosInSet: _this.positions[index] >= 0 ? _this.positions[index] : null, ariaSetSize: _this.positions[index] >= 0 ? _this.count : null, excludeTabStop: excludeTabStop || _this.tabbableIndex !== index, excludeFocusZone: !focusable, id: item.id, singleClickActivation: false, role: item.type === ListBoxItemType.Header || item.type === ListBoxItemType.Divider ? "row" : "option" });
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { key: item.id || index, item: item }, function () { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Table["TableRow"], { key: item.id || index, index: index, details: rowDetails, className: Object(Util["css"])("bolt-list-box-row", item.type === ListBoxItemType.Header && "bolt-list-box-header-row", item.type === ListBoxItemType.Divider && "bolt-list-box-divider-row", item.type === ListBoxItemType.Loading && "bolt-list-box-loading-row", _this.multiSelect && "bolt-list-box-multi-select-row", item.type !== ListBoxItemType.Header && item.type !== ListBoxItemType.Divider && "cursor-pointer", item.disabled && "bolt-list-box-item-disabled") }, _this.columns.map(function (tableColumn, columnIndex) {
                if (_this.multiSelect && columnIndex === 0) {
                    if (item.type === ListBoxItemType.Divider || item.type === ListBoxItemType.Loading) {
                        return null;
                    }
                    else if (item.type === ListBoxItemType.Header) {
                        return Object(Table["renderEmptyCell"])(index, columnIndex);
                    }
                }
                return tableColumn.renderCell(index, columnIndex, tableColumn, item);
            }))); }));
        };
        _this.renderListBoxTreeRow = function (index, item, details) {
            var _a = _this.props, excludeFocusZone = _a.excludeFocusZone, excludeTabStop = _a.excludeTabStop;
            var focusable = !excludeFocusZone && _this.selection.selectable(index);
            var data = item.underlyingItem.data;
            var rowDetails = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({ tooltipProps: { text: item.underlyingItem.text, overflowOnly: true, overflowDetected: overflowDetected } }, details), { ariaPosInSet: _this.positions[index] >= 0 ? _this.positions[index] : null, ariaSetSize: _this.positions[index] >= 0 ? _this.count : null, excludeTabStop: excludeTabStop || _this.tabbableIndex !== index, excludeFocusZone: !focusable, id: item.underlyingItem.id, singleClickActivation: false, role: data.type === ListBoxItemType.Header || data.type === ListBoxItemType.Divider ? "row" : "option" });
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { key: "observer-" + (item.underlyingItem.id || index), item: item }, function () { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TreeEx["TreeRow"], { key: "row-" + (item.underlyingItem.id || index), index: index, details: rowDetails, className: Object(Util["css"])("bolt-list-box-row", data.type === ListBoxItemType.Header && "bolt-list-box-header-row", data.type === ListBoxItemType.Divider && "bolt-list-box-divider-row", data.type === ListBoxItemType.Loading && "bolt-list-box-loading-row", _this.multiSelect && "bolt-list-box-multi-select-row", data.type !== ListBoxItemType.Header && data.type !== ListBoxItemType.Divider && "cursor-pointer", data.disabled && "bolt-list-box-item-disabled") }, _this.columns.map(function (treeColumn, columnIndex) {
                return treeColumn.renderCell(index, columnIndex, treeColumn, item);
            }))); }));
        };
        _this.renderListBoxCell = function (rowIndex, columnIndex, tableColumn, tableItem) {
            return renderListBoxCell(rowIndex, columnIndex, tableColumn, tableItem, _this.multiSelect);
        };
        var _a = _this.props, selection = _a.selection, renderItem = _a.renderItem, items = _a.items;
        _this.selection = selection || new DropdownSelection["DropdownSelection"]();
        _this.multiSelect = _this.props.enforceSingleSelect || _this.props.showTree ? false : _this.selection.multiSelect;
        // trees get custom columns
        if (!_this.props.columns) {
            _this.columns = [];
            if (_this.multiSelect && _this.props.showChecksColumn !== false) {
                _this.columns.push(new Table["ColumnSelect"]());
            }
            else if (!_this.multiSelect && _this.props.showChecksColumn === true) {
                _this.columns.push({
                    id: "column-check",
                    width: 24,
                    renderCell: function (rowIndex, columnIndex) { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Table["SimpleTableCell"], { columnIndex: columnIndex, key: "column-check" },
                        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Icon["Icon"], { className: Object(Util["css"])(!_this.selection.selected(rowIndex) && "invisible"), iconName: "CheckMark" }))); },
                    readonly: true
                });
            }
            _this.columns.push({
                id: "text",
                width: _this.getItemWidth(),
                renderCell: renderItem || _this.renderListBoxCell,
                className: Object(Util["css"])("bolt-list-box-text", _this.multiSelect ? "bolt-list-box-text-multi-select" : "bolt-list-box-text-single-select"),
                readonly: true
            });
        }
        else {
            _this.columns = _this.props.columns;
        }
        // string items are wrapped once here.  Only use a string array in the simple case where the items are not changing.
        _this.wrappedItems = wrapListBoxItems(items);
        _this.onItemsChanged();
        return _this;
    }
    ListBox.prototype.componentDidUpdate = function () {
        if (this.props.didUpdate) {
            this.props.didUpdate();
        }
    };
    ListBox.prototype.render = function () {
        var _this = this;
        var _a = this.props, ariaLabel = _a.ariaLabel, className = _a.className, containerClassName = _a.containerClassName, enforceSingleSelect = _a.enforceSingleSelect, focuszoneProps = _a.focuszoneProps, getUnselectableRanges = _a.getUnselectableRanges, items = _a.items, loading = _a.loading, searching = _a.searching, searchResultsLoadingText = _a.searchResultsLoadingText, showItemsWhileSearching = _a.showItemsWhileSearching, width = _a.width;
        var itemsObservable = { observableValue: items, filter: this.onItemsChanged };
        var listBoxItems = this.getListBoxItems();
        var itemProvider = listBoxItems
            ? this.props.showTree
                ? new TreeItemProvider["TreeItemProvider"](convertListBoxItemsToTreeItems(listBoxItems))
                : new Provider["a" /* ArrayItemProvider */](listBoxItems)
            : items;
        if (!this.props.columns) {
            this.columns[this.columns.length - 1].width = this.getItemWidth();
        }
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["ItemsObserver"], { getUnselectableRanges: getUnselectableRanges, items: items, selection: this.selection },
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { items: itemsObservable, loading: { observableValue: loading || false, filter: this.loadingChanged }, searching: { observableValue: searching || false, filter: this.searchingChanged } }, function (props) {
                if (props.searching && !showItemsWhileSearching) {
                    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-list-box-loading", style: { width: width } },
                        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Spinner_Spinner, { size: SpinnerSize.medium, label: searchResultsLoadingText || Resources_Dropdown["p" /* Searching */] })));
                }
                if (_this.props.showTree) {
                    var treeProvider_1 = itemProvider;
                    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TreeEx["Tree"], { ariaLabel: ariaLabel || Resources_Dropdown["l" /* ListboxAriaLabel */], className: Object(Util["css"])(className, "bolt-list-box"), columns: _this.columns, containerClassName: containerClassName, focuszoneProps: focuszoneProps, itemProvider: treeProvider_1, onActivate: _this.onTreeActivate, onSelect: _this.onTreeSelect, onToggle: function (event, treeItem) {
                            if (event.target.className.includes("bolt-tree-expand-button")) {
                                treeProvider_1.toggle(treeItem.underlyingItem);
                                if (_this.props.onToggle) {
                                    _this.props.onToggle(event, treeItem.underlyingItem.data);
                                }
                            }
                        }, ref: _this.tree, renderRow: _this.renderListBoxTreeRow, role: "listbox", scrollable: true, singleClickActivation: false, selection: _this.selection, showHeader: false, showLines: false }));
                }
                else {
                    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Table["Table"], { ariaLabel: ariaLabel || Resources_Dropdown["l" /* ListboxAriaLabel */], className: Object(Util["css"])(className, "bolt-list-box"), columns: _this.columns, containerClassName: containerClassName, enforceSingleSelect: enforceSingleSelect, focuszoneProps: focuszoneProps, itemProvider: itemProvider, onActivate: _this.onActivate, onSelect: _this.onSelect, renderRow: _this.renderListBoxRow, ref: _this.table, role: "listbox", scrollable: true, singleClickActivation: false, selection: _this.selection, showHeader: false, showLines: false, spacerWidth: 0 }));
                }
            })));
    };
    ListBox.prototype.scrollIntoView = function (rowIndex, options) {
        if (this.table.current) {
            return this.table.current.scrollIntoView(rowIndex, options);
        }
        else if (this.tree.current) {
            return this.tree.current.scrollIntoView(rowIndex, options);
        }
    };
    /**
     * Try to pull list box items out of props and variables.
     * Returns undefined in case where IItemProvider was passed in.
     */
    ListBox.prototype.getListBoxItems = function () {
        var _a, _b;
        return ((_b = (_a = this.wrappedItems) !== null && _a !== void 0 ? _a : (this.props.items && (Array.isArray(this.props.items) ? this.props.items : this.props.items.value))) !== null && _b !== void 0 ? _b : undefined);
    };
    ListBox.defaultProps = {
        getUnselectableRanges: ListBox_getUnselectableRanges,
        width: DefaultListBoxWidth
    };
    return ListBox;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));

function renderListBoxCell(rowIndex, columnIndex, tableColumn, tableItem, multiSelect) {
    if (tableItem.render) {
        return tableItem.render(rowIndex, columnIndex, tableColumn, tableItem);
    }
    if (tableItem.type === ListBoxItemType.Divider) {
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Table["SimpleTableCell"], { className: Object(Util["css"])(tableColumn.className, tableItem.className, multiSelect && "bolt-list-box-divider-multi-select"), columnIndex: columnIndex, colspan: multiSelect ? 2 : 1, key: tableItem.id, tableColumn: tableColumn },
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-list-box-divider flex-grow" })));
    }
    else if (tableItem.type === ListBoxItemType.Loading) {
        return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](ListBox_LoadingCell, { columnIndex: columnIndex, key: tableItem.id, tableColumn: tableColumn, tableItem: tableItem });
    }
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Table["SimpleTableCell"], { className: Object(Util["css"])(tableColumn.className, tableItem.className, tableItem.type === ListBoxItemType.Header && "bolt-list-box-header"), columnIndex: columnIndex, key: tableItem.id, tableColumn: tableColumn },
        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { id: tableItem.type === ListBoxItemType.Header ? "header-" + tableItem.id : undefined, "aria-label": tableItem.type === ListBoxItemType.Header ? Object(Util_String["a" /* format */])(Resources_Dropdown["k" /* HeaderAriaLabel */], tableItem.text) : undefined, className: "bolt-list-box-cell-container" }, tableItem && Object(List["renderListCell"])(tableItem, false))));
}
function overflowDetected(anchorElement) {
    var overflowElement = anchorElement.querySelector(".text-ellipsis");
    if (overflowElement) {
        return overflowElement.scrollWidth > Math.ceil(overflowElement.offsetWidth);
    }
    return false;
}
/**
 * Retrieve a list of unselectable ranges based on a itemSelectable function.
 * @param items the set of items
 * @param itemSelectable A function that returns false when an items is not selectable.
 *        Defaults to checking that the item type is not header or divider.
 */
function ListBox_getUnselectableRanges(items, itemSelectable) {
    if (itemSelectable === void 0) { itemSelectable = listBoxItemSelectable; }
    var ranges = [];
    var beginIndex = -1;
    for (var index = 0; index < items.length; index++) {
        if (!itemSelectable(items[index]) && beginIndex < 0) {
            beginIndex = index;
        }
        else if (itemSelectable(items[index]) && beginIndex >= 0) {
            ranges.push({ beginIndex: beginIndex, endIndex: index - 1 });
            beginIndex = -1;
        }
    }
    if (beginIndex >= 0) {
        ranges.push({ beginIndex: beginIndex, endIndex: items.length - 1 });
    }
    return ranges;
}
/**
 * Return whether a ListBoxItem can be selected or not.
 * @param item the ListBoxItem to evaluate
 */
function listBoxItemSelectable(item) {
    return item.type !== ListBoxItemType.Header && item.type !== ListBoxItemType.Divider && item.type !== ListBoxItemType.Loading && !item.disabled;
}
/**
 * When items is a string[], wrap each item in a ListBoxItem.  Otherwise, do nothing.
 * @param items the items prop
 */
function wrapListBoxItems(items) {
    if (Array.isArray(items) && items.length && typeof items[0] === "string") {
        return items.map(function (item) {
            return { id: item, text: item };
        });
    }
}
/**
 * Walk through the ListBoxItems and construct a tree
 */
function convertListBoxItemsToTreeItems(items) {
    var rootItems = [];
    var itemsMap = new Map();
    for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
        var item = items_2[_i];
        // include children that may have been processed before this parent
        var precreatedTreeItem = itemsMap.get(item.id);
        var treeItem = {
            childItems: precreatedTreeItem === null || precreatedTreeItem === void 0 ? void 0 : precreatedTreeItem.childItems,
            expanded: item.expanded,
            data: item,
            id: item.id,
            text: item.text
        };
        if (!item.parent) {
            rootItems.push(treeItem);
        }
        else {
            var parent_1 = itemsMap.get(item.parent.id);
            if (parent_1) {
                if (parent_1.childItems) {
                    parent_1.childItems.push(treeItem);
                }
                else {
                    parent_1.childItems = [treeItem];
                }
            }
            else {
                // add a placeholder that tracks children until parent actually gets processed
                itemsMap.set(item.parent.id, { childItems: [treeItem] });
            }
        }
        itemsMap.set(treeItem.id, treeItem);
    }
    return rootItems;
}
/**
 * Helper to get the value of the items prop.  If items is a string[], it should first be wrapped using wrapListBoxItems.
 * If it's an itemProvider, .value will be called on the provider.
 * @param items the items prop.  If items was provided as a string[], it should first be wrapped using wrapListBoxItems.
 */
function getListBoxItemsValue(items) {
    if (false) {}
    return Object(Provider["b" /* getItemsValue */])(items);
}
var ListBox_LoadingCell = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(LoadingCell, _super);
    function LoadingCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingCell.prototype.componentDidMount = function () {
        if (this.props.onMount) {
            this.props.onMount();
        }
    };
    LoadingCell.prototype.render = function () {
        var _a = this.props, columnIndex = _a.columnIndex, tableColumn = _a.tableColumn, tableItem = _a.tableItem;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Table["SimpleTableCell"], { className: Object(Util["css"])(tableColumn.className, tableItem.className), columnIndex: columnIndex, colspan: 2, contentClassName: "justify-center", key: columnIndex, tableColumn: tableColumn },
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-list-box-loading" },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Spinner_Spinner, { size: SpinnerSize.medium, label: Resources_Dropdown["m" /* Loading */] }))));
    };
    return LoadingCell;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));

function isListBoxItemVisible(item) {
    var parent = item.parent;
    while (parent) {
        if (!parent.expanded) {
            return false;
        }
        parent = parent.parent;
    }
    return true;
}

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/ListBox.js




/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_FocusWithin_FocusWithin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(110);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FocusWithin", function() { return _Components_FocusWithin_FocusWithin__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_FocusWithin_FocusWithin_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(111);
/* harmony import */ var _Components_FocusWithin_FocusWithin_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_FocusWithin_FocusWithin_Props__WEBPACK_IMPORTED_MODULE_1__);

// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present



/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Components_Table_ColumnMore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(137);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnMoreWidths", function() { return _Components_Table_ColumnMore__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnMore", function() { return _Components_Table_ColumnMore__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_Table_ColumnSelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(149);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnSelect", function() { return _Components_Table_ColumnSelect__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _Components_Table_ColumnSorting__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(150);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnSorting", function() { return _Components_Table_ColumnSorting__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sortItems", function() { return _Components_Table_ColumnSorting__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony import */ var _Components_Table_DragAndDropGripper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(151);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragAndDropGripper", function() { return _Components_Table_DragAndDropGripper__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderGripper", function() { return _Components_Table_DragAndDropGripper__WEBPACK_IMPORTED_MODULE_3__["b"]; });

/* harmony import */ var _Components_Table_Table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(196);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnFill", function() { return _Components_Table_Table__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return _Components_Table_Table__WEBPACK_IMPORTED_MODULE_4__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderColumns", function() { return _Components_Table_Table__WEBPACK_IMPORTED_MODULE_4__["i"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableHeaderCell", function() { return _Components_Table_Table__WEBPACK_IMPORTED_MODULE_4__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableRow", function() { return _Components_Table_Table__WEBPACK_IMPORTED_MODULE_4__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableLoadingRow", function() { return _Components_Table_Table__WEBPACK_IMPORTED_MODULE_4__["f"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableCell", function() { return _Components_Table_Table__WEBPACK_IMPORTED_MODULE_4__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SimpleTableCell", function() { return _Components_Table_Table__WEBPACK_IMPORTED_MODULE_4__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TwoLineTableCell", function() { return _Components_Table_Table__WEBPACK_IMPORTED_MODULE_4__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderEmptyCell", function() { return _Components_Table_Table__WEBPACK_IMPORTED_MODULE_4__["j"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderSimpleCell", function() { return _Components_Table_Table__WEBPACK_IMPORTED_MODULE_4__["l"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderSimpleCellValue", function() { return _Components_Table_Table__WEBPACK_IMPORTED_MODULE_4__["m"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderLoadingCell", function() { return _Components_Table_Table__WEBPACK_IMPORTED_MODULE_4__["k"]; });

/* harmony import */ var _Components_Table_Table_Props__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableColumnLayout", function() { return _Components_Table_Table_Props__WEBPACK_IMPORTED_MODULE_5__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableColumnStyle", function() { return _Components_Table_Table_Props__WEBPACK_IMPORTED_MODULE_5__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SortOrder", function() { return _Components_Table_Table_Props__WEBPACK_IMPORTED_MODULE_5__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnJustification", function() { return _Components_Table_Table_Props__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IMeasurementStyle", function() { return _Components_Table_Table_Props__WEBPACK_IMPORTED_MODULE_5__["b"]; });

/* harmony import */ var _Components_Table_TableBreakpoint__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableBreakpoint", function() { return _Components_Table_TableBreakpoint__WEBPACK_IMPORTED_MODULE_6__["a"]; });

/* harmony import */ var _Components_Table_TableBreakpoint_Props__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(156);
/* harmony import */ var _Components_Table_TableBreakpoint_Props__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Components_Table_TableBreakpoint_Props__WEBPACK_IMPORTED_MODULE_7__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_Table_TableBreakpoint_Props__WEBPACK_IMPORTED_MODULE_7__) if(["default","ColumnMoreWidths","ColumnMore","ColumnSelect","ColumnSorting","sortItems","DragAndDropGripper","renderGripper","ColumnFill","Table","renderColumns","TableHeaderCell","TableRow","TableLoadingRow","TableCell","SimpleTableCell","TwoLineTableCell","renderEmptyCell","renderSimpleCell","renderSimpleCellValue","renderLoadingCell","TableColumnLayout","TableColumnStyle","SortOrder","ColumnJustification","IMeasurementStyle","TableBreakpoint"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_Table_TableBreakpoint_Props__WEBPACK_IMPORTED_MODULE_7__[key]; }) }(__WEBPACK_IMPORT_KEY__));










/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MenuItemType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuCell; });
/**
 * Standard menu item types that are rendered through the menu.
 */
var MenuItemType;
(function (MenuItemType) {
    /**
     * This uses the standard five column menu item.
     */
    MenuItemType[MenuItemType["Normal"] = 0] = "Normal";
    /**
     * This will render a divider line between the previous and next item.
     * A divider will only appear if the previous and next item are non-dividers.
     * Consecutive dividers will be merged to a single divider.
     */
    MenuItemType[MenuItemType["Divider"] = 1] = "Divider";
    /**
     * A special menu item that shows a header styled menu item in the PrimaryText column.
     */
    MenuItemType[MenuItemType["Header"] = 2] = "Header";
})(MenuItemType || (MenuItemType = {}));
/**
 * Indicates what type of menu cell is being rendered. A menu is represented by
 * five columns. If any menu item in the menu uses the column the column will be
 * shown in all items. If no menu item uses the column, the column will not be
 * visible.
 */
var MenuCell;
(function (MenuCell) {
    /**
     * The state column is used to represent the state of the menu item. This is
     * usually either a read-only or read-write checkbox.
     */
    MenuCell[MenuCell["State"] = 0] = "State";
    /**
     * This is an Icon prefix used to represent the menu item.
     */
    MenuCell[MenuCell["Icon"] = 1] = "Icon";
    /**
     * Primary text that describes the menu item. Often this will be the only
     * column that has a value.
     */
    MenuCell[MenuCell["PrimaryText"] = 2] = "PrimaryText";
    /**
     * Secondary text is a column that is generally used to represent things
     * like hot-keys/accelerators.
     */
    MenuCell[MenuCell["SecondaryText"] = 3] = "SecondaryText";
    /**
     * Action column is used to give the user a way to represent a secondary
     * way to interact with the menu. This may be things like the submenu icon
     * or some other ui the user can independantly interact with.
     */
    MenuCell[MenuCell["Action"] = 4] = "Action";
})(MenuCell || (MenuCell = {}));


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getTabIndex; });

// UNUSED EXPORTS: focusAsync

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Utilities/Dom.js
function elementContains(parent, child) {
    var currentElement = child;
    while (currentElement) {
        if (currentElement === parent) {
            return true;
        }
        currentElement = currentElement.parentElement;
    }
    return false;
}
/**
 * Gets the window or iframe container of the target element
 * @param element
 */
function getWindow(element) {
    if (typeof window === "undefined") {
        return undefined;
    }
    else {
        return element && element.ownerDocument && element.ownerDocument.defaultView ? element.ownerDocument.defaultView : window;
    }
}
/**
 * Finds the nearest parent element of the target that is scrollable on the Y axis
 * @param element
 */
function findScrollableParent(element) {
    var currentElement = element;
    while (currentElement && currentElement !== document.body) {
        var styles = getComputedStyle(currentElement);
        var overflowY = styles ? styles.getPropertyValue("overflow-y") : "";
        if (overflowY && (overflowY === "scroll" || overflowY === "auto")) {
            return currentElement;
        }
        currentElement = currentElement.parentElement;
    }
    return document.body;
}

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Utilities/Focus.js


/**
 * getTabIndex takes in a standard set of focus related properties to determine
 * the correct tabIndex for the element.
 */
function getTabIndex(props, focusGroupContext) {
    // Return an explicit tabIndex if one was requested.
    if (props.tabIndex !== undefined) {
        return props.tabIndex;
    }
    // Make element tabbable if:
    //  The element is not disabled,
    //  The element does not have the excludeTabStop property
    //  Optionally, the component is within a focusGroup and is the focused element
    if (!props.disabled &&
        !props.excludeTabStop &&
        (!focusGroupContext || focusGroupContext.onFocus === Util["noop"] || focusGroupContext.focusedElementId === props.id)) {
        return 0;
    }
    // Allow the element to have focus as long as the excludeFocusZone was not supplied.
    if (!props.excludeFocusZone) {
        return -1;
    }
    // The element is not tabbable and wont have a tabIndex, therefore it can't get focus.
    return undefined;
}
var targetToFocusOnNextRepaint = undefined;
/**
 * Sets focus on the next frame OR after setTimeout(0)
 * If you pass an IFocusable instead of an HTMLElement it'll use setTimeout instead of window.requestAnimationFrame
 */
function focusAsync(element) {
    // If we've called this method this frame, re-set the element to focus but don't hook up another handler
    if (targetToFocusOnNextRepaint) {
        targetToFocusOnNextRepaint = element;
        return;
    }
    // If this is the first time we've called this this frame, set an event handler
    // or schedule it async if we can't get the window element
    targetToFocusOnNextRepaint = element;
    var window = getWindow(element);
    if (window) {
        window.requestAnimationFrame(function () {
            if (targetToFocusOnNextRepaint) {
                targetToFocusOnNextRepaint.focus();
            }
            targetToFocusOnNextRepaint = undefined;
        });
    }
    else {
        setTimeout(function () {
            if (targetToFocusOnNextRepaint) {
                targetToFocusOnNextRepaint.focus();
            }
        });
    }
}


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragDropEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return beginDragOperation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dispatchCustomDragEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DragImage; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
/* harmony import */ var _Portal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);
/* harmony import */ var _Position__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12);






/**
 * Represents the end result of a drag / drop operation.
 */
var DragDropEffect;
(function (DragDropEffect) {
    /**
     * If the drop where to happen at this point, it would be a no-op.
     */
    DragDropEffect["none"] = "none";
    /**
     * The data should be moved from the drag source to the drop target.
     */
    DragDropEffect["move"] = "move";
    /**
     * The data should be copied from the drag source to the drop target.
     */
    DragDropEffect["copy"] = "copy";
})(DragDropEffect || (DragDropEffect = {}));
var DragDropManager = /** @class */ (function () {
    function DragDropManager() {
        var _this = this;
        this.onEventCaptured = function (event) {
            // Handle the pointerup and pointermove events
            var type = event.type;
            if (type === "pointermove") {
                // For pointermove events, if there is no drag in progress, we need to check to see if the pointer
                // has moved far enough to meet our threshold for triggering a drag/drop operation.
                if (!_this.dragInProgress) {
                    if (_this.potentialDragInProgress) {
                        var coordinates = Object(_Util__WEBPACK_IMPORTED_MODULE_4__["getPointByEventType"])(event);
                        if (Object(_Position__WEBPACK_IMPORTED_MODULE_5__[/* distance */ "b"])(_this.initialCoordinates, coordinates) > _this.minimumPixelsForDrag) {
                            // The position of the pointer is far enough away from our threshold to trigger a drag event.
                            // Fire the dragstart event to give the drag source an opportunity to cancel the operation
                            dispatchCustomDragEvent("dragstart", _this.dragSourceElement, event, _this.dataTransfer);
                            if (_this.dataTransfer.effectAllowed === DragDropEffect.none) {
                                _this.potentialDragInProgress = false;
                                _this.endDrag();
                            }
                            else {
                                _this.dragInProgress = true;
                            }
                            event.preventDefault();
                        }
                    }
                    // If there isn't the potential for a drag, that means a consumer has already
                    // indicated that we should cancel this drag event, so there is no need to continue to
                    // check anything about this event.
                }
                else {
                    // If there is a drag in progress, treat this as a dragover event.
                    var target = _this.getTargetFromEvent(event);
                    if (target) {
                        var coordinates = Object(_Util__WEBPACK_IMPORTED_MODULE_4__["getPointByEventType"])(event);
                        _this.operation.x.value = coordinates.x;
                        _this.operation.y.value = coordinates.y;
                        dispatchCustomDragEvent("dragover", target, event, _this.dataTransfer);
                        event.preventDefault();
                    }
                }
            }
            else if (type === "pointerup") {
                if (_this.dragInProgress) {
                    var target = _this.getTargetFromEvent(event);
                    // Always fire the dragend event when we get a pointerup, if there was a drag in progress.
                    dispatchCustomDragEvent("dragend", _this.dragSourceElement, event, _this.dataTransfer);
                    if (target && _this.dataTransfer.dropEffect !== DragDropEffect.none) {
                        // Only fire a drop event if the dropEffect allows it.
                        dispatchCustomDragEvent("drop", target, event, _this.dataTransfer);
                    }
                }
                _this.endDrag();
            }
        };
        this.onPointerLeave = function (event) {
            // The pointer has left the bounds of the body element, so a drop is not
            // viable at this point.
            _this.dataTransfer.dropEffect = DragDropEffect.none;
        };
        this.onPointerOut = function (event) {
            if (event.target) {
                // The pointer has left an element, so we need to set the dropEffect to none.
                // The dragover event will fire, giving a new drop target the chance to
                // reset the effect.
                _this.dataTransfer.dropEffect = DragDropEffect.none;
                dispatchCustomDragEvent("dragexit", event.target, event, _this.dataTransfer);
            }
        };
        this.onPointerOver = function (event) {
            if (event.target) {
                // The pointer has entered an element, so we need to set the dropEffect to none.
                // The dragover event will fire, giving a new drop target the chance to
                // reset the effect.
                _this.dataTransfer.dropEffect = DragDropEffect.none;
                dispatchCustomDragEvent("dragenter", event.target, event, _this.dataTransfer);
            }
        };
    }
    DragDropManager.prototype.beginDragOperation = function (event, dataTransfer, minimumPixelsForDrag) {
        if (minimumPixelsForDrag === void 0) { minimumPixelsForDrag = 4; }
        this.operation = undefined;
        // Something (typically a pointdown on a drag source) has indicated that there is the potential
        // for a drag operation. If there is a drag operation already in progress, do nothing.
        if (!this.dragInProgress) {
            // If there is no drag operation in progress, we should set up the event handlers to detect pointer
            // operations that could lead us to actually start the drag / drop operation.
            if (event.type === "pointerdown") {
                this.startDrag(event, minimumPixelsForDrag, dataTransfer);
                this.initialCoordinates = {
                    x: event.clientX,
                    y: event.clientY
                };
                _Util__WEBPACK_IMPORTED_MODULE_4__["Pointer"].setCapture(this.onEventCaptured);
                document.body.addEventListener("pointerout", this.onPointerOut, true);
                document.body.addEventListener("pointerover", this.onPointerOver, true);
                document.body.addEventListener("pointerleave", this.onPointerLeave);
                this.operation = {
                    x: new _Core_Observable__WEBPACK_IMPORTED_MODULE_1__["ObservableValue"](undefined),
                    y: new _Core_Observable__WEBPACK_IMPORTED_MODULE_1__["ObservableValue"](undefined)
                };
            }
        }
        return this.operation;
    };
    DragDropManager.prototype.endDrag = function () {
        document.body.removeEventListener("pointerout", this.onPointerOut);
        document.body.removeEventListener("pointerover", this.onPointerOver);
        document.body.removeEventListener("pointerleave", this.onPointerLeave);
        this.dragInProgress = false;
    };
    DragDropManager.prototype.getTargetFromEvent = function (event) {
        return event.target;
    };
    DragDropManager.prototype.startDrag = function (event, minimumPixelsForDrag, dataTransfer) {
        this.potentialDragInProgress = true;
        this.dragSourceElement = event.target;
        this.minimumPixelsForDrag = minimumPixelsForDrag;
        this.dataTransfer = dataTransfer;
    };
    return DragDropManager;
}());
var dragDropManager = new DragDropManager();
function beginDragOperation(event, dataTransfer, minimumPixelsForDrag) {
    return dragDropManager.beginDragOperation(event, dataTransfer, minimumPixelsForDrag);
}
function dispatchCustomDragEvent(eventType, target, event, dataTransfer) {
    var customEvent = new CustomEvent(eventType, {
        bubbles: true,
        detail: { dataTransfer: dataTransfer, nativeEvent: event }
    });
    target.dispatchEvent(customEvent);
    return customEvent;
}
var DragImage = function (props) {
    var className = props.className, operation = props.operation, _a = props.xOffset, xOffset = _a === void 0 ? 5 : _a, _b = props.yOffset, yOffset = _b === void 0 ? 5 : _b;
    return (react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_Portal__WEBPACK_IMPORTED_MODULE_3__["Portal"], { className: "bolt-drag-image-portal" },
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_2__["Observer"], { x: operation.x, y: operation.y }, function (observedProps) {
            return observedProps.x !== undefined && observedProps.y !== undefined ? (react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", { className: Object(_Util__WEBPACK_IMPORTED_MODULE_4__["css"])(className, "bolt-drag-image depth-16 absolute flex-row flex-center scroll-hidden justify-center"), style: { left: observedProps.x + xOffset + "px", top: observedProps.y + yOffset + "px" } }, props.children)) : null;
        })));
};


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ TextField_TextField_TextField; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ TextFieldStyle; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ TextFieldFocusTreatmentBehavior; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ TextFieldWidth; });

// UNUSED EXPORTS: TextFieldWithMessage

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/TextField/TextField.css
var TextField_TextField = __webpack_require__(162);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/FocusWithin.js
var FocusWithin = __webpack_require__(23);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/FocusZone.js + 2 modules
var FocusZone = __webpack_require__(7);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/FormItem.js
var FormItem = __webpack_require__(200);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Icon.js + 2 modules
var Icon = __webpack_require__(9);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Observer.js
var Observer = __webpack_require__(8);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/TooltipEx.js
var TooltipEx = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Utilities/Focus.js + 1 modules
var Focus = __webpack_require__(26);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/TextField/TextField.Props.js
/**
 * Defines how the TextField is styled
 */
var TextFieldStyle;
(function (TextFieldStyle) {
    /**
     * Rendered closer to a typical <input />
     */
    TextFieldStyle[TextFieldStyle["normal"] = 0] = "normal";
    /**
     * Rendered with no border and a non-white background
     */
    TextFieldStyle[TextFieldStyle["inline"] = 1] = "inline";
})(TextFieldStyle || (TextFieldStyle = {}));
/**
 * Defines how the focus treatment should be rendered for the TextField.
 */
var TextFieldFocusTreatmentBehavior;
(function (TextFieldFocusTreatmentBehavior) {
    /**
     * Focus treatment will appear when the TextField has focus via mouse or keyboard
     */
    TextFieldFocusTreatmentBehavior[TextFieldFocusTreatmentBehavior["all"] = 0] = "all";
    /**
     * Focus treatment will only appear when the TextField has focus via keyboard
     */
    TextFieldFocusTreatmentBehavior[TextFieldFocusTreatmentBehavior["keyboardOnly"] = 1] = "keyboardOnly";
    /**
     * Focus treatment will never appear (used within FilterBar)
     */
    TextFieldFocusTreatmentBehavior[TextFieldFocusTreatmentBehavior["none"] = 2] = "none";
})(TextFieldFocusTreatmentBehavior || (TextFieldFocusTreatmentBehavior = {}));
// /**
//  * Defines the TextField's width
//  */
var TextFieldWidth;
(function (TextFieldWidth) {
    /**
     * No width property is added to the TextField, it will grow to fill its container.
     */
    TextFieldWidth["auto"] = "auto";
    /**
     * A standard width of 296px is set for the TextField
     */
    TextFieldWidth["standard"] = "bolt-textfield-default-width";
    /**
     * Width for the TextField when it is used inline within a TabBar
     */
    TextFieldWidth["tabBar"] = "bolt-textfield-inline-tabbar-width";
})(TextFieldWidth || (TextFieldWidth = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/TextField/TextField.js














var TextField_inputId = 1;
var TextField_TextField_TextField = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(TextField, _super);
    function TextField(props) {
        var _this = _super.call(this, props) || this;
        _this.select = function () {
            if (_this.inputElement.current) {
                _this.inputElement.current.select();
            }
        };
        _this.inputId = "textfield-input-" + TextField_inputId++;
        _this.inputElement = props.inputElement || external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"]();
        return _this;
    }
    TextField.prototype.focus = function () {
        if (this.inputElement.current) {
            this.inputElement.current.focus();
        }
    };
    Object.defineProperty(TextField.prototype, "selectionEnd", {
        get: function () {
            return this.inputElement.current ? this.inputElement.current.selectionEnd : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextField.prototype, "selectionStart", {
        get: function () {
            return this.inputElement.current ? this.inputElement.current.selectionStart : null;
        },
        enumerable: true,
        configurable: true
    });
    TextField.prototype.setSelectionRange = function (start, end, direction) {
        if (this.inputElement.current) {
            this.inputElement.current.setSelectionRange(start, end, direction);
        }
    };
    TextField.prototype.render = function () {
        var _this = this;
        var _a = this.props, autoAdjustHeight = _a.autoAdjustHeight, className = _a.className, containerClassName = _a.containerClassName, disabled = _a.disabled, _b = _a.focusTreatment, focusTreatment = _b === void 0 ? TextFieldFocusTreatmentBehavior.all : _b, inputId = _a.inputId, label = _a.label, onBlur = _a.onBlur, onFocus = _a.onFocus, style = _a.style, value = _a.value, width = _a.width;
        var input = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusWithin["FocusWithin"], { onFocus: onFocus, onBlur: onBlur }, function (focusStatus) { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FormItem["FormItemContext"].Consumer, null, function (formItemContext) {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])("flex-column", containerClassName, width !== TextFieldWidth.auto && width) },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(!label && className, "bolt-textfield flex-row flex-center", disabled && "disabled", focusTreatment === TextFieldFocusTreatmentBehavior.all && "focus-treatment", focusTreatment === TextFieldFocusTreatmentBehavior.keyboardOnly && "focus-keyboard-only", focusStatus.hasFocus && "focused", style === TextFieldStyle.inline && "bolt-textfield-inline", formItemContext.error && "bolt-textfield-error") },
                    external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusZone["b" /* FocusZoneContext */].Consumer, null, function (zoneContext) { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { value: value }, function (observedProps) {
                        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TextField_TextFieldInnerValue, Object(tslib_es6["a" /* __assign */])({}, _this.props, { focus: function () { return _this.focus(); }, focusStatus: focusStatus, formItemContext: formItemContext, inputElement: _this.inputElement, inputId: _this.props.inputId || _this.inputId, value: observedProps.value, zoneContext: zoneContext })));
                    })); }))));
        })); }));
        if (label) {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(className, "flex-column") },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("label", { htmlFor: Object(Util["getSafeId"])(inputId || this.inputId), className: "bolt-textfield-label" }, label),
                input));
        }
        else {
            return input;
        }
    };
    return TextField;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));

var TextField_TextFieldInnerValue = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(TextFieldInnerValue, _super);
    function TextFieldInnerValue() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.adjustedHeight = -1;
        _this.adjustedHeightValue = "";
        _this.hiddenElement = external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"]();
        return _this;
    }
    TextFieldInnerValue.prototype.render = function () {
        var _this = this;
        var _a = this.props, activatable = _a.activatable, ariaActiveDescendant = _a.ariaActiveDescendant, ariaAutoComplete = _a.ariaAutoComplete, ariaControls = _a.ariaControls, ariaExpanded = _a.ariaExpanded, ariaHasPopup = _a.ariaHasPopup, ariaInvalid = _a.ariaInvalid, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, ariaRoleDescription = _a.ariaRoleDescription, autoAdjustHeight = _a.autoAdjustHeight, autoComplete = _a.autoComplete, autoFocus = _a.autoFocus, autoSelect = _a.autoSelect, disabled = _a.disabled, excludeFocusZone = _a.excludeFocusZone, focus = _a.focus, focusStatus = _a.focusStatus, formItemContext = _a.formItemContext, inputClassName = _a.inputClassName, inputElement = _a.inputElement, inputId = _a.inputId, inputType = _a.inputType, maxLength = _a.maxLength, maxWidth = _a.maxWidth, multiline = _a.multiline, onClick = _a.onClick, onKeyDown = _a.onKeyDown, onKeyPress = _a.onKeyPress, onKeyUp = _a.onKeyUp, onPaste = _a.onPaste, placeholder = _a.placeholder, prefixIconProps = _a.prefixIconProps, readOnly = _a.readOnly, required = _a.required, resizable = _a.resizable, role = _a.role, rows = _a.rows, spellCheck = _a.spellCheck, tooltipProps = _a.tooltipProps, value = _a.value, zoneContext = _a.zoneContext;
        var _b = this.props, ariaDescribedBy = _b.ariaDescribedBy, suffixIconProps = _b.suffixIconProps;
        var TagName = multiline ? "textarea" : "input";
        var tagSpecificProps = multiline ? { rows: rows } : { type: inputType, autoComplete: autoComplete ? "on" : "off" };
        if (suffixIconProps === undefined && formItemContext.error) {
            suffixIconProps = {
                className: "bolt-textfield-message-error",
                iconName: "Error"
            };
        }
        if (ariaDescribedBy === undefined) {
            ariaDescribedBy = formItemContext.ariaDescribedById;
        }
        var className = Object(Util["css"])(inputClassName, "bolt-textfield-input flex-grow", autoAdjustHeight && "bolt-textfield-auto-adjust", resizable && "bolt-textfield-auto-unresizable", prefixIconProps && "bolt-textfield-input-with-prefix", suffixIconProps && "bolt-textfield-input-with-suffix", activatable && "activatable");
        var style = maxWidth !== undefined ? { maxWidth: maxWidth } : {};
        var element = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TagName, Object(tslib_es6["a" /* __assign */])({}, tagSpecificProps, { "aria-activedescendant": Object(Util["getSafeId"])(ariaActiveDescendant), "aria-autocomplete": ariaAutoComplete, "aria-controls": Object(Util["getSafeId"])(ariaControls), "aria-describedby": Object(Util["getSafeId"])(ariaDescribedBy), "aria-disabled": disabled, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, "aria-invalid": ariaInvalid, "aria-label": ariaLabel === undefined && placeholder ? placeholder : ariaLabel, "aria-labelledby": Object(Util["getSafeId"])(ariaLabelledBy) || Object(Util["getSafeId"])(formItemContext.ariaLabelledById), "aria-readonly": inputType && inputType !== "text" ? readOnly : undefined, "aria-required": required, "aria-roledescription": ariaRoleDescription, autoFocus: autoFocus, "data-focuszone": !disabled && !excludeFocusZone ? zoneContext.focuszoneId : undefined, disabled: disabled, className: className, id: Object(Util["getSafeId"])(inputId), maxLength: maxLength, onBlur: focusStatus.onBlur, onClick: onClick, onChange: function (e) {
                _this.props.onChange && _this.props.onChange(e, e.target.value);
                // Adjust height synchronously. If we wait until the React update effect, then
                // the text area has already been painted in a partially-scrolled state which
                // causes some ugly flickering.
                _this.adjustHeight();
            }, onFocus: function (event) {
                if (autoSelect && inputElement.current) {
                    inputElement.current.select();
                }
                focusStatus.onFocus && focusStatus.onFocus(event);
            }, onKeyDown: onKeyDown, onKeyPress: onKeyPress, onKeyUp: onKeyUp, onPaste: onPaste, placeholder: placeholder, readOnly: readOnly, required: required, ref: inputElement, role: role, style: style, spellCheck: spellCheck, tabIndex: Object(Focus["a" /* getTabIndex */])(this.props), value: value || "" })));
        // We will use a hidden element behind the input to measure the height.
        // This prevents the page from performing re-layout when measuring.
        if (multiline && autoAdjustHeight) {
            element = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "flex-row flex-grow relative" },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TagName, { "aria-hidden": true, className: Object(Util["css"])("bolt-textfield-auto-adjust-hidden", className), ref: this.hiddenElement, role: "presentation" }),
                element));
        }
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](external_commonjs_react_commonjs2_react_amd_React_root_React_["Fragment"], null,
            prefixIconProps &&
                Object(Icon["Icon"])(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({ size: Icon["IconSize"].medium }, prefixIconProps), { className: Object(Util["css"])(prefixIconProps.className, "prefix", !prefixIconProps.render && "bolt-textfield-icon", ((placeholder && !value) || prefixIconProps.render) && "bolt-textfield-no-text"), onClick: function (e) {
                        prefixIconProps && prefixIconProps.onClick && prefixIconProps.onClick(e);
                        focus();
                    } })),
            tooltipProps ? external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TooltipEx["Tooltip"], Object(tslib_es6["a" /* __assign */])({}, tooltipProps), element) : element,
            suffixIconProps &&
                Object(Icon["Icon"])(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({ size: Icon["IconSize"].medium }, suffixIconProps), { className: Object(Util["css"])(suffixIconProps.className, "suffix", !suffixIconProps.render && "bolt-textfield-icon", ((placeholder && !value) || suffixIconProps.render) && "bolt-textfield-no-text"), onClick: function (e) {
                        suffixIconProps && suffixIconProps.onClick && suffixIconProps.onClick(e);
                        focus();
                    } }))));
    };
    TextFieldInnerValue.prototype.componentDidMount = function () {
        this.adjustHeight();
    };
    TextFieldInnerValue.prototype.componentDidUpdate = function () {
        this.adjustHeight();
    };
    TextFieldInnerValue.prototype.adjustHeight = function () {
        var hiddenElement = this.hiddenElement;
        var _a = this.props, autoAdjustHeight = _a.autoAdjustHeight, inputElement = _a.inputElement, multiline = _a.multiline, value = _a.value;
        // If this is a multi-line, auto-adjust text area, adjust the height based on the current content
        if (multiline && autoAdjustHeight && inputElement.current && hiddenElement.current && value !== this.adjustedHeightValue) {
            hiddenElement.current.value = inputElement.current.value;
            if (this.adjustedHeight !== hiddenElement.current.scrollHeight) {
                this.adjustedHeight = hiddenElement.current.scrollHeight;
                this.adjustedHeightValue = inputElement.current.value;
                inputElement.current.style.height = this.adjustedHeight + "px";
            }
        }
    };
    return TextFieldInnerValue;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/TextField/TextFieldWithMessage.js








var messageId = 1;
var TextFieldWithMessage_TextFieldWithMessage = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(TextFieldWithMessage, _super);
    function TextFieldWithMessage(props) {
        var _this = _super.call(this, props) || this;
        _this.innerTextField = external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"]();
        _this.select = function () {
            if (_this.innerTextField.current) {
                _this.innerTextField.current.select();
            }
        };
        _this.setSelectionRange = function (start, length) {
            if (_this.innerTextField.current) {
                _this.innerTextField.current.setSelectionRange(start, length);
            }
        };
        _this.descriptionId = "textfield-message-" + messageId++;
        return _this;
    }
    TextFieldWithMessage.prototype.focus = function () {
        if (this.innerTextField.current) {
            this.innerTextField.current.focus();
        }
    };
    Object.defineProperty(TextFieldWithMessage.prototype, "selectionEnd", {
        get: function () {
            return this.innerTextField.current ? this.innerTextField.current.selectionEnd : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFieldWithMessage.prototype, "selectionStart", {
        get: function () {
            return this.innerTextField.current ? this.innerTextField.current.selectionStart : null;
        },
        enumerable: true,
        configurable: true
    });
    TextFieldWithMessage.prototype.render = function () {
        var _this = this;
        var _a = this.props, message = _a.message, error = _a.error;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { error: error, message: message }, function (observerProps) {
            var textFieldProps = Object(tslib_es6["a" /* __assign */])({}, _this.props.textFieldProps);
            var messageClassName = _this.props.messageClassName;
            if (observerProps.error) {
                textFieldProps.className = Object(Util["css"])(textFieldProps.className, "bolt-textfield-error");
                messageClassName = Object(Util["css"])(messageClassName, "bolt-textfield-message-error");
                textFieldProps.suffixIconProps = textFieldProps.suffixIconProps || {
                    className: "bolt-textfield-message-error",
                    iconName: "Error"
                };
            }
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(_this.props.className, "flex-column") },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TextField_TextField_TextField, Object(tslib_es6["a" /* __assign */])({ ariaDescribedBy: observerProps.message && _this.descriptionId, ref: _this.innerTextField }, textFieldProps)),
                observerProps.message && (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("span", { role: error ? "alert" : undefined, id: Object(Util["getSafeId"])(_this.descriptionId), className: Object(Util["css"])(messageClassName, "bolt-textfield-message") }, observerProps.message))));
        }));
    };
    return TextFieldWithMessage;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/TextField.js


// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present



/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = whitespace

var fromCode = String.fromCharCode
var re = /\s/

// Check if the given character code, or the character code at the first
// character, is a whitespace character.
function whitespace(character) {
  return re.test(
    typeof character === 'number' ? fromCode(character) : character.charAt(0)
  )
}


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Components_Link_Link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return _Components_Link_Link__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_Link_Link_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _Components_Link_Link_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_Link_Link_Props__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_Link_Link_Props__WEBPACK_IMPORTED_MODULE_1__) if(["default","Link"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_Link_Link_Props__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _Components_Link_Utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(132);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getDefaultAnchorProps", function() { return _Components_Link_Utilities__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getDefaultLinkProps", function() { return _Components_Link_Utilities__WEBPACK_IMPORTED_MODULE_2__["b"]; });






/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_FocusGroup_FocusGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(112);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FocusGroup", function() { return _Components_FocusGroup_FocusGroup__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FocusGroupContext", function() { return _Components_FocusGroup_FocusGroup__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony import */ var _Components_FocusGroup_FocusGroup_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(113);
/* harmony import */ var _Components_FocusGroup_FocusGroup_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_FocusGroup_FocusGroup_Props__WEBPACK_IMPORTED_MODULE_1__);

// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present



/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScreenBreakpoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ScreenSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ScreenContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);


var ScreenBreakpoints;
(function (ScreenBreakpoints) {
    /**
     * Smallest breakpoint used to react which usually corresponds to a mobile screen < 600px.
     */
    ScreenBreakpoints[ScreenBreakpoints["xsmall"] = 1] = "xsmall";
    /**
     * Medium breakpoint used to react when the screen size >= 600px and less than
     * the next breakpoint if exists.
     */
    ScreenBreakpoints[ScreenBreakpoints["small"] = 600] = "small";
    /**
     * Medium breakpoint used to react when the screen size >= 1024px and less than
     * the next breakpoint if exists.
     */
    ScreenBreakpoints[ScreenBreakpoints["medium"] = 1024] = "medium";
    /**
     * Large breakpoint used to react when the screen size >= 1366px and less than
     * the next breakpoint if exists.
     */
    ScreenBreakpoints[ScreenBreakpoints["large"] = 1366] = "large";
    /**
     * Largest breakpoint used to react when the screen size >= 1920px and less than
     * the next breakpoint if exists.
     */
    ScreenBreakpoints[ScreenBreakpoints["xlarge"] = 1920] = "xlarge";
})(ScreenBreakpoints || (ScreenBreakpoints = {}));
var ScreenSize;
(function (ScreenSize) {
    ScreenSize[ScreenSize["xsmall"] = 0] = "xsmall";
    ScreenSize[ScreenSize["small"] = 1] = "small";
    ScreenSize[ScreenSize["medium"] = 2] = "medium";
    ScreenSize[ScreenSize["large"] = 3] = "large";
    ScreenSize[ScreenSize["xlarge"] = 4] = "xlarge";
})(ScreenSize || (ScreenSize = {}));
var ScreenContextImp = /** @class */ (function () {
    function ScreenContextImp() {
        var _this = this;
        this.onResize = function () {
            var size = _this.getCurrentSize();
            if (_this.size.value !== size) {
                _this.size.value = size;
            }
        };
        this.size = new _Core_Observable__WEBPACK_IMPORTED_MODULE_1__["ObservableValue"](this.getCurrentSize());
        window.addEventListener("resize", this.onResize);
    }
    ScreenContextImp.prototype.getCurrentSize = function () {
        if (window.innerWidth >= ScreenBreakpoints.xlarge) {
            return ScreenSize.xlarge;
        }
        else if (window.innerWidth >= ScreenBreakpoints.large) {
            return ScreenSize.large;
        }
        else if (window.innerWidth >= ScreenBreakpoints.medium) {
            return ScreenSize.medium;
        }
        else if (window.innerWidth >= ScreenBreakpoints.small) {
            return ScreenSize.small;
        }
        else {
            return ScreenSize.xsmall;
        }
    };
    return ScreenContextImp;
}());
var ScreenContext = react__WEBPACK_IMPORTED_MODULE_0__["createContext"](new ScreenContextImp());


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FilterOperatorType", function() { return FilterOperatorType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILTER_CHANGE_EVENT", function() { return FILTER_CHANGE_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILTER_APPLIED_EVENT", function() { return FILTER_APPLIED_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILTER_RESET_EVENT", function() { return FILTER_RESET_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Filter", function() { return Filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FilterContext", function() { return FilterContext; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);



var FilterOperatorType;
(function (FilterOperatorType) {
    /**
     * The filter's value should be treated as having the AND operator
     * e.g. If the value is ['a', 'c', 'd'] any item which does not contain
     * 'a' AND 'c' AND 'd' should not be included
     */
    FilterOperatorType["and"] = "and";
    /**
     * The filter's value should be treated as having the OR operator
     * e.g. If the value is ['a', 'c', 'd'] any item which contains
     * 'a' OR 'c' OR 'd' should be included
     */
    FilterOperatorType["or"] = "or";
})(FilterOperatorType || (FilterOperatorType = {}));
var FILTER_CHANGE_EVENT = "filter-changed";
var FILTER_APPLIED_EVENT = "filter-applied";
var FILTER_RESET_EVENT = "reset-filters";
/**
 * Store for a set of filter values
 *
 * Events:
 *
 *  FILTER_CHANGE_EVENT: IFilterState
 *  Fired whenever a filter value changes. The event object contains the changed items.
 *  When using explicit apply-mode, this event is fired when the filter is changed (i.e. by user action)
 *  but not yet applied.
 *
 *  FILTER_APPLIED_EVENT: IFilterState
 *  Fired when new filter changes have been applied. The event object contains the changed items.
 *  When not using explicit apply-mode, this event is fired on every state change
 */
var Filter = /** @class */ (function () {
    /**
     * Create a new Filter store
     * @param options Options for the filter store
     */
    function Filter(options, observable) {
        if (options === void 0) { options = {}; }
        this.observable = observable || new _Core_Observable__WEBPACK_IMPORTED_MODULE_2__["Observable"]();
        this.applyMode = !!options.useApplyMode;
        this.defaultState = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, options.defaultState);
        this.currentState = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.defaultState);
        this.customValueComparers = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, options.customValueComparers);
        if (this.applyMode) {
            this.appliedState = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.currentState);
        }
        else {
            this.appliedState = this.currentState;
        }
    }
    Filter.prototype.subscribe = function (observer, action) {
        return this.observable.subscribe(observer, action);
    };
    Filter.prototype.unsubscribe = function (observer, action) {
        this.observable.unsubscribe(observer, action);
    };
    /**
     * Gets a dictionary containing the current values of all filter items
     */
    Filter.prototype.getState = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.currentState);
    };
    /**
     * Gets a dictionary containing the applied values of all filter items.
     * When useApplyMode is false, this always matches the value returned by getState.
     */
    Filter.prototype.getAppliedState = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.appliedState);
    };
    /**
     * Gets a dictionary containing the default values of all filter items
     */
    Filter.prototype.getDefaultState = function () {
        return this.defaultState;
    };
    /**
     * Update what the filter considers as its default state
     * @param defaultState The new default state
     */
    Filter.prototype.setDefaultState = function (defaultState) {
        this.defaultState = defaultState;
    };
    /**
     * Sets the current values of all filter items
     * @param state Dictionary of all current filter item values
     * @param supressChangeEvent If true, don't invoke the onFilterChanged callback at this time
     */
    Filter.prototype.setState = function (state, supressChangeEvent) {
        if (supressChangeEvent === void 0) { supressChangeEvent = false; }
        var prevState = this.currentState;
        this.currentState = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, state);
        if (!this.applyMode) {
            this.appliedState = this.currentState;
        }
        if (!supressChangeEvent) {
            var changedState = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, state);
            for (var key in prevState) {
                // Add current filters that are cleared by the new state
                // (i.e. these changed from "something" to "nothing")
                if (!state.hasOwnProperty(key)) {
                    changedState[key] = null;
                }
            }
            this._triggerStateChange(changedState);
        }
    };
    /**
     * Gets the value of the specified filter item
     * @param key Filter item key
     */
    Filter.prototype.getFilterItemState = function (key) {
        return this.currentState[key];
    };
    /**
     * Gets the applied value of the specified filter item. When applyMode is false,
     * this is equivalent to getFilterItemState.
     * @param key Filter item key
     */
    Filter.prototype.getAppliedFilterItemState = function (key) {
        return this.appliedState[key];
    };
    /**
     * Gets the value property for the filter item with the given key.
     * @param key The filter item's key
     */
    Filter.prototype.getFilterItemValue = function (key) {
        var item = this.currentState[key];
        if (item) {
            return item.value;
        }
        else {
            return undefined;
        }
    };
    /**
     * Sets the value of the specified filter item
     * @param key Filter item key
     * @param value Filter value
     */
    Filter.prototype.setFilterItemState = function (key, value) {
        this.currentState[key] = value;
        var changeEvent = {};
        changeEvent[key] = value;
        this._triggerStateChange(changeEvent);
    };
    /**
     * Resets the filter values to their default state
     * @param suppressChangeEvent If true, don't invoke the onFilterChanged callback at this time
     */
    Filter.prototype.reset = function (suppressChangeEvent) {
        if (suppressChangeEvent === void 0) { suppressChangeEvent = false; }
        this.setState(this.defaultState, suppressChangeEvent);
        if (!suppressChangeEvent) {
            this._raiseEventAndCallListeners(FILTER_RESET_EVENT, {});
        }
    };
    Filter.prototype.resetFilterItemState = function (key) {
        var value = this.defaultState[key];
        this.setFilterItemState(key, value);
    };
    Filter.prototype.applyChanges = function () {
        this.appliedState = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.currentState);
        this._raiseEventAndCallListeners(FILTER_APPLIED_EVENT, this.appliedState);
    };
    Filter.prototype.usesApplyMode = function () {
        return this.applyMode;
    };
    Filter.prototype.hasChangesToApply = function () {
        return !this.statesAreEqual(this.appliedState, this.currentState);
    };
    Filter.prototype.hasChangesToReset = function () {
        return !this.statesAreEqual(this.defaultState, this.currentState);
    };
    Filter.prototype.statesAreEqual = function (state1, state2) {
        return this._checkStateEquality(state1, state2) && this._checkStateEquality(state2, state1);
    };
    Filter.prototype.filterItemStatesAreEqual = function (item, state1, state2) {
        return this._checkFilterItemStateEquality(item, state1, state2);
    };
    Filter.prototype._triggerStateChange = function (changedState) {
        this._raiseEventAndCallListeners(FILTER_CHANGE_EVENT, changedState);
        if (!this.applyMode) {
            this._raiseEventAndCallListeners(FILTER_APPLIED_EVENT, changedState);
        }
    };
    Filter.prototype._raiseEventAndCallListeners = function (eventName, changedState) {
        this.observable.notify(changedState, eventName);
    };
    Filter.prototype._checkStateEquality = function (state1, state2) {
        for (var item in state1) {
            var filterItemStateEqual = this._checkFilterItemStateEquality(item, state1[item], state2[item]);
            if (!filterItemStateEqual) {
                return false;
            }
        }
        return true;
    };
    Filter.prototype._checkFilterItemStateEquality = function (item, item1State, item2State) {
        var item1Value = item1State && item1State.value;
        var item2Value = item2State && item2State.value;
        if (Array.isArray(item1Value)) {
            if (Array.isArray(item2Value)) {
                if (item1Value.length !== item2Value.length) {
                    return false;
                }
                for (var index = 0; index < item1Value.length; index++) {
                    if (!this._checkValueEquality(item, item1Value[index], item2Value[index])) {
                        return false;
                    }
                }
            }
            else {
                if (item1Value.length !== 0 || !!item2Value) {
                    return false;
                }
            }
        }
        else if (!this._checkValueEquality(item, item1Value, item2Value)) {
            return false;
        }
        else if (Array.isArray(item2Value)) {
            if (item2Value.length !== 0) {
                return false;
            }
        }
        return true;
    };
    Filter.prototype._checkValueEquality = function (key, item1, item2) {
        if (this.customValueComparers[key]) {
            return this.customValueComparers[key](item1, item2);
        }
        if (item1 && item1 !== item2) {
            return false;
        }
        else if (!!item1 !== !!item2) {
            return false;
        }
        return true;
    };
    return Filter;
}());

var FilterContext = react__WEBPACK_IMPORTED_MODULE_1__["createContext"]({
    filter: null,
    filterToggled: null
});


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_Intersection_Intersection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(114);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Intersection", function() { return _Components_Intersection_Intersection__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntersectionContext", function() { return _Components_Intersection_Intersection__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony import */ var _Components_Intersection_Intersection_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(115);
/* harmony import */ var _Components_Intersection_Intersection_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_Intersection_Intersection_Props__WEBPACK_IMPORTED_MODULE_1__);




/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return List; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ScrollableList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SimpleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return renderListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return renderListCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cellFromElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cellFromEvent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _List_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44);
/* harmony import */ var _List_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_List_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45);
/* harmony import */ var _ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4);
/* harmony import */ var _FocusWithin__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23);
/* harmony import */ var _FocusZone__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9);
/* harmony import */ var _Intersection__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(30);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8);
/* harmony import */ var _TooltipEx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(19);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1);
/* harmony import */ var _Utilities_Dispatch__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(54);
/* harmony import */ var _Utilities_Focus__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26);

















/**
 * The List component is used to render a collection of items with a series of rows.
 */
var List = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(List, _super);
    function List(props) {
        var _this = _super.call(this, props) || this;
        // Track the table element used to render the rows.
        _this.bodyElement = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.listElement = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        // Manage data about pages, including their spacers.
        _this.spacerElements = {};
        _this.scrollToIndex = -1;
        _this.scrollToOptions = undefined;
        // Focus/Selection management members.
        _this.selectOnFocus = true;
        _this.focusIndex = -1;
        _this.pivotIndex = -1;
        _this.onBlur = function () {
            _this.focusIndex = -1;
        };
        _this.onClick = function (event) {
            _this.onDispatch(event);
            if (!event.defaultPrevented && !(event.altKey && _this.props.selectableText)) {
                if (_this.listElement.current) {
                    var _a = cellFromEvent(event), cellElement = _a.cellElement, rowIndex = _a.rowIndex;
                    if (!cellElement || !Object(_Util__WEBPACK_IMPORTED_MODULE_14__["eventTargetContainsNode"])(event, ["A"], cellElement)) {
                        var item = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(_this.state.rows[rowIndex]);
                        if (rowIndex >= 0 && item) {
                            var listRow = { data: item, index: rowIndex };
                            // Even for singleClickActivation we fire the selection before activation.
                            if (_this.props.selectRowOnClick) {
                                _this.processSelectionEvent(event, listRow);
                            }
                            // For singleClickActivation we want the activation as well.
                            if (_this.props.singleClickActivation) {
                                _this.rowActivated(event, listRow);
                            }
                        }
                    }
                }
            }
        };
        _this.onDispatch = function (event) {
            _this.state.eventDispatch.dispatchEvent(event);
        };
        _this.onDoubleClick = function (event) {
            _this.onDispatch(event);
            if (!event.defaultPrevented && !_this.props.singleClickActivation) {
                var rowIndex = cellFromEvent(event).rowIndex;
                var item = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(_this.state.rows[rowIndex]);
                if (rowIndex >= 0 && item) {
                    _this.rowActivated(event, { data: item, index: rowIndex });
                }
            }
        };
        _this.onFocusBody = function (event) {
            // The first time the list gets focus we need to select initial row if we are performing
            // selection of focus.
            if (_this.selectOnFocus) {
                var selection = _this.props.selection;
                if (!selection || selection.selectOnFocus) {
                    var rowIndex = _this.focusIndex;
                    if (rowIndex >= 0) {
                        var item = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(_this.state.rows[rowIndex]);
                        if (item) {
                            _this.processSelectionEvent(event, { data: item, index: rowIndex });
                        }
                    }
                }
                _this.selectOnFocus = false;
            }
        };
        _this.onFocusItem = function (rowIndex, event) {
            var focusIndex = _this.focusIndex;
            if (focusIndex !== rowIndex) {
                // We need to re-render the previously focused row and newly focused row so we will
                // clear the cached values.
                if (focusIndex >= 0) {
                    delete _this.state.renderedRows[focusIndex];
                }
                else {
                    // If there was a tabble row that was not the focusIndex row we need to update this
                    // row as well to get it re-rendered without the tabIndex.
                    delete _this.state.renderedRows[_this.getInitialTabbableRow()];
                }
                delete _this.state.renderedRows[rowIndex];
                _this.focusIndex = rowIndex;
                var item = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(_this.state.rows[rowIndex]);
                if (item) {
                    _this.rowFocused(event, { data: item, index: rowIndex });
                }
            }
        };
        _this.onKeyDown = function (event) {
            _this.onDispatch(event);
            if (!event.defaultPrevented) {
                var nodeName = event.target.nodeName;
                if (nodeName === "INPUT" || nodeName === "TEXTAREA") {
                    // Don't handle keyboard events when target is an input
                    return;
                }
                var focusIndex_1 = _this.focusIndex;
                var item = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(_this.state.rows[focusIndex_1]);
                if (item) {
                    if (event.which === _Util__WEBPACK_IMPORTED_MODULE_14__["KeyCode"].enter) {
                        if (focusIndex_1 >= 0 && !Object(_Util__WEBPACK_IMPORTED_MODULE_14__["eventTargetContainsNode"])(event, ["A"])) {
                            _this.rowActivated(event, { data: item, index: focusIndex_1 });
                        }
                    }
                    else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_14__["KeyCode"].space) {
                        _this.processSelectionEvent(event, { data: item, index: focusIndex_1 });
                        event.preventDefault();
                    }
                    else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_14__["KeyCode"].upArrow || event.which === _Util__WEBPACK_IMPORTED_MODULE_14__["KeyCode"].downArrow) {
                        var selection = _this.props.selection;
                        if (!selection || (selection.selectOnFocus && (event.shiftKey || !event.ctrlKey))) {
                            event.persist();
                            // Need to wait for the keyboard event to be processed by the focuszone.
                            window.setTimeout(function () {
                                if (_this.focusIndex != focusIndex_1) {
                                    var data = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(_this.state.rows[_this.focusIndex]);
                                    if (data) {
                                        _this.processSelectionEvent(event, { data: data, index: _this.focusIndex });
                                    }
                                }
                            }, 0);
                        }
                    }
                    else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_14__["KeyCode"].pageDown) {
                        var stats = _this.getStats();
                        _this.focusRow(Math.min(focusIndex_1 + (stats.lastRendered - stats.firstRendered), _this.state.rowCount - 1), 1);
                        event.preventDefault();
                    }
                    else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_14__["KeyCode"].pageUp) {
                        var stats = _this.getStats();
                        _this.focusRow(Math.max(focusIndex_1 - (stats.lastRendered - stats.firstRendered), 0), -1);
                        event.preventDefault();
                    }
                    else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_14__["KeyCode"].home) {
                        _this.focusRow(0, 1);
                        event.preventDefault();
                    }
                    else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_14__["KeyCode"].end) {
                        _this.focusRow(_this.state.rowCount - 1, -1);
                        event.preventDefault();
                    }
                }
            }
        };
        _this.onIntersect = function (entries) {
            // If virtualization is disabled, we will not attempt to adjust the viewport.
            if (!_this.props.virtualize) {
                return;
            }
            var scrollTop = _this.context.root.scrollTop;
            var _a = _this.state, firstRendered = _a.firstRendered, firstMaterialized = _a.firstMaterialized, lastRendered = _a.lastRendered, lastMaterialized = _a.lastMaterialized, rowCount = _a.rowCount, rowProportion = _a.rowProportion;
            var rowHeight = _this.state.rowHeight;
            // console.log({ phase: "onIntersect - Start", firstMaterialized, lastMaterialized, rowHeight });
            // Don't process an intersection while scroll event is pending.
            if (scrollTop !== _this.state.scrollTop && entries.length) {
                // console.log("Don't process an intersection while scroll event is pending.");
                return;
            }
            // Ignore events if we dont have a our basic elements resolved (this should never happen).
            if (!_this.listElement.current || !_this.bodyElement.current) {
                // console.log("Elements not available at this point.");
                return;
            }
            // We are going to enumerate all the children, if the row is in the viewport
            // we will determine if it should be paged out.
            var rowElements = _this.bodyElement.current.children;
            // If a rowHeight was specified we will compute one based on the average rowHeight in the
            // first page rendered.
            if (rowHeight === 0) {
                if (rowElements.length > 0) {
                    var totalHeight = 0;
                    var childCount = 0;
                    // Loop through all children and average the rowHeight's.
                    for (var childIndex = 0; childIndex < rowElements.length; childIndex++) {
                        var childHeight = _this.bodyElement.current.children[childIndex].getBoundingClientRect().height;
                        if (childHeight > 0) {
                            totalHeight += childHeight;
                            childCount++;
                        }
                    }
                    // Make sure we have at least one child row that has size.
                    if (childCount > 0) {
                        rowHeight = totalHeight / childCount;
                    }
                }
                if (rowHeight === 0) {
                    return;
                }
                // If we have a pending scrollIntoView we will schedule it now that we have the rowHeight
                if (_this.scrollToIndex !== -1) {
                    _this.setState({
                        firstMaterialized: Math.max(0, _this.scrollToIndex - _this.state.pageSize),
                        lastMaterialized: _this.scrollToIndex + Math.min(_this.props.initialPageCount * _this.state.pageSize, rowCount - 1),
                        rowHeight: rowHeight
                    });
                    return;
                }
                // console.log({ phase: "onIntersect - Compute RowHeight", rowHeight });
            }
            // Determine the location of the intersection within the page. This is the element
            // we are scrolling within.
            var intersectionRect = _this.context.root.getBoundingClientRect();
            // Track the first and last row elements for adjusting the range.
            var firstMaterializedElement;
            var lastMaterializedElement;
            var firstMaterializedUpdated = firstMaterialized;
            var lastMaterializedUpdated = lastMaterialized;
            var firstRenderedUpdated = lastMaterializedUpdated;
            var lastRenderedUpdated = firstMaterializedUpdated;
            // Go through the viewport pages and determine if any are out of range and should be
            // paged out. Range is defined as more than 1 page of estimated rows away from the
            // nearest edge. If you dont allow for 1 page of estimated rows it may thrash pages
            // in and out of materialization.
            for (var childIndex = 0; childIndex < rowElements.length; childIndex++) {
                // Determine if this child is in the viewport, ignore rows that are not.
                var rowElement = rowElements[childIndex];
                var rowIndex = getAttributeAsNumber(rowElement, "data-row-index");
                var rowRect = rowElement.getBoundingClientRect();
                if (rowIndex >= firstMaterialized && rowIndex <= lastMaterialized) {
                    // Make sure to leave some extra room above and below the visible rectangle to handle
                    // variable height rows. This helps prevent jittering when paging rows out.
                    if (rowRect.bottom < intersectionRect.top - _this.state.pageSize * rowHeight) {
                        firstMaterializedUpdated++;
                    }
                    else if (rowRect.top > intersectionRect.bottom + _this.state.pageSize * rowHeight) {
                        lastMaterializedUpdated--;
                    }
                    // We will save the first and last rows for later computations.
                    if (rowIndex === firstMaterialized) {
                        firstMaterializedElement = rowElement;
                    }
                    if (rowIndex === lastMaterialized) {
                        lastMaterializedElement = rowElement;
                    }
                }
                // If the row is within the intersection rect, update the first and last rendered rows. These might be the focused items
                if (rowIndex > -1 && rowRect.top < intersectionRect.bottom && rowRect.bottom > intersectionRect.top) {
                    lastRenderedUpdated = Math.max(lastRenderedUpdated, rowIndex);
                    firstRenderedUpdated = Math.min(firstRenderedUpdated, rowIndex);
                }
            }
            // When we are scaling the size of the list, we want to keep a pageSize worth of elements materiaized but not rendered.
            // This allows users to scroll a few items. If they quickly scroll past the last materialized element or drag the scroll wheel, we recalculate where we should be
            // instead of paging in rows.
            if (rowProportion < 1) {
                if (firstMaterializedUpdated > lastMaterializedUpdated ||
                    firstRenderedUpdated === firstMaterializedUpdated ||
                    lastRenderedUpdated === lastMaterializedUpdated) {
                    if (lastRenderedUpdated >= rowCount - 1) {
                        firstMaterializedUpdated = Math.ceil(lastMaterializedUpdated - (intersectionRect.height / rowHeight + _this.state.pageSize));
                    }
                    else {
                        var offsetTop = scrollTop - (_this.listElement.current.offsetTop - _this.context.root.offsetTop);
                        firstMaterializedUpdated = Math.max(0, Math.min(rowCount - 1, Math.floor(offsetTop / (rowProportion * rowHeight))) - _this.state.pageSize);
                        lastMaterializedUpdated = Math.min(rowCount - 1, firstMaterializedUpdated + Math.ceil(intersectionRect.height / rowHeight + _this.state.pageSize));
                        lastRenderedUpdated = -1;
                        firstRenderedUpdated = -1;
                    }
                }
                else {
                    firstMaterializedUpdated = Math.min(firstMaterializedUpdated, firstRenderedUpdated - _this.state.pageSize);
                    lastMaterializedUpdated = Math.max(lastMaterializedUpdated, lastRenderedUpdated + _this.state.pageSize);
                }
            }
            // If the row range is inverted (top above bottom) then all rows have been hidden and we should
            // recompute the viewport based on the scrollTop of our intersection and intersection height.
            else if (firstMaterializedUpdated > lastMaterializedUpdated) {
                var offsetTop = scrollTop - (_this.listElement.current.offsetTop - _this.context.root.offsetTop);
                firstMaterializedUpdated = Math.max(0, Math.min(rowCount - 1, Math.floor(offsetTop / rowHeight)) - _this.state.pageSize);
                lastMaterializedUpdated = Math.min(rowCount - 1, firstMaterializedUpdated + Math.ceil(intersectionRect.height / rowHeight + _this.state.pageSize));
                lastRenderedUpdated = -1;
                firstRenderedUpdated = -1;
            }
            else {
                // If the firstPage didn't move down, we may need more pages above.
                if (firstMaterializedUpdated === firstMaterialized && firstMaterializedElement) {
                    var rowRect = firstMaterializedElement.getBoundingClientRect();
                    var availableSpace = rowRect.top - intersectionRect.top;
                    if (availableSpace > 0) {
                        firstMaterializedUpdated -= Math.ceil(availableSpace / rowHeight);
                    }
                }
                // If the lastPage didn't move up, we may need more pages below.
                if (lastMaterializedUpdated === lastMaterialized && lastMaterializedElement) {
                    var rowRect = lastMaterializedElement.getBoundingClientRect();
                    var availableSpace = intersectionRect.bottom - rowRect.bottom;
                    if (availableSpace > 0) {
                        lastMaterializedUpdated += Math.ceil(availableSpace / rowHeight);
                    }
                }
            }
            // Make sure our page boundary stays in the available page range.
            firstMaterializedUpdated = Math.max(firstMaterializedUpdated, 0);
            lastMaterializedUpdated = Math.min(lastMaterializedUpdated, rowCount - 1);
            // console.log({ phase: "onIntersect - End", firstMaterializedUpdated, lastMaterializedUpdated, rowHeight });
            // Update our state if and only if something has changed.
            if (firstMaterializedUpdated !== firstMaterialized ||
                firstRenderedUpdated !== firstRendered ||
                lastMaterializedUpdated !== lastMaterialized ||
                lastRenderedUpdated !== lastRendered ||
                rowHeight !== _this.state.rowHeight ||
                scrollTop !== _this.state.scrollTop) {
                //
                // @TODO: We need to unload data for pages that are no longer rendererd.
                // This means not in the viewport or within any other rendered range.
                //
                // console.log({ phase: "onIntersect - stateChange", firstMaterializedUpdated, firstRenderedUpdated, lastRenderedUpdated, lastMaterializedUpdated, scrollTop });
                _this.setState({
                    firstMaterialized: firstMaterializedUpdated,
                    firstRendered: firstRenderedUpdated,
                    lastMaterialized: lastMaterializedUpdated,
                    lastRendered: lastRenderedUpdated,
                    rowHeight: rowHeight,
                    scrollTop: scrollTop
                });
            }
        };
        _this.onPointerDownBody = function (event) {
            // If the table body gets a mousedown, we will never need to fire the selection event when
            // the list gets focus since the mouse event will cause the selection.
            _this.selectOnFocus = false;
        };
        _this.getInitialTabbableRow = function () {
            var _a = _this.props, defaultTabbableRow = _a.defaultTabbableRow, itemProvider = _a.itemProvider, selection = _a.selection;
            if (defaultTabbableRow) {
                return defaultTabbableRow;
            }
            if (selection) {
                for (var i = 0; i < itemProvider.length; i++) {
                    if (selection.selectable(i)) {
                        return i;
                    }
                }
            }
            return 0;
        };
        _this.getHeight = function (rowIndex) {
            var height = 0;
            var rowHeights = _this.props.rowHeights || [];
            for (var i = 0; i < rowIndex - 1 && i < rowHeights.length; i++) {
                height += rowHeights[i];
            }
            return height;
        };
        var rowCount = props.itemProvider.length;
        var pageSize = props.pageSize;
        _this.state = {
            columnCount: 1,
            eventDispatch: props.eventDispatch || new _Utilities_Dispatch__WEBPACK_IMPORTED_MODULE_15__[/* EventDispatch */ "a"](),
            firstMaterialized: 0,
            firstRendered: 0,
            itemProvider: props.itemProvider,
            lastMaterialized: _this.props.virtualize ? Math.min(props.initialPageCount * pageSize, rowCount - 1) : rowCount - 1,
            lastRendered: _this.props.virtualize ? Math.min(props.initialPageCount * pageSize, rowCount - 1) : rowCount - 1,
            overlays: new _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableArray"](),
            pageSize: pageSize,
            renderedRows: {},
            rowCount: rowCount,
            rowHeight: props.rowHeight || 0,
            rowProportion: props.rowHeight && props.maxHeight ? Math.min(1, props.maxHeight / (props.rowHeight * rowCount)) : 1,
            rows: {},
            scrollTop: 0
        };
        // Initialize the supplied behaviors.
        if (props.behaviors) {
            for (var _i = 0, _a = props.behaviors; _i < _a.length; _i++) {
                var behavior = _a[_i];
                if (behavior.initialize) {
                    behavior.initialize(props, _this, _this.state.eventDispatch);
                }
            }
        }
        return _this;
    }
    List.getDerivedStateFromProps = function (props, state) {
        var rowCount = props.itemProvider.length;
        var firstMaterialized = state.firstMaterialized;
        var lastMaterialized = state.lastMaterialized;
        if (rowCount !== state.rowCount) {
            firstMaterialized = Math.max(0, Math.min(state.firstMaterialized, rowCount));
            lastMaterialized = props.virtualize
                ? Math.max(firstMaterialized, Math.min(state.lastMaterialized + (state.lastMaterialized === state.rowCount - 1 ? props.pageSize : 0), rowCount - 1))
                : rowCount - 1;
        }
        // Ensure out pages and providers are appropriately computed.
        var updatedState = {
            firstMaterialized: firstMaterialized,
            itemProvider: props.itemProvider,
            lastMaterialized: lastMaterialized,
            pageSize: props.pageSize,
            rowCount: rowCount,
            rowProportion: Math.min(1, (props.maxHeight || 100000) / (state.rowHeight * (rowCount - (lastMaterialized - firstMaterialized))))
        };
        // If there are changes to the props that affect the cached data, we need it clear it.
        if (props.itemProvider !== state.itemProvider || props.columnCount !== state.columnCount) {
            updatedState.columnCount = props.columnCount;
            updatedState.renderedRows = {};
            updatedState.rows = {};
        }
        // console.log(updatedState);
        return updatedState;
    };
    List.prototype.render = function () {
        var _this = this;
        var _a = this.props, ariaRowOffset = _a.ariaRowOffset, className = _a.className, focuszoneProps = _a.focuszoneProps, id = _a.id, maxWidth = _a.maxWidth, minWidth = _a.minWidth, width = _a.width;
        var _b = this.state, firstMaterialized = _b.firstMaterialized, lastMaterialized = _b.lastMaterialized, rowCount = _b.rowCount, rowProportion = _b.rowProportion;
        var focusIndex = this.focusIndex;
        var role = this.props.role ? this.props.role : this.props.selection ? "listbox" : "list";
        var useAriaCounts = role === "table" || role === "grid" || role === "treegrid";
        var rows = [];
        // Number of pages each spacer takes up. There are potentially two spacers above
        // or below the view port. They surround the focus range when the focus range is
        // not within the viewport.
        var topSpacer1 = 0;
        var topSpacer2 = firstMaterialized;
        var bottomSpacer2 = Math.max(0, rowCount - lastMaterialized - 1);
        var bottomSpacer1 = 0;
        var firstFocusRow = Number.MAX_SAFE_INTEGER;
        var lastFocusRow = 0;
        // Compute the range of focus pages, these will be either before or after the pages
        // in the viewport. We need to ensure we have one row before and one row after the
        // focus row to support arrowing up and down.
        if (focusIndex !== -1) {
            firstFocusRow = Math.max(0, focusIndex - 3);
            lastFocusRow = Math.min(rowCount, focusIndex + 3);
            // Make sure we dont draw any of the pages that are in the viewport.
            if (firstFocusRow < firstMaterialized) {
                lastFocusRow = Math.min(lastFocusRow, firstMaterialized - 1);
                topSpacer1 = firstFocusRow;
                topSpacer2 = firstMaterialized - lastFocusRow - 1;
            }
            else if (lastFocusRow > lastMaterialized) {
                firstFocusRow = Math.max(firstFocusRow, lastMaterialized + 1);
                bottomSpacer2 = firstFocusRow - lastMaterialized - 1;
                bottomSpacer1 = Math.max(0, rowCount - lastFocusRow - 1);
            }
        }
        if (rowProportion < 1) {
            // Ensure that the spacers leave room for 1 pageSize above the viewport
            topSpacer2 += Math.min(this.state.pageSize, firstMaterialized);
        }
        // console.log({ phase: "render", firstMaterialized, lastMaterialized, topSpacer1, topSpacer2, bottomSpacer2, bottomSpacer1 });
        rows.push(this.renderSpacer("st1", topSpacer1));
        // If the focus pages are before the viewport render them up to
        // the first page but not including the first page.
        if (firstFocusRow < firstMaterialized) {
            for (var rowIndex = firstFocusRow; rowIndex <= lastFocusRow; rowIndex++) {
                rows.push(this.renderRow(rowIndex));
            }
        }
        rows.push(this.renderSpacer("st2", topSpacer2));
        // Go through each of the rendered pages and generate the child component.
        for (var rowIndex = firstMaterialized; rowIndex <= lastMaterialized; rowIndex++) {
            rows.push(this.renderRow(rowIndex));
        }
        rows.push(this.renderSpacer("sb2", bottomSpacer2, true));
        // If the focus pages are after the last page in the viewport render
        // them but not including the last page.
        if (lastFocusRow > lastMaterialized) {
            for (var rowIndex = firstFocusRow; rowIndex <= lastFocusRow; rowIndex++) {
                rows.push(this.renderRow(rowIndex));
            }
        }
        rows.push(this.renderSpacer("sb1", bottomSpacer1, true));
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_12__["Observer"], { itemProvider: {
                // Supply an IObservableExpression to elevate the provider change to a state
                // update for the entire component instead of just the observer.
                filter: function (change, action) {
                    // Notify the selection about the change to the items.
                    if (_this.props.selection) {
                        _this.props.selection.onItemsChanged(change, action);
                    }
                    // @NOTE: For now we will just wipe out the entire cache, we can do an optimized
                    // update to the cache based on the rows that changed.
                    var updatedState = {
                        renderedRows: {},
                        rows: {}
                    };
                    // If the focused row was removed, we will clear the focus index.
                    if (change.removedItems && _this.focusIndex >= change.index && change.index + change.removedItems.length >= _this.focusIndex) {
                        _this.focusIndex = -1;
                    }
                    // If there is a well defined rowcount we will update it and the maxPage.
                    if (_this.state.rowCount !== -1) {
                        var countChange = (change.addedItems ? change.addedItems.length : 0) - (change.removedItems ? change.removedItems.length : 0);
                        if (countChange) {
                            updatedState.rowCount = _this.state.rowCount + countChange;
                            updatedState.firstMaterialized = Math.max(0, Math.min(_this.state.firstMaterialized, updatedState.rowCount - 1));
                            updatedState.lastMaterialized = _this.props.virtualize
                                ? Math.max(updatedState.firstMaterialized, Math.min(_this.state.lastMaterialized +
                                    (change.index >= _this.state.firstMaterialized && change.index <= _this.state.lastMaterialized + 1
                                        ? Math.min(_this.state.pageSize, countChange)
                                        : 0), updatedState.rowCount - 1))
                                : updatedState.rowCount - 1;
                        }
                    }
                    // console.log(updatedState);
                    _this.setState(updatedState);
                    return false;
                },
                observableValue: this.props.itemProvider
            } },
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusWithin__WEBPACK_IMPORTED_MODULE_7__["FocusWithin"], { onBlur: this.onBlur }, function (focusStatus) {
                // @TODO: Once we get the line-height: 20px in the body the body-m should be removed from the list.
                var list = (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("table", { "aria-colcount": useAriaCounts ? (_this.props.ariaColumnCount ? _this.props.ariaColumnCount : _this.props.columnCount) : undefined, "aria-label": _this.props.ariaLabel, "aria-rowcount": useAriaCounts ? _this.state.itemProvider.length + ariaRowOffset : undefined, className: Object(_Util__WEBPACK_IMPORTED_MODULE_14__["css"])(className, "bolt-list body-m relative", _this.props.showScroll ? undefined : "scroll-hidden"), id: Object(_Util__WEBPACK_IMPORTED_MODULE_14__["getSafeId"])(id), onBlur: focusStatus.onBlur, onClick: _this.onClick, onContextMenu: _this.onDispatch, onDoubleClick: _this.onDoubleClick, onDragEnd: _this.onDispatch, onDragEnter: _this.onDispatch, onDragExit: _this.onDispatch, onDragOver: _this.onDispatch, onDragStart: _this.onDispatch, onDrop: _this.onDispatch, onFocus: focusStatus.onFocus, onKeyDown: _this.onKeyDown, onKeyUp: _this.onDispatch, onPointerDown: _this.onDispatch, ref: _this.listElement, role: role, style: { maxWidth: maxWidth, minWidth: minWidth, width: width } },
                    _this.props.renderHeader && _this.props.renderHeader(),
                    react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("tbody", { className: "relative", onFocus: _this.onFocusBody, onPointerDown: _this.onPointerDownBody, ref: _this.bodyElement, role: role === "listbox" || role === "list" || role === "menu" ? "presentation" : undefined },
                        _this.renderOverlay(_this.listElement),
                        rows)));
                if (focuszoneProps) {
                    list = (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZone */ "a"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, focuszoneProps, { skipHiddenCheck: true }), list));
                }
                return list;
            })));
    };
    List.prototype.componentDidMount = function () {
        this.context.register(this.onIntersect);
    };
    List.prototype.componentDidUpdate = function () {
        var _a = this, scrollToIndex = _a.scrollToIndex, onScrollComplete = _a.onScrollComplete;
        if (scrollToIndex !== -1 && this.state.rowHeight) {
            var parentElement = this.bodyElement.current;
            var _b = this.state, firstMaterialized = _b.firstMaterialized, lastMaterialized = _b.lastMaterialized;
            // If the row is materialized, we will ensure it is in the viewport.
            if (scrollToIndex >= firstMaterialized && scrollToIndex <= lastMaterialized && parentElement) {
                for (var currentIndex = 0; currentIndex < parentElement.children.length; currentIndex++) {
                    var childElement = parentElement.children[currentIndex];
                    var cellDetails = cellFromElement(childElement);
                    if (cellDetails.rowIndex === scrollToIndex) {
                        childElement.scrollIntoView(this.scrollToOptions);
                        break;
                    }
                }
            }
            // Reset the scroll state before we notify the complete function, it may start a new scroll operation.
            this.onScrollComplete = undefined;
            this.scrollToIndex = -1;
            this.scrollToOptions = undefined;
            // Notify any pending scrollComplete method that scrolling has completed.
            if (onScrollComplete) {
                onScrollComplete(scrollToIndex);
            }
        }
    };
    List.prototype.componentWillUnmount = function () {
        this.context.unregister(this.onIntersect);
    };
    List.prototype.addOverlay = function (id, rowIndex, render, zIndex) {
        if (zIndex === void 0) { zIndex = 0; }
        var overlays = this.state.overlays;
        var overlayIndex = overlays.value.findIndex(function (overlay) { return overlay.id === id; });
        var rowOverlay = { render: render, id: id, rowIndex: rowIndex, zIndex: zIndex + 1 };
        // Update the overlay if it exists for that id, otherwise add it
        if (overlayIndex >= 0) {
            overlays.change(overlayIndex, rowOverlay);
        }
        else {
            overlays.push(rowOverlay);
        }
    };
    List.prototype.removeOverlay = function (id) {
        var overlays = this.state.overlays;
        var overlayIndex = overlays.value.findIndex(function (overlay) { return overlay.id === id; });
        // Remove the overlay if it exists.
        if (overlayIndex >= 0) {
            overlays.splice(overlayIndex, 1);
        }
    };
    List.prototype.getFocusIndex = function () {
        return this.focusIndex;
    };
    List.prototype.getStats = function () {
        return {
            firstMaterialized: this.state.firstMaterialized,
            firstRendered: this.state.firstRendered,
            lastMaterialized: this.state.lastMaterialized,
            lastRendered: this.state.lastRendered
        };
    };
    List.prototype.scrollIntoView = function (rowIndex, options, onScrollComplete) {
        var _a = this.state, firstMaterialized = _a.firstMaterialized, lastMaterialized = _a.lastMaterialized, pageSize = _a.pageSize, rowCount = _a.rowCount, rowHeight = _a.rowHeight, rowProportion = _a.rowProportion;
        if (rowIndex >= 0 && rowIndex < this.state.rowCount) {
            var parentElement = this.bodyElement.current;
            // If the row is materialized, we will ensure it is in the viewport.
            if (rowIndex >= firstMaterialized && rowIndex <= lastMaterialized && parentElement) {
                for (var currentIndex = 0; currentIndex < parentElement.children.length; currentIndex++) {
                    var childElement = parentElement.children[currentIndex];
                    var cellDetails = cellFromElement(childElement);
                    if (cellDetails.rowIndex === rowIndex) {
                        childElement.scrollIntoView(options);
                        break;
                    }
                }
                // If the caller wants to know when the scroll has completed, notify them.
                if (onScrollComplete) {
                    onScrollComplete(rowIndex);
                }
            }
            else {
                // We only notify the last caller for now, if someone was waiting and another
                // scroll request was made we will send -1 as the rowIndex scrolled into view.
                if (this.onScrollComplete) {
                    this.onScrollComplete(-1);
                }
                // Set the scrollToOptions that will be applied after the next update.
                this.onScrollComplete = onScrollComplete;
                this.scrollToIndex = rowIndex;
                this.scrollToOptions = options;
                // We need to add some padding when we grow proportionally, since the spacers do not fill up enough room if
                // the list starts in the middle of the scrollable region
                var padding = rowProportion < 1 ? pageSize : 0;
                // If we havent computed the rowHeight at this point we need to wait until
                // we know how big rows are to get the row in the right location.
                if (rowHeight) {
                    this.setState({
                        firstMaterialized: Math.max(0, rowIndex - padding),
                        lastMaterialized: Math.min(rowCount - 1, rowIndex + padding)
                    });
                }
            }
        }
    };
    List.prototype.focusRow = function (rowIndex, direction) {
        var _this = this;
        if (direction === void 0) { direction = 1; }
        return new Promise(function (resolve) {
            _this.scrollIntoView(rowIndex, { block: "center" }, function (completedIndex) {
                if (completedIndex === rowIndex && _this.bodyElement.current) {
                    var rowElement = _this.bodyElement.current.querySelector("[data-row-index='" + completedIndex + "']");
                    if (rowElement) {
                        // We need to ensure the requested row is focusable, if not we will move in the
                        // requested direction to find the first focusable row.
                        if (!rowElement.getAttribute("tabindex")) {
                            var newIndex = Math.min(_this.state.rowCount - 1, Math.max(0, completedIndex + direction));
                            if (newIndex !== completedIndex) {
                                _this.focusRow(newIndex, direction);
                            }
                            else if (newIndex !== _this.focusIndex) {
                                _this.focusRow(newIndex, -direction);
                            }
                        }
                        else {
                            rowElement.focus();
                        }
                    }
                }
                resolve();
            });
        });
    };
    List.prototype.processSelectionEvent = function (event, listRow) {
        var _a = this.props, selection = _a.selection, enforceSingleSelect = _a.enforceSingleSelect;
        if (!selection || selection.selectable(listRow.index)) {
            if (selection) {
                var index = listRow.index;
                var multiSelect = enforceSingleSelect ? false : selection.multiSelect;
                // Determine the type of change being made to the selection based on key states.
                if (this.pivotIndex >= 0 && event.shiftKey && multiSelect) {
                    selection.select(Math.min(this.pivotIndex, index), Math.abs(this.pivotIndex - index) + 1, event.ctrlKey || event.metaKey, multiSelect);
                }
                else {
                    var isSpaceBarStroke = event.which === _Util__WEBPACK_IMPORTED_MODULE_14__["KeyCode"].space;
                    if ((event.ctrlKey || event.metaKey || selection.alwaysMerge || isSpaceBarStroke) && multiSelect) {
                        selection.toggle(index, true, multiSelect);
                    }
                    else {
                        selection.select(index, 1, false, multiSelect);
                    }
                }
                // Save the last selectionIndex that we selected, this will allow
                // us to perform range based selection.
                if (!event.shiftKey) {
                    this.pivotIndex = index;
                }
            }
            this.rowSelected(event, listRow);
        }
    };
    List.prototype.renderLoadingRow = function (rowIndex, details) {
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](ListItem, { className: "bolt-list-row-loading", details: details, index: rowIndex },
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "shimmer shimmer-line", style: { width: Math.random() * 80 + 20 + "%" } }, "\u00A0")));
    };
    List.prototype.renderOverlay = function (listElementRef) {
        var _this = this;
        var _a = this.state, firstMaterialized = _a.firstMaterialized, lastMaterialized = _a.lastMaterialized, overlays = _a.overlays;
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_12__["Observer"], { overlays: overlays }, function (props) {
            var bodyElement = _this.bodyElement.current;
            if (props.overlays.length > 0 && bodyElement) {
                return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-list-overlay-container absolute" }, props.overlays.map(function (overlay) {
                    // Make sure the row is in the rendered range of rows before starting.
                    if (overlay.rowIndex < firstMaterialized || overlay.rowIndex > lastMaterialized) {
                        return null;
                    }
                    // Find the row for the given rowIndex
                    var rowElement = listElementRef.current &&
                        listElementRef.current.querySelector("[data-row-index='" + overlay.rowIndex + "']");
                    // We cant render the overlay if the row is paged out since we can't determine
                    // the location of the row.
                    if (rowElement) {
                        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-list-overlay flex-row absolute", id: Object(_Util__WEBPACK_IMPORTED_MODULE_14__["getSafeId"])(overlay.id), key: overlay.id, style: {
                                height: rowElement.offsetHeight,
                                top: rowElement.getBoundingClientRect().top - bodyElement.getBoundingClientRect().top,
                                zIndex: overlay.zIndex * 10
                            } }, overlay.render({ rowElement: rowElement })));
                    }
                    return null;
                })));
            }
            return null;
        }));
    };
    List.prototype.renderRow = function (rowIndex) {
        var _this = this;
        var itemProvider = this.props.itemProvider;
        var _a = this.state, renderedRows = _a.renderedRows, rows = _a.rows;
        var renderedRow = renderedRows[rowIndex];
        if (!renderedRow) {
            var item_1 = rows[rowIndex];
            if (!item_1) {
                if (itemProvider.getItem) {
                    item_1 = itemProvider.getItem(rowIndex);
                }
                else {
                    item_1 = itemProvider.value[rowIndex];
                }
            }
            // @TODO: If there are no more rows, we need to handle an itemProvider with -1 length.
            if (!item_1) {
                return null;
            }
            // Save the current item in the item cache.
            rows[rowIndex] = item_1;
            var selection = this.props.selection;
            var selectionObservable = void 0;
            if (selection) {
                selectionObservable = {
                    observableValue: selection,
                    filter: function (selectedRanges) {
                        for (var _i = 0, selectedRanges_1 = selectedRanges; _i < selectedRanges_1.length; _i++) {
                            var selectionRange = selectedRanges_1[_i];
                            if (rowIndex >= selectionRange.beginIndex && rowIndex <= selectionRange.endIndex) {
                                return true;
                            }
                        }
                        return false;
                    }
                };
            }
            // console.log("render row - " + rowIndex);
            // Render the row, save it in the cache, and add it to the current page.
            renderedRow = (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_12__["Observer"], { item: item_1, key: rowIndex, selection: selectionObservable }, function (props) {
                var _a = _this.props, selectableText = _a.selectableText, renderRow = _a.renderRow, renderLoadingRow = _a.renderLoadingRow;
                var focusIndex = _this.focusIndex;
                var tabbableIndex = focusIndex >= 0 ? focusIndex : _this.getInitialTabbableRow();
                var rowItem = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(item_1);
                var itemDetails = {
                    selectableText: selectableText,
                    ariaBusy: !props.item,
                    ariaRowOffset: _this.props.ariaRowOffset + 1,
                    data: rowItem,
                    eventDispatch: _this.state.eventDispatch,
                    excludeTabStop: tabbableIndex !== rowIndex,
                    listProps: _this.props,
                    onFocusItem: _this.onFocusItem,
                    singleClickActivation: _this.props.onActivate && _this.props.singleClickActivation
                };
                if (props.item) {
                    return renderRow(rowIndex, props.item, itemDetails);
                }
                else if (renderLoadingRow) {
                    return renderLoadingRow(rowIndex, itemDetails);
                }
                else {
                    return _this.renderLoadingRow(rowIndex, itemDetails);
                }
            }));
            // Save the row in our cache.
            this.state.renderedRows[rowIndex] = renderedRow;
        }
        return renderedRow;
    };
    List.prototype.renderSpacer = function (key, rowCount, estimateRowHeight) {
        var _this = this;
        var height = !estimateRowHeight && this.props.rowHeights ? this.getHeight(rowCount) : rowCount * this.state.rowHeight * this.state.rowProportion;
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("tr", { "aria-hidden": "true", className: "bolt-list-row-spacer invisible", key: key, ref: function (spacerElement) {
                var existingElement = _this.spacerElements[key];
                if (spacerElement) {
                    if (existingElement !== spacerElement) {
                        if (existingElement) {
                            _this.context.unobserve(spacerElement);
                        }
                        _this.context.observe(spacerElement);
                        _this.spacerElements[key] = spacerElement;
                    }
                }
                else if (existingElement) {
                    _this.context.unobserve(existingElement);
                    delete _this.spacerElements[key];
                }
            }, role: "presentation" },
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("td", { className: "bolt-list-cell-spacer invisible", colSpan: this.props.columnCount, style: { height: height + "px" } })));
    };
    List.prototype.rowActivated = function (event, listRow) {
        this.state.eventDispatch.dispatchEvent(event, listRow, "activate");
        if (this.props.onActivate) {
            this.props.onActivate(event, listRow);
        }
    };
    List.prototype.rowSelected = function (event, listRow) {
        this.state.eventDispatch.dispatchEvent(event, listRow, "select");
        if (this.props.onSelect) {
            this.props.onSelect(event, listRow);
        }
    };
    List.prototype.rowFocused = function (event, listRow) {
        this.state.eventDispatch.dispatchEvent(event, listRow, "focus");
        if (this.props.onFocus) {
            this.props.onFocus(event, listRow);
        }
    };
    List.contextType = _Intersection__WEBPACK_IMPORTED_MODULE_10__["IntersectionContext"];
    List.defaultProps = {
        ariaRowOffset: 0,
        columnCount: 1,
        focuszoneProps: { direction: _FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZoneDirection */ "c"].Vertical },
        initialPageCount: 3,
        maxHeight: 100000,
        pageSize: 10,
        singleClickActivation: false,
        selectRowOnClick: true,
        virtualize: true
    };
    return List;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));

var ScrollableList = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(ScrollableList, _super);
    function ScrollableList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.list = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.scrollableElement = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        return _this;
    }
    ScrollableList.prototype.render = function () {
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Intersection__WEBPACK_IMPORTED_MODULE_10__["Intersection"], { rootMargin: window.innerHeight / 2 },
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { ref: this.scrollableElement, onScroll: this.props.onScroll, className: Object(_Util__WEBPACK_IMPORTED_MODULE_14__["css"])(this.props.outerClassName, "flex-grow", "scroll-auto") },
                react__WEBPACK_IMPORTED_MODULE_5__["createElement"](List, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.props, { ref: this.list })))));
    };
    ScrollableList.prototype.addOverlay = function (id, rowIndex, render, zIndex) {
        if (zIndex === void 0) { zIndex = 0; }
        if (this.list.current) {
            return this.list.current.addOverlay(id, rowIndex, render, zIndex);
        }
    };
    ScrollableList.prototype.getStats = function () {
        if (this.list.current) {
            return this.list.current.getStats();
        }
        return {
            firstMaterialized: -1,
            firstRendered: -1,
            lastMaterialized: -1,
            lastRendered: -1
        };
    };
    ScrollableList.prototype.removeOverlay = function (id) {
        if (this.list.current) {
            return this.list.current.removeOverlay(id);
        }
    };
    ScrollableList.prototype.focusRow = function (rowIndex, direction) {
        if (direction === void 0) { direction = 1; }
        if (this.list.current) {
            return this.list.current.focusRow(rowIndex, direction);
        }
        else {
            return Promise.resolve();
        }
    };
    ScrollableList.prototype.getFocusIndex = function () {
        if (this.list.current) {
            return this.list.current.getFocusIndex();
        }
        return -1;
    };
    ScrollableList.prototype.scrollIntoView = function (rowIndex, scrollToOptions) {
        if (this.list.current) {
            return this.list.current.scrollIntoView(rowIndex, scrollToOptions);
        }
    };
    ScrollableList.prototype.scrollTo = function (scrollTop) {
        if (this.scrollableElement.current) {
            this.scrollableElement.current.scrollTop = scrollTop;
        }
    };
    return ScrollableList;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));

var SimpleList = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(SimpleList, _super);
    function SimpleList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.list = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.renderListItem = function (rowIndex, listCell, details) {
            return renderListItem(rowIndex, details, renderListCell(listCell));
        };
        return _this;
    }
    SimpleList.prototype.render = function () {
        var listProps = {
            selectableText: this.props.selectableText,
            className: this.props.className,
            columnCount: 1,
            eventDispatch: this.props.eventDispatch,
            focuszoneProps: this.props.focuszoneProps,
            id: this.props.id,
            initialPageCount: this.props.initialPageCount,
            itemProvider: this.props.itemProvider,
            maxHeight: this.props.maxHeight,
            onActivate: this.props.onActivate,
            onFocus: this.props.onFocus,
            onSelect: this.props.onSelect,
            pageSize: this.props.pageSize,
            renderRow: this.renderListItem,
            selection: this.props.selection,
            width: this.props.width,
            virtualize: this.props.virtualize
        };
        if (this.props.scrollable) {
            return react__WEBPACK_IMPORTED_MODULE_5__["createElement"](ScrollableList, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, listProps, { ref: this.list }));
        }
        else {
            return react__WEBPACK_IMPORTED_MODULE_5__["createElement"](List, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, listProps, { ref: this.list }));
        }
    };
    SimpleList.prototype.addOverlay = function (id, rowIndex, render, zIndex) {
        if (zIndex === void 0) { zIndex = 0; }
        if (this.list.current) {
            return this.list.current.addOverlay(id, rowIndex, render, zIndex);
        }
    };
    SimpleList.prototype.removeOverlay = function (id) {
        if (this.list.current) {
            return this.list.current.removeOverlay(id);
        }
    };
    SimpleList.prototype.focusRow = function (rowIndex, direction) {
        if (direction === void 0) { direction = 1; }
        if (this.list.current) {
            return this.list.current.focusRow(rowIndex, direction);
        }
        else {
            return Promise.resolve();
        }
    };
    SimpleList.prototype.getFocusIndex = function () {
        if (this.list.current) {
            return this.list.current.getFocusIndex();
        }
        return -1;
    };
    SimpleList.prototype.getStats = function () {
        if (this.list.current) {
            return this.list.current.getStats();
        }
        return {
            firstMaterialized: -1,
            firstRendered: -1,
            lastMaterialized: -1,
            lastRendered: -1
        };
    };
    SimpleList.prototype.scrollIntoView = function (rowIndex, scrollToOptions) {
        if (this.list.current) {
            return this.list.current.scrollIntoView(rowIndex, scrollToOptions);
        }
    };
    return SimpleList;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));

function renderListItem(rowIndex, details, children) {
    return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](ListItem, { details: details, index: rowIndex }, children));
}
function ListItem(props) {
    var onFocus = function (event) {
        props.details.onFocusItem(props.index, event);
    };
    var children = props.children, details = props.details, index = props.index, linkProps = props.linkProps;
    var selectableText = details.selectableText, ariaBusy = details.ariaBusy, ariaDescribedBy = details.ariaDescribedBy, ariaLabel = details.ariaLabel, ariaPosInSet = details.ariaPosInSet, ariaSetSize = details.ariaSetSize, excludeFocusZone = details.excludeFocusZone;
    var _a = details.listProps, selection = _a.selection, singleClickActivation = _a.singleClickActivation;
    return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusWithin__WEBPACK_IMPORTED_MODULE_7__["FocusWithin"], { onFocus: onFocus }, function (focusStatus) { return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZoneContext */ "b"].Consumer, null, function (rowContext) {
        var rowProps = {
            "aria-busy": ariaBusy,
            "aria-describedby": ariaDescribedBy,
            "aria-label": ariaLabel,
            "aria-posinset": ariaPosInSet === undefined ? index + 1 : ariaPosInSet === null ? undefined : ariaPosInSet,
            "aria-selected": selection && selection.selected(index),
            "aria-setsize": ariaSetSize === undefined
                ? props.details.listProps.itemProvider.length
                : ariaSetSize === null
                    ? undefined
                    : ariaSetSize,
            className: Object(_Util__WEBPACK_IMPORTED_MODULE_14__["css"])(props.className, "bolt-list-row", index === 0 && "first-row", linkProps && "bolt-link", selection && selection.selected(index) && "selected", focusStatus.hasFocus && "focused", singleClickActivation && "single-click-activation", selectableText && "selectable-text"),
            "data-focuszone": excludeFocusZone || (selection && !selection.selectable(index)) ? undefined : rowContext.focuszoneId,
            "data-row-index": index,
            tabIndex: Object(_Utilities_Focus__WEBPACK_IMPORTED_MODULE_16__[/* getTabIndex */ "a"])(details),
            onBlur: focusStatus.onBlur,
            onFocus: focusStatus.onFocus,
            role: selection ? "option" : "listitem"
        };
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZone */ "a"], { direction: _FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZoneDirection */ "c"].Horizontal }, linkProps ? (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("a", Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, Object(_Link__WEBPACK_IMPORTED_MODULE_11__["getDefaultLinkProps"])(linkProps), rowProps),
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-list-cell", "data-column-index": 0 },
                react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-list-cell-content flex-row" }, children)))) : (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("tr", Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, rowProps),
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("td", { className: "bolt-list-cell", "data-column-index": 0 },
                react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-list-cell-content flex-row" }, children))))));
    })); }));
}
function renderListCell(listCell, showOverflowTooltip) {
    if (showOverflowTooltip === void 0) { showOverflowTooltip = true; }
    var textClassName = undefined;
    var textContent = (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("span", { className: "text-ellipsis body-m" }, typeof listCell === "string" || typeof listCell === "number" ? listCell : listCell.textNode ? listCell.textNode : listCell.text));
    if (showOverflowTooltip) {
        textContent = react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_TooltipEx__WEBPACK_IMPORTED_MODULE_13__["Tooltip"], { overflowOnly: true }, textContent);
    }
    var content = textContent;
    var classNames = Object(_Util__WEBPACK_IMPORTED_MODULE_14__["css"])("bolt-list-cell-child flex-row flex-center");
    if (typeof listCell !== "string" && typeof listCell !== "number") {
        textClassName = listCell.textClassName;
        if (listCell.iconProps) {
            content = (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](react__WEBPACK_IMPORTED_MODULE_5__["Fragment"], null,
                Object(_Icon__WEBPACK_IMPORTED_MODULE_9__["Icon"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, listCell.iconProps), { className: Object(_Util__WEBPACK_IMPORTED_MODULE_14__["css"])("icon-margin", listCell.iconProps.className) })),
                textContent));
        }
        if (listCell.href) {
            return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Link__WEBPACK_IMPORTED_MODULE_11__["Link"], { className: Object(_Util__WEBPACK_IMPORTED_MODULE_14__["css"])(textClassName, classNames, "scroll-hidden"), href: listCell.href, rel: listCell.hrefRel, target: listCell.hrefTarget, excludeTabStop: true, subtle: true }, content));
        }
    }
    return react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("span", { className: Object(_Util__WEBPACK_IMPORTED_MODULE_14__["css"])(textClassName, classNames, "bolt-list-cell-text") }, content);
}
function getAttributeAsNumber(element, attributeName) {
    var attributeValue = element.getAttribute(attributeName);
    if (attributeValue) {
        return parseInt(attributeValue, 10);
    }
    return -1;
}
function cellFromElement(element) {
    var attributeValue;
    var cellIndex = -1;
    var rowIndex = -1;
    var cellElement = null;
    while (element) {
        attributeValue = getAttributeAsNumber(element, "data-column-index");
        if (attributeValue !== -1) {
            cellIndex = attributeValue;
            cellElement = element;
        }
        attributeValue = getAttributeAsNumber(element, "data-row-index");
        if (attributeValue !== -1) {
            rowIndex = attributeValue;
            break;
        }
        // We have hit the root of the details list, dont look above this.
        if (element.classList.contains("bolt-list")) {
            element = null;
            break;
        }
        element = element.parentElement;
    }
    return {
        cellElement: cellElement,
        cellIndex: cellIndex,
        rowElement: element,
        rowIndex: rowIndex
    };
}
function cellFromEvent(event) {
    return cellFromElement(event.target);
}


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrayItemProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getItemsValue; });
/**
 * Basic ItemProvider that surfaces an array of items through the IItemProvider
 * interface.
 */
var ArrayItemProvider = /** @class */ (function () {
    function ArrayItemProvider(items) {
        this.items = items;
    }
    Object.defineProperty(ArrayItemProvider.prototype, "length", {
        get: function () {
            return this.items.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArrayItemProvider.prototype, "value", {
        get: function () {
            return this.items;
        },
        enumerable: true,
        configurable: true
    });
    return ArrayItemProvider;
}());

/**
 * Helper function to get the value of a set of items that can be an itemProvider or normal array.
 * @param items the items to retrieve the value from.
 */
function getItemsValue(items) {
    return Array.isArray(items) ? items : items.value;
}


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(384);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(386);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4);





/**
 * Handles subscription to properties that are IObservableValues, so that components don't have to handle on their own.
 *
 * Usage:
 *
 * <Observer myObservableValue={observableValue} className='foo'>
 *     <MyComponent myObservableValue='' />
 * </Observer>
 *
 * Your component will get re-rendered with the new value of myObservableValue whenever that value changes.
 * Additionally, any additional props set on the Observer will also get passed down.
 */
var Observer = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(Observer, _super);
    function Observer(props) {
        var _this = _super.call(this, props) || this;
        _this.subscriptions = {};
        // Initialize the state with the initial value of the observable.
        var state = { values: {}, oldProps: {} };
        for (var propName in props) {
            state.values[propName] = getPropValue(props[propName]);
        }
        _this.state = state;
        return _this;
    }
    Observer.getDerivedStateFromProps = function (props, state) {
        var newState = updateSubscriptionsAndState(state.oldProps, props, state);
        if (newState != null) {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, newState), { oldProps: props });
        }
        return { oldProps: props };
    };
    Observer.prototype.render = function () {
        var newProps = {};
        // Copy over any properties from the observable component to the children.
        for (var key in this.state.values) {
            if (key !== "children") {
                newProps[key] = this.state.values[key];
            }
        }
        if (typeof this.props.children === "function") {
            var child = this.props.children;
            return child(newProps);
        }
        else {
            var child = react__WEBPACK_IMPORTED_MODULE_3__["Children"].only(this.props.children);
            return react__WEBPACK_IMPORTED_MODULE_3__["cloneElement"](child, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, child.props), newProps), child.props.children);
        }
    };
    Observer.prototype.componentDidMount = function () {
        this.updateSubscriptionsAndStateAfterRender();
    };
    Observer.prototype.componentDidUpdate = function () {
        this.updateSubscriptionsAndStateAfterRender();
        if (this.props.onUpdate) {
            this.props.onUpdate();
        }
    };
    Observer.prototype.componentWillUnmount = function () {
        // Unsubscribe from any of the observable properties.
        for (var propName in this.subscribedProps) {
            this.unsubscribe(propName, this.subscribedProps);
        }
    };
    Observer.prototype.subscribe = function (propName, props) {
        if (propName !== "children") {
            var observableExpression = void 0;
            var observableValue = props[propName];
            var action = void 0;
            // If this is an observableExpression, we need to subscribe to the value
            // and execute the filter on changes.
            if (observableValue && observableValue.observableValue !== undefined) {
                observableExpression = observableValue;
                observableValue = observableExpression.observableValue;
                action = observableExpression.action;
            }
            if (_Core_Observable__WEBPACK_IMPORTED_MODULE_4__["ObservableLike"].isObservable(observableValue)) {
                var delegate = this.onValueChanged.bind(this, propName, observableValue, observableExpression);
                _Core_Observable__WEBPACK_IMPORTED_MODULE_4__["ObservableLike"].subscribe(observableValue, delegate, action);
                this.subscriptions[propName] = { delegate: delegate, action: action };
            }
        }
    };
    Observer.prototype.unsubscribe = function (propName, props) {
        if (propName !== "children") {
            var observableValue = getObservableValue(props[propName]);
            if (_Core_Observable__WEBPACK_IMPORTED_MODULE_4__["ObservableLike"].isObservable(observableValue)) {
                var subscription = this.subscriptions[propName];
                _Core_Observable__WEBPACK_IMPORTED_MODULE_4__["ObservableLike"].unsubscribe(observableValue, subscription.delegate, subscription.action);
                delete this.subscriptions[propName];
            }
        }
    };
    Observer.prototype.updateSubscriptionsAndStateAfterRender = function () {
        var newState = updateSubscriptionsAndState(this.subscribedProps, this.props, this.state, this);
        if (newState != null) {
            this.setState(newState);
        }
        this.subscribedProps = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.props);
    };
    Observer.prototype.onValueChanged = function (propName, observableValue, observableExpression, value, action) {
        var setState = true;
        if (!(propName in this.subscriptions)) {
            return;
        }
        // If this is an ObservableExpression we will call the filter before setting state.
        if (observableExpression && observableExpression.filter) {
            setState = observableExpression.filter(value, action);
        }
        if (setState) {
            this.setState(function (prevState, props) {
                var _a;
                return {
                    values: Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, prevState.values), (_a = {}, _a[propName] = observableValue.value || value, _a))
                };
            });
        }
    };
    return Observer;
}(react__WEBPACK_IMPORTED_MODULE_3__["Component"]));

function getObservableValue(propValue) {
    if (propValue && propValue.observableValue !== undefined) {
        return propValue.observableValue;
    }
    return propValue;
}
function getPropValue(propValue) {
    return _Core_Observable__WEBPACK_IMPORTED_MODULE_4__["ObservableLike"].getValue(getObservableValue(propValue));
}
function updateSubscriptionsAndState(oldProps, newProps, state, component) {
    // We need to unsubscribe from any observable values on old props and
    // subscribe to any observable values on new props.
    // In addition, if any of the values of the observables on the new props
    // differ from the value on the state, then we need to update the state.
    // This is possible if the value of the observable changed while the value
    // was being rendered, but before we had set up the subscription.
    // If we want to unsubscribe/resubscribe, then a component should be passed,
    // since this method is always called statically.
    var newState = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, state);
    var stateChanged = false;
    if (oldProps) {
        for (var propName in oldProps) {
            var oldValue = getObservableValue(oldProps[propName]);
            var newValue = getObservableValue(newProps[propName]);
            if (oldValue !== newValue) {
                component && component.unsubscribe(propName, oldProps);
                if (newValue === undefined) {
                    delete newState.values[propName];
                    stateChanged = true;
                }
            }
        }
    }
    for (var propName in newProps) {
        var oldValue = oldProps && getObservableValue(oldProps[propName]);
        var newValue = getObservableValue(newProps[propName]);
        if (oldValue !== newValue) {
            component && component.subscribe(propName, newProps);
            // Look for changes in the observables between creation and now.
            if (state.values[propName] !== getPropValue(newValue)) {
                newState.values[propName] = getPropValue(newValue);
                stateChanged = true;
            }
        }
    }
    // If any state updates occurred update the state now.
    if (stateChanged) {
        return newState;
    }
    return null;
}


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimerManagement; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

/**
 * The TimerManagement class is used to track a set of timers.
 */
var TimerManagement = /** @class */ (function () {
    function TimerManagement(parent) {
        this.disposed = false;
        this.immediateIds = null;
        this.intervals = [];
        this.timeouts = [];
        this.parent = parent || null;
    }
    /**
     * clearAllTimers is used to clear any active timers in the object.
     */
    TimerManagement.prototype.clearAllTimers = function () {
        for (var _i = 0, _a = this.intervals; _i < _a.length; _i++) {
            var intervalId = _a[_i];
            window.clearInterval(intervalId);
        }
        for (var _b = 0, _c = this.timeouts; _b < _c.length; _b++) {
            var timeoutId = _c[_b];
            window.clearTimeout(timeoutId);
        }
        this.intervals.splice(0, this.intervals.length);
        this.timeouts.splice(0, this.timeouts.length);
    };
    /**
     * Clears the immediate.
     * @param id - Id to cancel.
     */
    TimerManagement.prototype.clearImmediate = function (id) {
        if (this.immediateIds && this.immediateIds[id]) {
            window.clearTimeout(id);
            delete this.immediateIds[id];
        }
    };
    /**
     * clearInterval is used to stop the series of callbacks that was setup through setInterval.
     *
     * @param intervalId - The id returned from eh setInterval call that you want stopped.
     */
    TimerManagement.prototype.clearInterval = function (intervalId) {
        window.clearInterval(intervalId);
        this.removeInterval(intervalId);
    };
    /**
     * clearTimeout is used to stop a timeout callback that was setup through setTimeout.
     *
     * @param timeoutId - The id returned from the setTimeout call that you want stopped.
     */
    TimerManagement.prototype.clearTimeout = function (timeoutId) {
        window.clearTimeout(timeoutId);
        this.removeTimeout(timeoutId);
    };
    /**
     * SetImmediate override, which will auto cancel the immediate during dispose.
     * @param callback - Callback to execute.
     * @returns The setTimeout id.
     */
    TimerManagement.prototype.setImmediate = function (callback) {
        var _this = this;
        var immediateId = 0;
        if (!this.disposed) {
            if (!this.immediateIds) {
                this.immediateIds = {};
            }
            var setImmediateCallback = function () {
                // Time to execute the timeout, enqueue it as a foreground task to be executed.
                try {
                    // Now delete the record and call the callback.
                    if (_this.immediateIds) {
                        delete _this.immediateIds[immediateId];
                    }
                    callback.apply(_this.parent);
                }
                catch (e) { }
            };
            immediateId = window.setTimeout(setImmediateCallback, 0);
            this.immediateIds[immediateId] = true;
        }
        return immediateId;
    };
    /**
     * setInterval is used to setup a callback that is called on an interval.
     *
     * @param callback - The callback that should be called each interval time period.
     *
     * @param milliseconds - The number of milliseconds between each callback.
     *
     * @param args - Optional variable argument list passed to the callback.
     *
     * @returns - returns a handle to the interval, this can be used to cancel through clearInterval method.
     */
    TimerManagement.prototype.setInterval = function (callback, milliseconds) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        // Create the timer, and add a method to track the completion so we can
        // remove our tracked reference.
        var intervalId = window.setInterval.apply(window, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])([callback, milliseconds], args));
        this.intervals.push(intervalId);
        return intervalId;
    };
    /**
     * setTimeout is used to setup a onetime callback that is called after the specified timeout.
     *
     * @param callback - The callback that should be called when the time period has elapsed.
     *
     * @param milliseconds - The number of milliseconds before the callback should be called.
     *  Even if a timeout of 0 is used the callback will be executed asynchronouly.
     *
     * @param args - Optional variable argument list passed to the callback.
     *
     * @returns - returns a handle to the timeout, this can be used to cancel through clearTimeout method.
     */
    TimerManagement.prototype.setTimeout = function (callback, milliseconds) {
        var _this = this;
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var timeoutId = 0;
        // Create the timer, and add a method to track the completion so we can
        // remove our tracked reference.
        timeoutId = window.setTimeout.apply(window, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])([function () {
                _this.removeTimeout(timeoutId);
                callback.apply(void 0, args);
            },
            milliseconds], args));
        this.timeouts.push(timeoutId);
        return timeoutId;
    };
    TimerManagement.prototype.dispose = function () {
        this.disposed = true;
        this.parent = null;
        this.clearAllTimers();
        // Clear immediates.
        if (this.immediateIds) {
            for (var id in this.immediateIds) {
                if (this.immediateIds.hasOwnProperty(id)) {
                    this.clearImmediate(parseInt(id, 10));
                }
            }
        }
        this.immediateIds = null;
    };
    /**
     * Creates a function that will delay the execution of func until after wait milliseconds have
     * elapsed since the last time it was invoked. Provide an options object to indicate that func
     * should be invoked on the leading and/or trailing edge of the wait timeout. Subsequent calls
     * to the debounced function will return the result of the last func call.
     *
     * Note: If leading and trailing options are true func will be called on the trailing edge of
     * the timeout only if the the debounced function is invoked more than once during the wait
     * timeout.
     *
     * @param func - The function to debounce.
     * @param wait - The number of milliseconds to delay.
     * @param options - The options object.
     * @returns The new debounced function.
     */
    TimerManagement.prototype.debounce = function (func, wait, options) {
        var _this = this;
        if (this.disposed) {
            var noOpFunction = (function () {
                /** Do nothing */
            });
            noOpFunction.cancel = function () {
                return;
            };
            noOpFunction.flush = (function () { return null; });
            noOpFunction.pending = function () { return false; };
            return noOpFunction;
        }
        var waitMS = wait || 0;
        var leading = false;
        var trailing = true;
        var maxWait = null;
        var lastCallTime = 0;
        var lastExecuteTime = new Date().getTime();
        var lastResult;
        var lastArgs;
        var timeoutId = null;
        if (options) {
            leading = options.leading || false;
            trailing = options.trailing || true;
            maxWait = options.maxWait || null;
        }
        var markExecuted = function (time) {
            if (timeoutId) {
                _this.clearTimeout(timeoutId);
                timeoutId = null;
            }
            lastExecuteTime = time;
        };
        var invokeFunction = function (time) {
            markExecuted(time);
            lastResult = func.apply(null, lastArgs);
        };
        var callback = function (userCall) {
            var now = new Date().getTime();
            var executeImmediately = false;
            if (userCall) {
                if (leading && now - lastCallTime >= waitMS) {
                    executeImmediately = true;
                }
                lastCallTime = now;
            }
            var delta = now - lastCallTime;
            var waitLength = waitMS - delta;
            var maxWaitDelta = now - lastExecuteTime;
            var maxWaitExpired = false;
            if (maxWait !== null) {
                // maxWait only matters when there is a pending callback
                if (maxWaitDelta >= maxWait && timeoutId) {
                    maxWaitExpired = true;
                }
                else {
                    waitLength = Math.min(waitLength, maxWait - maxWaitDelta);
                }
            }
            if (delta >= waitMS || maxWaitExpired || executeImmediately) {
                invokeFunction(now);
            }
            else if ((timeoutId === null || !userCall) && trailing) {
                timeoutId = _this.setTimeout(callback, waitLength);
            }
            return lastResult;
        };
        var pending = function () {
            return !!timeoutId;
        };
        var cancel = function () {
            if (pending()) {
                // Mark the debounced function as having executed
                markExecuted(new Date().getTime());
            }
        };
        var flush = function () {
            if (pending()) {
                invokeFunction(new Date().getTime());
            }
            return lastResult;
        };
        // tslint:disable-next-line:no-any
        var resultFunction = (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            lastArgs = args;
            return callback(true);
        });
        resultFunction.cancel = cancel;
        resultFunction.flush = flush;
        resultFunction.pending = pending;
        return resultFunction;
    };
    /**
     * Creates a function that, when executed, will only call the func function at most once per
     * every wait milliseconds. Provide an options object to indicate that func should be invoked
     * on the leading and/or trailing edge of the wait timeout. Subsequent calls to the throttled
     * function will return the result of the last func call.
     *
     * Note: If leading and trailing options are true func will be called on the trailing edge of
     * the timeout only if the the throttled function is invoked more than once during the wait timeout.
     *
     * @param func - The function to throttle.
     * @param wait - The number of milliseconds to throttle executions to. Defaults to 0.
     * @param options - The options object.
     * @returns The new throttled function.
     */
    TimerManagement.prototype.throttle = function (func, wait, options) {
        var _this = this;
        if (this.disposed) {
            var noOpFunction = (function () {
                /** Do nothing */
            });
            noOpFunction.cancel = function () {
                return;
            };
            noOpFunction.flush = (function () { return null; });
            noOpFunction.pending = function () { return false; };
            return noOpFunction;
        }
        var waitMS = wait || 0;
        var leading = true;
        var trailing = true;
        var lastExecuteTime = 0;
        var lastResult;
        // tslint:disable-next-line:no-any
        var lastArgs;
        var timeoutId = null;
        if (options && typeof options.leading === "boolean") {
            leading = options.leading;
        }
        if (options && typeof options.trailing === "boolean") {
            trailing = options.trailing;
        }
        var callback = function (userCall) {
            var now = new Date().getTime();
            var delta = now - lastExecuteTime;
            var waitLength = leading ? waitMS - delta : waitMS;
            if (delta >= waitMS && (!userCall || leading)) {
                lastExecuteTime = now;
                if (timeoutId) {
                    _this.clearTimeout(timeoutId);
                    timeoutId = null;
                }
                lastResult = func.apply(null, lastArgs);
            }
            else if (timeoutId === null && trailing) {
                timeoutId = _this.setTimeout(callback, waitLength);
            }
            return lastResult;
        };
        // tslint:disable-next-line:no-any
        var resultFunction = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            lastArgs = args;
            return callback(true);
        };
        return resultFunction;
    };
    TimerManagement.prototype.removeInterval = function (intervalId) {
        var index = this.intervals.indexOf(intervalId);
        if (index >= 0) {
            this.intervals.splice(index, 1);
        }
    };
    TimerManagement.prototype.removeTimeout = function (timeoutId) {
        var index = this.timeouts.indexOf(timeoutId);
        if (index >= 0) {
            this.timeouts.splice(index, 1);
        }
    };
    return TimerManagement;
}());



/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_MouseWithin_MouseWithin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(127);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MouseWithin", function() { return _Components_MouseWithin_MouseWithin__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_MouseWithin_MouseWithin_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(128);
/* harmony import */ var _Components_MouseWithin_MouseWithin_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_MouseWithin_MouseWithin_Props__WEBPACK_IMPORTED_MODULE_1__);

// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present



/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Back; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EnterFullScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ExitFullScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Filter; });
var Back = "Back";
var EnterFullScreen = "Enter full-screen mode";
var ExitFullScreen = "Exit full-screen mode";
var Filter = "Filter";


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(220);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(221);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownSelection", function() { return DropdownSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownMultiSelection", function() { return DropdownMultiSelection; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _List__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);


var DropdownSelection = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(DropdownSelection, _super);
    function DropdownSelection() {
        return _super.call(this, { selectOnFocus: false }) || this;
    }
    return DropdownSelection;
}(_List__WEBPACK_IMPORTED_MODULE_1__["ListSelection"]));

var DropdownMultiSelection = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(DropdownMultiSelection, _super);
    function DropdownMultiSelection() {
        return _super.call(this, { alwaysMerge: true, multiSelect: true, selectOnFocus: false }) || this;
    }
    return DropdownMultiSelection;
}(_List__WEBPACK_IMPORTED_MODULE_1__["ListSelection"]));



/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ Callout_Callout_Callout; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ ContentSize; });

// UNUSED EXPORTS: ContentJustification, ContentLocation, ContentOrientation

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Callout/Callout.css
var Callout_Callout = __webpack_require__(228);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/FocusWithin.js
var FocusWithin = __webpack_require__(23);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/FocusZone.js + 2 modules
var FocusZone = __webpack_require__(7);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Portal.js
var Portal = __webpack_require__(55);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Utilities/Position.js
var Position = __webpack_require__(12);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/TimerManagement.js
var TimerManagement = __webpack_require__(41);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Surface.js + 2 modules
var Surface = __webpack_require__(18);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Callout/Callout.Props.js
var ContentJustification;
(function (ContentJustification) {
    ContentJustification[ContentJustification["Start"] = 0] = "Start";
    ContentJustification[ContentJustification["Center"] = 1] = "Center";
    ContentJustification[ContentJustification["End"] = 2] = "End";
    ContentJustification[ContentJustification["Stretch"] = 3] = "Stretch";
})(ContentJustification || (ContentJustification = {}));
var ContentLocation;
(function (ContentLocation) {
    ContentLocation[ContentLocation["Start"] = 0] = "Start";
    ContentLocation[ContentLocation["Center"] = 1] = "Center";
    ContentLocation[ContentLocation["End"] = 2] = "End";
})(ContentLocation || (ContentLocation = {}));
var ContentOrientation;
(function (ContentOrientation) {
    ContentOrientation[ContentOrientation["Column"] = 0] = "Column";
    ContentOrientation[ContentOrientation["Row"] = 1] = "Row";
})(ContentOrientation || (ContentOrientation = {}));
var ContentSize;
(function (ContentSize) {
    ContentSize[ContentSize["Small"] = 0] = "Small";
    ContentSize[ContentSize["Medium"] = 1] = "Medium";
    ContentSize[ContentSize["Large"] = 2] = "Large";
    ContentSize[ContentSize["Auto"] = 3] = "Auto";
    ContentSize[ContentSize["ExtraLarge"] = 4] = "ExtraLarge";
})(ContentSize || (ContentSize = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Callout/Callout.js













var Callout_Callout_Callout = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(Callout, _super);
    function Callout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.calloutContent = external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"]();
        return _this;
    }
    Callout.prototype.render = function () {
        var portalProps = this.props.portalProps;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Portal["Portal"], Object(tslib_es6["a" /* __assign */])({}, portalProps, { className: Object(Util["css"])(portalProps && portalProps.className, this.props.anchorElement && "bolt-layout-relative") }),
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Callout_CalloutContent, Object(tslib_es6["a" /* __assign */])({ ref: this.calloutContent }, this.props))));
    };
    Callout.prototype.componentWillUnmount = function () {
        // We need to let the content handle the WillUnmount before the Portal, this
        // will ensure the the callout can deal with unmounting content that still has
        // focus. Otherwise the root will be detached from the document and focus will
        // have moved to the body.
        if (this.calloutContent.current) {
            this.calloutContent.current.portalWillUnmount();
        }
    };
    Callout.prototype.updateLayout = function () {
        if (this.calloutContent.current) {
            this.calloutContent.current.updateLayout();
        }
    };
    Callout.defaultProps = {
        blurDismiss: false,
        viewportChangeDismiss: true
    };
    return Callout;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));

var Callout_CalloutContent = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(CalloutContent, _super);
    function CalloutContent(props) {
        var _this = _super.call(this, props) || this;
        _this.calloutElement = external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"]();
        _this.relayoutTimer = new TimerManagement["a" /* TimerManagement */]();
        _this.scrollListen = false;
        _this.scrollEvent = null;
        _this.initialScreenWidth = window.innerWidth;
        _this.onBlur = function () {
            _this.props.onDismiss && _this.props.onDismiss();
        };
        _this.onClick = function (event) {
            // If we click on the light dismiss div we will dismiss it.
            if (_this.props.lightDismiss && !event.defaultPrevented) {
                if (_this.props.onDismiss) {
                    _this.props.onDismiss();
                }
                event.preventDefault();
            }
        };
        _this.onKeyDown = function (event) {
            // If we press escape from within the callout this will dismiss it.
            if (_this.props.escDismiss && event.which === Util["KeyCode"].escape && !event.defaultPrevented) {
                if (_this.props.onDismiss) {
                    _this.props.onDismiss();
                }
                event.preventDefault();
            }
        };
        _this.onResize = function () {
            // Fix for issue where the soft keyboard on android closes callouts.
            if (_this.props.viewportChangeDismiss === true &&
                (_this.initialScreenWidth !== window.innerWidth ||
                    !document.activeElement ||
                    (document.activeElement.tagName !== "INPUT" && document.activeElement.tagName !== "TEXTAREA"))) {
                _this.props.onDismiss && _this.props.onDismiss();
            }
            else if (_this.props.updateLayout) {
                _this.relayoutTimer.clearAllTimers();
                _this.relayoutTimer.setTimeout(function () {
                    _this.updateLayout();
                }, 200);
            }
        };
        _this.onScroll = function (event) {
            if (_this.scrollListen) {
                _this.scrollEvent = event.nativeEvent;
            }
        };
        _this.onScrollDocument = function (event) {
            if (_this.scrollListen) {
                if (event === _this.scrollEvent) {
                    _this.scrollEvent = null;
                }
                else {
                    if (_this.props.viewportChangeDismiss === true) {
                        var anchorElement = _this.props.anchorElement;
                        // If the element containing the anchor is scrolled dismiss the callout.
                        if (event.target && anchorElement && event.target.contains(anchorElement)) {
                            _this.props.onDismiss && _this.props.onDismiss();
                        }
                    }
                    else if (_this.props.updateLayout) {
                        _this.relayoutTimer.setTimeout(function () {
                            _this.updateLayout();
                        }, 50);
                    }
                }
            }
        };
        // Track the element that had focus when we mounted.
        _this.focusElement = document.activeElement;
        _this.contentElement = props.contentRef || external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"]();
        return _this;
    }
    CalloutContent.prototype.render = function () {
        var _this = this;
        var _a = this.props, blurDismiss = _a.blurDismiss, contentJustification = _a.contentJustification, contentLocation = _a.contentLocation, contentOrientation = _a.contentOrientation, focuszoneProps = _a.focuszoneProps, lightDismiss = _a.lightDismiss, modal = _a.modal, onAnimationEnd = _a.onAnimationEnd, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, anchorElement = _a.anchorElement;
        var content;
        // If we have both a FocusWithin and a FocusZone we need to use the functional version
        // of the FocusWithin to allow the FocusZone to contain the content directly.
        if (blurDismiss && focuszoneProps) {
            content = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusWithin["FocusWithin"], { onBlur: this.onBlur, updateStateOnFocusChange: false }, function (props) { return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusZone["a" /* FocusZone */], Object(tslib_es6["a" /* __assign */])({}, focuszoneProps), _this.renderContent(props.onFocus, props.onBlur)); }));
        }
        else {
            content = this.renderContent();
            // Add the focus tracker to dismiss the callout if we are dismissing on blur.
            if (blurDismiss) {
                content = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusWithin["FocusWithin"], { onBlur: this.onBlur, updateStateOnFocusChange: false }, content));
            }
            // Add focus zone if focuszoneProperties are specified
            if (focuszoneProps) {
                content = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusZone["a" /* FocusZone */], Object(tslib_es6["a" /* __assign */])({}, focuszoneProps), content);
            }
        }
        var lightDismissDiv = lightDismiss ? (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])("absolute-fill bolt-light-dismiss", modal && "bolt-callout-modal"), onClick: this.onClick })) : null;
        // The callout is wrapped in a floating element in the portal.
        // If lightDismiss is enabled we will create an absolute-fill div to capture onClick events.
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Surface["SurfaceContext"].Provider, { value: { background: Surface["SurfaceBackground"].callout } },
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "flex-row flex-grow" },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(this.props.className, "bolt-callout absolute", contentLocation !== undefined && "absolute-fill", contentJustification === ContentJustification.Start && "justify-start", contentJustification === ContentJustification.Center && "justify-center", contentJustification === ContentJustification.End && "justify-end", contentLocation === ContentLocation.Start && "flex-start", contentLocation === ContentLocation.Center && "flex-center", contentLocation === ContentLocation.End && "flex-end", contentOrientation === ContentOrientation.Column && "flex-column", contentOrientation !== ContentOrientation.Column && "flex-row", modal && !lightDismiss && "bolt-callout-modal"), id: Object(Util["getSafeId"])(this.props.id), onAnimationEnd: onAnimationEnd, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: this.onKeyDown, ref: this.calloutElement, role: this.props.role },
                    !anchorElement && lightDismissDiv,
                    content),
                !!anchorElement && lightDismissDiv)));
    };
    CalloutContent.prototype.componentDidMount = function () {
        this.updateLayout();
        // If this is an element relative layout we need to listen for scroll events
        // on the document and dismiss the callout if the scroll event didnt pass
        // through the callout.
        if (this.props.anchorElement) {
            window.addEventListener("resize", this.onResize);
            document.addEventListener("scroll", this.onScrollDocument, true);
            this.scrollListen = true;
        }
    };
    CalloutContent.prototype.componentDidUpdate = function () {
        if (this.props.updateLayout) {
            this.updateLayout();
        }
    };
    CalloutContent.prototype.componentWillUnmount = function () {
        if (this.scrollListen) {
            document.removeEventListener("scroll", this.onScrollDocument, true);
            window.removeEventListener("resize", this.onResize);
        }
        if (this.relayoutTimer) {
            this.relayoutTimer.clearAllTimers();
        }
    };
    CalloutContent.prototype.portalWillUnmount = function () {
        var contentElement = this.contentElement.current;
        var focusElement = this.focusElement;
        // If the callout has focus when unmounted we need to set focus back to the last element with focus.
        // Need to wait for next tick otherwise focus/blur events are not fired.
        if (focusElement && contentElement && contentElement.contains(document.activeElement)) {
            window.setTimeout(function () {
                // We need to make sure the active element is portal after the timeout.
                // It may have moved through other means before the timeout expires.
                // Set focus to the focusElement if our element contains focus, or if the focus has gone back to the document body
                if (contentElement.contains(document.activeElement) || document.activeElement === document.body || document.activeElement === null) {
                    focusElement.focus();
                }
            }, 0);
        }
    };
    CalloutContent.prototype.updateLayout = function () {
        if (this.props.contentLocation === undefined) {
            if (this.calloutElement.current) {
                // Position the element based on the initial layout parameters.
                Object(Position["c" /* position */])(this.calloutElement.current, this.props.calloutOrigin || { horizontal: Position["a" /* Location */].start, vertical: Position["a" /* Location */].start }, this.props.anchorOffset, this.props.anchorElement, this.props.anchorOrigin, this.props.anchorPoint, this.props.anchorElement ? 5000 : 0);
                // Now that the component is placed at the requested location, update
                // the layout if the caller didnt request a fixed layout.
                if (!this.props.fixedLayout) {
                    Object(Position["d" /* updateLayout */])(this.calloutElement.current, this.props.calloutOrigin || { horizontal: Position["a" /* Location */].start, vertical: Position["a" /* Location */].start }, this.props.anchorOffset, this.props.anchorElement, this.props.anchorOrigin, this.props.anchorPoint, this.props.anchorElement ? 5000 : 0);
                }
            }
        }
    };
    CalloutContent.prototype.renderContent = function (onFocus, onBlur) {
        var _a = this.props, contentJustification = _a.contentJustification, contentOrientation = _a.contentOrientation, contentSize = _a.contentSize, height = _a.height, width = _a.width;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { "aria-describedby": Object(Util["getSafeId"])(this.props.ariaDescribedBy), "aria-label": this.props.ariaLabel, "aria-labelledby": Object(Util["getSafeId"])(this.props.ariaLabelledBy), "aria-modal": this.props.modal, className: Object(Util["css"])(this.props.contentClassName, "bolt-callout-content", this.props.contentShadow && "bolt-callout-shadow", contentJustification === ContentJustification.Stretch && "flex-grow", contentOrientation === ContentOrientation.Column && "flex-column", contentOrientation === ContentOrientation.Row && "flex-row", contentSize === ContentSize.Small && "bolt-callout-small", contentSize === ContentSize.Medium && "bolt-callout-medium", contentSize === ContentSize.Large && "bolt-callout-large", contentSize === ContentSize.ExtraLarge && "bolt-callout-extra-large", contentSize === ContentSize.Auto && "bolt-callout-auto"), onBlur: onBlur, onFocus: onFocus, onScroll: this.onScroll, ref: this.contentElement, role: this.props.role || "dialog", style: { height: height, width: width } }, this.props.children));
    };
    return CalloutContent;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Callout.js




/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__48__;

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AgoHours */
/* unused harmony export AgoMinutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Collapsed; });
/* unused harmony export DayAtTimeFormat */
/* unused harmony export DaysHoursMinutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Expanded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FriendlyNumberBillionsFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FriendlyNumberMillionsFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FriendlyNumberThousandsFormat; });
/* unused harmony export HoursMinutesSeconds */
/* unused harmony export JustNow */
/* unused harmony export LessThanASecond */
/* unused harmony export MinutesSeconds */
/* unused harmony export Seconds */
/* unused harmony export Today */
/* unused harmony export Yesterday */
var AgoHours = "{0}h ago";
var AgoMinutes = "{0}m ago";
var Collapsed = "Collapsed";
var DayAtTimeFormat = "{0} at {1}";
var DaysHoursMinutes = "{0}d {1}h {2}m";
var Expanded = "Expanded";
var FriendlyNumberBillionsFormat = "{0}B+";
var FriendlyNumberMillionsFormat = "{0}M+";
var FriendlyNumberThousandsFormat = "{0}K+";
var HoursMinutesSeconds = "{0}h {1}m {2}s";
var JustNow = "Just now";
var LessThanASecond = "<1s";
var MinutesSeconds = "{0}m {1}s";
var Seconds = "{0}s";
var Today = "Today";
var Yesterday = "Yesterday";


/***/ }),
/* 50 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(219);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 52 */
/***/ (function(module, exports) {


exports = module.exports = trim;

function trim(str){
  return str.replace(/^\s*|\s*$/g, '');
}

exports.left = function(str){
  return str.replace(/^\s*/, '');
};

exports.right = function(str){
  return str.replace(/\s*$/, '');
};


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownCallout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DropdownCalloutComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Dropdown_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51);
/* harmony import */ var _Dropdown_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Dropdown_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var _Core_Util_String__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14);
/* harmony import */ var _Callout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47);
/* harmony import */ var _FocusZone__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9);
/* harmony import */ var _ListBox__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8);
/* harmony import */ var _Resources_Dropdown__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17);
/* harmony import */ var _TextField__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(28);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1);
















var ItemsForFilter = 10;
var DefaultWidth = 256;
// This should match the total horizontal padding on bolt-dropdown-filter-container
var FilterBarPadding = 16;
// This should match the width + margin of the textfield search icon
var FilterBarIconWidth = 27;
function DropdownCallout(props) {
    return react__WEBPACK_IMPORTED_MODULE_4__["createElement"](DropdownCalloutComponent, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, props));
}
var DropdownCalloutComponent = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(DropdownCalloutComponent, _super);
    function DropdownCalloutComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.callout = react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
        _this.calloutContent = react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
        _this.filterBox = react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
        _this.initFocusElement = react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
        _this.updateLayout = function () {
            // Allow the new items to draw before updating the layout.
            setTimeout(function () {
                if (_this.callout.current) {
                    _this.callout.current.updateLayout();
                }
            }, 0);
            return true;
        };
        _this.onMouseDown = function (event) {
            if (_this.props.ignoreMouseDown) {
                if (event.target.tagName !== "INPUT") {
                    Object(_Util__WEBPACK_IMPORTED_MODULE_15__["preventDefault"])(event);
                }
            }
        };
        _this.listBoxDidUpdate = function () {
            _this.getScrollWidth();
        };
        _this.getScrollWidth = function () {
            window.requestAnimationFrame(function () {
                if (_this.calloutContent.current) {
                    var widthChange = _this.calloutContent.current.offsetWidth - _this.props.width;
                    // A 1 pixel change in the width may change the total width by 2 pixels if there are two scroll bars.
                    // Only rerender when a scrollbar is appearing or being removed which should be > 1 pixel change.
                    if (Math.abs(widthChange) > 1) {
                        _this.setState({ scrollBarWidth: widthChange + _this.state.scrollBarWidth });
                    }
                }
            });
        };
        _this.state = { scrollBarWidth: 0 };
        return _this;
    }
    DropdownCalloutComponent.prototype.componentDidMount = function () {
        this.getScrollWidth();
    };
    DropdownCalloutComponent.prototype.focus = function () {
        if (this.filterBox.current) {
            this.filterBox.current.focus();
        }
        else if (this.initFocusElement.current) {
            this.initFocusElement.current.focus();
        }
    };
    DropdownCalloutComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, actions = _a.actions, anchorElement = _a.anchorElement, anchorOffset = _a.anchorOffset, anchorOrigin = _a.anchorOrigin, anchorPoint = _a.anchorPoint, ariaLabel = _a.ariaLabel, _b = _a.blurDismiss, blurDismiss = _b === void 0 ? true : _b, calloutContentClassName = _a.calloutContentClassName, columns = _a.columns, containerClassName = _a.containerClassName, contentLocation = _a.contentLocation, dropdownOrigin = _a.dropdownOrigin, enforceSingleSelect = _a.enforceSingleSelect, excludeFocusZone = _a.excludeFocusZone, excludeTabStop = _a.excludeTabStop, filteredItems = _a.filteredItems, filteredNoResultsText = _a.filteredNoResultsText, filteredResultsLoadingText = _a.filteredResultsLoadingText, filterPlaceholderText = _a.filterPlaceholderText, filterText = _a.filterText, focusOnMount = _a.focusOnMount, getUnselectableRanges = _a.getUnselectableRanges, id = _a.id, items = _a.items, lightDismiss = _a.lightDismiss, listBoxClassName = _a.listBoxClassName, listBoxRef = _a.listBoxRef, loading = _a.loading, onActivate = _a.onActivate, onFilterKeyDown = _a.onFilterKeyDown, onFilterTextChanged = _a.onFilterTextChanged, onSelect = _a.onSelect, onToggle = _a.onToggle, renderBeforeContent = _a.renderBeforeContent, renderItem = _a.renderItem, searching = _a.searching, selection = _a.selection, showCloseButton = _a.showCloseButton, showFilterBox = _a.showFilterBox, showItemsWhileSearching = _a.showItemsWhileSearching, showTree = _a.showTree, title = _a.title, updateFilteredItems = _a.updateFilteredItems, userFilteredItems = _a.userFilteredItems;
        var _c = this.props.width, width = _c === void 0 ? DefaultWidth : _c;
        if (width > 0) {
            width -= this.state.scrollBarWidth;
        }
        var textFieldId = "bolt-dropdown-textfield-" + id;
        var clearInput = function () {
            filterText.value = "";
            if (onFilterTextChanged) {
                onFilterTextChanged(null, "");
            }
            if (updateFilteredItems) {
                updateFilteredItems();
            }
        };
        var onDismiss = function () {
            if (_this.props.onDismiss) {
                _this.props.onDismiss();
            }
            clearInput();
        };
        return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Callout__WEBPACK_IMPORTED_MODULE_8__[/* Callout */ "a"], { anchorElement: anchorElement, anchorOffset: anchorOffset, anchorOrigin: anchorOrigin, anchorPoint: anchorPoint, blurDismiss: blurDismiss, calloutOrigin: dropdownOrigin, contentClassName: Object(_Util__WEBPACK_IMPORTED_MODULE_15__["css"])(calloutContentClassName, "bolt-dropdown flex-column custom-scrollbar v-scroll-auto h-scroll-hidden"), contentLocation: contentLocation, contentRef: this.calloutContent, contentShadow: true, contentSize: _Callout__WEBPACK_IMPORTED_MODULE_8__[/* ContentSize */ "b"].Auto, escDismiss: true, id: id, lightDismiss: lightDismiss, focuszoneProps: {
                postprocessKeyStroke: function (event) {
                    // dismiss the callout on tab key instead of letting the
                    // browser handle the tab key, since with React.portals it
                    // will move to the body, instead of the next tabbable element after
                    // the dropdown.
                    if (event.which === _Util__WEBPACK_IMPORTED_MODULE_15__["KeyCode"].tab && !event.defaultPrevented) {
                        event.preventDefault();
                        onDismiss();
                        return _FocusZone__WEBPACK_IMPORTED_MODULE_9__[/* FocusZoneKeyStroke */ "d"].IgnoreAll;
                    }
                    return _FocusZone__WEBPACK_IMPORTED_MODULE_9__[/* FocusZoneKeyStroke */ "d"].IgnoreNone;
                }
            }, onDismiss: onDismiss, ref: this.callout },
            react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_9__[/* FocusZone */ "a"], { circularNavigation: true, defaultActiveElement: showFilterBox || (showFilterBox === undefined && items.length > ItemsForFilter)
                    ? Object(_Util__WEBPACK_IMPORTED_MODULE_15__["getSafeIdSelector"])(textFieldId)
                    : ".bolt-dropdown-init-focus", direction: _FocusZone__WEBPACK_IMPORTED_MODULE_9__[/* FocusZoneDirection */ "c"].Vertical, focusOnMount: focusOnMount !== undefined ? focusOnMount : true },
                react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: "bolt-dropdown-container no-outline", onMouseDown: this.onMouseDown, onKeyDown: onFilterKeyDown, style: { width: width >= 0 ? width : undefined } },
                    react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { "aria-hidden": "true", "aria-roledescription": _Resources_Dropdown__WEBPACK_IMPORTED_MODULE_13__[/* DropdownCalloutRoleDescription */ "h"], className: "bolt-dropdown-init-focus no-outline", tabIndex: !excludeTabStop ? -1 : undefined, ref: this.initFocusElement, role: "listbox" }),
                    react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_12__["Observer"], { items: { observableValue: items, filter: this.updateLayout } }, function () {
                        var shouldShowFilterBox = showFilterBox === undefined ? items.length > ItemsForFilter : showFilterBox;
                        return shouldShowFilterBox || title || showCloseButton ? (react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: "bolt-dropdown-header-container" },
                            (title || showCloseButton) && (react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: "bolt-dropdown-header flex-row flex-center" },
                                react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: "bolt-dropdown-header-text flex-grow font-weight-semibold" }, title),
                                showCloseButton && (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Button__WEBPACK_IMPORTED_MODULE_7__["Button"], { className: "bolt-dropdown-header-button", ariaLabel: _Resources_Dropdown__WEBPACK_IMPORTED_MODULE_13__[/* Close */ "g"], iconProps: { iconName: "Cancel" }, onClick: onDismiss, subtle: true })))),
                            shouldShowFilterBox && (react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { key: "bolt-dropdown-filter-container", className: "bolt-dropdown-filter-container" },
                                react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_12__["Observer"], { filterText: filterText }, function (props) {
                                    return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_TextField__WEBPACK_IMPORTED_MODULE_14__[/* TextField */ "a"], { key: "bolt-dropdown-filter", ariaLabel: _Resources_Dropdown__WEBPACK_IMPORTED_MODULE_13__[/* SearchAriaLabel */ "o"], className: "bolt-dropdown-filter", excludeTabStop: true, inputId: textFieldId, onChange: onFilterTextChanged, placeholder: filterPlaceholderText, prefixIconProps: { iconName: "Search" }, ref: _this.filterBox, value: filterText, maxWidth: _this.props.width - FilterBarPadding - FilterBarIconWidth, suffixIconProps: props.filterText.length > 0
                                            ? {
                                                ariaLabel: _Resources_Dropdown__WEBPACK_IMPORTED_MODULE_13__[/* ClearText */ "f"],
                                                iconName: "ChromeClose",
                                                onClick: clearInput,
                                                size: _Icon__WEBPACK_IMPORTED_MODULE_10__["IconSize"].small,
                                                tooltipProps: {
                                                    text: _Resources_Dropdown__WEBPACK_IMPORTED_MODULE_13__[/* ClearText */ "f"]
                                                }
                                            }
                                            : undefined }));
                                }))))) : null;
                    }),
                    renderBeforeContent && renderBeforeContent(),
                    react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_12__["Observer"], { filteredItems: filteredItems, filteredNoResultsText: filteredNoResultsText, listBoxItems: { observableValue: items, filter: updateFilteredItems }, userFilteredItems: { observableValue: userFilteredItems, filter: updateFilteredItems } }, function (props) {
                        var noItemsElement = null;
                        var noItemsText = "";
                        if (((filteredItems && filteredItems.length === 0) || items.length === 0) && !searching) {
                            noItemsText =
                                filterText.value === ""
                                    ? _this.props.noItemsText
                                    : Object(_Core_Util_String__WEBPACK_IMPORTED_MODULE_6__[/* format */ "a"])(props.filteredNoResultsText || _Resources_Dropdown__WEBPACK_IMPORTED_MODULE_13__[/* NoFilterResults */ "n"], filterText.value);
                            if (noItemsText) {
                                noItemsElement = react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: "bolt-dropdown-no-items" }, noItemsText);
                            }
                        }
                        return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](react__WEBPACK_IMPORTED_MODULE_4__["Fragment"], null,
                            noItemsElement,
                            react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_ListBox__WEBPACK_IMPORTED_MODULE_11__[/* ListBox */ "a"], { ariaLabel: ariaLabel, className: listBoxClassName, columns: columns, containerClassName: Object(_Util__WEBPACK_IMPORTED_MODULE_15__["css"])("bolt-dropdown-list-box-container", containerClassName), didUpdate: _this.listBoxDidUpdate, enforceSingleSelect: enforceSingleSelect, excludeFocusZone: excludeFocusZone, excludeTabStop: true, searchResultsLoadingText: filteredResultsLoadingText, focuszoneProps: null, getUnselectableRanges: getUnselectableRanges, items: filteredItems ? filteredItems.value : items, loading: loading, onActivate: onActivate, onSelect: onSelect, onToggle: onToggle, renderItem: renderItem, ref: listBoxRef, searching: searching, selection: selection, showChecksColumn: true, showItemsWhileSearching: showItemsWhileSearching, showTree: showTree })));
                    }),
                    react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_12__["Observer"], { actions: actions }, function (props) {
                        var actions = _this.props.actions;
                        return actions && actions.length ? (react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: "bolt-actions-container flex-column" }, _Core_Observable__WEBPACK_IMPORTED_MODULE_5__["ObservableLike"].getValue(actions).map(function (actionProps, index) { return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Button__WEBPACK_IMPORTED_MODULE_7__["Button"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({ key: actionProps.id || index, subtle: true, excludeTabStop: true }, actionProps))); }))) : null;
                    })))));
    };
    DropdownCalloutComponent.defaultProps = {
        width: DefaultWidth,
        ignoreMouseDown: true
    };
    return DropdownCalloutComponent;
}(react__WEBPACK_IMPORTED_MODULE_4__["Component"]));



/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventDispatch; });
var EventDispatch = /** @class */ (function () {
    function EventDispatch() {
        this.listeners = {};
    }
    EventDispatch.prototype.addEventListener = function (eventType, callback) {
        if (!(eventType in this.listeners)) {
            this.listeners[eventType] = [];
        }
        this.listeners[eventType].push(callback);
    };
    EventDispatch.prototype.dispatchEvent = function (event, data, type) {
        var delegates = this.listeners[type || event.type];
        if (delegates) {
            var stack = delegates.slice();
            for (var i = 0, l = stack.length; i < l; i++) {
                stack[i].call(this, event, data);
            }
        }
    };
    EventDispatch.prototype.removeEventListener = function (eventType, callback) {
        if (!(eventType in this.listeners)) {
            return;
        }
        var stack = this.listeners[eventType];
        for (var i = 0, l = stack.length; i < l; i++) {
            if (stack[i] === callback) {
                stack.splice(i, 1);
                return;
            }
        }
    };
    return EventDispatch;
}());



/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_Portal_Portal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Portal", function() { return _Components_Portal_Portal__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_Portal_Portal_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(126);
/* harmony import */ var _Components_Portal_Portal_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_Portal_Portal_Props__WEBPACK_IMPORTED_MODULE_1__);




/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Components_Menu_ContextMenuBehavior__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(145);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContextMenuBehavior", function() { return _Components_Menu_ContextMenuBehavior__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_Menu_Menu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "groupMenuItems", function() { return _Components_Menu_Menu__WEBPACK_IMPORTED_MODULE_1__["f"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return _Components_Menu_Menu__WEBPACK_IMPORTED_MODULE_1__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuDivider", function() { return _Components_Menu_Menu__WEBPACK_IMPORTED_MODULE_1__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuHeader", function() { return _Components_Menu_Menu__WEBPACK_IMPORTED_MODULE_1__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return _Components_Menu_Menu__WEBPACK_IMPORTED_MODULE_1__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContextualMenu", function() { return _Components_Menu_Menu__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _Components_Menu_Menu_Props__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuItemType", function() { return _Components_Menu_Menu_Props__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuCell", function() { return _Components_Menu_Menu_Props__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _Components_Menu_MenuButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuButton", function() { return _Components_Menu_MenuButton__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _Components_Menu_MenuButton_Props__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(148);
/* harmony import */ var _Components_Menu_MenuButton_Props__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Components_Menu_MenuButton_Props__WEBPACK_IMPORTED_MODULE_4__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_Menu_MenuButton_Props__WEBPACK_IMPORTED_MODULE_4__) if(["default","ContextMenuBehavior","groupMenuItems","Menu","MenuDivider","MenuHeader","MenuItem","ContextualMenu","MenuItemType","MenuCell","MenuButton"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_Menu_MenuButton_Props__WEBPACK_IMPORTED_MODULE_4__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _Components_Menu_MoreButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MoreButton", function() { return _Components_Menu_MoreButton__WEBPACK_IMPORTED_MODULE_5__["a"]; });









/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_Breakpoint_Breakpoint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(154);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Breakpoint", function() { return _Components_Breakpoint_Breakpoint__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_Breakpoint_Breakpoint_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(155);
/* harmony import */ var _Components_Breakpoint_Breakpoint_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_Breakpoint_Breakpoint_Props__WEBPACK_IMPORTED_MODULE_1__);




/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(240);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryOr = exports.tryLink = void 0;
const React = __webpack_require__(0);
const Link_1 = __webpack_require__(30);
const tryLink = (fHref, inner, className, onClick) => {
    try {
        const href = fHref();
        if (!href)
            throw null;
        return React.createElement(Link_1.Link, { className: className, excludeTabStop: true, href: fHref(), target: "_blank", onClick: onClick }, inner);
    }
    catch (e) {
        return inner;
    }
};
exports.tryLink = tryLink;
function tryOr(...functions) {
    for (const func of functions) {
        if (typeof func !== 'function')
            return func; // A non-function constant value.
        try {
            const value = func();
            if (!value)
                continue;
            return value;
        }
        catch (e) { }
    }
}
exports.tryOr = tryOr;


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Components_TreeEx_FixedHeightTree__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(157);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FixedHeightTree", function() { return _Components_TreeEx_FixedHeightTree__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_TreeEx_FixedHeightTree_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(158);
/* harmony import */ var _Components_TreeEx_FixedHeightTree_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_TreeEx_FixedHeightTree_Props__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_TreeEx_FixedHeightTree_Props__WEBPACK_IMPORTED_MODULE_1__) if(["default","FixedHeightTree"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_TreeEx_FixedHeightTree_Props__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _Components_TreeEx_Tree__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(159);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tree", function() { return _Components_TreeEx_Tree__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TreeRow", function() { return _Components_TreeEx_Tree__WEBPACK_IMPORTED_MODULE_2__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderTreeRow", function() { return _Components_TreeEx_Tree__WEBPACK_IMPORTED_MODULE_2__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpandableTreeCell", function() { return _Components_TreeEx_Tree__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderExpandableTreeCell", function() { return _Components_TreeEx_Tree__WEBPACK_IMPORTED_MODULE_2__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderTreeCell", function() { return _Components_TreeEx_Tree__WEBPACK_IMPORTED_MODULE_2__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderTreeCellWithClassName", function() { return _Components_TreeEx_Tree__WEBPACK_IMPORTED_MODULE_2__["f"]; });

/* harmony import */ var _Components_TreeEx_Tree_Props__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(160);
/* harmony import */ var _Components_TreeEx_Tree_Props__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Components_TreeEx_Tree_Props__WEBPACK_IMPORTED_MODULE_3__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_TreeEx_Tree_Props__WEBPACK_IMPORTED_MODULE_3__) if(["default","FixedHeightTree","Tree","TreeRow","renderTreeRow","ExpandableTreeCell","renderExpandableTreeCell","renderTreeCell","renderTreeCellWithClassName"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_TreeEx_Tree_Props__WEBPACK_IMPORTED_MODULE_3__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _Components_TreeEx_TreeExpand__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TreeExpand", function() { return _Components_TreeEx_TreeExpand__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony import */ var _Components_TreeEx_TreeExpand_Props__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(161);
/* harmony import */ var _Components_TreeEx_TreeExpand_Props__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Components_TreeEx_TreeExpand_Props__WEBPACK_IMPORTED_MODULE_5__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_TreeEx_TreeExpand_Props__WEBPACK_IMPORTED_MODULE_5__) if(["default","FixedHeightTree","Tree","TreeRow","renderTreeRow","ExpandableTreeCell","renderExpandableTreeCell","renderTreeCell","renderTreeCellWithClassName","TreeExpand"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_TreeEx_TreeExpand_Props__WEBPACK_IMPORTED_MODULE_5__[key]; }) }(__WEBPACK_IMPORT_KEY__));








/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TreeExpand; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Tree_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96);
/* harmony import */ var _Tree_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Tree_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _TreeExpand_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97);
/* harmony import */ var _TreeExpand_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_TreeExpand_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1);








var defaultCollapsedProps = { iconName: "ChevronRightMed" };
var defaultExpandedProps = { iconName: "ChevronDownMed" };
var TreeExpand = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(TreeExpand, _super);
    function TreeExpand() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseDown = function (event) {
            if (!event.defaultPrevented) {
                // Only toggle on a lone left button, not when mixed with others.
                // IPhone doesnt pass buttons so we will take 0 as a click.
                if (event.buttons === 1 || event.buttons === 0) {
                    if (_this.props.onToggle) {
                        _this.props.onToggle(event);
                        event.preventDefault();
                    }
                }
            }
        };
        return _this;
    }
    TreeExpand.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, depth = _a.depth, expanded = _a.expanded, _b = _a.iconCollapsedProps, iconCollapsedProps = _b === void 0 ? defaultCollapsedProps : _b, _c = _a.iconExpandedProps, iconExpandedProps = _c === void 0 ? defaultExpandedProps : _c, _d = _a.indentationSize, indentationSize = _d === void 0 ? 16 : _d;
        var iconProps = expanded ? iconExpandedProps : iconCollapsedProps;
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](react__WEBPACK_IMPORTED_MODULE_5__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Icon__WEBPACK_IMPORTED_MODULE_6__["Icon"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, iconProps, { className: Object(_Util__WEBPACK_IMPORTED_MODULE_7__["css"])(className, "bolt-tree-expand-button font-size cursor-pointer", !this.props.onToggle && "invisible"), onClick: this.props.onClick, onMouseDown: this.onMouseDown, role: "presentation", size: _Icon__WEBPACK_IMPORTED_MODULE_6__["IconSize"].small, style: { marginLeft: depth > 0 ? depth * indentationSize + "px" : undefined } })),
            children));
    };
    return TreeExpand;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));



/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardContent; });
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Card_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73);
/* harmony import */ var _Card_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Card_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Surface__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1);






var CardContent = function (props) {
    return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Surface__WEBPACK_IMPORTED_MODULE_4__["SurfaceContext"].Consumer, null, function (surfaceContext) {
        var _a = props.contentPadding, contentPadding = _a === void 0 ? true : _a;
        return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { className: Object(_Util__WEBPACK_IMPORTED_MODULE_5__["css"])(props.className, "bolt-card-content flex-row flex-grow", contentPadding && surfaceContext.horizontalClassName) }, props.children));
    }));
};


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Pill", function() { return /* reexport */ Pill_Pill_Pill; });
__webpack_require__.d(__webpack_exports__, "PillSize", function() { return /* reexport */ PillSize; });
__webpack_require__.d(__webpack_exports__, "PillVariant", function() { return /* reexport */ PillVariant; });

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Pill/Pill.css
var Pill_Pill = __webpack_require__(363);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Util/String.js
var Util_String = __webpack_require__(16);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Button.js
var Button = __webpack_require__(14);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/FocusZone.js + 2 modules
var FocusZone = __webpack_require__(7);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Icon.js + 2 modules
var Icon = __webpack_require__(9);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Resources.Widgets.js
var Resources_Widgets = __webpack_require__(20);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Utilities/Color.js
function darken(color, darkenFactor) {
    var darkenMultiplier = 1 - darkenFactor;
    return {
        red: color.red * darkenMultiplier,
        green: color.green * darkenMultiplier,
        blue: color.blue * darkenMultiplier
    };
}
function getColorString(color) {
    return "rgb(" + color.red + ", " + color.green + ", " + color.blue + ")";
}
function isDark(color) {
    var luminance = color.red * 0.299 + color.green * 0.587 + color.blue * 0.114;
    return luminance <= 128;
}
function rgbToHex(color) {
    return ("#" + rgbValueToString(color.red) + rgbValueToString(color.green) + rgbValueToString(color.blue)).toUpperCase();
}
/**
 * Convert a hex color to numeric r g b value
 * @param color Color in format #aabbcc
 */
function hexToRgb(color) {
    if (color.length !== 7 || color[0] !== "#") {
        throw new Error("Expected color in format #AABBCC");
    }
    return {
        red: parseInt(color.substr(1, 2), 16),
        green: parseInt(color.substr(3, 2), 16),
        blue: parseInt(color.substr(5, 2), 16)
    };
}
function generateRandomColor() {
    var blue = Math.floor(Math.random() * 256);
    var green = Math.floor(Math.random() * 256);
    var red = Math.floor(Math.random() * 256);
    return { red: red, blue: blue, green: green };
}
function generateRandomColorHex() {
    return rgbToHex(generateRandomColor());
}
function parseColor(hexString) {
    if (!hexString) {
        return undefined;
    }
    var color = undefined;
    if (hexString.length === 7) {
        try {
            color = hexToRgb(hexString);
        }
        catch (ex) {
            console.log(ex);
            // swallow the exception
        }
    }
    return color;
}
var hexRegex = new RegExp("^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$");
function testForHexString(hexString) {
    return hexString.match(hexRegex);
}
function rgbValueToString(colorCoord) {
    var hexColor = colorCoord.toString(16);
    if (hexColor.length === 1) {
        hexColor = "0" + hexColor;
    }
    return hexColor;
}

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Utilities/Focus.js + 1 modules
var Focus = __webpack_require__(26);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Pill/Pill.Props.js
var PillSize;
(function (PillSize) {
    PillSize[PillSize["compact"] = 0] = "compact";
    PillSize[PillSize["regular"] = 1] = "regular";
    PillSize[PillSize["large"] = 2] = "large";
})(PillSize || (PillSize = {}));
var PillVariant;
(function (PillVariant) {
    PillVariant[PillVariant["standard"] = 0] = "standard";
    PillVariant[PillVariant["outlined"] = 1] = "outlined";
    PillVariant[PillVariant["colored"] = 2] = "colored";
})(PillVariant || (PillVariant = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Pill/Pill.js














var Pill_Pill_Pill = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(Pill, _super);
    function Pill(props) {
        var _this = _super.call(this, props) || this;
        _this.getChildText = function () {
            var text = "";
            external_commonjs_react_commonjs2_react_amd_React_root_React_["Children"].map(_this.props.children, function (child) {
                if (typeof child === "string") {
                    text += child;
                }
            });
            return text;
        };
        _this.onKeyDown = function (event) {
            var keyCode = event.which;
            if (keyCode === Util["KeyCode"].enter) {
                _this.props.onClick && _this.props.onClick();
            }
        };
        _this.onMouseEnter = function (event) {
            _this.props.onMouseEnter && _this.props.onMouseEnter(event);
            _this.setState({
                isHoveringPrimaryElement: true
            });
        };
        /**
         * onMouseLeaveButton fires first; if it leaves the container too
         * onMouseLeave will setState again, which will prevent weird behavior
         */
        _this.onMouseLeave = function (event) {
            _this.props.onMouseLeave && _this.props.onMouseLeave(event);
            _this.setState({
                isHoveringPrimaryElement: false
            });
        };
        _this.onMouseLeaveButton = function () {
            _this.setState({
                isHoveringPrimaryElement: true
            });
        };
        _this.onMouseOverButton = function () {
            _this.setState({
                isHoveringPrimaryElement: false
            });
        };
        _this.state = {
            isHoveringPrimaryElement: false
        };
        return _this;
    }
    Pill.getColorStyle = function (color, isHoveringPrimaryElement, onClick) {
        if (!color) {
            return undefined;
        }
        var renderColor = onClick && isHoveringPrimaryElement ? darken(color, 0.06) : color;
        return { backgroundColor: getColorString(renderColor) };
    };
    Pill.getSizeClass = function (size) {
        switch (size) {
            case PillSize.compact:
                return "compact";
            case PillSize.large:
                return "large";
            case PillSize.regular:
            default:
                return "regular";
        }
    };
    Pill.getVariantClass = function (variant, color) {
        switch (variant) {
            case PillVariant.outlined:
                return "outlined";
            case PillVariant.colored:
                if (color) {
                    return Object(Util["css"])("colored", isDark(color) ? "dark" : "light");
                }
                else {
                    return "standard";
                }
            case PillVariant.standard:
            default:
                return "standard";
        }
    };
    Pill.getDerivedStateFromProps = function (props, state) {
        if (false) { var unsupportedFields, color, iconProps, onRenderFilledVisual, _a, size, variant; }
        return state;
    };
    Pill.prototype.render = function () {
        var _this = this;
        var _a = this.props, ariaHidden = _a.ariaHidden, contentClassName = _a.contentClassName, className = _a.className, color = _a.color, _b = _a.containsCount, containsCount = _b === void 0 ? false : _b, iconProps = _a.iconProps, id = _a.id, onClick = _a.onClick, onBlur = _a.onBlur, onFocus = _a.onFocus, onRemoveClick = _a.onRemoveClick, onRenderFilledVisual = _a.onRenderFilledVisual, _c = _a.size, size = _c === void 0 ? PillSize.regular : _c, _d = _a.variant, variant = _d === void 0 ? PillVariant.standard : _d;
        var isHoveringPrimaryElement = this.state.isHoveringPrimaryElement;
        var ariaLabel = this.props.ariaLabel || this.getChildText();
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusZone["b" /* FocusZoneContext */].Consumer, null, function (zoneContext) { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(className, "bolt-pill flex-row flex-center", Pill.getVariantClass(variant, color), Pill.getSizeClass(size), containsCount && "count", isHoveringPrimaryElement && "hover", onClick && "clickable", onRenderFilledVisual && "has-filled-visual", iconProps && !onRenderFilledVisual && "has-icon", onRemoveClick && "has-remove-button"), id: Object(Util["getSafeId"])(id), onClick: onClick, onBlur: onBlur, onMouseEnter: _this.onMouseEnter, onMouseLeave: _this.onMouseLeave, style: Pill.getColorStyle(color, isHoveringPrimaryElement, onClick) },
            onRenderFilledVisual && external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-pill-filled-visual flex-noshrink" }, onRenderFilledVisual()),
            iconProps && !onRenderFilledVisual && external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Icon["Icon"], Object(tslib_es6["a" /* __assign */])({}, iconProps, { className: Object(Util["css"])(iconProps.className, "bolt-pill-icon") })),
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { "aria-label": ariaLabel, "aria-hidden": ariaHidden, className: Object(Util["css"])(contentClassName, "bolt-pill-content text-ellipsis"), "data-focuszone": !_this.props.excludeFocusZone ? zoneContext.focuszoneId : undefined, onFocus: onFocus, onKeyDown: _this.onKeyDown, role: onClick ? "button" : "presentation", tabIndex: onClick || onFocus ? Object(Focus["a" /* getTabIndex */])(_this.props) : undefined }, _this.props.children),
            onRemoveClick && (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Button["Button"], { ariaLabel: Object(Util_String["a" /* format */])(Resources_Widgets["k" /* RemovePillLabel */], ariaLabel), className: "bolt-pill-button", iconProps: { iconName: "Cancel", size: Icon["IconSize"].inherit }, onClick: onRemoveClick, onMouseLeave: _this.onMouseLeaveButton, onMouseOver: _this.onMouseOverButton, subtle: true, tooltipProps: { text: Object(Util_String["a" /* format */])(Resources_Widgets["k" /* RemovePillLabel */], ariaLabel) } })))); }));
    };
    return Pill;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Pill.js




/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Selection; });
/* unused harmony export indexWithinRanges */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return compareSelectionRanges; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);


var Selection = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(Selection, _super);
    function Selection(options) {
        var _this = _super.call(this, []) || this;
        _this.selectedRanges = [];
        _this.lockCount = 0;
        _this.unselectableRangesValue = [];
        _this.selectedCount = 0;
        _this.unselectableCount = 0;
        _this.onItemsChanged = function (change, action) {
            var index = change.index;
            var removedUnselectableRange, unselectedRange;
            if (action === "change") {
                return;
            }
            // Unselect any items that were removed from the underlying item collection.
            if (change.removedItems && change.removedItems.length) {
                removedUnselectableRange = _this.removeUnselectableInternal(index, change.removedItems.length);
                unselectedRange = _this.unselectInternal(index, change.removedItems.length);
            }
            // Offset any selection by the items added.
            if (change.addedItems || change.removedItems) {
                var adjustCount = (change.addedItems ? change.addedItems.length : 0) - (change.removedItems ? change.removedItems.length : 0);
                var adjustedSelectionRanges = adjustRanges(index, adjustCount, _this.selectedRanges);
                var adjustedUnselectableRanges = adjustRanges(index, adjustCount, _this.unselectableRanges);
                if (adjustedSelectionRanges.length) {
                    _this.notify(adjustedSelectionRanges, "set");
                }
                if (adjustedUnselectableRanges.length) {
                    _this.notify(adjustedUnselectableRanges, "setUnselectable");
                }
            }
            if (removedUnselectableRange) {
                _this.notify([removedUnselectableRange], "removeUnselectable");
            }
            if (unselectedRange) {
                _this.notify([unselectedRange], "unselect");
            }
        };
        if (typeof options === "boolean" || options === undefined) {
            _this.multiSelect = !!options || false;
        }
        else {
            _this.alwaysMerge = !!options.alwaysMerge;
            _this.multiSelect = !!options.multiSelect;
            _this.unselectableRanges = options.unselectableRanges || [];
            _this.value = options.selectedRanges || [];
        }
        return _this;
    }
    Object.defineProperty(Selection.prototype, "value", {
        get: function () {
            return this.selectedRanges;
        },
        set: function (ranges) {
            var _this = this;
            this.selectedCount = 0;
            this.selectedRanges = ranges.map(function (range) {
                _this.selectedCount += range.endIndex - range.beginIndex + 1;
                return { beginIndex: range.beginIndex, endIndex: range.endIndex };
            });
            this.notify(ranges, "set");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Selection.prototype, "unselectableRanges", {
        get: function () {
            return this.unselectableRangesValue;
        },
        set: function (ranges) {
            var _this = this;
            this.unselectableCount = 0;
            this.unselectableRangesValue = ranges.map(function (range) {
                _this.unselectableCount += range.endIndex - range.beginIndex + 1;
                return { beginIndex: range.beginIndex, endIndex: range.endIndex };
            });
            this.notify(ranges, "setUnselectable");
        },
        enumerable: true,
        configurable: true
    });
    Selection.prototype.clear = function () {
        var selectedRanges = this.clearSelectedRanges();
        if (selectedRanges) {
            // Go through and notify any observers of the change.
            this.notify(selectedRanges, "unselect");
        }
    };
    Selection.prototype.clearUnselectable = function () {
        var unselectableRanges = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])(this.unselectableRangesValue);
        this.unselectableRanges = [];
        this.unselectableCount = 0;
        this.notify(unselectableRanges, "removeUnselectable");
    };
    Selection.prototype.selectable = function (index) {
        return !indexWithinRanges(index, this.unselectableRanges);
    };
    Selection.prototype.selected = function (index) {
        return indexWithinRanges(index, this.selectedRanges);
    };
    Selection.prototype.addUnselectable = function (index, count) {
        var updatedRanges = false;
        var beginIndex = index;
        var endIndex = index + (count || 1) - 1;
        // If no count is specified we will add a single item.
        count = count || 1;
        for (; count > 0; count--) {
            if (!this.selectable(index)) {
                index++;
                continue;
            }
            var rangeIndex = 0;
            var updatedRange = void 0;
            // Determine if there is a range we can add this unselectable item to.
            for (; rangeIndex < this.unselectableRanges.length; rangeIndex++) {
                var unselectableRange = this.unselectableRanges[rangeIndex];
                // Check if this unselectable item occurs before this unselectableRange.
                if (index < unselectableRange.beginIndex) {
                    if (index === unselectableRange.beginIndex - 1) {
                        updatedRange = unselectableRange;
                        updatedRange.beginIndex--;
                    }
                    break;
                }
                // If this index is directly after this range we will extend it.
                else if (index === unselectableRange.endIndex + 1) {
                    // If there is a gap of 1 number we will merge the two ranges.
                    if (rangeIndex < this.unselectableRanges.length - 1 && index === this.unselectableRanges[rangeIndex + 1].beginIndex - 1) {
                        updatedRange = unselectableRange;
                        updatedRange.endIndex = this.unselectableRanges[rangeIndex + 1].endIndex;
                        // Remove the second range since it is merged into the previous range.
                        this.unselectableRanges.splice(rangeIndex + 1, 1);
                    }
                    else {
                        updatedRange = unselectableRange;
                        updatedRange.endIndex++;
                    }
                    break;
                }
            }
            // If there was no range to merge with, add a new one.
            if (!updatedRange) {
                updatedRange = { beginIndex: index, endIndex: index };
                this.unselectableRanges.splice(rangeIndex, 0, updatedRange);
            }
            updatedRanges = true;
            this.unselectableCount++;
            index++;
        }
        // Notify observers of the added item.
        if (updatedRanges) {
            this.notify([{ beginIndex: beginIndex, endIndex: endIndex }], "addUnselectable");
        }
    };
    Selection.prototype.removeUnselectable = function (index, count) {
        var removedRange = this.removeUnselectableInternal(index, count);
        if (removedRange) {
            this.notify([removedRange], "removeUnselectable");
        }
    };
    Selection.prototype.select = function (index, count, merge, multiSelect) {
        if (merge === void 0) { merge = this.alwaysMerge; }
        if (multiSelect === void 0) { multiSelect = this.multiSelect; }
        if (!this.lockCount) {
            var beginIndex = index;
            var endIndex = beginIndex + (count || 1) - 1;
            var updatedRanges = false;
            var unselectedRanges = void 0;
            if (!multiSelect) {
                if (!this.selected(index) && this.selectable(index)) {
                    unselectedRanges = this.clearSelectedRanges();
                    var updatedRange = { beginIndex: index, endIndex: index };
                    this.selectedRanges.push(updatedRange);
                    this.selectedCount++;
                    updatedRanges = true;
                }
            }
            else {
                if (!merge) {
                    unselectedRanges = this.clearSelectedRanges();
                }
                // If no count is specified we will use a single item selection.
                count = count || 1;
                // @TODO: Implement a more optimal multi-count selection
                for (; count > 0; count--) {
                    if (this.selected(index) || !this.selectable(index)) {
                        index++;
                        continue;
                    }
                    var rangeIndex = 0;
                    var updatedRange = void 0;
                    // Determine if there is a range we can add this selection to.
                    for (; rangeIndex < this.selectedRanges.length; rangeIndex++) {
                        var selectionRange = this.selectedRanges[rangeIndex];
                        // Check if this selection occurs before this selectionRange.
                        if (index < selectionRange.beginIndex) {
                            if (index === selectionRange.beginIndex - 1) {
                                updatedRange = selectionRange;
                                updatedRange.beginIndex--;
                            }
                            break;
                        }
                        // If this index is directly after this range we will extend it.
                        else if (index === selectionRange.endIndex + 1) {
                            // If there is a gap of 1 number we will merge the two ranges.
                            if (rangeIndex < this.selectedRanges.length - 1 && index === this.selectedRanges[rangeIndex + 1].beginIndex - 1) {
                                updatedRange = selectionRange;
                                updatedRange.endIndex = this.selectedRanges[rangeIndex + 1].endIndex;
                                // Remove the second range since it is merged into the previous range.
                                this.selectedRanges.splice(rangeIndex + 1, 1);
                            }
                            else {
                                updatedRange = selectionRange;
                                updatedRange.endIndex++;
                            }
                            break;
                        }
                    }
                    // If there was no range to merge with, add a new one.
                    if (!updatedRange) {
                        updatedRange = { beginIndex: index, endIndex: index };
                        this.selectedRanges.splice(rangeIndex, 0, updatedRange);
                    }
                    this.selectedCount++;
                    index++;
                    updatedRanges = true;
                }
            }
            if (unselectedRanges) {
                this.notify(unselectedRanges, "unselect");
            }
            // Notify observers of the added selection.
            if (updatedRanges) {
                this.notify([{ beginIndex: beginIndex, endIndex: endIndex }], "select");
            }
        }
    };
    Selection.prototype.toggle = function (index, merge, multiSelect) {
        if (merge === void 0) { merge = this.alwaysMerge; }
        if (multiSelect === void 0) { multiSelect = this.multiSelect; }
        if (this.selected(index)) {
            this.unselect(index);
        }
        else {
            this.select(index, 1, merge, multiSelect);
        }
    };
    Selection.prototype.unselect = function (index, count) {
        var unselectedRange = this.unselectInternal(index, count);
        if (unselectedRange) {
            this.notify([unselectedRange], "unselect");
        }
    };
    Selection.prototype.lock = function () {
        this.lockCount++;
    };
    Selection.prototype.unlock = function () {
        this.lockCount--;
    };
    Selection.prototype.removeUnselectableInternal = function (index, count) {
        var beginIndex = index;
        var endIndex = beginIndex + (count || 1) - 1;
        var updatedRanges = false;
        // If no count is specified we will use a single item selection.
        count = count || 1;
        // @TODO: Implement a more optimal multi-count selection
        for (; count > 0; count--) {
            if (this.selectable(index)) {
                index++;
                continue;
            }
            // Determine the range we are unselecting the item from.
            for (var rangeIndex = 0; rangeIndex < this.unselectableRanges.length; rangeIndex++) {
                var unselectableRange = this.unselectableRanges[rangeIndex];
                // If this index if before this range move on to the next one.
                if (index < unselectableRange.beginIndex) {
                    continue;
                }
                // Determine whether or not this index falls into this range.
                if (index >= unselectableRange.beginIndex && index <= unselectableRange.endIndex) {
                    // If the index is on the start or end of the range, we will just shrink it.
                    // Otherwise we will have to split it.
                    if (index === unselectableRange.beginIndex) {
                        unselectableRange.beginIndex++;
                    }
                    else if (index === unselectableRange.endIndex) {
                        unselectableRange.endIndex--;
                    }
                    else {
                        this.unselectableRanges.splice(rangeIndex + 1, 0, {
                            beginIndex: index + 1,
                            endIndex: unselectableRange.endIndex
                        });
                        unselectableRange.endIndex = index - 1;
                    }
                    // Shrinking may have created an empty range, we need to remove it.
                    if (unselectableRange.beginIndex > unselectableRange.endIndex) {
                        this.unselectableRanges.splice(rangeIndex, 1);
                    }
                    this.unselectableCount--;
                    updatedRanges = true;
                    break;
                }
            }
            index++;
        }
        if (updatedRanges) {
            return { beginIndex: beginIndex, endIndex: endIndex };
        }
    };
    Selection.prototype.unselectInternal = function (index, count) {
        var updatedRanges = false;
        var beginIndex = index;
        var endIndex = beginIndex + (count || 1) - 1;
        if (!this.lockCount) {
            // If no count is specified we will use a single item selection.
            count = count || 1;
            // @TODO: Implement a more optimal multi-count selection
            for (; count > 0; count--) {
                if (!this.selected(index)) {
                    index++;
                    continue;
                }
                // Determine the range we are unselecting the item from.
                for (var rangeIndex = 0; rangeIndex < this.selectedRanges.length; rangeIndex++) {
                    var selectionRange = this.selectedRanges[rangeIndex];
                    // If this index if before this range move on to the next one.
                    if (index < selectionRange.beginIndex) {
                        continue;
                    }
                    // Determine whether or not this index falls into this range.
                    if (index >= selectionRange.beginIndex && index <= selectionRange.endIndex) {
                        // If the index is on the start or end of the range, we will just shrink it.
                        // Otherwise we will have to split it.
                        if (index === selectionRange.beginIndex) {
                            selectionRange.beginIndex++;
                        }
                        else if (index === selectionRange.endIndex) {
                            selectionRange.endIndex--;
                        }
                        else {
                            this.selectedRanges.splice(rangeIndex + 1, 0, {
                                beginIndex: index + 1,
                                endIndex: selectionRange.endIndex
                            });
                            selectionRange.endIndex = index - 1;
                        }
                        // Shrinking may have created an empty range, we need to remove it.
                        if (selectionRange.beginIndex > selectionRange.endIndex) {
                            this.selectedRanges.splice(rangeIndex, 1);
                        }
                        this.selectedCount--;
                        updatedRanges = true;
                        break;
                    }
                }
                index++;
            }
        }
        if (updatedRanges) {
            return { beginIndex: beginIndex, endIndex: endIndex };
        }
    };
    Selection.prototype.clearSelectedRanges = function () {
        if (!this.lockCount && this.selectedRanges.length > 0) {
            // Save the current selection ranges for notification.
            var selectedRanges = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])(this.selectedRanges);
            // Reset the selection to an empty selection.
            this.selectedRanges = [];
            this.selectedCount = 0;
            return selectedRanges;
        }
    };
    return Selection;
}(_Core_Observable__WEBPACK_IMPORTED_MODULE_1__["ObservableValue"]));

function indexWithinRanges(index, ranges) {
    if (ranges) {
        for (var _i = 0, ranges_1 = ranges; _i < ranges_1.length; _i++) {
            var range = ranges_1[_i];
            if (index >= range.beginIndex && index <= range.endIndex) {
                return true;
            }
        }
    }
    return false;
}
function adjustRanges(index, adjustCount, ranges) {
    var adjustedRanges = [];
    for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
        var range = ranges[rangeIndex];
        // If the added items are before the range shift it down.
        if (index <= range.beginIndex) {
            // If this adjustment will create a continuous range with the previous range
            // we merge the ranges.
            if (rangeIndex > 0 && range.beginIndex + adjustCount === ranges[rangeIndex - 1].endIndex + 1) {
                ranges[rangeIndex - 1].endIndex = range.endIndex + adjustCount;
                ranges.splice(rangeIndex--, 1);
                adjustedRanges.push(ranges[rangeIndex]);
            }
            else {
                range.beginIndex += adjustCount;
                range.endIndex += adjustCount;
                adjustedRanges.push(range);
            }
        }
        else if (index > range.beginIndex && index <= range.endIndex) {
            // Create the new split selection range.
            var splitRange = {
                beginIndex: index + adjustCount,
                endIndex: range.endIndex + adjustCount
            };
            ranges.splice(++rangeIndex, 0, splitRange);
            adjustedRanges.push(splitRange);
            // If the added items are in the middle of range we need to split the range.
            range.endIndex = index - 1;
            adjustedRanges.push(range);
        }
    }
    return adjustedRanges;
}
/**
 * return an array describing the difference of two sets of selection ranges.  Postive values in the array are indices in second
 * that are not in first.  Negative values in the array are indices that are in first that are not in second.
 * @param firstRanges the first set of values to use in the comparison.
 * @param secondRanges the second set of values to use in the comparison.
 */
function compareSelectionRanges(firstRanges, secondRanges) {
    var difference = [];
    for (var rangeIndex = 0; rangeIndex < firstRanges.length; rangeIndex++) {
        var range = firstRanges[rangeIndex];
        for (var selectionIndex = range.beginIndex; selectionIndex <= range.endIndex; selectionIndex++) {
            if (!indexWithinRanges(selectionIndex, secondRanges)) {
                difference.push(selectionIndex * -1);
            }
        }
    }
    for (var rangeIndex = 0; rangeIndex < secondRanges.length; rangeIndex++) {
        var range = secondRanges[rangeIndex];
        for (var selectionIndex = range.beginIndex; selectionIndex <= range.endIndex; selectionIndex++) {
            if (!indexWithinRanges(selectionIndex, firstRanges)) {
                difference.push(selectionIndex);
            }
        }
    }
    return difference;
}


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(146);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return _Components_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TriStateCheckbox", function() { return _Components_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony import */ var _Components_Checkbox_Checkbox_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(147);
/* harmony import */ var _Components_Checkbox_Checkbox_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_Checkbox_Checkbox_Props__WEBPACK_IMPORTED_MODULE_1__);




/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ TabProviderContext; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ TabProviderContext_TabProvider; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ TabGroupProviderContext_TabGroupProvider; });

// UNUSED EXPORTS: TabSize, Orientation, TabBadge, TabBar, TabList, Tabs, Tab, TabContent, TabGroupProviderContext

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Tabs/Tabs.Props.js
var TabSize;
(function (TabSize) {
    /**
     * 32px tall with 14px text
     */
    TabSize["Compact"] = "compact";
    /**
     * 48px tall with 14px text
     */
    TabSize["Tall"] = "tall";
    /**
     * 40px tall with 17px text
     */
    TabSize["LargeLink"] = "large-link";
})(TabSize || (TabSize = {}));
/**
 * Defines the orientation of the child FocusZone and the flex orientation
 * of the list
 */
var Orientation;
(function (Orientation) {
    Orientation[Orientation["Horizontal"] = 0] = "Horizontal";
    Orientation[Orientation["Vertical"] = 1] = "Vertical";
})(Orientation || (Orientation = {}));

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Tabs/Tabs.css
var Tabs_Tabs = __webpack_require__(39);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Pill.js + 3 modules
var Pill = __webpack_require__(63);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/TooltipEx.js
var TooltipEx = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Tabs/TabBadge.js








var TabBadge = function (props) {
    var children = props.children, className = props.className, _a = props.containsCount, containsCount = _a === void 0 ? true : _a, tooltipProps = props.tooltipProps;
    var badge = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Pill["Pill"], { className: Object(Util["css"])(className, "bolt-tab-badge"), containsCount: containsCount, size: Pill["PillSize"].compact, contentClassName: "text-ellipsis", excludeFocusZone: true, excludeTabStop: true }, children));
    if (tooltipProps) {
        badge = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TooltipEx["Tooltip"], Object(tslib_es6["a" /* __assign */])({}, tooltipProps), badge);
    }
    return badge;
};

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Observable.js
var Observable = __webpack_require__(4);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Util/Screen.js
var Screen = __webpack_require__(32);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Observer.js
var Observer = __webpack_require__(8);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Surface.js + 2 modules
var Surface = __webpack_require__(18);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/FocusGroup.js
var FocusGroup = __webpack_require__(31);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/FocusZone.js + 2 modules
var FocusZone = __webpack_require__(7);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Icon.js + 2 modules
var Icon = __webpack_require__(9);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Util/String.js
var Util_String = __webpack_require__(16);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Resources.Core.js
var Resources_Core = __webpack_require__(49);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Utilities/FriendlyNumber.js


/**
 * Gets a friendly display value like "15K+" for a given numerical
 * value like 15217.
 *
 * @param value The numerical value to convert to a friendlier text string
 */
function getFriendlyDisplayValue(value) {
    var displayValue = "";
    var negative = false;
    if (isNaN(value)) {
        return "";
    }
    if (value < 0) {
        negative = true;
        value = -value;
    }
    value = Math.floor(value);
    if (value < 1000) {
        displayValue = value.toString();
    }
    else if (value < 1000000) {
        displayValue = Object(Util_String["a" /* format */])(Resources_Core["e" /* FriendlyNumberThousandsFormat */], Math.floor(value / 1000));
    }
    else if (value < 1000000000) {
        displayValue = Object(Util_String["a" /* format */])(Resources_Core["d" /* FriendlyNumberMillionsFormat */], Math.floor(value / 1000000));
    }
    else {
        displayValue = Object(Util_String["a" /* format */])(Resources_Core["c" /* FriendlyNumberBillionsFormat */], Math.floor(value / 1000000000));
    }
    return (negative && value > 0 ? "-" : "") + displayValue;
}

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Tabs/Tab.js













/**
 * Presentational component that represents a single tab.
 */
var Tab_Tab = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(Tab, _super);
    function Tab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (event) {
            var url = _this.props.url;
            var updatePivot = true;
            // If ctrl-click is pressed, and there is a URL specified for this item, then
            // don't handle the click here, allowing the browser to perform a navigation
            // (i.e. open in a new tab/window)
            if (event.ctrlKey) {
                if (url) {
                    updatePivot = false;
                }
            }
            if (updatePivot) {
                event.preventDefault();
                _this.updateSelectedItem(event);
            }
        };
        _this.onKeyDown = function (event) {
            if (!event.defaultPrevented) {
                if (event.which === Util["KeyCode"].space || event.which === Util["KeyCode"].enter) {
                    event.preventDefault();
                    _this.updateSelectedItem(event);
                }
            }
        };
        return _this;
    }
    Tab.prototype.render = function () {
        var _this = this;
        var _a = this.props, ariaLabel = _a.ariaLabel, index = _a.index, setSize = _a.setSize, iconProps = _a.iconProps, id = _a.id, isSelected = _a.isSelected, renderBadge = _a.renderBadge, url = _a.url;
        var TagName = url ? "a" : "div";
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { name: this.props.name, badgeCount: this.props.badgeCount }, function (props) {
            var name = props.name;
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusGroup["FocusGroupContext"].Consumer, null, function (focusGroupContext) { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusZone["b" /* FocusZoneContext */].Consumer, null, function (zoneContext) {
                var badge = renderBadge ? renderBadge() : _this.renderBadge(props.badgeCount);
                var icon = iconProps !== undefined && Object(Icon["Icon"])(Object(tslib_es6["a" /* __assign */])({ className: "bolt-tab-icon" }, iconProps));
                var text = name && (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("span", { className: "bolt-tab-text", "data-content": name }, name));
                var tooltipProps = icon && !name && ariaLabel
                    ? {
                        text: ariaLabel,
                        overflowOnly: false
                    }
                    : {
                        text: name,
                        overflowDetected: overflowDetected,
                        overflowOnly: true
                    };
                return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TooltipEx["Tooltip"], Object(tslib_es6["a" /* __assign */])({}, tooltipProps),
                    external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TagName, { "aria-label": ariaLabel, "aria-posinset": index !== undefined ? index + 1 : undefined, "aria-selected": isSelected, "aria-setsize": setSize, className: Object(Util["css"])(_this.props.className, "bolt-tab focus-treatment flex-noshrink", isSelected && "selected"), "data-focuszone": zoneContext.focuszoneId, href: url, id: Object(Util["getSafeId"])("tab-" + id), key: id, onClick: _this.onClick, onKeyDown: _this.onKeyDown, role: "tab", tabIndex: focusGroupContext.focusedElementId === "tab-" + id ? 0 : -1 },
                        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("span", { className: "bolt-tab-inner-container" },
                            icon,
                            text,
                            badge))));
            })); }));
        }));
    };
    Tab.prototype.renderBadge = function (badgeCount) {
        var badgeDisplayValue = badgeCount !== undefined ? getFriendlyDisplayValue(badgeCount) : undefined;
        var badgeTooltip = undefined;
        if (badgeCount && badgeDisplayValue !== badgeCount.toString()) {
            badgeTooltip = badgeCount.toString();
        }
        var badge = null;
        if (badgeDisplayValue) {
            var tooltipProps = badgeTooltip ? { text: badgeTooltip } : undefined;
            badge = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TabBadge, { tooltipProps: tooltipProps }, badgeDisplayValue);
        }
        return badge;
    };
    /**
     * Updates the state with the new selected pivot.
     */
    Tab.prototype.updateSelectedItem = function (ev) {
        var onClick = this.props.onClick;
        if (ev && this.props.onBeforeTabChange && !this.props.onBeforeTabChange(ev, this.props.id, this.props.url)) {
            ev.preventDefault();
            return;
        }
        // Update notifiers
        if (onClick) {
            onClick(this.props.id);
        }
    };
    return Tab;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));

function overflowDetected(anchorElement) {
    var overflowElement = anchorElement.querySelector(".bolt-tab-text");
    if (overflowElement) {
        return overflowElement && overflowElement.scrollWidth > Math.ceil(overflowElement.offsetWidth);
    }
    return false;
}

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Tabs/TabProviderContext.js






var TabProviderContext = external_commonjs_react_commonjs2_react_amd_React_root_React_["createContext"]({
    selectedId: undefined,
    tabs: [],
    commandBarItems: [],
    renderContent: undefined,
    renderFilterBar: undefined
});
var TabProviderContext_TabProvider = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(TabProvider, _super);
    function TabProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabProvider.prototype.render = function () {
        var _this = this;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { selectedTabId: this.props.selectedTabId, tabs: this.props.providers }, function (props) {
            var selectedTabId = props.selectedTabId;
            var selectedTab = undefined;
            var tabs = Object(tslib_es6["d" /* __spreadArrays */])(props.tabs.sort(function (a, b) { return (a.order || 100) - (b.order || 100); }));
            tabs.forEach(function (tab) {
                if (tab.id === selectedTabId) {
                    selectedTab = tab;
                }
            });
            if (selectedTab === undefined) {
                selectedTab = {
                    id: selectedTabId,
                    name: undefined,
                    render: undefined
                };
            }
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TabProviderContext.Provider, { value: {
                    selectedId: selectedTab.id,
                    tabs: tabs,
                    commandBarItems: selectedTab.commandBarItems,
                    renderContent: selectedTab.render,
                    renderFilterBar: selectedTab.renderFilterBar
                } }, _this.props.children));
        }));
    };
    return TabProvider;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Tabs/Tabs.js










/**
 * Renders all children as focusable, selectable elements and indicates whether or not they are
 * currently selected.
 */
var Tabs_Tabs_Tabs = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.onTabClick = function (newTabId) {
            var onSelectedTabChanged = _this.props.onSelectedTabChanged;
            if (onSelectedTabChanged) {
                onSelectedTabChanged(newTabId);
            }
        };
        _this.onSelectedTabIdChanged = function () {
            _this.forceUpdate();
        };
        if (Observable["ObservableLike"].isObservable(props.selectedTabId)) {
            props.selectedTabId.subscribe(_this.onSelectedTabIdChanged);
        }
        return _this;
    }
    Tabs.prototype.componentWillUnmount = function () {
        if (Observable["ObservableLike"].isObservable(this.props.selectedTabId)) {
            this.props.selectedTabId.unsubscribe(this.onSelectedTabIdChanged);
        }
    };
    Tabs.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.tabSize, tabSize = _b === void 0 ? TabSize.Tall : _b, _c = _a.orientation, orientation = _c === void 0 ? Orientation.Horizontal : _c;
        var selectedTabId = this.props.selectedTabId && Observable["ObservableLike"].getValue(this.props.selectedTabId);
        var childrenCount = 0;
        var childIndex = 0;
        var idToIndex = {};
        var defaultId;
        external_commonjs_react_commonjs2_react_amd_React_root_React_["Children"].map(this.props.children, function (child) {
            if (child && child.type === Tab_Tab) {
                idToIndex[child.props.id] = childIndex++;
                childrenCount++;
                if (!defaultId && child.props.id) {
                    defaultId = "tab-" + child.props.id;
                }
            }
        });
        var children = external_commonjs_react_commonjs2_react_amd_React_root_React_["Children"].map(this.props.children, function (child) {
            if (child && typeof child.type !== "string") {
                // We don't want to pass along the following props, unless the
                // child is a React component that will presumably know what
                // to do with them.
                var isSelected = (child.props.id && child.props.id.toLocaleLowerCase()) === (selectedTabId && selectedTabId.toLocaleLowerCase());
                var onClick = _this.onTabClick;
                return external_commonjs_react_commonjs2_react_amd_React_root_React_["cloneElement"](child, Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, child.props), { isSelected: isSelected,
                    onClick: onClick, index: idToIndex[child.props.id], setSize: childrenCount }));
            }
            return child;
        });
        var orientationClass = orientation === Orientation.Vertical ? "flex-column" : "flex-row";
        var focusZoneDirection = orientation === Orientation.Vertical ? FocusZone["c" /* FocusZoneDirection */].Vertical : FocusZone["c" /* FocusZoneDirection */].Horizontal;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusZone["a" /* FocusZone */], { direction: focusZoneDirection, focusGroupProps: { defaultElementId: defaultId } },
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { "aria-label": this.props.ariaLabel, className: Object(Util["css"])(this.props.className, "bolt-tabs", orientationClass, tabSize), role: "tablist" }, children)));
    };
    return Tabs;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Tabs/TabBar.js













/**
 * Renders tabs (provided as children or through a tab provider context) as well as addtional
 * content such as in-line filters, view options, etc.
 *
 * Tabs provided directly as children will always be place before contributed tabs.
 */
var TabBar_TabBar = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(TabBar, _super);
    function TabBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderAdditionalContent = function (renderFilterBar) {
            if (renderFilterBar) {
                return renderFilterBar(true);
            }
            return _this.props.renderAdditionalContent && _this.props.renderAdditionalContent();
        };
        _this.createTab = function (tab) {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Tab_Tab, { ariaLabel: tab.ariaLabel, badgeCount: tab.badgeCount, className: tab.className, key: tab.id, iconProps: tab.iconProps, id: tab.id, name: tab.name, onBeforeTabChange: tab.onBeforeTabChange, url: tab.url && Observable["ObservableLike"].getValue(tab.url), renderBadge: tab.renderBadge }));
        };
        return _this;
    }
    TabBar.prototype.render = function () {
        var _this = this;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { size: this.context.size }, function (props) {
            // If the screen is really small (mobile) then we don't let tabbar grow and let its container
            // to scroll in overflow case. Instead, we enable horizontal scrolling for tabs only.
            var smallScreen = props.size === Screen["c" /* ScreenSize */].xsmall;
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Surface["SurfaceContext"].Consumer, null, function (surfaceContext) { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TabProviderContext.Consumer, null, function (tabProviderContext) {
                var selectedTabId = _this.props.selectedTabId || tabProviderContext.selectedId;
                return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(_this.props.className, "bolt-tabbar flex-row flex-center flex-noshrink", !_this.props.disableSticky && props.size >= Screen["c" /* ScreenSize */].small && "sticky", surfaceContext.background === Surface["SurfaceBackground"].neutral && "bolt-tabbar-grey", surfaceContext.background === Surface["SurfaceBackground"].callout && "bolt-tabbar-on-callout") },
                    external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Tabs_Tabs_Tabs, Object(tslib_es6["a" /* __assign */])({ selectedTabId: selectedTabId }, _this.props, { className: Object(Util["css"])(_this.props.tabsClassName, "bolt-tabbar-tabs flex-grow", !smallScreen && "flex-noshrink", smallScreen && "flex-wrap") }),
                        _this.props.children,
                        tabProviderContext.tabs.map(_this.createTab)),
                    _this.renderAdditionalContent(tabProviderContext.renderFilterBar)));
            })); }));
        }));
    };
    TabBar.contextType = Screen["b" /* ScreenContext */];
    return TabBar;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Tabs/TabGroupProviderContext.js






var TabGroupProviderContext = external_commonjs_react_commonjs2_react_amd_React_root_React_["createContext"]({ groups: [] });
var TabGroupProviderContext_TabGroupProvider = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(TabGroupProvider, _super);
    function TabGroupProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabGroupProvider.prototype.render = function () {
        var _this = this;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { groups: this.props.providers }, function (props) {
            var groups = props.groups.sort(function (a, b) { return (a.order || 100) - (b.order || 100); });
            return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TabGroupProviderContext.Provider, { value: { groups: groups } }, _this.props.children);
        }));
    };
    return TabGroupProvider;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Tabs/TabList.js












var TabList_TabList = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(TabList, _super);
    function TabList(props) {
        var _this = _super.call(this, props) || this;
        _this.generateGroupMap = function (groups) {
            if (!groups) {
                return {};
            }
            var map = {};
            groups.forEach(function (group) {
                map[group.id] = group;
            });
            return map;
        };
        _this.processChildren = function (groups) {
            var childGroups = {};
            external_commonjs_react_commonjs2_react_amd_React_root_React_["Children"].forEach(_this.props.children, function (child) {
                if (child) {
                    var groupId = child.props.groupId || "";
                    if (!childGroups[groupId]) {
                        childGroups[groupId] = {
                            items: [child],
                            groupProps: groups[groupId] || {
                                id: "",
                                name: "",
                                order: -1
                            }
                        };
                    }
                    else {
                        childGroups[groupId].items.push(child);
                    }
                }
            });
            return childGroups;
        };
        _this.processContributions = function (tabs, baseGroups, childGroups) {
            tabs.forEach(function (tab) {
                var mappedTab = _this.createRow(tab);
                var groupId = tab.groupId || "";
                if (!childGroups[groupId]) {
                    childGroups[groupId] = {
                        items: [mappedTab],
                        groupProps: baseGroups[groupId] || {
                            id: "",
                            name: "",
                            order: -1
                        }
                    };
                }
                else {
                    childGroups[groupId].items.push(mappedTab);
                }
            });
            return childGroups;
        };
        _this.processGroups = function (groups) {
            var elements = [];
            // Flattening to allow for sort
            var flatMappedGroups = [];
            for (var groupId in groups) {
                flatMappedGroups.push(groups[groupId]);
            }
            flatMappedGroups
                .sort(function (a, b) { return (a.groupProps.order || 1000) - (b.groupProps.order || 1000); })
                .forEach(function (group) {
                group.groupProps.name &&
                    elements.push(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { key: group.groupProps.name, className: "bolt-tablist-heading title-xs flex-noshrink" }, group.groupProps.name));
                elements.push.apply(elements, group.items);
            });
            return elements;
        };
        _this.createRow = function (tab) {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Tab_Tab, { key: tab.id, id: tab.id, name: tab.name, url: tab.url && Observable["ObservableLike"].getValue(tab.url), onBeforeTabChange: tab.onBeforeTabChange, iconProps: tab.iconProps }));
        };
        _this.renderTitle = function (header) {
            return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-tablist-title title-m flex-noshrink" }, header);
        };
        _this.renderSubTitle = function (header) {
            return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-tablist-subtitle secondary-text flex-noshrink text-ellipsis" }, header);
        };
        _this.onSelectedTabIdChanged = function () {
            _this.forceUpdate();
        };
        return _this;
    }
    TabList.prototype.render = function () {
        var _this = this;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TabGroupProviderContext.Consumer, null, function (provider) {
            var _a = _this.props, className = _a.className, tabGroups = _a.tabGroups;
            var mergedGroups = tabGroups ? tabGroups.concat(provider.groups) : provider.groups;
            var groupMap = _this.generateGroupMap(mergedGroups);
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TabProviderContext.Consumer, null, function (provider) {
                var selectedTabId = _this.props.selectedTabId || provider.selectedId;
                var tabGroups = _this.processContributions(provider.tabs, groupMap, _this.processChildren(groupMap));
                var trueChildren = _this.processGroups(tabGroups);
                return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(className, "bolt-tablist flex-column") },
                    _this.props.listTitle && _this.renderTitle(_this.props.listTitle),
                    _this.props.listSubTitle && _this.renderSubTitle(_this.props.listSubTitle),
                    external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Tabs_Tabs_Tabs, Object(tslib_es6["a" /* __assign */])({ ariaLabel: _this.props.listTitle, selectedTabId: selectedTabId }, _this.props, { className: "bolt-tablist-tabs", orientation: Orientation.Vertical }), trueChildren)));
            }));
        }));
    };
    return TabList;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Tabs/TabContent.js







/**
 * Hooks into tab provider context to render the tab's provided content, as well
 * as optionally the a filter bar if it is to be rendered outside of the TabBar.
 */
var TabContent_TabContent = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(TabContent, _super);
    function TabContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabContent.prototype.render = function () {
        var _this = this;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TabProviderContext.Consumer, null, function (tabProviderContext) {
            var content;
            if (tabProviderContext.renderContent) {
                var filterBar = tabProviderContext.renderFilterBar && tabProviderContext.renderFilterBar(false);
                content = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](external_commonjs_react_commonjs2_react_amd_React_root_React_["Fragment"], null,
                    filterBar,
                    tabProviderContext.renderContent()));
            }
            else {
                content = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](external_commonjs_react_commonjs2_react_amd_React_root_React_["Fragment"], null, _this.props.children);
            }
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TabProviderContext_TabProvider, { providers: new Observable["ObservableArray"]([]), selectedTabId: tabProviderContext.selectedId || "" }, content));
        }));
    };
    return TabContent;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Tabs.js











/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onError", function() { return onError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observer", function() { return observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Observer", function() { return Observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderReporter", function() { return renderReporter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentByNodeRegistery", function() { return componentByNodeRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentByNodeRegistry", function() { return componentByNodeRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trackComponents", function() { return trackComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useStaticRendering", function() { return useStaticRendering; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return inject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disposeOnUnmount", function() { return disposeOnUnmount; });
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_2__);
/** @license mobx-react v5.4.4
 * index.module.js
 *
 * Copyright (c) 2015 Michel Weststrate.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

// These functions can be stubbed out in specific environments

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var reactIs_production_min = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,r=b?Symbol.for("react.memo"):
60115,t=b?Symbol.for("react.lazy"):60116;function u(a){if("object"===typeof a&&null!==a){var q=a.$$typeof;switch(q){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return q}}case d:return q}}}function v(a){return u(a)===m}exports.typeOf=u;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;
exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;exports.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||u(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return u(a)===k};exports.isContextProvider=function(a){return u(a)===h};
exports.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return u(a)===n};exports.isFragment=function(a){return u(a)===e};exports.isProfiler=function(a){return u(a)===g};exports.isPortal=function(a){return u(a)===d};exports.isStrictMode=function(a){return u(a)===f};
});

unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
var reactIs_production_min_6 = reactIs_production_min.Element;
var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
var reactIs_production_min_8 = reactIs_production_min.Fragment;
var reactIs_production_min_9 = reactIs_production_min.Profiler;
var reactIs_production_min_10 = reactIs_production_min.Portal;
var reactIs_production_min_11 = reactIs_production_min.StrictMode;
var reactIs_production_min_12 = reactIs_production_min.isValidElementType;
var reactIs_production_min_13 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_14 = reactIs_production_min.isConcurrentMode;
var reactIs_production_min_15 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_16 = reactIs_production_min.isContextProvider;
var reactIs_production_min_17 = reactIs_production_min.isElement;
var reactIs_production_min_18 = reactIs_production_min.isForwardRef;
var reactIs_production_min_19 = reactIs_production_min.isFragment;
var reactIs_production_min_20 = reactIs_production_min.isProfiler;
var reactIs_production_min_21 = reactIs_production_min.isPortal;
var reactIs_production_min_22 = reactIs_production_min.isStrictMode;

var reactIs = createCommonjsModule(function (module) {

{
  module.exports = reactIs_production_min;
}
});

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var EventEmitter =
/*#__PURE__*/
function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.listeners = [];
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(cb) {
      var _this = this;

      this.listeners.push(cb);
      return function () {
        var index = _this.listeners.indexOf(cb);

        if (index !== -1) _this.listeners.splice(index, 1);
      };
    }
  }, {
    key: "emit",
    value: function emit(data) {
      this.listeners.forEach(function (fn) {
        return fn(data);
      });
    }
  }]);

  return EventEmitter;
}();

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      rest[_key - 6] = arguments[_key];
    }

    return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["untracked"])(function () {
      componentName = componentName || "<<anonymous>>";
      propFullName = propFullName || propName;

      if (props[propName] == null) {
        if (isRequired) {
          var actual = props[propName] === null ? "null" : "undefined";
          return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
        }

        return null;
      } else {
        return validate.apply(void 0, [props, propName, componentName, location, propFullName].concat(rest));
      }
    });
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
} // Copied from React.PropTypes


function isSymbol(propType, propValue) {
  // Native Symbol.
  if (propType === "symbol") {
    return true;
  } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


  if (propValue["@@toStringTag"] === "Symbol") {
    return true;
  } // Fallback for non-spec compliant Symbols which are polyfilled.


  if (typeof Symbol === "function" && propValue instanceof Symbol) {
    return true;
  }

  return false;
} // Copied from React.PropTypes


function getPropType(propValue) {
  var propType = _typeof(propValue);

  if (Array.isArray(propValue)) {
    return "array";
  }

  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
  }

  if (isSymbol(propType, propValue)) {
    return "symbol";
  }

  return propType;
} // This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes


function getPreciseType(propValue) {
  var propType = getPropType(propValue);

  if (propType === "object") {
    if (propValue instanceof Date) {
      return "date";
    } else if (propValue instanceof RegExp) {
      return "regexp";
    }
  }

  return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
  return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
    return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["untracked"])(function () {
      if (allowNativeType) {
        if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
      }

      var mobxChecker;

      switch (mobxType) {
        case "Array":
          mobxChecker = mobx__WEBPACK_IMPORTED_MODULE_0__["isObservableArray"];
          break;

        case "Object":
          mobxChecker = mobx__WEBPACK_IMPORTED_MODULE_0__["isObservableObject"];
          break;

        case "Map":
          mobxChecker = mobx__WEBPACK_IMPORTED_MODULE_0__["isObservableMap"];
          break;

        default:
          throw new Error("Unexpected mobxType: ".concat(mobxType));
      }

      var propValue = props[propName];

      if (!mobxChecker(propValue)) {
        var preciseType = getPreciseType(propValue);
        var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
        return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
      }

      return null;
    });
  });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
  return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
      rest[_key2 - 5] = arguments[_key2];
    }

    return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["untracked"])(function () {
      if (typeof typeChecker !== "function") {
        return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
      }

      var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
      if (error instanceof Error) return error;
      var propValue = props[propName];

      for (var i = 0; i < propValue.length; i++) {
        error = typeChecker.apply(void 0, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
        if (error instanceof Error) return error;
      }

      return null;
    });
  });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");

var propTypes = /*#__PURE__*/Object.freeze({
  observableArray: observableArray,
  observableArrayOf: observableArrayOf,
  observableMap: observableMap,
  observableObject: observableObject,
  arrayOrObservableArray: arrayOrObservableArray,
  arrayOrObservableArrayOf: arrayOrObservableArrayOf,
  objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
  // `function() {}` has prototype, but `() => {}` doesn't
  // `() => {}` via Babel has prototype too.
  return !(component.prototype && component.prototype.render);
}
var symbolId = 0;

function createSymbol(name) {
  if (typeof Symbol === "function") {
    return Symbol(name);
  }

  var symbol = "__$mobx-react ".concat(name, " (").concat(symbolId, ")");
  symbolId++;
  return symbol;
}

var createdSymbols = {};
function newSymbol(name) {
  if (!createdSymbols[name]) {
    createdSymbols[name] = createSymbol(name);
  }

  return createdSymbols[name];
}
var mobxMixins = newSymbol("patchMixins");
var mobxPatchedDefinition = newSymbol("patchedDefinition");

function getMixins(target, methodName) {
  var mixins = target[mobxMixins] = target[mobxMixins] || {};
  var methodMixins = mixins[methodName] = mixins[methodName] || {};
  methodMixins.locks = methodMixins.locks || 0;
  methodMixins.methods = methodMixins.methods || [];
  return methodMixins;
}

function wrapper(realMethod, mixins) {
  var _this = this;

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
  mixins.locks++;

  try {
    var retVal;

    if (realMethod !== undefined && realMethod !== null) {
      retVal = realMethod.apply(this, args);
    }

    return retVal;
  } finally {
    mixins.locks--;

    if (mixins.locks === 0) {
      mixins.methods.forEach(function (mx) {
        mx.apply(_this, args);
      });
    }
  }
}

function wrapFunction(realMethod, mixins) {
  var fn = function fn() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    wrapper.call.apply(wrapper, [this, realMethod, mixins].concat(args));
  };

  return fn;
}

function patch(target, methodName) {
  var mixins = getMixins(target, methodName);

  for (var _len3 = arguments.length, mixinMethods = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    mixinMethods[_key3 - 2] = arguments[_key3];
  }

  for (var _i = 0; _i < mixinMethods.length; _i++) {
    var mixinMethod = mixinMethods[_i];

    if (mixins.methods.indexOf(mixinMethod) < 0) {
      mixins.methods.push(mixinMethod);
    }
  }

  var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);

  if (oldDefinition && oldDefinition[mobxPatchedDefinition]) {
    // already patched definition, do not repatch
    return;
  }

  var originalMethod = target[methodName];
  var newDefinition = createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
  Object.defineProperty(target, methodName, newDefinition);
}

function createDefinition(target, methodName, enumerable, mixins, originalMethod) {
  var _ref;

  var wrappedFunc = wrapFunction(originalMethod, mixins);
  return _ref = {}, _defineProperty(_ref, mobxPatchedDefinition, true), _defineProperty(_ref, "get", function get() {
    return wrappedFunc;
  }), _defineProperty(_ref, "set", function set(value) {
    if (this === target) {
      wrappedFunc = wrapFunction(value, mixins);
    } else {
      // when it is an instance of the prototype/a child prototype patch that particular case again separately
      // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
      // e.g. the method for super might not be the same as the method for the prototype which might be not the same
      // as the method for the instance
      var newDefinition = createDefinition(this, methodName, enumerable, mixins, value);
      Object.defineProperty(this, methodName, newDefinition);
    }
  }), _defineProperty(_ref, "configurable", true), _defineProperty(_ref, "enumerable", enumerable), _ref;
}

var injectorContextTypes = {
  mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);
var proxiedInjectorProps = {
  contextTypes: {
    get: function get() {
      return injectorContextTypes;
    },
    set: function set(_) {
      console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
    },
    configurable: true,
    enumerable: false
  },
  isMobxInjector: {
    value: true,
    writable: true,
    configurable: true,
    enumerable: true
  }
  /**
   * Store Injection
   */

};

function createStoreInjector(grabStoresFn, component, injectNames) {
  var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
  if (injectNames) displayName += "-with-" + injectNames;

  var Injector =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Injector, _Component);

    function Injector() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Injector);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Injector)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _this.storeRef = function (instance) {
        _this.wrappedInstance = instance;
      };

      return _this;
    }

    _createClass(Injector, [{
      key: "render",
      value: function render() {
        // Optimization: it might be more efficient to apply the mapper function *outside* the render method
        // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
        // See this test: 'using a custom injector is not too reactive' in inject.js
        var newProps = {};

        for (var key in this.props) {
          if (this.props.hasOwnProperty(key)) {
            newProps[key] = this.props[key];
          }
        }

        var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};

        for (var _key2 in additionalProps) {
          newProps[_key2] = additionalProps[_key2];
        }

        if (!isStateless(component)) {
          newProps.ref = this.storeRef;
        }

        return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(component, newProps);
      }
    }]);

    return Injector;
  }(react__WEBPACK_IMPORTED_MODULE_1__["Component"]); // Static fields from component should be visible on the generated Injector


  Injector.displayName = displayName;
  hoistNonReactStatics_cjs(Injector, component);
  Injector.wrappedComponent = component;
  Object.defineProperties(Injector, proxiedInjectorProps);
  return Injector;
}

function grabStoresByName(storeNames) {
  return function (baseStores, nextProps) {
    storeNames.forEach(function (storeName) {
      if (storeName in nextProps // prefer props over stores
      ) return;
      if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
      nextProps[storeName] = baseStores[storeName];
    });
    return nextProps;
  };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */


function inject()
/* fn(stores, nextProps) or ...storeNames */
{
  var grabStoresFn;

  if (typeof arguments[0] === "function") {
    grabStoresFn = arguments[0];
    return function (componentClass) {
      var injected = createStoreInjector(grabStoresFn, componentClass);
      injected.isMobxInjector = false; // supress warning
      // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
      // see #111

      injected = observer(injected);
      injected.isMobxInjector = true; // restore warning

      return injected;
    };
  } else {
    var storeNames = [];

    for (var i = 0; i < arguments.length; i++) {
      storeNames[i] = arguments[i];
    }

    grabStoresFn = grabStoresByName(storeNames);
    return function (componentClass) {
      return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
    };
  }
}

var mobxAdminProperty = mobx__WEBPACK_IMPORTED_MODULE_0__["$mobx"] || "$mobx";
var mobxIsUnmounted = newSymbol("isUnmounted");
/**
 * dev tool support
 */

var isDevtoolsEnabled = false;
var isUsingStaticRendering = false;
var warnedAboutObserverInjectDeprecation = false; // WeakMap<Node, Object>;

var componentByNodeRegistry = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();
var skipRenderKey = newSymbol("skipRender");
var isForcingUpdateKey = newSymbol("isForcingUpdate"); // Using react-is had some issues (and operates on elements, not on types), see #608 / #609

var ReactForwardRefSymbol = typeof react__WEBPACK_IMPORTED_MODULE_1__["forwardRef"] === "function" && Object(react__WEBPACK_IMPORTED_MODULE_1__["forwardRef"])(function (_props, _ref) {})["$$typeof"];
/**
 * Helper to set `prop` to `this` as non-enumerable (hidden prop)
 * @param target
 * @param prop
 * @param value
 */

function setHiddenProp(target, prop, value) {
  if (!Object.hasOwnProperty.call(target, prop)) {
    Object.defineProperty(target, prop, {
      enumerable: false,
      configurable: true,
      writable: true,
      value: value
    });
  } else {
    target[prop] = value;
  }
}

function findDOMNode$2(component) {
  if (react_dom__WEBPACK_IMPORTED_MODULE_2__["findDOMNode"]) {
    try {
      return Object(react_dom__WEBPACK_IMPORTED_MODULE_2__["findDOMNode"])(component);
    } catch (e) {
      // findDOMNode will throw in react-test-renderer, see:
      // See https://github.com/mobxjs/mobx-react/issues/216
      // Is there a better heuristic?
      return null;
    }
  }

  return null;
}

function reportRendering(component) {
  var node = findDOMNode$2(component);
  if (node && componentByNodeRegistry) componentByNodeRegistry.set(node, component);
  renderReporter.emit({
    event: "render",
    renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
    totalTime: Date.now() - component.__$mobRenderStart,
    component: component,
    node: node
  });
}

function trackComponents() {
  if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
  if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}
function useStaticRendering(useStaticRendering) {
  isUsingStaticRendering = useStaticRendering;
}
/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();
/**
 * Utilities
 */

function patch$1(target, funcName) {
  patch(target, funcName, reactiveMixin[funcName]);
}

function shallowEqual(objA, objB) {
  //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
  if (is(objA, objB)) return true;

  if (_typeof(objA) !== "object" || objA === null || _typeof(objB) !== "object" || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

function is(x, y) {
  // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function makeComponentReactive(render) {
  var _this2 = this;

  if (isUsingStaticRendering === true) return render.call(this);

  function reactiveRender() {
    var _this = this;

    isRenderingPending = false;
    var exception = undefined;
    var rendering = undefined;
    reaction.track(function () {
      if (isDevtoolsEnabled) {
        _this.__$mobRenderStart = Date.now();
      }

      try {
        rendering = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["_allowStateChanges"])(false, baseRender);
      } catch (e) {
        exception = e;
      }

      if (isDevtoolsEnabled) {
        _this.__$mobRenderEnd = Date.now();
      }
    });

    if (exception) {
      errorsReporter.emit(exception);
      throw exception;
    }

    return rendering;
  } // Generate friendly name for debugging


  var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
  var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalInstance && this._reactInternalInstance._debugID || this._reactInternalFiber && this._reactInternalFiber._debugID;
  /**
   * If props are shallowly modified, react will render anyway,
   * so atom.reportChanged() should not result in yet another re-render
   */

  setHiddenProp(this, skipRenderKey, false);
  /**
   * forceUpdate will re-assign this.props. We don't want that to cause a loop,
   * so detect these changes
   */

  setHiddenProp(this, isForcingUpdateKey, false); // wire up reactive render

  var baseRender = render.bind(this);
  var isRenderingPending = false;
  var reaction = new mobx__WEBPACK_IMPORTED_MODULE_0__["Reaction"]("".concat(initialName, "#").concat(rootNodeID, ".render()"), function () {
    if (!isRenderingPending) {
      // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
      // This unidiomatic React usage but React will correctly warn about this so we continue as usual
      // See #85 / Pull #44
      isRenderingPending = true;
      if (typeof _this2.componentWillReact === "function") _this2.componentWillReact(); // TODO: wrap in action?

      if (_this2[mobxIsUnmounted] !== true) {
        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
        // However, people also claim this might happen during unit tests..
        var hasError = true;

        try {
          setHiddenProp(_this2, isForcingUpdateKey, true);
          if (!_this2[skipRenderKey]) react__WEBPACK_IMPORTED_MODULE_1__["Component"].prototype.forceUpdate.call(_this2);
          hasError = false;
        } finally {
          setHiddenProp(_this2, isForcingUpdateKey, false);
          if (hasError) reaction.dispose();
        }
      }
    }
  });
  reaction.reactComponent = this;
  reactiveRender[mobxAdminProperty] = reaction;
  this.render = reactiveRender;
  return reactiveRender.call(this);
}
/**
 * ReactiveMixin
 */


var reactiveMixin = {
  componentWillUnmount: function componentWillUnmount() {
    if (isUsingStaticRendering === true) return;
    this.render[mobxAdminProperty] && this.render[mobxAdminProperty].dispose();
    this[mobxIsUnmounted] = true;

    if (isDevtoolsEnabled) {
      var node = findDOMNode$2(this);

      if (node && componentByNodeRegistry) {
        componentByNodeRegistry.delete(node);
      }

      renderReporter.emit({
        event: "destroy",
        component: this,
        node: node
      });
    }
  },
  componentDidMount: function componentDidMount() {
    if (isDevtoolsEnabled) {
      reportRendering(this);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    if (isDevtoolsEnabled) {
      reportRendering(this);
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    if (isUsingStaticRendering) {
      console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    } // update on any state changes (as is the default)


    if (this.state !== nextState) {
      return true;
    } // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.


    return !shallowEqual(this.props, nextProps);
  }
};

function makeObservableProp(target, propName) {
  var valueHolderKey = newSymbol("reactProp_".concat(propName, "_valueHolder"));
  var atomHolderKey = newSymbol("reactProp_".concat(propName, "_atomHolder"));

  function getAtom() {
    if (!this[atomHolderKey]) {
      setHiddenProp(this, atomHolderKey, Object(mobx__WEBPACK_IMPORTED_MODULE_0__["createAtom"])("reactive " + propName));
    }

    return this[atomHolderKey];
  }

  Object.defineProperty(target, propName, {
    configurable: true,
    enumerable: true,
    get: function get() {
      getAtom.call(this).reportObserved();
      return this[valueHolderKey];
    },
    set: function set(v) {
      if (!this[isForcingUpdateKey] && !shallowEqual(this[valueHolderKey], v)) {
        setHiddenProp(this, valueHolderKey, v);
        setHiddenProp(this, skipRenderKey, true);
        getAtom.call(this).reportChanged();
        setHiddenProp(this, skipRenderKey, false);
      } else {
        setHiddenProp(this, valueHolderKey, v);
      }
    }
  });
}
/**
 * Observer function / decorator
 */


function observer(arg1, arg2) {
  if (typeof arg1 === "string") {
    throw new Error("Store names should be provided as array");
  }

  if (Array.isArray(arg1)) {
    // TODO: remove in next major
    // component needs stores
    if (!warnedAboutObserverInjectDeprecation) {
      warnedAboutObserverInjectDeprecation = true;
      console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
    }

    if (!arg2) {
      // invoked as decorator
      return function (componentClass) {
        return observer(arg1, componentClass);
      };
    } else {
      return inject.apply(null, arg1)(observer(arg2));
    }
  }

  var componentClass = arg1;

  if (componentClass.isMobxInjector === true) {
    console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
  }

  if (componentClass.__proto__ === react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]) {
    console.warn("Mobx observer: You are using 'observer' on React.PureComponent. These two achieve two opposite goals and should not be used together");
  } // Unwrap forward refs into `<Observer>` component
  // we need to unwrap the render, because it is the inner render that needs to be tracked,
  // not the ForwardRef HoC


  if (ReactForwardRefSymbol && componentClass["$$typeof"] === ReactForwardRefSymbol) {
    var _baseRender = componentClass.render;
    if (typeof _baseRender !== "function") throw new Error("render property of ForwardRef was not a function"); // TODO: do we need to hoist statics from baseRender to the forward ref?

    return Object(react__WEBPACK_IMPORTED_MODULE_1__["forwardRef"])(function ObserverForwardRef() {
      var _arguments = arguments;
      return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(Observer, null, function () {
        return _baseRender.apply(undefined, _arguments);
      });
    });
  } // Stateless function component:
  // If it is function but doesn't seem to be a react class constructor,
  // wrap it to a react class automatically


  if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !react__WEBPACK_IMPORTED_MODULE_1__["Component"].isPrototypeOf(componentClass)) {
    var _class, _temp;

    var observerComponent = observer((_temp = _class =
    /*#__PURE__*/
    function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          return componentClass.call(this, this.props, this.context);
        }
      }]);

      return _class;
    }(react__WEBPACK_IMPORTED_MODULE_1__["Component"]), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
    hoistNonReactStatics_cjs(observerComponent, componentClass);
    return observerComponent;
  }

  if (!componentClass) {
    throw new Error("Please pass a valid component to 'observer'");
  }

  var target = componentClass.prototype || componentClass;
  mixinLifecycleEvents(target);
  componentClass.isMobXReactObserver = true;
  makeObservableProp(target, "props");
  makeObservableProp(target, "state");
  var baseRender = target.render;

  target.render = function () {
    return makeComponentReactive.call(this, baseRender);
  };

  return componentClass;
}

function mixinLifecycleEvents(target) {
  ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
    patch$1(target, funcName);
  });

  if (!target.shouldComponentUpdate) {
    target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
  } else {
    if (target.shouldComponentUpdate !== reactiveMixin.shouldComponentUpdate) {
      // TODO: make throw in next major
      console.warn("Use `shouldComponentUpdate` in an `observer` based component breaks the behavior of `observer` and might lead to unexpected results. Manually implementing `sCU` should not be needed when using mobx-react.");
    }
  }
}

var Observer = observer(function (_ref2) {
  var children = _ref2.children,
      observerInject = _ref2.inject,
      render = _ref2.render;
  var component = children || render;

  if (typeof component === "undefined") {
    return null;
  }

  if (!observerInject) {
    return component();
  } // TODO: remove in next major


  console.warn("<Observer inject=.../> is no longer supported. Please use inject on the enclosing component instead");
  var InjectComponent = inject(observerInject)(component);
  return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(InjectComponent, null);
});
Observer.displayName = "Observer";

var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
  var extraKey = key === "children" ? "render" : "children";

  if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
    return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
  }

  if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
    return;
  }

  return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
};

Observer.propTypes = {
  render: ObserverPropsCheck,
  children: ObserverPropsCheck
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component$$1) {
  var prototype = Component$$1.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component$$1.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component$$1;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component$$1.displayName || Component$$1.name;
    var newApiName =
      typeof Component$$1.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component$$1.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component$$1;
}

var specialReactKeys = {
  children: true,
  key: true,
  ref: true
};

var Provider =
/*#__PURE__*/
function (_Component) {
  _inherits(Provider, _Component);

  function Provider(props, context) {
    var _this;

    _classCallCheck(this, Provider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Provider).call(this, props, context));
    _this.state = {};
    copyStores(props, _this.state);
    return _this;
  }

  _createClass(Provider, [{
    key: "render",
    value: function render() {
      return react__WEBPACK_IMPORTED_MODULE_1__["Children"].only(this.props.children);
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      var stores = {}; // inherit stores

      copyStores(this.context.mobxStores, stores); // add own stores

      copyStores(this.props, stores);
      return {
        mobxStores: stores
      };
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!nextProps) return null;
      if (!prevState) return nextProps; // Maybe this warning is too aggressive?

      if (Object.keys(nextProps).filter(validStoreName).length !== Object.keys(prevState).filter(validStoreName).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
      if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
        if (validStoreName(key) && prevState[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
      }
      return nextProps;
    }
  }]);

  return Provider;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]);

Provider.contextTypes = {
  mobxStores: objectOrObservableObject
};
Provider.childContextTypes = {
  mobxStores: objectOrObservableObject.isRequired
};

function copyStores(from, to) {
  if (!from) return;

  for (var key in from) {
    if (validStoreName(key)) to[key] = from[key];
  }
}

function validStoreName(key) {
  return !specialReactKeys[key] && key !== "suppressChangedStoreWarning";
} // TODO: kill in next major


polyfill(Provider);

var storeKey = newSymbol("disposeOnUnmount");

function runDisposersOnWillUnmount() {
  var _this = this;

  if (!this[storeKey]) {
    // when disposeOnUnmount is only set to some instances of a component it will still patch the prototype
    return;
  }

  this[storeKey].forEach(function (propKeyOrFunction) {
    var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;

    if (prop !== undefined && prop !== null) {
      if (typeof prop !== "function") {
        throw new Error("[mobx-react] disposeOnUnmount only works on functions such as disposers returned by reactions, autorun, etc.");
      }

      prop();
    }
  });
  this[storeKey] = [];
}

function disposeOnUnmount(target, propertyKeyOrFunction) {
  if (Array.isArray(propertyKeyOrFunction)) {
    return propertyKeyOrFunction.map(function (fn) {
      return disposeOnUnmount(target, fn);
    });
  }

  if (!target instanceof react__WEBPACK_IMPORTED_MODULE_1__["Component"]) {
    throw new Error("[mobx-react] disposeOnUnmount only works on class based React components.");
  }

  if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function") {
    throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
  } // add property key / function we want run (disposed) to the store


  var componentWasAlreadyModified = !!target[storeKey];
  var store = target[storeKey] || (target[storeKey] = []);
  store.push(propertyKeyOrFunction); // tweak the component class componentWillUnmount if not done already

  if (!componentWasAlreadyModified) {
    patch(target, "componentWillUnmount", runDisposersOnWillUnmount);
  } // return the disposer as is if invoked as a non decorator


  if (typeof propertyKeyOrFunction !== "string") {
    return propertyKeyOrFunction;
  }
}

if (!react__WEBPACK_IMPORTED_MODULE_1__["Component"]) throw new Error("mobx-react requires React to be available");
if (!mobx__WEBPACK_IMPORTED_MODULE_0__["spy"]) throw new Error("mobx-react requires mobx to be available");
if (typeof react_dom__WEBPACK_IMPORTED_MODULE_2__["unstable_batchedUpdates"] === "function") Object(mobx__WEBPACK_IMPORTED_MODULE_0__["configure"])({
  reactionScheduler: react_dom__WEBPACK_IMPORTED_MODULE_2__["unstable_batchedUpdates"]
});
var onError = function onError(fn) {
  return errorsReporter.on(fn);
};

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
  var mobx = {
    spy: mobx__WEBPACK_IMPORTED_MODULE_0__["spy"],
    extras: {
      getDebugName: mobx__WEBPACK_IMPORTED_MODULE_0__["getDebugName"]
    }
  };
  var mobxReact = {
    renderReporter: renderReporter,
    componentByNodeRegistry: componentByNodeRegistry,
    componentByNodeRegistery: componentByNodeRegistry,
    trackComponents: trackComponents
  };

  __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx);
}




/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(243);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(244);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hi = void 0;
const React = __webpack_require__(0);
const Viewer_1 = __webpack_require__(94);
class Hi extends React.Component {
    render() {
        let children = this.props.children;
        if (!children)
            return null;
        if (typeof children !== 'string')
            return children; // Gracefully (and silently) fail if not a string.
        let term = this.context;
        if (!term || term.length <= 1)
            return children;
        term = term && term.replace(/[\-\[\]\/\{\}\(\)\+\?\.\\\^\$\|]/g, "\\$&").replace(/\*/g, ".*");
        return children
            .split(new RegExp(`(${term.split(/\s+/).filter(part => part).join('|')})`, 'i'))
            .map((word, i) => i % 2 === 1 ? React.createElement("mark", { key: i }, word) : word);
    }
}
exports.Hi = Hi;
Hi.contextType = Viewer_1.FilterKeywordContext;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = decimal

// Check if the given character code, or the character code at the first
// character, is decimal.
function decimal(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character

  return code >= 48 && code <= 57 /* 0-9 */
}


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = visit

var visitParents = __webpack_require__(299)

var CONTINUE = visitParents.CONTINUE
var SKIP = visitParents.SKIP
var EXIT = visitParents.EXIT

visit.CONTINUE = CONTINUE
visit.SKIP = SKIP
visit.EXIT = EXIT

function visit(tree, test, visitor, reverse) {
  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor
    visitor = test
    test = null
  }

  visitParents(tree, test, overload, reverse)

  function overload(node, parents) {
    var parent = parents[parents.length - 1]
    var index = parent ? parent.children.indexOf(node) : null
    return visitor(node, index, parent)
  }
}


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(383);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterItemByText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return renderDropdownSelectedItemText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return filterItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return filterTreeItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return filterMatchedItemByListboxType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return renderHighlightedText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getHighlightedText; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Dropdown_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51);
/* harmony import */ var _Dropdown_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Dropdown_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var _Core_TimerManagement__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41);
/* harmony import */ var _Core_Util_Accessibility__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15);
/* harmony import */ var _Core_Util_String__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16);
/* harmony import */ var _List__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21);
/* harmony import */ var _ListBox__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8);
/* harmony import */ var _Resources_Dropdown__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17);
/* harmony import */ var _Table__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1);
/* harmony import */ var _Utilities_DropdownSelection__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(46);
/* harmony import */ var _Utilities_Provider__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(36);
/* harmony import */ var _DropdownCallout__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(53);
/* harmony import */ var _DropdownExpandableTextField__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(81);



















var Dropdown = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.expandable = react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
        _this.expandableContainer = react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
        _this.filterText = new _Core_Observable__WEBPACK_IMPORTED_MODULE_5__["ObservableValue"]("");
        _this.collapse = function () {
            if (_this.expandable.current) {
                _this.expandable.current.collapse();
            }
        };
        _this.expand = function () {
            if (_this.expandable.current) {
                _this.expandable.current.expand();
            }
        };
        _this.onDismiss = function () {
            if (_this.expandable.current) {
                _this.expandable.current.collapse();
            }
        };
        _this.onExpand = function () {
            if (_this.props.onExpand) {
                _this.props.onExpand();
            }
            _this.updateFilteredItems();
            _this.state.expanded.value = true;
        };
        _this.onCollapse = function () {
            if (_this.props.onCollapse) {
                _this.props.onCollapse();
            }
            _this.state.expanded.value = false;
        };
        _this.onActivate = function (event, item) {
            if (!event.defaultPrevented && event.type === "keydown") {
                var multiSelect = _this.props.enforceSingleSelect ? false : _this.state.filteredSelection.multiSelect;
                if (multiSelect) {
                    _this.state.filteredSelection.toggle(_this.state.filteredItems.value.indexOf(item), _this.state.filteredSelection.alwaysMerge, multiSelect);
                }
                else {
                    _this.state.filteredSelection.select(_this.state.filteredItems.value.indexOf(item), 1, _this.state.filteredSelection.alwaysMerge, multiSelect);
                }
                _this.onSelect(event, item);
            }
        };
        _this.onFilterTextChanged = function (e, newValue) {
            _this.filterText.value = newValue;
            _this.debouncedUpdateFilteredItems();
        };
        _this.onSelect = function (event, item) {
            var _a = _this.props, dismissOnSelect = _a.dismissOnSelect, onSelect = _a.onSelect;
            var selection = _this.parentSelection;
            if (onSelect) {
                onSelect(event, item);
            }
            if (dismissOnSelect !== undefined
                ? dismissOnSelect
                : selection.value.length > 0 && !(_this.props.enforceSingleSelect ? false : selection.multiSelect) && !selection.selectOnFocus) {
                _this.onDismiss();
            }
        };
        _this.selectionChanged = function (value, action) {
            _this.state.filteredSelection.selectionChanged(value, action);
            return true;
        };
        _this.renderCallout = function (dropdown, dropdownId, anchorElement, anchorOffset, anchorOrigin, anchorPoint, dropdownOrigin) {
            var _a = _this.props, actions = _a.actions, calloutContentClassName = _a.calloutContentClassName, columns = _a.columns, containerClassName = _a.containerClassName, filterPlaceholderText = _a.filterPlaceholderText, filteredNoResultsText = _a.filteredNoResultsText, getUnselectableRanges = _a.getUnselectableRanges, items = _a.items, loading = _a.loading, noItemsText = _a.noItemsText, onToggle = _a.onToggle, renderItem = _a.renderItem, renderBeforeContent = _a.renderBeforeContent, searching = _a.searching, showFilterBox = _a.showFilterBox, showItemsWhileSearching = _a.showItemsWhileSearching, showTree = _a.showTree, userFilteredItems = _a.userFilteredItems;
            var width = _this.props.width;
            if (width === undefined && _this.expandableContainer.current) {
                width = Math.max(_this.expandableContainer.current.clientWidth, 100);
            }
            var _b = _this.state, filteredItems = _b.filteredItems, filterText = _b.filterText, filteredSelection = _b.filteredSelection;
            var calloutProps = {
                actions: actions,
                anchorElement: anchorElement,
                anchorOffset: anchorOffset,
                anchorOrigin: anchorOrigin,
                anchorPoint: anchorPoint,
                calloutContentClassName: calloutContentClassName,
                columns: columns,
                containerClassName: containerClassName,
                dropdownOrigin: dropdownOrigin,
                filteredItems: filteredItems,
                filteredNoResultsText: filteredNoResultsText,
                selection: filteredSelection,
                filterPlaceholderText: filterPlaceholderText,
                filterText: filterText,
                getUnselectableRanges: getUnselectableRanges,
                id: dropdownId,
                items: items,
                loading: loading,
                noItemsText: noItemsText,
                onActivate: _this.onActivate,
                onFilterTextChanged: _this.onFilterTextChanged,
                onDismiss: _this.onDismiss,
                onSelect: _this.onSelect,
                onToggle: onToggle,
                renderBeforeContent: renderBeforeContent,
                renderItem: renderItem,
                searching: searching,
                showItemsWhileSearching: showItemsWhileSearching,
                showFilterBox: showFilterBox,
                showTree: showTree,
                updateFilteredItems: _this.updateFilteredItems,
                userFilteredItems: userFilteredItems,
                width: width
            };
            return _this.props.renderCallout(calloutProps);
        };
        _this.updateFilteredItems = function () {
            updateFilteredItems(_this.props, _this.state);
            return true;
        };
        _this.debouncedUpdateFilteredItems = function () {
            updateFilteredItems(_this.props, _this.state);
        };
        _this.parentSelection = props.selection || new _Utilities_DropdownSelection__WEBPACK_IMPORTED_MODULE_15__["DropdownSelection"]();
        // string items are wrapped once here.  Only use a string array in the simple case where the items are not changing.
        var wrappedItems = Object(_ListBox__WEBPACK_IMPORTED_MODULE_10__[/* wrapListBoxItems */ "e"])(props.items);
        var itemsValue = Object(_ListBox__WEBPACK_IMPORTED_MODULE_10__[/* getListBoxItemsValue */ "c"])(wrappedItems || props.items);
        _this.timerManagement = new _Core_TimerManagement__WEBPACK_IMPORTED_MODULE_6__[/* TimerManagement */ "a"]();
        _this.state = {
            expanded: new _Core_Observable__WEBPACK_IMPORTED_MODULE_5__["ObservableValue"](false),
            filteredItems: new _Core_Observable__WEBPACK_IMPORTED_MODULE_5__["ObservableArray"](Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])(itemsValue)),
            filteredSelection: new _List__WEBPACK_IMPORTED_MODULE_9__["FilteredListSelection"](_this.parentSelection),
            filterText: _this.filterText,
            props: props,
            wrappedItems: wrappedItems
        };
        return _this;
    }
    Dropdown.getDerivedStateFromProps = function (props, state) {
        if (props.userFilteredItems !== state.props.userFilteredItems || props.items !== state.props.items) {
            updateFilteredItems(props, state);
        }
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, state), { props: props, wrappedItems: Object(_ListBox__WEBPACK_IMPORTED_MODULE_10__[/* wrapListBoxItems */ "e"])(props.items) });
    };
    Dropdown.prototype.componentDidMount = function () {
        if (this.props.filterThrottleWait) {
            this.debouncedUpdateFilteredItems = this.timerManagement.debounce(this.debouncedUpdateFilteredItems, this.props.filterThrottleWait);
        }
    };
    Dropdown.prototype.render = function () {
        var _this = this;
        var _a = this.props, ariaLabel = _a.ariaLabel, className = _a.className, disabled = _a.disabled, enforceSingleSelect = _a.enforceSingleSelect, excludeTabStop = _a.excludeTabStop, items = _a.items, placeholder = _a.placeholder, renderExpandable = _a.renderExpandable, renderSelectedItems = _a.renderSelectedItems, showPrefix = _a.showPrefix;
        var selectionObservable = { observableValue: this.parentSelection, filter: this.selectionChanged };
        return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_11__["ItemsObserver"], { getUnselectableRanges: this.props.getUnselectableRanges, items: items, selection: this.parentSelection },
            react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_11__["Observer"], { selection: selectionObservable }, function () {
                return renderExpandable({
                    ariaLabel: ariaLabel,
                    className: Object(_Util__WEBPACK_IMPORTED_MODULE_14__["css"])(className, "bolt-dropdown-expandable"),
                    containerRef: _this.expandableContainer,
                    disabled: disabled,
                    enforceSingleSelect: enforceSingleSelect,
                    excludeTabStop: excludeTabStop,
                    placeholder: placeholder,
                    onCollapse: _this.onCollapse,
                    onExpand: _this.onExpand,
                    expandableRef: _this.expandable,
                    renderCallout: _this.renderCallout,
                    items: Object(_ListBox__WEBPACK_IMPORTED_MODULE_10__[/* getListBoxItemsValue */ "c"])(_this.state.wrappedItems || items),
                    renderSelectedItems: renderSelectedItems,
                    selection: _this.parentSelection,
                    showPrefix: showPrefix
                });
            })));
    };
    Dropdown.prototype.focus = function () {
        if (this.expandable.current) {
            this.expandable.current.focus();
        }
    };
    Dropdown.defaultProps = {
        filterByText: true,
        filterItem: filterItemByText,
        getUnselectableRanges: _ListBox__WEBPACK_IMPORTED_MODULE_10__[/* getUnselectableRanges */ "d"],
        renderCallout: _DropdownCallout__WEBPACK_IMPORTED_MODULE_17__[/* DropdownCallout */ "a"],
        renderExpandable: _DropdownExpandableTextField__WEBPACK_IMPORTED_MODULE_18__[/* DropdownExpandableTextField */ "a"],
        renderSelectedItems: renderDropdownSelectedItemText
    };
    return Dropdown;
}(react__WEBPACK_IMPORTED_MODULE_4__["Component"]));

function filterItemByText(filterText, item) {
    if (item.text && item.type !== _ListBox__WEBPACK_IMPORTED_MODULE_10__[/* ListBoxItemType */ "b"].Header && item.type !== _ListBox__WEBPACK_IMPORTED_MODULE_10__[/* ListBoxItemType */ "b"].Divider && item.type !== _ListBox__WEBPACK_IMPORTED_MODULE_10__[/* ListBoxItemType */ "b"].Loading) {
        return item.text.toLowerCase().indexOf(filterText.toLowerCase()) !== -1;
    }
    return false;
}
function renderDropdownSelectedItemText(selection, items) {
    var firstSelectedItem = items[selection.value[0].beginIndex];
    var text = (firstSelectedItem && firstSelectedItem.text) || "";
    if (selection.selectedCount > 1) {
        text = text + " (+" + (selection.selectedCount - 1) + ")";
    }
    return text;
}
function updateFilteredItems(props, state) {
    var filteredSelection = state.filteredSelection, filterText = state.filterText;
    var filteredIndexMap = [];
    var items = Object(_ListBox__WEBPACK_IMPORTED_MODULE_10__[/* getListBoxItemsValue */ "c"])(state.wrappedItems || props.items);
    var filteredItems = items;
    if (props.userFilteredItems) {
        filteredItems = Object(_Utilities_Provider__WEBPACK_IMPORTED_MODULE_16__[/* getItemsValue */ "b"])(props.userFilteredItems);
        var userFilteredItemsIndexMap = props.userFilteredItemsIndexMap && props.userFilteredItemsIndexMap.value;
        if (userFilteredItemsIndexMap) {
            filteredIndexMap = userFilteredItemsIndexMap;
        }
        else {
            var _loop_1 = function (filteredIndex) {
                var index = items.findIndex(function (listItem) { return listItem.id === filteredItems[filteredIndex].id; });
                if (false) {}
                filteredIndexMap.push(index);
            };
            for (var filteredIndex = 0; filteredIndex < props.userFilteredItems.length; filteredIndex++) {
                _loop_1(filteredIndex);
            }
        }
    }
    if (props.filterByText && filterText.value) {
        var filterItemsResults = filterItems(filteredItems, filterText.value, filteredIndexMap, props.filterItem);
        filteredItems = filterItemsResults.filteredItems;
        filteredIndexMap = filterItemsResults.filteredIndexMap;
    }
    // Remove the first item if it's a divider
    while (filteredItems.length && filteredItems[0].type === _ListBox__WEBPACK_IMPORTED_MODULE_10__[/* ListBoxItemType */ "b"].Divider) {
        filteredItems.shift();
        filteredIndexMap.shift();
    }
    if (!_Core_Observable__WEBPACK_IMPORTED_MODULE_5__["ObservableLike"].getValue(props.searching) && !_Core_Observable__WEBPACK_IMPORTED_MODULE_5__["ObservableLike"].getValue(props.loading) && state.expanded.value) {
        if (filterText.value) {
            var noResultsText = _Resources_Dropdown__WEBPACK_IMPORTED_MODULE_12__[/* NoFilterResults */ "n"];
            if (props.filteredNoResultsText) {
                noResultsText = _Core_Observable__WEBPACK_IMPORTED_MODULE_5__["ObservableLike"].getValue(props.filteredNoResultsText);
            }
            _Core_Util_Accessibility__WEBPACK_IMPORTED_MODULE_7__[/* announce */ "a"](filteredItems.length > 0 ? Object(_Core_Util_String__WEBPACK_IMPORTED_MODULE_8__[/* format */ "a"])(_Resources_Dropdown__WEBPACK_IMPORTED_MODULE_12__[/* AnnounceFilterResultCount */ "b"], filteredItems.length) : noResultsText, true);
        }
        else if (filteredItems.length === 0 && props.noItemsText) {
            _Core_Util_Accessibility__WEBPACK_IMPORTED_MODULE_7__[/* announce */ "a"](props.noItemsText, true);
        }
        else if (filteredItems.length > 0) {
            _Core_Util_Accessibility__WEBPACK_IMPORTED_MODULE_7__[/* announce */ "a"](Object(_Core_Util_String__WEBPACK_IMPORTED_MODULE_8__[/* format */ "a"])(_Resources_Dropdown__WEBPACK_IMPORTED_MODULE_12__[/* AnnounceItemCount */ "d"], filteredItems.length));
        }
    }
    filteredSelection.updateFilteredSelection(filteredIndexMap, props.enforceSingleSelect ? false : undefined);
    state.filteredItems.value = filteredItems;
    return true;
}
function filterItems(items, filterTextValue, currentFilteredIndexMap, filterItem) {
    if (currentFilteredIndexMap === void 0) { currentFilteredIndexMap = []; }
    if (filterItem === void 0) { filterItem = filterItemByText; }
    var filteredItems = [];
    var filteredIndexMap = [];
    var filterMatches = [];
    if (filterTextValue) {
        var lastHeader = void 0;
        var lastHeaderIndex = -1;
        var lastDivider = void 0;
        var lastDividerIndex = -1;
        for (var i = 0, l = items.length; i < l; i++) {
            var item = items[i];
            var itemIndex = currentFilteredIndexMap.length ? currentFilteredIndexMap[i] : i;
            // Add Dividers and Headers only if they have an item from their group showing.
            if (item.type === _ListBox__WEBPACK_IMPORTED_MODULE_10__[/* ListBoxItemType */ "b"].Header) {
                lastHeader = item;
                lastHeaderIndex = itemIndex;
            }
            else if (item.type === _ListBox__WEBPACK_IMPORTED_MODULE_10__[/* ListBoxItemType */ "b"].Divider) {
                lastDivider = item;
                lastDividerIndex = itemIndex;
            }
            else {
                var filterResults = filterItem(filterTextValue, item, items);
                if (filterResults || item.type === _ListBox__WEBPACK_IMPORTED_MODULE_10__[/* ListBoxItemType */ "b"].Loading) {
                    // Add any divider, then header for this group
                    if (lastDivider && lastDivider.groupId === item.groupId) {
                        filteredItems.push(lastDivider);
                        filteredIndexMap.push(lastDividerIndex);
                        lastDivider = undefined;
                    }
                    if (lastHeader && lastHeader.groupId === item.groupId) {
                        filteredItems.push(lastHeader);
                        filteredIndexMap.push(lastHeaderIndex);
                        lastHeader = undefined;
                    }
                    filteredItems.push(item);
                    filteredIndexMap.push(itemIndex);
                    filterMatches.push(Array.isArray(filterResults) ? filterResults : []);
                }
            }
        }
    }
    return { filteredItems: filteredItems, filteredIndexMap: filteredIndexMap, filterMatches: filterMatches };
}
/**
 * Filter the tree of items using user-entered text. Include all items with text matching
 * the filter and all their predecessors and descendants in the tree.
 * @returns items matching filter and all their predecessors and descendants in the tree, and the index of the first actual match (since we're returning predecessors)
 */
function filterTreeItems(items, filterText, currentFilteredIndexMap, filterItem, filterMatchedItem) {
    if (currentFilteredIndexMap === void 0) { currentFilteredIndexMap = []; }
    if (filterItem === void 0) { filterItem = filterItemByText; }
    if (filterMatchedItem === void 0) { filterMatchedItem = filterMatchedItemByListboxType; }
    var filterResults = filterItems(items, filterText, currentFilteredIndexMap, filterItem);
    var filteredIndexes = filterResults.filteredIndexMap;
    // find the index of the first actual match to allow calling code to focus it
    var firstMatch = filterResults.filteredItems.find(filterMatchedItem);
    // reconstruct the list of filtered items, adding in descendants of filtered items
    var indexMap = {};
    for (var _i = 0, filteredIndexes_1 = filteredIndexes; _i < filteredIndexes_1.length; _i++) {
        var index = filteredIndexes_1[_i];
        var item = items[index];
        var parent_1 = item.parent;
        while (parent_1) {
            var parentIndex = items.indexOf(parent_1);
            indexMap[parentIndex] = parent_1;
            parent_1.expanded = true;
            parent_1 = parent_1.parent;
        }
        indexMap[index] = item;
    }
    var filteredIndexMap = [];
    var filteredItems = [];
    for (var _a = 0, _b = Object.keys(indexMap); _a < _b.length; _a++) {
        var indexStr = _b[_a];
        var index = Number(indexStr);
        var value = indexMap[index];
        filteredIndexMap.push(index);
        filteredItems.push(value);
    }
    var firstMatchIndex = firstMatch ? items.indexOf(firstMatch) : -1;
    return [{ filteredIndexMap: filteredIndexMap, filteredItems: filteredItems, filterMatches: [] }, firstMatchIndex];
}
function filterMatchedItemByListboxType(item) {
    return !item.type || item.type === _ListBox__WEBPACK_IMPORTED_MODULE_10__[/* ListBoxItemType */ "b"].Row;
}
function renderHighlightedText(rowIndex, columnIndex, tableColumn, tableItem, filterResults) {
    var item = tableItem;
    if (filterResults && tableItem.text) {
        item = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, tableItem), { textNode: getHighlightedText(tableItem.text, filterResults) });
    }
    return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Table__WEBPACK_IMPORTED_MODULE_13__["SimpleTableCell"], { className: Object(_Util__WEBPACK_IMPORTED_MODULE_14__["css"])(tableColumn.className, tableItem.className, tableItem.type === _ListBox__WEBPACK_IMPORTED_MODULE_10__[/* ListBoxItemType */ "b"].Header && "bolt-list-box-header"), columnIndex: columnIndex, key: columnIndex, tableColumn: tableColumn },
        react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { id: tableItem.type === _ListBox__WEBPACK_IMPORTED_MODULE_10__[/* ListBoxItemType */ "b"].Header ? "header-" + tableItem.id : undefined, "aria-label": tableItem.type === _ListBox__WEBPACK_IMPORTED_MODULE_10__[/* ListBoxItemType */ "b"].Header ? Object(_Core_Util_String__WEBPACK_IMPORTED_MODULE_8__[/* format */ "a"])(_Resources_Dropdown__WEBPACK_IMPORTED_MODULE_12__[/* HeaderAriaLabel */ "k"], tableItem.text) : undefined }, Object(_List__WEBPACK_IMPORTED_MODULE_9__["renderListCell"])(item))));
}
function getHighlightedText(text, matchingIndices, className) {
    var splitText = [];
    var splitTextIndex = -1;
    // Split text into bold and non-bold sections
    for (var i = 0; i < text.length; i++) {
        if (matchingIndices.indexOf(i) !== -1) {
            if (splitText && splitText[splitText.length - 1] && splitText[splitText.length - 1].bold) {
                splitText[splitTextIndex].text += text.charAt(i);
            }
            else {
                splitText[++splitTextIndex] = { text: text.charAt(i), bold: true };
            }
        }
        else {
            if (splitText && splitText[splitText.length - 1] && !splitText[splitText.length - 1].bold) {
                splitText[splitTextIndex].text += text.charAt(i);
            }
            else {
                splitText[++splitTextIndex] = { text: text.charAt(i), bold: false };
            }
        }
    }
    var formattedText = [];
    for (var i = 0; i < splitText.length; i++) {
        var substring = splitText[i];
        substring.bold
            ? formattedText.push(react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("span", { className: "font-weight-heavy", key: text + "-" + i }, substring.text))
            : formattedText.push(substring.text);
    }
    return react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("span", { className: className }, formattedText);
}


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListDragSourceBehavior; });
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _List_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44);
/* harmony import */ var _List_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_List_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45);
/* harmony import */ var _ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Utilities_DragDrop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27);
/* harmony import */ var _List__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35);







/**
 * A behavior that turns a list into the source of a drag and drop operation. Note - this
 * behavior should only be used if your list is intended to _only_ be a drag source. Please use
 * the ListDragDropBehavior instead if the list is also a drop target, as that is the only way
 * to get keyboard drag and drop support within your list.
 */
var ListDragSourceBehavior = /** @class */ (function () {
    function ListDragSourceBehavior(options) {
        var _this = this;
        this.initialize = function (props, dragDroppableUI, eventDispatch) {
            _this.dragDroppableUI = dragDroppableUI;
            _this.eventDispatch = eventDispatch;
            _this.eventDispatch.addEventListener("pointerdown", _this.onPointerDown);
            _this.eventDispatch.addEventListener("dragstart", _this.onDragStart);
            _this.eventDispatch.addEventListener("dragend", _this.onDragEnd);
            _this.itemProvider = props.itemProvider;
        };
        this.onDragEnd = function (event) {
            var index = Object(_List__WEBPACK_IMPORTED_MODULE_6__[/* cellFromEvent */ "f"])(event).rowIndex;
            if (index >= 0 && _this.options.onDragEnd) {
                _this.options.onDragEnd(event);
            }
            _this.dragDroppableUI.removeOverlay("drag-source-item");
            _this.dragImageData = undefined;
        };
        this.onDragStart = function (event) {
            if (event.detail.dataTransfer) {
                var index = Object(_List__WEBPACK_IMPORTED_MODULE_6__[/* cellFromEvent */ "f"])(event).rowIndex;
                if (index >= 0) {
                    if (_this.options.onDragStart) {
                        _this.options.onDragStart(event);
                    }
                    if (event.detail.dataTransfer.effectAllowed !== _Utilities_DragDrop__WEBPACK_IMPORTED_MODULE_5__[/* DragDropEffect */ "a"].none) {
                        _this.dragDroppableUI.addOverlay("drag-source-item", index, _this.renderDragSourceItemOverlay);
                        if (_this.dragImageData === undefined) {
                            _this.dragImageData = {
                                image: _this.options.renderDragImage(event)
                            };
                        }
                    }
                }
            }
            else {
                event.stopPropagation();
                event.preventDefault();
            }
        };
        this.onPointerDown = function (event) {
            if (event.button === 0) {
                _this.beginDrag(event);
            }
        };
        this.renderDragSourceItemOverlay = function (props) {
            return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](react__WEBPACK_IMPORTED_MODULE_4__["Fragment"], null,
                react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: "bolt-list-drag-source-item flex-grow" }),
                _this.operation && _this.dragImageData && react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Utilities_DragDrop__WEBPACK_IMPORTED_MODULE_5__[/* DragImage */ "b"], { operation: _this.operation }, _this.dragImageData.image)));
        };
        this.setDragImage = function (image, xOffset, yOffset) {
            _this.dragImageData = { image: image, xOffset: xOffset, yOffset: yOffset };
        };
        this.options = options;
    }
    ListDragSourceBehavior.prototype.componentDidUpdate = function (props) {
        this.itemProvider = props.itemProvider;
    };
    ListDragSourceBehavior.prototype.componentWillUnmount = function () {
        var _a, _b, _c;
        (_a = this.eventDispatch) === null || _a === void 0 ? void 0 : _a.removeEventListener("pointerdown", this.onPointerDown);
        (_b = this.eventDispatch) === null || _b === void 0 ? void 0 : _b.removeEventListener("dragstart", this.onDragStart);
        (_c = this.eventDispatch) === null || _c === void 0 ? void 0 : _c.removeEventListener("dragend", this.onDragEnd);
    };
    ListDragSourceBehavior.prototype.beginDrag = function (event) {
        var index = Object(_List__WEBPACK_IMPORTED_MODULE_6__[/* cellFromEvent */ "f"])(event).rowIndex;
        if (this.itemProvider && index >= 0) {
            var item = this.itemProvider.value[index];
            this.operation = Object(_Utilities_DragDrop__WEBPACK_IMPORTED_MODULE_5__[/* beginDragOperation */ "c"])(event, {
                data: item,
                dropEffect: _Utilities_DragDrop__WEBPACK_IMPORTED_MODULE_5__[/* DragDropEffect */ "a"].none,
                secondaryData: { index: index, sourceId: this.options.id },
                setDragImage: this.setDragImage,
                type: this.options.type
            });
        }
    };
    return ListDragSourceBehavior;
}());



/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(138);
/* harmony import */ var _Button_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Button_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ExpandableButton_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(139);
/* harmony import */ var _ExpandableButton_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ExpandableButton_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _FocusGroup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31);
/* harmony import */ var _FocusZone__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9);
/* harmony import */ var _TooltipEx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1);
/* harmony import */ var _Utilities_Focus__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26);












var Button = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonElement = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.onClick = function (event) {
            if (!_this.props.disabled) {
                var onClick = _this.props.onClick;
                // @NOTE: Safari doesnt set focus to buttons when they are clicked, we need this
                //  to help manage the focus state for callouts.
                _this.focus();
                if (onClick) {
                    onClick(event);
                }
            }
            else {
                event.preventDefault();
            }
        };
        _this.onFocus = function (event) {
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
            if (_this.props.id) {
                // @NOTE: Due to test issues using React.16.3.2 we MUST validate the onFocus method.
                _this.context.onFocus && _this.context.onFocus(_this.props.id);
            }
        };
        _this.onKeyDown = function (event) {
            if (!event.defaultPrevented && !_this.props.disabled) {
                if (event.which === _Util__WEBPACK_IMPORTED_MODULE_10__["KeyCode"].enter || event.which === _Util__WEBPACK_IMPORTED_MODULE_10__["KeyCode"].space) {
                    if (_this.props.onClick) {
                        _this.props.onClick(event);
                    }
                    if (!_this.props.href) {
                        event.preventDefault();
                    }
                }
                else if (_this.props.onKeyDown) {
                    _this.props.onKeyDown(event);
                }
            }
        };
        _this.onMouseDown = function (event) {
            if (!event.defaultPrevented) {
                if (_this.props.disabled) {
                    event.preventDefault();
                }
            }
            var onMouseDown = _this.props.onMouseDown;
            if (onMouseDown) {
                onMouseDown(event);
            }
        };
        _this.onMouseLeave = function (event) {
            if (!_this.props.disabled) {
                var onMouseLeave = _this.props.onMouseLeave;
                if (onMouseLeave) {
                    onMouseLeave(event);
                }
            }
        };
        _this.onMouseOver = function (event) {
            if (!_this.props.disabled) {
                var onMouseOver = _this.props.onMouseOver;
                if (onMouseOver) {
                    onMouseOver(event);
                }
            }
        };
        return _this;
    }
    Button.prototype.render = function () {
        var _this = this;
        if (false) {}
        // Determine if the button is an iconOnly button.
        var iconOnly = this.props.iconProps && !this.props.text && Object(_Util__WEBPACK_IMPORTED_MODULE_10__["childCount"])(this.props.children) === 0;
        var tooltipProps = this.props.tooltipProps !== undefined
            ? this.props.tooltipProps
            : iconOnly && this.props.ariaLabel
                ? { text: this.props.ariaLabel }
                : undefined;
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_7__[/* FocusZoneContext */ "b"].Consumer, null, function (zoneContext) {
            var ButtonType = _this.props.href ? "a" : "button";
            // @TODO (line-height): remove the body-m from the text once the line-height is applied globally.
            var role = _this.props.role || (_this.props.href ? "link" : "button");
            var button = (
            // @ts-ignore TypeScript no longer works with dynamic intrinsic component types.
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"](ButtonType, { autoFocus: !_this.props.href ? _this.props.autoFocus : undefined, "aria-controls": Object(_Util__WEBPACK_IMPORTED_MODULE_10__["getSafeId"])(_this.props.ariaControls), "aria-describedby": Object(_Util__WEBPACK_IMPORTED_MODULE_10__["getSafeId"])(_this.props.ariaDescribedBy), "aria-disabled": _this.props.disabled, "aria-expanded": _this.props.ariaExpanded, "aria-haspopup": _this.props.ariaHasPopup, "aria-label": _this.props.ariaLabel, "aria-labelledby": _this.props.ariaLabelledBy, "aria-setsize": _this.props.ariaSetSize, "aria-posinset": _this.props.ariaPosInSet, "aria-selected": _this.props.ariaSelected, "aria-checked": _this.props.ariaChecked, "aria-pressed": _this.props.ariaPressed, "aria-roledescription": _this.props.ariaRoleDescription, className: Object(_Util__WEBPACK_IMPORTED_MODULE_10__["css"])(_this.props.className, "bolt-button", _this.props.href && "bolt-link-button", _this.props.iconProps && "bolt-icon-button", _this.props.danger && "danger", _this.props.disabled ? "disabled" : "enabled", _this.props.primary && "primary", _this.props.subtle && "subtle", iconOnly && "icon-only", "bolt-focus-treatment"), "data-focuszone": !_this.props.disabled && !_this.props.excludeFocusZone
                    ? Object(_Util__WEBPACK_IMPORTED_MODULE_10__["css"])(_this.props.focusZoneId, zoneContext.focuszoneId)
                    : undefined, "data-index": _this.props.dataIndex, "data-is-focusable": !_this.props.excludeFocusZone, href: !_this.props.disabled ? _this.props.href : undefined, id: Object(_Util__WEBPACK_IMPORTED_MODULE_10__["getSafeId"])(_this.props.id), onBlur: _this.props.onBlur, onClick: _this.onClick, onMouseLeave: _this.onMouseLeave, onMouseOver: _this.onMouseOver, onKeyDown: _this.onKeyDown, onMouseDown: _this.onMouseDown, onFocus: _this.onFocus, rel: _this.props.rel, role: role, style: _this.props.style, tabIndex: Object(_Utilities_Focus__WEBPACK_IMPORTED_MODULE_11__[/* getTabIndex */ "a"])(_this.props, _this.context), target: _this.props.target, type: _this.props.type ? _this.props.type : !_this.props.href ? "button" : undefined, ref: _this.buttonElement },
                _this.props.iconProps &&
                    Object(_Icon__WEBPACK_IMPORTED_MODULE_8__["Icon"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({ size: _Icon__WEBPACK_IMPORTED_MODULE_8__["IconSize"].medium }, _this.props.iconProps), { className: Object(_Util__WEBPACK_IMPORTED_MODULE_10__["css"])(_this.props.iconProps.className, "left-icon") })),
                _this.props.text && react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("span", { className: "bolt-button-text body-m" }, _this.props.text),
                _this.props.children));
            if (tooltipProps) {
                button = (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_TooltipEx__WEBPACK_IMPORTED_MODULE_9__["Tooltip"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({ addAriaDescribedBy: true }, tooltipProps), button));
            }
            return button;
        }));
    };
    Button.prototype.focus = function () {
        if (this.buttonElement.current) {
            this.buttonElement.current.focus();
        }
    };
    Button.contextType = _FocusGroup__WEBPACK_IMPORTED_MODULE_6__["FocusGroupContext"];
    return Button;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));



/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return groupMenuItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Menu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MenuDivider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MenuHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MenuItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextualMenu; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Menu_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68);
/* harmony import */ var _Menu_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Menu_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _MenuButton_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69);
/* harmony import */ var _MenuButton_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_MenuButton_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4);
/* harmony import */ var _Callout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47);
/* harmony import */ var _Checkbox__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65);
/* harmony import */ var _FocusWithin__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23);
/* harmony import */ var _FocusZone__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9);
/* harmony import */ var _List__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(21);
/* harmony import */ var _MouseWithin__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(42);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8);
/* harmony import */ var _TooltipEx__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(19);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(1);
/* harmony import */ var _Utilities_Position__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(12);
/* harmony import */ var _Utilities_Provider__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(36);
/* harmony import */ var _Menu_Props__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(25);




















/**
 * Arrange the items into groups and put separators between them and headings above them as needed.
 *
 * @param items Menu items with optional order and groupKey properties
 * @param groupInfo Optional list of menu groups
 */
function groupMenuItems(items, groupInfo) {
    var groupMap = {};
    var maxGroupRank = 0;
    var ungroupedItems = [];
    var groups = groupInfo || [];
    // gather known groups
    if (groups.length > 0) {
        maxGroupRank = groups.reduce(function (max, g) { return (g.rank || 0 > max ? g.rank : max); }, 0) || 0;
        for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
            var g = groups_1[_i];
            groupMap[g.key] = {
                key: g.key,
                rank: g.rank === undefined ? ++maxGroupRank : g.rank,
                items: []
            };
        }
    }
    // put all menu items in groups
    for (var _a = 0, items_1 = items; _a < items_1.length; _a++) {
        var i = items_1[_a];
        if (i.groupKey) {
            if (groupMap[i.groupKey]) {
                groupMap[i.groupKey].items.push(i);
            }
            else {
                groupMap[i.groupKey] = {
                    key: i.groupKey,
                    rank: ++maxGroupRank,
                    items: [i]
                };
            }
        }
        else {
            ungroupedItems.push(i);
        }
    }
    // sort the groups
    var groupList = Object.keys(groupMap).map(function (n) { return groupMap[n]; });
    groupList.sort(function (a, b) { return (a.rank || Number.MAX_VALUE) - (b.rank || Number.MAX_VALUE); });
    // add ungrouped items to end of group list
    groupList.push({
        key: "ungrouped",
        rank: ++maxGroupRank,
        items: ungroupedItems
    });
    // remove dividers from the beginning and end of each group
    groupList.forEach(function (g) {
        var array = g.items;
        while (array.length > 0 && array[0].itemType === _Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuItemType */ "b"].Divider) {
            array.shift();
        }
        while (array.length > 0 && array[array.length - 1].itemType === _Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuItemType */ "b"].Divider) {
            array.pop();
        }
    });
    // merge the groups into the final array
    items = [];
    var first = true;
    for (var _b = 0, groupList_1 = groupList; _b < groupList_1.length; _b++) {
        var g = groupList_1[_b];
        if (g.items.length === 0) {
            continue;
        }
        // add the separator or header for the top of the group
        if (!first) {
            items.push({
                id: "divider_" + g.key,
                itemType: _Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuItemType */ "b"].Divider
            });
        }
        if (first) {
            first = false;
        }
        items = items.concat(g.items);
    }
    return items;
}
var MenuItemProvider = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(MenuItemProvider, _super);
    function MenuItemProvider(menuItems, menuGroups) {
        var _this = _super.call(this, menuItems) || this;
        _this.positions = [];
        var derivedItems = [];
        // Process the set of menu items.
        if (menuItems) {
            var shouldGroupMenuItems = false;
            var shouldSortMenuItems = false;
            var lastItemType = _Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuItemType */ "b"].Divider;
            var dividerItem = void 0;
            for (var _i = 0, menuItems_1 = menuItems; _i < menuItems_1.length; _i++) {
                var menuItem = menuItems_1[_i];
                // Don't allow multiple dividers to render next to each other.
                if (menuItem.itemType === _Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuItemType */ "b"].Divider) {
                    if (menuItem.itemType === lastItemType) {
                        continue;
                    }
                    dividerItem = menuItem;
                }
                else {
                    if (dividerItem) {
                        derivedItems.push(dividerItem);
                        dividerItem = undefined;
                    }
                    derivedItems.push(menuItem);
                }
                lastItemType = menuItem.itemType || _Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuItemType */ "b"].Normal;
                // If the item is ranked or grouped we need to sort and group them.
                shouldGroupMenuItems = !!menuItem.groupKey || shouldGroupMenuItems;
                shouldSortMenuItems = menuItem.rank >= 0 || shouldSortMenuItems;
            }
            if (shouldSortMenuItems) {
                derivedItems.sort(function (a, b) {
                    var aRank = a.rank || Number.MAX_VALUE;
                    var bRank = b.rank || Number.MAX_VALUE;
                    return aRank - bRank;
                });
            }
            if (shouldGroupMenuItems) {
                derivedItems = groupMenuItems(derivedItems, menuGroups);
            }
        }
        // Update the items to be the derived items.
        _this.items = derivedItems;
        return _this;
    }
    // Custom getCount to support excluding the decorative items from the count.
    MenuItemProvider.prototype.getCount = function () {
        if (this.count === undefined) {
            this.count = 0;
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var menuItem = _a[_i];
                if (menuItem.itemType === _Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuItemType */ "b"].Divider || menuItem.itemType === _Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuItemType */ "b"].Header) {
                    this.positions.push(-1);
                }
                else {
                    this.positions.push(++this.count);
                }
            }
        }
        return this.count;
    };
    MenuItemProvider.prototype.getItem = function (index) {
        return this.items[index];
    };
    MenuItemProvider.prototype.getPosition = function (index) {
        if (!this.positions.length) {
            this.getCount();
        }
        return this.positions[index];
    };
    return MenuItemProvider;
}(_Utilities_Provider__WEBPACK_IMPORTED_MODULE_18__[/* ArrayItemProvider */ "a"]));
var Menu = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(Menu, _super);
    function Menu(props) {
        var _this = _super.call(this, props) || this;
        _this.containerElement = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.expandItem = function (menuItem, expanded) {
            if (!menuItem && _this.state.expandedIndex.value !== -1) {
                menuItem = _this.itemProvider.getItem(_this.state.expandedIndex.value);
            }
            if (menuItem && menuItem.subMenuProps) {
                for (var index = 0; index < _this.itemProvider.length; index++) {
                    if (menuItem === _this.itemProvider.getItem(index)) {
                        if (expanded) {
                            _this.state.expandedIndex.value = index;
                        }
                        else {
                            _this.state.expandedIndex.value = -1;
                        }
                        break;
                    }
                }
            }
        };
        _this.focus = function () {
            if (_this.containerElement.current) {
                _this.containerElement.current.focus();
            }
        };
        _this.getParent = function () {
            return _this.props.parentMenu;
        };
        _this.onActivate = function (menuItem, event) {
            if (_this.props.onActivate) {
                _this.props.onActivate(menuItem, event);
            }
        };
        _this.renderMenuItem = function (index, menuItem, details) {
            var onFocusItem = details.onFocusItem;
            var menuItemDetails = {
                expandedIndex: _this.state.expandedIndex,
                menu: _this,
                menuProps: _this.props,
                onActivate: _this.onActivate,
                onFocusItem: onFocusItem,
                position: _this.itemProvider.getPosition(index),
                setSize: _this.itemProvider.getCount()
            };
            if (menuItem.renderMenuItem) {
                return menuItem.renderMenuItem(index, menuItem, menuItemDetails);
            }
            var key = menuItem.id;
            switch (menuItem.itemType) {
                case _Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuItemType */ "b"].Divider:
                    return MenuDivider(index, menuItem);
                case _Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuItemType */ "b"].Header:
                    return MenuHeader(index, menuItem);
                default:
                    return react__WEBPACK_IMPORTED_MODULE_5__["createElement"](MenuItem, { key: key, index: index, menuItem: menuItem, details: menuItemDetails });
            }
        };
        _this.state = {
            expandedIndex: new _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableValue"](-1)
        };
        return _this;
    }
    Menu.prototype.render = function () {
        var _this = this;
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_14__["Observer"], { items: this.props.items }, function (props) {
            _this.itemProvider = new MenuItemProvider(props.items, _this.props.groups);
            return _this.renderList();
        }));
    };
    Menu.prototype.renderList = function () {
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-menu-container no-outline", ref: this.containerElement, tabIndex: -1 }, this.itemProvider.length > 0 && (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](react__WEBPACK_IMPORTED_MODULE_5__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-menu-spacer", onMouseDown: _Util__WEBPACK_IMPORTED_MODULE_16__["preventDefault"] }),
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_List__WEBPACK_IMPORTED_MODULE_12__["List"], { ariaLabel: this.props.ariaLabel, className: Object(_Util__WEBPACK_IMPORTED_MODULE_16__["css"])(this.props.className, "bolt-menu"), columnCount: 7, focuszoneProps: null, id: this.props.id, itemProvider: this.itemProvider, renderRow: this.renderMenuItem, role: "menu", virtualize: false }),
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-menu-spacer", onMouseDown: _Util__WEBPACK_IMPORTED_MODULE_16__["preventDefault"] })))));
    };
    return Menu;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));

function MenuDivider(index, menuItem) {
    return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("tr", { "aria-hidden": "true", className: Object(_Util__WEBPACK_IMPORTED_MODULE_16__["css"])(menuItem.className, "bolt-menuitem-row bolt-list-row bolt-menuitem-divider"), key: menuItem.id || "divider-" + index, onMouseDown: _Util__WEBPACK_IMPORTED_MODULE_16__["preventDefault"] },
        react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("td", { className: "bolt-menuitem-cell bolt-list-cell" }),
        react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("td", { className: "bolt-menuitem-cell bolt-list-cell bolt-menuitem-divider-column", colSpan: 5 },
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-menuitem-divider-content" })),
        react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("td", { className: "bolt-menuitem-cell bolt-list-cell" })));
}
function MenuHeader(index, menuItem) {
    return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("tr", { "aria-level": 1, className: Object(_Util__WEBPACK_IMPORTED_MODULE_16__["css"])(menuItem.className, "bolt-menuitem-row bolt-list-row bolt-menuitem-header"), key: menuItem.id || "header-" + index, onMouseDown: _Util__WEBPACK_IMPORTED_MODULE_16__["preventDefault"], role: "heading" },
        react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("td", { className: "bolt-menuitem-cell bolt-list-cell" }),
        react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("td", { className: "bolt-menuitem-cell bolt-list-cell", colSpan: 3 },
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-menuitem-cell-content bolt-menuitem-cell-text" }, menuItem.text)),
        react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("td", { className: "bolt-menuitem-cell bolt-list-cell", colSpan: 3 })));
}
var MenuItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(MenuItem, _super);
    function MenuItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localKeyStroke = false;
        _this.expanded = false;
        _this.element = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.handleClick = function (event) {
            var menuItem = _this.props.menuItem;
            if (menuItem.disabled) {
                event.preventDefault();
            }
            else if (!_this.expanded) {
                var ownerResponse = void 0;
                // If the menu owner supplied a handler, we will get feedback from them before doing
                // default processing on the menu item.
                if (menuItem.onActivate) {
                    ownerResponse = menuItem.onActivate(menuItem, event);
                }
                // If the owner specifically returned true, we will not perform any defaults.
                if (!ownerResponse) {
                    if (!menuItem.href) {
                        event.preventDefault();
                    }
                    // For menus with sub-menus we will expand it on activation. For other menu items
                    // they are executed.
                    if (menuItem.subMenuProps) {
                        _this.props.details.menu.expandItem(menuItem, true);
                    }
                    else if (menuItem.href) {
                        _this.props.details.onActivate(menuItem, event);
                    }
                    else if (menuItem.checked === undefined || menuItem.readonly) {
                        _this.props.details.onActivate(menuItem, event);
                    }
                }
            }
        };
        // If the click handler doesn't return false explicitly close dismiss the menu.
        _this.onClick = function (event) {
            if (!event.defaultPrevented) {
                _this.handleClick(event);
            }
        };
        _this.onDismissSubMenu = function (dismissAll) {
            if (!dismissAll && _this.element.current) {
                _this.props.details.menu.expandItem(_this.props.menuItem, false);
            }
        };
        _this.onExpandedChange = function (expandedIndex) {
            return (_this.expanded && expandedIndex !== _this.props.index) || (!_this.expanded && expandedIndex === _this.props.index);
        };
        _this.onFocus = function (event) {
            if (_this.element.current === document.activeElement) {
                _this.props.details.onFocusItem(_this.props.index, event);
            }
        };
        // Handle the keydown to expand the menu.
        _this.onKeyDown = function (event) {
            _this.localKeyStroke = true;
            if (!event.defaultPrevented) {
                var menuItem = _this.props.menuItem;
                if (event.which === _Util__WEBPACK_IMPORTED_MODULE_16__["KeyCode"].tab || event.which === _Util__WEBPACK_IMPORTED_MODULE_16__["KeyCode"].space) {
                    event.preventDefault();
                }
                else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_16__["KeyCode"].rightArrow && menuItem.subMenuProps) {
                    event.preventDefault();
                    _this.props.details.menu.expandItem(menuItem, true);
                }
            }
        };
        // Translate the space and enter keys into onClick event for a menuItem.
        _this.onKeyUp = function (event) {
            // If we get focus while a key is down we will get the keyup. We dont want
            // to process this key, it needs to originate from us.
            if (!_this.localKeyStroke) {
                return;
            }
            if (!event.defaultPrevented) {
                if (event.which === _Util__WEBPACK_IMPORTED_MODULE_16__["KeyCode"].enter || event.which === _Util__WEBPACK_IMPORTED_MODULE_16__["KeyCode"].space) {
                    _this.handleClick(event);
                }
            }
        };
        _this.onMouseDown = function (event) {
            if (!event.defaultPrevented) {
                var menuItem = _this.props.menuItem;
                if (menuItem.disabled || _this.props.details.expandedIndex.value === _this.props.index) {
                    event.preventDefault();
                }
            }
        };
        // If you hover over a menu with a submenu we will open it after a short delay
        // or stop the closing timeout.
        _this.onMouseEnter = function () {
            if (!_this.props.menuItem.disabled) {
                _this.props.details.menu.expandItem(_this.props.menuItem, true);
                Object(_Util__WEBPACK_IMPORTED_MODULE_16__["setFocusVisible"])(false);
            }
        };
        // If you leave the menu item and sub-menu we will close the menu after a short delay
        // or stop the open timeout.
        _this.onMouseLeave = function () {
            _this.onDismissSubMenu(false);
        };
        return _this;
    }
    MenuItem.prototype.render = function () {
        var _this = this;
        var _a = this.props, index = _a.index, menuItem = _a.menuItem, details = _a.details;
        var menu = details.menu, position = details.position, setSize = details.setSize;
        var checked = menuItem.checked, className = menuItem.className, disabled = menuItem.disabled, href = menuItem.href, iconProps = menuItem.iconProps, readonly = menuItem.readonly, secondaryText = menuItem.secondaryText, subMenuProps = menuItem.subMenuProps, target = menuItem.target;
        var id = menuItem.id, rel = menuItem.rel, text = menuItem.text;
        // If this is a link menu item we will use an anchor otherwise a plain div.
        var CellType = href ? "div" : "td";
        var RowType = href ? "a" : "tr";
        // If the menu item is a link is targetting an external window or tab and no explicit rel
        // attribute was supplied we will set noopener.
        if (href && target && !rel) {
            rel = "noopener";
        }
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_14__["Observer"], { checked: checked, expandedIndex: { observableValue: this.props.details.expandedIndex, filter: this.onExpandedChange } }, function (props) {
            _this.expanded = props.expandedIndex === index;
            return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_MouseWithin__WEBPACK_IMPORTED_MODULE_13__["MouseWithin"], { enterDelay: 250, leaveDelay: 250, onMouseEnter: _this.onMouseEnter, onMouseLeave: _this.onMouseLeave }, function (mouseWithinEvents) { return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_10__[/* FocusZoneContext */ "b"].Consumer, null, function (rowContext) { return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusWithin__WEBPACK_IMPORTED_MODULE_9__["FocusWithin"], { onFocus: _this.onFocus }, function (focusStatus) { return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_10__[/* FocusZone */ "a"], { direction: _FocusZone__WEBPACK_IMPORTED_MODULE_10__[/* FocusZoneDirection */ "c"].Horizontal },
                react__WEBPACK_IMPORTED_MODULE_5__["createElement"](RowType, { "aria-checked": props.checked === true || undefined, "aria-controls": _this.expanded && subMenuProps ? Object(_Util__WEBPACK_IMPORTED_MODULE_16__["getSafeId"])(subMenuProps.id) : undefined, "aria-disabled": disabled ? "true" : undefined, "aria-expanded": subMenuProps ? _this.expanded : undefined, "aria-haspopup": subMenuProps ? true : undefined, "aria-posinset": position, "aria-setsize": setSize, className: Object(_Util__WEBPACK_IMPORTED_MODULE_16__["css"])(className, "bolt-menuitem-row bolt-list-row bolt-menuitem-row-normal cursor-pointer", disabled && "disabled", _this.expanded && "expanded", focusStatus.hasFocus && "focused"), "data-focuszone": disabled ? undefined : rowContext.focuszoneId, href: href, id: Object(_Util__WEBPACK_IMPORTED_MODULE_16__["getSafeId"])(id), role: props.checked !== undefined ? "menuitemcheckbox" : "menuitem", onBlur: focusStatus.onBlur, onClick: _this.onClick, onFocus: focusStatus.onFocus, onKeyDown: _this.onKeyDown, onKeyUp: _this.onKeyUp, onMouseDown: _this.onMouseDown, onMouseEnter: mouseWithinEvents.onMouseEnter, onMouseLeave: mouseWithinEvents.onMouseLeave, ref: _this.element, rel: rel, tabIndex: disabled ? undefined : -1, target: target },
                    react__WEBPACK_IMPORTED_MODULE_5__["createElement"](CellType, { className: "bolt-menuitem-cell bolt-list-cell" },
                        react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-menuitem-cell-content flex-row" })),
                    react__WEBPACK_IMPORTED_MODULE_5__["createElement"](CellType, { className: "bolt-menuitem-cell bolt-list-cell" }, props.checked !== undefined &&
                        ((menuItem.renderMenuCell &&
                            menuItem.renderMenuCell(_Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuCell */ "a"].State, menuItem, details)) || (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-menuitem-cell-content bolt-menuitem-cell-state flex-row" }, readonly === true ? (Object(_Icon__WEBPACK_IMPORTED_MODULE_11__["Icon"])({
                            className: Object(_Util__WEBPACK_IMPORTED_MODULE_16__["css"])(!props.checked && "invisible"),
                            iconName: "CheckMark"
                        })) : (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Checkbox__WEBPACK_IMPORTED_MODULE_8__["Checkbox"], { checked: props.checked, disabled: disabled, excludeFocusZone: true, excludeTabStop: true, onChange: _this.onClick })))))),
                    react__WEBPACK_IMPORTED_MODULE_5__["createElement"](CellType, { className: "bolt-menuitem-cell bolt-list-cell" }, (menuItem.renderMenuCell && menuItem.renderMenuCell(_Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuCell */ "a"].Icon, menuItem, details)) ||
                        (iconProps && (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-menuitem-cell-content bolt-menuitem-cell-icon flex-row" }, Object(_Icon__WEBPACK_IMPORTED_MODULE_11__["Icon"])(iconProps))))),
                    react__WEBPACK_IMPORTED_MODULE_5__["createElement"](CellType, { className: "bolt-menuitem-cell bolt-list-cell" }, (menuItem.renderMenuCell &&
                        menuItem.renderMenuCell(_Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuCell */ "a"].PrimaryText, menuItem, details)) || (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { id: Object(_Util__WEBPACK_IMPORTED_MODULE_16__["getSafeId"])(id + "-text"), className: "bolt-menuitem-cell-content bolt-menuitem-cell-text flex-row" }, text ? (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_TooltipEx__WEBPACK_IMPORTED_MODULE_15__["Tooltip"], { overflowOnly: true, text: text },
                        react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "text-ellipsis" }, text))) : (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", null, "\u00A0"))))),
                    react__WEBPACK_IMPORTED_MODULE_5__["createElement"](CellType, { className: "bolt-menuitem-cell bolt-list-cell" }, (menuItem.renderMenuCell &&
                        menuItem.renderMenuCell(_Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuCell */ "a"].SecondaryText, menuItem, details)) ||
                        (secondaryText && (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-menuitem-cell-content bolt-menuitem-cell-secondary flex-row" }, secondaryText)))),
                    react__WEBPACK_IMPORTED_MODULE_5__["createElement"](CellType, { className: "bolt-menuitem-cell bolt-list-cell" }, (menuItem.renderMenuCell &&
                        menuItem.renderMenuCell(_Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuCell */ "a"].Action, menuItem, details)) ||
                        (subMenuProps && (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-menuitem-cell-content bolt-menuitem-cell-submenu flex-row" },
                            Object(_Icon__WEBPACK_IMPORTED_MODULE_11__["Icon"])({ iconName: "ChevronRightMed", size: _Icon__WEBPACK_IMPORTED_MODULE_11__["IconSize"].small }),
                            _this.expanded && _this.element.current && (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](ContextualMenu, { anchorElement: _this.element.current, anchorOffset: { horizontal: 0, vertical: -8 }, anchorOrigin: { horizontal: _Utilities_Position__WEBPACK_IMPORTED_MODULE_17__[/* Location */ "a"].end, vertical: _Utilities_Position__WEBPACK_IMPORTED_MODULE_17__[/* Location */ "a"].start }, subMenu: true, menuOrigin: { horizontal: _Utilities_Position__WEBPACK_IMPORTED_MODULE_17__[/* Location */ "a"].start, vertical: _Utilities_Position__WEBPACK_IMPORTED_MODULE_17__[/* Location */ "a"].start }, menuProps: subMenuProps, onActivate: _this.props.details.onActivate, onDismiss: _this.onDismissSubMenu, parentMenu: menu })))))),
                    react__WEBPACK_IMPORTED_MODULE_5__["createElement"](CellType, { className: "bolt-menuitem-cell bolt-list-cell" },
                        react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-menuitem-cell-content flex-row" }))))); })); })); }));
        }));
    };
    return MenuItem;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));

var ContextualMenu = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(ContextualMenu, _super);
    function ContextualMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDismiss = function () {
            if (_this.props.onDismiss) {
                _this.props.onDismiss(false);
            }
        };
        _this.onKeyDown = function (event) {
            if (!event.defaultPrevented) {
                if (event.which === _Util__WEBPACK_IMPORTED_MODULE_16__["KeyCode"].escape || event.which === _Util__WEBPACK_IMPORTED_MODULE_16__["KeyCode"].tab || (event.which === _Util__WEBPACK_IMPORTED_MODULE_16__["KeyCode"].leftArrow && _this.props.subMenu)) {
                    event.preventDefault();
                    if (_this.props.onDismiss) {
                        _this.props.onDismiss(false);
                    }
                }
            }
        };
        _this.onActivate = function (menuItem, event) {
            if (_this.props.menuProps.onActivate) {
                _this.props.menuProps.onActivate(menuItem, event);
            }
            if (_this.props.onActivate) {
                _this.props.onActivate(menuItem, event);
            }
            if (_this.props.onDismiss) {
                _this.props.onDismiss(true);
            }
        };
        _this.preprocessKeyStroke = function (event) {
            if (Object(_Util__WEBPACK_IMPORTED_MODULE_16__["isArrowKey"])(event)) {
                return _FocusZone__WEBPACK_IMPORTED_MODULE_10__[/* FocusZoneKeyStroke */ "d"].IgnoreParents;
            }
            return _FocusZone__WEBPACK_IMPORTED_MODULE_10__[/* FocusZoneKeyStroke */ "d"].IgnoreNone;
        };
        return _this;
    }
    ContextualMenu.prototype.render = function () {
        var defaultActiveElement = ".bolt-menu-container";
        // Determine which element should be the first to get focus.
        // Headers may be the first row and they wont take focus.
        var items = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(this.props.menuProps.items);
        for (var menuIndex = 0; menuIndex < items.length; menuIndex++) {
            if (items[menuIndex].itemType === _Menu_Props__WEBPACK_IMPORTED_MODULE_19__[/* MenuItemType */ "b"].Normal || items[menuIndex].itemType === undefined) {
                var menuItemId = items[menuIndex].id;
                if (!menuItemId || items[menuIndex].disabled) {
                    continue;
                }
                defaultActiveElement = Object(_Util__WEBPACK_IMPORTED_MODULE_16__["getSafeIdSelector"])(menuItemId);
                break;
            }
        }
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Callout__WEBPACK_IMPORTED_MODULE_7__[/* Callout */ "a"], { anchorElement: this.props.anchorElement, anchorOffset: this.props.anchorOffset, anchorOrigin: this.props.anchorOrigin, anchorPoint: this.props.anchorPoint, blurDismiss: true, calloutOrigin: this.props.menuOrigin, className: this.props.className, contentClassName: Object(_Util__WEBPACK_IMPORTED_MODULE_16__["css"])("bolt-contextual-menu flex-column custom-scrollbar depth-8", this.props.subMenu && "bolt-contextual-submenu"), contentShadow: true, onDismiss: this.onDismiss, fixedLayout: this.props.fixedLayout, focuszoneProps: {
                defaultActiveElement: defaultActiveElement,
                direction: _FocusZone__WEBPACK_IMPORTED_MODULE_10__[/* FocusZoneDirection */ "c"].Vertical,
                focusOnMount: true,
                preprocessKeyStroke: this.preprocessKeyStroke
            }, id: this.props.menuProps.id + "-callout", portalProps: { className: "bolt-menu-portal" } },
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-contextualmenu-container", onKeyDown: this.onKeyDown },
                react__WEBPACK_IMPORTED_MODULE_5__["createElement"](Menu, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.props.menuProps, { onActivate: this.onActivate, parentMenu: this.props.parentMenu })))));
    };
    return ContextualMenu;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));



/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuButton; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Menu_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68);
/* harmony import */ var _Menu_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Menu_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _MenuButton_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69);
/* harmony import */ var _MenuButton_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_MenuButton_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14);
/* harmony import */ var _Menu__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77);








var buttonId = 1;
var MenuButton = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(MenuButton, _super);
    function MenuButton(props) {
        var _this = _super.call(this, props) || this;
        _this.dropdownButton = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.expand = function () {
            if (_this.dropdownButton.current) {
                _this.dropdownButton.current.expand();
            }
        };
        _this.collapse = function () {
            if (_this.dropdownButton.current) {
                _this.dropdownButton.current.collapse();
            }
        };
        _this.renderMenu = function (dropdown, dropdownId, anchorElement, anchorOffset, anchorOrigin, anchorPoint, dropdownOrigin) {
            var contextualMenuProps = typeof _this.props.contextualMenuProps === "function" ? _this.props.contextualMenuProps() : _this.props.contextualMenuProps;
            return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Menu__WEBPACK_IMPORTED_MODULE_7__[/* ContextualMenu */ "a"], { anchorElement: anchorElement, anchorOffset: contextualMenuProps.anchorOffset || anchorOffset, anchorOrigin: contextualMenuProps.anchorOrigin || anchorOrigin, anchorPoint: contextualMenuProps.anchorPoint || anchorPoint, fixedLayout: contextualMenuProps.fixedLayout, menuOrigin: contextualMenuProps.menuOrigin || dropdownOrigin, menuProps: contextualMenuProps.menuProps, className: contextualMenuProps.className, onActivate: function (menuItem, event) {
                    if (contextualMenuProps.onActivate) {
                        contextualMenuProps.onActivate(menuItem, event);
                    }
                    dropdown.collapse();
                }, onDismiss: dropdown.collapse }));
        };
        _this.state = {
            id: _this.props.id || "menu-button-" + buttonId++
        };
        return _this;
    }
    MenuButton.prototype.render = function () {
        var _a = this.props, contextualMenuProps = _a.contextualMenuProps, hideDropdownIcon = _a.hideDropdownIcon;
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Button__WEBPACK_IMPORTED_MODULE_6__["ExpandableButton"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.props), { menuProps: undefined }), { hideDropdownIcon: hideDropdownIcon, id: this.state.id, ref: this.dropdownButton, renderCallout: this.renderMenu }), this.props.children));
    };
    MenuButton.prototype.focus = function () {
        if (this.dropdownButton.current) {
            this.dropdownButton.current.focus();
        }
    };
    return MenuButton;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));



/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MoreButton; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Menu_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68);
/* harmony import */ var _Menu_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Menu_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _MenuButton_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69);
/* harmony import */ var _MenuButton_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_MenuButton_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Resources_Widgets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20);
/* harmony import */ var _MenuButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78);








var MoreButton = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(MoreButton, _super);
    function MoreButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menuButton = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.expand = function () {
            if (_this.menuButton.current) {
                _this.menuButton.current.expand();
            }
        };
        _this.collapse = function () {
            if (_this.menuButton.current) {
                _this.menuButton.current.collapse();
            }
        };
        return _this;
    }
    MoreButton.prototype.render = function () {
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_MenuButton__WEBPACK_IMPORTED_MODULE_7__[/* MenuButton */ "a"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({ ariaLabel: _Resources_Widgets__WEBPACK_IMPORTED_MODULE_6__[/* MoreActions */ "h"], hideDropdownIcon: true, iconProps: { iconName: "MoreVertical" }, ref: this.menuButton, subtle: true, tooltipProps: { text: _Resources_Widgets__WEBPACK_IMPORTED_MODULE_6__[/* MoreActions */ "h"] } }, this.props)));
    };
    MoreButton.prototype.focus = function () {
        if (this.menuButton.current) {
            this.menuButton.current.focus();
        }
    };
    return MoreButton;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));



/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableBreakpoint; });
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Table_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58);
/* harmony import */ var _Table_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Table_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4);
/* harmony import */ var _Breakpoint__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57);






function TableBreakpoint(props) {
    var breakpoints = [];
    var onBreakpoint = function (breakpointIndex, breakpoint) {
        var columnWidths = props.breakpoints[Math.max(0, breakpointIndex)].columnWidths;
        for (var index = 0; index < columnWidths.length; index++) {
            if (_Core_Observable__WEBPACK_IMPORTED_MODULE_4__["ObservableLike"].isObservable(props.columnWidths[index])) {
                props.columnWidths[index].value = columnWidths[index];
            }
        }
        // Notify the owner if the responsive udpate property was supplied.
        if (props.onBreakpoint) {
            props.onBreakpoint(breakpointIndex, breakpoint);
        }
    };
    // Compute the breakpoints from the table definition.
    for (var index = 0; index < props.breakpoints.length; index++) {
        breakpoints.push(props.breakpoints[index].breakpoint);
    }
    // Compute the set of breakpoints needed for the responsive columns.
    return react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Breakpoint__WEBPACK_IMPORTED_MODULE_5__["Breakpoint"], { breakpoints: breakpoints, onBreakpoint: onBreakpoint });
}


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownExpandableTextField; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Dropdown_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51);
/* harmony import */ var _Dropdown_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Dropdown_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ExpandableTextField__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(201);
/* harmony import */ var _Resources_Dropdown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17);
/* harmony import */ var _TextField__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1);









function DropdownExpandableTextField(props) {
    var _a;
    var editable = props.editable, expandableRef = props.expandableRef, items = props.items, inputClassName = props.inputClassName, renderSelectedItems = props.renderSelectedItems, selection = props.selection, _b = props.showPrefix, showPrefix = _b === void 0 ? true : _b, rest = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __rest */ "c"])(props, ["editable", "expandableRef", "items", "inputClassName", "renderSelectedItems", "selection", "showPrefix"]);
    var prefixIconProps;
    var text;
    if (!editable) {
        text = props.placeholder;
        if (selection.selectedCount > 0) {
            text = renderSelectedItems(selection, items);
        }
    }
    // If only a single item is selected and the item has an icon we will show it as a prefix icon.
    if (showPrefix && selection.selectedCount === 1) {
        prefixIconProps = (_a = items[selection.value[0].beginIndex]) === null || _a === void 0 ? void 0 : _a.iconProps;
    }
    return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_ExpandableTextField__WEBPACK_IMPORTED_MODULE_5__["ExpandableTextField"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({ ariaHasPopup: "menu", ariaRoleDescription: !editable ? _Resources_Dropdown__WEBPACK_IMPORTED_MODULE_6__[/* DropdownExpandableRoleDescription */ "j"] : undefined, autoComplete: editable, ariaAutoComplete: editable ? "list" : undefined, focusTreatment: editable ? _TextField__WEBPACK_IMPORTED_MODULE_7__[/* TextFieldFocusTreatmentBehavior */ "b"].all : _TextField__WEBPACK_IMPORTED_MODULE_7__[/* TextFieldFocusTreatmentBehavior */ "b"].keyboardOnly, inputType: !editable ? "button" : undefined, editable: editable, ref: expandableRef, value: text }, rest, { className: Object(_Util__WEBPACK_IMPORTED_MODULE_8__["css"])(props.className, "bolt-dropdown-expandable-text-field", rest.disabled && "disabled"), inputClassName: Object(_Util__WEBPACK_IMPORTED_MODULE_8__["css"])(inputClassName, "bolt-dropdown-expandable-textfield-input text-ellipsis"), onClick: function (event) { return expandableRef.current && expandableRef.current.expand(); }, prefixIconProps: props.prefixIconProps || prefixIconProps, tooltipProps: Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({ text: text, overflowOnly: true, overflowDetected: overflowDetected }, props.tooltipProps) })));
}
function overflowDetected(anchorElement) {
    var _a = anchorElement.style, wordBreak = _a.wordBreak, whiteSpace = _a.whiteSpace;
    var height = anchorElement.clientHeight;
    anchorElement.style.wordBreak = "break-all";
    anchorElement.style.whiteSpace = "normal";
    var heightChanged = height < anchorElement.clientHeight;
    anchorElement.style.wordBreak = wordBreak;
    anchorElement.style.whiteSpace = whiteSpace;
    return heightChanged;
}


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownExpandableButton; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Dropdown_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51);
/* harmony import */ var _Dropdown_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Dropdown_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14);






function DropdownExpandableButton(props) {
    var expandableRef = props.expandableRef, items = props.items, placeholder = props.placeholder, renderSelectedItems = props.renderSelectedItems, selection = props.selection, tooltipProps = props.tooltipProps, rest = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __rest */ "c"])(props, ["expandableRef", "items", "placeholder", "renderSelectedItems", "selection", "tooltipProps"]);
    var text = placeholder;
    if (selection.selectedCount > 0) {
        text = renderSelectedItems(selection, items);
    }
    return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Button__WEBPACK_IMPORTED_MODULE_5__["ExpandableButton"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({ ref: expandableRef }, rest, { tooltipProps: Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({ overflowOnly: true, overflowDetected: overflowDetected }, props.tooltipProps) }),
        react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: "bolt-dropdown-expandable-button-label justify-start flex-grow text-ellipsis" },
            props.children,
            text)));
}
function overflowDetected(anchorElement) {
    var overflowElement = anchorElement.querySelector(".bolt-dropdown-expandable-button-label");
    if (overflowElement) {
        return overflowElement.scrollWidth > Math.ceil(overflowElement.offsetWidth);
    }
    return false;
}


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextFilterBarItem; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14);
/* harmony import */ var _FilterBarItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92);
/* harmony import */ var _Resources_Input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93);
/* harmony import */ var _TextField__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1);









var DEFAULT_MAX_TEXT_LENGTH = 200;
var DEFAULT_THROTTLE_WAIT = 200;
var TextFilterBarItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(TextFilterBarItem, _super);
    function TextFilterBarItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textField = react__WEBPACK_IMPORTED_MODULE_3__["createRef"]();
        _this.onClickClearButton = function (event) {
            _this.setFilterValue({ value: "" });
            if (_this.textField.current) {
                _this.textField.current.focus();
            }
        };
        _this.onTextChanged = function (ev, text) {
            _this.setFilterValue({ value: text });
        };
        _this.onKeyDown = function (ev) {
            if (_this.props.filter) {
                switch (ev.which) {
                    case _Util__WEBPACK_IMPORTED_MODULE_8__["KeyCode"].enter:
                        _this.props.filter.setFilterItemState(_this.props.filterItemKey, { value: _this.state.value });
                        _this.props.filter.applyChanges();
                        break;
                    case _Util__WEBPACK_IMPORTED_MODULE_8__["KeyCode"].escape:
                        _this.setFilterValue({ value: "" });
                        _this.setState({
                            value: ""
                        });
                        _this.props.filter.applyChanges();
                        break;
                    default:
                        return;
                }
                // We only get here if the keypress has been handled.
                ev.preventDefault();
                ev.stopPropagation();
            }
        };
        return _this;
    }
    TextFilterBarItem.prototype.focus = function () {
        if (this.textField.current) {
            return this.textField.current.focus();
        }
    };
    TextFilterBarItem.prototype.render = function () {
        var _this = this;
        var value = this.state.value;
        var _a = this.props, className = _a.className, clearable = _a.clearable, placeholder = _a.placeholder, maxTextLength = _a.maxTextLength, inputClassName = _a.inputClassName, style = _a.style, width = _a.width;
        var clearButtonIconProps = undefined;
        if (clearable && value) {
            clearButtonIconProps = {
                render: function (className) {
                    return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Button__WEBPACK_IMPORTED_MODULE_4__["Button"], { ariaLabel: _Resources_Input__WEBPACK_IMPORTED_MODULE_6__[/* ClearFilter */ "a"], className: Object(_Util__WEBPACK_IMPORTED_MODULE_8__["css"])(className, "bolt-text-filterbaritem-clear"), iconProps: { iconName: "Cancel" }, onClick: _this.onClickClearButton }));
                }
            };
        }
        return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_TextField__WEBPACK_IMPORTED_MODULE_7__[/* TextField */ "a"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({ ariaLabel: placeholder, className: Object(_Util__WEBPACK_IMPORTED_MODULE_8__["css"])(className, "bolt-text-filterbaritem flex-grow"), containerClassName: "flex-grow", inputClassName: Object(_Util__WEBPACK_IMPORTED_MODULE_8__["css"])(inputClassName, "bolt-text-filterbaritem-input"), inputType: "text", focusTreatment: _TextField__WEBPACK_IMPORTED_MODULE_7__[/* TextFieldFocusTreatmentBehavior */ "b"].keyboardOnly, maxLength: maxTextLength || DEFAULT_MAX_TEXT_LENGTH, onChange: this.onTextChanged, onKeyDown: this.onKeyDown, placeholder: placeholder, ref: this.textField, style: style, suffixIconProps: clearButtonIconProps, value: value || "", width: width }, this.getExtraTextFieldProps())));
    };
    TextFilterBarItem.prototype.getExtraTextFieldProps = function () {
        return null;
    };
    TextFilterBarItem.prototype.getThrottleWait = function () {
        var throttleWait = this.props.throttleWait;
        return throttleWait === undefined ? DEFAULT_THROTTLE_WAIT : throttleWait;
    };
    TextFilterBarItem.defaultProps = {
        isTextItem: true
    };
    return TextFilterBarItem;
}(_FilterBarItem__WEBPACK_IMPORTED_MODULE_5__["FilterBarItem"]));



/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Components_Card_Card__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(195);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return _Components_Card_Card__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_Card_CardContent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CardContent", function() { return _Components_Card_CardContent__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _Components_Card_CardFooter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(192);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CardFooter", function() { return _Components_Card_CardFooter__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _Components_Card_CustomCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CustomCard", function() { return _Components_Card_CustomCard__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _Components_Card_Card_Props__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(193);
/* harmony import */ var _Components_Card_Card_Props__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Components_Card_Card_Props__WEBPACK_IMPORTED_MODULE_4__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_Card_Card_Props__WEBPACK_IMPORTED_MODULE_4__) if(["default","Card","CardContent","CardFooter","CustomCard"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_Card_Card_Props__WEBPACK_IMPORTED_MODULE_4__[key]; }) }(__WEBPACK_IMPORT_KEY__));







/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomHeaderCommandBar; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _HeaderCommandBar_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(106);
/* harmony import */ var _HeaderCommandBar_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_HeaderCommandBar_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ButtonGroup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(203);
/* harmony import */ var _FocusZone__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1);








/**
 * Renders children in a FocusZone and ButtonGroup. This should be used directly only
 * if you need to render custom content that does not map to an IHeaderCommandBarItem.
 *
 * This component will always render all of its children - the logic for which items live
 * in the ... button and which items are always shown is only in the HeaderCommandBar. It is assumed
 * that if you are custom rendering the header command bar, that you are responsible for putting
 * the items correctly into the menu button.
 */
var CustomHeaderCommandBar = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(CustomHeaderCommandBar, _super);
    function CustomHeaderCommandBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomHeaderCommandBar.prototype.render = function () {
        return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_6__[/* FocusZone */ "a"], { direction: _FocusZone__WEBPACK_IMPORTED_MODULE_6__[/* FocusZoneDirection */ "c"].Horizontal, focusGroupProps: this.props.focusGroupProps }, Object(_ButtonGroup__WEBPACK_IMPORTED_MODULE_5__["ButtonGroup"])({
            className: Object(_Util__WEBPACK_IMPORTED_MODULE_7__["css"])(this.props.className, "bolt-header-commandbar", this.props.lastItemIsIconButton && "bolt-header-commandbar-no-right-padding"),
            children: this.props.children,
            role: this.props.role
        })));
    };
    return CustomHeaderCommandBar;
}(react__WEBPACK_IMPORTED_MODULE_4__["Component"]));



/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFilterItem; });
/* unused harmony export getFullScreenItem */
/* unused harmony export toggleFullScreen */
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _HeaderCommandBar_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(106);
/* harmony import */ var _HeaderCommandBar_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_HeaderCommandBar_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Resources_Page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43);




function getFilterItem(onActivate, hasChanges, important) {
    if (important === void 0) { important = true; }
    return {
        ariaLabel: _Resources_Page__WEBPACK_IMPORTED_MODULE_3__[/* Filter */ "d"],
        iconProps: {
            iconName: hasChanges ? "FilterSolid" : "Filter"
        },
        id: "filter",
        important: important,
        onActivate: onActivate,
        subtle: true,
        tooltipProps: { text: _Resources_Page__WEBPACK_IMPORTED_MODULE_3__[/* Filter */ "d"] }
    };
}
function getFullScreenItem(onActivate, fullscreen, important) {
    if (important === void 0) { important = true; }
    return {
        ariaLabel: fullscreen ? _Resources_Page__WEBPACK_IMPORTED_MODULE_3__[/* ExitFullScreen */ "c"] : _Resources_Page__WEBPACK_IMPORTED_MODULE_3__[/* EnterFullScreen */ "b"],
        iconProps: {
            iconName: fullscreen ? "BackToWindow" : "FullScreen"
        },
        id: "fullscreen",
        important: important,
        onActivate: onActivate,
        subtle: true
    };
}
function toggleFullScreen(newFullScreenState) {
    if (newFullScreenState) {
        document.body && document.body.classList.add("full-screen-mode");
    }
    else {
        document.body && document.body.classList.remove("full-screen-mode");
    }
}


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomCard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Card_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73);
/* harmony import */ var _Card_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Card_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Surface__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1);







var CustomCard = function (props) {
    return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Surface__WEBPACK_IMPORTED_MODULE_5__["SurfaceContext"].Consumer, null, function (surfaceContext) { return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Surface__WEBPACK_IMPORTED_MODULE_5__["Surface"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, surfaceContext, { spacing: _Surface__WEBPACK_IMPORTED_MODULE_5__["Spacing"].default }),
        react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: Object(_Util__WEBPACK_IMPORTED_MODULE_6__["css"])(props.className, "bolt-card flex-column depth-8", surfaceContext.background === _Surface__WEBPACK_IMPORTED_MODULE_5__["SurfaceBackground"].neutral && "bolt-card-white") }, props.children))); }));
};


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ ResizeGroupContext; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ResizeGroup_ResizeGroup; });

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Observable.js
var Observable = __webpack_require__(4);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/ResponsiveLayout/ResponsiveLayout.Props.js
/**
 * The response layout can be used to adjust the children based on either a horizonal or
 * vertical layout but not both at the same time.
 */
var ResponsiveOrientation;
(function (ResponsiveOrientation) {
    /**
     * Components are measured by width and adjusted based on the the width of the parent
     * element.
     */
    ResponsiveOrientation[ResponsiveOrientation["Horizontal"] = 0] = "Horizontal";
    /**
     * Components are measure by height and adjusted based on the height of the parent
     * element.
     */
    ResponsiveOrientation[ResponsiveOrientation["Vertical"] = 1] = "Vertical";
})(ResponsiveOrientation || (ResponsiveOrientation = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/ResponsiveLayout/ResponsiveLayout.js






/**
 * The ResponsiveLayout component is used to create a container that responds to
 * its size. Children of the layout container element will be shown or hidden
 * based on the amount of space available. The client creates the ResponsiveLayout
 * around the element that should be managed.
 *
 * The children of the layout container MUST map one element per child. This allows
 * the ResponsiveLayout to map visibility of the component to its relative DOM
 * element. The child MAY be a component and is not required to be a direct DOM
 * element. The child component MUST result in one root DOM element.
 */
var ResponsiveLayout_ResponsiveLayout = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(ResponsiveLayout, _super);
    function ResponsiveLayout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Details about each of the children in the responsive layout.
         */
        _this.childDetails = [];
        /**
         * All components within the responsiveLayout MUST specific a unique key. The
         * key should follow the same rules as a standard React key. If the component
         * fundamentally changes the key should change along with it.
         */
        _this.childKeys = [];
        /**
         * ref to the container element used by the responsive layout. The direct children
         * are the elements that are responsive.
         */
        _this.containerRef = external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"]();
        /**
         * Number of hidden components in the layout.
         */
        _this.hiddenCount = 0;
        /**
         * Timeout used to notify callers about changes to the visible elements.
         */
        _this.layoutTimeout = 0;
        _this.updateLayout = function () {
            var componentElement = _this.containerRef.current;
            if (componentElement && componentElement.children.length) {
                var hiddenCount = _this.hiddenCount;
                var componentClientRect = componentElement.getBoundingClientRect();
                var renderedSize = 0;
                var ignoredSize = 0;
                var initialPass = false;
                // If we dont have the child details computed, or the children have changed we need
                // to populate the child details.s
                // @NOTE: We need to be able to detect changes to children without the length changing.
                if (!_this.childDetails || componentElement.children.length !== _this.childDetails.length) {
                    _this.childDetails = [];
                    initialPass = true;
                }
                // We need to go through and compute the sizes of the child components.
                for (var componentIndex = 0; componentIndex < componentElement.children.length; componentIndex++) {
                    var clientRect = componentElement.children[componentIndex].getBoundingClientRect();
                    // If this is the initial pass we will create new adjust entries for this components
                    // otherwise we will just update the current state.
                    if (initialPass) {
                        _this.childDetails.push({ appliedSize: 0, clientRect: clientRect });
                    }
                    else {
                        _this.childDetails[componentIndex].clientRect = clientRect;
                    }
                    // Track ignored component sizes independently, this will help with rounding issues.
                    if (_this.props.ignoredChildren && _this.props.ignoredChildren.indexOf(componentIndex) >= 0) {
                        ignoredSize += _this.props.orientation === ResponsiveOrientation.Vertical ? clientRect.height : clientRect.width;
                    }
                }
                // The renderedSize is equal to the size from the end of the last component to the
                // start of the first component minus any ignored space.
                if (_this.props.orientation === ResponsiveOrientation.Vertical) {
                    renderedSize = Math.floor(_this.childDetails[_this.childDetails.length - 1].clientRect.bottom - _this.childDetails[0].clientRect.top);
                }
                else {
                    renderedSize = Math.floor(_this.childDetails[_this.childDetails.length - 1].clientRect.right - _this.childDetails[0].clientRect.left);
                }
                renderedSize -= Math.floor(ignoredSize);
                // If there is not enough space we will try to adjust items smaller first.
                var componentClientSize = Math.floor(_this.props.orientation === ResponsiveOrientation.Vertical ? componentClientRect.height : componentClientRect.width);
                if (componentClientSize <= renderedSize) {
                    var availableSpace = componentClientSize - renderedSize;
                    while (availableSpace < 0 && _this.hiddenCount < _this.props.responsiveChildren.length) {
                        var childIndex = _this.props.responsiveChildren[_this.hiddenCount];
                        var childDetail = _this.childDetails[childIndex];
                        // Determine how much space we will recoupe from this component.
                        var appliedSize = _this.props.orientation === ResponsiveOrientation.Vertical ? childDetail.clientRect.height : childDetail.clientRect.width;
                        // Apply the next adjustment to the child components.
                        availableSpace += appliedSize;
                        // Mark the child hidden and track how space we recouped from component.
                        childDetail.hidden = true;
                        childDetail.appliedSize = appliedSize;
                        // Move on to the next component if we need more space.
                        _this.hiddenCount++;
                        // console.log("Adjust (shrink), applied " + appliedSize + " from child " + childIndex);
                    }
                }
                // If we have availableSpace and there are adjusted items we should see if we can give
                // some back to items.
                else if (componentClientSize > renderedSize) {
                    var availableSpace = componentClientSize - renderedSize;
                    while (_this.hiddenCount > 0) {
                        var childIndex = _this.props.responsiveChildren[_this.hiddenCount - 1];
                        var childDetail = _this.childDetails[childIndex];
                        // Check if there is enough space for this component.  Use a buffer to prevent flickering.
                        var buffer = 8;
                        if (_this.childDetails[childIndex].appliedSize + buffer >= availableSpace) {
                            break;
                        }
                        // Apply the next adjustment to the child components.
                        availableSpace -= childDetail.appliedSize;
                        childDetail.hidden = false;
                        // Now that this component is visible we will decrement its count.
                        _this.hiddenCount--;
                        // console.log("Adjust (grow), applied " + childDetail.appliedSize + " from child " + childIndex);
                    }
                }
                // If adjustments were applied we need to notify the owner on the change and re-layout.
                if (hiddenCount != _this.hiddenCount) {
                    _this.layoutTimeout = window.setTimeout(function () {
                        _this.layoutTimeout = 0;
                        if (_this.props.onLayoutChange) {
                            _this.props.onLayoutChange(_this.hiddenCount);
                        }
                        // Force updates to the components and we will see if we have gained enough space.
                        _this.forceUpdate();
                    }, 0);
                }
            }
        };
        return _this;
    }
    ResponsiveLayout.prototype.render = function () {
        var _this = this;
        var childKeys = [];
        var container = external_commonjs_react_commonjs2_react_amd_React_root_React_["Children"].only(this.props.children);
        // Get the to the container for us to use during sizing calculations.
        this.containerRef = Object(Util["shimRef"])(container);
        // Clone the container and insert the placeholders for hidden children.
        var children = external_commonjs_react_commonjs2_react_amd_React_root_React_["cloneElement"](container, Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, container.props), { ref: this.containerRef }), external_commonjs_react_commonjs2_react_amd_React_root_React_["Children"].map(container.props.children, function (child, index) {
            if (false) {}
            // ALL children MUST have unique keys.
            if (!child.key) {
                console.warn("All children MUST have a unique key");
                child.key = index;
            }
            childKeys[index] = child.key;
            // If the component has been hidden by an layout, we will render a placeholder, that takes 0 size.
            if (_this.childDetails && _this.childDetails[index] && _this.childDetails[index].hidden) {
                return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { key: "PH" + index, className: "responsive-placeholder" });
            }
            return child;
        }));
        // If the children have changed we will reset the layout and start over.
        if (this.childKeys) {
            if (this.childKeys.length !== childKeys.length) {
                this.resetLayout();
            }
            else {
                for (var keyIndex = 0; keyIndex < childKeys.length; keyIndex++) {
                    if (this.childKeys[keyIndex] !== childKeys[keyIndex]) {
                        this.resetLayout();
                        break;
                    }
                }
            }
        }
        this.childKeys = childKeys;
        return children;
    };
    ResponsiveLayout.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.updateLayout);
        this.updateLayout();
    };
    ResponsiveLayout.prototype.componentDidUpdate = function () {
        this.updateLayout();
    };
    ResponsiveLayout.prototype.componentWillUnmount = function () {
        if (this.layoutTimeout) {
            window.clearTimeout(this.layoutTimeout);
            this.layoutTimeout = 0;
        }
        window.removeEventListener("resize", this.updateLayout);
    };
    ResponsiveLayout.prototype.resetLayout = function () {
        this.childDetails = undefined;
        this.hiddenCount = 0;
    };
    return ResponsiveLayout;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/ResponsiveLayout.js



// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/ResizeGroup/ResizeGroup.js






var ResizeGroupContext = external_commonjs_react_commonjs2_react_amd_React_root_React_["createContext"]({});
var ResizeGroup_ResizeGroup = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(ResizeGroup, _super);
    function ResizeGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.onLayoutChange = function (hiddenCount) {
            _this.state.hiddenCount.value = hiddenCount;
            if (_this.props.responsiveLayoutProps.onLayoutChange) {
                _this.props.responsiveLayoutProps.onLayoutChange(hiddenCount);
            }
            ResizeGroup.updateOverflowItems(_this.props, _this.state);
        };
        var extraItems = _this.props.extraItems || [];
        _this.state = {
            hiddenCount: new Observable["ObservableValue"](0),
            overflowItems: new Observable["ObservableArray"](Object(tslib_es6["d" /* __spreadArrays */])(extraItems))
        };
        return _this;
    }
    ResizeGroup.getDerivedStateFromProps = function (nextProps, prevState) {
        ResizeGroup.updateOverflowItems(nextProps, prevState);
        return prevState;
    };
    ResizeGroup.prototype.render = function () {
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](ResizeGroupContext.Provider, { value: { overflowItems: this.state.overflowItems } },
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](ResponsiveLayout_ResponsiveLayout, Object(tslib_es6["a" /* __assign */])({}, this.props.responsiveLayoutProps, { onLayoutChange: this.onLayoutChange }), this.props.children)));
    };
    ResizeGroup.updateOverflowItems = function (props, state) {
        var extraItems = props.extraItems || [];
        state.overflowItems.value = Object(tslib_es6["d" /* __spreadArrays */])(extraItems, props.overflowMenuItems.slice(0, state.hiddenCount.value));
    };
    return ResizeGroup;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));



/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ListDropTargetBehavior_ListDropTargetBehavior; });

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/List/List.css
var List = __webpack_require__(44);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/List/ListDropIndicator.css
var ListDropIndicator = __webpack_require__(45);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Utilities/DragDrop.js
var DragDrop = __webpack_require__(27);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/List/List.js
var List_List = __webpack_require__(35);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/List/ListDropIndicator.Props.js
/**
 * Represents where within the containing element to draw the drop indicator
 */
var ListDropIndicatorPosition;
(function (ListDropIndicatorPosition) {
    ListDropIndicatorPosition[ListDropIndicatorPosition["bottom"] = 0] = "bottom";
    ListDropIndicatorPosition[ListDropIndicatorPosition["top"] = 1] = "top";
})(ListDropIndicatorPosition || (ListDropIndicatorPosition = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/List/ListDropIndicator.js







function ListDropIndicator_ListDropIndicator(props) {
    var position = props.position, xOffset = props.xOffset;
    var left = (xOffset || 0) + "px";
    var positionClassName = position === ListDropIndicatorPosition.top ? "top" : "bottom";
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](external_commonjs_react_commonjs2_react_amd_React_root_React_["Fragment"], null,
        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])("bolt-list-drop-indicator-line flex-grow absolute", positionClassName), style: { left: left } }),
        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])("bolt-list-drop-indicator-circle absolute", positionClassName), style: { left: left } })));
}

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/List/ListDropTargetBehavior.js










/**
 * A behavior that turns a list into the target of a drag and drop operation. Note - this
 * behavior should only be used if your list is intended to _only_ be a drop target. Please use
 * the ListDragDropBehavior instead if the list is also a drag source, as that is the only way
 * to get keyboard drag and drop support within your list.
 */
var ListDropTargetBehavior_ListDropTargetBehavior = /** @class */ (function () {
    function ListDropTargetBehavior(options) {
        var _this = this;
        this.initialize = function (props, dragDroppableUI, eventDispatch) {
            _this.dragDroppableUI = dragDroppableUI;
            _this.eventDispatch = eventDispatch;
            _this.eventDispatch.addEventListener("dragenter", _this.onDragEnter);
            _this.eventDispatch.addEventListener("dragexit", _this.onDragExit);
            _this.eventDispatch.addEventListener("dragover", _this.onDragOver);
            _this.eventDispatch.addEventListener("drop", _this.onDrop);
            _this.itemProvider = props.itemProvider;
            _this.indicatorName = _this.options.isTree ? "tree-drop-indicator" : "drop-indicator";
        };
        this.onDragEnter = function (event) {
            if (!_this.handlesType(event)) {
                return;
            }
            if (_this.options.onDragEnter) {
                _this.options.onDragEnter(event);
            }
            else {
                event.detail.dataTransfer.dropEffect = DragDrop["a" /* DragDropEffect */].move;
            }
        };
        this.onDragExit = function (event) {
            if (!_this.handlesType(event)) {
                return;
            }
            if (_this.options.onDragExit) {
                _this.options.onDragExit(event);
            }
            _this.dragDroppableUI.removeOverlay(_this.indicatorName);
        };
        this.onDragOver = function (event) {
            if (!_this.handlesType(event)) {
                return;
            }
            var index = _this.calculateIndex(event);
            var dragIndex = event.detail.dataTransfer.secondaryData.index;
            var listId = event.detail.dataTransfer.secondaryData.sourceId;
            if (index >= 0 && (index !== dragIndex || listId !== _this.options.id || _this.options.isTree)) {
                if (_this.options.onDragOver) {
                    _this.options.onDragOver(event, { index: _this.listIndicatorPosition === ListDropIndicatorPosition.bottom ? index + 1 : index });
                }
                else {
                    event.detail.dataTransfer.dropEffect = DragDrop["a" /* DragDropEffect */].move;
                }
            }
            else {
                event.detail.dataTransfer.dropEffect = DragDrop["a" /* DragDropEffect */].none;
            }
            if (event.detail.dataTransfer.dropEffect === DragDrop["a" /* DragDropEffect */].none) {
                _this.dragDroppableUI.removeOverlay(_this.indicatorName);
            }
            else {
                _this.dragDroppableUI.addOverlay(_this.indicatorName, index, _this.renderDropIndicator);
            }
        };
        this.onDrop = function (event) {
            if (!_this.handlesType(event)) {
                return;
            }
            var index = _this.calculateIndex(event);
            var dragIndex = event.detail.dataTransfer.secondaryData.index;
            var listId = event.detail.dataTransfer.secondaryData.sourceId;
            if (index >= 0 && (index !== dragIndex || listId !== _this.options.id) && _this.options.onDrop) {
                _this.options.onDrop(event, { index: _this.listIndicatorPosition === ListDropIndicatorPosition.bottom ? index + 1 : index });
            }
            _this.dragDroppableUI.removeOverlay(_this.indicatorName);
        };
        this.renderDropIndicator = function (props) {
            return _this.options.isTree ? (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-list-tree-drop-target flex-grow" })) : (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](ListDropIndicator_ListDropIndicator, { position: _this.listIndicatorPosition }));
        };
        this.options = options;
    }
    ListDropTargetBehavior.prototype.componentDidUpdate = function (props) {
        this.itemProvider = props.itemProvider;
    };
    ListDropTargetBehavior.prototype.componentWillUnmount = function () {
        var _a, _b, _c;
        (_a = this.eventDispatch) === null || _a === void 0 ? void 0 : _a.removeEventListener("dragenter", this.onDragEnter);
        (_b = this.eventDispatch) === null || _b === void 0 ? void 0 : _b.removeEventListener("dragexit", this.onDragExit);
        (_c = this.eventDispatch) === null || _c === void 0 ? void 0 : _c.removeEventListener("dragover", this.onDragOver);
    };
    ListDropTargetBehavior.prototype.calculateIndex = function (event) {
        var cell = Object(List_List["f" /* cellFromEvent */])(event);
        var index = cell.rowIndex;
        if (this.options.isTree) {
            return index;
        }
        if (cell.rowElement && event.detail.dataTransfer.secondaryData) {
            var dragIndex = event.detail.dataTransfer.secondaryData.index;
            var listId = event.detail.dataTransfer.secondaryData.sourceId;
            var nativeEvent = event.detail.nativeEvent;
            var rowRect = cell.rowElement.getBoundingClientRect();
            var point = Object(Util["getPointByEventType"])(nativeEvent);
            var topHalfOfRow = point ? point.y < rowRect.height / 2 + rowRect.top : index < dragIndex;
            if (this.options.id !== listId) {
                this.listIndicatorPosition = ListDropIndicatorPosition.top;
                if (!topHalfOfRow) {
                    index++;
                }
                if (index >= this.itemProvider.length) {
                    this.listIndicatorPosition = ListDropIndicatorPosition.bottom;
                    index--;
                }
            }
            else {
                if (index < dragIndex) {
                    this.listIndicatorPosition = ListDropIndicatorPosition.top;
                    if (!topHalfOfRow) {
                        index++;
                    }
                }
                else if (index > dragIndex) {
                    this.listIndicatorPosition = ListDropIndicatorPosition.bottom;
                    if (topHalfOfRow) {
                        index--;
                    }
                }
                // No-op if index === dragIndex
            }
        }
        return index;
    };
    ListDropTargetBehavior.prototype.handlesType = function (event) {
        var _a;
        var type = ((_a = event.detail.dataTransfer) === null || _a === void 0 ? void 0 : _a.type) || "";
        return this.options.allowedTypes.indexOf(type) !== -1;
    };
    return ListDropTargetBehavior;
}());



/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_Expandable_Expandable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(142);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Expandable", function() { return _Components_Expandable_Expandable__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_Expandable_Expandable_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(143);
/* harmony import */ var _Components_Expandable_Expandable_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_Expandable_Expandable_Props__WEBPACK_IMPORTED_MODULE_1__);




/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ScreenSizeObserver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScreenSizeConditional; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Core_Util_Screen__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);



var ScreenSizeObserver = function (props) {
    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_Core_Util_Screen__WEBPACK_IMPORTED_MODULE_1__[/* ScreenContext */ "b"].Consumer, null, function (screen) { return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_2__["Observer"], { screenSize: screen.size }, props.children); });
};
/**
 * Conditionally renders children based on screen size.
 */
var ScreenSizeConditional = function (props) {
    return (react__WEBPACK_IMPORTED_MODULE_0__["createElement"](ScreenSizeObserver, null, function (screenSizeProps) { return props.condition(screenSizeProps.screenSize) && props.children; }));
};


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_FilterBarItem_FilterBarItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(170);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilterBarItem", function() { return _Components_FilterBarItem_FilterBarItem__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_FilterBarItem_FilterBarItem_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(171);
/* harmony import */ var _Components_FilterBarItem_FilterBarItem_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_FilterBarItem_FilterBarItem_Props__WEBPACK_IMPORTED_MODULE_1__);

// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present



/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClearFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KeywordFilterBarItemPlaceholderText; });
var ClearFilter = "Clear filter";
var KeywordFilterBarItemPlaceholderText = "Filter by keywords";


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Viewer = exports.FilterKeywordContext = void 0;
__webpack_require__(204);
const React = __webpack_require__(0);
const react_1 = __webpack_require__(0);
const mobx_1 = __webpack_require__(3);
const mobx_react_1 = __webpack_require__(67);
const mobx_utils_1 = __webpack_require__(207);
__webpack_require__(208);
// Contexts must come before renderCell or anything the uses this.
exports.FilterKeywordContext = React.createContext('');
const FilterBar_1 = __webpack_require__(209);
const RunCard_1 = __webpack_require__(261);
const RunStore_1 = __webpack_require__(185);
const successPng = __webpack_require__(387);
const noResultsPng = __webpack_require__(388);
const Card_1 = __webpack_require__(84);
const MessageCard_1 = __webpack_require__(396);
const Page_1 = __webpack_require__(398);
const Surface_1 = __webpack_require__(18);
const ZeroData_1 = __webpack_require__(397);
const Observable_1 = __webpack_require__(4);
let Viewer = class Viewer extends react_1.Component {
    constructor(props) {
        super(props);
        this.collapseComments = new Observable_1.ObservableValue(false);
        this.warnOldVersion = false;
        this._warnOldVersion = (0, mobx_1.autorun)(() => {
            const { logs } = this.props;
            this.warnOldVersion = logs === null || logs === void 0 ? void 0 : logs.some(log => log.version !== '2.1.0');
        });
        this.runStores = (0, mobx_utils_1.computedFn)(logs => {
            const { hideBaseline, showAge, showActions } = this.props;
            if (!logs)
                return []; // Undef interpreted as loading.
            const runs = [].concat(...logs.filter(log => log.version === '2.1.0').map(log => { log.runs.forEach((run, index) => { run._index = index; }); return log.runs; }));
            const { filter, groupByAge } = this;
            const runStores = runs.map((run, i) => new RunStore_1.RunStore(run, i, filter, groupByAge, hideBaseline, showAge, showActions));
            runStores.sort((a, b) => a.driverName.localeCompare(b.driverName)); // May not be required after introduction of runStoresSorted.
            return runStores;
        }, { keepAlive: true });
        const { defaultFilterState, filterState, showAge } = this.props;
        this.filter = new FilterBar_1.MobxFilter(defaultFilterState, filterState);
        this.groupByAge = mobx_1.observable.box(showAge);
    }
    get runStoresSorted() {
        const { logs } = this.props;
        return this.runStores(logs).slice().sorted((a, b) => b.filteredCount - a.filteredCount); // Highest count first.
    }
    render() {
        var _a;
        const { hideBaseline, hideLevel, showSuppression, showAge, successMessage } = this.props;
        // Computed values fail to cache if called from onRenderNearElement() for unknown reasons. Thus call them in advance.
        const currentfilterState = this.filter.getState();
        const filterKeywords = (_a = currentfilterState.Keywords) === null || _a === void 0 ? void 0 : _a.value;
        const nearElement = (() => {
            var _a, _b, _c, _d;
            const { runStoresSorted } = this;
            if (!runStoresSorted.length)
                return null; // Interpreted as loading.
            const filteredResultsCount = runStoresSorted.reduce((total, run) => total + run.filteredCount, 0);
            if (filteredResultsCount === 0) {
                const startingFilterState = this.props.filterState || FilterBar_1.recommendedDefaultState;
                const startingFilterStateLevel = (_b = (_a = startingFilterState['Level']) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : [];
                if (!startingFilterStateLevel.length) {
                    startingFilterStateLevel.push('error', 'warning', 'note', 'none'); // Normalize.
                }
                const currentfilterStateLevel = (_d = (_c = currentfilterState['Level']) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : [];
                if (!currentfilterStateLevel.length) {
                    currentfilterStateLevel.push('error', 'warning', 'note', 'none'); // Normalize.
                }
                // Desired Behavior Matrix:
                // start curr 
                // ew    ew    success (common)
                // ew    e-    noResult (there could still be warnings)
                // ew    -w    noResult (there could still be errors)
                // ew    --    noResult (there could still be either)
                // e-    ew    success
                // e-    e-    success (common)
                // e-    -w    noResult (there could still be errors)
                // e-    --    noResult (there could still be either)
                // -w    ew    success (uncommon)
                // -w    e-    noResult (there could still be warnings, uncommon)
                // -w    -w    success (uncommon)
                // -w    --    noResult (there could still be either)
                // --    **    no scenario
                const showSuccess = successMessage
                    && (!startingFilterStateLevel.includes('error') || currentfilterStateLevel.includes('error'))
                    && (!startingFilterStateLevel.includes('warning') || currentfilterStateLevel.includes('warning'));
                if (showSuccess && !filterKeywords) {
                    return React.createElement("div", { className: "page-content-left page-content-right page-content-top" },
                        React.createElement(Card_1.Card, { contentProps: { contentPadding: false } },
                            React.createElement(ZeroData_1.ZeroData, { imagePath: successPng, imageAltText: "Success", secondaryText: successMessage })));
                }
                return React.createElement("div", { className: "page-content-left page-content-right page-content-top" },
                    React.createElement(Card_1.Card, { contentProps: { contentPadding: false } },
                        React.createElement(ZeroData_1.ZeroData, { imagePath: noResultsPng, imageAltText: "No results found", secondaryText: "No results found" })));
            }
            return runStoresSorted
                .filter(run => !filterKeywords || run.filteredCount)
                .map((run, index) => React.createElement("div", { key: run.logIndex, className: "page-content-left page-content-right page-content-top" },
                React.createElement(RunCard_1.RunCard, { runStore: run, index: index, runCount: runStoresSorted.length })));
        })();
        return React.createElement(exports.FilterKeywordContext.Provider, { value: filterKeywords !== null && filterKeywords !== void 0 ? filterKeywords : '' },
            React.createElement(Surface_1.SurfaceContext.Provider, { value: { background: Surface_1.SurfaceBackground.neutral } },
                React.createElement(Page_1.Page, null,
                    React.createElement("div", { className: "swcShim" }),
                    React.createElement(FilterBar_1.FilterBar, { filter: this.filter, groupByAge: this.groupByAge.get(), hideBaseline: hideBaseline, hideLevel: hideLevel, showSuppression: showSuppression, showAge: showAge }),
                    this.warnOldVersion && React.createElement(MessageCard_1.MessageCard, { severity: MessageCard_1.MessageCardSeverity.Warning, onDismiss: () => this.warnOldVersion = false }, "Pre-SARIF-2.1 logs have been omitted. Use the Artifacts explorer to access all files."),
                    nearElement)));
    }
};
__decorate([
    mobx_1.observable
], Viewer.prototype, "warnOldVersion", void 0);
__decorate([
    mobx_1.computed
], Viewer.prototype, "runStoresSorted", null);
Viewer = __decorate([
    mobx_react_1.observer
], Viewer);
exports.Viewer = Viewer;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(251);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(252);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(265);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(50)))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var legacy = __webpack_require__(288)
var invalid = __webpack_require__(289)
var decimal = __webpack_require__(71)
var hexadecimal = __webpack_require__(290)
var alphanumerical = __webpack_require__(291)
var decodeEntity = __webpack_require__(292)

module.exports = parseEntities

var own = {}.hasOwnProperty
var fromCharCode = String.fromCharCode
var noop = Function.prototype

// Default settings.
var defaults = {
  warning: null,
  reference: null,
  text: null,
  warningContext: null,
  referenceContext: null,
  textContext: null,
  position: {},
  additional: null,
  attribute: false,
  nonTerminated: true
}

// Characters.
var tab = 9 // '\t'
var lineFeed = 10 // '\n'
var formFeed = 12 //  '\f'
var space = 32 // ' '
var ampersand = 38 //  '&'
var semicolon = 59 //  ';'
var lessThan = 60 //  '<'
var equalsTo = 61 //  '='
var numberSign = 35 //  '#'
var uppercaseX = 88 //  'X'
var lowercaseX = 120 //  'x'
var replacementCharacter = 65533 // '�'

// Reference types.
var name = 'named'
var hexa = 'hexadecimal'
var deci = 'decimal'

// Map of bases.
var bases = {}

bases[hexa] = 16
bases[deci] = 10

// Map of types to tests.
// Each type of character reference accepts different characters.
// This test is used to detect whether a reference has ended (as the semicolon
// is not strictly needed).
var tests = {}

tests[name] = alphanumerical
tests[deci] = decimal
tests[hexa] = hexadecimal

// Warning types.
var namedNotTerminated = 1
var numericNotTerminated = 2
var namedEmpty = 3
var numericEmpty = 4
var namedUnknown = 5
var numericDisallowed = 6
var numericProhibited = 7

// Warning messages.
var messages = {}

messages[namedNotTerminated] =
  'Named character references must be terminated by a semicolon'
messages[numericNotTerminated] =
  'Numeric character references must be terminated by a semicolon'
messages[namedEmpty] = 'Named character references cannot be empty'
messages[numericEmpty] = 'Numeric character references cannot be empty'
messages[namedUnknown] = 'Named character references must be known'
messages[numericDisallowed] =
  'Numeric character references cannot be disallowed'
messages[numericProhibited] =
  'Numeric character references cannot be outside the permissible Unicode range'

// Wrap to ensure clean parameters are given to `parse`.
function parseEntities(value, options) {
  var settings = {}
  var option
  var key

  if (!options) {
    options = {}
  }

  for (key in defaults) {
    option = options[key]
    settings[key] =
      option === null || option === undefined ? defaults[key] : option
  }

  if (settings.position.indent || settings.position.start) {
    settings.indent = settings.position.indent || []
    settings.position = settings.position.start
  }

  return parse(value, settings)
}

// Parse entities.
// eslint-disable-next-line complexity
function parse(value, settings) {
  var additional = settings.additional
  var nonTerminated = settings.nonTerminated
  var handleText = settings.text
  var handleReference = settings.reference
  var handleWarning = settings.warning
  var textContext = settings.textContext
  var referenceContext = settings.referenceContext
  var warningContext = settings.warningContext
  var pos = settings.position
  var indent = settings.indent || []
  var length = value.length
  var index = 0
  var lines = -1
  var column = pos.column || 1
  var line = pos.line || 1
  var queue = ''
  var result = []
  var entityCharacters
  var namedEntity
  var terminated
  var characters
  var character
  var reference
  var following
  var warning
  var reason
  var output
  var entity
  var begin
  var start
  var type
  var test
  var prev
  var next
  var diff
  var end

  if (typeof additional === 'string') {
    additional = additional.charCodeAt(0)
  }

  // Cache the current point.
  prev = now()

  // Wrap `handleWarning`.
  warning = handleWarning ? parseError : noop

  // Ensure the algorithm walks over the first character and the end (inclusive).
  index--
  length++

  while (++index < length) {
    // If the previous character was a newline.
    if (character === lineFeed) {
      column = indent[lines] || 1
    }

    character = value.charCodeAt(index)

    if (character === ampersand) {
      following = value.charCodeAt(index + 1)

      // The behaviour depends on the identity of the next character.
      if (
        following === tab ||
        following === lineFeed ||
        following === formFeed ||
        following === space ||
        following === ampersand ||
        following === lessThan ||
        following !== following ||
        (additional && following === additional)
      ) {
        // Not a character reference.
        // No characters are consumed, and nothing is returned.
        // This is not an error, either.
        queue += fromCharCode(character)
        column++

        continue
      }

      start = index + 1
      begin = start
      end = start

      if (following === numberSign) {
        // Numerical entity.
        end = ++begin

        // The behaviour further depends on the next character.
        following = value.charCodeAt(end)

        if (following === uppercaseX || following === lowercaseX) {
          // ASCII hex digits.
          type = hexa
          end = ++begin
        } else {
          // ASCII digits.
          type = deci
        }
      } else {
        // Named entity.
        type = name
      }

      entityCharacters = ''
      entity = ''
      characters = ''
      test = tests[type]
      end--

      while (++end < length) {
        following = value.charCodeAt(end)

        if (!test(following)) {
          break
        }

        characters += fromCharCode(following)

        // Check if we can match a legacy named reference.
        // If so, we cache that as the last viable named reference.
        // This ensures we do not need to walk backwards later.
        if (type === name && own.call(legacy, characters)) {
          entityCharacters = characters
          entity = legacy[characters]
        }
      }

      terminated = value.charCodeAt(end) === semicolon

      if (terminated) {
        end++

        namedEntity = type === name ? decodeEntity(characters) : false

        if (namedEntity) {
          entityCharacters = characters
          entity = namedEntity
        }
      }

      diff = 1 + end - start

      if (!terminated && !nonTerminated) {
        // Empty.
      } else if (!characters) {
        // An empty (possible) entity is valid, unless it’s numeric (thus an
        // ampersand followed by an octothorp).
        if (type !== name) {
          warning(numericEmpty, diff)
        }
      } else if (type === name) {
        // An ampersand followed by anything unknown, and not terminated, is
        // invalid.
        if (terminated && !entity) {
          warning(namedUnknown, 1)
        } else {
          // If theres something after an entity name which is not known, cap
          // the reference.
          if (entityCharacters !== characters) {
            end = begin + entityCharacters.length
            diff = 1 + end - begin
            terminated = false
          }

          // If the reference is not terminated, warn.
          if (!terminated) {
            reason = entityCharacters ? namedNotTerminated : namedEmpty

            if (settings.attribute) {
              following = value.charCodeAt(end)

              if (following === equalsTo) {
                warning(reason, diff)
                entity = null
              } else if (alphanumerical(following)) {
                entity = null
              } else {
                warning(reason, diff)
              }
            } else {
              warning(reason, diff)
            }
          }
        }

        reference = entity
      } else {
        if (!terminated) {
          // All non-terminated numeric entities are not rendered, and trigger a
          // warning.
          warning(numericNotTerminated, diff)
        }

        // When terminated and number, parse as either hexadecimal or decimal.
        reference = parseInt(characters, bases[type])

        // Trigger a warning when the parsed number is prohibited, and replace
        // with replacement character.
        if (prohibited(reference)) {
          warning(numericProhibited, diff)
          reference = fromCharCode(replacementCharacter)
        } else if (reference in invalid) {
          // Trigger a warning when the parsed number is disallowed, and replace
          // by an alternative.
          warning(numericDisallowed, diff)
          reference = invalid[reference]
        } else {
          // Parse the number.
          output = ''

          // Trigger a warning when the parsed number should not be used.
          if (disallowed(reference)) {
            warning(numericDisallowed, diff)
          }

          // Stringify the number.
          if (reference > 0xffff) {
            reference -= 0x10000
            output += fromCharCode((reference >>> (10 & 0x3ff)) | 0xd800)
            reference = 0xdc00 | (reference & 0x3ff)
          }

          reference = output + fromCharCode(reference)
        }
      }

      // Found it!
      // First eat the queued characters as normal text, then eat an entity.
      if (reference) {
        flush()

        prev = now()
        index = end - 1
        column += end - start + 1
        result.push(reference)
        next = now()
        next.offset++

        if (handleReference) {
          handleReference.call(
            referenceContext,
            reference,
            {start: prev, end: next},
            value.slice(start - 1, end)
          )
        }

        prev = next
      } else {
        // If we could not find a reference, queue the checked characters (as
        // normal characters), and move the pointer to their end.
        // This is possible because we can be certain neither newlines nor
        // ampersands are included.
        characters = value.slice(start - 1, end)
        queue += characters
        column += characters.length
        index = end - 1
      }
    } else {
      // Handle anything other than an ampersand, including newlines and EOF.
      if (
        character === 10 // Line feed
      ) {
        line++
        lines++
        column = 0
      }

      if (character === character) {
        queue += fromCharCode(character)
        column++
      } else {
        flush()
      }
    }
  }

  // Return the reduced nodes, and any possible warnings.
  return result.join('')

  // Get current position.
  function now() {
    return {
      line: line,
      column: column,
      offset: index + (pos.offset || 0)
    }
  }

  // “Throw” a parse-error: a warning.
  function parseError(code, offset) {
    var position = now()

    position.column += offset
    position.offset += offset

    handleWarning.call(warningContext, messages[code], position, code)
  }

  // Flush `queue` (normal text).
  // Macro invoked before each entity and at the end of `value`.
  // Does nothing when `queue` is empty.
  function flush() {
    if (queue) {
      result.push(queue)

      if (handleText) {
        handleText.call(textContext, queue, {start: prev, end: now()})
      }

      queue = ''
    }
  }
}

// Check if `character` is outside the permissible unicode range.
function prohibited(code) {
  return (code >= 0xd800 && code <= 0xdfff) || code > 0x10ffff
}

// Check if `character` is disallowed.
function disallowed(code) {
  return (
    (code >= 0x0001 && code <= 0x0008) ||
    code === 0x000b ||
    (code >= 0x000d && code <= 0x001f) ||
    (code >= 0x007f && code <= 0x009f) ||
    (code >= 0xfdd0 && code <= 0xfdef) ||
    (code & 0xffff) === 0xffff ||
    (code & 0xffff) === 0xfffe
  )
}


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */



/**
 * Results cache
 */

var res = '';
var cache;

/**
 * Expose `repeat`
 */

module.exports = repeat;

/**
 * Repeat the given `string` the specified `number`
 * of times.
 *
 * **Example:**
 *
 * ```js
 * var repeat = require('repeat-string');
 * repeat('A', 5);
 * //=> AAAAA
 * ```
 *
 * @param {String} `string` The string to repeat
 * @param {Number} `number` The number of times to repeat the string
 * @return {String} Repeated string
 * @api public
 */

function repeat(str, num) {
  if (typeof str !== 'string') {
    throw new TypeError('expected a string');
  }

  // cover common, quick use cases
  if (num === 1) return str;
  if (num === 2) return str + str;

  var max = str.length * num;
  if (cache !== str || typeof cache === 'undefined') {
    cache = str;
    res = '';
  } else if (res.length >= max) {
    return res.substr(0, max);
  }

  while (max > res.length && num > 1) {
    if (num & 1) {
      res += str;
    }

    num >>= 1;
    str += str;
  }

  res += str;
  res = res.substr(0, max);
  return res;
}


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = trimTrailingLines

// Remove final newline characters from `value`.
function trimTrailingLines(value) {
  return String(value).replace(/\n+$/, '')
}


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = interrupt;

function interrupt(interruptors, tokenizers, ctx, params) {
  var bools = ['pedantic', 'commonmark'];
  var count = bools.length;
  var length = interruptors.length;
  var index = -1;
  var interruptor;
  var config;
  var fn;
  var offset;
  var bool;
  var ignore;

  while (++index < length) {
    interruptor = interruptors[index];
    config = interruptor[1] || {};
    fn = interruptor[0];
    offset = -1;
    ignore = false;

    while (++offset < count) {
      bool = bools[offset];

      if (config[bool] !== undefined && config[bool] !== ctx.options[bool]) {
        ignore = true;
        break;
      }
    }

    if (ignore) {
      continue;
    }

    if (tokenizers[fn].apply(ctx, params)) {
      return true;
    }
  }

  return false;
}


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var collapseWhiteSpace = __webpack_require__(312);

module.exports = normalize;

/* Normalize an identifier.  Collapses multiple white space
 * characters into a single space, and removes casing. */
function normalize(value) {
  return collapseWhiteSpace(value).toLowerCase();
}


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getRepoUri = void 0;
const urlJoin = __webpack_require__(366);
function getHostname(url) {
    if (!url)
        return undefined;
    try {
        return new URL(url).hostname;
    }
    catch (_) {
        return undefined;
    }
}
// TODO: Account for URI joins (normalizing slashes).
function getRepoUri(uri, run, region) {
    var _a, _b, _c;
    if (!uri)
        return undefined;
    const versionControlDetails = (_a = run.versionControlProvenance) === null || _a === void 0 ? void 0 : _a[0];
    if (!versionControlDetails)
        return undefined; // Required.
    const { repositoryUri, revisionId } = versionControlDetails;
    const hostname = getHostname(repositoryUri);
    if (!hostname)
        return undefined; // Required.
    if (hostname.endsWith('azure.com') || (hostname === null || hostname === void 0 ? void 0 : hostname.endsWith('visualstudio.com'))) {
        // Examples:
        // https://dev.azure.com/microsoft/sarif-web-component/_git/sarif-web-component?path=%2F.gitignore
        // https://dev.azure.com/microsoft/sarif-web-component/_git/sarif-web-component?path=%2F.gitignore&version=GCd14c42f18766159a7ef6fbb8858ab5ad4f0b532a
        let repoUri = revisionId
            ? `${repositoryUri}?path=${encodeURIComponent(uri)}&version=GC${revisionId}`
            : `${repositoryUri}?path=${encodeURIComponent(uri)}`;
        if (region === null || region === void 0 ? void 0 : region.startLine) { // lines and columns are 1-based, so it is safe to to use simple truthy checks.
            // First three params required even in the most basic case (highlight a single line).
            // If there is no endColumn, we +1 the lineEnd to select the entire line.
            repoUri += `&line=${region.startLine}`;
            repoUri += `&lineEnd=${(_b = region.endLine) !== null && _b !== void 0 ? _b : (region.startLine + (region.endColumn ? 0 : 1))}`;
            repoUri += `&lineStartColumn=${(_c = region.startColumn) !== null && _c !== void 0 ? _c : 1}`;
            if (region === null || region === void 0 ? void 0 : region.endColumn) {
                repoUri += `&lineEndColumn=${region.endColumn}`;
            }
        }
        return repoUri;
    }
    if (hostname.endsWith('github.com')) {
        // Examples:
        // https://github.com/microsoft/sarif-web-component/blob/main/.gitignore
        // https://github.com/microsoft/sarif-web-component/blob/d14c42f18766159a7ef6fbb8858ab5ad4f0b532a/.gitignore
        // https://github.com/microsoft/sarif-web-component/blob/d14c42f18766159a7ef6fbb8858ab5ad4f0b532a/.gitignore#L1
        // Note: path-browserify's path.join does does not preserve authority slashes
        // (ex: https://github.com becomes https:/github.com). Thus using url-join.
        let repoUri = urlJoin(`${repositoryUri}/blob/${revisionId !== null && revisionId !== void 0 ? revisionId : 'main'}`, uri);
        if (region === null || region === void 0 ? void 0 : region.startLine) { // `startLine` is 1-based.
            repoUri += `#L${region.startLine}`;
        }
        return repoUri;
    }
    return undefined; // Unsupported host.
}
exports.getRepoUri = getRepoUri;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(385);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TreeItemProvider", function() { return TreeItemProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);


/**
 * A TreeItemProvider is designed to store and manage the state of a tree.
 * As items are added/removed, expanded/collapsed, the providers "value" will
 * represent the current set of ordered items within the tree.
 */
var TreeItemProvider = /** @class */ (function () {
    function TreeItemProvider(rootItems) {
        if (rootItems === void 0) { rootItems = []; }
        // Track a map for each ITreeItem being tracked in the tree to its internal ITreeItemEx.
        this.itemMap = new Map();
        var treeItems = [];
        // Make a copy of the initial root items
        this.rootItems = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])(rootItems);
        // Add the root item and its entire sub-tree to the item map and update the items passed to the underlying tree.
        this.addItems(rootItems, undefined, treeItems);
        // Create the underlying observable we use to manage the underlying table items.
        this.tableItems = new _Core_Observable__WEBPACK_IMPORTED_MODULE_1__["ObservableArray"](treeItems);
    }
    Object.defineProperty(TreeItemProvider.prototype, "length", {
        get: function () {
            return this.tableItems.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeItemProvider.prototype, "roots", {
        get: function () {
            return this.rootItems;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeItemProvider.prototype, "value", {
        get: function () {
            return this.tableItems.value;
        },
        enumerable: true,
        configurable: true
    });
    TreeItemProvider.prototype.subscribe = function (observer, action) {
        return this.tableItems.subscribe(observer, action);
    };
    TreeItemProvider.prototype.unsubscribe = function (observer, action) {
        return this.tableItems.unsubscribe(observer, action);
    };
    /**
     * add can be used to add a single item to the tree at a given location. If the
     * specified parentItem or insertAfter are not in the tree or the insertAfter is not
     * a child of parentItem, the addition will be ignored.
     *
     * @param item The item to add to the tree.
     * @param parentItem The direct parent of the item being added.
     * If this is a rootItem leave the parentItem undefined.
     * @param insertAfter The sibling item this item should be inserted after.
     * If this is the first item within the parent leave insertAfter undefined.
     */
    TreeItemProvider.prototype.add = function (item, parentItem, insertAfter) {
        return this.splice(parentItem, undefined, [
            {
                insertAfter: insertAfter,
                items: [item]
            }
        ]);
    };
    /**
     * clear can be used to reset the provider. This is an optimized way to
     * remove all items from the tree.
     */
    TreeItemProvider.prototype.clear = function () {
        this.tableItems.splice(0, this.tableItems.length);
        this.rootItems.splice(0, this.rootItems.length);
    };
    /**
     * Collapse the node.
     *
     * @param treeItem The item whose state should be collapsed. If the treeItem is
     * not in the tree or if the item is already expanded the method will no-op.
     */
    TreeItemProvider.prototype.collapse = function (treeItem) {
        treeItem.expanded && this.toggle(treeItem);
    };
    /**
     * Expand the node. Optionally expand all parent nodes.
     *
     * @param treeItem The item whose state should be expanded. If the treeItem is
     * not in the tree the method will no-op.
     * @param expandParents If all parent nodes should be expanded. @default false
     */
    TreeItemProvider.prototype.expand = function (treeItem, expandParents) {
        var treeItemEx = this.itemMap.get(treeItem);
        if (!treeItemEx) {
            return;
        }
        var expandNodes = [];
        do {
            if (!treeItemEx.underlyingItem.expanded) {
                expandNodes.push(treeItemEx);
            }
            treeItemEx = treeItemEx.parentItem;
        } while (expandParents && treeItemEx);
        for (var index = expandNodes.length - 1; index >= 0; index--) {
            this.toggle(expandNodes[index].underlyingItem);
        }
    };
    /**
     * Remove the specified item from the tree. If the item doesnt exist the
     * remove will be ignored.
     *
     * @param treeItem The item that should be removed from the tree.
     * @param parentItem The parentItem of the item being removed. If the caller
     * doesnt have the parentItem readily available it will be computed, but this
     * can be expensive. The caller should supply it if they can.
     */
    TreeItemProvider.prototype.remove = function (treeItem, parentItem) {
        if (!parentItem) {
            var itemIndex = this.indexOf(treeItem);
            if ((itemIndex = this.indexOf(treeItem)) === -1) {
                return;
            }
            var removeItem = this.tableItems.value[itemIndex];
            parentItem = removeItem.parentItem && removeItem.parentItem.underlyingItem;
        }
        return this.splice(parentItem, [treeItem]);
    };
    /**
     * spliceItems is used to update the direct children of a given item
     * in the tree. If the parentItem is supplied and not in the tree the
     * changes will be ignored.
     *
     * @NOTE: Adds are processed before removes, this allows the existing
     * elements to be used as an insertAfter for placement. An item can't
     * be in both the add and remove set. This will cause duplication.
     *
     * @param parentItem The item whos children are being updated. If undefined
     * is supplied the updates will modify the root.
     * @param itemsToRemove The set of items that should removed from the parent.
     * @param itemsToAdd The set of items that should be added to the parent.
     */
    TreeItemProvider.prototype.splice = function (parentItem, itemsToRemove, itemsToAdd) {
        var _a;
        var parentItemEx;
        var notifyChange = false;
        var parentIndex = -1;
        var childItems = this.rootItems;
        if (parentItem) {
            parentItemEx = this.itemMap.get(parentItem);
            if (!parentItemEx) {
                return;
            }
            // Find the location in the table items we need splice changes.
            parentIndex = this.indexOf(parentItem);
            childItems = parentItemEx.underlyingItem.childItems || [];
        }
        // Before making any changes make a copy of the removed array, this allows
        // the caller to supply the current childItems to clear them.
        if (itemsToRemove) {
            itemsToRemove = itemsToRemove.slice(0);
        }
        // We will process the adds before the removes.
        if (itemsToAdd) {
            for (var index = 0; index < itemsToAdd.length; index++) {
                var tableItems = !parentItem || (parentIndex >= 0 && parentItem.expanded) ? [] : undefined;
                var itemToAdd = itemsToAdd[index];
                var insertIndex = parentIndex;
                var childIndex = 0;
                // If we are inserting after a specific item find that item. If it
                // isn't found, ignore the add.
                if (itemToAdd.insertAfter) {
                    // Ensure the insertAfter is a child of the parentItem.
                    if ((childIndex = childItems.indexOf(itemToAdd.insertAfter)) === -1) {
                        continue;
                    }
                    // Find the location in the underlying tableItems to insert.
                    var childInsertIndex = this.indexOf(itemToAdd.insertAfter, parentIndex + 1);
                    if (childInsertIndex !== -1) {
                        // Determine the number of elements in table under the insertAfter, we need to insert
                        // after these elements to ensure the inserted element is a sibling of insertAfter.
                        insertIndex = childInsertIndex + this.getTableChildCount(itemToAdd.insertAfter);
                    }
                }
                else {
                    // if we add to the front, childIndex needs to be -1 so when we do the +1 later, it will be 0
                    childIndex--;
                }
                // Add the items to the overall item map and compute the item being sent to the table.
                this.addItems(itemToAdd.items, parentItemEx, tableItems);
                // Update the childItems and if this is the first child update the treeItem.
                // We will notify if we are adding the first child since the state of the item is changing.
                childItems.splice.apply(childItems, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])([childIndex + 1, 0], itemToAdd.items));
                if (parentItemEx && !parentItemEx.underlyingItem.childItems) {
                    parentItemEx.underlyingItem.childItems = childItems;
                    notifyChange = true;
                }
                // Add the new items to the set of table items.
                if (tableItems) {
                    (_a = this.tableItems).splice.apply(_a, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])([insertIndex + 1, 0], tableItems));
                    notifyChange = true;
                }
            }
        }
        // Now process the removes.
        if (itemsToRemove) {
            for (var index = 0; index < itemsToRemove.length; index++) {
                var itemToRemove = itemsToRemove[index];
                var tableItems = !parentItem || parentItem.expanded ? [] : undefined;
                var childIndex = void 0;
                // Ensure the itemToRemove is a child of the parentItem.
                if ((childIndex = childItems.indexOf(itemToRemove)) === -1) {
                    continue;
                }
                // Remove the items from the underlying map and compute the set of items in the table.
                this.removeItem(itemToRemove, tableItems);
                // Remove the item from this childItem list. Notify if we removed the last child
                // since this is changing the state of the item.
                childItems.splice(childIndex, 1);
                if (childItems.length === 0 && parentItem) {
                    delete parentItem.childItems;
                    notifyChange = true;
                }
                var removeIndex = this.indexOf(itemToRemove, parentIndex + 1);
                if (removeIndex === -1) {
                    continue;
                }
                // Remove the items from the underlying observable.
                if (tableItems) {
                    this.tableItems.splice(removeIndex, tableItems.length);
                    notifyChange = true;
                }
            }
        }
        if (notifyChange && parentItemEx && parentIndex !== -1) {
            this.tableItems.change(parentIndex, parentItemEx);
        }
    };
    /**
     * toggleItem is used to toggle the expand/collapse state of a given tree item.
     *
     * @param treeItem The item whose state should be toggled. If the treeItem is
     * not in the tree the method will no-op.
     */
    TreeItemProvider.prototype.toggle = function (treeItem) {
        var _a;
        var itemIndex = this.indexOf(treeItem);
        if (itemIndex >= 0) {
            // Toggle the expanded state of the treeItem.
            treeItem.expanded = !treeItem.expanded;
            if (treeItem.childItems) {
                var tableItems = [];
                // Get the set of children being added to the underlying array.
                for (var index = 0; index < treeItem.childItems.length; index++) {
                    this.getTableItems(treeItem.childItems[index], tableItems);
                }
                // We need to update the underlying observables items.
                if (treeItem.expanded) {
                    (_a = this.tableItems).splice.apply(_a, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])([itemIndex + 1, 0], tableItems));
                }
                else {
                    this.tableItems.splice(itemIndex + 1, tableItems.length);
                }
            }
        }
    };
    TreeItemProvider.prototype.addItems = function (treeItems, parentItem, tableItems) {
        for (var index = 0; index < treeItems.length; index++) {
            var treeItem = treeItems[index];
            var treeItemEx = { depth: parentItem ? parentItem.depth + 1 : 0, parentItem: parentItem, underlyingItem: treeItem };
            // Add this treeItem and computed treeItemEx to the map.
            this.itemMap.set(treeItem, treeItemEx);
            // If the caller requested the set of items that should be given to the table.
            if (tableItems) {
                tableItems.push(treeItemEx);
            }
            // Go through all the children and add them to the map, and if it is expanded
            // we will forward the current tableItems array.
            if (treeItem.childItems) {
                this.addItems(treeItem.childItems, treeItemEx, treeItem.expanded ? tableItems : undefined);
            }
        }
    };
    TreeItemProvider.prototype.getTableItems = function (treeItem, tableItems) {
        var treeItemEx = this.itemMap.get(treeItem);
        if (treeItemEx) {
            tableItems.push(treeItemEx);
            if (treeItem.childItems && treeItem.expanded) {
                for (var _i = 0, _a = treeItem.childItems; _i < _a.length; _i++) {
                    var childItem = _a[_i];
                    this.getTableItems(childItem, tableItems);
                }
            }
        }
    };
    TreeItemProvider.prototype.getTableChildCount = function (treeItem) {
        var count = 0;
        if (treeItem.childItems && treeItem.expanded) {
            for (var index = 0; index < treeItem.childItems.length; index++) {
                count += this.getTableChildCount(treeItem.childItems[index]) + 1;
            }
        }
        return count;
    };
    /**
     * indexOfItem is used to find the index of a source treeItem. The underlying
     * observable indexOf will find instances of ITreeItemEx. This returns the
     * index from the set of items passed to the table.
     *
     * @param treeItem The item to find in the tree.
     * @param fromIndex The index to start the search.
     * @returns If the item is found an index >= 0 is returned, if it is not found -1 is returned.
     */
    TreeItemProvider.prototype.indexOf = function (treeItem, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        // @TODO: Can we come up with a faster method than this.
        for (var index = fromIndex; index < this.tableItems.length; index++) {
            if (treeItem === this.tableItems.value[index].underlyingItem) {
                return index;
            }
        }
        return -1;
    };
    TreeItemProvider.prototype.removeItem = function (treeItem, tableItems) {
        // Add this treeItem and computed treeItemEx to the map.
        this.itemMap.delete(treeItem);
        // If the caller requested the set of items that should be given to the table.
        if (tableItems) {
            tableItems.push(treeItem);
        }
        // Go through all the children and add them to the map, and if it is expanded
        // we will forward the current tableItems array.
        if (treeItem.childItems) {
            for (var childIndex = 0; childIndex < treeItem.childItems.length; childIndex++) {
                this.removeItem(treeItem.childItems[childIndex], treeItem.expanded ? tableItems : undefined);
            }
        }
    };
    return TreeItemProvider;
}());



/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_ResizeGroup_ResizeGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeGroup", function() { return _Components_ResizeGroup_ResizeGroup__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_ResizeGroup_ResizeGroup_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(189);
/* harmony import */ var _Components_ResizeGroup_ResizeGroup_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_ResizeGroup_ResizeGroup_Props__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_Components_ResizeGroup_ResizeGroup_Props__WEBPACK_IMPORTED_MODULE_1__, "OverflowButton")) __webpack_require__.d(__webpack_exports__, "OverflowButton", function() { return _Components_ResizeGroup_ResizeGroup_Props__WEBPACK_IMPORTED_MODULE_1__["OverflowButton"]; });

/* harmony import */ var _Components_ResizeGroup_OverflowButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(190);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OverflowButton", function() { return _Components_ResizeGroup_OverflowButton__WEBPACK_IMPORTED_MODULE_2__["a"]; });


// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present




/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FixedHeightList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rowFromElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rowFromEvent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _List_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44);
/* harmony import */ var _List_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_List_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45);
/* harmony import */ var _ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4);
/* harmony import */ var _FocusWithin__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23);
/* harmony import */ var _FocusZone__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7);
/* harmony import */ var _Intersection__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1);
/* harmony import */ var _Utilities_Dispatch__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(54);













/**
 * The FixedHeightList component is used to render a collection of items with a series of rows.
 */
var FixedHeightList = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(FixedHeightList, _super);
    function FixedHeightList(props) {
        var _this = _super.call(this, props) || this;
        // Manage data about pages, including their spacers.
        _this.intersectionElements = {};
        // Track the table element used to render the rows.
        _this.bodyElement = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.listElement = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.scrollToIndex = -1;
        _this.scrollToOptions = undefined;
        // Focus/Selection management members.
        _this.selectOnFocus = true;
        _this.focusIndex = new _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableValue"](-1);
        _this.pivotIndex = -1;
        _this.onBlur = function () {
            _this.focusIndex.value = -1;
        };
        _this.onClick = function (event) {
            _this.onDispatch(event);
            if (!event.defaultPrevented) {
                if (_this.listElement.current) {
                    var _a = rowFromEvent(event), cellElement = _a.cellElement, rowIndex = _a.rowIndex;
                    if (!cellElement) {
                        var item = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(_this.state.rows[rowIndex]);
                        if (rowIndex >= 0 && item) {
                            var listRow = { data: item, index: rowIndex };
                            // Even for singleClickActivation we fire the selection before activation.
                            if (_this.props.selectRowOnClick) {
                                _this.processSelectionEvent(event, listRow);
                            }
                            // For singleClickActivation we want the activation as well.
                            if (_this.props.singleClickActivation) {
                                _this.rowActivated(event, listRow);
                            }
                        }
                    }
                }
            }
        };
        _this.onDispatch = function (event) {
            _this.state.eventDispatch.dispatchEvent(event);
        };
        _this.onDoubleClick = function (event) {
            _this.onDispatch(event);
            if (!event.defaultPrevented && !_this.props.singleClickActivation) {
                var rowIndex = rowFromEvent(event).rowIndex;
                var item = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(_this.state.rows[rowIndex]);
                if (rowIndex >= 0 && item) {
                    _this.rowActivated(event, { data: item, index: rowIndex });
                }
            }
        };
        _this.onFocusBody = function (event) {
            // The first time the list gets focus we need to select initial row if we are performing
            // selection of focus.
            if (_this.selectOnFocus) {
                var selection = _this.props.selection;
                if (!selection || selection.selectOnFocus) {
                    var rowIndex = _this.focusIndex.value;
                    if (rowIndex >= 0) {
                        var item = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(_this.state.rows[rowIndex]);
                        if (item) {
                            _this.processSelectionEvent(event, { data: item, index: rowIndex });
                        }
                    }
                }
                _this.selectOnFocus = false;
            }
        };
        _this.onFocusItem = function (rowIndex, event) {
            var focusIndex = _this.focusIndex;
            if (focusIndex.value !== rowIndex) {
                _this.focusRow(rowIndex, 2);
                // We need to re-render the previously focused row and newly focused row so we will
                // clear the cached values.
                if (focusIndex.value >= 0) {
                    delete _this.state.renderedRows[focusIndex.value];
                }
                else if (_this.props.defaultTabbableRow !== undefined) {
                    // If there was a tabble row that was not the focusIndex.value row we need to update this
                    // row as well to get it re-rendered without the tabIndex.
                    delete _this.state.renderedRows[_this.props.defaultTabbableRow];
                }
                delete _this.state.renderedRows[rowIndex];
                _this.focusIndex.value = rowIndex;
                var item = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(_this.state.rows[rowIndex]);
                if (item) {
                    _this.rowFocused(event, { data: item, index: rowIndex });
                }
            }
        };
        _this.onKeyDown = function (event) {
            _this.onDispatch(event);
            if (!event.defaultPrevented) {
                var nodeName = event.target.nodeName;
                if (nodeName === "INPUT" || nodeName === "TEXTAREA") {
                    // Don't handle keyboard events when target is an input
                    return;
                }
                var focusIndex_1 = _this.focusIndex;
                var item_1 = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(_this.state.rows[focusIndex_1.value]);
                if (item_1) {
                    if (event.which === _Util__WEBPACK_IMPORTED_MODULE_11__["KeyCode"].enter) {
                        if (focusIndex_1.value >= 0 && !Object(_Util__WEBPACK_IMPORTED_MODULE_11__["eventTargetContainsNode"])(event, ["A"])) {
                            _this.rowActivated(event, { data: item_1, index: focusIndex_1.value });
                        }
                    }
                    else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_11__["KeyCode"].space) {
                        _this.processSelectionEvent(event, { data: item_1, index: focusIndex_1.value });
                        event.preventDefault();
                    }
                    else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_11__["KeyCode"].upArrow || event.which === _Util__WEBPACK_IMPORTED_MODULE_11__["KeyCode"].downArrow) {
                        var selection = _this.props.selection;
                        if (!selection || (selection.selectOnFocus && (event.shiftKey || !event.ctrlKey))) {
                            event.persist();
                            // Need to wait for the keyboard event to be processed by the focuszone.
                            window.setTimeout(function () {
                                if (_this.focusIndex.value != focusIndex_1.value) {
                                    _this.processSelectionEvent(event, { data: item_1, index: _this.focusIndex.value });
                                }
                            }, 0);
                        }
                    }
                    else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_11__["KeyCode"].pageDown) {
                        _this.focusRow(Math.min(focusIndex_1.value + _this.props.pageSize, _this.state.rowCount - 1), 1);
                        event.preventDefault();
                    }
                    else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_11__["KeyCode"].pageUp) {
                        _this.focusRow(Math.max(focusIndex_1.value - _this.props.pageSize, 0), -1);
                        event.preventDefault();
                    }
                    else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_11__["KeyCode"].home) {
                        _this.focusRow(0, 1);
                        event.preventDefault();
                    }
                    else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_11__["KeyCode"].end) {
                        _this.focusRow(_this.state.rowCount - 1, -1);
                        event.preventDefault();
                    }
                }
            }
        };
        _this.onIntersect = function (entries) {
            var scrollTop = _this.context.root.scrollTop;
            var rowCount = _this.state.rowCount;
            var _a = _this.state, firstMaterialized = _a.firstMaterialized, lastMaterialized = _a.lastMaterialized;
            var _b = _this.state, rowHeight = _b.rowHeight, rowProportion = _b.rowProportion;
            // Don't process an intersection while scroll event is pending.
            if (scrollTop !== _this.state.scrollTop && entries.length) {
                return;
            }
            // Ignore events if we dont have a our basic elements resolved (this should never happen).
            if (!_this.listElement.current || !_this.bodyElement.current) {
                return;
            }
            // Determine the location of the intersection within the page. This is the element
            // we are scrolling within.
            var intersectionRect = _this.context.root.getBoundingClientRect();
            var scrollTopRect = Math.max(0, scrollTop + _this.context.root.offsetTop - _this.listElement.current.offsetTop);
            // Track the first and last row elements for adjusting the range.
            var firstMaterializedUpdated = Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTopRect / (rowHeight * rowProportion))));
            var lastMaterializedUpdated = Math.min(rowCount - 1, firstMaterializedUpdated + Math.ceil(intersectionRect.height / rowHeight));
            if (scrollTopRect + (lastMaterializedUpdated - firstMaterializedUpdated) * rowHeight > _this.state.maxHeight) {
                lastMaterializedUpdated = rowCount - 1;
                firstMaterializedUpdated = Math.max(0, lastMaterializedUpdated - Math.ceil(intersectionRect.height / rowHeight));
            }
            // Update our state if and only if something has changed.
            if (firstMaterializedUpdated !== firstMaterialized ||
                lastMaterializedUpdated !== lastMaterialized ||
                rowHeight !== _this.state.rowHeight ||
                scrollTop !== _this.state.scrollTop ||
                scrollTopRect !== _this.state.scrollTopRect) {
                //
                // @TODO: We need to unload data for pages that are no longer rendererd.
                // This means not in the viewport or within any other rendered range.
                //
                _this.setState({
                    firstMaterialized: firstMaterializedUpdated,
                    lastMaterialized: lastMaterializedUpdated,
                    rowHeight: rowHeight,
                    scrollTop: scrollTop,
                    scrollTopRect: scrollTopRect
                });
            }
        };
        _this.onMouseDownBody = function (event) {
            // If the table body gets a mousedown, we will never need to fire the selection event when
            // the list gets focus since the mouse event will cause the selection.
            _this.selectOnFocus = false;
        };
        var rowCount = props.itemProvider.length;
        _this.state = {
            eventDispatch: props.eventDispatch || new _Utilities_Dispatch__WEBPACK_IMPORTED_MODULE_12__[/* EventDispatch */ "a"](),
            firstMaterialized: 0,
            itemProvider: props.itemProvider,
            lastMaterialized: 0,
            maxHeight: _this.props.maxHeight || 1000000,
            focusRows: {},
            renderedRows: {},
            rowCount: rowCount,
            rowHeight: props.rowHeight || 0,
            rowProportion: props.rowHeight && props.maxHeight ? Math.min(1, props.maxHeight / (props.rowHeight * rowCount)) : 1,
            rows: {},
            scrollTop: 0,
            scrollTopRect: 0
        };
        return _this;
    }
    FixedHeightList.getDerivedStateFromProps = function (props, state) {
        var rowCount = props.itemProvider.length;
        var firstMaterialized = state.firstMaterialized;
        var lastMaterialized = state.lastMaterialized;
        if (rowCount !== state.rowCount) {
            firstMaterialized = Math.max(0, Math.min(state.firstMaterialized, rowCount));
            lastMaterialized = Math.max(firstMaterialized, Math.min(state.lastMaterialized + (state.lastMaterialized === state.rowCount - 1 ? props.pageSize : 0), rowCount - 1));
        }
        // Ensure out pages and providers are appropriately computed.
        var updatedState = {
            firstMaterialized: firstMaterialized,
            itemProvider: props.itemProvider,
            lastMaterialized: lastMaterialized,
            rowCount: rowCount,
            rowProportion: Math.min(1, state.maxHeight / (state.rowHeight * rowCount))
        };
        // If there are changes to the props that affect the cached data, we need it clear it.
        if (props.itemProvider !== state.itemProvider) {
            updatedState.renderedRows = {};
            updatedState.rows = {};
        }
        return updatedState;
    };
    FixedHeightList.prototype.getListRole = function () {
        return this.props.role ? this.props.role : this.props.selection ? "listbox" : "list";
    };
    FixedHeightList.prototype.getItemRole = function () {
        switch (this.getListRole()) {
            case "tree":
            case "group":
                return "treeitem";
            case "list":
                return "listitem";
            case "listbox":
                return "option";
            case "radiogroup":
                return "radio";
            default:
                return null;
        }
    };
    FixedHeightList.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, focuszoneProps = _a.focuszoneProps, id = _a.id, width = _a.width;
        var _b = this.state, firstMaterialized = _b.firstMaterialized, lastMaterialized = _b.lastMaterialized, maxHeight = _b.maxHeight, rowCount = _b.rowCount, rowHeight = _b.rowHeight;
        var role = this.getListRole();
        var rows = [];
        var firstFocusRow = Math.max(0, this.focusIndex.value - 3);
        var lastFocusRow = Math.min(rowCount, this.focusIndex.value + 3);
        rows.push(this.renderIntersectionBounds(true));
        // Add focus rows around rendered rows.
        if (this.focusIndex.value !== -1 && firstFocusRow < firstMaterialized) {
            for (var rowIndex = firstFocusRow; rowIndex <= Math.min(lastFocusRow, firstMaterialized - 1); rowIndex++) {
                rows.push(this.renderRow(rowIndex, false));
            }
        }
        for (var rowIndex = firstMaterialized; rowIndex <= lastMaterialized; rowIndex++) {
            rows.push(this.renderRow(rowIndex, true));
        }
        if (this.focusIndex.value !== -1 && lastFocusRow > lastMaterialized && lastMaterialized > 0) {
            for (var rowIndex = Math.max(firstFocusRow, lastMaterialized + 1); rowIndex <= lastFocusRow; rowIndex++) {
                rows.push(this.renderRow(rowIndex, false));
            }
        }
        rows.push(this.renderIntersectionBounds(false));
        var height = Math.min(maxHeight, rowHeight * this.state.rowCount);
        var list = (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { "aria-label": this.props.ariaLabel, className: Object(_Util__WEBPACK_IMPORTED_MODULE_11__["css"])(className, "bolt-fixed-height-list relative"), id: Object(_Util__WEBPACK_IMPORTED_MODULE_11__["getSafeId"])(id), onBlur: this.onBlur, onClick: this.onClick, onDoubleClick: this.onDoubleClick, onDragEnd: this.onDispatch, onDragEnter: this.onDispatch, onDragExit: this.onDispatch, onDragOver: this.onDispatch, onDragStart: this.onDispatch, onDrop: this.onDispatch, onKeyUp: this.onDispatch, onMouseDown: this.onDispatch, onTouchStart: this.onDispatch, ref: this.listElement, role: role, style: { width: width, height: height } },
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "relative", onFocus: this.onFocusBody, onKeyDown: this.onKeyDown, onMouseDown: this.onMouseDownBody, ref: this.bodyElement, style: { width: width, height: height } }, rows)));
        list = (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZone */ "a"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({ direction: _FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZoneDirection */ "c"].Vertical, skipHiddenCheck: true }, focuszoneProps), list));
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_10__["Observer"], { itemProvider: {
                // Supply an IObservableExpression to elevate the provider change to a state
                // update for the entire component instead of just the observer.
                filter: function (change, action) {
                    // Notify the selection about the change to the items.
                    if (_this.props.selection) {
                        _this.props.selection.onItemsChanged(change, action);
                    }
                    // @NOTE: For now we will just wipe out the entire cache, we can do an optimized
                    // update to the cache based on the rows that changed.
                    var updatedState = {
                        renderedRows: {},
                        focusRows: {},
                        rows: {}
                    };
                    // If their is a well defined rowcount we will update it and the maxPage.
                    if (_this.state.rowCount !== -1) {
                        var countChange = (change.addedItems ? change.addedItems.length : 0) - (change.removedItems ? change.removedItems.length : 0);
                        if (countChange) {
                            updatedState.rowCount = _this.state.rowCount + countChange;
                            updatedState.firstMaterialized = Math.max(0, Math.min(_this.state.firstMaterialized, updatedState.rowCount - 1));
                            updatedState.lastMaterialized = Math.max(updatedState.firstMaterialized, Math.min(_this.state.lastMaterialized +
                                (change.index >= _this.state.firstMaterialized && change.index <= _this.state.lastMaterialized + 1
                                    ? countChange
                                    : 0), updatedState.rowCount - 1));
                        }
                    }
                    _this.setState(updatedState);
                    return false;
                },
                observableValue: this.props.itemProvider
            } }, function () { return list; }));
    };
    FixedHeightList.prototype.componentDidMount = function () {
        this.onIntersect([]);
        this.context.register(this.onIntersect);
    };
    FixedHeightList.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this, scrollToIndex = _a.scrollToIndex, onScrollComplete = _a.onScrollComplete;
        if (this.state.rowCount !== prevState.rowCount) {
            this.onIntersect([]);
        }
        if (scrollToIndex !== -1 && this.state.rowHeight) {
            var parentElement = this.bodyElement.current;
            var _b = this.state, firstMaterialized = _b.firstMaterialized, lastMaterialized = _b.lastMaterialized;
            // If the row is materialized, we will ensure it is in the viewport.
            if (scrollToIndex >= firstMaterialized && scrollToIndex <= lastMaterialized && parentElement) {
                for (var currentIndex = 0; currentIndex < parentElement.children.length; currentIndex++) {
                    var childElement = parentElement.children[currentIndex];
                    var cellDetails = rowFromElement(childElement);
                    if (cellDetails.rowIndex === scrollToIndex) {
                        childElement.scrollIntoView(this.scrollToOptions);
                        break;
                    }
                }
            }
            // Reset the scroll state before we notify the complete function, it may start a new scroll operation.
            this.onScrollComplete = undefined;
            this.scrollToIndex = -1;
            this.scrollToOptions = undefined;
            // Notify any pending scrollComplete method that scrolling has completed.
            if (onScrollComplete) {
                onScrollComplete(scrollToIndex);
            }
        }
    };
    FixedHeightList.prototype.componentWillUnmount = function () {
        this.context.unregister(this.onIntersect);
    };
    FixedHeightList.prototype.getFocusIndex = function () {
        return this.focusIndex.value;
    };
    FixedHeightList.prototype.getStats = function () {
        return {
            firstMaterialized: this.state.firstMaterialized,
            lastMaterialized: this.state.lastMaterialized
        };
    };
    FixedHeightList.prototype.scrollIntoView = function (rowIndex, options, onScrollComplete) {
        var pageSize = this.props.pageSize;
        var _a = this.state, firstMaterialized = _a.firstMaterialized, lastMaterialized = _a.lastMaterialized, rowCount = _a.rowCount;
        if (rowIndex >= 0 && rowIndex < this.state.rowCount) {
            var parentElement = this.bodyElement.current;
            // If the row is materialized, we will ensure it is in the viewport.
            if (rowIndex >= firstMaterialized && rowIndex <= lastMaterialized && parentElement) {
                for (var currentIndex = 0; currentIndex < parentElement.children.length; currentIndex++) {
                    var childElement = parentElement.children[currentIndex];
                    var cellDetails = rowFromElement(childElement);
                    if (cellDetails.rowIndex === rowIndex) {
                        childElement.scrollIntoView(options);
                        break;
                    }
                }
                // If the caller wants to know when the scroll has completed, notify them.
                if (onScrollComplete) {
                    onScrollComplete(rowIndex);
                }
            }
            else {
                // We only notify the last caller for now, if someone was waiting and another
                // scroll request was made we will send -1 as the rowIndex scrolled into view.
                if (this.onScrollComplete) {
                    this.onScrollComplete(-1);
                }
                // Set the scrollToOptions that will be applied after the next update.
                this.onScrollComplete = onScrollComplete;
                this.scrollToIndex = rowIndex;
                this.scrollToOptions = options;
                // If we havent computed the rowHeight at this point we need to wait until
                // we know how big rows are to get the row in the right location.
                this.setState({
                    firstMaterialized: Math.max(0, rowIndex - Math.floor((lastMaterialized - firstMaterialized) / 2)),
                    lastMaterialized: Math.min(rowCount - 1, Math.ceil(rowIndex + (lastMaterialized - firstMaterialized) / 2))
                });
            }
        }
    };
    FixedHeightList.prototype.focusRow = function (rowIndex, direction) {
        var _this = this;
        this.scrollIntoView(rowIndex, { block: "nearest" }, function (completedIndex) {
            if (completedIndex === rowIndex && _this.bodyElement.current) {
                var rowElement = _this.bodyElement.current.querySelector("[data-row-index='" + completedIndex + "']");
                if (rowElement) {
                    // We need to ensure the requested row is focusable, if not we will move in the
                    // requested direction to find the first focusable row.
                    if (!rowElement.getAttribute("tabindex")) {
                        var newIndex = Math.min(_this.state.rowCount - 1, Math.max(0, completedIndex + direction));
                        if (newIndex !== completedIndex) {
                            _this.focusRow(newIndex, direction);
                        }
                        else if (newIndex !== _this.focusIndex.value) {
                            _this.focusRow(newIndex, -direction);
                        }
                    }
                    else {
                        // Set focus to the row that scroll to
                        rowElement.focus();
                    }
                }
            }
        });
    };
    FixedHeightList.prototype.processSelectionEvent = function (event, listRow) {
        var selection = this.props.selection;
        if (!selection || selection.selectable(listRow.index)) {
            var initialState = false;
            var targetState = true;
            if (selection) {
                var index = listRow.index;
                // If a selection is available use it to track the initial state.
                initialState = selection.selected(index);
                // Determine the type of change being made to the selection based on key states.
                if (this.pivotIndex >= 0 && event.shiftKey && selection.multiSelect) {
                    selection.select(Math.min(this.pivotIndex, index), Math.abs(this.pivotIndex - index) + 1, event.ctrlKey || event.metaKey);
                }
                else {
                    if ((event.ctrlKey || event.metaKey || selection.alwaysMerge) && selection.multiSelect) {
                        selection.toggle(index, true);
                        targetState = false;
                    }
                    else {
                        selection.select(index, 1, false);
                    }
                }
                // Save the last selectionIndex that we selected, this will allow
                // us to perform range based selection.
                if (!event.shiftKey) {
                    this.pivotIndex = index;
                }
            }
            if (initialState !== targetState) {
                this.rowSelected(event, listRow);
            }
        }
    };
    FixedHeightList.prototype.renderLoadingRow = function (rowIndex, details) {
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-list-row-loading" },
            react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "shimmer shimmer-line", style: { width: Math.random() * 80 + 20 + "%" } }, "\u00A0")));
    };
    FixedHeightList.prototype.renderIntersectionBounds = function (top) {
        var _this = this;
        var _a = this.state, firstMaterialized = _a.firstMaterialized, lastMaterialized = _a.lastMaterialized, rowHeight = _a.rowHeight, rowProportion = _a.rowProportion;
        var key = top ? "topobserv" : "bottomobserv";
        var rowTop = 0;
        // If we run out of room move from the bottom up. This can happen with proportionally allocated rows
        if (firstMaterialized * rowHeight * rowProportion + (lastMaterialized - firstMaterialized) * rowHeight > this.state.maxHeight) {
            if (top) {
                rowTop = this.state.maxHeight;
                rowTop -= (lastMaterialized - firstMaterialized) * rowHeight * rowProportion + rowHeight;
                rowTop--;
            }
            else {
                rowTop = this.state.maxHeight - 1;
            }
        }
        else {
            if (top) {
                rowTop = firstMaterialized * rowHeight * rowProportion - 1;
            }
            else {
                rowTop = firstMaterialized * rowHeight * rowProportion + (1 + lastMaterialized - firstMaterialized) * rowHeight + 1;
            }
        }
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { "aria-hidden": "true", className: "bolt-list-row-spacer invisible absolute", key: key, ref: function (spacerElement) {
                var existingElement = _this.intersectionElements[key];
                if (spacerElement) {
                    if (existingElement !== spacerElement) {
                        if (existingElement) {
                            _this.context.unobserve(spacerElement);
                        }
                        _this.context.observe(spacerElement);
                        _this.intersectionElements[key] = spacerElement;
                    }
                }
                else if (existingElement) {
                    _this.context.unobserve(existingElement);
                    delete _this.intersectionElements[key];
                }
            }, role: "presentation", style: { top: rowTop + "px", height: "1px" } }));
    };
    FixedHeightList.prototype.renderRow = function (rowIndex, isVisible) {
        var _this = this;
        var itemProvider = this.props.itemProvider;
        var _a = this.state, focusRows = _a.focusRows, renderedRows = _a.renderedRows, firstMaterialized = _a.firstMaterialized, lastMaterialized = _a.lastMaterialized, rowHeight = _a.rowHeight, rowProportion = _a.rowProportion, rows = _a.rows;
        var role = this.getItemRole();
        var renderedRow = isVisible ? renderedRows[rowIndex] : focusRows[rowIndex];
        // We can't use the cache for proportioned rows since the top is different based on what the firstMaterialized value is
        if (!renderedRow || rowProportion !== 1) {
            var item_2 = rows[rowIndex];
            if (!item_2) {
                if (itemProvider.getItem) {
                    item_2 = itemProvider.getItem(rowIndex);
                }
                else {
                    item_2 = itemProvider.value[rowIndex];
                }
            }
            // @TODO: If there are no more rows, we need to handle an itemProvider with -1 length.
            if (!item_2) {
                return null;
            }
            // Save the current item in the item cache.
            rows[rowIndex] = item_2;
            var selection = this.props.selection;
            var selectionObservable = void 0;
            if (selection) {
                selectionObservable = {
                    observableValue: selection,
                    filter: function (selectedRanges) {
                        for (var _i = 0, selectedRanges_1 = selectedRanges; _i < selectedRanges_1.length; _i++) {
                            var selectionRange = selectedRanges_1[_i];
                            if (rowIndex >= selectionRange.beginIndex && rowIndex <= selectionRange.endIndex) {
                                return true;
                            }
                        }
                        return false;
                    }
                };
            }
            var onFocus_1 = function (event) {
                _this.onFocusItem(rowIndex, event);
            };
            // Render the row, save it in the cache, and add it to the current page.
            renderedRow = (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_10__["Observer"], { item: item_2, key: rowIndex, selection: selectionObservable, focusIndex: this.focusIndex }, function (props) {
                var _a = _this.props, renderRow = _a.renderRow, renderLoadingRow = _a.renderLoadingRow;
                var _b = _this.state, rowHeight = _b.rowHeight, rowCount = _b.rowCount;
                var rowItem = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(item_2);
                var itemDetails = {
                    ariaBusy: !props.item,
                    ariaRowOffset: 1,
                    data: rowItem,
                    eventDispatch: _this.state.eventDispatch,
                    itemProvider: _this.props.itemProvider,
                    listProps: _this.props,
                    onFocusItem: _this.onFocusItem,
                    singleClickActivation: _this.props.onActivate && _this.props.singleClickActivation
                };
                var renderedRow;
                if (props.item) {
                    renderedRow = renderRow(rowIndex, props.item, itemDetails);
                }
                else if (renderLoadingRow) {
                    renderedRow = renderLoadingRow(rowIndex, itemDetails);
                }
                else {
                    renderedRow = _this.renderLoadingRow(rowIndex, itemDetails);
                }
                var rowTop = 0;
                var rowHeightSpace = 0;
                if (rowIndex >= firstMaterialized && rowIndex <= lastMaterialized) {
                    rowHeightSpace = rowHeight;
                }
                // If we run out of room move from the bottom up. This can happen with proportionally allocated rows
                if (firstMaterialized * rowHeight * rowProportion + (lastMaterialized - firstMaterialized) * rowHeight >
                    _this.state.maxHeight) {
                    rowTop = _this.state.maxHeight;
                    rowTop -= (rowCount - lastMaterialized) * rowHeight * rowProportion;
                    rowTop -= (lastMaterialized - rowIndex) * rowHeight;
                }
                else {
                    if (rowHeightSpace === 0) {
                        rowTop = rowIndex * rowHeight * rowProportion;
                    }
                    else {
                        rowTop = firstMaterialized * rowHeight * rowProportion;
                        rowTop += (rowIndex - firstMaterialized) * rowHeight;
                    }
                }
                return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusWithin__WEBPACK_IMPORTED_MODULE_7__["FocusWithin"], { onFocus: onFocus_1 }, function (focusStatus) {
                    return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZoneContext */ "b"].Consumer, null, function (rowContext) {
                        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZone */ "a"], { direction: _FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZoneDirection */ "c"].Horizontal },
                            react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: Object(_Util__WEBPACK_IMPORTED_MODULE_11__["css"])("bolt-fixed-height-list-row scroll-hidden absolute", _this.focusIndex.value === rowIndex && "focused"), style: {
                                    height: rowHeightSpace + "px",
                                    top: rowTop + "px"
                                }, "data-focuszone": rowContext.focuszoneId, "data-row-index": rowIndex, tabIndex: rowIndex === 0 ? 0 : -1, onBlur: focusStatus.onBlur, onFocus: focusStatus.onFocus, role: role }, renderedRow)));
                    }));
                }));
            }));
            // Save the row in our cache.
            if (isVisible) {
                this.state.renderedRows[rowIndex] = renderedRow;
            }
            else {
                this.state.focusRows[rowIndex] = renderedRow;
            }
        }
        return renderedRow;
    };
    FixedHeightList.prototype.rowActivated = function (event, listRow) {
        this.state.eventDispatch.dispatchEvent(event, listRow, "activate");
        if (this.props.onActivate) {
            this.props.onActivate(event, listRow);
        }
    };
    FixedHeightList.prototype.rowSelected = function (event, listRow) {
        this.state.eventDispatch.dispatchEvent(event, listRow, "select");
        if (this.props.onSelect) {
            this.props.onSelect(event, listRow);
        }
    };
    FixedHeightList.prototype.rowFocused = function (event, listRow) {
        this.state.eventDispatch.dispatchEvent(event, listRow, "focus");
        if (this.props.onFocus) {
            this.props.onFocus(event, listRow);
        }
    };
    FixedHeightList.contextType = _Intersection__WEBPACK_IMPORTED_MODULE_9__["IntersectionContext"];
    FixedHeightList.defaultProps = {
        defaultTabbableRow: 0,
        focuszoneProps: { direction: _FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZoneDirection */ "c"].Vertical },
        maxHeight: 1000000
    };
    return FixedHeightList;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));

function getAttributeAsNumber(element, attributeName) {
    var attributeValue = element.getAttribute(attributeName);
    if (attributeValue) {
        return parseInt(attributeValue, 10);
    }
    return -1;
}
function rowFromElement(element) {
    var attributeValue;
    var cellIndex = -1;
    var rowIndex = -1;
    var cellElement = null;
    while (element) {
        attributeValue = getAttributeAsNumber(element, "data-row-index");
        if (attributeValue !== -1) {
            rowIndex = attributeValue;
            break;
        }
        // We have hit the root of the details list, dont look above this.
        if (element.classList.contains("bolt-fixed-height-list")) {
            element = null;
            break;
        }
        element = element.parentElement;
    }
    return {
        cellElement: cellElement,
        cellIndex: cellIndex,
        rowElement: element,
        rowIndex: rowIndex
    };
}
function rowFromEvent(event) {
    return rowFromElement(event.target);
}


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FocusWithin; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);




var FocusWithinContext = react__WEBPACK_IMPORTED_MODULE_3__["createContext"]({});
var FocusWithin = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(FocusWithin, _super);
    function FocusWithin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.blurTimeout = -1;
        _this.focusCount = 0;
        _this.focus = false;
        /**
         * onBlur method that should be attached to the onBlur handler of the
         * continers root element.
         */
        _this.onBlur = function () {
            // Don't let the focus count go below 0.
            // We have seen cases where we get a blur event, even when we
            // do not have focus. One such example is the Office Fabric TrapZone,
            // which will lose focus, then regain focus and stop propagation on
            // the event.
            _this.focusCount = Math.max(0, _this.focusCount - 1);
            // Clear any previous timeout if we somehow got a second blur event before
            // ever processing the timeout from the first one.
            if (_this.blurTimeout !== -1) {
                window.clearTimeout(_this.blurTimeout);
            }
            // We must delay the blur processing for two basic reasons:
            // 1) If focus is transitioning to a child element we will fire a Blur
            //  followed quickly by a Focus even though focus never left the element.
            //  This causes problems for things like menus that close on loss of focus.
            // 2) IE 11 fires the blur before the focus (no other browser does this)
            //  and this causes the same issue above but also causes focusCount
            //  inconsistencies.
            _this.blurTimeout = window.setTimeout(function () {
                _this.blurTimeout = -1;
                if (!_this.focusCount) {
                    _this.focus = false;
                    // If we are tracking the focus state we will force a component update.
                    if (_this.props.updateStateOnFocusChange) {
                        _this.forceUpdate();
                    }
                    if (_this.props.onBlur) {
                        _this.props.onBlur();
                    }
                }
            }, 0);
        };
        /**
         * onFocus method that should be attached to the onFocus handler of the
         * continer's root element.
         */
        _this.onFocus = function (event) {
            _this.focusCount++;
            // If focus is just entering one of the child components and not just moving
            // one child to another we will call the onFocus delegate if supplied.
            if (!_this.focus) {
                _this.focus = true;
                // If we are tracking the focus state we will force a component update.
                if (_this.props.updateStateOnFocusChange) {
                    _this.forceUpdate();
                }
                if (_this.props.onFocus) {
                    _this.props.onFocus(event);
                }
            }
        };
        return _this;
    }
    FocusWithin.prototype.render = function () {
        var _this = this;
        return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](FocusWithinContext.Consumer, null, function (focusWithinContext) {
            var children;
            var newProps = {
                onBlur: _this.onBlur,
                onFocus: _this.onFocus
            };
            // Save ou parent focus within for potential communication.
            _this.parentFocusWithin = focusWithinContext.focusWithin;
            if (typeof _this.props.children === "function") {
                var child = _this.props.children;
                // For functional components we pass the hasFocus attribute as well.
                newProps.hasFocus = _this.focus;
                children = child(newProps);
            }
            else {
                var child = react__WEBPACK_IMPORTED_MODULE_3__["Children"].only(_this.props.children);
                children = react__WEBPACK_IMPORTED_MODULE_3__["cloneElement"](child, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, child.props), newProps), child.props.children);
            }
            return react__WEBPACK_IMPORTED_MODULE_3__["createElement"](FocusWithinContext.Provider, { value: { focusWithin: _this } }, children);
        }));
    };
    /**
     * componentWillUnmount is used to cleanup the component state.
     *
     * @NOTE: The main thing we need to deal with is when this component is unmounted
     * while it has focus. We need to get this FocusWithin and all of its parents state
     * updated since focus will move directly to the body without a blur event.
     */
    FocusWithin.prototype.componentWillUnmount = function () {
        if (this.blurTimeout !== -1) {
            window.clearTimeout(this.blurTimeout);
            this.blurTimeout = -1;
        }
        if (this.focusCount > 0) {
            this.unmountWithFocus(false);
        }
    };
    /**
     * hasFocus returns true if the focus is contained within the focus component
     * hierarchy. This includes portals, the element may or may not
     * be a direct descendant of the focus component in the DOM structure.
     */
    FocusWithin.prototype.hasFocus = function () {
        return this.focusCount > 0;
    };
    /**
     * When the focusWithin unmounts we need to determine if we currently have focus.
     * If we do, focus will be moved silently to the body. We need to cleanup the
     * focusWithin's that are affected by this silent change.
     */
    FocusWithin.prototype.unmountWithFocus = function (fromParent) {
        if (this.focusCount > 0) {
            this.focusCount--;
            if (this.focusCount > 0) {
                // If we are tracking the focus state we will force a component update.
                if (fromParent) {
                    this.focusCount = 0;
                    this.focus = false;
                    if (this.props.updateStateOnFocusChange) {
                        this.forceUpdate();
                    }
                    if (this.props.onBlur) {
                        this.props.onBlur();
                    }
                }
            }
            // Notify the parent focus within that the mounted focus component is unmounting.
            if (this.parentFocusWithin) {
                this.parentFocusWithin.unmountWithFocus(true);
            }
        }
    };
    FocusWithin.defaultProps = {
        updateStateOnFocusChange: true
    };
    return FocusWithin;
}(react__WEBPACK_IMPORTED_MODULE_3__["Component"]));



/***/ }),
/* 111 */
/***/ (function(module, exports) {



/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FocusGroupContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FocusGroup; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);





var FocusGroupContext = react__WEBPACK_IMPORTED_MODULE_3__["createContext"]({
    onFocus: _Util__WEBPACK_IMPORTED_MODULE_4__["noop"]
});
var FocusGroup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(FocusGroup, _super);
    function FocusGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.onFocus = function (focusedElementId) {
            // Only setState if the focusedElement is changing. This prevents us from setting the state
            // when focus keeps getting fired on the same element. Example: Browser keeps losing and
            // getting focus.
            if (_this.state.focusedElementId !== focusedElementId) {
                _this.setState({ focusedElementId: focusedElementId });
            }
        };
        _this.state = { defaultElementId: props.defaultElementId, focusedElementId: props.defaultElementId };
        return _this;
    }
    FocusGroup.getDerivedStateFromProps = function (props, state) {
        if (state.defaultElementId !== props.defaultElementId) {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, state), { defaultElementId: props.defaultElementId, focusedElementId: props.defaultElementId });
        }
        return null;
    };
    FocusGroup.prototype.render = function () {
        return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](FocusGroupContext.Provider, { value: {
                focusedElementId: this.state.focusedElementId,
                onFocus: this.onFocus
            } }, this.props.children));
    };
    FocusGroup.prototype.focus = function (elementId) {
        var id = Object(_Util__WEBPACK_IMPORTED_MODULE_4__["getSafeId"])(elementId || this.state.focusedElementId);
        if (id) {
            var element = document.getElementById(id);
            if (element) {
                element.focus();
            }
        }
    };
    return FocusGroup;
}(react__WEBPACK_IMPORTED_MODULE_3__["Component"]));



/***/ }),
/* 113 */
/***/ (function(module, exports) {



/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IntersectionContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Intersection; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);





// We need to monitor fine grained changes, especially when the list
// has horizontal scroll. You dont get 100% visible ever.
var defaultThreshold = [];
for (var index = 0; index <= 100; index++) {
    defaultThreshold.push(index / 100);
}
var IntersectionContextImpl = /** @class */ (function () {
    function IntersectionContextImpl() {
        var _this = this;
        this.callbacks = [];
        this.pending = [];
        this.rootMargin = 0;
        this.root = document.body;
        this.onIntersect = function (entries) {
            if (_this.observer) {
                for (var _i = 0, _a = _this.callbacks; _i < _a.length; _i++) {
                    var callback = _a[_i];
                    callback(entries, _this.observer);
                }
            }
        };
    }
    IntersectionContextImpl.prototype.connect = function (root, rootMargin, threshold) {
        if (rootMargin === void 0) { rootMargin = 0; }
        if (threshold === void 0) { threshold = defaultThreshold; }
        this.observer = new IntersectionObserver(this.onIntersect, { root: root, rootMargin: rootMargin + "px", threshold: threshold });
        this.rootMargin = rootMargin;
        this.root = root;
        for (var _i = 0, _a = this.pending; _i < _a.length; _i++) {
            var element = _a[_i];
            this.observer.observe(element);
        }
    };
    IntersectionContextImpl.prototype.disconnect = function () {
        if (this.observer) {
            this.observer.disconnect();
        }
    };
    IntersectionContextImpl.prototype.observe = function (element) {
        if (this.observer) {
            this.observer.observe(element);
        }
        else {
            this.pending.push(element);
        }
    };
    IntersectionContextImpl.prototype.register = function (callback) {
        this.callbacks.push(callback);
    };
    IntersectionContextImpl.prototype.unobserve = function (element) {
        var elementIndex = this.pending.indexOf(element);
        if (elementIndex >= 0) {
            this.pending.splice(elementIndex, 1);
        }
        if (this.observer) {
            this.observer.unobserve(element);
        }
    };
    IntersectionContextImpl.prototype.unregister = function (callback) {
        var callbackIndex = this.callbacks.indexOf(callback);
        if (callbackIndex >= 0) {
            this.callbacks.splice(callbackIndex, 1);
        }
    };
    return IntersectionContextImpl;
}());
var IntersectionContext = react__WEBPACK_IMPORTED_MODULE_3__["createContext"](new IntersectionContextImpl());
/**
 * The Intersection is used to observe the changes of visibility in the children
 * of the rootElement. It also will notify the caller when the rootElement is
 * scrolled. It will pass an empty array of entries in the scorlling case.
 */
var Intersection = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(Intersection, _super);
    function Intersection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = new IntersectionContextImpl();
        _this.onScroll = function (event) {
            _this.state.onIntersect([]);
        };
        return _this;
    }
    // Render the provider around a SINGLE child. This is the element that is scrollable.
    Intersection.prototype.render = function () {
        var _this = this;
        var child = react__WEBPACK_IMPORTED_MODULE_3__["Children"].only(this.props.children);
        // Ensure we get the ref to the child if a rootElement wasnt supplied.
        if (!this.props.rootElement) {
            this.rootElement = Object(_Util__WEBPACK_IMPORTED_MODULE_4__["shimRef"])(child);
        }
        var onScroll;
        if (child.props.onScroll) {
            onScroll = function (event) {
                if (child.props.onScroll) {
                    child.props.onScroll(event);
                }
                _this.onScroll(event);
            };
        }
        else {
            onScroll = this.onScroll;
        }
        return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](IntersectionContext.Provider, { value: this.state }, react__WEBPACK_IMPORTED_MODULE_3__["cloneElement"](child, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, child.props), { ref: this.rootElement, onScroll: onScroll }), child.props.children)));
    };
    Intersection.prototype.componentDidMount = function () {
        var _a = this.props, observationElement = _a.observationElement, rootElement = _a.rootElement;
        var connectElement = null;
        if (rootElement) {
            if (typeof rootElement === "string") {
                connectElement = document.querySelector(rootElement);
            }
            else if (typeof rootElement === "function") {
                connectElement = rootElement();
            }
            else {
                connectElement = rootElement;
            }
            if (connectElement) {
                connectElement.addEventListener("scroll", this.onScroll);
                this.externalElement = connectElement;
            }
        }
        else if (this.rootElement) {
            connectElement = this.rootElement.current;
        }
        if (connectElement) {
            this.state.connect(connectElement, this.props.rootMargin, this.props.threshold);
            // Allow the creator of the intersection to observe intersection events.
            if (this.props.onIntersect) {
                this.state.register(this.props.onIntersect);
            }
            if (observationElement) {
                var observeElement = void 0;
                if (typeof observationElement === "string") {
                    observeElement = document.querySelector(observationElement);
                }
                else if (typeof observationElement === "function") {
                    observeElement = observationElement();
                }
                else {
                    observeElement = observationElement;
                }
                if (observeElement) {
                    this.state.observe(observeElement);
                }
            }
        }
    };
    Intersection.prototype.componentWillUnmount = function () {
        if (this.externalElement) {
            this.externalElement.removeEventListener("scroll", this.onScroll);
        }
        this.state.disconnect();
    };
    return Intersection;
}(react__WEBPACK_IMPORTED_MODULE_3__["Component"]));



/***/ }),
/* 115 */
/***/ (function(module, exports) {



/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemsObserver; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Utilities_Provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40);






var ItemsObserver = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(ItemsObserver, _super);
    function ItemsObserver() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onItemsChanged = function (value, action) {
            var _a = _this.props, getUnselectableRanges = _a.getUnselectableRanges, items = _a.items, selection = _a.selection;
            selection.onItemsChanged(value, action);
            selection.unselectableRanges = getUnselectableRanges(Object(_Utilities_Provider__WEBPACK_IMPORTED_MODULE_4__[/* getItemsValue */ "b"])(items));
            return false;
        };
        return _this;
    }
    ItemsObserver.prototype.componentDidMount = function () {
        this.props.selection.unselectableRanges = this.props.getUnselectableRanges(Object(_Utilities_Provider__WEBPACK_IMPORTED_MODULE_4__[/* getItemsValue */ "b"])(this.props.items));
    };
    ItemsObserver.prototype.render = function () {
        var itemsObservable = {
            observableValue: this.props.items,
            filter: this.onItemsChanged
        };
        return react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_5__[/* Observer */ "a"], { itemsObservable: itemsObservable }, this.props.children);
    };
    return ItemsObserver;
}(react__WEBPACK_IMPORTED_MODULE_3__["Component"]));



/***/ }),
/* 117 */
/***/ (function(module, exports) {



/***/ }),
/* 118 */
/***/ (function(module, exports) {



/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReadyableArrayObserver; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40);





var ReadyableArrayObserver = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(ReadyableArrayObserver, _super);
    function ReadyableArrayObserver() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loaded = false;
        _this.handleLoaded = function () {
            if (_this.props.data.ready.value && !_this.loaded) {
                _this.props.onReady && _this.props.onReady();
                _this.loaded = true;
            }
        };
        return _this;
    }
    ReadyableArrayObserver.prototype.render = function () {
        var _a = this.props, dataComponent = _a.dataComponent, loadingComponent = _a.loadingComponent, zeroDataComponent = _a.zeroDataComponent;
        return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_4__[/* Observer */ "a"], { data: this.props.data, onUpdate: this.handleLoaded, ready: this.props.data.ready }, function (props) {
            if (!props.ready) {
                return loadingComponent ? loadingComponent() : null;
            }
            if (props.data.length) {
                return dataComponent(props.data);
            }
            return zeroDataComponent ? zeroDataComponent() : null;
        }));
    };
    ReadyableArrayObserver.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.data !== this.props.data) {
            this.loaded = false;
            this.handleLoaded();
        }
    };
    ReadyableArrayObserver.prototype.componentDidMount = function () {
        this.handleLoaded();
    };
    return ReadyableArrayObserver;
}(react__WEBPACK_IMPORTED_MODULE_3__["Component"]));



/***/ }),
/* 120 */
/***/ (function(module, exports) {



/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectionObserver; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40);





var SelectionObserver = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(SelectionObserver, _super);
    function SelectionObserver() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelectionChanged = function (value, action) {
            var shouldUpdate = false;
            if (action === "select" && _this.props.onSelect) {
                shouldUpdate = _this.props.onSelect(value);
            }
            if ((action === "select" || action === "unselect" || action === "set") && _this.props.onSelectionChanged) {
                shouldUpdate = _this.props.onSelectionChanged(_this.props.selection.value, action);
            }
            return shouldUpdate;
        };
        return _this;
    }
    SelectionObserver.prototype.render = function () {
        var selectionObservable = { observableValue: this.props.selection, filter: this.onSelectionChanged };
        return react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_4__[/* Observer */ "a"], { selectionObservable: selectionObservable }, this.props.children);
    };
    return SelectionObserver;
}(react__WEBPACK_IMPORTED_MODULE_3__["Component"]));



/***/ }),
/* 122 */
/***/ (function(module, exports) {



/***/ }),
/* 123 */
/***/ (function(module, exports) {



/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TooltipStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Tooltip_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(226);
/* harmony import */ var _Tooltip_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Tooltip_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Callout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47);
/* harmony import */ var _FocusWithin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23);
/* harmony import */ var _MouseWithin__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1);
/* harmony import */ var _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12);










var TooltipStatus;
(function (TooltipStatus) {
    TooltipStatus[TooltipStatus["hidden"] = 0] = "hidden";
    TooltipStatus[TooltipStatus["visible"] = 1] = "visible";
    TooltipStatus[TooltipStatus["fadingout"] = 2] = "fadingout";
})(TooltipStatus || (TooltipStatus = {}));
var tooltipId = 1;
var Tooltip = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(Tooltip, _super);
    function Tooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.contentRef = react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
        _this.tooltipId = "tooltip-" + tooltipId++;
        _this.focus = false;
        _this.mouse = false;
        _this.showTooltip = function (event) {
            var anchorElement = event.currentTarget;
            if (_this.shouldShowTooltip(anchorElement)) {
                // If no anchorOrigin was specified use the Mouse.position when we show the toolip.
                var anchorPoint = void 0;
                if (!_this.props.anchorOrigin) {
                    anchorPoint = _Util__WEBPACK_IMPORTED_MODULE_8__["Mouse"].position;
                }
                _this.mouse = true;
                document.addEventListener("keydown", _this.onKeyDown);
                _this.setState({
                    anchorElement: anchorElement,
                    anchorOffset: { horizontal: 8, vertical: 8 },
                    anchorOrigin: { horizontal: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].center, vertical: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].end },
                    anchorPoint: anchorPoint,
                    innerText: _this.props.overflowOnly && !_this.props.text ? anchorElement.innerText : undefined,
                    tooltipStatus: TooltipStatus.visible,
                    tooltipOrigin: { horizontal: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].start, vertical: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].start }
                });
            }
        };
        _this.closeTooltip = function () {
            if (!(_this.focus && Object(_Util__WEBPACK_IMPORTED_MODULE_8__["getFocusVisible"])()) && _this.state.tooltipStatus === TooltipStatus.visible) {
                _this.mouse = false;
                document.removeEventListener("keydown", _this.onKeyDown);
                _this.setState({ tooltipStatus: _this.getDismissStatus() });
            }
        };
        _this.onKeyDown = function (event) {
            var _a;
            if (event.which === _Util__WEBPACK_IMPORTED_MODULE_8__["KeyCode"].escape && _this.state.tooltipStatus === TooltipStatus.visible) {
                _this.closeTooltip();
            }
            if (event.which === _Util__WEBPACK_IMPORTED_MODULE_8__["KeyCode"].ctrl && _this.state.tooltipStatus === TooltipStatus.visible) {
                var container = _this.contentRef.current;
                var selectionNode = (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.anchorNode;
                var hasSelectionInTooltip = container && selectionNode && container.contains(selectionNode);
                // Ctrl keystroke anywhere will dismiss the callout as per MAS 1.4.13,
                // except if user has selected something inside, in which case we allow Ctrl-C.
                if (!hasSelectionInTooltip) {
                    _this.closeTooltip();
                }
            }
        };
        _this.onAnimationEnd = function () {
            if (_this.state.tooltipStatus === TooltipStatus.fadingout) {
                _this.setState({
                    tooltipStatus: TooltipStatus.hidden
                });
            }
        };
        _this.getDismissStatus = function () {
            return _this.props.disabled ? TooltipStatus.hidden : TooltipStatus.fadingout;
        };
        _this.shouldShowTooltip = function (anchorElement) {
            if (_this.state.tooltipStatus !== TooltipStatus.hidden) {
                return false;
            }
            // If the tooltip only appears when the anchorElement overflows its parent then
            // we need to check on mouse enter.
            if (_this.props.overflowOnly && !_this.overflowDetected(anchorElement)) {
                return false;
            }
            // Dont show the tooltip if there is not content to show.
            if (!(_this.props.text || _this.props.renderContent || (anchorElement.innerText && _this.props.overflowOnly))) {
                return false;
            }
            return !_this.props.disabled;
        };
        _this.overflowDetected = props.overflowDetected || overflowDetected;
        _this.state = {
            tooltipStatus: TooltipStatus.hidden
        };
        return _this;
    }
    Tooltip.prototype.render = function () {
        var _this = this;
        return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_MouseWithin__WEBPACK_IMPORTED_MODULE_7__["MouseWithin"], { leaveDelay: 50, enterDelay: this.props.delayMs, onMouseLeave: this.closeTooltip, onMouseEnter: this.showTooltip }, function (mouseWithinEvents) {
            var child = react__WEBPACK_IMPORTED_MODULE_4__["Children"].only(_this.props.children);
            var id = _this.props.id || _this.tooltipId;
            var showTooltip = _this.state.tooltipStatus !== TooltipStatus.hidden && !_this.props.disabled && _this.state.anchorElement;
            // Save the existing events we will potentially proxy.
            var existingMouseEnter = child.props.onMouseEnter;
            var existingMouseLeave = child.props.onMouseLeave;
            var existingKeyDown = child.props.onKeyDown;
            var existingBlur;
            var existingFocus;
            var onMouseEnter = function (event) {
                if (mouseWithinEvents.onMouseEnter) {
                    mouseWithinEvents.onMouseEnter(event);
                }
                if (existingMouseEnter) {
                    existingMouseEnter(event);
                }
            };
            var onMouseLeave = function (event) {
                if (mouseWithinEvents.onMouseLeave) {
                    mouseWithinEvents.onMouseLeave(event);
                }
                if (existingMouseLeave) {
                    existingMouseLeave(event);
                }
            };
            var onKeyDown = function (event) {
                if (event.which === _Util__WEBPACK_IMPORTED_MODULE_8__["KeyCode"].escape && showTooltip) {
                    _this.setState({ tooltipStatus: TooltipStatus.hidden });
                    event.preventDefault();
                }
                if (existingKeyDown) {
                    existingKeyDown(event);
                }
            };
            // to not let consumers have to care about an implementation detail, wrap
            // the tooltip id in getSafeId and use that as the aria-describedBy property
            // on the child.
            var ariaDescribedById = _this.props.addAriaDescribedBy && _this.state.tooltipStatus !== TooltipStatus.hidden ? Object(_Util__WEBPACK_IMPORTED_MODULE_8__["getSafeId"])(id) : undefined;
            var childProps = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, child.props), { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown });
            if (childProps["aria-describedby"] === undefined) {
                childProps["aria-describedby"] = ariaDescribedById;
            }
            var clonedChild = react__WEBPACK_IMPORTED_MODULE_4__["cloneElement"](child, childProps, child.props.children);
            // If this tooltip should become visible when focus is within the component add the focus tracking.
            if (_this.props.showOnFocus && (_this.props.text || _this.props.renderContent || _this.props.overflowOnly)) {
                existingBlur = child.props.onBlur;
                existingFocus = child.props.onFocus;
                var onBlur = function () {
                    _this.focus = false;
                    if (!_this.mouse) {
                        _this.closeTooltip();
                    }
                    if (existingBlur) {
                        existingBlur();
                    }
                };
                var onFocus = function (event) {
                    var anchorElement = event.currentTarget;
                    if (_this.shouldShowTooltip(anchorElement)) {
                        _this.focus = true;
                        Object(_Util__WEBPACK_IMPORTED_MODULE_8__["getFocusVisible"])() &&
                            _this.setState({
                                anchorElement: event.target,
                                anchorOffset: { horizontal: 0, vertical: 8 },
                                anchorOrigin: { horizontal: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].center, vertical: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].end },
                                anchorPoint: undefined,
                                innerText: _this.props.overflowOnly && !_this.props.text ? anchorElement.innerText : undefined,
                                tooltipStatus: TooltipStatus.visible,
                                tooltipOrigin: { horizontal: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].center, vertical: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].start }
                            });
                    }
                    if (existingFocus) {
                        existingFocus(event);
                    }
                };
                clonedChild = (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_FocusWithin__WEBPACK_IMPORTED_MODULE_6__["FocusWithin"], { onBlur: onBlur, onFocus: onFocus, updateStateOnFocusChange: false }, clonedChild));
            }
            return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](react__WEBPACK_IMPORTED_MODULE_4__["Fragment"], null,
                clonedChild,
                showTooltip ? (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Callout__WEBPACK_IMPORTED_MODULE_5__[/* Callout */ "a"], { anchorElement: _this.state.anchorElement, anchorOffset: _this.props.anchorOffset || _this.state.anchorOffset, anchorOrigin: _this.props.anchorOrigin || _this.state.anchorOrigin, anchorPoint: _this.state.anchorPoint, calloutOrigin: _this.props.tooltipOrigin || _this.state.tooltipOrigin, className: Object(_Util__WEBPACK_IMPORTED_MODULE_8__["css"])(_this.props.className, "bolt-tooltip", _this.state.tooltipStatus === TooltipStatus.fadingout && "bolt-tooltip-fade-out"), fixedLayout: _this.props.fixedLayout, id: id, key: id, onAnimationEnd: _this.onAnimationEnd, onMouseEnter: mouseWithinEvents.onMouseEnter, onMouseLeave: mouseWithinEvents.onMouseLeave, portalProps: { className: "bolt-tooltip-portal" }, contentRef: _this.contentRef, role: "tooltip" },
                    react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: "bolt-tooltip-content body-m" }, (_this.props.renderContent && _this.props.renderContent()) || _this.props.text || _this.state.innerText))) : null));
        }));
    };
    Tooltip.prototype.componentWillUnmount = function () {
        document.removeEventListener("keydown", this.onKeyDown);
    };
    Tooltip.defaultProps = {
        delayMs: 250,
        showOnFocus: true
    };
    return Tooltip;
}(react__WEBPACK_IMPORTED_MODULE_4__["Component"]));

function overflowDetected(anchorElement) {
    return anchorElement.scrollWidth > Math.ceil(anchorElement.offsetWidth);
}


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Portal_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(230);
/* harmony import */ var _Portal_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Portal_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8);








/**
 * The Portal component is used to create a React Portal through a well known component.
 * This component allows the platform to control where portals are rooted in the document
 * and ensure these are managed properly.
 */
var Portal = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(Portal, _super);
    function Portal(props) {
        var _this = _super.call(this, props) || this;
        _this.mounted = new _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableValue"](false);
        // Determine the element that will host the portal.
        var parentElement = _this.props.portalElement;
        if (!parentElement && _this.props.portalSelector) {
            parentElement = document.querySelector(_this.props.portalSelector);
        }
        if (!parentElement) {
            parentElement = document.querySelector(".bolt-portal-host");
            if (!parentElement) {
                parentElement = document.createElement("div");
                parentElement.className = "bolt-portal-host absolute-fill no-events scroll-hidden";
                document.body.appendChild(parentElement);
            }
        }
        if (_this.props.parentClassName && !parentElement.classList.contains(_this.props.parentClassName)) {
            parentElement.classList.add(_this.props.parentClassName);
        }
        _this.parentElement = parentElement;
        // Create the hosting element for the portal.
        _this.hostElement = document.createElement("div");
        return _this;
    }
    Portal.prototype.render = function () {
        var _this = this;
        this.hostElement.className = "";
        this.hostElement.classList.add("bolt-portal");
        this.hostElement.classList.add("absolute-fill");
        // If custom class's are supplied add them (1 at a time since IE doesnt support multiple args).
        if (this.props.className) {
            var classNames = this.props.className.split(" ");
            for (var _i = 0, classNames_1 = classNames; _i < classNames_1.length; _i++) {
                var className = classNames_1[_i];
                this.hostElement.classList.add(className);
            }
        }
        // NOTE: We dont render the children until after we have mounted the portal.
        //  If the caller needs to access the document while mounting the content this
        //  will ensure the children of the portal are not mounted until the portal
        //  is attached to the DOM.
        return react_dom__WEBPACK_IMPORTED_MODULE_5__["createPortal"](react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_7__["Observer"], { mounted: this.mounted }, function (props) { return (props.mounted ? _this.props.children : null); }), this.hostElement);
    };
    Portal.prototype.componentDidMount = function () {
        this.parentElement.appendChild(this.hostElement);
        this.mounted.value = true;
    };
    Portal.prototype.componentWillUnmount = function () {
        this.parentElement.removeChild(this.hostElement);
    };
    return Portal;
}(react__WEBPACK_IMPORTED_MODULE_4__["Component"]));



/***/ }),
/* 126 */
/***/ (function(module, exports) {



/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MouseWithin; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);





var MouseWithin = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(MouseWithin, _super);
    function MouseWithin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.enterTimeout = 0;
        _this.delayTimeout = 0;
        _this.mouse = false;
        /**
         * onMouseEnter method that should be attached to the onMouseEnter handler of the
         * continer's root element.
         */
        _this.onMouseEnter = function (event) {
            // If the mouse is just entering one of the child components and not just moving
            // from one child to another we will call the onMouseEnter delegate if supplied.
            if (!_this.mouse) {
                _this.mouse = true;
                // Clear any pending leave if we have left and re-entered the component during
                // the leaveTimeout.
                if (_this.delayTimeout) {
                    window.clearTimeout(_this.delayTimeout);
                    _this.delayTimeout = 0;
                }
                if (_this.props.enterDelay) {
                    event.persist();
                    // persist does not preserve the currentTarget so we do that manually
                    var currentTarget_1 = event.currentTarget;
                    _this.enterTimeout = window.setTimeout(function () {
                        _this.enterTimeout = 0;
                        var newCurrentTarget = event.currentTarget;
                        event.currentTarget = currentTarget_1;
                        _this.mouseEntered(event);
                        event.currentTarget = newCurrentTarget;
                    }, _this.props.enterDelay);
                }
                else {
                    _this.mouseEntered(event);
                }
            }
        };
        /**
         * onMouseLeave method that should be attached to the onMouseLeave handler of the
         * container's root element.
         */
        _this.onMouseLeave = function (event) {
            if (_this.mouse) {
                _this.mouse = false;
                // Clear any pending enterTimeout if we didnt stay over the element long enough.
                if (_this.enterTimeout) {
                    window.clearTimeout(_this.enterTimeout);
                    _this.enterTimeout = 0;
                }
                if (_this.props.leaveDelay) {
                    event.persist();
                    _this.delayTimeout = window.setTimeout(function () {
                        _this.delayTimeout = 0;
                        _this.mouseLeft(event);
                    }, _this.props.leaveDelay);
                }
                else {
                    _this.mouseLeft(event);
                }
            }
        };
        return _this;
    }
    MouseWithin.prototype.render = function () {
        var newProps = {
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        if (Object(_Util__WEBPACK_IMPORTED_MODULE_4__["isFunctionalChildren"])(this.props.children)) {
            var child = this.props.children;
            // For functional components we pass the hasMouse attribute as well.
            newProps.hasMouse = this.mouse;
            return child(newProps);
        }
        else {
            var child = react__WEBPACK_IMPORTED_MODULE_3__["Children"].only(this.props.children);
            return react__WEBPACK_IMPORTED_MODULE_3__["cloneElement"](child, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, child.props), newProps), child.props.children);
        }
    };
    MouseWithin.prototype.componentWillUnmount = function () {
        if (this.enterTimeout) {
            window.clearTimeout(this.enterTimeout);
        }
        if (this.delayTimeout) {
            window.clearTimeout(this.delayTimeout);
        }
    };
    /**
     * hasMouse returns true if the mouse is contained within the component
     * hierarchy. This includes portals, the element may or may not
     * be a direct descendant of the component in the DOM structure.
     */
    MouseWithin.prototype.hasMouse = function () {
        return this.mouse;
    };
    MouseWithin.prototype.mouseEntered = function (event) {
        // If we are tracking the mouse state we will force a component update.
        if (this.props.updateStateOnMouseChange) {
            this.forceUpdate();
        }
        if (this.props.onMouseEnter) {
            this.props.onMouseEnter(event);
        }
    };
    MouseWithin.prototype.mouseLeft = function (event) {
        // If we are tracking the mouse state we will force a component update.
        if (this.props.updateStateOnMouseChange) {
            this.forceUpdate();
        }
        if (this.props.onMouseLeave) {
            this.props.onMouseLeave(event);
        }
    };
    MouseWithin.defaultProps = {
        updateStateOnMouseChange: true
    };
    return MouseWithin;
}(react__WEBPACK_IMPORTED_MODULE_3__["Component"]));



/***/ }),
/* 128 */
/***/ (function(module, exports) {



/***/ }),
/* 129 */
/***/ (function(module, exports) {



/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Link; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Link_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(234);
/* harmony import */ var _Link_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Link_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _FocusGroup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31);
/* harmony import */ var _FocusZone__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
/* harmony import */ var _TooltipEx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1);
/* harmony import */ var _Utilities_Focus__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26);










var Link = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(Link, _super);
    function Link() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
        _this.onClick = function (event) {
            _this.handleActivation(event);
        };
        _this.onKeyPress = function (event) {
            if (!_this.props.href && event.which === _Util__WEBPACK_IMPORTED_MODULE_8__["KeyCode"].enter) {
                // We only want to handle keyboard interaction if there is no href
                _this.handleActivation(event);
            }
        };
        _this.onFocus = function (event) {
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
            if (_this.props.id) {
                _this.context.onFocus(_this.props.id);
            }
        };
        return _this;
    }
    Link.prototype.render = function () {
        var _this = this;
        return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_6__[/* FocusZoneContext */ "b"].Consumer, null, function (focusZoneContext) {
            var props = _this.props;
            var ariaDescribedBy = props.ariaDescribedBy, ariaLabel = props.ariaLabel, ariaExpanded = props.ariaExpanded, ariaHasPopup = props.ariaHasPopup, ariaSelected = props.ariaSelected, className = props.className, excludeFocusZone = props.excludeFocusZone, target = props.target, dataIsFocusable = props.dataIsFocusable;
            var rel = props.rel, role = props.role;
            var TagType = "a";
            // If the link is targetting an external window or tab and no explicit rel
            // attribute was supplied we will set noopener.
            if (target && !rel) {
                rel = "noopener";
            }
            if (!props.href && !props.role) {
                role = "button";
            }
            if (!props.href) {
                TagType = "span";
            }
            var link = (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](TagType, { ref: _this.ref, "aria-describedby": Object(_Util__WEBPACK_IMPORTED_MODULE_8__["getSafeId"])(ariaDescribedBy), "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, "aria-label": ariaLabel, "aria-selected": ariaSelected, className: Object(_Util__WEBPACK_IMPORTED_MODULE_8__["css"])(className, "bolt-link", props.disabled && "disabled", props.subtle && "subtle", props.underline && "underline"), "data-focuszone": !excludeFocusZone && focusZoneContext.focuszoneId, "data-is-focusable": dataIsFocusable, download: props.download, href: props.href, id: Object(_Util__WEBPACK_IMPORTED_MODULE_8__["getSafeId"])(props.id), onBlur: props.onBlur, onClick: _this.onClick, onFocus: _this.onFocus, onKeyPress: _this.onKeyPress, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave, onMouseOver: props.onMouseOver, onTouchEnd: props.onTouchEnd, onTouchMove: props.onTouchMove, onTouchStart: props.onTouchStart, rel: rel, role: role, tabIndex: Object(_Utilities_Focus__WEBPACK_IMPORTED_MODULE_9__[/* getTabIndex */ "a"])(_this.props, _this.context), target: target }, _this.props.children));
            if (props.tooltipProps) {
                link = react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_TooltipEx__WEBPACK_IMPORTED_MODULE_7__["Tooltip"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, props.tooltipProps), link);
            }
            return link;
        }));
    };
    Link.prototype.focus = function () {
        this.ref.current && this.ref.current.focus();
    };
    Link.prototype.handleActivation = function (event) {
        if (!event.defaultPrevented) {
            if (this.props.disabled) {
                event.preventDefault();
            }
            else {
                this.props.onClick && this.props.onClick(event);
            }
        }
    };
    Link.contextType = _FocusGroup__WEBPACK_IMPORTED_MODULE_5__["FocusGroupContext"];
    return Link;
}(react__WEBPACK_IMPORTED_MODULE_4__["Component"]));



/***/ }),
/* 131 */
/***/ (function(module, exports) {



/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDefaultAnchorProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDefaultLinkProps; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

/**
 * Handles an href and target being passed to an anchor, without a rel.
 */
function getDefaultAnchorProps(anchorProps) {
    var modifiedAnchorProps;
    if (anchorProps) {
        var rel = anchorProps.rel;
        if (anchorProps.href && anchorProps.target && !rel) {
            rel = "noopener";
        }
        modifiedAnchorProps = {
            href: anchorProps.href,
            rel: rel,
            target: anchorProps.target
        };
    }
    return modifiedAnchorProps;
}
/**
 * Handles an href and target being passed to a link, without a rel.
 */
function getDefaultLinkProps(linkProps) {
    if (!linkProps) {
        return getDefaultAnchorProps(linkProps);
    }
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, getDefaultAnchorProps(linkProps)), { disabled: linkProps.disabled, id: linkProps.id, onClick: linkProps.onClick, role: linkProps.role });
}


/***/ }),
/* 133 */
/***/ (function(module, exports) {



/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListDragDropBehavior; });
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _List_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44);
/* harmony import */ var _List_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_List_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45);
/* harmony import */ var _ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);
/* harmony import */ var _Utilities_DragDrop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27);
/* harmony import */ var _List__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35);
/* harmony import */ var _ListDragSourceBehavior__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75);
/* harmony import */ var _ListDropTargetBehavior__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89);









/**
 * A behavior that combines the ListDragSourceBehavior and ListDropTargetBehavior. If your list
 * is only meant to be a drag source, or only meant to be a drop target, then use those two
 * behaviors individually.
 * In addition to combining the two behaviors for convenience, this single behavior also enhances
 * the list with keyboard drag and drop support.
 */
var ListDragDropBehavior = /** @class */ (function () {
    function ListDragDropBehavior(options) {
        var _this = this;
        this.initialize = function (props, dragDroppableUI, eventDispatch) {
            _this.eventDispatch = eventDispatch;
            _this.itemProvider = props.itemProvider;
            _this.eventDispatch.addEventListener("keydown", _this.onKeyDown);
            _this.dragBehavior.initialize(props, dragDroppableUI, eventDispatch);
            _this.dropBehavior.initialize(props, dragDroppableUI, eventDispatch);
        };
        this.onDragRowKeyDown = function (event) {
            if (event.which === _Util__WEBPACK_IMPORTED_MODULE_4__["KeyCode"].escape) {
                _this.endDrag(event);
            }
            else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_4__["KeyCode"].space) {
                _this.endDrag(event, true);
            }
            else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_4__["KeyCode"].downArrow) {
                _this.focusIndex = Math.min(_this.focusIndex + 1, _this.itemProvider.length);
                _this.fireRowDragEvents(event);
            }
            else if (event.which === _Util__WEBPACK_IMPORTED_MODULE_4__["KeyCode"].upArrow) {
                _this.focusIndex = Math.max(_this.focusIndex - 1, 0);
                _this.fireRowDragEvents(event);
            }
            // We don't want the list itself to have a chance to handle these events, while
            // we are in the middle of a drag operation.
            event.preventDefault();
        };
        this.onKeyDown = function (event) {
            if (!event.defaultPrevented && event.which === _Util__WEBPACK_IMPORTED_MODULE_4__["KeyCode"].space && event.target.tagName !== "INPUT") {
                // The user has hit spacebar on the row, so we should start the drag/drop operation.
                var index = Object(_List__WEBPACK_IMPORTED_MODULE_6__[/* cellFromEvent */ "f"])(event).rowIndex;
                _this.focusIndex = index;
                var item = _this.itemProvider.value[index];
                _this.dataTransfer = {
                    data: item,
                    dropEffect: _Utilities_DragDrop__WEBPACK_IMPORTED_MODULE_5__[/* DragDropEffect */ "a"].none,
                    secondaryData: { index: index, sourceId: _this.options.id },
                    setDragImage: _Util__WEBPACK_IMPORTED_MODULE_4__["noop"],
                    type: _this.options.type
                };
                // Give the consumer a chance to cancel the drag/drop operation
                Object(_Utilities_DragDrop__WEBPACK_IMPORTED_MODULE_5__[/* dispatchCustomDragEvent */ "d"])("dragstart", event.target, event.nativeEvent, _this.dataTransfer);
                if (_this.dataTransfer.effectAllowed !== _Utilities_DragDrop__WEBPACK_IMPORTED_MODULE_5__[/* DragDropEffect */ "a"].none) {
                    // As long as the operation was not cancelled, save off the
                    // row element that is being dragged and add a keydown listener.
                    // This listener will get called before the event dispatch for the list
                    // itself and allows us to have a way to no change focus as the user
                    // arrows up and down.
                    _this.dragItemRowElement = event.target;
                    _this.dragItemRowElement.addEventListener("keydown", _this.onDragRowKeyDown);
                }
            }
        };
        this.options = options;
        this.dragBehavior = new _ListDragSourceBehavior__WEBPACK_IMPORTED_MODULE_7__[/* ListDragSourceBehavior */ "a"](options);
        this.dropBehavior = new _ListDropTargetBehavior__WEBPACK_IMPORTED_MODULE_8__[/* ListDropTargetBehavior */ "a"](options);
    }
    ListDragDropBehavior.prototype.componentDidUpdate = function (props) {
        this.itemProvider = props.itemProvider;
        this.dragBehavior.componentDidUpdate(props);
        this.dropBehavior.componentDidUpdate(props);
    };
    ListDragDropBehavior.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.eventDispatch) === null || _a === void 0 ? void 0 : _a.removeEventListener("keydown", this.onKeyDown);
        if (this.dragItemRowElement) {
            this.dragItemRowElement.removeEventListener("keydown", this.onDragRowKeyDown);
        }
        this.dragBehavior.componentWillUnmount();
        this.dropBehavior.componentWillUnmount();
    };
    ListDragDropBehavior.prototype.dispatchEventAtIndex = function (eventType, target, event, index) {
        // To maintain consistency with mouse-based drag and drop, we want a way to have the row itself fire
        // the drag events. Since the row element isn't actually associated with the keyboard event that we get,
        // because the drag row itself is still the source of all of these events, we need a way to find that
        // row. We do this by first finding the list of our drag row, and then finding the row with the correct
        // index within that list.
        var listElement = target;
        while (listElement) {
            // We have hit the root of the list, dont look above this.
            if (listElement.classList.contains("bolt-list")) {
                break;
            }
            listElement = listElement.parentElement;
        }
        if (listElement) {
            var rowTarget = listElement.querySelector("[data-row-index='" + index + "']");
            if (rowTarget) {
                Object(_Utilities_DragDrop__WEBPACK_IMPORTED_MODULE_5__[/* dispatchCustomDragEvent */ "d"])(eventType, rowTarget, event, this.dataTransfer);
            }
        }
    };
    ListDragDropBehavior.prototype.endDrag = function (event, drop) {
        if (drop === void 0) { drop = false; }
        Object(_Utilities_DragDrop__WEBPACK_IMPORTED_MODULE_5__[/* dispatchCustomDragEvent */ "d"])("dragend", event.target, event, this.dataTransfer);
        if (drop) {
            this.dispatchEventAtIndex("drop", event.target, event, this.focusIndex);
        }
        else {
            this.dispatchEventAtIndex("dragexit", event.target, event, this.focusIndex);
        }
        if (this.dragItemRowElement) {
            this.dragItemRowElement.removeEventListener("keydown", this.onDragRowKeyDown);
            this.dragItemRowElement = undefined;
        }
    };
    ListDragDropBehavior.prototype.fireRowDragEvents = function (event) {
        this.dispatchEventAtIndex("dragenter", event.target, event, this.focusIndex);
        this.dispatchEventAtIndex("dragover", event.target, event, this.focusIndex);
    };
    return ListDragDropBehavior;
}());



/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListDragImage; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _List_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44);
/* harmony import */ var _List_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_List_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45);
/* harmony import */ var _ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ListDropIndicator_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1);








var ListDragImage = function (props) {
    return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](react__WEBPACK_IMPORTED_MODULE_5__["Fragment"], null,
        props.iconProps && react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Icon__WEBPACK_IMPORTED_MODULE_6__["Icon"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, props.iconProps, { className: Object(_Util__WEBPACK_IMPORTED_MODULE_7__["css"])(props.iconProps.className, "flex-noshrink icon-margin") })),
        react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("span", { className: "text-ellipsis" }, props.text)));
};


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ListSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilteredListSelection; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _Utilities_Selection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64);


var ListSelection = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(ListSelection, _super);
    function ListSelection(options) {
        var _this = _super.call(this, typeof options === "boolean" || options === undefined
            ? options
            : {
                alwaysMerge: options.alwaysMerge,
                multiSelect: options.multiSelect,
                unselectableRanges: options.unselectableRanges,
                selectedRanges: options.selectedRanges
            }) || this;
        _this.selectOnFocus = true;
        if (typeof options !== "boolean" && options !== undefined) {
            _this.selectOnFocus = options.selectOnFocus === undefined ? true : options.selectOnFocus;
        }
        return _this;
    }
    return ListSelection;
}(_Utilities_Selection__WEBPACK_IMPORTED_MODULE_1__[/* Selection */ "a"]));

var FilteredListSelection = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(FilteredListSelection, _super);
    function FilteredListSelection(selection) {
        var _this = _super.call(this, {
            alwaysMerge: selection.alwaysMerge,
            multiSelect: selection.multiSelect,
            unselectableRanges: selection.unselectableRanges,
            selectedRanges: selection.value,
            selectOnFocus: selection.selectOnFocus
        }) || this;
        _this.filteredIndexMap = [];
        _this.updateFilteredSelection = function (filteredIndexMap, multiSelect) {
            if (multiSelect === void 0) { multiSelect = _this.selection.multiSelect; }
            if (filteredIndexMap.length === 0) {
                _this.value = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])(_this.selection.value);
                _this.unselectableRanges = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])(_this.selection.unselectableRanges);
            }
            else {
                var newSelection_1 = new _Utilities_Selection__WEBPACK_IMPORTED_MODULE_1__[/* Selection */ "a"](multiSelect);
                filteredIndexMap.map(function (mappedIndex, index) {
                    if (_this.selection.selected(mappedIndex)) {
                        newSelection_1.select(index, 1, true, multiSelect);
                    }
                    if (!_this.selection.selectable(mappedIndex)) {
                        newSelection_1.addUnselectable(index);
                    }
                });
                _this.value = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])(newSelection_1.value);
                _this.unselectableRanges = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])(newSelection_1.unselectableRanges);
            }
            _this.filteredIndexMap = filteredIndexMap;
        };
        _this.selectionChanged = function (value, action) {
            switch (action) {
                case "addUnselectable":
                    for (var rangeIndex = 0; rangeIndex < value.length; rangeIndex++) {
                        for (var unselectableIndex = value[rangeIndex].beginIndex; unselectableIndex <= value[rangeIndex].endIndex; unselectableIndex++) {
                            var index = _this.filteredIndexMap.length > 0 ? _this.filteredIndexMap.indexOf(unselectableIndex) : unselectableIndex;
                            if (_this.selectable(index)) {
                                _this.addUnselectable(index, 1);
                            }
                        }
                    }
                    break;
                case "removeUnselectable":
                    for (var rangeIndex = 0; rangeIndex < value.length; rangeIndex++) {
                        for (var unselectableIndex = value[rangeIndex].beginIndex; unselectableIndex <= value[rangeIndex].endIndex; unselectableIndex++) {
                            var index = _this.filteredIndexMap.length > 0 ? _this.filteredIndexMap.indexOf(unselectableIndex) : unselectableIndex;
                            if (!_this.selectable(index)) {
                                _this.removeUnselectable(index, 1);
                            }
                        }
                    }
                    break;
                case "setUnselectable":
                case "set":
                    _this.updateFilteredSelection(_this.filteredIndexMap);
                    break;
                case "select":
                    for (var rangeIndex = 0; rangeIndex < value.length; rangeIndex++) {
                        for (var selectionIndex = value[rangeIndex].beginIndex; selectionIndex <= value[rangeIndex].endIndex; selectionIndex++) {
                            var index = _this.filteredIndexMap.length > 0 ? _this.filteredIndexMap.indexOf(selectionIndex) : selectionIndex;
                            if (index > -1 && !_this.selected(index)) {
                                _this.select(index, 1, true);
                            }
                        }
                    }
                    break;
                case "unselect":
                    for (var rangeIndex = 0; rangeIndex < value.length; rangeIndex++) {
                        for (var selectionIndex = value[rangeIndex].beginIndex; selectionIndex <= value[rangeIndex].endIndex; selectionIndex++) {
                            var index = _this.filteredIndexMap.length > 0 ? _this.filteredIndexMap.indexOf(selectionIndex) : selectionIndex;
                            if (_this.selected(index)) {
                                _this.unselect(index, 1);
                            }
                        }
                    }
                    break;
            }
        };
        _this.selection = selection;
        return _this;
    }
    FilteredListSelection.prototype.select = function (index, count, merge, multiSelect) {
        _super.prototype.select.call(this, index, count, merge, multiSelect);
        if (this.filteredIndexMap.length > 0) {
            if (!merge) {
                this.clear();
            }
            count = count || 1;
            for (var i = 0; i < count; i++) {
                this.selection.select(this.filteredIndexMap[index + i], 1, true, multiSelect);
            }
        }
        else {
            this.selection.select(index, count, merge, multiSelect);
        }
    };
    FilteredListSelection.prototype.unselect = function (index, count) {
        _super.prototype.unselect.call(this, index, count);
        if (this.filteredIndexMap.length > 0) {
            count = count || 1;
            for (var i = 0; i < count; i++) {
                this.selection.unselect(this.filteredIndexMap[index + i], 1);
            }
        }
        else {
            this.selection.unselect(index, count);
        }
    };
    FilteredListSelection.prototype.clear = function () {
        _super.prototype.clear.call(this);
        if (this.filteredIndexMap.length > 0) {
            for (var i = 0; i < this.filteredIndexMap.length; i++) {
                this.selection.unselect(this.filteredIndexMap[i]);
            }
        }
        else {
            this.selection.clear();
        }
    };
    return FilteredListSelection;
}(ListSelection));



/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ColumnMoreWidths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColumnMore; });
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Table_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58);
/* harmony import */ var _Table_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Table_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14);
/* harmony import */ var _Menu__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56);
/* harmony import */ var _Resources_Widgets__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1);
/* harmony import */ var _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12);
/* harmony import */ var _Table_Props__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13);











/**
 * Standard widths for the more column
 */
var ColumnMoreWidths;
(function (ColumnMoreWidths) {
    ColumnMoreWidths[ColumnMoreWidths["compact"] = 2] = "compact";
    ColumnMoreWidths[ColumnMoreWidths["default"] = 2.625] = "default";
})(ColumnMoreWidths || (ColumnMoreWidths = {}));
/**
 * The ColumnMore class is used as a custom column within a Table.
 *
 * It renders a fixed width column with a button that is visible on focus and
 * hover that will show a contextual menu for the given item. The caller
 * should create a new instance of this for each table. The header for this
 * column is empty.
 *
 * When creating the column you must supply delegate that is used to get the
 * menuProps when the menu is opened.
 */
var ColumnMore = /** @class */ (function () {
    /**
     * Creates an instance of ColumnMore with the appropriate delegates.
     *
     * @param menuProvider Method that returns the menu props. This is called
     *  with the item from the row the menu was activated on.
     * @param menuAvailable Optional method that is called when the row
     *  is rendered. The MoreButton will be shown if no method is supplied
     *  or if the method is supplied and it returns true.
     */
    function ColumnMore(menuProvider, menuAvailable, onActivate, width, refs) {
        var _this = this;
        if (width === void 0) { width = ColumnMoreWidths.default; }
        this.ariaLabel = _Resources_Widgets__WEBPACK_IMPORTED_MODULE_7__[/* MoreActions */ "h"];
        this.columnLayout = _Table_Props__WEBPACK_IMPORTED_MODULE_10__[/* TableColumnLayout */ "d"].none;
        this.id = "_more";
        this.widthStyle = _Table_Props__WEBPACK_IMPORTED_MODULE_10__[/* IMeasurementStyle */ "b"].REM;
        this.renderCell = function (rowIndex, columnIndex, tableColumn, listItem) {
            var _a;
            var buttonRef = react__WEBPACK_IMPORTED_MODULE_3__["createRef"]();
            if (_this.refs && !_this.refs.value[rowIndex]) {
                _this.refs.value[rowIndex] = buttonRef;
            }
            return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("td", { "aria-colindex": columnIndex + 1, className: Object(_Util__WEBPACK_IMPORTED_MODULE_8__["css"])("bolt-table-cell-side-action bolt-table-cell bolt-list-cell", "col-" + columnIndex), "data-column-index": columnIndex, key: "col-more", onClick: _this.onClick, onDoubleClick: _Util__WEBPACK_IMPORTED_MODULE_8__["preventDefault"], onKeyDown: _this.onKeyDown, onMouseDown: _Util__WEBPACK_IMPORTED_MODULE_8__["preventDefault"] }, !_this.menuAvailable || _this.menuAvailable(listItem) ? (react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { className: "bolt-table-cell-content-reveal flex-row justify-center" },
                react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Button__WEBPACK_IMPORTED_MODULE_5__["ExpandableButton"], { ariaLabel: _Resources_Widgets__WEBPACK_IMPORTED_MODULE_7__[/* MoreTooltip */ "i"], className: "bolt-table-button-more", excludeTabStop: true, hideDropdownIcon: true, iconProps: { className: "small", iconName: "MoreVertical" }, onClick: function (e) {
                        if (_this.onActivate) {
                            _this.onActivate(rowIndex, columnIndex, e);
                        }
                    }, ref: (_a = _this.refs) === null || _a === void 0 ? void 0 : _a.value[rowIndex], renderCallout: function (dropdown, dropdownId, anchorElement) {
                        return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Menu__WEBPACK_IMPORTED_MODULE_6__["ContextualMenu"], { anchorElement: anchorElement, anchorOrigin: { horizontal: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].end, vertical: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].end }, menuProps: _this.menuProvider(listItem, rowIndex, buttonRef), menuOrigin: { horizontal: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].end, vertical: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].start }, onDismiss: dropdown.collapse }));
                    }, subtle: true, tooltipProps: { text: _Resources_Widgets__WEBPACK_IMPORTED_MODULE_7__[/* MoreTooltip */ "i"] } }))) : (react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { "aria-label": _Resources_Widgets__WEBPACK_IMPORTED_MODULE_7__[/* NoMoreActions */ "j"], className: "bolt-table-cell-content" }))));
        };
        this.renderHeaderCell = function (columnIndex, tableColumn) {
            return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("th", { "aria-colindex": columnIndex + 1, "aria-label": tableColumn.ariaLabel, className: Object(_Util__WEBPACK_IMPORTED_MODULE_8__["css"])(tableColumn.headerClassName, "bolt-table-header-cell bolt-table-header-cell-empty", "col-header-" + columnIndex), "data-column-index": columnIndex, key: "col-more" }));
        };
        this.onClick = function (event) {
            if (!event.defaultPrevented) {
                if (!Object(_Util__WEBPACK_IMPORTED_MODULE_8__["eventTargetContainsNode"])(event, ["A"], document.body)) {
                    event.preventDefault();
                }
            }
        };
        this.onKeyDown = function (event) {
            if (!event.defaultPrevented) {
                if (event.which === _Util__WEBPACK_IMPORTED_MODULE_8__["KeyCode"].enter || event.which === _Util__WEBPACK_IMPORTED_MODULE_8__["KeyCode"].space) {
                    if (!Object(_Util__WEBPACK_IMPORTED_MODULE_8__["eventTargetContainsNode"])(event, ["A"])) {
                        event.preventDefault();
                    }
                }
            }
        };
        this.menuAvailable = menuAvailable;
        this.menuProvider = menuProvider;
        this.onActivate = onActivate;
        this.width = new _Core_Observable__WEBPACK_IMPORTED_MODULE_4__["ObservableValue"](width);
        this.refs = refs;
    }
    return ColumnMore;
}());



/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(241);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(242);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 140 */
/***/ (function(module, exports) {



/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpandableButton; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(138);
/* harmony import */ var _Button_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Button_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ExpandableButton_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(139);
/* harmony import */ var _ExpandableButton_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ExpandableButton_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Expandable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1);
/* harmony import */ var _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76);











var buttonId = 1;
var ExpandableButton = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(ExpandableButton, _super);
    function ExpandableButton(props) {
        var _this = _super.call(this, props) || this;
        _this.buttonElement = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.expandable = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.collapse = function () {
            if (_this.expandable.current) {
                _this.expandable.current.collapse();
            }
        };
        _this.expand = function () {
            if (_this.expandable.current) {
                _this.expandable.current.expand();
            }
        };
        _this.renderCallout = function () {
            return _this.props.renderCallout(_this, _this.dropdownId, _this.props.anchorElement
                ? _this.props.anchorElement
                : !_this.props.anchorPoint
                    ? _this.containerElement.current
                        ? _this.containerElement.current
                        : undefined
                    : undefined, _this.props.anchorOffset || { horizontal: 0, vertical: 0 }, _this.props.anchorOrigin || { horizontal: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].end, vertical: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].end }, _this.props.anchorPoint, _this.props.dropdownOrigin || { horizontal: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].end, vertical: _Utilities_Position__WEBPACK_IMPORTED_MODULE_9__[/* Location */ "a"].start });
        };
        _this.dropdownId = props.dropdownId || "dropdown-" + buttonId++;
        _this.containerElement = props.containerRef || react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        return _this;
    }
    ExpandableButton.prototype.render = function () {
        var _this = this;
        // We disable the tooltip when we are expanded. Make sure we dont remove it
        // from the component tree, this causes the button element to get regenerated
        // and focus wont return.
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Expandable__WEBPACK_IMPORTED_MODULE_6__["Expandable"], { disabled: this.props.disabled, expandKey: this.props.expandKey, onCollapse: this.props.onCollapse, onExpand: this.props.onExpand, renderCallout: this.renderCallout, ref: this.expandable }, function (expandableProps) {
            var _a, _b;
            return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: Object(_Util__WEBPACK_IMPORTED_MODULE_8__["css"])(_this.props.className, "bolt-expandable-button inline-flex-row"), onMouseDown: expandableProps.onMouseDown, onKeyDown: expandableProps.onKeyDown, ref: _this.containerElement },
                react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Button__WEBPACK_IMPORTED_MODULE_10__[/* Button */ "a"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, _this.props, { ariaControls: expandableProps.expanded ? _this.dropdownId : undefined, ariaExpanded: expandableProps.expanded, ariaHasPopup: true, ariaLabel: (_a = _this.props.ariaLabel) !== null && _a !== void 0 ? _a : (_this.props.tooltipProps && _this.props.tooltipProps.text ? (_b = _this.props.tooltipProps) === null || _b === void 0 ? void 0 : _b.text : ""), className: Object(_Util__WEBPACK_IMPORTED_MODULE_8__["css"])(!_this.props.text && !_this.props.children && _this.props.iconProps && "icon-only", expandableProps.expanded && "active", _this.props.buttonClassName), onClick: function (e) {
                        expandableProps.onClick(e);
                        if (_this.props.onClick) {
                            _this.props.onClick(e);
                        }
                        e.preventDefault();
                    }, ref: _this.buttonElement, tooltipProps: _this.props.tooltipProps ? Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, _this.props.tooltipProps), { disabled: expandableProps.expanded }) : undefined }),
                    _this.props.children,
                    !_this.props.hideDropdownIcon
                        ? Object(_Icon__WEBPACK_IMPORTED_MODULE_7__["Icon"])({
                            key: "dropdown-icon",
                            className: "icon-right font-weight-normal",
                            iconName: "ChevronDownMed",
                            size: _Icon__WEBPACK_IMPORTED_MODULE_7__["IconSize"].small
                        })
                        : undefined)));
        }));
    };
    ExpandableButton.prototype.focus = function () {
        if (this.buttonElement.current) {
            this.buttonElement.current.focus();
        }
    };
    ExpandableButton.defaultProps = {
        expandKey: [_Util__WEBPACK_IMPORTED_MODULE_8__["KeyCode"].downArrow, _Util__WEBPACK_IMPORTED_MODULE_8__["KeyCode"].enter]
    };
    return ExpandableButton;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));



/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Expandable; });
/* unused harmony export ExpandableContainer */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Core_Util_Accessibility__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15);
/* harmony import */ var _FocusGroup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31);
/* harmony import */ var _FocusZone__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
/* harmony import */ var _MouseWithin__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42);
/* harmony import */ var _Resources_Core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1);
/* harmony import */ var _Utilities_Focus__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26);











var Expandable = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(Expandable, _super);
    function Expandable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { expanded: false };
        _this.collapse = function () {
            if (_this.state.expanded) {
                _this.setState({ expanded: false });
                _Core_Util_Accessibility__WEBPACK_IMPORTED_MODULE_4__[/* announce */ "a"](_Resources_Core__WEBPACK_IMPORTED_MODULE_8__[/* Collapsed */ "a"], true);
                if (_this.props.onCollapse) {
                    _this.props.onCollapse();
                }
            }
        };
        _this.expand = function () {
            if (!_this.state.expanded) {
                _this.setState({ expanded: !_this.state.expanded });
                _Core_Util_Accessibility__WEBPACK_IMPORTED_MODULE_4__[/* announce */ "a"](_Resources_Core__WEBPACK_IMPORTED_MODULE_8__[/* Expanded */ "b"], true);
                if (_this.props.onExpand) {
                    _this.props.onExpand();
                }
            }
        };
        _this.onClick = function (event) {
            if (!_this.props.disabled) {
                if (!event.defaultPrevented) {
                    if (!_this.state.expanded && !_this.ignoreClick) {
                        _this.expand();
                        event.preventDefault();
                    }
                }
            }
            else {
                event.preventDefault();
            }
        };
        _this.onKeyDown = function (event) {
            if (!event.defaultPrevented) {
                // If the control key is pressed we want to navigate in a focus zone and not open the menu
                if (event.ctrlKey) {
                    return;
                }
                if (!_this.state.expanded && _this.isExpandKey(event)) {
                    _this.ignoreClick = false;
                    _this.expand();
                    event.preventDefault();
                }
            }
        };
        _this.onMouseDown = function () {
            // If the callout is expanded when we click on it, we want to ignore the click
            // and let the blur occur and close the callout.
            _this.ignoreClick = _this.state.expanded;
        };
        return _this;
    }
    Expandable.prototype.render = function () {
        var expanded = this.state.expanded;
        var child = this.props.children;
        return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](react__WEBPACK_IMPORTED_MODULE_3__["Fragment"], null,
            child({ expanded: expanded, onClick: this.onClick, onKeyDown: this.onKeyDown, onMouseDown: this.onMouseDown }),
            expanded && this.props.renderCallout && this.props.renderCallout()));
    };
    Expandable.prototype.isExpandKey = function (event) {
        return (Array.isArray(this.props.expandKey) && this.props.expandKey.indexOf(event.which) !== -1) || event.which === this.props.expandKey;
    };
    Expandable.defaultProps = {
        expandKey: _Util__WEBPACK_IMPORTED_MODULE_9__["KeyCode"].downArrow
    };
    return Expandable;
}(react__WEBPACK_IMPORTED_MODULE_3__["Component"]));

var expandableContainerId = 1;
/**
 * ExpandableContainer is a specialized form of Expandable and generally shouldn't be used.
 * It's main goal is to provider mouse enter/leave behavior for collapsing.
 *
 * @NOTE: This component MAY be deprecated in the future, use <Expandable /> instead.
 */
var ExpandableContainer = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(ExpandableContainer, _super);
    function ExpandableContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = react__WEBPACK_IMPORTED_MODULE_3__["createRef"]();
        _this.expandedOnHover = false;
        _this.expandable = react__WEBPACK_IMPORTED_MODULE_3__["createRef"]();
        _this.expandableId = "expandableContainer-" + expandableContainerId++;
        _this.collapse = function () {
            if (_this.expandable.current) {
                _this.expandable.current.collapse();
            }
        };
        _this.expand = function () {
            if (_this.expandable.current) {
                _this.expandable.current.expand();
            }
        };
        _this.onFocus = function (event) {
            // Only call onFocus for the FocusGroup is the expandable itself is getting focus.
            // Otherwise it is going to a child element and it should manage focus appropriately.
            if (_this.props.id && (!_this.element.current || _this.element.current === event.target)) {
                _this.context.onFocus(_this.props.id);
            }
        };
        _this.onMouseEnter = function () {
            if (_this.props.expandOnHover) {
                _this.expandedOnHover = true;
                Object(_Util__WEBPACK_IMPORTED_MODULE_9__["setFocusVisible"])(false);
                _this.expand();
            }
        };
        _this.onMouseLeave = function () {
            if (_this.expandedOnHover) {
                _this.collapse();
            }
        };
        _this.renderCallout = function () {
            return _this.props.renderCallout(_this.expandable.current, _this.expandableId, _this.element.current);
        };
        return _this;
    }
    ExpandableContainer.prototype.render = function () {
        var _this = this;
        return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_6__[/* FocusZoneContext */ "b"].Consumer, null, function (zoneContext) { return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_MouseWithin__WEBPACK_IMPORTED_MODULE_7__["MouseWithin"], { enterDelay: _this.props.expandDelay, leaveDelay: _this.props.collapseDelay, onMouseEnter: _this.onMouseEnter, onMouseLeave: _this.onMouseLeave, updateStateOnMouseChange: false }, function (mouseContext) { return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](Expandable, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, _this.props, { renderCallout: undefined, ref: _this.expandable }), function (expandableProps) { return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { "aria-controls": expandableProps.expanded ? Object(_Util__WEBPACK_IMPORTED_MODULE_9__["getSafeId"])(_this.props.expandableId) : undefined, "aria-expanded": expandableProps.expanded, "aria-haspopup": true, "aria-label": _this.props.ariaLabel, className: Object(_Util__WEBPACK_IMPORTED_MODULE_9__["css"])(_this.props.className, "bolt-expandable-container flex-row flex-center", expandableProps.expanded && "expanded"), "data-focuszone": !_this.props.disabled && !_this.props.excludeFocusZone ? zoneContext.focuszoneId : undefined, id: Object(_Util__WEBPACK_IMPORTED_MODULE_9__["getSafeId"])(_this.props.id), onClick: expandableProps.onClick, onFocus: _this.onFocus, onKeyDown: expandableProps.onKeyDown, onMouseDown: expandableProps.onMouseDown, onMouseEnter: mouseContext.onMouseEnter, onMouseLeave: mouseContext.onMouseLeave, role: _this.props.role || "button", tabIndex: Object(_Utilities_Focus__WEBPACK_IMPORTED_MODULE_10__[/* getTabIndex */ "a"])(_this.props, _this.context), ref: _this.element },
            _this.props.children,
            expandableProps.expanded && _this.renderCallout())); })); })); }));
    };
    ExpandableContainer.contextType = _FocusGroup__WEBPACK_IMPORTED_MODULE_5__["FocusGroupContext"];
    ExpandableContainer.defaultProps = {
        collapseDelay: 250,
        expandDelay: 250,
        expandKey: [_Util__WEBPACK_IMPORTED_MODULE_9__["KeyCode"].downArrow, _Util__WEBPACK_IMPORTED_MODULE_9__["KeyCode"].enter]
    };
    return ExpandableContainer;
}(react__WEBPACK_IMPORTED_MODULE_3__["Component"]));



/***/ }),
/* 143 */
/***/ (function(module, exports) {



/***/ }),
/* 144 */
/***/ (function(module, exports) {



/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextMenuBehavior; });
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Menu_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68);
/* harmony import */ var _Menu_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Menu_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _MenuButton_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69);
/* harmony import */ var _MenuButton_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_MenuButton_css__WEBPACK_IMPORTED_MODULE_3__);




var ContextMenuBehavior = /** @class */ (function () {
    function ContextMenuBehavior(contextMenuHandler) {
        var _this = this;
        this.initialize = function (props, component, eventDispatch) {
            _this.eventDispatch = eventDispatch;
            _this.eventDispatch.addEventListener("contextmenu", _this.onContextMenu);
        };
        this.onContextMenu = function (event) {
            _this.contextMenuHandler(event);
        };
        this.contextMenuHandler = contextMenuHandler;
    }
    ContextMenuBehavior.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.eventDispatch) === null || _a === void 0 ? void 0 : _a.removeEventListener("contextmenu", this.onContextMenu);
    };
    return ContextMenuBehavior;
}());



/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TriStateCheckbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Checkbox_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(245);
/* harmony import */ var _Checkbox_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Checkbox_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var _FocusGroup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31);
/* harmony import */ var _FocusZone__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8);
/* harmony import */ var _TooltipEx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1);
/* harmony import */ var _Utilities_Focus__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26);













var checkboxId = 1;
var TriStateCheckbox = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(TriStateCheckbox, _super);
    function TriStateCheckbox(props) {
        var _this = _super.call(this, props) || this;
        _this.checkboxElement = react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
        _this.animationClassName = "";
        _this.onClick = function (event) {
            _this.focus();
            _this.onChange(event);
        };
        _this.onFocus = function () {
            var id = _this.props.id;
            if (id) {
                _this.context.onFocus(id);
            }
        };
        _this.onKeyDown = function (event) {
            if (!event.defaultPrevented && !_this.props.disabled) {
                if (event.which === _Util__WEBPACK_IMPORTED_MODULE_11__["KeyCode"].space) {
                    _this.onChange(event);
                    event.preventDefault();
                }
            }
        };
        _this.onChange = function (event) {
            if (_this.props.onChange) {
                var checked = _Core_Observable__WEBPACK_IMPORTED_MODULE_5__["ObservableLike"].getValue(_this.props.checked);
                // Unchecked transitions to Checked.
                // Checked transitions to TriState or Unchecked.
                // Indeterminate transitions to Unchecked.
                if (checked === false) {
                    checked = true;
                }
                else if (checked === true) {
                    if (_this.props.triState) {
                        checked = undefined;
                    }
                    else {
                        checked = false;
                    }
                }
                else {
                    checked = false;
                }
                _this.props.onChange(event, checked);
            }
        };
        _this.labelId = "checkbox-" + checkboxId++ + "-label";
        return _this;
    }
    TriStateCheckbox.prototype.render = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, label = _a.label, labelId = _a.labelId, tooltipProps = _a.tooltipProps;
        return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_7__[/* FocusZoneContext */ "b"].Consumer, null, function (zoneContext) { return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_9__["Observer"], { checked: _this.props.checked }, function (props) {
            var checkbox = (react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { "aria-checked": props.checked === undefined ? "mixed" : props.checked === true ? "true" : "false", "aria-describedby": Object(_Util__WEBPACK_IMPORTED_MODULE_11__["getSafeId"])(_this.props.ariaDescribedBy), "aria-disabled": _this.props.disabled, "aria-label": _this.props.ariaLabel, "aria-labelledby": !_this.props.ariaLabel ? Object(_Util__WEBPACK_IMPORTED_MODULE_11__["getSafeId"])(_this.props.ariaLabelledBy) : undefined, className: Object(_Util__WEBPACK_IMPORTED_MODULE_11__["css"])(_this.props.className, "bolt-checkbox cursor-pointer", props.checked !== false && "checked", disabled ? "disabled" : "enabled", "bolt-focus-treatment", label && "labelled"), "data-focuszone": !disabled && Object(_Util__WEBPACK_IMPORTED_MODULE_11__["css"])(_this.props.focuszoneId, !_this.props.excludeFocusZone ? zoneContext.focuszoneId : undefined), id: Object(_Util__WEBPACK_IMPORTED_MODULE_11__["getSafeId"])(_this.props.id), onClick: !disabled ? _this.onClick : undefined, onFocus: _this.onFocus, onKeyDown: _this.onKeyDown, ref: _this.checkboxElement, role: _this.props.role || "checkbox", tabIndex: Object(_Utilities_Focus__WEBPACK_IMPORTED_MODULE_12__[/* getTabIndex */ "a"])(_this.props, _this.context) },
                react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: "bolt-checkmark justify-center flex-row flex-noshrink scroll-hidden" }, Object(_Icon__WEBPACK_IMPORTED_MODULE_8__["Icon"])({
                    className: _this.animationClassName,
                    iconName: props.checked === undefined ? "SkypeMinus" : "CheckMark",
                    size: _Icon__WEBPACK_IMPORTED_MODULE_8__["IconSize"].small
                })),
                label && (react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: "bolt-checkbox-label", id: Object(_Util__WEBPACK_IMPORTED_MODULE_11__["getSafeId"])(labelId || _this.labelId) }, label)),
                _this.props.children));
            if (tooltipProps) {
                checkbox = (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_TooltipEx__WEBPACK_IMPORTED_MODULE_10__["Tooltip"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({ addAriaDescribedBy: true }, tooltipProps), checkbox));
            }
            return checkbox;
        })); }));
    };
    TriStateCheckbox.prototype.componentDidMount = function () {
        this.animationClassName = "animation-ready";
    };
    TriStateCheckbox.prototype.focus = function () {
        if (this.checkboxElement.current) {
            this.checkboxElement.current.focus();
        }
    };
    TriStateCheckbox.contextType = _FocusGroup__WEBPACK_IMPORTED_MODULE_6__["FocusGroupContext"];
    return TriStateCheckbox;
}(react__WEBPACK_IMPORTED_MODULE_4__["Component"]));

var Checkbox = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(Checkbox, _super);
    function Checkbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Checkbox.defaultProps = {
        checked: false
    };
    return Checkbox;
}(TriStateCheckbox));



/***/ }),
/* 147 */
/***/ (function(module, exports) {



/***/ }),
/* 148 */
/***/ (function(module, exports) {



/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColumnSelect; });
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Table_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58);
/* harmony import */ var _Table_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Table_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4);
/* harmony import */ var _Core_Util_Accessibility__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15);
/* harmony import */ var _Checkbox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8);
/* harmony import */ var _Resources_Widgets__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1);
/* harmony import */ var _Table_Props__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13);











/**
 * ColumnSelect is used to render additional selection ui for a given row.
 *
 * This renders a fixed width column that contains a checkbox in the header
 * as well as each row that represents the selection state of the row. It
 * also allows the user to change the selection state. The header checkbox
 * is used to set the state of all rows in the table to the same state.
 *
 */
var ColumnSelect = /** @class */ (function () {
    function ColumnSelect() {
        var _this = this;
        this.columnSelectBehavior = {
            initialize: function (props) {
                _this.ariaHidden = props.tableProps.role === "menu";
                _this.itemProvider = props.tableProps.itemProvider;
                _this.selection = props.tableProps.selection;
                _this.onSelect = props.tableProps.onSelect;
            },
            componentDidMount: function (props) {
                _this.componentDidMount(props);
            },
            componentDidUpdate: function (props) {
                _this.componentDidUpdate(props);
            },
            componentWillUnmount: function () {
                _this.componentWillUnmount();
            }
        };
        this.allSelected = new _Core_Observable__WEBPACK_IMPORTED_MODULE_4__["ObservableValue"](false);
        this.columnLayout = _Table_Props__WEBPACK_IMPORTED_MODULE_10__[/* TableColumnLayout */ "d"].none;
        this.id = "_select";
        this.width = 2.5;
        this.widthStyle = _Table_Props__WEBPACK_IMPORTED_MODULE_10__[/* IMeasurementStyle */ "b"].REM;
        this.behaviors = [this.columnSelectBehavior];
        this.renderCell = function (rowIndex, columnIndex, listColumn) {
            var selection = _this.selection;
            var selected = selection && selection.selected(rowIndex);
            var selectable = selection && selection.selectable(rowIndex);
            return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("td", { "aria-colindex": columnIndex + 1, "aria-hidden": _this.ariaHidden, className: Object(_Util__WEBPACK_IMPORTED_MODULE_9__["css"])("bolt-table-cell-select bolt-table-cell bolt-list-cell", "col-" + columnIndex), "data-column-index": columnIndex, key: "col-select", onClick: _Util__WEBPACK_IMPORTED_MODULE_9__["preventDefault"], onDoubleClick: _Util__WEBPACK_IMPORTED_MODULE_9__["preventDefault"], onMouseDown: function (event) {
                    _this.updateSelection(event, rowIndex);
                    event.preventDefault();
                }, onKeyDown: function (event) {
                    if (event.which === _Util__WEBPACK_IMPORTED_MODULE_9__["KeyCode"].space) {
                        _this.updateSelection(event, rowIndex);
                        event.preventDefault();
                    }
                } },
                react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { className: "flex-row justify-center" },
                    react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("span", { className: "flex-row-inline" },
                        react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Checkbox__WEBPACK_IMPORTED_MODULE_6__["Checkbox"], { ariaLabel: _Resources_Widgets__WEBPACK_IMPORTED_MODULE_8__[/* SelectRowLabel */ "o"], checked: !!selected, excludeTabStop: true, disabled: !selectable })))));
        };
        this.renderHeaderCell = function (columnIndex, listColumn, focuszoneId) {
            return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("th", { "aria-colindex": columnIndex + 1, className: Object(_Util__WEBPACK_IMPORTED_MODULE_9__["css"])("bolt-table-cell-select bolt-table-header-cell", "col-header-" + columnIndex), "data-column-index": columnIndex, key: "col-select" },
                react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { className: "flex-row" },
                    react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_7__["Observer"], { allSelected: _this.allSelected }, function (props) {
                        var _a = _this, itemProvider = _a.itemProvider, selection = _a.selection;
                        // Get the total number of items within the list.
                        var itemCount = itemProvider && itemProvider.length;
                        return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { className: "flex-row flex-grow justify-center" }, selection && selection.multiSelect && itemCount !== -1 && (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Checkbox__WEBPACK_IMPORTED_MODULE_6__["TriStateCheckbox"], { ariaLabel: _Resources_Widgets__WEBPACK_IMPORTED_MODULE_8__[/* SelectAllRowsLabel */ "n"], checked: props.allSelected, focuszoneId: focuszoneId, onChange: _this.onChangeHeader }))));
                    }))));
        };
        this.onChangeHeader = function (event) {
            var _a = _this, itemProvider = _a.itemProvider, onSelect = _a.onSelect, selection = _a.selection;
            // toggle select all
            if (selection) {
                if (_this.allSelected.value !== false) {
                    selection.clear();
                    Object(_Core_Util_Accessibility__WEBPACK_IMPORTED_MODULE_5__[/* announce */ "a"])(_Resources_Widgets__WEBPACK_IMPORTED_MODULE_8__[/* AllRowsUnselectedMessage */ "b"], true);
                }
                else {
                    selection.select(0, itemProvider && itemProvider.length);
                    Object(_Core_Util_Accessibility__WEBPACK_IMPORTED_MODULE_5__[/* announce */ "a"])(_Resources_Widgets__WEBPACK_IMPORTED_MODULE_8__[/* AllRowsSelectedMessage */ "a"], true);
                }
            }
            if (onSelect && itemProvider) {
                for (var i = 0; i < itemProvider.length; i++) {
                    onSelect(event, _this.getListRow(i));
                }
            }
        };
        this.onSelectionChange = function () {
            var _a = _this, itemProvider = _a.itemProvider, selection = _a.selection;
            if (selection) {
                var selectedCount = selection.selectedCount;
                var itemCount = itemProvider && itemProvider.length - selection.unselectableCount;
                if (selectedCount > 0) {
                    if (selectedCount === itemCount) {
                        _this.allSelected.value = true;
                    }
                    else {
                        _this.allSelected.value = undefined;
                    }
                }
                else {
                    _this.allSelected.value = false;
                }
            }
        };
        this.updateSelection = function (event, rowIndex) {
            var _a = _this, onSelect = _a.onSelect, selection = _a.selection;
            if (selection) {
                if (selection.selected(rowIndex)) {
                    selection.unselect(rowIndex);
                }
                else {
                    selection.select(rowIndex, 1, true);
                }
            }
            if (onSelect) {
                var listRow = _this.getListRow(rowIndex);
                onSelect(event, listRow);
            }
        };
        this.getListRow = function (rowIndex) {
            return { data: _this.itemProvider ? _this.itemProvider.value[rowIndex] : {}, index: rowIndex };
        };
    }
    ColumnSelect.prototype.componentDidMount = function (props) {
        var _a = this, itemProvider = _a.itemProvider, selection = _a.selection;
        // We need to know about changes to the selection to manage the selectAll state.
        if (selection) {
            selection.subscribe(this.onSelectionChange);
            this.onSelectionChange();
        }
        if (itemProvider && itemProvider.subscribe) {
            itemProvider.subscribe(this.onSelectionChange);
        }
    };
    ColumnSelect.prototype.componentDidUpdate = function (props) {
        var selection = this.selection;
        if (selection !== props.tableProps.selection) {
            if (selection) {
                selection.unsubscribe(this.onSelectionChange);
            }
            selection = props.tableProps.selection;
            this.selection = selection;
            if (selection) {
                selection.subscribe(this.onSelectionChange);
            }
        }
        if (selection) {
            this.onSelectionChange();
        }
        if (this.itemProvider !== props.tableProps.itemProvider) {
            if (this.itemProvider && this.itemProvider.unsubscribe) {
                this.itemProvider.unsubscribe(this.onSelectionChange);
            }
            this.itemProvider = props.tableProps.itemProvider;
            if (this.itemProvider && this.itemProvider.subscribe) {
                this.itemProvider.subscribe(this.onSelectionChange);
            }
        }
    };
    ColumnSelect.prototype.componentWillUnmount = function () {
        var selection = this.selection;
        if (selection) {
            selection.unsubscribe(this.onSelectionChange);
        }
        if (this.itemProvider && this.itemProvider.unsubscribe) {
            this.itemProvider.unsubscribe(this.onSelectionChange);
        }
    };
    return ColumnSelect;
}());



/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColumnSorting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sortItems; });
/* harmony import */ var _List__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _Table_Props__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13);



/**
 * The ColumnSorting class is a behavior that can be used with the Table
 * component to provide column sorting. To use the ColumnSorting, create an
 * instance passing the sorting delegate to the constructor. Then supply
 * the created behavior to the table.
 */
var ColumnSorting = /** @class */ (function () {
    function ColumnSorting(onSort) {
        var _this = this;
        this.initialize = function (props, table, eventDispatch) {
            _this.props = props;
            _this.eventDispatch = eventDispatch;
            eventDispatch.addEventListener("click", _this.onClick);
            eventDispatch.addEventListener("keydown", _this.onKeyDown);
        };
        this.componentDidMount = function (props) {
            _this.props = props;
        };
        this.componentDidUpdate = function (props) {
            _this.props = props;
        };
        this.componentWillUnmount = function () {
            if (_this.eventDispatch) {
                _this.eventDispatch.removeEventListener("click", _this.onClick);
                _this.eventDispatch.removeEventListener("keydown", _this.onKeyDown);
            }
        };
        this.onClick = function (event) {
            if (!event.defaultPrevented) {
                _this.processSortEvent(event, true);
            }
        };
        this.onKeyDown = function (event) {
            if (!event.defaultPrevented) {
                if (event.which === _Util__WEBPACK_IMPORTED_MODULE_1__["KeyCode"].enter || event.which === _Util__WEBPACK_IMPORTED_MODULE_1__["KeyCode"].space) {
                    _this.processSortEvent(event);
                }
            }
        };
        this.onSort = onSort;
    }
    ColumnSorting.prototype.processSortEvent = function (event, click) {
        var clickedCell = Object(_List__WEBPACK_IMPORTED_MODULE_0__["cellFromEvent"])(event);
        // Check if we clicked on an actionable area; walk up to see if we clicked within one
        var testHtmlElement = event.target;
        var actionableClick = click ? false : testHtmlElement.classList.contains("bolt-table-header-cell-actionable");
        if (testHtmlElement.classList.contains("bolt-table-header-sizer")) {
            var headerElement = testHtmlElement.closest(".bolt-table-header-cell-actionable");
            if (headerElement) {
                headerElement.focus();
                Object(_Util__WEBPACK_IMPORTED_MODULE_1__["setFocusVisible"])(true);
            }
        }
        while (!actionableClick && testHtmlElement !== clickedCell.cellElement) {
            if (testHtmlElement.parentElement) {
                testHtmlElement = testHtmlElement.parentElement;
            }
            else {
                break;
            }
            actionableClick = testHtmlElement.classList.contains("bolt-table-header-cell-actionable");
        }
        if (clickedCell.rowIndex === -1 && actionableClick) {
            var column = this.props.columns[clickedCell.cellIndex];
            // If the column is currently sorted ascending then we need to invert the sort.
            if (column && column.sortProps) {
                this.onSort(clickedCell.cellIndex, column.sortProps.sortOrder === _Table_Props__WEBPACK_IMPORTED_MODULE_2__[/* SortOrder */ "c"].ascending ? _Table_Props__WEBPACK_IMPORTED_MODULE_2__[/* SortOrder */ "c"].descending : _Table_Props__WEBPACK_IMPORTED_MODULE_2__[/* SortOrder */ "c"].ascending, event);
                event.preventDefault();
            }
        }
    };
    return ColumnSorting;
}());

/**
 * sortItems is a helper method that works with the ColumnSorting and a Table
 * component to make it eaiser to maintain the props of the table. This function
 * will update the column definitions and return the sorted data. The caller
 * needs to update the props to the table appropriately after calling this
 * method.
 *
 * @param columnIndex The column that should be sorted.
 * @param sortOrder The order the data should be sorted.
 * @param sortFunctions An array of sort functions. Each sortable column should
 *  have a function supplied. If there are non-sortable columns, null should be
 *  supplied for their index.
 * @param columns The column definitions for the table.
 * @param items The array of items that should be sorted. Note: This is done in
 *  place so the input array will be updated.
 *
 * @return The resulting sorted array of items.
 */
function sortItems(columnIndex, sortOrder, sortFunctions, columns, items) {
    var sortFunction = sortFunctions[columnIndex];
    // If we are sorting descending, invert the sorting function.
    if (sortFunction && sortOrder === _Table_Props__WEBPACK_IMPORTED_MODULE_2__[/* SortOrder */ "c"].descending) {
        sortFunction = function (item1, item2) {
            return -sortFunctions[columnIndex](item1, item2);
        };
    }
    // Update the sortOrder for each of the columns.
    for (var index = 0; index < columns.length; index++) {
        var column = columns[index];
        if (column.sortProps) {
            column.sortProps.sortOrder = index === columnIndex ? sortOrder : undefined;
        }
    }
    if (sortFunction) {
        return items.sort(sortFunction);
    }
    else {
        return items;
    }
}


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragAndDropGripper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return renderGripper; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Table_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58);
/* harmony import */ var _Table_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Table_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);





/**
 * The DragAndDropGripper is meant to be rendered inside of the
 * spacer column of a table, to indicate an item can be dragged in a table.
 */
var DragAndDropGripper = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(DragAndDropGripper, _super);
    function DragAndDropGripper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DragAndDropGripper.prototype.render = function () {
        return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: "bolt-gripper-container bolt-table-cell-content-reveal" },
            react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: "bolt-gripper" })));
    };
    return DragAndDropGripper;
}(react__WEBPACK_IMPORTED_MODULE_4__["Component"]));

function renderGripper(index, left) {
    if (left) {
        return react__WEBPACK_IMPORTED_MODULE_4__["createElement"](DragAndDropGripper, null);
    }
    return null;
}


/***/ }),
/* 152 */
/***/ (function(module, exports) {



/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FocusOrMouseWithin; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _FocusWithin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23);
/* harmony import */ var _MouseWithin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42);






var FocusOrMouseWithin = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(FocusOrMouseWithin, _super);
    function FocusOrMouseWithin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mouseWithinRef = react__WEBPACK_IMPORTED_MODULE_3__["createRef"]();
        _this.focusWithinRef = react__WEBPACK_IMPORTED_MODULE_3__["createRef"]();
        _this.hasFocus = function () {
            return !!_this.focusWithinRef.current && _this.focusWithinRef.current.hasFocus();
        };
        _this.hasMouse = function () {
            return !!_this.mouseWithinRef.current && _this.mouseWithinRef.current.hasMouse();
        };
        return _this;
    }
    FocusOrMouseWithin.prototype.render = function () {
        var _this = this;
        var _a = this.props, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onFocus = _a.onFocus, onBlur = _a.onBlur;
        var children;
        return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_MouseWithin__WEBPACK_IMPORTED_MODULE_5__["MouseWithin"], { ref: this.mouseWithinRef, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, function (mouseWithinStatus) {
            if (typeof _this.props.children === "function") {
                children = function (props) {
                    return _this.props.children(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, props), mouseWithinStatus));
                };
            }
            else {
                var child = react__WEBPACK_IMPORTED_MODULE_3__["Children"].only(_this.props.children);
                children = react__WEBPACK_IMPORTED_MODULE_3__["cloneElement"](child, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, child.props), mouseWithinStatus), child.props.children);
            }
            return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_FocusWithin__WEBPACK_IMPORTED_MODULE_4__["FocusWithin"], { onFocus: onFocus, onBlur: onBlur, ref: _this.focusWithinRef }, children));
        }));
    };
    return FocusOrMouseWithin;
}(react__WEBPACK_IMPORTED_MODULE_3__["Component"]));



/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breakpoint; });
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Breakpoint_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(249);
/* harmony import */ var _Breakpoint_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Breakpoint_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Intersection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34);





function Breakpoint(props) {
    var observationElement = react__WEBPACK_IMPORTED_MODULE_3__["useState"](function () { return react__WEBPACK_IMPORTED_MODULE_3__["createRef"](); })[0];
    var lastBreakpointIndex = -2;
    var observationElementFunction = function () {
        return observationElement.current;
    };
    var observationDelegate = function () {
        var visibleWidth = observationElement.current.parentElement.clientWidth;
        var breakpoints = props.breakpoints, onBreakpoint = props.onBreakpoint;
        // Determine the longest visible breakpoint.
        var breakpointIndex = breakpoints.length - 1;
        for (; breakpointIndex >= 0; breakpointIndex--) {
            if (visibleWidth >= breakpoints[breakpointIndex]) {
                break;
            }
        }
        // Notify the caller about the change in the breakpoint.
        if (breakpointIndex !== lastBreakpointIndex) {
            lastBreakpointIndex = breakpointIndex;
            onBreakpoint(breakpointIndex, breakpoints[breakpointIndex]);
        }
    };
    // Compute the threshold we will use for the notification. This is the percentage
    // visibility of the observation element within the container.
    // NOTE: Due to rounding issues we need to know about all 3 pixels (1 before, at breakpoint, 1 after).
    var breakpoints = props.breakpoints;
    var observationWidth = breakpoints[breakpoints.length - 1] + 1;
    var threshold = [];
    for (var index = 0; index < breakpoints.length; index++) {
        threshold[index * 3] = (breakpoints[index] - 1) / observationWidth;
        threshold[index * 3 + 1] = breakpoints[index] / observationWidth;
        threshold[index * 3 + 2] = (breakpoints[index] + 1) / observationWidth;
    }
    return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { className: "bolt-breakpoint relative" },
        react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Intersection__WEBPACK_IMPORTED_MODULE_4__["Intersection"], { observationElement: observationElementFunction, onIntersect: observationDelegate, threshold: threshold },
            react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { className: "bolt-breakpoint-container absolute-fill scroll-hidden" },
                react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { className: "bolt-breakpoint-observation absolute", ref: observationElement, style: { width: observationWidth + "px" } })))));
}


/***/ }),
/* 155 */
/***/ (function(module, exports) {



/***/ }),
/* 156 */
/***/ (function(module, exports) {



/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FixedHeightTree; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Tree_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96);
/* harmony import */ var _Tree_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Tree_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _TreeExpand_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97);
/* harmony import */ var _TreeExpand_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_TreeExpand_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _List__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8);








var FixedHeightTree = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(FixedHeightTree, _super);
    function FixedHeightTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.list = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.onActivateExpand = function (event, tableRow) {
            if (!event.defaultPrevented && tableRow.data.underlyingItem.childItems) {
                _this.props.onToggle && _this.props.onToggle(event, tableRow.data);
                event.preventDefault();
            }
        };
        _this.renderRow = function (rowIndex, item, details) {
            if (!_this.props.renderRow || !details.data) {
                return react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", null);
            }
            var rowDetails = {
                ariaRowOffset: details.ariaRowOffset,
                eventDispatch: details.eventDispatch,
                data: details.data,
                itemProvider: _this.props.itemProvider,
                listProps: details.listProps,
                onFocusItem: details.onFocusItem
            };
            return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_7__["Observer"], { data: item.underlyingItem.data }, function (props) {
                if (props.data) {
                    // We need to forward the onToggle handler to the treeItemEx before it is rendered.
                    item.onToggle = item.underlyingItem.childItems ? _this.props.onToggle : undefined;
                    // First determine if the item supplied a custom row rendering function, if not
                    // attempt to use the global row rendering function.
                    var renderRow = item.underlyingItem.data.renderRow || _this.props.renderRow;
                    return renderRow(rowIndex, item, rowDetails);
                }
                else {
                    var renderLoadingRow = _this.props.renderLoadingRow;
                    // If a custom row loading animation is available use it.
                    if (renderLoadingRow) {
                        return renderLoadingRow(rowIndex, rowDetails);
                    }
                    // Return the default row loading animation.
                    return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "bolt-list-row-loading" },
                        react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("div", { className: "shimmer shimmer-line", style: { width: Math.random() * 80 + 20 + "%" } }, "\u00A0")));
                }
            }));
        };
        return _this;
    }
    FixedHeightTree.prototype.render = function () {
        var _a = this.props.role, role = _a === void 0 ? "tree" : _a;
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_List__WEBPACK_IMPORTED_MODULE_6__["FixedHeightList"], { className: this.props.className, eventDispatch: this.props.eventDispatch, focuszoneProps: this.props.focuszoneProps, id: this.props.id, itemProvider: this.props.itemProvider, maxHeight: this.props.maxHeight, onActivate: this.onActivateExpand, onFocus: this.props.onFocus, onSelect: this.props.onSelect, pageSize: this.props.pageSize, renderRow: this.renderRow, role: role, rowHeight: this.props.rowHeight, ref: this.list, selection: this.props.selection, singleClickActivation: this.props.singleClickActivation || true, width: this.props.width || "100%" }));
    };
    FixedHeightTree.prototype.getFocusIndex = function () {
        if (this.list.current) {
            return this.list.current.getFocusIndex();
        }
        return -1;
    };
    FixedHeightTree.prototype.getStats = function () {
        if (this.list.current) {
            return this.list.current.getStats();
        }
        return {
            firstMaterialized: -1,
            lastMaterialized: -1
        };
    };
    FixedHeightTree.prototype.scrollIntoView = function (rowIndex, options) {
        if (this.list.current) {
            return this.list.current.scrollIntoView(rowIndex, options);
        }
    };
    return FixedHeightTree;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));



/***/ }),
/* 158 */
/***/ (function(module, exports) {



/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Tree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TreeRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return renderTreeRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpandableTreeCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return renderExpandableTreeCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return renderTreeCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return renderTreeCellWithClassName; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Tree_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96);
/* harmony import */ var _Tree_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Tree_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _TreeExpand_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97);
/* harmony import */ var _TreeExpand_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_TreeExpand_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4);
/* harmony import */ var _FocusWithin__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23);
/* harmony import */ var _FocusZone__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30);
/* harmony import */ var _List__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8);
/* harmony import */ var _Table__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(24);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1);
/* harmony import */ var _Utilities_Focus__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26);
/* harmony import */ var _TreeExpand__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61);
















var Tree = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(Tree, _super);
    function Tree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.table = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.onActivateExpand = function (event, tableRow) {
            if (!event.defaultPrevented && tableRow.data.underlyingItem.childItems) {
                _this.props.onToggle && _this.props.onToggle(event, tableRow.data);
                event.preventDefault();
            }
        };
        _this.renderRow = function (rowIndex, item, details) {
            // If onActivate for tree is not specified but onToggle is, tree passes on onActivateExpand as onActivate to table.
            // In that case, onActivate can be different for tree and table
            details.singleClickActivation = _this.props.onActivate && details.singleClickActivation;
            // Since the underlying table is unable to determine whether or not a row
            // is in a loading state since the observable value is within the ITreeItemEx
            // we need to handle this in the row rendering.
            return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_11__["Observer"], { data: item.underlyingItem.data }, function (props) {
                if (props.data) {
                    // We need to forward the onToggle handler to the treeItemEx before it is rendered.
                    item.onToggle = item.underlyingItem.childItems ? _this.props.onToggle : undefined;
                    // First determine if the item supplied a custom row rendering function, if not
                    // attempt to use the global row rendering function.
                    var renderRow = item.underlyingItem.data.renderRow || _this.props.renderRow;
                    if (renderRow) {
                        return renderRow(rowIndex, item, details);
                    }
                    return renderTreeRow(rowIndex, item, details, _this.props.columns, props.data);
                }
                else {
                    var renderLoadingRow = _this.props.renderLoadingRow;
                    // If a custom row loading animation is available use it.
                    if (renderLoadingRow) {
                        return renderLoadingRow(rowIndex, details);
                    }
                    // Return the default row loading animation.
                    return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](TreeRow, { index: rowIndex, details: details }, _this.props.columns.map(function (treeColumn, columnIndex) {
                        var children = Object(_Table__WEBPACK_IMPORTED_MODULE_12__["renderLoadingCell"])(treeColumn.columnLayout);
                        if (treeColumn.hierarchical) {
                            children = react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_TreeExpand__WEBPACK_IMPORTED_MODULE_15__[/* TreeExpand */ "a"], { depth: details.data.depth }, children);
                        }
                        return Object(_Table__WEBPACK_IMPORTED_MODULE_12__["SimpleTableCell"])({ className: "bolt-tree-cell", columnIndex: columnIndex, children: children });
                    })));
                }
            }));
        };
        return _this;
    }
    Tree.prototype.render = function () {
        var _a = this.props.role, role = _a === void 0 ? "treegrid" : _a;
        // If we haven't specified an onActivate, but have specified an onToggle, toggle on activate.
        var onActivate = this.props.onActivate ? this.props.onActivate : this.props.onToggle ? this.onActivateExpand : undefined;
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_Table__WEBPACK_IMPORTED_MODULE_12__["Table"], { ariaLabel: this.props.ariaLabel, behaviors: this.props.behaviors, className: this.props.className, columns: this.props.columns, containerClassName: this.props.containerClassName, eventDispatch: this.props.eventDispatch, focuszoneProps: this.props.focuszoneProps, id: this.props.id, itemProvider: this.props.itemProvider, maxHeight: this.props.maxHeight, onActivate: onActivate, onFocus: this.props.onFocus, onSelect: this.props.onSelect, pageSize: this.props.pageSize, renderHeader: this.props.renderHeader, renderRow: this.renderRow, renderSpacer: this.props.renderSpacer, role: role, rowHeight: this.props.rowHeight, ref: this.table, scrollable: this.props.scrollable, selectableText: this.props.selectableText, selection: this.props.selection, singleClickActivation: this.props.singleClickActivation, showHeader: this.props.showHeader, showLines: this.props.showLines, showScroll: this.props.showScroll, tableBreakpoints: this.props.tableBreakpoints, virtualize: this.props.virtualize }));
    };
    Tree.prototype.addOverlay = function (id, rowIndex, render, zIndex) {
        if (zIndex === void 0) { zIndex = 0; }
        if (this.table.current) {
            return this.table.current.addOverlay(id, rowIndex, render, zIndex);
        }
    };
    Tree.prototype.removeOverlay = function (id) {
        if (this.table.current) {
            return this.table.current.removeOverlay(id);
        }
    };
    Tree.prototype.focusRow = function (rowIndex, direction) {
        if (direction === void 0) { direction = 1; }
        if (this.table.current) {
            return this.table.current.focusRow(rowIndex, direction);
        }
        else {
            return Promise.resolve();
        }
    };
    Tree.prototype.getFocusIndex = function () {
        if (this.table.current) {
            return this.table.current.getFocusIndex();
        }
        return -1;
    };
    Tree.prototype.getStats = function () {
        if (this.table.current) {
            return this.table.current.getStats();
        }
        return {
            firstMaterialized: -1,
            firstRendered: -1,
            lastMaterialized: -1,
            lastRendered: -1
        };
    };
    Tree.prototype.scrollIntoView = function (rowIndex, options) {
        if (this.table.current) {
            return this.table.current.scrollIntoView(rowIndex, options);
        }
    };
    return Tree;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));

var TreeRow = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(TreeRow, _super);
    function TreeRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowElement = react__WEBPACK_IMPORTED_MODULE_5__["createRef"]();
        _this.onFocus = function (event) {
            _this.props.details.onFocusItem(_this.props.index, event);
        };
        _this.onKeyDown = function (event) {
            if (!event.defaultPrevented) {
                if (_this.rowElement.current === event.nativeEvent.srcElement) {
                    var data = _this.props.details.data;
                    if (data) {
                        if (data.onToggle) {
                            var expanded = data.underlyingItem.expanded;
                            if ((event.which === _Util__WEBPACK_IMPORTED_MODULE_13__["KeyCode"].rightArrow && !expanded) || (event.which === _Util__WEBPACK_IMPORTED_MODULE_13__["KeyCode"].leftArrow && expanded)) {
                                data.onToggle(event, data);
                                event.preventDefault();
                            }
                        }
                    }
                }
            }
        };
        _this.onPostprocessKeyStroke = function (event) {
            if (!event.defaultPrevented) {
                if (event.which === _Util__WEBPACK_IMPORTED_MODULE_13__["KeyCode"].leftArrow) {
                    _this.rowElement.current.focus();
                    event.preventDefault();
                }
            }
            return _FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZoneKeyStroke */ "d"].IgnoreNone;
        };
        return _this;
    }
    TreeRow.prototype.render = function () {
        var _this = this;
        var _a = this.props, details = _a.details, index = _a.index, linkProps = _a.linkProps;
        var ariaRowOffset = details.ariaRowOffset, data = details.data, excludeFocusZone = details.excludeFocusZone, renderSpacer = details.renderSpacer, selectableText = details.selectableText, selection = details.selection, singleClickActivation = details.singleClickActivation;
        // If the row is being rendered as a link we will use an anchor, otherwise we will
        // use a standard table row.
        var RowType = linkProps ? "a" : "tr";
        // Build the set of props needed from the link to forward on to the row element.
        var linkForwardProps = Object(_Link__WEBPACK_IMPORTED_MODULE_9__["getDefaultAnchorProps"])(linkProps);
        return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusWithin__WEBPACK_IMPORTED_MODULE_7__["FocusWithin"], { onFocus: this.onFocus }, function (focusStatus) {
            return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZoneContext */ "b"].Consumer, null, function (rowContext) {
                return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZone */ "a"], { direction: _FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZoneDirection */ "c"].Horizontal, postprocessKeyStroke: _this.onPostprocessKeyStroke },
                    react__WEBPACK_IMPORTED_MODULE_5__["createElement"](RowType, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, linkForwardProps, { "aria-busy": data === undefined, "aria-expanded": data && data.underlyingItem.expanded, "aria-level": data ? data.depth + 1 : undefined, "aria-rowindex": index + ariaRowOffset, "aria-selected": selection && selection.selected(index) ? true : undefined, className: Object(_Util__WEBPACK_IMPORTED_MODULE_13__["css"])(_this.props.className, "bolt-tree-row bolt-table-row bolt-list-row", index === 0 && "first-row", focusStatus.hasFocus && "focused", selection && selection.selected(index) && "selected", singleClickActivation && "single-click-activation", selectableText && "selectable-text", linkProps && "v-align-middle"), "data-focuszone": excludeFocusZone || (selection && !selection.selectable(index)) ? undefined : rowContext.focuszoneId, "data-row-index": index, tabIndex: Object(_Utilities_Focus__WEBPACK_IMPORTED_MODULE_14__[/* getTabIndex */ "a"])(details), onBlur: focusStatus.onBlur, onFocus: focusStatus.onFocus, onKeyDown: _this.onKeyDown, ref: _this.rowElement, role: "row" }),
                        react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("td", { key: "left-spacer", className: "bolt-table-cell-compact bolt-table-cell bolt-list-cell", role: "presentation" }, renderSpacer && renderSpacer(index, true)),
                        _this.props.children,
                        react__WEBPACK_IMPORTED_MODULE_5__["createElement"]("td", { key: "right-spacer", className: "bolt-table-cell-compact bolt-table-cell bolt-list-cell", role: "presentation" }, renderSpacer && renderSpacer(index, false)))));
            }));
        }));
    };
    return TreeRow;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]));

function renderTreeRow(rowIndex, item, details, columns, data, className) {
    return (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](TreeRow, { index: rowIndex, details: details, linkProps: data ? data.linkProps : undefined, className: className }, Object(_Table__WEBPACK_IMPORTED_MODULE_12__["renderColumns"])(rowIndex, columns, item, details)));
}
/**
 * Standard cell renderer for a tree cell with expandable children. This will use the tree items
 * state to determine whether or not the row is expanded etc.
 */
function ExpandableTreeCell(props) {
    var colspan = props.colspan, columnIndex = props.columnIndex, contentClassName = props.contentClassName, treeItem = props.treeItem, treeColumn = props.treeColumn;
    var depth = treeItem.depth, onToggle = treeItem.onToggle, underlyingItem = treeItem.underlyingItem;
    var expanded = underlyingItem.expanded;
    var children = (react__WEBPACK_IMPORTED_MODULE_5__["createElement"](_TreeExpand__WEBPACK_IMPORTED_MODULE_15__[/* TreeExpand */ "a"], { expanded: expanded, depth: depth, indentationSize: treeColumn && treeColumn.indentationSize, onClick: _Util__WEBPACK_IMPORTED_MODULE_13__["preventDefault"], onToggle: onToggle ? function (event) { return onToggle(event, treeItem); } : undefined }, props.children));
    return Object(_Table__WEBPACK_IMPORTED_MODULE_12__["SimpleTableCell"])({
        children: children,
        className: Object(_Util__WEBPACK_IMPORTED_MODULE_13__["css"])(props.className, "bolt-tree-cell"),
        colspan: colspan,
        columnIndex: columnIndex,
        contentClassName: contentClassName,
        tableColumn: treeColumn
    });
}
function renderExpandableTreeCell(rowIndex, columnIndex, treeColumn, treeItem) {
    var underlyingItem = treeItem.underlyingItem;
    var data = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(underlyingItem.data);
    var treeCell = data && data[treeColumn.id];
    // Do not include padding if the table cell has an href
    var hasLink = !!(treeCell && typeof treeCell !== "string" && typeof treeCell !== "number" && treeCell.href);
    return ExpandableTreeCell({
        children: treeCell && Object(_List__WEBPACK_IMPORTED_MODULE_10__["renderListCell"])(treeCell),
        className: treeColumn.className,
        columnIndex: columnIndex,
        contentClassName: hasLink ? "bolt-table-cell-content-with-link" : undefined,
        treeItem: treeItem,
        treeColumn: treeColumn
    });
}
function renderTreeCell(rowIndex, columnIndex, treeColumn, treeItem) {
    var underlyingItem = treeItem.underlyingItem;
    var data = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(underlyingItem.data);
    var treeCell = data && data[treeColumn.id];
    // Do not include padding if the table cell has an href
    var hasLink = !!(treeCell && typeof treeCell !== "string" && typeof treeCell !== "number" && treeCell.href);
    return Object(_Table__WEBPACK_IMPORTED_MODULE_12__["SimpleTableCell"])({
        className: treeColumn.className,
        children: treeCell && Object(_List__WEBPACK_IMPORTED_MODULE_10__["renderListCell"])(treeCell),
        columnIndex: columnIndex,
        contentClassName: hasLink ? "bolt-table-cell-content-with-link" : undefined,
        tableColumn: treeColumn
    });
}
function renderTreeCellWithClassName(rowIndex, columnIndex, treeColumn, treeItem, contentClassName) {
    var underlyingItem = treeItem.underlyingItem;
    var data = _Core_Observable__WEBPACK_IMPORTED_MODULE_6__["ObservableLike"].getValue(underlyingItem.data);
    var treeCell = data && data[treeColumn.id];
    // Do not include padding if the table cell has an href
    var hasLink = !!(treeCell && typeof treeCell !== "string" && typeof treeCell !== "number" && treeCell.href);
    return Object(_Table__WEBPACK_IMPORTED_MODULE_12__["SimpleTableCell"])({
        className: treeColumn.className,
        children: treeCell && Object(_List__WEBPACK_IMPORTED_MODULE_10__["renderListCell"])(treeCell),
        columnIndex: columnIndex,
        contentClassName: Object(_Util__WEBPACK_IMPORTED_MODULE_13__["css"])(contentClassName, hasLink ? "bolt-table-cell-content-with-link" : undefined),
        tableColumn: treeColumn
    });
}


/***/ }),
/* 160 */
/***/ (function(module, exports) {



/***/ }),
/* 161 */
/***/ (function(module, exports) {



/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(253);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormItemContext; });
/* unused harmony export FormItem */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _FormItem_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(254);
/* harmony import */ var _FormItem_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_FormItem_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1);







var FormItemContext = react__WEBPACK_IMPORTED_MODULE_4__["createContext"]({});
var formItemId = 1;
var FormItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(FormItem, _super);
    function FormItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = "form-item-" + formItemId++;
        return _this;
    }
    FormItem.prototype.render = function () {
        var _this = this;
        var _a = this.props, ariaLabel = _a.ariaLabel, className = _a.className, error = _a.error, label = _a.label, message = _a.message;
        var ariaLabelledById = label ? this.id + "-label" : undefined;
        return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_5__["Observer"], { error: error, message: message }, function (observedProps) {
            var ariaDescribedById = observedProps.message ? _this.id + "-message" : undefined;
            return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](FormItemContext.Provider, { value: { ariaDescribedById: ariaDescribedById, ariaLabelledById: ariaLabelledById, error: observedProps.error } },
                react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: Object(_Util__WEBPACK_IMPORTED_MODULE_6__["css"])(className, "flex-column") },
                    label && (react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("label", { "aria-label": ariaLabel, className: "bolt-formitem-label body-m", id: Object(_Util__WEBPACK_IMPORTED_MODULE_6__["getSafeId"])(ariaLabelledById) }, label)),
                    _this.props.children,
                    observedProps.message && (react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("span", { className: Object(_Util__WEBPACK_IMPORTED_MODULE_6__["css"])("bolt-formitem-message body-xs", observedProps.error && "bolt-formitem-message-error"), id: Object(_Util__WEBPACK_IMPORTED_MODULE_6__["getSafeId"])(ariaDescribedById), role: observedProps.error ? "alert" : undefined }, observedProps.message)))));
        }));
    };
    return FormItem;
}(react__WEBPACK_IMPORTED_MODULE_4__["Component"]));



/***/ }),
/* 164 */
/***/ (function(module, exports) {



/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpandableTextField; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ExpandableTextField_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(256);
/* harmony import */ var _ExpandableTextField_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ExpandableTextField_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Expandable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90);
/* harmony import */ var _FocusWithin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9);
/* harmony import */ var _TextField__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1);
/* harmony import */ var _Utilities_Position__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12);











var textFieldId = 1;
var ExpandableTextField = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(ExpandableTextField, _super);
    function ExpandableTextField(props) {
        var _this = _super.call(this, props) || this;
        _this.textFieldElement = react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
        _this.expandable = react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
        _this.collapse = function () {
            if (_this.expandable.current) {
                _this.expandable.current.collapse();
            }
        };
        _this.expand = function () {
            if (_this.expandable.current) {
                _this.expandable.current.expand();
            }
        };
        _this.renderCallout = function () {
            return _this.props.renderCallout(_this, _this.dropdownId, _this.props.anchorElement
                ? _this.props.anchorElement
                : !_this.props.anchorPoint
                    ? _this.containerElement.current
                        ? _this.containerElement.current
                        : undefined
                    : undefined, _this.props.anchorOffset || { horizontal: 0, vertical: 0 }, _this.props.anchorOrigin || { horizontal: _Utilities_Position__WEBPACK_IMPORTED_MODULE_10__[/* Location */ "a"].end, vertical: _Utilities_Position__WEBPACK_IMPORTED_MODULE_10__[/* Location */ "a"].end }, _this.props.anchorPoint, _this.props.dropdownOrigin || { horizontal: _Utilities_Position__WEBPACK_IMPORTED_MODULE_10__[/* Location */ "a"].end, vertical: _Utilities_Position__WEBPACK_IMPORTED_MODULE_10__[/* Location */ "a"].start });
        };
        _this.dropdownId = props.dropdownId || "dropdown-" + textFieldId++;
        _this.containerElement = props.containerRef || react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
        return _this;
    }
    ExpandableTextField.prototype.render = function () {
        var _this = this;
        return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Expandable__WEBPACK_IMPORTED_MODULE_5__["Expandable"], { disabled: this.props.disabled, expandKey: this.props.expandKey, onCollapse: this.props.onCollapse, onExpand: this.props.onExpand, renderCallout: this.renderCallout, ref: this.expandable }, function (expandableProps) {
            return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_FocusWithin__WEBPACK_IMPORTED_MODULE_6__["FocusWithin"], { onFocus: _this.props.onFocus, onBlur: _this.props.onBlur }, function (focusStatus) { return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: Object(_Util__WEBPACK_IMPORTED_MODULE_9__["css"])(_this.props.className, "bolt-expandable-textfield"), onBlur: function () {
                    if (_this.props.blurDismiss) {
                        _this.collapse();
                    }
                    focusStatus.onBlur && focusStatus.onBlur();
                }, onFocus: function (event) {
                    focusStatus.onFocus && focusStatus.onFocus(event);
                    // If the top-level component recieves focus, set focus to the text field.
                    if (event.target === _this.containerElement.current) {
                        _this.focus();
                    }
                }, onMouseDown: expandableProps.onMouseDown, onKeyDown: expandableProps.onKeyDown, ref: _this.containerElement, role: _this.props.editable ? "combobox" : undefined, "aria-expanded": _this.props.editable ? expandableProps.expanded : undefined, tabIndex: -1 },
                react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_TextField__WEBPACK_IMPORTED_MODULE_8__[/* TextField */ "a"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({ ariaHasPopup: "dialog" }, _this.props, { ariaActiveDescendant: expandableProps.expanded ? _this.props.ariaActiveDescendant : undefined, role: _this.props.editable ? "textbox" : undefined, ariaExpanded: !_this.props.editable ? expandableProps.expanded : undefined, ariaControls: expandableProps.expanded ? _this.dropdownId : undefined, className: "", onClick: expandableProps.onClick, ref: _this.textFieldElement, suffixIconProps: !_this.props.hideDropdownIcon
                        ? {
                            key: "dropdown-icon",
                            className: Object(_Util__WEBPACK_IMPORTED_MODULE_9__["css"])("bolt-expandable-textfield-icon icon-right", _this.props.disabled && "disabled"),
                            iconName: "ChevronDownMed",
                            onClick: expandableProps.onClick,
                            size: _Icon__WEBPACK_IMPORTED_MODULE_7__["IconSize"].small
                        }
                        : undefined })))); }));
        }));
    };
    ExpandableTextField.prototype.focus = function () {
        if (this.textFieldElement.current) {
            this.textFieldElement.current.focus();
        }
    };
    ExpandableTextField.prototype.select = function () {
        if (this.textFieldElement.current) {
            this.textFieldElement.current.select();
        }
    };
    ExpandableTextField.defaultProps = {
        expandKey: [_Util__WEBPACK_IMPORTED_MODULE_9__["KeyCode"].downArrow, _Util__WEBPACK_IMPORTED_MODULE_9__["KeyCode"].enter]
    };
    return ExpandableTextField;
}(react__WEBPACK_IMPORTED_MODULE_4__["Component"]));



/***/ }),
/* 166 */
/***/ (function(module, exports) {



/***/ }),
/* 167 */
/***/ (function(module, exports) {



/***/ }),
/* 168 */
/***/ (function(module, exports) {



/***/ }),
/* 169 */
/***/ (function(module, exports) {



/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterBarItem; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Core_TimerManagement__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41);
/* harmony import */ var _Utilities_Filter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33);






var FilterBarItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(FilterBarItem, _super);
    function FilterBarItem(props) {
        var _this = _super.call(this, props) || this;
        _this._onFilterChanged = function (changedState) {
            if (changedState.hasOwnProperty(_this.props.filterItemKey)) {
                _this.onFilterChanged(changedState[_this.props.filterItemKey]);
            }
        };
        _this._setFilterValue = function (filterState) {
            if (_this.props.filter) {
                _this.props.filter.setFilterItemState(_this.props.filterItemKey, filterState);
            }
        };
        _this.timerManagement = new _Core_TimerManagement__WEBPACK_IMPORTED_MODULE_4__[/* TimerManagement */ "a"]();
        return _this;
    }
    FilterBarItem.prototype.UNSAFE_componentWillMount = function () {
        if (this.props.filter) {
            var itemState = this.props.filter.getFilterItemState(this.props.filterItemKey);
            this.setState({ value: itemState && itemState.value, operator: itemState && itemState.operator });
            var throttleWait = this.getThrottleWait();
            if (throttleWait) {
                this.throttledSetFilterValue = this.timerManagement.debounce(this._setFilterValue, throttleWait, { leading: false, trailing: true });
            }
            else {
                this.throttledSetFilterValue = this._setFilterValue;
            }
        }
    };
    /**
     * Setting state when component state is different from filter item state
     * Needed for handling scenarios when filter object's setState method is called with suppressChangeEvent=true
     * In such cases, FILTER_CHANGE_EVENT is not triggered and thus component state is not updated
     * And then on re-rendering component renders with old state.
     * @param nextProps
     */
    FilterBarItem.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.filter) {
            var itemState = nextProps.filter.getFilterItemState(nextProps.filterItemKey);
            // If we are throttling the changes from the filter item's state, there is a chance that the props are out of sync with the state.
            // Therefore, we only want to react to new changes in props if we are not throttling or if the setKey for the component has changed
            // (indicating we want to completely reset state, reacting to the props)
            if (this.props.setKey !== nextProps.setKey ||
                (this.getThrottleWait() === 0 &&
                    !nextProps.filter.filterItemStatesAreEqual(nextProps.filterItemKey, itemState, this.state))) {
                this.setState({ value: itemState && itemState.value, operator: itemState && itemState.operator });
            }
        }
    };
    FilterBarItem.prototype.componentDidMount = function () {
        this.props.filter && this.props.filter.subscribe(this._onFilterChanged, _Utilities_Filter__WEBPACK_IMPORTED_MODULE_5__["FILTER_CHANGE_EVENT"]);
    };
    FilterBarItem.prototype.componentWillUnmount = function () {
        this.props.filter && this.props.filter.unsubscribe(this._onFilterChanged, _Utilities_Filter__WEBPACK_IMPORTED_MODULE_5__["FILTER_CHANGE_EVENT"]);
        this.timerManagement.dispose();
    };
    FilterBarItem.prototype.onFilterChanged = function (filterState) {
        this.setState({
            value: filterState && filterState.value,
            operator: filterState && filterState.operator
        });
    };
    FilterBarItem.prototype.getThrottleWait = function () {
        return 0;
    };
    FilterBarItem.prototype.setFilterValue = function (filterState) {
        if (this.getThrottleWait()) {
            this.setState({
                value: filterState && filterState.value,
                operator: filterState && filterState.operator
            });
        }
        this.throttledSetFilterValue(filterState);
    };
    return FilterBarItem;
}(react__WEBPACK_IMPORTED_MODULE_3__["Component"]));



/***/ }),
/* 171 */
/***/ (function(module, exports) {



/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WithPivots; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Dropdown_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51);
/* harmony import */ var _Dropdown_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Dropdown_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14);
/* harmony import */ var _FocusWithin__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23);
/* harmony import */ var _FocusZone__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1);
/* harmony import */ var _DropdownCallout__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53);












function WithPivots(props) {
    var renderCallout = function (calloutProps) {
        return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_DropdownCallout__WEBPACK_IMPORTED_MODULE_11__[/* DropdownCallout */ "a"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, calloutProps, props.calloutProps, { onFilterTextChanged: function (e, value) {
                calloutProps.onFilterTextChanged && calloutProps.onFilterTextChanged(e, value);
                props.calloutProps && props.calloutProps.onFilterTextChanged && props.calloutProps.onFilterTextChanged(e, value);
            }, renderBeforeContent: function () { return renderPivots(props); } })));
    };
    return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_9__["Observer"], { selectedPivot: props.selectedPivot }, function () {
        var selectedPivot = getSelectedPivot(props);
        return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_9__["Observer"], { userFilteredItems: selectedPivot.userFilteredItems }, function () {
            var newProps = {
                actions: selectedPivot.actions,
                filterByText: selectedPivot.filterByText,
                userFilteredItems: selectedPivot.userFilteredItems || selectedPivot.items,
                filteredNoResultsText: selectedPivot.filteredNoResultsText,
                filterPlaceholderText: selectedPivot.filterPlaceholderText,
                noItemsText: selectedPivot.noItemsText,
                renderCallout: renderCallout,
                showFilterBox: selectedPivot.showFilterBox
            };
            return props.children(newProps);
        }));
    }));
}
function onPivotClick(pivot, props) {
    if (props.onPivotClicked) {
        props.onPivotClicked(pivot);
    }
}
function getSelectedPivot(props) {
    var selectedPivot;
    if (props.selectedPivot) {
        var selectedPivotId_1 = _Core_Observable__WEBPACK_IMPORTED_MODULE_5__["ObservableLike"].getValue(props.selectedPivot);
        selectedPivot = props.pivots.find(function (pivot) { return pivot.id === selectedPivotId_1; });
    }
    return selectedPivot || props.pivots[0];
}
function renderPivots(props) {
    if (props.pivots.length < 2) {
        return null;
    }
    return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZoneContext */ "b"].Consumer, null, function (verticalContext) { return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZone */ "a"], { direction: _FocusZone__WEBPACK_IMPORTED_MODULE_8__[/* FocusZoneDirection */ "c"].Horizontal },
        react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { role: "tablist" },
            react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_FocusWithin__WEBPACK_IMPORTED_MODULE_7__["FocusWithin"], null, function (focusStatus) {
                return props.pivots.map(function (pivot, index) {
                    var selected = props.selectedPivot !== undefined && pivot.id === _Core_Observable__WEBPACK_IMPORTED_MODULE_5__["ObservableLike"].getValue(props.selectedPivot);
                    return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_Button__WEBPACK_IMPORTED_MODULE_6__["Button"], { ariaSelected: selected, ariaSetSize: props.pivots.length, ariaPosInSet: index + 1, className: "bolt-dropdown-pivot", key: pivot.id, subtle: true, onBlur: focusStatus.onBlur, onClick: function () { return onPivotClick(pivot, props); }, onFocus: focusStatus.onFocus, role: "tab", focusZoneId: index === 0 && !focusStatus.hasFocus ? verticalContext.focuszoneId : undefined },
                        react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("span", { className: Object(_Util__WEBPACK_IMPORTED_MODULE_10__["css"])(props.selectedPivot &&
                                pivot.id === _Core_Observable__WEBPACK_IMPORTED_MODULE_5__["ObservableLike"].getValue(props.selectedPivot) &&
                                "bolt-dropdown-pivot-selected") }, pivot.name || pivot.id)));
                });
            })))); }));
}


/***/ }),
/* 173 */
/***/ (function(module, exports) {



/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _FilterBar_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(175);
/* harmony import */ var _FilterBar_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_FilterBar_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _FilterBar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(198);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilterBar", function() { return _FilterBar__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _FilterBar_Props__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(176);
/* harmony import */ var _FilterBar_Props__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_FilterBar_Props__WEBPACK_IMPORTED_MODULE_4__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _FilterBar_Props__WEBPACK_IMPORTED_MODULE_4__) if(["default","FilterBar"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _FilterBar_Props__WEBPACK_IMPORTED_MODULE_4__[key]; }) }(__WEBPACK_IMPORT_KEY__));







/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(259);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 176 */
/***/ (function(module, exports) {



/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KeywordFilterBarItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InlineKeywordFilterBarItem; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Resources_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93);
/* harmony import */ var _TextField__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28);
/* harmony import */ var _TextFilterBarItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83);







var KeywordFilterBarItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(KeywordFilterBarItem, _super);
    function KeywordFilterBarItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeywordFilterBarItem.prototype.getExtraTextFieldProps = function () {
        var placeholder = this.props.placeholder || _Resources_Input__WEBPACK_IMPORTED_MODULE_4__[/* KeywordFilterBarItemPlaceholderText */ "b"];
        return {
            prefixIconProps: { className: "keyword-filter-icon", iconName: "Filter" },
            placeholder: placeholder,
            ariaLabel: placeholder,
            role: "searchbox"
        };
    };
    return KeywordFilterBarItem;
}(_TextFilterBarItem__WEBPACK_IMPORTED_MODULE_6__[/* TextFilterBarItem */ "a"]));

var InlineKeywordFilterBarItem = function (props) {
    return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { className: "flex-noshrink flex-row bolt-inline-keyword-filter-bar" },
        react__WEBPACK_IMPORTED_MODULE_3__["createElement"](KeywordFilterBarItem, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({ clearable: true }, props, { style: _TextField__WEBPACK_IMPORTED_MODULE_5__[/* TextFieldStyle */ "c"].inline, width: _TextField__WEBPACK_IMPORTED_MODULE_5__[/* TextFieldWidth */ "d"].tabBar }))));
};


/***/ }),
/* 178 */
/***/ (function(module, exports) {



/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = alphabetical

// Check if the given character code, or the character code at the first
// character, is alphabetical.
function alphabetical(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character

  return (
    (code >= 97 && code <= 122) /* a-z */ ||
    (code >= 65 && code <= 90) /* A-Z */
  )
}


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  position: true,
  gfm: true,
  commonmark: false,
  footnotes: false,
  pedantic: false,
  blocks: __webpack_require__(296)
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = indentation;

/* Map of characters, and their column length,
 * which can be used as indentation. */
var characters = {' ': 1, '\t': 4};

/* Gets indentation information for a line. */
function indentation(value) {
  var index = 0;
  var indent = 0;
  var character = value.charAt(index);
  var stops = {};
  var size;

  while (character in characters) {
    size = characters[character];

    indent += size;

    if (size > 1) {
      indent = Math.floor(indent / size) * size;
    }

    stops[indent] = index;

    character = value.charAt(++index);
  }

  return {indent: indent, stops: stops};
}


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var attributeName = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var unquoted = '[^"\'=<>`\\u0000-\\u0020]+';
var singleQuoted = '\'[^\']*\'';
var doubleQuoted = '"[^"]*"';
var attributeValue = '(?:' + unquoted + '|' + singleQuoted + '|' + doubleQuoted + ')';
var attribute = '(?:\\s+' + attributeName + '(?:\\s*=\\s*' + attributeValue + ')?)';
var openTag = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';
var closeTag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var processing = '<[?].*?[?]>';
var declaration = '<![A-Za-z]+\\s+[^>]*>';
var cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';

exports.openCloseTag = new RegExp('^(?:' + openTag + '|' + closeTag + ')');

exports.tag = new RegExp('^(?:' +
  openTag + '|' +
  closeTag + '|' +
  comment + '|' +
  processing + '|' +
  declaration + '|' +
  cdata +
')');


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('<', fromIndex);
}


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  var link = value.indexOf('[', fromIndex);
  var image = value.indexOf('![', fromIndex);

  if (image === -1) {
    return link;
  }

  /* Link can never be `-1` if an image is found, so we don’t need
   * to check for that :) */
  return link < image ? link : image;
}


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunStore = exports.isMatch = exports.SortRuleBy = void 0;
const mobx_1 = __webpack_require__(3);
const try_1 = __webpack_require__(59);
const Table_1 = __webpack_require__(24);
const getRepoUri_1 = __webpack_require__(105);
const getRepositoryDetailsFromRemoteUrl_1 = __webpack_require__(381);
var SortRuleBy;
(function (SortRuleBy) {
    SortRuleBy[SortRuleBy["Count"] = 0] = "Count";
    SortRuleBy[SortRuleBy["Name"] = 1] = "Name";
})(SortRuleBy = exports.SortRuleBy || (exports.SortRuleBy = {}));
const isMatch = (field, keywords) => !keywords.length || keywords.some(keyword => field.includes(keyword));
exports.isMatch = isMatch;
class RunStore {
    constructor(run, logIndex, filter, groupByAge, hideBaseline, showAge, showActions) {
        var _a;
        this.run = run;
        this.logIndex = logIndex;
        this.filter = filter;
        this.groupByAge = groupByAge;
        this.hideBaseline = hideBaseline;
        this.showAge = showAge;
        this.showActions = showActions;
        this.sortRuleBy = SortRuleBy.Count;
        this.sortColumnIndex = 1;
        this.sortOrder = Table_1.SortOrder.ascending;
        this.showAllRevision = 0;
        this.rulesTruncated = []; // Technically ITreeItem<Rule>[], ref assuming immutable array.
        const { driver } = run.tool;
        this.driverName = run.properties && run.properties['logFileName'] || driver.name.replace(/^Microsoft.CodeAnalysis.Sarif.PatternMatcher$/, 'CredScan on Push');
        const buildId = run.properties ? run.properties['buildId'] : 0;
        const artifactName = run.properties ? run.properties['artifactName'] : '';
        const filePath = run.properties ? run.properties['filePath'] : '';
        if (!run._augmented) {
            run._rulesInUse = new Map();
            run._agesInUse = new Map([
                ['Past SLA', { results: [], treeItem: null, name: 'Past SLA (31+ days)', isAge: true }],
                ['Within SLA', { results: [], treeItem: null, name: 'Within SLA (0 - 30 days)', isAge: true }],
            ]);
            const rules = driver.rules || [];
            const rulesListed = new Map(rules.map(rule => [rule.id, rule])); // Unable to express [[string, RuleEx]].
            let url;
            let repoDetails;
            try {
                url = (0, getRepoUri_1.getRepoUri)('-', run);
                repoDetails = (0, getRepositoryDetailsFromRemoteUrl_1.getRepositoryDetailsFromRemoteUrl)(url);
            }
            catch (TypeError) { }
            let resultIndex = 0;
            (_a = run.results) === null || _a === void 0 ? void 0 : _a.forEach(result => {
                var _a, _b, _c;
                // Collate by Rule
                const { ruleIndex } = result;
                const ruleId = (_a = result.ruleId) !== null && _a !== void 0 ? _a : '(No Rule)'; // Ignores 3.5.4 Hierarchical strings.
                if (!run._rulesInUse.has(ruleId)) {
                    // Need to generate rules for some like Microsoft.CodeAnalysis.Sarif.PatternMatcher.
                    const rule = ruleIndex !== undefined && rules[ruleIndex] || rulesListed.get(ruleId) || { id: ruleId };
                    rule.isRule = true;
                    rule.run = run; // For taxa.
                    run._rulesInUse.set(ruleId, rule);
                }
                const rule = run._rulesInUse.get(ruleId);
                // Try to build a 'Fix in VS Code' action
                if ((0, getRepositoryDetailsFromRemoteUrl_1.isRepositoryDetailsComplete)(repoDetails) && buildId && artifactName && filePath) {
                    const fixInVsCodeAction = {
                        text: 'Fix in VS Code',
                        linkUrl: `https://waveanalysis.microsoft.com/import?buildId=${buildId}&artifactName=${artifactName}&filePath=${filePath}&organization=${repoDetails.organizationName}&project=${repoDetails.projectName}&repoName=${repoDetails.repositoryName}&runIndex=${run._index}&resultIndex=${resultIndex++}&source=1esscans`,
                        imageName: 'vscode',
                        className: 'vscode-action'
                    };
                    result.actions = [
                        fixInVsCodeAction
                    ];
                }
                rule.results = rule.results || [];
                rule.results.push(result);
                // Collate by Age
                const firstDetection = (_b = result.provenance) === null || _b === void 0 ? void 0 : _b.firstDetectionTimeUtc;
                result.firstDetection = firstDetection ? new Date(firstDetection) : new Date();
                const age = (new Date().getTime() - result.firstDetection.getTime()) / (24 * 60 * 60 * 1000); // 1 day in milliseconds
                result.sla = age > 31 ? 'Past SLA' : 'Within SLA';
                run._agesInUse.get(result.sla).results.push(result);
                // Fill-in url from run.artifacts as needed.
                const artLoc = (0, try_1.tryOr)(() => result.locations[0].physicalLocation.artifactLocation);
                if (artLoc && artLoc.uri === undefined) {
                    const art = (0, try_1.tryOr)(() => run.artifacts[artLoc.index]);
                    artLoc.uri = (_c = art.location) === null || _c === void 0 ? void 0 : _c.uri;
                }
                result.run = run; // For result renderer to get to run.artifacts.
                result._rule = rule;
            });
            run._augmented = true;
        }
        (0, mobx_1.autorun)(() => {
            this.showAllRevision; // Read.
            const rules = this.groupByAge.get() // Slice to satisfy ref rulesTruncated.
                ? this.agesFiltered.slice()
                : this.rulesFiltered.slice();
            rules.forEach(ruleTreeItem => {
                const maxLength = 3;
                ruleTreeItem.childItems = !ruleTreeItem.isShowAll && ruleTreeItem.childItemsAll.length > maxLength
                    ? [
                        ...ruleTreeItem.childItemsAll.slice(0, maxLength),
                        { data: { onClick: () => {
                                    ruleTreeItem.isShowAll = true;
                                    this.showAllRevision++;
                                } } }
                    ]
                    : ruleTreeItem.childItemsAll;
            });
            this.rulesTruncated = rules;
        }, { name: 'Truncation' });
    }
    filterHelper(treeItems) {
        var _a, _b;
        const filter = this.filter.getState();
        const filterKeywords = ((_b = (_a = filter.Keywords) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '').toLowerCase().split(/\s+/).filter(part => part);
        const { sortColumnIndex, sortOrder } = this;
        treeItems.forEach(treeItem => {
            // if (!treeItem.hasOwnProperty('isShowAll')) extendObservable(treeItem, { isShowAll: false })
            treeItem.isShowAll = false;
            // Filtering logic: Show if 1) dropdowns match AND 2) any field matches text.
            const isDriverMatch = (0, exports.isMatch)(this.driverName.toLowerCase(), filterKeywords);
            const resultContainer = treeItem.data;
            treeItem.childItemsAll = resultContainer.results
                .filter(result => {
                var _a, _b;
                const { _rule } = result;
                const ruleId = _rule.id.toLowerCase();
                const ruleName = (_b = (_a = _rule.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
                const isRuleMatch = (0, exports.isMatch)(ruleId, filterKeywords) || (0, exports.isMatch)(ruleName, filterKeywords);
                for (const columnName in filter) {
                    if (columnName === 'Discussion')
                        continue; // Discussion filter does not apply to Results.
                    const selectedValues = filter[columnName].value;
                    if (!Array.isArray(selectedValues))
                        continue;
                    if (!selectedValues.length)
                        continue;
                    const map = {
                        Baseline: (result) => result.baselineState || 'new',
                        Level: (result) => result.level || 'warning',
                        Suppression: (result) => { var _a; return ((_a = result.suppressions) === null || _a === void 0 ? void 0 : _a.some(s => s.status === undefined || s.status === 'accepted')) ? 'suppressed' : 'unsuppressed'; },
                        Age: (result) => result.sla.toLowerCase(),
                    };
                    const translatedCellValue = map[columnName] ? map[columnName](result) : result;
                    if (!selectedValues.includes(translatedCellValue))
                        return false;
                }
                const isKeywordMatch = this.columns.some(column => {
                    const field = column.filterString(result).toLowerCase();
                    return (0, exports.isMatch)(field, filterKeywords);
                });
                return isDriverMatch || isRuleMatch || isKeywordMatch;
            })
                .map(result => ({ data: result })); // Can cache the result here.
            treeItem.childItemsAll.sort((treeItemLeft, treeItemRight) => {
                const resultToValue = this.columns[sortColumnIndex].sortString;
                const valueLeft = resultToValue(treeItemLeft.data);
                const valueRight = resultToValue(treeItemRight.data);
                const inverter = sortOrder === Table_1.SortOrder.ascending ? 1 : -1;
                return inverter * valueLeft.localeCompare(valueRight);
            });
            return treeItem;
        });
        const treeItemsVisible = treeItems.filter(rule => rule.childItemsAll.length);
        treeItemsVisible.sort(this.sortRuleBy === SortRuleBy.Count
            ? (a, b) => b.childItemsAll.length - a.childItemsAll.length
            : (a, b) => a.data.id.localeCompare(b.data.id));
        treeItemsVisible.forEach((rule, i) => rule.expanded = i === 0);
        return treeItemsVisible;
    }
    get agesFiltered() {
        const treeItems = [...this.run._agesInUse.values()]
            .map(age => {
            const treeItem = age.treeItem = age.treeItem || {
                data: age,
                expanded: false,
            };
            return treeItem;
        });
        return this.filterHelper(treeItems);
    }
    get rulesFiltered() {
        const treeItems = [...this.run._rulesInUse.values()]
            .map(rule => {
            const treeItem = rule.treeItem = rule.treeItem || {
                data: rule,
                expanded: false,
            };
            return treeItem;
        });
        return this.filterHelper(treeItems);
    }
    get filteredCount() {
        return this.rulesFiltered.reduce((total, rule) => total + rule.childItemsAll.length, 0);
    }
    get columns() {
        const columns = [
            {
                id: 'Path',
                filterString: (result) => (0, try_1.tryOr)(() => `${result.locations[0].logicalLocations[0].fullyQualifiedName} ${(0, try_1.tryOr)(() => {
                    const { index } = result.locations[0].physicalLocation.artifactLocation;
                    return result.run.artifacts[index].description.text;
                }, '')}`, () => result.locations[0].physicalLocation.artifactLocation.uri, ''),
                sortString: (result) => (0, try_1.tryOr)(() => result.locations[0].physicalLocation.artifactLocation.uri, '\u2014'),
                width: -3,
            }
        ];
        if (this.showAge && this.groupByAge.get()) {
            columns.push({
                id: 'Rule',
                filterString: (result) => {
                    var _a;
                    const rule = result._rule;
                    return `${rule.id || rule.guid} ${(_a = rule.name) !== null && _a !== void 0 ? _a : ''}`;
                },
                sortString: (result) => {
                    var _a;
                    const rule = result._rule;
                    return `${rule.id || rule.guid} ${(_a = rule.name) !== null && _a !== void 0 ? _a : ''}`;
                },
                width: -2,
            });
        }
        columns.push({
            id: 'Details',
            filterString: (result) => {
                // TODO: Support templated messages.
                const message = (0, try_1.tryOr)(() => result.message.markdown, () => result.message.text, // Can be a constant?
                '');
                const snippet = (0, try_1.tryOr)(() => result.locations[0].physicalLocation.contextRegion.snippet.text, () => result.locations[0].physicalLocation.region.snippet.text, '');
                return `${message} ${snippet}`;
            },
            sortString: (result) => result.message.text || '',
            width: -5,
        });
        if (this.showActions) {
            columns.push({
                id: 'Actions',
                filterString: (result) => '',
                sortString: (result) => '',
                width: -2,
            });
        }
        if (!this.hideBaseline) {
            columns.push({
                id: 'Baseline',
                filterString: (result) => result.baselineState || 'new',
                sortString: (result) => result.baselineState || 'new',
                width: -1,
            });
        }
        const hasWorkItemUris = this.run.results && this.run.results.some(result => result.workItemUris && !!result.workItemUris.length);
        if (hasWorkItemUris) {
            columns.push({
                id: 'Bug',
                filterString: (result) => '',
                sortString: (result) => '',
                width: -1,
            });
        }
        if (this.showAge && !this.groupByAge.get()) {
            columns.push({
                id: 'Age',
                filterString: (result) => result.sla,
                sortString: (result) => result.sla,
                width: -1,
            });
        }
        if (this.showAge) {
            columns.push({
                id: 'First Observed',
                filterString: (result) => result.firstDetection.toLocaleDateString(),
                sortString: (result) => result.firstDetection.getTime().toString(),
                width: -1,
            });
        }
        return columns;
    }
}
__decorate([
    mobx_1.observable
], RunStore.prototype, "sortRuleBy", void 0);
__decorate([
    mobx_1.observable
], RunStore.prototype, "sortColumnIndex", void 0);
__decorate([
    mobx_1.observable
], RunStore.prototype, "sortOrder", void 0);
__decorate([
    mobx_1.computed
], RunStore.prototype, "agesFiltered", null);
__decorate([
    mobx_1.computed
], RunStore.prototype, "rulesFiltered", null);
__decorate([
    mobx_1.computed
], RunStore.prototype, "filteredCount", null);
__decorate([
    mobx_1.observable
], RunStore.prototype, "showAllRevision", void 0);
__decorate([
    mobx_1.observable.ref
], RunStore.prototype, "rulesTruncated", void 0);
__decorate([
    mobx_1.computed
], RunStore.prototype, "columns", null);
exports.RunStore = RunStore;


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonGroup; });
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1);




var ButtonGroup = function (props) {
    return (react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { className: Object(_Util__WEBPACK_IMPORTED_MODULE_3__["css"])(props.className, "bolt-button-group flex-row rhythm-horizontal-8"), role: props.role }, props.children));
};


/***/ }),
/* 187 */
/***/ (function(module, exports) {



/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderCommandBar; });
/* unused harmony export HeaderCommandBarWithFilter */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _HeaderCommandBar_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(106);
/* harmony import */ var _HeaderCommandBar_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_HeaderCommandBar_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Core_Observable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14);
/* harmony import */ var _Menu__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56);
/* harmony import */ var _ResizeGroup__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(108);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1);
/* harmony import */ var _Utilities_Filter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33);
/* harmony import */ var _CustomHeaderCommandBar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85);
/* harmony import */ var _Items__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86);













var headerCommandBarId = 1;
var HeaderCommandBar = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(HeaderCommandBar, _super);
    function HeaderCommandBar(props) {
        var _this = _super.call(this, props) || this;
        _this.overflowButtonRef = react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
        _this.buttonRefs = {};
        _this.moreButtonId = props.moreButtonId || "header-command-bar-menu-button" + headerCommandBarId++;
        return _this;
    }
    HeaderCommandBar.prototype.render = function () {
        var _this = this;
        var _a;
        var items = this.props.items;
        var sortedItems = items.sort(function (a, b) {
            var _a, _b;
            var aRank = (_a = a.rank) !== null && _a !== void 0 ? _a : Number.MAX_VALUE;
            var bRank = (_b = b.rank) !== null && _b !== void 0 ? _b : Number.MAX_VALUE;
            return aRank > bRank ? 1 : aRank < bRank ? -1 : 0;
        });
        var defaultElementId = "";
        this.buttonRefs = {};
        var buttonItems = [];
        var overflowItems = [];
        var extraItems = [];
        var responsiveChildren = [];
        // Anything with important: true will be rendered as a button
        // Anything with important: false will be rendered in overflow
        // If buttonCount is supplied, that many buttons will be rendered into
        // a resizeGroup, and the rest will be overflow.  By default, buttonCount is 3.
        var buttonCount = (_a = this.props.buttonCount) !== null && _a !== void 0 ? _a : 3;
        var isMenuBar = !items.length || items[0].role !== "button";
        sortedItems.forEach(function (value, index) {
            var id = value.id;
            if (value.itemType === _Menu__WEBPACK_IMPORTED_MODULE_7__["MenuItemType"].Divider) {
                if (value.important) {
                    buttonItems.push(react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: "bolt-header-command-item-separator", key: id }));
                }
                else {
                    extraItems.push(value);
                }
            }
            else {
                var buttonProps = {
                    ariaChecked: _Core_Observable__WEBPACK_IMPORTED_MODULE_5__["ObservableLike"].getValue(value.checked),
                    ariaLabel: value.ariaLabel,
                    ariaRoleDescription: value.href ? "link" : "button",
                    ariaControls: value.ariaControls,
                    ariaDescribedBy: value.ariaDescribedBy,
                    ariaExpanded: value.ariaExpanded,
                    ariaHasPopup: value.ariaHasPopup,
                    ariaSetSize: value.ariaSetSize,
                    ariaPosInSet: value.ariaPosInSet,
                    ariaSelected: value.ariaSelected,
                    ariaPressed: value.ariaPressed,
                    className: Object(_Util__WEBPACK_IMPORTED_MODULE_9__["css"])(value.className, "bolt-header-command-item-button"),
                    disabled: value.disabled,
                    href: value.href,
                    iconProps: value.iconProps,
                    id: id,
                    primary: value.isPrimary,
                    role: value.role || "menuitem",
                    subtle: value.subtle,
                    target: value.target,
                    text: value.text,
                    tooltipProps: value.tooltipProps
                };
                if (value.important === false || (value.important === undefined && buttonCount === 0)) {
                    extraItems.push(value);
                    return;
                }
                else {
                    if (value.important === undefined) {
                        responsiveChildren.push(index);
                        overflowItems.push(value);
                    }
                    buttonCount--;
                }
                var TagName = _Button__WEBPACK_IMPORTED_MODULE_6__["Button"];
                var ref = react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
                _this.buttonRefs[id] = ref;
                if (value.subMenuProps) {
                    buttonProps.contextualMenuProps = { menuProps: value.subMenuProps };
                    buttonProps.hideDropdownIcon = value.hideDropdownIcon;
                    TagName = _Menu__WEBPACK_IMPORTED_MODULE_7__["MenuButton"];
                }
                else {
                    buttonProps.onClick = function (e) { return value.onActivate && value.onActivate(value, e); };
                }
                if (!defaultElementId && !value.disabled) {
                    defaultElementId = id;
                }
                if (value.renderButton) {
                    buttonItems.push(value.renderButton(buttonProps));
                }
                else {
                    buttonItems.push(react__WEBPACK_IMPORTED_MODULE_4__["createElement"](TagName, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, buttonProps, { key: id, ref: ref })));
                }
            }
        });
        buttonItems.push(react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_ResizeGroup__WEBPACK_IMPORTED_MODULE_8__["OverflowButton"], { className: Object(_Util__WEBPACK_IMPORTED_MODULE_9__["css"])(this.props.overflowClassName, "bolt-header-command-item-button"), id: this.moreButtonId, key: this.moreButtonId, role: "menuitem", ref: this.overflowButtonRef }));
        this.buttonRefs[this.moreButtonId] = this.overflowButtonRef;
        // We will use a role of "menubar", unless the first item has a role of button.
        // This will be the case the close button in Panel Headers.
        if (items.length > 0) {
            return (react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_CustomHeaderCommandBar__WEBPACK_IMPORTED_MODULE_11__[/* CustomHeaderCommandBar */ "a"], { className: this.props.className, focusGroupProps: { defaultElementId: defaultElementId || this.moreButtonId }, role: isMenuBar ? "menubar" : undefined },
                react__WEBPACK_IMPORTED_MODULE_4__["createElement"](_ResizeGroup__WEBPACK_IMPORTED_MODULE_8__["ResizeGroup"], { responsiveLayoutProps: { responsiveChildren: responsiveChildren.reverse() }, overflowMenuItems: overflowItems.reverse(), extraItems: extraItems },
                    react__WEBPACK_IMPORTED_MODULE_4__["createElement"]("div", { className: Object(_Util__WEBPACK_IMPORTED_MODULE_9__["css"])(this.props.className, "flex-row flex-center flex-grow scroll-hidden rhythm-horizontal-8") }, buttonItems))));
        }
        return null;
    };
    HeaderCommandBar.prototype.focus = function (options) {
        var ref = this.buttonRefs[options.commandBarItemId];
        if (ref && ref.current) {
            ref.current.focus();
        }
    };
    return HeaderCommandBar;
}(react__WEBPACK_IMPORTED_MODULE_4__["Component"]));

var HeaderCommandBarWithFilter = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(HeaderCommandBarWithFilter, _super);
    function HeaderCommandBarWithFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.headerCommandBarRef = react__WEBPACK_IMPORTED_MODULE_4__["createRef"]();
        _this.onFilterClicked = function () {
            _this.props.filterToggled.value = !_this.props.filterToggled.value;
        };
        _this.onFilterChanged = function () {
            var hasChanges = _this.props.filter.hasChangesToReset();
            if (hasChanges !== _this.state.filterHasChanges) {
                _this.setState({
                    filterHasChanges: hasChanges
                });
            }
        };
        _this.state = { filterHasChanges: _this.props.filter.hasChangesToReset() };
        return _this;
    }
    HeaderCommandBarWithFilter.prototype.componentDidMount = function () {
        this.props.filter.subscribe(this.onFilterChanged, _Utilities_Filter__WEBPACK_IMPORTED_MODULE_10__["FILTER_CHANGE_EVENT"]);
    };
    HeaderCommandBarWithFilter.prototype.componentWillUnmount = function () {
        this.props.filter.unsubscribe(this.onFilterChanged, _Utilities_Filter__WEBPACK_IMPORTED_MODULE_10__["FILTER_CHANGE_EVENT"]);
    };
    HeaderCommandBarWithFilter.prototype.render = function () {
        var items = this.props.items ? Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spreadArrays */ "d"])(this.props.items) : [];
        items.push(Object(_Items__WEBPACK_IMPORTED_MODULE_12__[/* getFilterItem */ "a"])(this.onFilterClicked, this.state.filterHasChanges));
        return react__WEBPACK_IMPORTED_MODULE_4__["createElement"](HeaderCommandBar, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.props, { items: items, ref: this.headerCommandBarRef }));
    };
    HeaderCommandBarWithFilter.prototype.focus = function (options) {
        if (this.headerCommandBarRef.current) {
            this.headerCommandBarRef.current.focus(options);
        }
    };
    return HeaderCommandBarWithFilter;
}(react__WEBPACK_IMPORTED_MODULE_4__["Component"]));



/***/ }),
/* 189 */
/***/ (function(module, exports) {



/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverflowButton; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Menu_MoreButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8);
/* harmony import */ var _ResizeGroup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88);







var OverflowButton = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(OverflowButton, _super);
    function OverflowButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.moreButton = react__WEBPACK_IMPORTED_MODULE_3__["createRef"]();
        return _this;
    }
    OverflowButton.prototype.render = function () {
        var _this = this;
        return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_ResizeGroup__WEBPACK_IMPORTED_MODULE_6__[/* ResizeGroupContext */ "b"].Consumer, null, function (resizeGroupContext) {
            return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Observer__WEBPACK_IMPORTED_MODULE_5__["Observer"], { menuItems: resizeGroupContext.overflowItems }, function (props) {
                return props.menuItems && props.menuItems.length > 0 ? (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Menu_MoreButton__WEBPACK_IMPORTED_MODULE_4__[/* MoreButton */ "a"], Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({ contextualMenuProps: {
                        menuProps: { id: "overflow-menu", items: props.menuItems }
                    }, ref: _this.moreButton }, _this.props))) : (react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", null));
            }));
        }));
    };
    OverflowButton.prototype.focus = function () {
        if (this.moreButton.current) {
            this.moreButton.current.focus();
        }
    };
    return OverflowButton;
}(react__WEBPACK_IMPORTED_MODULE_3__["Component"]));



/***/ }),
/* 191 */
/***/ (function(module, exports) {



/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardFooter; });
/* harmony import */ var _CommonImports__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _Core_core_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Core_core_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Card_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73);
/* harmony import */ var _Card_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Card_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Surface__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18);
/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1);






var CardFooter = function (props) {
    return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_Surface__WEBPACK_IMPORTED_MODULE_4__["SurfaceContext"].Consumer, null, function (surfaceContext) { return (react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { className: Object(_Util__WEBPACK_IMPORTED_MODULE_5__["css"])(props.className, "bolt-card-footer flex-row flex-noshrink", surfaceContext.horizontalClassName) }, props.children)); }));
};


/***/ }),
/* 193 */
/***/ (function(module, exports) {



/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(395);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Card_Card; });

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Card/Card.css
var Card = __webpack_require__(73);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Button.js
var Button = __webpack_require__(14);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Header/Header.css
var Header_Header = __webpack_require__(38);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Surface.js + 2 modules
var Surface = __webpack_require__(18);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Header/CustomHeader.js







var CustomHeader_CustomHeader = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(CustomHeader, _super);
    function CustomHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomHeader.prototype.render = function () {
        var _this = this;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Surface["SurfaceContext"].Consumer, null, function (surfaceContext) {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](external_commonjs_react_commonjs2_react_amd_React_root_React_["Fragment"], null,
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(_this.props.className, "bolt-header flex-row flex-noshrink flex-start", surfaceContext.horizontalClassName, surfaceContext.spacing === undefined && "bolt-header-no-spacing-defined", surfaceContext.spacing === Surface["Spacing"].condensed && "bolt-header-condensed", surfaceContext.spacing === Surface["Spacing"].default && "bolt-header-default", surfaceContext.spacing === Surface["Spacing"].relaxed && "bolt-header-relaxed") }, _this.props.children),
                _this.props.separator && external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-header-separator flex-noshrink" })));
        }));
    };
    return CustomHeader;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Util/Screen.js
var Screen = __webpack_require__(32);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Icon.js + 2 modules
var Icon = __webpack_require__(9);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Resources.Page.js
var Resources_Page = __webpack_require__(43);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Utilities/ScreenSize.js
var ScreenSize = __webpack_require__(91);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Header/HeaderBackButton.js











function HeaderBackButton(props) {
    var buttonProps = props.buttonProps;
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](ScreenSize["b" /* ScreenSizeObserver */], null, function (screenSizeProps) {
        var smallScreen = screenSizeProps.screenSize === Screen["c" /* ScreenSize */].xsmall;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Button["Button"], Object(tslib_es6["a" /* __assign */])({ ariaLabel: Resources_Page["a" /* Back */], iconProps: {
                iconName: "Back",
                size: smallScreen ? Icon["IconSize"].small : undefined
            }, subtle: true }, buttonProps, { text: smallScreen ? (buttonProps.text ? buttonProps.text : Resources_Page["a" /* Back */]) : undefined, className: Object(Util["css"])(buttonProps.className, "bolt-header-back-button justify-end") })));
    }));
}

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Header/HeaderDescription.js






var HeaderDescription_HeaderDescription = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(HeaderDescription, _super);
    function HeaderDescription() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderDescription.prototype.render = function () {
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(this.props.className, "bolt-header-description body-m secondary-text"), id: Object(Util["getSafeId"])(this.props.id) }, this.props.children));
    };
    return HeaderDescription;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Header/Header.Props.js
var TitleSize;
(function (TitleSize) {
    TitleSize[TitleSize["Medium"] = 0] = "Medium";
    TitleSize[TitleSize["Large"] = 1] = "Large";
    TitleSize[TitleSize["Small"] = 2] = "Small";
})(TitleSize || (TitleSize = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Header/HeaderIcon.js








var HeaderIcon_HeaderIcon = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(HeaderIcon, _super);
    function HeaderIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderIcon.prototype.render = function () {
        var titleSizeClass = undefined;
        switch (this.props.titleSize) {
            case TitleSize.Large:
                titleSizeClass = "l";
                break;
            case TitleSize.Small:
                titleSizeClass = "s";
                break;
            case TitleSize.Medium:
            default:
                titleSizeClass = "m";
        }
        return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(this.props.className, "bolt-header-icon", titleSizeClass) }, Object(Icon["Icon"])(this.props.iconProps));
    };
    return HeaderIcon;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// EXTERNAL MODULE: ./node_modules/azure-devops-ui/TooltipEx.js
var TooltipEx = __webpack_require__(19);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Header/HeaderTitle.js







function HeaderTitle(props) {
    var _a = props.ariaLevel, ariaLevel = _a === void 0 ? 1 : _a, id = props.id;
    var titleSizeClass = undefined;
    switch (props.titleSize) {
        case TitleSize.Large:
            titleSizeClass = "title-m l";
            break;
        case TitleSize.Small:
            titleSizeClass = "title-xs s";
            break;
        case TitleSize.Medium:
        default:
            titleSizeClass = "body-xl m";
    }
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TooltipEx["Tooltip"], { overflowOnly: true },
        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { "aria-level": ariaLevel, className: Object(Util["css"])(props.className, "bolt-header-title", titleSizeClass), id: Object(Util["getSafeId"])(id), role: "heading" }, props.children)));
}

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Header/HeaderTitleArea.js






var HeaderTitleArea_HeaderTitleArea = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(HeaderTitleArea, _super);
    function HeaderTitleArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderTitleArea.prototype.render = function () {
        return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(this.props.className, "bolt-header-title-area flex-column flex-grow scroll-hidden") }, this.props.children);
    };
    return HeaderTitleArea;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Header/HeaderTitleRow.js






var HeaderTitleRow_HeaderTitleRow = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(HeaderTitleRow, _super);
    function HeaderTitleRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderTitleRow.prototype.render = function () {
        return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(this.props.className, "bolt-header-title-row flex-row flex-baseline") }, this.props.children);
    };
    return HeaderTitleRow;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Observable.js
var Observable = __webpack_require__(4);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Breakpoint.js
var Breakpoint = __webpack_require__(57);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/HeaderCommandBar.js
var HeaderCommandBar = __webpack_require__(202);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Observer.js
var Observer = __webpack_require__(8);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Tabs.js + 10 modules
var Tabs = __webpack_require__(66);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Header/Header.js


















var Header_Header_Header = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this.breakpointIndex = 0;
        _this.headerCommandBarRef = external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"]();
        _this.onBreakPoint = function (index, breakpoint) {
            _this.breakpointIndex = index;
            // This is making sure that command bar items are made visible after getting notified
            // for the exact breakpoint. Otherwise, there is flickering from default to current breakpoint.
            // If there are no breakpoints specified, actions are rendered at first place.
            _this.commandBarClassName.value = Object(Util["css"])(_this.props.commandBarClassName, "flex-self-start");
        };
        _this.commandBarClassName = new Observable["ObservableValue"](Object(Util["css"])(props.commandBarClassName, "flex-self-start", !!props.headerBreakpoints && "invisible"));
        return _this;
    }
    Header.prototype.render = function () {
        var _this = this;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Tabs["c" /* TabProviderContext */].Consumer, null, function (tabProviderContext) {
            var _a = _this.props, backButtonProps = _a.backButtonProps, buttonCount = _a.buttonCount, className = _a.className, contentClassName = _a.contentClassName, commandBarMoreButtonId = _a.commandBarMoreButtonId, description = _a.description, descriptionClassName = _a.descriptionClassName, descriptionId = _a.descriptionId, headerBreakpoints = _a.headerBreakpoints, title = _a.title, titleAriaLevel = _a.titleAriaLevel, titleClassName = _a.titleClassName, titleIconProps = _a.titleIconProps, titleId = _a.titleId, titleSize = _a.titleSize;
            var commandBarItems = _this.props.commandBarItems || tabProviderContext.commandBarItems;
            var commandBarComponent = undefined;
            if (commandBarItems) {
                commandBarComponent = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { items: commandBarItems, className: _this.commandBarClassName }, function (props) {
                    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](HeaderCommandBar["HeaderCommandBar"], { buttonCount: buttonCount, className: props.className, items: _this.getUpdatedCommandBarItems(props.items), moreButtonId: commandBarMoreButtonId, ref: _this.headerCommandBarRef }));
                }));
            }
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](external_commonjs_react_commonjs2_react_amd_React_root_React_["Fragment"], null,
                headerBreakpoints && (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Breakpoint["Breakpoint"], { breakpoints: headerBreakpoints.map(function (hbp) { return hbp.breakpoint; }), onBreakpoint: _this.onBreakPoint })),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](CustomHeader_CustomHeader, { className: Object(Util["css"])(className, commandBarItems && commandBarItems.length > 0 && "bolt-header-with-commandbar", backButtonProps && "bolt-header-with-back-button"), separator: _this.props.separator },
                    backButtonProps && external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](HeaderBackButton, { buttonProps: backButtonProps }),
                    external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(contentClassName, "bolt-header-content-area flex-row flex-grow flex-self-stretch") },
                        titleIconProps && external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](HeaderIcon_HeaderIcon, { iconProps: titleIconProps, titleSize: titleSize }),
                        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](HeaderTitleArea_HeaderTitleArea, null,
                            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](HeaderTitleRow_HeaderTitleRow, null, title && (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](HeaderTitle, { ariaLevel: titleAriaLevel, className: titleClassName, id: titleId, titleSize: titleSize }, title))),
                            description && (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](HeaderDescription_HeaderDescription, { className: descriptionClassName, id: descriptionId }, description)),
                            _this.props.children),
                        commandBarComponent))));
        }));
    };
    Header.prototype.focus = function (options) {
        if (this.headerCommandBarRef.current) {
            this.headerCommandBarRef.current.focus(options);
        }
    };
    Header.prototype.getUpdatedCommandBarItems = function (sourceCommandBarItems) {
        var headerBreakpoints = this.props.headerBreakpoints;
        var breakpoint = headerBreakpoints ? headerBreakpoints[Math.max(0, this.breakpointIndex)] : null;
        if (breakpoint) {
            var _a = breakpoint.commandBarItems, commandBarItems = _a === void 0 ? [] : _a;
            // Update if there are actions changing their look for this breakpoint
            if (commandBarItems.length > 0) {
                // Convert actions to a map to access later quickly
                var commandBarItemsMap_1 = {};
                commandBarItems.forEach(function (item) { return (commandBarItemsMap_1[item.id] = item); });
                var targetCommandBarItems = [];
                for (var _i = 0, sourceCommandBarItems_1 = sourceCommandBarItems; _i < sourceCommandBarItems_1.length; _i++) {
                    var commandBarItem = sourceCommandBarItems_1[_i];
                    var changedItem = commandBarItemsMap_1[commandBarItem.id];
                    if (changedItem) {
                        // Update command bar item with the specified properties
                        targetCommandBarItems.push(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, commandBarItem), changedItem));
                    }
                    else {
                        // If there is no change requested, use the same item
                        targetCommandBarItems.push(Object(tslib_es6["a" /* __assign */])({}, commandBarItem));
                    }
                }
                return targetCommandBarItems;
            }
        }
        return sourceCommandBarItems;
    };
    return Header;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Header.js










// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Resources.Card.js
var CollapseButtonAriaLabel = "Collapse";
var ExpandButtonAriaLabel = "Expand";

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Card/CardContent.js
var CardContent = __webpack_require__(62);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Card/CustomCard.js
var CustomCard = __webpack_require__(87);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Card/Card.js













var Card_Card = function (props) {
    var collapsible = props.collapsible, _a = props.collapsed, collapsed = _a === void 0 ? false : _a, _b = props.titleProps, titleProps = _b === void 0 ? {} : _b, headerCommandBarItems = props.headerCommandBarItems, onCollapseClick = props.onCollapseClick, renderHeader = props.renderHeader;
    var text = titleProps.text;
    var divId = Object(Util["getSafeId"])("card-header-row");
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](CustomCard["a" /* CustomCard */], { className: Object(Util["css"])(props.className, (text || headerCommandBarItems) && "bolt-card-with-header") }, collapsible ? (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { collapsed: collapsed }, function (observerProps) { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](external_commonjs_react_commonjs2_react_amd_React_root_React_["Fragment"], null,
        (text || headerCommandBarItems || renderHeader) && (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "flex-row", id: divId },
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Button["Button"], { ariaExpanded: !observerProps.collapsed, ariaLabelledBy: divId, subtle: true, iconProps: { iconName: observerProps.collapsed ? "ChevronRightMed" : "ChevronDownMed", size: Icon["IconSize"].small }, className: "bolt-card-expand-button flex-self-start", onClick: onCollapseClick, tooltipProps: {
                    text: !observerProps.collapsed ? CollapseButtonAriaLabel : ExpandButtonAriaLabel
                } }),
            renderHeader ? (renderHeader()) : (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](CardHeader, Object(tslib_es6["a" /* __assign */])({}, props, { headerClassName: Object(Util["css"])(props.headerClassName, "bolt-card-expandable-header", observerProps.collapsed && "bolt-card-header-collapsed") }))))),
        !observerProps.collapsed && external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](CardContent["a" /* CardContent */], Object(tslib_es6["a" /* __assign */])({}, props.contentProps), props.children))); })) : (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](external_commonjs_react_commonjs2_react_amd_React_root_React_["Fragment"], null,
        renderHeader ? renderHeader() : (text || headerCommandBarItems) && external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](CardHeader, Object(tslib_es6["a" /* __assign */])({}, props)),
        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](CardContent["a" /* CardContent */], Object(tslib_es6["a" /* __assign */])({}, props.contentProps), props.children)))));
};
var CardHeader = function (props) {
    var collapsible = props.collapsible, _a = props.titleProps, titleProps = _a === void 0 ? {} : _a, headerBreakpoints = props.headerBreakpoints, headerClassName = props.headerClassName, headerCommandBarItems = props.headerCommandBarItems, _b = props.headerDescriptionProps, headerDescriptionProps = _b === void 0 ? {} : _b, headerIconProps = props.headerIconProps;
    var text = titleProps.text, className = titleProps.className, id = titleProps.id, size = titleProps.size, ariaLevel = titleProps.ariaLevel;
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Header_Header_Header, { className: Object(Util["css"])(headerClassName, "bolt-card-header", collapsible && "bolt-card-header-collapsible"), commandBarClassName: "justify-end", commandBarItems: headerCommandBarItems, description: headerDescriptionProps.text, descriptionClassName: headerDescriptionProps.className, headerBreakpoints: headerBreakpoints, titleId: id, titleIconProps: headerIconProps, title: text, titleAriaLevel: ariaLevel, titleClassName: className, titleSize: size }));
};


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ColumnFill; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ Table_Table_Table; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ renderColumns; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ Table_TableHeaderCell; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ TableRow; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ TableLoadingRow; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ TableCell; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ SimpleTableCell; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ TwoLineTableCell; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ renderEmptyCell; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ renderSimpleCell; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ renderSimpleCellValue; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ renderLoadingCell; });

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Table/Table.css
var Table_Table = __webpack_require__(58);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Observable.js
var Observable = __webpack_require__(4);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Util/Accessibility.js
var Accessibility = __webpack_require__(15);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Util/String.js
var Util_String = __webpack_require__(16);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/FocusOrMouseWithin.js
var FocusOrMouseWithin = __webpack_require__(199);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/FocusWithin.js
var FocusWithin = __webpack_require__(23);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/FocusZone.js + 2 modules
var FocusZone = __webpack_require__(7);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Icon.js + 2 modules
var Icon = __webpack_require__(9);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Intersection.js
var Intersection = __webpack_require__(34);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Link.js
var Link = __webpack_require__(30);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/List.js
var List = __webpack_require__(21);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Observer.js
var Observer = __webpack_require__(8);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Resources.Widgets.js
var Resources_Widgets = __webpack_require__(20);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Sizer/Sizer.css
var Sizer_Sizer = __webpack_require__(247);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/TimerManagement.js
var TimerManagement = __webpack_require__(41);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Portal.js
var Portal = __webpack_require__(55);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Sizer/Sizer.Props.js
/**
 * The orientiation of a the Sizer defines whether or not it is being used
 * in a row or column of components. This is used to determine if the
 * component is sizing on the X axis (horizontally) or Y axis (vertically).
 */
var Orientation;
(function (Orientation) {
    /**
     * Sizes on the X axis, left - right.
     */
    Orientation[Orientation["row"] = 0] = "row";
    /**
     * Sizes on the Y axis top - bottom.
     */
    Orientation[Orientation["column"] = 1] = "column";
})(Orientation || (Orientation = {}));
/**
 * Position should be defined as where the Sized component being managed
 * by the Sizer is in relationship. If the Sized component comes after
 * the Sizer is should be set to Far, otherwise Near.
 */
var Position;
(function (Position) {
    /**
     * The Sized component appears before the Sizer.
     */
    Position[Position["near"] = 0] = "near";
    /**
     * The Sized component appears after the Sizer.
     */
    Position[Position["far"] = 1] = "far";
})(Position || (Position = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Sizer/Sizer.js














var Sizer_Sizer_Sizer = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(Sizer, _super);
    function Sizer(props) {
        var _this = _super.call(this, props) || this;
        _this.lastLocation = -1;
        _this.timerManagement = new TimerManagement["a" /* TimerManagement */]();
        _this.state = { showPortal: false };
        _this.onMouseCapture = function (event) {
            // Recompute the size and update the lastLocation based on the amount changed.
            _this.lastLocation += _this.updateSize(event, _this.getMouseLocation(event) - _this.lastLocation);
            // Remove the portal now that we are no longer sizing.
            if (event.type === "mouseup") {
                _this.setState({ showPortal: false });
                // If the user wanted to know when the sizing was complete, we will notify
                // the now that sizing is complete.
                _this.onSizeEnd();
            }
        };
        _this.onKeyDown = function (event) {
            var _a;
            if (!event.defaultPrevented) {
                var orientation_1 = _this.props.orientation;
                var sizeChange = void 0;
                if (orientation_1 === Orientation.row) {
                    if (event.which === Util["KeyCode"].enter) {
                        var focuselt = _this.props.getFocusedElement(event);
                        (_a = focuselt === null || focuselt === void 0 ? void 0 : focuselt.current) === null || _a === void 0 ? void 0 : _a.focus();
                    }
                    if (event.which === Util["KeyCode"].leftArrow) {
                        sizeChange = _this.updateSize(event.nativeEvent, -1);
                    }
                    else if (event.which === Util["KeyCode"].rightArrow) {
                        sizeChange = _this.updateSize(event.nativeEvent, 1);
                    }
                }
                else {
                    if (event.which === Util["KeyCode"].upArrow) {
                        sizeChange = _this.updateSize(event.nativeEvent, -1);
                    }
                    else if (event.which === Util["KeyCode"].downArrow) {
                        sizeChange = _this.updateSize(event.nativeEvent, 1);
                    }
                }
                // If we changed the size, we will prevent the default and start a
                // timer to end the sizing operation. Since there is no gesture to
                // start and complete with the keyboard.
                if (sizeChange) {
                    event.preventDefault();
                    _this.debouncedEnd();
                }
            }
        };
        _this.onSizeEnd = function () {
            if (_this.props.onSizeEnd) {
                _this.props.onSizeEnd(_this.props.id);
            }
        };
        _this.onMouseDown = function (event) {
            if (!event.defaultPrevented) {
                _this.lastLocation = _this.getMouseLocation(event.nativeEvent);
                // Capture the mouse, this will let us size the column even when the mouse moves
                // outside our element.
                Util["Mouse"].setCapture(_this.onMouseCapture);
                // Show the portal that keeps our sizing actions for effecting the other elements.
                _this.setState({ showPortal: true });
                // Don't let the event set focus or start a mouse selection.
                event.preventDefault();
            }
        };
        _this.onFocus = function (event) {
            Object(Accessibility["a" /* announce */])(Object(Util_String["a" /* format */])(Resources_Widgets["p" /* SizerLabel */], _this.props.size, _this.props.minSize, _this.props.maxSize), true);
        };
        _this.debouncedEnd = _this.timerManagement.debounce(_this.onSizeEnd, 500, { trailing: true });
        return _this;
    }
    Sizer.prototype.render = function () {
        var divider = this.props.divider;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { "aria-label": this.props.ariaLabel, "aria-valuemin": this.props.minSize, "aria-valuemax": this.props.maxSize, "aria-valuenow": Observable["ObservableLike"].getValue(this.props.size), className: Object(Util["css"])(this.props.className, "bolt-sizer", this.props.orientation === Orientation.row ? "bolt-sizer-row flex-row" : "bolt-sizer-column flex-column", divider && "divider"), id: this.props.id, onKeyDown: this.onKeyDown, onMouseDown: this.onMouseDown, role: "separator", tabIndex: this.props.tabIndex, onFocus: this.onFocus }, this.state.showPortal && (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Portal["Portal"], { className: Object(Util["css"])("bolt-sizer-portal", this.props.orientation === Orientation.row ? "bolt-sizer-portal-row" : "bolt-sizer-portal-column") },
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", null)))));
    };
    Sizer.prototype.componentWillUnmount = function () {
        Util["Mouse"].releaseCapture(this.onMouseCapture);
        this.timerManagement.dispose();
    };
    Sizer.prototype.getMouseLocation = function (event) {
        return this.props.orientation === Orientation.row ? event.pageX : event.pageY;
    };
    Sizer.prototype.updateSize = function (event, sizeChange) {
        // Compute the udpated size of the Sized element.
        var currentSize = Observable["ObservableLike"].getValue(this.props.size);
        var multiplier = this.props.position === Position.far ? -1 : 1;
        var updatedSize = Math.floor(Math.min(this.props.maxSize, Math.max(this.props.minSize, currentSize + sizeChange * multiplier)));
        // Notify the caller of the updated size.
        this.props.onSize(event, updatedSize, this.props.id);
        Object(Accessibility["a" /* announce */])(Object(Util_String["a" /* format */])(Resources_Widgets["q" /* SizerValueChanged */], updatedSize), true);
        // console.log("currentSize = " + currentSize + " updateSize = " + updatedSize);
        return (updatedSize - currentSize) * multiplier;
    };
    Sizer.defaultProps = {
        divider: true,
        maxSize: 10000,
        minSize: 100
    };
    return Sizer;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));

/**
 * The Sized function is used to produce a div that has a fixed width or height
 * based on the orientation of the sized props. This is a basic component that
 * can be used with the Sizer to produce a basic splitter like UI.
 *
 * @param props properties to render the appropriate container element given the
 * props.
 */
function Sized(props) {
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { height: props.height, width: props.width }, function (observedProps) {
        var style = {};
        // Add any specific height that has been defined.
        if (observedProps.height !== undefined) {
            style.height = observedProps.height + "px";
        }
        // Add any specific width that has been defined.
        if (observedProps.width !== undefined) {
            style.width = observedProps.width + "px";
        }
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(props.className, "flex-noshrink"), style: style }, props.children));
    }));
}

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Sizer.js



// EXTERNAL MODULE: ./node_modules/azure-devops-ui/TooltipEx.js
var TooltipEx = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Utilities/Dispatch.js
var Dispatch = __webpack_require__(54);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Utilities/Focus.js + 1 modules
var Focus = __webpack_require__(26);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Utilities/ScreenSize.js
var ScreenSize = __webpack_require__(91);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Table/Table.Props.js
var Table_Props = __webpack_require__(13);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Table/TableBreakpoint.js
var TableBreakpoint = __webpack_require__(80);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Table/Table.js

























/**
 * ColumnFill is used to fill the remaining space in the parent element with an
 * empty column. This column can be used anywhere in the column order. Columns
 * that appear after this will be pushed to the right.
 */
var ColumnFill = {
    columnLayout: Table_Props["d" /* TableColumnLayout */].none,
    id: "_fill",
    renderCell: function (rowIndex, columnIndex) {
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("td", { key: "col-fill", "aria-colindex": columnIndex + 1, "aria-hidden": true, className: Object(Util["css"])("bolt-table-cell bolt-list-cell", "col-" + columnIndex), "data-column-index": columnIndex, role: "presentation" }));
    },
    renderHeaderCell: function (columnIndex, tableColumn) {
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("th", { key: "col-fill", "aria-hidden": true, className: Object(Util["css"])(tableColumn.headerClassName, "bolt-table-header-cell bolt-table-header-cell-empty", "col-header-" + columnIndex), "data-column-index": columnIndex, role: "presentation" }));
    },
    width: -100
};
/**
 * The Table is a multi-column List component with an optional header.
 */
var Table_Table_Table = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(Table, _super);
    function Table(props) {
        var _this = _super.call(this, props) || this;
        // Reference to the underlying list interface.
        _this.list = external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"]();
        _this.onBreakpoint = function () {
            var visibleColumnsKey = _this.props.tableBreakpoints
                ? getVisibleColumnsAndIndices(_this.props.columns)
                    .map(function (_a) {
                    var originalIndex = _a.originalIndex;
                    return originalIndex;
                })
                    .join(",")
                : "";
            // If any column has toggled its visibility, we have to re-render.
            if (_this.state.renderInvisible || _this.state.visibleColumnsKey !== visibleColumnsKey) {
                _this.setState({ renderInvisible: false, visibleColumnsKey: visibleColumnsKey });
            }
        };
        _this.onColumnsChanged = function () {
            _this.forceUpdate();
            return false;
        };
        _this.renderHeader = function () {
            var _a = _this.props, columns = _a.columns, showHeader = _a.showHeader, renderHeader = _a.renderHeader, spacerWidth = _a.spacerWidth;
            var widths = [];
            var proportionalTotal = 0;
            // Determine the percentage for proportionally sized columns.
            for (var columnIndex = 0; columnIndex < columns.length; columnIndex++) {
                var width = Observable["ObservableLike"].getValue(columns[columnIndex].width);
                if (width < 0) {
                    proportionalTotal += width;
                }
            }
            // Compute the width of all columns based on the fixed/proportional values
            for (var columnIndex = 0; columnIndex < columns.length; columnIndex++) {
                var width = Observable["ObservableLike"].getValue(columns[columnIndex].width);
                widths[columnIndex] = width >= 0 ? width : -((width / proportionalTotal) * 100);
            }
            var header = null;
            // 0 is a valid ScreenSize, so we have strict inequality checking here
            if (showHeader !== false) {
                header = renderHeader ? renderHeader(columns) : external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Table_TableHeader, { tableColumns: columns });
            }
            if (typeof showHeader === "function") {
                header = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](ScreenSize["a" /* ScreenSizeConditional */], { condition: function (screenSize) { return showHeader(screenSize); } }, header);
            }
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](external_commonjs_react_commonjs2_react_amd_React_root_React_["Fragment"], null,
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("colgroup", null,
                    external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("col", { "aria-hidden": "true", key: "col-group-left-spacer", style: { width: spacerWidth === 0 ? spacerWidth + "%" : spacerWidth + "px" } }),
                    getVisibleColumnsAndIndices(columns).map(function (_a) {
                        var column = _a.column, originalIndex = _a.originalIndex;
                        var _b = column.widthStyle, widthStyle = _b === void 0 ? Table_Props["b" /* IMeasurementStyle */].Pixel : _b;
                        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { key: "col-group-" + originalIndex, width: {
                                filter: _this.onColumnsChanged,
                                observableValue: column.width
                            } }, function () { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("col", { style: {
                                width: Math.abs(widths[originalIndex]) +
                                    (widths[originalIndex] < 0 ? "%" : widthStyle === Table_Props["b" /* IMeasurementStyle */].Pixel ? "px" : "rem")
                            } })); }));
                    }),
                    external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("col", { "aria-hidden": "true", key: "col-group-right-spacer", style: { width: spacerWidth === 0 ? spacerWidth + "%" : spacerWidth + "px" } })),
                header));
        };
        _this.renderLoadingRow = function (rowIndex, details) {
            var _a;
            var _b = _this.props, columns = _b.columns, renderLoadingRow = _b.renderLoadingRow;
            var rowDetails = {
                ariaBusy: true,
                ariaRowOffset: details.ariaRowOffset,
                data: details.data,
                eventDispatch: _this.state.eventDispatch,
                excludeFocusZone: true,
                excludeTabStop: (_a = _this.props.excludeTabStop) !== null && _a !== void 0 ? _a : details.excludeTabStop,
                itemProvider: _this.props.itemProvider,
                listProps: details.listProps,
                onFocusItem: details.onFocusItem,
                renderSpacer: _this.props.renderSpacer,
                selection: _this.props.selection,
                singleClickActivation: _this.props.onActivate && _this.props.singleClickActivation
            };
            // If a custom row loading animation is available use it.
            if (renderLoadingRow) {
                return renderLoadingRow(rowIndex, rowDetails);
            }
            return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TableLoadingRow, { columns: columns, details: rowDetails, rowIndex: rowIndex });
        };
        _this.renderRow = function (rowIndex, item, details) {
            var _a;
            var rowDetails = {
                selectableText: details.selectableText,
                ariaRowOffset: details.ariaRowOffset,
                eventDispatch: _this.state.eventDispatch,
                data: details.data,
                excludeTabStop: (_a = _this.props.excludeTabStop) !== null && _a !== void 0 ? _a : details.excludeTabStop,
                itemProvider: _this.props.itemProvider,
                listProps: details.listProps,
                onFocusItem: details.onFocusItem,
                renderSpacer: _this.props.renderSpacer,
                selection: _this.props.selection,
                singleClickActivation: _this.props.onActivate && _this.props.singleClickActivation
            };
            // First determine if the item supplied a custom row rendering function, if not
            // attempt to use the global row rendering function.
            var renderRow = item.renderRow || _this.props.renderRow;
            if (renderRow) {
                return renderRow(rowIndex, item, rowDetails);
            }
            // If no custom row renderer is available use the default row renderer.
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TableRow, { details: rowDetails, index: rowIndex, linkProps: item.linkProps }, renderColumns(rowIndex, _this.props.columns, item, rowDetails)));
        };
        _this.state = {
            columnBehaviors: [],
            eventDispatch: props.eventDispatch || new Dispatch["a" /* EventDispatch */](),
            renderInvisible: !!props.tableBreakpoints,
            visibleColumnsKey: "",
            tableBehaviors: [],
            tableWidth: ""
        };
        // Initialize any column behaviors.
        for (var columnIndex = 0; columnIndex < props.columns.length; columnIndex++) {
            var tableColumn = props.columns[columnIndex];
            if (tableColumn.behaviors) {
                for (var _i = 0, _a = tableColumn.behaviors; _i < _a.length; _i++) {
                    var behavior = _a[_i];
                    if (behavior && behavior.initialize) {
                        behavior.initialize({ tableProps: props, columnIndex: columnIndex }, {}, _this.state.eventDispatch);
                    }
                }
            }
        }
        // Initialize the supplied behaviors.
        if (props.behaviors) {
            for (var _b = 0, _c = props.behaviors; _b < _c.length; _b++) {
                var behavior = _c[_b];
                if (behavior.initialize) {
                    behavior.initialize(props, _this, _this.state.eventDispatch);
                }
            }
        }
        return _this;
    }
    Table.getDerivedStateFromProps = function (props, state) {
        var tableBehaviors = [];
        var columnBehaviors = [];
        // Build the set of behaviors columns have attached to them
        for (var columnIndex = 0; columnIndex < props.columns.length; columnIndex++) {
            var tableColumn = props.columns[columnIndex];
            if (tableColumn.behaviors) {
                for (var _i = 0, _a = tableColumn.behaviors; _i < _a.length; _i++) {
                    var behavior = _a[_i];
                    columnBehaviors.push(behavior);
                }
            }
        }
        // Build the set of behaviors the table has attached to it
        if (props.behaviors) {
            tableBehaviors.splice.apply(tableBehaviors, Object(tslib_es6["d" /* __spreadArrays */])([tableBehaviors.length, 0], props.behaviors));
        }
        return {
            columnBehaviors: columnBehaviors,
            tableBehaviors: tableBehaviors
        };
    };
    Table.prototype.render = function () {
        var _a = this.state, eventDispatch = _a.eventDispatch, renderInvisible = _a.renderInvisible, visibleColumnsKey = _a.visibleColumnsKey;
        var _b = this.props, selectableText = _b.selectableText, className = _b.className, columns = _b.columns, containerClassName = _b.containerClassName, enforceSingleSelect = _b.enforceSingleSelect, focuszoneProps = _b.focuszoneProps, showLines = _b.showLines, id = _b.id, itemProvider = _b.itemProvider, maxHeight = _b.maxHeight, onActivate = _b.onActivate, onFocus = _b.onFocus, onSelect = _b.onSelect, pageSize = _b.pageSize, role = _b.role, rowHeight = _b.rowHeight, scrollable = _b.scrollable, selection = _b.selection, singleClickActivation = _b.singleClickActivation, selectRowOnClick = _b.selectRowOnClick, showScroll = _b.showScroll, tableBreakpoints = _b.tableBreakpoints, virtualize = _b.virtualize;
        var columnWidths = [];
        var spacerWidth = (this.props.spacerWidth || 0) * 2;
        var tableMaxWidth = spacerWidth;
        var tableMinWidth = spacerWidth;
        var tableWidth = spacerWidth;
        var hasBoundedColumn = false;
        var hasUnboundedColumn = false;
        var fill = false;
        var columnCount = 0;
        var columnFillCount = 0;
        // Compute the table size based on the current column definition. Size the sizes
        // are observable, we need to recompute each render to ensure we have the
        // proper values.
        for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
            var column = columns_1[_i];
            var maxWidth = column.maxWidth, minWidth = column.minWidth, _c = column.widthStyle, widthStyle = _c === void 0 ? Table_Props["b" /* IMeasurementStyle */].Pixel : _c;
            var width = Observable["ObservableLike"].getValue(column.width);
            // Add the column width the set of available columnWidths.
            columnWidths.push(column.width);
            if (width < 0) {
                // This is a variable width columnn so we will fill the container.
                fill = true;
                // Update the min/max width of the table based on the supplied value.
                // We use a minumum width of 100px if one isnt specified.
                tableMinWidth += minWidth ? minWidth : 0;
                // If all variable width columns have a maxWidth, let the table fill the available
                // space, but set the table's max width to the sum of the column widths/maxWidths.
                if (maxWidth) {
                    hasBoundedColumn = true;
                    tableMaxWidth += maxWidth;
                }
                else {
                    // If there are any variable width columns without maxWidth, let the table
                    // fill the available space with no maxWidth.
                    hasUnboundedColumn = true;
                }
                columnCount++;
            }
            else if (width > 0) {
                if (widthStyle === Table_Props["b" /* IMeasurementStyle */].Pixel) {
                    tableWidth += width;
                    tableMinWidth += width;
                    tableMaxWidth += width;
                }
                else {
                    // @NOTE: For now we are going to estimate a rem = 16px which is the default.
                    //  We could attempt to measure this if an exact measurement is really important.
                    tableWidth += width * 16;
                    tableMinWidth += width * 16;
                    tableMaxWidth += width * 16;
                }
                columnCount++;
            }
            if (column.id === "_fill") {
                columnFillCount++;
            }
        }
        var listProps = {
            selectableText: selectableText,
            ariaColumnCount: columnCount - columnFillCount,
            ariaLabel: this.props.ariaLabel,
            ariaRowOffset: this.props.showHeader ? 1 : 0,
            className: Object(Util["css"])(className, "bolt-table", showLines && "bolt-table-show-lines"),
            columnCount: columnCount + 2,
            enforceSingleSelect: enforceSingleSelect,
            eventDispatch: eventDispatch,
            focuszoneProps: focuszoneProps,
            id: id,
            itemProvider: itemProvider,
            maxWidth: hasBoundedColumn && !hasUnboundedColumn ? tableMaxWidth + "px" : undefined,
            maxHeight: maxHeight,
            minWidth: tableMinWidth !== tableWidth ? tableMinWidth + "px" : undefined,
            onActivate: onActivate,
            onFocus: onFocus,
            onSelect: onSelect,
            pageSize: pageSize,
            renderHeader: this.renderHeader,
            renderLoadingRow: this.renderLoadingRow,
            renderRow: this.renderRow,
            role: role,
            rowHeight: rowHeight,
            selection: selection,
            selectRowOnClick: selectRowOnClick,
            singleClickActivation: singleClickActivation,
            showScroll: showScroll,
            virtualize: virtualize,
            width: fill ? "100%" : tableWidth + "px"
        };
        var firstActionableHeaderIndex = getActionableIndex(columns);
        if (firstActionableHeaderIndex >= 0) {
            // If the header is tabbable, the rows do not need to be since they are
            // in the focus zone.
            listProps.defaultTabbableRow = -1;
        }
        var table = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(containerClassName, "bolt-table-container flex-grow", renderInvisible && "invisible", scrollable && "v-scroll-auto", tableBreakpoints && "h-scroll-hidden") },
            tableBreakpoints ? (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TableBreakpoint["a" /* TableBreakpoint */], { columnWidths: columnWidths, onBreakpoint: this.onBreakpoint, breakpoints: tableBreakpoints })) : undefined,
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](List["List"], Object(tslib_es6["a" /* __assign */])({}, listProps, { key: visibleColumnsKey, ref: this.list }))));
        if (scrollable) {
            table = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Intersection["Intersection"], null, table);
        }
        return table;
    };
    Table.prototype.componentDidMount = function () {
        // Mount any of the attached tableBehaviors.
        for (var _i = 0, _a = this.state.tableBehaviors; _i < _a.length; _i++) {
            var behavior = _a[_i];
            if (behavior.componentDidMount) {
                behavior.componentDidMount(this.props);
            }
        }
        for (var _b = 0, _c = this.state.columnBehaviors; _b < _c.length; _b++) {
            var behavior = _c[_b];
            if (behavior.componentDidMount) {
                behavior.componentDidMount({ tableProps: this.props });
            }
        }
    };
    Table.prototype.componentDidUpdate = function () {
        // Update any of the attached tableBehaviors.
        for (var _i = 0, _a = this.state.tableBehaviors; _i < _a.length; _i++) {
            var behavior = _a[_i];
            if (behavior.componentDidUpdate) {
                behavior.componentDidUpdate(this.props);
            }
        }
        for (var _b = 0, _c = this.state.columnBehaviors; _b < _c.length; _b++) {
            var behavior = _c[_b];
            if (behavior.componentDidUpdate) {
                behavior.componentDidUpdate({ tableProps: this.props });
            }
        }
    };
    Table.prototype.componentWillUnmount = function () {
        // Unmount any of the attached tableBehaviors.
        for (var _i = 0, _a = this.state.tableBehaviors; _i < _a.length; _i++) {
            var behavior = _a[_i];
            if (behavior.componentWillUnmount) {
                behavior.componentWillUnmount();
            }
        }
        for (var _b = 0, _c = this.state.columnBehaviors; _b < _c.length; _b++) {
            var behavior = _c[_b];
            if (behavior.componentDidUpdate) {
                behavior.componentDidUpdate({ tableProps: this.props });
            }
        }
    };
    Table.prototype.addOverlay = function (id, rowIndex, render, zIndex) {
        if (zIndex === void 0) { zIndex = 0; }
        if (this.list.current) {
            return this.list.current.addOverlay(id, rowIndex, render, zIndex);
        }
    };
    Table.prototype.removeOverlay = function (id) {
        if (this.list.current) {
            return this.list.current.removeOverlay(id);
        }
    };
    Table.prototype.focusRow = function (rowIndex, direction) {
        if (direction === void 0) { direction = 1; }
        if (this.list.current) {
            return this.list.current.focusRow(rowIndex, direction);
        }
        else {
            return Promise.resolve();
        }
    };
    Table.prototype.getFocusIndex = function () {
        if (this.list.current) {
            return this.list.current.getFocusIndex();
        }
        return -1;
    };
    Table.prototype.getStats = function () {
        if (this.list.current) {
            return this.list.current.getStats();
        }
        return {
            firstMaterialized: -1,
            firstRendered: -1,
            lastMaterialized: -1,
            lastRendered: -1
        };
    };
    Table.prototype.scrollIntoView = function (rowIndex, options) {
        if (this.list.current) {
            return this.list.current.scrollIntoView(rowIndex, options);
        }
    };
    Table.defaultProps = {
        role: "grid",
        selectRowOnClick: true,
        showHeader: true,
        showLines: true,
        singleClickActivation: true,
        spacerWidth: 8
    };
    return Table;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));

function renderColumns(rowIndex, columns, item, details) {
    return getVisibleColumnsAndIndices(columns).map(function (_a, columnIndex) {
        var column = _a.column;
        return column.renderCell(rowIndex, columnIndex, column, item, rowIndex + (details.ariaRowOffset ? details.ariaRowOffset : 1));
    });
}
function getVisibleColumnsAndIndices(columns) {
    return columns.map(function (column, index) { return ({ column: column, originalIndex: index }); }).filter(function (_a) {
        var column = _a.column;
        return Observable["ObservableLike"].getValue(column.width);
    });
}
function getActionableIndex(columns) {
    return columns.findIndex(function (column) { return Observable["ObservableLike"].getValue(column.width) !== 0 && ((column.behaviors && column.behaviors.length > 0) || !!column.sortProps); });
}
var Table_TableHeader = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(TableHeader, _super);
    function TableHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableHeader.prototype.render = function () {
        var _this = this;
        var firstActionableIndex = getActionableIndex(this.props.tableColumns);
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusZone["b" /* FocusZoneContext */].Consumer, null, function (rowContext) {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusZone["a" /* FocusZone */], { direction: FocusZone["c" /* FocusZoneDirection */].Horizontal },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("thead", null,
                    external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusWithin["FocusWithin"], null, function (focusStatus) {
                        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("tr", { "aria-rowindex": 1, className: Object(Util["css"])("bolt-table-header-row", focusStatus.hasFocus && "focused"), "data-row-index": -1, onBlur: focusStatus.onBlur, onFocus: focusStatus.onFocus },
                            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("th", { "aria-hidden": "true", key: "left-spacer", role: "presentation", className: "bolt-table-header-border" }),
                            getVisibleColumnsAndIndices(_this.props.tableColumns).map(function (_a, columnIndex) {
                                var column = _a.column, originalIndex = _a.originalIndex;
                                if (column.renderHeaderCell) {
                                    return column.renderHeaderCell(columnIndex, column, rowContext.focuszoneId, originalIndex === firstActionableIndex);
                                }
                                else if (column.iconProps || column.name) {
                                    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Table_TableHeaderCell, { key: "col-header-" + columnIndex, column: column, columnIndex: columnIndex, focuszoneId: rowContext.focuszoneId, isFirstActionableHeader: originalIndex === firstActionableIndex },
                                        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TooltipEx["Tooltip"], { overflowOnly: true, text: column.name },
                                            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-table-header-cell-text text-ellipsis body-s" },
                                                column.iconProps && Object(Icon["Icon"])(column.iconProps),
                                                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("span", null, column.name)))));
                                }
                                else {
                                    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("th", { "aria-colindex": columnIndex + 1, "aria-label": column.ariaLabel || Resources_Widgets["f" /* EmptyColumnHeaderLabel */], "aria-readonly": column.readonly !== undefined ? column.readonly : "true", className: "bolt-table-header-border", key: "col-header-" + columnIndex }));
                                }
                            }),
                            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("th", { "aria-hidden": "true", key: "right-spacer", role: "presentation", className: "bolt-table-header-border" })));
                    }))));
        }));
    };
    return TableHeader;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));
var boltTableHeaderCellCount = 0;
var Table_TableHeaderCell = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(TableHeaderCell, _super);
    function TableHeaderCell(props) {
        var _this = _super.call(this, props) || this;
        _this.element = external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"]();
        _this.state = { measuredWidth: 0 };
        _this.onSize = function (event, updatedSize) {
            var column = _this.props.column;
            // Ensure we havent had our column definition updated and onSize removed.
            if (column.onSize) {
                column.onSize(event, _this.props.columnIndex, updatedSize, column);
            }
        };
        _this.headerCellId = boltTableHeaderCellCount++;
        return _this;
    }
    TableHeaderCell.prototype.render = function () {
        var _this = this;
        var _a = this.props, column = _a.column, columnIndex = _a.columnIndex, focuszoneId = _a.focuszoneId, isFirstActionableHeader = _a.isFirstActionableHeader;
        var sizer;
        if (column.onSize) {
            sizer = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { width: column.width }, function (props) {
                // If we are sizable we will either use the supplied width (desired), or the
                // measured width if we are a proportional column.
                var width = props.width;
                if (width < 0) {
                    width = _this.state.measuredWidth;
                }
                return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Sizer_Sizer_Sizer, { ariaLabel: Object(Util_String["a" /* format */])(Resources_Widgets["e" /* ColumnSizerLabel */], column.name), className: "bolt-table-header-sizer", divider: false, maxSize: column.maxWidth, minSize: column.minWidth, onSize: _this.onSize, onSizeEnd: _this.props.column.onSizeEnd, orientation: Orientation.row, position: Position.near, size: width, tabIndex: 0, getFocusedElement: function (e) { return _this.element; } }));
            }));
        }
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusZone["b" /* FocusZoneContext */].Consumer, null, function (cellContext) {
            var actionable = (column.behaviors && column.behaviors.length > 0) || !!column.sortProps;
            var _a = column.sortProps, sortProps = _a === void 0 ? {} : _a;
            var sortIcon = column.sortProps && sortProps.sortOrder !== undefined
                ? Object(Icon["Icon"])({
                    className: "bolt-table-header-sort-icon body-s",
                    iconName: sortProps.sortOrder === Table_Props["c" /* SortOrder */].ascending ? "SortUp" : "SortDown"
                })
                : null;
            var justificationClassName;
            if (column.justification === Table_Props["a" /* ColumnJustification */].Left) {
                justificationClassName = "justify-start";
            }
            else if (column.justification === Table_Props["a" /* ColumnJustification */].Right) {
                justificationClassName = "justify-end";
            }
            var colIndex = columnIndex + 1;
            var childId = Object(Util["getSafeId"])("th-col-content-" + _this.headerCellId);
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("th", { role: "columnheader", "aria-colindex": colIndex, "aria-labelledby": childId, "aria-readonly": "true", "aria-sort": sortProps.sortOrder !== undefined
                    ? sortProps.sortOrder === Table_Props["c" /* SortOrder */].ascending
                        ? "ascending"
                        : "descending"
                    : undefined, className: Object(Util["css"])(column.headerClassName, "bolt-table-header-cell", "col-header-" + columnIndex, actionable && "bolt-table-header-cell-actionable"), "data-column-index": columnIndex, "data-focuszone": actionable && Object(Util["css"])(isFirstActionableHeader && focuszoneId, cellContext.focuszoneId), ref: _this.element, tabIndex: (actionable || sizer) ? 0 : -1 },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])("bolt-table-header-cell-content flex-row", justificationClassName) },
                    column.justification === Table_Props["a" /* ColumnJustification */].Right && sortIcon,
                    external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { id: childId, className: "scroll-hidden" }, _this.props.children),
                    column.justification !== Table_Props["a" /* ColumnJustification */].Right && sortIcon,
                    sizer)));
        }));
    };
    TableHeaderCell.prototype.componentDidMount = function () {
        this.updateMeasuredWidth();
    };
    TableHeaderCell.prototype.componentDidUpdate = function () {
        this.updateMeasuredWidth();
    };
    TableHeaderCell.prototype.updateMeasuredWidth = function () {
        var column = this.props.column;
        if (column.onSize && this.element.current && Observable["ObservableLike"].getValue(column.width) < 0) {
            var measuredWidth = this.element.current.getBoundingClientRect().width;
            if (measuredWidth !== this.state.measuredWidth) {
                this.setState({ measuredWidth: measuredWidth });
            }
        }
    };
    return TableHeaderCell;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));

function TableRow(props) {
    var onFocus = function (event) {
        var _a;
        props.details.onFocusItem(props.index, event);
        var rowNumber = (_a = props.details.ariaPosInSet) !== null && _a !== void 0 ? _a : props.index + ariaRowOffset;
        if (props.details.ariaSetSize) {
            if (props.linkProps) {
                Accessibility["a" /* announce */](Object(Util_String["a" /* format */])(Resources_Widgets["d" /* ClickableRowAnnouncementWithSize */], rowNumber), true);
            }
            else if (role == "option") {
                Accessibility["a" /* announce */](Resources_Widgets["g" /* ListItem */], true);
            }
            else {
                Accessibility["a" /* announce */](Object(Util_String["a" /* format */])(Resources_Widgets["m" /* RowAnnouncementWithSize */], rowNumber, props.details.ariaSetSize), true);
            }
        }
        else {
            if (props.linkProps) {
                Accessibility["a" /* announce */](Object(Util_String["a" /* format */])(Resources_Widgets["c" /* ClickableRowAnnouncement */], rowNumber), true);
            }
            else {
                Accessibility["a" /* announce */](Object(Util_String["a" /* format */])(Resources_Widgets["l" /* RowAnnouncement */], rowNumber), true);
            }
        }
    };
    var postprocessKeyStroke = function (event) {
        var nodeName = event.target.nodeName;
        if (!event.defaultPrevented && nodeName !== "INPUT" && nodeName !== "TEXTAREA") {
            if (event.which === Util["KeyCode"].leftArrow && rowElement.current) {
                rowElement.current.focus();
                event.preventDefault();
            }
        }
        return FocusZone["d" /* FocusZoneKeyStroke */].IgnoreNone;
    };
    var rowElement = external_commonjs_react_commonjs2_react_amd_React_root_React_["useState"](function () { return external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"](); })[0];
    var details = props.details, index = props.index, linkProps = props.linkProps;
    var selectableText = details.selectableText, ariaLabel = details.ariaLabel, ariaBusy = details.ariaBusy, ariaDescribedBy = details.ariaDescribedBy, ariaPosInSet = details.ariaPosInSet, ariaRowOffset = details.ariaRowOffset, ariaSetSize = details.ariaSetSize, excludeFocusZone = details.excludeFocusZone, id = details.id, renderSpacer = details.renderSpacer, role = details.role, selection = details.selection, singleClickActivation = details.singleClickActivation;
    var ariaChecked;
    var ariaSelected;
    if (role === "menuitemcheckbox") {
        ariaChecked = selection && selection.selected(index);
    }
    else {
        ariaSelected = selection && selection.selected(index);
    }
    var rowElem = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusOrMouseWithin["FocusOrMouseWithin"], { onFocus: onFocus }, function (focusOrMouseWithinStatus) {
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusZone["b" /* FocusZoneContext */].Consumer, null, function (rowContext) {
            var rowProps = {
                "aria-busy": ariaBusy,
                "aria-checked": ariaChecked,
                "aria-describedby": ariaDescribedBy,
                "aria-label": ariaLabel,
                "aria-rowindex": role === "menuitemcheckbox" || role === "option" ? undefined : index + ariaRowOffset,
                "aria-posinset": ariaPosInSet === null ? undefined : ariaPosInSet,
                "aria-selected": ariaSelected,
                "aria-setsize": ariaSetSize === null ? undefined : ariaSetSize,
                className: Object(Util["css"])(props.className, "bolt-table-row bolt-list-row", index === 0 && "first-row", focusOrMouseWithinStatus.hasFocus && "focused", selection && selection.selected(index) && "selected", singleClickActivation && "single-click-activation", linkProps && "v-align-middle", selectableText && "selectable-text"),
                "data-focuszone": excludeFocusZone || (selection && !selection.selectable(index)) ? undefined : rowContext.focuszoneId,
                "data-row-index": props.index,
                id: Object(Util["getSafeId"])(id),
                role: role || "row",
                tabIndex: Object(Focus["a" /* getTabIndex */])(details),
                onBlur: focusOrMouseWithinStatus.onBlur,
                onFocus: focusOrMouseWithinStatus.onFocus,
                onMouseEnter: focusOrMouseWithinStatus.onMouseEnter,
                onMouseLeave: focusOrMouseWithinStatus.onMouseLeave,
                ref: rowElement
            };
            var rowChildren = [
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("td", { "aria-hidden": "true", key: "left-spacer", className: "bolt-table-cell-compact bolt-table-cell bolt-list-cell bolt-table-spacer-cell", role: "presentation" }, renderSpacer && renderSpacer(index, true)),
                props.children,
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("td", { "aria-hidden": "true", key: "right-spacer", className: "bolt-table-cell-compact bolt-table-cell bolt-list-cell bolt-table-spacer-cell", role: "presentation" }, renderSpacer && renderSpacer(index, false))
            ];
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusZone["a" /* FocusZone */], { direction: FocusZone["c" /* FocusZoneDirection */].Horizontal, postprocessKeyStroke: postprocessKeyStroke }, linkProps ? (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("a", Object(tslib_es6["a" /* __assign */])({}, Object(Link["getDefaultLinkProps"])(linkProps), rowProps), rowChildren)) : (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("tr", Object(tslib_es6["a" /* __assign */])({}, rowProps), rowChildren))));
        }));
    }));
    if (details.tooltipProps) {
        return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TooltipEx["Tooltip"], Object(tslib_es6["a" /* __assign */])({}, details.tooltipProps), rowElem);
    }
    return rowElem;
}
function TableLoadingRow(props) {
    return (
    // Return the default row loading animation.
    external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TableRow, { className: "bolt-list-row-loading", details: props.details, index: props.rowIndex }, getVisibleColumnsAndIndices(props.columns).map(function (_a, columnIndex) {
        var column = _a.column;
        return SimpleTableCell({ columnIndex: columnIndex, children: renderLoadingCell(column.columnLayout) });
    })));
}
function TableCell(props) {
    var ariaLabel = props.ariaLabel, ariaRowIndex = props.ariaRowIndex, className = props.className, colspan = props.colspan, columnIndex = props.columnIndex, tableColumn = props.tableColumn;
    var justificationClassName;
    if (tableColumn) {
        if (tableColumn.justification === Table_Props["a" /* ColumnJustification */].Left) {
            justificationClassName = "justify-cell-start";
        }
        else if (tableColumn.justification === Table_Props["a" /* ColumnJustification */].Right) {
            justificationClassName = "justify-cell-end";
        }
    }
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("td", { "aria-colindex": columnIndex + 1, "aria-label": ariaLabel, "aria-readonly": tableColumn && tableColumn.readonly, "aria-rowindex": ariaRowIndex, className: Object(Util["css"])(className, tableColumn && tableColumn.className, "bolt-table-cell bolt-list-cell", justificationClassName), colSpan: colspan, "data-column-index": columnIndex, key: "col-" + columnIndex, role: "gridcell" }, props.children));
}
function SimpleTableCell(props) {
    var children = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(props.contentClassName, "bolt-table-cell-content flex-row flex-center") }, props.children);
    return TableCell({
        ariaLabel: props.ariaLabel,
        ariaRowIndex: props.ariaRowIndex,
        children: children,
        className: props.className,
        colspan: props.colspan,
        columnIndex: props.columnIndex,
        tableColumn: props.tableColumn
    });
}
function TwoLineTableCell(props) {
    var rowClasses = "bolt-table-two-line-cell-item flex-row scroll-hidden";
    var line1 = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: rowClasses }, props.line1);
    var line2 = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: rowClasses }, props.line2);
    var lines = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](external_commonjs_react_commonjs2_react_amd_React_root_React_["Fragment"], null,
        line1,
        line2));
    var children;
    if (props.iconProps) {
        children = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(props.className, "bolt-table-cell-content flex-row flex-center") },
            Object(Icon["Icon"])(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, props.iconProps), { className: Object(Util["css"])(props.iconProps.className, "bolt-table-two-line-cell-icon flex-noshrink") })),
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "flex-column scroll-hidden" }, lines)));
    }
    else {
        children = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(props.className, "bolt-table-cell-content flex-column") }, lines);
    }
    return TableCell({
        ariaRowIndex: props.ariaRowIndex,
        children: children,
        colspan: props.colspan,
        columnIndex: props.columnIndex,
        className: "bolt-table-two-line-cell",
        tableColumn: props.tableColumn
    });
}
function renderEmptyCell(rowIndex, columnIndex) {
    return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TableCell, { columnIndex: columnIndex, key: columnIndex });
}
/**
 * A basic cell renderer that works well for most simple columns. Gets the value of the
 * the {column.id} property in the given table item and displays it as a string
 *
 * @param rowIndex Index of the row being rendered
 * @param columnIndex Index of the column being rendered
 * @param tableColumn Column definition
 * @param tableItem The data item being rendered for the current row
 */
function renderSimpleCell(rowIndex, columnIndex, tableColumn, tableItem, ariaRowIndex) {
    return renderSimpleCellValue(columnIndex, tableColumn, tableItem[tableColumn.id], ariaRowIndex);
}
/**
 * Renders a simple table cell value
 *
 * @param columnIndex Index of the column being rendered
 * @param tableColumn Column definition
 * @param tableCell Simple value to render as text
 */
function renderSimpleCellValue(columnIndex, tableColumn, tableCell, ariaRowIndex) {
    var columnStyle = tableColumn.columnStyle;
    // Do not include padding if the table cell has an href
    var hasLink = !!(tableCell && typeof tableCell !== "string" && typeof tableCell !== "number" && tableCell.href);
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](SimpleTableCell, { ariaRowIndex: ariaRowIndex, className: Object(Util["css"])(columnStyle === Table_Props["e" /* TableColumnStyle */].Primary && "bolt-table-cell-primary", columnStyle === Table_Props["e" /* TableColumnStyle */].Secondary && "bolt-table-cell-secondary", columnStyle === Table_Props["e" /* TableColumnStyle */].Tertiary && "bolt-table-cell-tertiary"), columnIndex: columnIndex, contentClassName: hasLink ? "bolt-table-cell-content-with-link" : undefined, key: columnIndex, tableColumn: tableColumn }, tableCell && Object(List["renderListCell"])(tableCell)));
}
function getVariableLength() {
    return Math.random() * 80 + 20 + "%";
}
function renderLoadingCell(columnLayout) {
    if (columnLayout === Table_Props["d" /* TableColumnLayout */].singleLine || columnLayout === undefined) {
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "shimmer shimmer-line", style: { width: getVariableLength() } }, "\u00A0"));
    }
    else if (columnLayout === Table_Props["d" /* TableColumnLayout */].singleLinePrefix) {
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](external_commonjs_react_commonjs2_react_amd_React_root_React_["Fragment"], null,
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "shimmer shimmer-circle-small flex-noshrink" }),
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "shimmer shimmer-line", style: { width: getVariableLength() } }, "\u00A0")));
    }
    else if (columnLayout === Table_Props["d" /* TableColumnLayout */].twoLine) {
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "flex-column flex-grow" },
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-table-two-line-cell-item shimmer shimmer-line", style: { width: getVariableLength() } }, "\u00A0"),
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-table-two-line-cell-item shimmer shimmer-line", style: { width: getVariableLength() } }, "\u00A0")));
    }
    else if (columnLayout === Table_Props["d" /* TableColumnLayout */].twoLinePrefix) {
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](external_commonjs_react_commonjs2_react_amd_React_root_React_["Fragment"], null,
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "shimmer shimmer-circle-large flex-noshrink" }),
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "flex-column flex-grow" },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-table-two-line-cell-item shimmer shimmer-line", style: { width: getVariableLength() } }, "\u00A0"),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-table-two-line-cell-item shimmer shimmer-line", style: { width: getVariableLength() } }, "\u00A0"))));
    }
    return null;
}


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ DropdownFilterBarItem_DropdownFilterBarItem; });

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Dropdown/Dropdown.css
var Dropdown = __webpack_require__(51);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Observable.js
var Observable = __webpack_require__(4);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Util/Accessibility.js
var Accessibility = __webpack_require__(15);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/FilterBarItem.js
var FilterBarItem = __webpack_require__(92);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/List.js
var List = __webpack_require__(21);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/ListBox.js + 5 modules
var ListBox = __webpack_require__(22);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Observer.js
var Observer = __webpack_require__(8);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Resources.Dropdown.js
var Resources_Dropdown = __webpack_require__(17);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Utilities/DropdownFilter.js

function updateFilterToSelection(values, items, filter, filterItemKey) {
    var selectedValues = [];
    for (var rangeIndex = 0; rangeIndex < values.length; rangeIndex++) {
        for (var i = values[rangeIndex].beginIndex; i <= values[rangeIndex].endIndex; i++) {
            selectedValues.push(items[i].data !== undefined ? items[i].data : items[i].id);
        }
    }
    var currentState = filter.getFilterItemState(filterItemKey);
    var changesToSet = false;
    if (currentState) {
        changesToSet = !Object(Util["arrayEquals"])(currentState.value, selectedValues) && (selectedValues.length || currentState.value);
    }
    else {
        changesToSet = !!selectedValues.length;
    }
    if (changesToSet) {
        if (filterItemKey === "keyword") {
            filter.setFilterItemState(filterItemKey, { value: selectedValues[0] });
        }
        else {
            filter.setFilterItemState(filterItemKey, { value: selectedValues, operator: currentState === null || currentState === void 0 ? void 0 : currentState.operator });
        }
    }
}

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Utilities/DropdownSelection.js
var DropdownSelection = __webpack_require__(46);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Utilities/Selection.js
var Selection = __webpack_require__(64);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Dropdown/Dropdown.js
var Dropdown_Dropdown = __webpack_require__(74);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Dropdown/DropdownExpandableButton.js
var DropdownExpandableButton = __webpack_require__(82);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Dropdown/DropdownFilterBarItem.js


















var DropdownFilterBarItemWidth = 256;
var DropdownFilterBarItem_DropdownFilterBarItem = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(DropdownFilterBarItem, _super);
    function DropdownFilterBarItem(props) {
        var _this = _super.call(this, props) || this;
        _this.dropdown = external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"]();
        _this.componentDidMount = function () {
            var _a;
            _super.prototype.componentDidMount.call(_this);
            if (_this.props.filter) {
                var filterState = (_a = _this.props.filter) === null || _a === void 0 ? void 0 : _a.getFilterItemState(_this.props.filterItemKey);
                _this.onFilterChanged(filterState);
            }
        };
        _this.selectDefaultFilterItem = function () {
            if (_this.props.filter) {
                var filterState_1 = _this.props.filter.getFilterItemState(_this.props.filterItemKey);
                if (filterState_1 && filterState_1.value) {
                    var items = Object(ListBox["c" /* getListBoxItemsValue */])(_this.wrappedItems || _this.props.items);
                    var newSelection = new List["ListSelection"](_this.selection.multiSelect);
                    var _loop_1 = function (i) {
                        var index = items.findIndex(function (item) {
                            return item.id === filterState_1.value[i] ||
                                item.data === filterState_1.value[i] ||
                                JSON.stringify(item.data) === JSON.stringify(filterState_1.value[i]);
                        });
                        if (index > -1) {
                            newSelection.select(index, 1, true);
                        }
                    };
                    for (var i = 0; i < filterState_1.value.length; i++) {
                        _loop_1(i);
                    }
                    _this.selection.value = newSelection.value;
                }
            }
        };
        _this.onFilterChanged = function (filterState) {
            _super.prototype.onFilterChanged.call(_this, filterState);
            var items = Object(ListBox["c" /* getListBoxItemsValue */])(_this.wrappedItems || _this.props.items);
            if (filterState && filterState.value) {
                var newSelection = new List["ListSelection"](_this.selection.multiSelect);
                var _loop_2 = function (i) {
                    var index = items.findIndex(function (item) {
                        return item.id === filterState.value[i] ||
                            item.data === filterState.value[i] ||
                            JSON.stringify(item.data) === JSON.stringify(filterState.value[i]);
                    });
                    if (index > -1) {
                        newSelection.select(index, 1, true);
                    }
                };
                for (var i = 0; i < filterState.value.length; i++) {
                    _loop_2(i);
                }
                var selectionDifference = Object(Selection["b" /* compareSelectionRanges */])(_this.selection.value, newSelection.value);
                if (selectionDifference.length) {
                    _this.selection.value = newSelection.value;
                }
            }
            else {
                _this.selection.clear();
            }
        };
        _this.onSelectionChanged = function (values) {
            var items = Object(ListBox["c" /* getListBoxItemsValue */])(_this.wrappedItems || _this.props.items);
            if (_this.props.filter) {
                updateFilterToSelection(values, items, _this.props.filter, _this.props.filterItemKey);
            }
            return true;
        };
        _this.renderExpandableButton = function (expandableProps) {
            var _a = _this.props, className = _a.className, renderExpandable = _a.renderExpandable;
            var expandableButtonProps = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, expandableProps), { className: Object(Util["css"])(className, "bolt-dropdown-filter-bar-item"), subtle: true, renderSelectedItems: _this.renderSelectedItems });
            if (renderExpandable) {
                return renderExpandable(expandableButtonProps);
            }
            return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](DropdownExpandableButton["a" /* DropdownExpandableButton */], Object(tslib_es6["a" /* __assign */])({}, expandableButtonProps));
        };
        _this.onClearClick = function () {
            _this.selection.clear();
            _this.props.toggleFilterBar && _this.props.toggleFilterBar();
            Accessibility["a" /* announce */](Resources_Dropdown["a" /* AnnounceFilterCleared */]);
        };
        _this.renderSelectedItems = function (selection, items) {
            var selectedText = items[selection.value[0].beginIndex].text || "";
            if (selection.selectedCount > 1) {
                selectedText = selectedText + " (+" + (selection.selectedCount - 1) + ")";
            }
            var selectedTextSpan = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("span", { className: "bolt-dropdown-filter-bar-item-selected-text" }, selectedText);
            return _this.props.showPlaceholderAsLabel ? (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](external_commonjs_react_commonjs2_react_amd_React_root_React_["Fragment"], null,
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("span", { className: "bolt-dropdown-filter-bar-item-placeholder" }, _this.props.placeholder + ": "),
                selectedTextSpan)) : (selectedTextSpan);
        };
        // string items are wrapped once here.  Only use a string array in the simple case where the items are not changing.
        _this.wrappedItems = Object(ListBox["e" /* wrapListBoxItems */])(props.items);
        _this.selection = props.selection || new DropdownSelection["DropdownSelection"]();
        // Select the default items from the filter.
        _this.selectDefaultFilterItem();
        return _this;
    }
    DropdownFilterBarItem.prototype.focus = function () {
        if (this.dropdown.current) {
            this.dropdown.current.focus();
        }
    };
    DropdownFilterBarItem.prototype.render = function () {
        var _this = this;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["SelectionObserver"], { selection: this.selection, onSelectionChanged: this.onSelectionChanged }, function () {
            var actionsFromProps = Observable["ObservableLike"].getValue(_this.props.actions || []);
            var actions = Object(tslib_es6["d" /* __spreadArrays */])(actionsFromProps);
            if (!_this.props.hideClearAction) {
                actions.push({
                    className: "bolt-dropdown-action-right-button",
                    disabled: _this.selection.selectedCount === 0,
                    iconProps: { iconName: "Clear" },
                    text: Resources_Dropdown["i" /* DropdownClearActionText */],
                    onClick: _this.onClearClick
                });
            }
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Observer["Observer"], { dropdownItems: { observableValue: _this.props.items, filter: _this.selectDefaultFilterItem } }, function () { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Dropdown_Dropdown["a" /* Dropdown */], Object(tslib_es6["a" /* __assign */])({ renderExpandable: _this.renderExpandableButton, width: DropdownFilterBarItemWidth }, _this.props, { actions: actions, selection: _this.selection, ref: _this.dropdown }))); }));
        }));
    };
    return DropdownFilterBarItem;
}(FilterBarItem["FilterBarItem"]));



/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FilterBar_FilterBar_FilterBar; });

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/FilterBar/FilterBar.css
var FilterBar_FilterBar = __webpack_require__(175);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Util/Accessibility.js
var Accessibility = __webpack_require__(15);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Util/String.js
var Util_String = __webpack_require__(16);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Button.js
var Button = __webpack_require__(14);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Resources.FilterBar.js
var AnnonuceVisibleFilters = "Showing filters {0} through {1}";
var ApplyChangesFilterBarText = "Apply";
var ClearAndDismissFilterBarLinkLabel = "Clear and dismiss filters";
var ClearFilterBarLinkLabel = "Clear filters";
var FilterPageLeftAriaLabel = "See previous group of filters";
var FilterPageRightAriaLabel = "See next group of filters";

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Surface.js + 2 modules
var Surface = __webpack_require__(18);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Utilities/Filter.js
var Filter = __webpack_require__(33);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/FilterBar/FilterBar.js












var idCount = 0;
var FilterBar_FilterBar_FilterBar = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(FilterBar, _super);
    function FilterBar(props) {
        var _this = _super.call(this, props) || this;
        _this._firstChildIsKeywordItem = false;
        _this._prevContainerWidth = 0;
        _this._id = Object(Util["getSafeId"])("filter-bar-" + idCount++);
        _this._onResize = function () {
            if (!_this._resizeTimeout) {
                _this._resizeTimeout = setTimeout(function () {
                    _this._resizeTimeout = null;
                    if (_this._isMounted) {
                        var containerIsGrowing = _this._prevContainerWidth < _this._filterBarElement.clientWidth;
                        var shouldHidePlaceholderLabels = _this.state.shouldHidePlaceholderLabels && containerIsGrowing ? false : _this.state.shouldHidePlaceholderLabels;
                        var shouldHaveMaxItemWidth = _this.state.shouldHaveMaxItemWidth && containerIsGrowing ? false : _this.state.shouldHaveMaxItemWidth;
                        _this.setState({ filtersToShowStopIndex: FilterBar.RENDER_EVERYTHING, shouldHidePlaceholderLabels: shouldHidePlaceholderLabels, shouldHaveMaxItemWidth: shouldHaveMaxItemWidth });
                        _this._prevContainerWidth = _this._filterBarElement.clientWidth;
                    }
                }, 100);
            }
        };
        _this._onPageLeft = function () {
            _this._hasMadeVisibleFilterAnnouncement = false;
            var startIndex = _this._startingFilterIndices.pop() || 0;
            _this._hasPagedLeft = true;
            _this.setState({ filtersToShowStartIndex: startIndex, filtersToShowStopIndex: FilterBar.RENDER_EVERYTHING });
        };
        _this._onPageRight = function () {
            _this._hasMadeVisibleFilterAnnouncement = false;
            _this._startingFilterIndices.push(_this.state.filtersToShowStartIndex);
            _this._hasPagedRight = true;
            _this.setState({ filtersToShowStartIndex: _this.state.filtersToShowStopIndex, filtersToShowStopIndex: FilterBar.RENDER_EVERYTHING });
        };
        _this._calculateFiltersToShowStopIndex = function () {
            var totalWidth = _this._rightElement.clientWidth;
            for (var i = 0; i < _this._childrenContainerElements.length; i++) {
                var elem = _this._childrenContainerElements[i];
                var elemWidth = elem.clientWidth + parseFloat(window.getComputedStyle(elem).marginRight);
                totalWidth += elemWidth;
                if (totalWidth > _this._filterBarElement.clientWidth) {
                    // Make sure we show at least one filter.
                    var endIndex = _this.state.filtersToShowStartIndex + i;
                    return endIndex > _this.state.filtersToShowStartIndex ? endIndex : _this.state.filtersToShowStartIndex + 1;
                }
            }
            return _this.state.filtersToShowStartIndex + _this._childrenContainerElements.length;
        };
        _this._onFilterChanged = function (changedState) {
            _this.setState({
                hasChangesToApply: _this.props.filter.hasChangesToApply(),
                hasChangesToReset: _this.props.filter.hasChangesToReset(),
                filtersToShowStopIndex: FilterBar.RENDER_EVERYTHING,
                shouldHidePlaceholderLabels: false
            });
        };
        _this._onFilterApplied = function (changedState) {
            _this.setState({
                hasChangesToApply: _this.props.filter.hasChangesToApply()
            });
        };
        _this._onClearAndDismiss = function () {
            if (_this.props.filter.hasChangesToReset()) {
                _this.props.filter.reset();
            }
            if (_this.props.onDismissClicked) {
                _this.props.onDismissClicked();
            }
        };
        _this._onApplyChanges = function () {
            _this.props.filter.applyChanges();
            _this.focus();
        };
        if (!props.filter) {
            throw new Error("Cannot create a FilterBar without a filter prop.");
        }
        _this._startingFilterIndices = [];
        _this._hasMadeVisibleFilterAnnouncement = false;
        _this._isMounted = false;
        _this.state = {
            hasChangesToReset: props.filter.hasChangesToReset(),
            hasChangesToApply: props.filter.hasChangesToApply(),
            filtersToShowStartIndex: 0,
            filtersToShowStopIndex: FilterBar.RENDER_EVERYTHING,
            shouldHidePlaceholderLabels: false,
            shouldHaveMaxItemWidth: false
        };
        return _this;
    }
    FilterBar.prototype.focus = function () {
        if (this._filterItemRefs && this._filterItemRefs.length > 0) {
            this._filterItemRefs[0].focus();
        }
    };
    FilterBar.prototype.forceUpdate = function () {
        _super.prototype.forceUpdate.call(this);
        if (this._filterItemRefs) {
            this._filterItemRefs.forEach(function (filterItem) { return filterItem.forceUpdate(); });
        }
    };
    FilterBar.prototype.componentDidMount = function () {
        this.props.filter && this.props.filter.subscribe(this._onFilterChanged, Filter["FILTER_CHANGE_EVENT"]);
        this.props.filter && this.props.filter.subscribe(this._onFilterApplied, Filter["FILTER_APPLIED_EVENT"]);
        window.addEventListener("resize", this._onResize);
        var stopIndex = this._calculateFiltersToShowStopIndex();
        if (stopIndex < external_commonjs_react_commonjs2_react_amd_React_root_React_["Children"].toArray(this.props.children).length - 1) {
            this.setState({ shouldHidePlaceholderLabels: true });
        }
        else {
            this.setState({ filtersToShowStopIndex: stopIndex });
        }
        this._isMounted = true;
        if (this.props.onMounted) {
            this.props.onMounted(this);
        }
    };
    FilterBar.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        // Bug#1284606 Checking our child components to see if we actually changed
        // the contents of the filter bar so we can know if we want to reload tabbing
        // and adjust how we're drawing out child components
        var currentKeys = this.getChildKeysAsString(this.props);
        var newKeys = this.getChildKeysAsString(nextProps);
        if (currentKeys !== newKeys) {
            // Bug#1284606 Triggers a full re-render in the event we changed the child elements
            this.setState({
                hasChangesToApply: nextProps.filter.hasChangesToApply(),
                hasChangesToReset: nextProps.filter.hasChangesToReset(),
                filtersToShowStartIndex: 0,
                filtersToShowStopIndex: FilterBar.RENDER_EVERYTHING
            });
        }
        else {
            // Normal prop updates, triggered when child components update as well
            this.setState({
                hasChangesToApply: nextProps.filter.hasChangesToApply(),
                hasChangesToReset: nextProps.filter.hasChangesToReset()
            });
        }
    };
    FilterBar.prototype.componentWillUnmount = function () {
        this.props.filter && this.props.filter.unsubscribe(this._onFilterChanged, Filter["FILTER_CHANGE_EVENT"]);
        this.props.filter && this.props.filter.unsubscribe(this._onFilterApplied, Filter["FILTER_APPLIED_EVENT"]);
        window.removeEventListener("resize", this._onResize);
        this._isMounted = false;
    };
    FilterBar.prototype.componentDidUpdate = function () {
        if (this.props.onRenderComplete) {
            this.props.onRenderComplete();
        }
        if (this._hasPagedLeft && this.state.filtersToShowStopIndex > 0) {
            if (this.state.filtersToShowStartIndex == 0) {
                this._nextButtonElem && this._nextButtonElem.focus();
            }
            this._hasPagedLeft = false;
        }
        if (this.state.filtersToShowStopIndex < 0) {
            var filtersToShowStopIndex = this._calculateFiltersToShowStopIndex();
            var allFiltersFit = filtersToShowStopIndex === external_commonjs_react_commonjs2_react_amd_React_root_React_["Children"].toArray(this.props.children).length;
            if (!allFiltersFit && !this.state.shouldHidePlaceholderLabels) {
                this.setState({ shouldHidePlaceholderLabels: true });
            }
            else if (!allFiltersFit && !this.state.shouldHaveMaxItemWidth) {
                this.setState({ shouldHaveMaxItemWidth: true });
            }
            else {
                if (this._hasPagedRight && filtersToShowStopIndex === this.state.filtersToShowStartIndex + this._childrenContainerElements.length) {
                    this._prevButtonElem && this._prevButtonElem.focus();
                }
                this.setState({ filtersToShowStopIndex: filtersToShowStopIndex });
                this._hasPagedRight = false;
            }
        }
        else if (!this._hasMadeVisibleFilterAnnouncement) {
            Accessibility["a" /* announce */](Object(Util_String["a" /* format */])(AnnonuceVisibleFilters, this.state.filtersToShowStartIndex + 1, this.state.filtersToShowStopIndex), false);
            this._hasMadeVisibleFilterAnnouncement = true;
        }
    };
    FilterBar.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, filter = _a.filter, className = _a.className, onDismissClicked = _a.onDismissClicked;
        var _b = this.state, hasChangesToApply = _b.hasChangesToApply, hasChangesToReset = _b.hasChangesToReset, filtersToShowStopIndex = _b.filtersToShowStopIndex, filtersToShowStartIndex = _b.filtersToShowStartIndex, shouldHaveMaxItemWidth = _b.shouldHaveMaxItemWidth, shouldHidePlaceholderLabels = _b.shouldHidePlaceholderLabels;
        this._filterItemRefs = [];
        this._childrenContainerElements = [];
        var isFirstChild = true;
        var isKeywordPresent = false;
        this._firstChildIsKeywordItem = false;
        var childrenWithProps = external_commonjs_react_commonjs2_react_amd_React_root_React_["Children"].map(children, function (child) {
            if (child === null) {
                return null;
            }
            var containerClassName = "vss-FilterBar--item";
            var childElement = child;
            if (childElement.props.isTextItem && !isKeywordPresent) {
                _this._firstChildIsKeywordItem = isFirstChild;
                isKeywordPresent = true;
                containerClassName = Object(Util["css"])(containerClassName, "vss-FilterBar--item-keyword-container");
            }
            else if (shouldHaveMaxItemWidth) {
                containerClassName = Object(Util["css"])(containerClassName, "max-width-small");
            }
            isFirstChild = false;
            var childWithProps = external_commonjs_react_commonjs2_react_amd_React_root_React_["cloneElement"](childElement, {
                filter: childElement.props.filter || filter,
                ref: function (elem) {
                    if (elem) {
                        _this._filterItemRefs.push(elem);
                    }
                },
                hideSelectedItemIcon: true,
                showPlaceholderAsLabel: !shouldHidePlaceholderLabels && childElement.props.showPlaceholderAsLabel
            });
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: containerClassName, ref: function (elem) {
                    if (elem) {
                        _this._childrenContainerElements.push(elem);
                    }
                } }, childWithProps));
        });
        var canPageRight = filtersToShowStopIndex < childrenWithProps.length;
        var canPageLeft = filtersToShowStartIndex > 0;
        if (canPageRight || canPageLeft) {
            var endIndex = filtersToShowStopIndex > 0 ? filtersToShowStopIndex : childrenWithProps.length;
            childrenWithProps = childrenWithProps.slice(filtersToShowStartIndex, endIndex);
        }
        var clearLabel = onDismissClicked ? ClearAndDismissFilterBarLinkLabel : ClearFilterBarLinkLabel;
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Surface["SurfaceContext"].Consumer, null, function (surfaceContext) { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(className, "vss-FilterBar", surfaceContext.background === Surface["SurfaceBackground"].neutral && "bolt-filterbar-white depth-8 no-v-margin"), role: "search", id: _this._id },
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])("vss-FilterBar--list", (!_this._firstChildIsKeywordItem || filtersToShowStartIndex > 0) && "justify-right"), ref: function (elem) {
                    _this._filterBarElement = elem;
                } },
                childrenWithProps,
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "vss-FilterBar--right-items", ref: function (elem) {
                        _this._rightElement = elem;
                    } },
                    (canPageLeft || canPageRight) && (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "vss-FilterBar--page-button-container" },
                        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Button["Button"], { className: "filter-bar-button  vss-FilterBar-page-button", ref: function (elem) {
                                _this._prevButtonElem = elem;
                            }, onClick: _this._onPageLeft, disabled: !canPageLeft, ariaLabel: FilterPageLeftAriaLabel, iconProps: { iconName: "ChevronLeftMed" } }),
                        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Button["Button"], { className: "filter-bar-button vss-FilterBar-page-button", ref: function (elem) {
                                _this._nextButtonElem = elem;
                            }, onClick: _this._onPageRight, disabled: !canPageRight, ariaLabel: FilterPageRightAriaLabel, iconProps: { iconName: "ChevronRightMed" } }))),
                    !_this.props.hideClearAction && (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "vss-FilterBar--action vss-FilterBar--action-clear" },
                        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Button["Button"], { ariaLabel: clearLabel, className: "filter-bar-button", disabled: !hasChangesToReset && !onDismissClicked, iconProps: { iconName: "Cancel" }, onClick: _this._onClearAndDismiss, subtle: true, tooltipProps: { text: clearLabel } }))),
                    filter.usesApplyMode() && (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "vss-FilterBar--action vss-FilterBar--action-apply" },
                        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Button["Button"], { className: "filter-bar-button", disabled: !hasChangesToApply, onClick: _this._onApplyChanges, iconProps: { iconName: "CheckMark" } }, ApplyChangesFilterBarText))))))); }));
    };
    FilterBar.prototype.getChildKeysAsString = function (props) {
        var childKeys = (props.children &&
            external_commonjs_react_commonjs2_react_amd_React_root_React_["Children"].map(props.children, function (child) {
                if (child === null) {
                    return null;
                }
                var childAsFilterBarItem = child;
                // If the child isn't able to be cast properly, just note that it exists
                // it's infeasible to get a unique identifier from an arbitrary, possibly stateful component
                // That said, we DO want to at least count these elements instead of excluding them
                // so we aren't filtering them out
                if (childAsFilterBarItem === undefined) {
                    return "";
                }
                return childAsFilterBarItem.props.filterItemKey;
            })) ||
            [];
        return JSON.stringify(childKeys);
    };
    FilterBar.RENDER_EVERYTHING = -1;
    return FilterBar;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));



/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_FocusOrMouseWithin_FocusOrMouseWithin_Props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(152);
/* harmony import */ var _Components_FocusOrMouseWithin_FocusOrMouseWithin_Props__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Components_FocusOrMouseWithin_FocusOrMouseWithin_Props__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_Components_FocusOrMouseWithin_FocusOrMouseWithin_Props__WEBPACK_IMPORTED_MODULE_0__, "FocusOrMouseWithin")) __webpack_require__.d(__webpack_exports__, "FocusOrMouseWithin", function() { return _Components_FocusOrMouseWithin_FocusOrMouseWithin_Props__WEBPACK_IMPORTED_MODULE_0__["FocusOrMouseWithin"]; });

/* harmony import */ var _Components_FocusOrMouseWithin_FocusOrMouseWithin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(153);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FocusOrMouseWithin", function() { return _Components_FocusOrMouseWithin_FocusOrMouseWithin__WEBPACK_IMPORTED_MODULE_1__["a"]; });





/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_FormItem_FormItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(163);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormItemContext", function() { return _Components_FormItem_FormItem__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_FormItem_FormItem_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(164);
/* harmony import */ var _Components_FormItem_FormItem_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_FormItem_FormItem_Props__WEBPACK_IMPORTED_MODULE_1__);




/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_ExpandableTextField_ExpandableTextField__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(165);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpandableTextField", function() { return _Components_ExpandableTextField_ExpandableTextField__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_ExpandableTextField_ExpandableTextField_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(166);
/* harmony import */ var _Components_ExpandableTextField_ExpandableTextField_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_ExpandableTextField_ExpandableTextField_Props__WEBPACK_IMPORTED_MODULE_1__);




/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_HeaderCommandBar_CustomHeaderCommandBar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85);
/* harmony import */ var _Components_HeaderCommandBar_HeaderCommandBar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(188);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HeaderCommandBar", function() { return _Components_HeaderCommandBar_HeaderCommandBar__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _Components_HeaderCommandBar_HeaderCommandBar_Props__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(191);
/* harmony import */ var _Components_HeaderCommandBar_HeaderCommandBar_Props__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Components_HeaderCommandBar_HeaderCommandBar_Props__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Components_HeaderCommandBar_Items__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86);






/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Components_ButtonGroup_ButtonGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(186);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return _Components_ButtonGroup_ButtonGroup__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_ButtonGroup_ButtonGroup_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);
/* harmony import */ var _Components_ButtonGroup_ButtonGroup_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_ButtonGroup_ButtonGroup_Props__WEBPACK_IMPORTED_MODULE_1__);




/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(205);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-page{height:100%}.bolt-page>*{flex:0 0 auto}.bolt-page .bolt-messagecard{margin:16px 32px 0}.bolt-page .swcShim{height:32px;position:sticky;z-index:2;top:0;background-color:rgba( var(--palette-neutral-2) ,  1 )}.bolt-page .vss-FilterBar{position:sticky;z-index:2;top:29px;flex-shrink:0}.bolt-page .bolt-card-content{flex-direction:column}.vss-ZeroData{min-height:400px;margin-top:0}.vss-ZeroData .vss-ZeroDataItem{justify-content:center}pre{background-color:var(--palette-black-alpha-6);border-radius:2px;padding:4px 8px 6px 8px}.bolt-card .bolt-list-cell{padding:6px 8px}.swcSplitter{width:100%}.swcSplitter.vss-Splitter--container .vss-Splitter--divider:after{background-color:transparent}.swcSplitter .swcNearElement{margin-right:-24px;padding-bottom:16px}.swcSplitter .swcFarElement{margin-left:-24px}\n", ""]);



/***/ }),
/* 206 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FULFILLED", function() { return FULFILLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IDENTITY", function() { return IDENTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NOOP", function() { return NOOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableGroupMap", function() { return ObservableGroupMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PENDING", function() { return PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REJECTED", function() { return REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewModel", function() { return ViewModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionAsync", function() { return actionAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addHiddenProp", function() { return addHiddenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asyncAction", function() { return asyncAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chunkProcessor", function() { return chunkProcessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computedFn", function() { return computedFn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTransformer", function() { return createTransformer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createViewModel", function() { return createViewModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepObserve", function() { return deepObserve; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deprecated", function() { return deprecated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expr", function() { return expr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fail", function() { return fail$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromPromise", function() { return fromPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromResource", function() { return fromResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromStream", function() { return fromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllMethodsAndProperties", function() { return getAllMethodsAndProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invariant", function() { return invariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPromiseBasedObservable", function() { return isPromiseBasedObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keepAlive", function() { return keepAlive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lazyObservable", function() { return lazyObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "moveItem", function() { return moveItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "now", function() { return now; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queueProcessor", function() { return queueProcessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "task", function() { return task; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toStream", function() { return toStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "whenAsync", function() { return whenAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "whenWithTimeout", function() { return whenWithTimeout; });
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);


var NOOP = function () { };
var IDENTITY = function (_) { return _; };
function fail$1(message) {
    throw new Error("[mobx-utils] " + message);
}
function invariant(cond, message) {
    if (message === void 0) { message = "Illegal state"; }
    if (!cond)
        fail$1(message);
}
var deprecatedMessages = [];
function deprecated(msg) {
    if (deprecatedMessages.indexOf(msg) !== -1)
        return;
    deprecatedMessages.push(msg);
    console.error("[mobx-utils] Deprecated: " + msg);
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value,
    });
}
var deepFields = function (x) {
    return (x &&
        x !== Object.prototype &&
        Object.getOwnPropertyNames(x).concat(deepFields(Object.getPrototypeOf(x)) || []));
};
var distinctDeepFields = function (x) {
    var deepFieldsIndistinct = deepFields(x);
    var deepFieldsDistinct = deepFieldsIndistinct.filter(function (item, index) { return deepFieldsIndistinct.indexOf(item) === index; });
    return deepFieldsDistinct;
};
var getAllMethodsAndProperties = function (x) {
    return distinctDeepFields(x).filter(function (name) { return name !== "constructor" && !~name.indexOf("__"); });
};

var PENDING = "pending";
var FULFILLED = "fulfilled";
var REJECTED = "rejected";
function caseImpl(handlers) {
    switch (this.state) {
        case PENDING:
            return handlers.pending && handlers.pending(this.value);
        case REJECTED:
            return handlers.rejected && handlers.rejected(this.value);
        case FULFILLED:
            return handlers.fulfilled ? handlers.fulfilled(this.value) : this.value;
    }
}
/**
 * `fromPromise` takes a Promise, extends it with 2 observable properties that track
 * the status of the promise and returns it. The returned object has the following observable properties:
 *  - `value`: either the initial value, the value the Promise resolved to, or the value the Promise was rejected with. use `.state` if you need to be able to tell the difference.
 *  - `state`: one of `"pending"`, `"fulfilled"` or `"rejected"`
 *
 * And the following methods:
 * - `case({fulfilled, rejected, pending})`: maps over the result using the provided handlers, or returns `undefined` if a handler isn't available for the current promise state.
 * - `then((value: TValue) => TResult1 | PromiseLike<TResult1>, [(rejectReason: any) => any])`: chains additional handlers to the provided promise.
 *
 * The returned object implements `PromiseLike<TValue>`, so you can chain additional `Promise` handlers using `then`. You may also use it with `await` in `async` functions.
 *
 * Note that the status strings are available as constants:
 * `mobxUtils.PENDING`, `mobxUtils.REJECTED`, `mobxUtil.FULFILLED`
 *
 * fromPromise takes an optional second argument, a previously created `fromPromise` based observable.
 * This is useful to replace one promise based observable with another, without going back to an intermediate
 * "pending" promise state while fetching data. For example:
 *
 * @example
 * \@observer
 * class SearchResults extends React.Component {
 *   \@observable.ref searchResults
 *
 *   componentDidUpdate(nextProps) {
 *     if (nextProps.query !== this.props.query)
 *       this.searchResults = fromPromise(
 *         window.fetch("/search?q=" + nextProps.query),
 *         // by passing, we won't render a pending state if we had a successful search query before
 *         // rather, we will keep showing the previous search results, until the new promise resolves (or rejects)
 *         this.searchResults
 *       )
 *   }
 *
 *   render() {
 *     return this.searchResults.case({
 *        pending: (staleValue) => {
 *          return staleValue || "searching" // <- value might set to previous results while the promise is still pending
 *        },
 *        fulfilled: (value) => {
 *          return value // the fresh results
 *        },
 *        rejected: (error) => {
 *          return "Oops: " + error
 *        }
 *     })
 *   }
 * }
 *
 * Observable promises can be created immediately in a certain state using
 * `fromPromise.reject(reason)` or `fromPromise.resolve(value?)`.
 * The main advantage of `fromPromise.resolve(value)` over `fromPromise(Promise.resolve(value))` is that the first _synchronously_ starts in the desired state.
 *
 * It is possible to directly create a promise using a resolve, reject function:
 * `fromPromise((resolve, reject) => setTimeout(() => resolve(true), 1000))`
 *
 * @example
 * const fetchResult = fromPromise(fetch("http://someurl"))
 *
 * // combine with when..
 * when(
 *   () => fetchResult.state !== "pending",
 *   () => {
 *     console.log("Got ", fetchResult.value)
 *   }
 * )
 *
 * // or a mobx-react component..
 * const myComponent = observer(({ fetchResult }) => {
 *   switch(fetchResult.state) {
 *      case "pending": return <div>Loading...</div>
 *      case "rejected": return <div>Ooops... {fetchResult.value}</div>
 *      case "fulfilled": return <div>Gotcha: {fetchResult.value}</div>
 *   }
 * })
 *
 * // or using the case method instead of switch:
 *
 * const myComponent = observer(({ fetchResult }) =>
 *   fetchResult.case({
 *     pending:   () => <div>Loading...</div>,
 *     rejected:  error => <div>Ooops.. {error}</div>,
 *     fulfilled: value => <div>Gotcha: {value}</div>,
 *   }))
 *
 * // chain additional handler(s) to the resolve/reject:
 *
 * fetchResult.then(
 *   (result) =>  doSomeTransformation(result),
 *   (rejectReason) => console.error('fetchResult was rejected, reason: ' + rejectReason)
 * ).then(
 *   (transformedResult) => console.log('transformed fetchResult: ' + transformedResult)
 * )
 *
 * @param {IThenable<T>} promise The promise which will be observed
 * @param {IThenable<T>} oldPromise? The previously observed promise
 * @returns {IPromiseBasedObservable<T>}
 */
function fromPromise(origPromise, oldPromise) {
    invariant(arguments.length <= 2, "fromPromise expects up to two arguments");
    invariant(typeof origPromise === "function" ||
        (typeof origPromise === "object" &&
            origPromise &&
            typeof origPromise.then === "function"), "Please pass a promise or function to fromPromise");
    if (origPromise.isPromiseBasedObservable === true)
        return origPromise;
    if (typeof origPromise === "function") {
        // If it is a (reject, resolve function, wrap it)
        origPromise = new Promise(origPromise);
    }
    var promise = origPromise;
    origPromise.then(Object(mobx__WEBPACK_IMPORTED_MODULE_0__["action"])("observableFromPromise-resolve", function (value) {
        promise.value = value;
        promise.state = FULFILLED;
    }), Object(mobx__WEBPACK_IMPORTED_MODULE_0__["action"])("observableFromPromise-reject", function (reason) {
        promise.value = reason;
        promise.state = REJECTED;
    }));
    promise.isPromiseBasedObservable = true;
    promise.case = caseImpl;
    var oldData = oldPromise && oldPromise.state === FULFILLED
        ? oldPromise.value
        : undefined;
    Object(mobx__WEBPACK_IMPORTED_MODULE_0__["extendObservable"])(promise, {
        value: oldData,
        state: PENDING,
    }, {}, { deep: false });
    return promise;
}
(function (fromPromise) {
    fromPromise.reject = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["action"])("fromPromise.reject", function (reason) {
        var p = fromPromise(Promise.reject(reason));
        p.state = REJECTED;
        p.value = reason;
        return p;
    });
    function resolveBase(value) {
        if (value === void 0) { value = undefined; }
        var p = fromPromise(Promise.resolve(value));
        p.state = FULFILLED;
        p.value = value;
        return p;
    }
    fromPromise.resolve = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["action"])("fromPromise.resolve", resolveBase);
})(fromPromise || (fromPromise = {}));
/**
 * Returns true if the provided value is a promise-based observable.
 * @param value any
 * @returns {boolean}
 */
function isPromiseBasedObservable(value) {
    return value && value.isPromiseBasedObservable === true;
}

var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/**
 * Moves an item from one position to another, checking that the indexes given are within bounds.
 *
 * @example
 * const source = observable([1, 2, 3])
 * moveItem(source, 0, 1)
 * console.log(source.map(x => x)) // [2, 1, 3]
 *
 * @export
 * @param {ObservableArray<T>} target
 * @param {number} fromIndex
 * @param {number} toIndex
 * @returns {ObservableArray<T>}
 */
function moveItem(target, fromIndex, toIndex) {
    checkIndex(target, fromIndex);
    checkIndex(target, toIndex);
    if (fromIndex === toIndex) {
        return;
    }
    var oldItems = target[mobx__WEBPACK_IMPORTED_MODULE_0__["$mobx"]].values;
    var newItems;
    if (fromIndex < toIndex) {
        newItems = __spreadArrays(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [
            oldItems[fromIndex]
        ], oldItems.slice(toIndex + 1));
    }
    else {
        // toIndex < fromIndex
        newItems = __spreadArrays(oldItems.slice(0, toIndex), [
            oldItems[fromIndex]
        ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
    }
    target.replace(newItems);
    return target;
}
/**
 * Checks whether the specified index is within bounds. Throws if not.
 *
 * @private
 * @param {ObservableArray<any>} target
 * @param {number }index
 */
function checkIndex(target, index) {
    if (index < 0) {
        throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
    }
    var length = target[mobx__WEBPACK_IMPORTED_MODULE_0__["$mobx"]].values.length;
    if (index >= length) {
        throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
    }
}

/**
 * `lazyObservable` creates an observable around a `fetch` method that will not be invoked
 * until the observable is needed the first time.
 * The fetch method receives a `sink` callback which can be used to replace the
 * current value of the lazyObservable. It is allowed to call `sink` multiple times
 * to keep the lazyObservable up to date with some external resource.
 *
 * Note that it is the `current()` call itself which is being tracked by MobX,
 * so make sure that you don't dereference to early.
 *
 * @example
 * const userProfile = lazyObservable(
 *   sink => fetch("/myprofile").then(profile => sink(profile))
 * )
 *
 * // use the userProfile in a React component:
 * const Profile = observer(({ userProfile }) =>
 *   userProfile.current() === undefined
 *   ? <div>Loading user profile...</div>
 *   : <div>{userProfile.current().displayName}</div>
 * )
 *
 * // triggers refresh the userProfile
 * userProfile.refresh()
 *
 * @param {(sink: (newValue: T) => void) => void} fetch method that will be called the first time the value of this observable is accessed. The provided sink can be used to produce a new value, synchronously or asynchronously
 * @param {T} [initialValue=undefined] optional initialValue that will be returned from `current` as long as the `sink` has not been called at least once
 * @returns {{
 *     current(): T,
 *     refresh(): T,
 *     reset(): T
 *     pending: boolean
 * }}
 */
function lazyObservable(fetch, initialValue) {
    if (initialValue === void 0) { initialValue = undefined; }
    var started = false;
    var value = mobx__WEBPACK_IMPORTED_MODULE_0__["observable"].box(initialValue, { deep: false });
    var pending = mobx__WEBPACK_IMPORTED_MODULE_0__["observable"].box(false);
    var currentFnc = function () {
        if (!started) {
            started = true;
            Object(mobx__WEBPACK_IMPORTED_MODULE_0__["_allowStateChanges"])(true, function () {
                pending.set(true);
            });
            fetch(function (newValue) {
                Object(mobx__WEBPACK_IMPORTED_MODULE_0__["_allowStateChanges"])(true, function () {
                    value.set(newValue);
                    pending.set(false);
                });
            });
        }
        return value.get();
    };
    var resetFnc = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["action"])("lazyObservable-reset", function () {
        started = false;
        value.set(initialValue);
        return value.get();
    });
    return {
        current: currentFnc,
        refresh: function () {
            if (started) {
                started = false;
                return currentFnc();
            }
            else {
                return value.get();
            }
        },
        reset: function () {
            return resetFnc();
        },
        get pending() {
            return pending.get();
        },
    };
}

/**
 * `fromResource` creates an observable whose current state can be inspected using `.current()`,
 * and which can be kept in sync with some external datasource that can be subscribed to.
 *
 * The created observable will only subscribe to the datasource if it is in use somewhere,
 * (un)subscribing when needed. To enable `fromResource` to do that two callbacks need to be provided,
 * one to subscribe, and one to unsubscribe. The subscribe callback itself will receive a `sink` callback, which can be used
 * to update the current state of the observable, allowing observes to react.
 *
 * Whatever is passed to `sink` will be returned by `current()`. The values passed to the sink will not be converted to
 * observables automatically, but feel free to do so.
 * It is the `current()` call itself which is being tracked,
 * so make sure that you don't dereference to early.
 *
 * For inspiration, an example integration with the apollo-client on [github](https://github.com/apollostack/apollo-client/issues/503#issuecomment-241101379),
 * or the [implementation](https://github.com/mobxjs/mobx-utils/blob/1d17cf7f7f5200937f68cc0b5e7ec7f3f71dccba/src/now.ts#L43-L57) of `mobxUtils.now`
 *
 * The following example code creates an observable that connects to a `dbUserRecord`,
 * which comes from an imaginary database and notifies when it has changed.
 *
 * @example
 * function createObservableUser(dbUserRecord) {
 *   let currentSubscription;
 *   return fromResource(
 *     (sink) => {
 *       // sink the current state
 *       sink(dbUserRecord.fields)
 *       // subscribe to the record, invoke the sink callback whenever new data arrives
 *       currentSubscription = dbUserRecord.onUpdated(() => {
 *         sink(dbUserRecord.fields)
 *       })
 *     },
 *     () => {
 *       // the user observable is not in use at the moment, unsubscribe (for now)
 *       dbUserRecord.unsubscribe(currentSubscription)
 *     }
 *   )
 * }
 *
 * // usage:
 * const myUserObservable = createObservableUser(myDatabaseConnector.query("name = 'Michel'"))
 *
 * // use the observable in autorun
 * autorun(() => {
 *   // printed everytime the database updates its records
 *   console.log(myUserObservable.current().displayName)
 * })
 *
 * // ... or a component
 * const userComponent = observer(({ user }) =>
 *   <div>{user.current().displayName}</div>
 * )
 *
 * @export
 * @template T
 * @param {(sink: (newValue: T) => void) => void} subscriber
 * @param {IDisposer} [unsubscriber=NOOP]
 * @param {T} [initialValue=undefined] the data that will be returned by `get()` until the `sink` has emitted its first data
 * @returns {{
 *     current(): T;
 *     dispose(): void;
 *     isAlive(): boolean;
 * }}
 */
function fromResource(subscriber, unsubscriber, initialValue) {
    if (unsubscriber === void 0) { unsubscriber = NOOP; }
    if (initialValue === void 0) { initialValue = undefined; }
    var isActive = false;
    var isDisposed = false;
    var value = initialValue;
    var suspender = function () {
        if (isActive) {
            isActive = false;
            unsubscriber();
        }
    };
    var atom = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["createAtom"])("ResourceBasedObservable", function () {
        invariant(!isActive && !isDisposed);
        isActive = true;
        subscriber(function (newValue) {
            Object(mobx__WEBPACK_IMPORTED_MODULE_0__["_allowStateChanges"])(true, function () {
                value = newValue;
                atom.reportChanged();
            });
        });
    }, suspender);
    return {
        current: function () {
            invariant(!isDisposed, "subscribingObservable has already been disposed");
            var isBeingTracked = atom.reportObserved();
            if (!isBeingTracked && !isActive)
                console.warn("Called `get` of a subscribingObservable outside a reaction. Current value will be returned but no new subscription has started");
            return value;
        },
        dispose: function () {
            isDisposed = true;
            suspender();
        },
        isAlive: function () { return isActive; },
    };
}

var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function observableSymbol() {
    return (typeof Symbol === "function" && Symbol.observable) || "@@observable";
}
/**
 * Converts an expression to an observable stream (a.k.a. TC 39 Observable / RxJS observable).
 * The provided expression is tracked by mobx as long as there are subscribers, automatically
 * emitting when new values become available. The expressions respect (trans)actions.
 *
 * @example
 *
 * const user = observable({
 *   firstName: "C.S",
 *   lastName: "Lewis"
 * })
 *
 * Rx.Observable
 *   .from(mobxUtils.toStream(() => user.firstname + user.lastName))
 *   .scan(nameChanges => nameChanges + 1, 0)
 *   .subscribe(nameChanges => console.log("Changed name ", nameChanges, "times"))
 *
 * @export
 * @template T
 * @param {() => T} expression
 * @param {boolean} fireImmediately (by default false)
 * @returns {IObservableStream<T>}
 */
function toStream(expression, fireImmediately) {
    var _a;
    if (fireImmediately === void 0) { fireImmediately = false; }
    var computedValue = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["computed"])(expression);
    return _a = {
            subscribe: function (observer) {
                if ("function" === typeof observer) {
                    return {
                        unsubscribe: computedValue.observe(function (_a) {
                            var newValue = _a.newValue;
                            return observer(newValue);
                        }, fireImmediately),
                    };
                }
                if (observer && "object" === typeof observer && observer.next) {
                    return {
                        unsubscribe: computedValue.observe(function (_a) {
                            var newValue = _a.newValue;
                            return observer.next(newValue);
                        }, fireImmediately),
                    };
                }
                return {
                    unsubscribe: function () { },
                };
            }
        },
        _a[observableSymbol()] = function () {
            return this;
        },
        _a;
}
var StreamListener = /** @class */ (function () {
    function StreamListener(observable, initialValue) {
        var _this = this;
        Object(mobx__WEBPACK_IMPORTED_MODULE_0__["runInAction"])(function () {
            _this.current = initialValue;
            _this.subscription = observable.subscribe(_this);
        });
    }
    StreamListener.prototype.dispose = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    StreamListener.prototype.next = function (value) {
        this.current = value;
    };
    StreamListener.prototype.complete = function () {
        this.dispose();
    };
    StreamListener.prototype.error = function (value) {
        this.current = value;
        this.dispose();
    };
    __decorate([
        mobx__WEBPACK_IMPORTED_MODULE_0__["observable"].ref
    ], StreamListener.prototype, "current", void 0);
    __decorate([
        mobx__WEBPACK_IMPORTED_MODULE_0__["action"].bound
    ], StreamListener.prototype, "next", null);
    __decorate([
        mobx__WEBPACK_IMPORTED_MODULE_0__["action"].bound
    ], StreamListener.prototype, "complete", null);
    __decorate([
        mobx__WEBPACK_IMPORTED_MODULE_0__["action"].bound
    ], StreamListener.prototype, "error", null);
    return StreamListener;
}());
function fromStream(observable, initialValue) {
    if (initialValue === void 0) { initialValue = undefined; }
    return new StreamListener(observable, initialValue);
}

var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate$1 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RESERVED_NAMES = ["model", "reset", "submit", "isDirty", "isPropertyDirty", "resetProperty"];
var ViewModel = /** @class */ (function () {
    function ViewModel(model) {
        var _this = this;
        this.model = model;
        this.localValues = mobx__WEBPACK_IMPORTED_MODULE_0__["observable"].map({});
        this.localComputedValues = mobx__WEBPACK_IMPORTED_MODULE_0__["observable"].map({});
        this.isPropertyDirty = function (key) {
            return _this.localValues.has(key);
        };
        invariant(Object(mobx__WEBPACK_IMPORTED_MODULE_0__["isObservableObject"])(model), "createViewModel expects an observable object");
        // use this helper as Object.getOwnPropertyNames doesn't return getters
        getAllMethodsAndProperties(model).forEach(function (key) {
            if (key === mobx__WEBPACK_IMPORTED_MODULE_0__["$mobx"] || key === "__mobxDidRunLazyInitializers") {
                return;
            }
            invariant(RESERVED_NAMES.indexOf(key) === -1, "The propertyname " + key + " is reserved and cannot be used with viewModels");
            if (Object(mobx__WEBPACK_IMPORTED_MODULE_0__["isComputedProp"])(model, key)) {
                var derivation = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["_getAdministration"])(model, key).derivation; // Fixme: there is no clear api to get the derivation
                _this.localComputedValues.set(key, Object(mobx__WEBPACK_IMPORTED_MODULE_0__["computed"])(derivation.bind(_this)));
            }
            var descriptor = Object.getOwnPropertyDescriptor(model, key);
            var additionalDescriptor = descriptor ? { enumerable: descriptor.enumerable } : {};
            Object.defineProperty(_this, key, __assign(__assign({}, additionalDescriptor), { configurable: true, get: function () {
                    if (Object(mobx__WEBPACK_IMPORTED_MODULE_0__["isComputedProp"])(model, key))
                        return _this.localComputedValues.get(key).get();
                    if (_this.isPropertyDirty(key))
                        return _this.localValues.get(key);
                    else
                        return _this.model[key];
                }, set: Object(mobx__WEBPACK_IMPORTED_MODULE_0__["action"])(function (value) {
                    if (value !== _this.model[key]) {
                        _this.localValues.set(key, value);
                    }
                    else {
                        _this.localValues.delete(key);
                    }
                }) }));
        });
    }
    Object.defineProperty(ViewModel.prototype, "isDirty", {
        get: function () {
            return this.localValues.size > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewModel.prototype, "changedValues", {
        get: function () {
            return this.localValues.toJS();
        },
        enumerable: false,
        configurable: true
    });
    ViewModel.prototype.submit = function () {
        var _this = this;
        Object(mobx__WEBPACK_IMPORTED_MODULE_0__["keys"])(this.localValues).forEach(function (key) {
            var source = _this.localValues.get(key);
            var destination = _this.model[key];
            if (Object(mobx__WEBPACK_IMPORTED_MODULE_0__["isObservableArray"])(destination)) {
                destination.replace(source);
            }
            else if (Object(mobx__WEBPACK_IMPORTED_MODULE_0__["isObservableMap"])(destination)) {
                destination.clear();
                destination.merge(source);
            }
            else if (!Object(mobx__WEBPACK_IMPORTED_MODULE_0__["isComputed"])(source)) {
                _this.model[key] = source;
            }
        });
        this.localValues.clear();
    };
    ViewModel.prototype.reset = function () {
        this.localValues.clear();
    };
    ViewModel.prototype.resetProperty = function (key) {
        this.localValues.delete(key);
    };
    __decorate$1([
        mobx__WEBPACK_IMPORTED_MODULE_0__["computed"]
    ], ViewModel.prototype, "isDirty", null);
    __decorate$1([
        mobx__WEBPACK_IMPORTED_MODULE_0__["computed"]
    ], ViewModel.prototype, "changedValues", null);
    __decorate$1([
        mobx__WEBPACK_IMPORTED_MODULE_0__["action"].bound
    ], ViewModel.prototype, "submit", null);
    __decorate$1([
        mobx__WEBPACK_IMPORTED_MODULE_0__["action"].bound
    ], ViewModel.prototype, "reset", null);
    __decorate$1([
        mobx__WEBPACK_IMPORTED_MODULE_0__["action"].bound
    ], ViewModel.prototype, "resetProperty", null);
    return ViewModel;
}());
/**
 * `createViewModel` takes an object with observable properties (model)
 * and wraps a viewmodel around it. The viewmodel proxies all enumerable properties of the original model with the following behavior:
 *  - as long as no new value has been assigned to the viewmodel property, the original property will be returned.
 *  - any future change in the model will be visible in the viewmodel as well unless the viewmodel property was dirty at the time of the attempted change.
 *  - once a new value has been assigned to a property of the viewmodel, that value will be returned during a read of that property in the future. However, the original model remain untouched until `submit()` is called.
 *
 * The viewmodel exposes the following additional methods, besides all the enumerable properties of the model:
 * - `submit()`: copies all the values of the viewmodel to the model and resets the state
 * - `reset()`: resets the state of the viewmodel, abandoning all local modifications
 * - `resetProperty(propName)`: resets the specified property of the viewmodel
 * - `isDirty`: observable property indicating if the viewModel contains any modifications
 * - `isPropertyDirty(propName)`: returns true if the specified property is dirty
 * - `changedValues`: returns a key / value map with the properties that have been changed in the model so far
 * - `model`: The original model object for which this viewModel was created
 *
 * You may use observable arrays, maps and objects with `createViewModel` but keep in mind to assign fresh instances of those to the viewmodel's properties, otherwise you would end up modifying the properties of the original model.
 * Note that if you read a non-dirty property, viewmodel only proxies the read to the model. You therefore need to assign a fresh instance not only the first time you make the assignment but also after calling `reset()` or `submit()`.
 *
 * @example
 * class Todo {
 *   \@observable title = "Test"
 * }
 *
 * const model = new Todo()
 * const viewModel = createViewModel(model);
 *
 * autorun(() => console.log(viewModel.model.title, ",", viewModel.title))
 * // prints "Test, Test"
 * model.title = "Get coffee"
 * // prints "Get coffee, Get coffee", viewModel just proxies to model
 * viewModel.title = "Get tea"
 * // prints "Get coffee, Get tea", viewModel's title is now dirty, and the local value will be printed
 * viewModel.submit()
 * // prints "Get tea, Get tea", changes submitted from the viewModel to the model, viewModel is proxying again
 * viewModel.title = "Get cookie"
 * // prints "Get tea, Get cookie" // viewModel has diverged again
 * viewModel.reset()
 * // prints "Get tea, Get tea", changes of the viewModel have been abandoned
 *
 * @param {T} model
 * @returns {(T & IViewModel<T>)}
 * ```
 */
function createViewModel(model) {
    return new ViewModel(model);
}

/**
 * Like normal `when`, except that this `when` will automatically dispose if the condition isn't met within a certain amount of time.
 *
 * @example
 * test("expect store to load", t => {
 *   const store = {
 *     items: [],
 *     loaded: false
 *   }
 *   fetchDataForStore((data) => {
 *     store.items = data;
 *     store.loaded = true;
 *   })
 *   whenWithTimeout(
 *     () => store.loaded
 *     () => t.end()
 *     2000,
 *     () => t.fail("store didn't load with 2 secs")
 *   )
 * })
 *
 *
 * @export
 * @param {() => boolean} expr see when, the expression to await
 * @param {() => void} action see when, the action to execut when expr returns truthy
 * @param {number} [timeout=10000] maximum amount when spends waiting before giving up
 * @param {any} [onTimeout=() => {}] the ontimeout handler will be called if the condition wasn't met within the given time
 * @returns {IDisposer} disposer function that can be used to cancel the when prematurely. Neither action or onTimeout will be fired if disposed
 */
function whenWithTimeout(expr, action, timeout, onTimeout) {
    if (timeout === void 0) { timeout = 10000; }
    if (onTimeout === void 0) { onTimeout = function () { }; }
    deprecated("whenWithTimeout is deprecated, use mobx.when with timeout option instead");
    return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["when"])(expr, action, {
        timeout: timeout,
        onError: onTimeout,
    });
}

/**
 * MobX normally suspends any computed value that is not in use by any reaction,
 * and lazily re-evaluates the expression if needed outside a reaction while not in use.
 * `keepAlive` marks a computed value as always in use, meaning that it will always fresh, but never disposed automatically.
 *
 * @example
 * const obj = observable({
 *   number: 3,
 *   doubler: function() { return this.number * 2 }
 * })
 * const stop = keepAlive(obj, "doubler")
 *
 * @param {Object} target an object that has a computed property, created by `@computed` or `extendObservable`
 * @param {string} property the name of the property to keep alive
 * @returns {IDisposer} stops this keep alive so that the computed value goes back to normal behavior
 */
/**
 * @example
 * const number = observable(3)
 * const doubler = computed(() => number.get() * 2)
 * const stop = keepAlive(doubler)
 * // doubler will now stay in sync reactively even when there are no further observers
 * stop()
 * // normal behavior, doubler results will be recomputed if not observed but needed, but lazily
 *
 * @param {IComputedValue<any>} computedValue created using the `computed` function
 * @returns {IDisposer} stops this keep alive so that the computed value goes back to normal behavior
 */
function keepAlive(_1, _2) {
    var computed = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["getAtom"])(_1, _2);
    if (!computed)
        throw new Error("No computed provided, please provide an object created with `computed(() => expr)` or an object + property name");
    return computed.observe(function () { });
}

/**
 * `queueProcessor` takes an observable array, observes it and calls `processor`
 * once for each item added to the observable array, optionally debouncing the action
 *
 * @example
 * const pendingNotifications = observable([])
 * const stop = queueProcessor(pendingNotifications, msg => {
 *   // show Desktop notification
 *   new Notification(msg);
 * })
 *
 * // usage:
 * pendingNotifications.push("test!")
 *
 * @param {T[]} observableArray observable array instance to track
 * @param {(item: T) => void} processor action to call per item
 * @param {number} [debounce=0] optional debounce time in ms. With debounce 0 the processor will run synchronously
 * @returns {IDisposer} stops the processor
 */
function queueProcessor(observableArray, processor, debounce) {
    if (debounce === void 0) { debounce = 0; }
    if (!Object(mobx__WEBPACK_IMPORTED_MODULE_0__["isObservableArray"])(observableArray))
        throw new Error("Expected observable array as first argument");
    if (!Object(mobx__WEBPACK_IMPORTED_MODULE_0__["isAction"])(processor))
        processor = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["action"])("queueProcessor", processor);
    var runner = function () {
        // construct a final set
        var items = observableArray.slice(0);
        // clear the queue for next iteration
        Object(mobx__WEBPACK_IMPORTED_MODULE_0__["runInAction"])(function () { return observableArray.splice(0); });
        // fire processor
        items.forEach(processor);
    };
    if (debounce > 0)
        return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["autorun"])(runner, { delay: debounce });
    else
        return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["autorun"])(runner);
}

/**
 * `chunkProcessor` takes an observable array, observes it and calls `processor`
 * once for a chunk of items added to the observable array, optionally deboucing the action.
 * The maximum chunk size can be limited by number.
 * This allows both, splitting larger into smaller chunks or (when debounced) combining smaller
 * chunks and/or single items into reasonable chunks of work.
 *
 * @example
 * const trackedActions = observable([])
 * const stop = chunkProcessor(trackedActions, chunkOfMax10Items => {
 *   sendTrackedActionsToServer(chunkOfMax10Items);
 * }, 100, 10)
 *
 * // usage:
 * trackedActions.push("scrolled")
 * trackedActions.push("hoveredButton")
 * // when both pushes happen within 100ms, there will be only one call to server
 *
 * @param {T[]} observableArray observable array instance to track
 * @param {(item: T[]) => void} processor action to call per item
 * @param {number} [debounce=0] optional debounce time in ms. With debounce 0 the processor will run synchronously
 * @param {number} [maxChunkSize=0] optionally do not call on full array but smaller chunks. With 0 it will process the full array.
 * @returns {IDisposer} stops the processor
 */
function chunkProcessor(observableArray, processor, debounce, maxChunkSize) {
    if (debounce === void 0) { debounce = 0; }
    if (maxChunkSize === void 0) { maxChunkSize = 0; }
    if (!Object(mobx__WEBPACK_IMPORTED_MODULE_0__["isObservableArray"])(observableArray))
        throw new Error("Expected observable array as first argument");
    if (!Object(mobx__WEBPACK_IMPORTED_MODULE_0__["isAction"])(processor))
        processor = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["action"])("chunkProcessor", processor);
    var runner = function () {
        var _loop_1 = function () {
            var chunkSize = maxChunkSize === 0
                ? observableArray.length
                : Math.min(observableArray.length, maxChunkSize);
            // construct a final set
            var items = observableArray.slice(0, chunkSize);
            // clear the slice for next iteration
            Object(mobx__WEBPACK_IMPORTED_MODULE_0__["runInAction"])(function () { return observableArray.splice(0, chunkSize); });
            // fire processor
            processor(items);
        };
        while (observableArray.length > 0) {
            _loop_1();
        }
    };
    if (debounce > 0)
        return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["autorun"])(runner, { delay: debounce });
    else
        return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["autorun"])(runner);
}

var tickers = {};
/**
 * Returns the current date time as epoch number.
 * The date time is read from an observable which is updated automatically after the given interval.
 * So basically it treats time as an observable.
 *
 * The function takes an interval as parameter, which indicates how often `now()` will return a new value.
 * If no interval is given, it will update each second. If "frame" is specified, it will update each time a
 * `requestAnimationFrame` is available.
 *
 * Multiple clocks with the same interval will automatically be synchronized.
 *
 * Countdown example: https://jsfiddle.net/mweststrate/na0qdmkw/
 *
 * @example
 *
 * const start = Date.now()
 *
 * autorun(() => {
 *   console.log("Seconds elapsed: ", (mobxUtils.now() - start) / 1000)
 * })
 *
 *
 * @export
 * @param {(number | "frame")} [interval=1000] interval in milliseconds about how often the interval should update
 * @returns
 */
function now(interval) {
    if (interval === void 0) { interval = 1000; }
    if (!Object(mobx__WEBPACK_IMPORTED_MODULE_0__["_isComputingDerivation"])()) {
        // See #40
        return Date.now();
    }
    if (!tickers[interval]) {
        if (typeof interval === "number")
            tickers[interval] = createIntervalTicker(interval);
        else
            tickers[interval] = createAnimationFrameTicker();
    }
    return tickers[interval].current();
}
function createIntervalTicker(interval) {
    var subscriptionHandle;
    return fromResource(function (sink) {
        sink(Date.now());
        subscriptionHandle = setInterval(function () { return sink(Date.now()); }, interval);
    }, function () {
        clearInterval(subscriptionHandle);
    }, Date.now());
}
function createAnimationFrameTicker() {
    var frameBasedTicker = fromResource(function (sink) {
        sink(Date.now());
        function scheduleTick() {
            window.requestAnimationFrame(function () {
                sink(Date.now());
                if (frameBasedTicker.isAlive())
                    scheduleTick();
            });
        }
        scheduleTick();
    }, function () { }, Date.now());
    return frameBasedTicker;
}

var __assign$1 = (undefined && undefined.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
/**
 * _deprecated_ this functionality can now be found as `flow` in the mobx package. However, `flow` is not applicable as decorator, where `asyncAction` still is.
 *
 *
 *
 * `asyncAction` takes a generator function and automatically wraps all parts of the process in actions. See the examples below.
 * `asyncAction` can be used both as decorator or to wrap functions.
 *
 * - It is important that `asyncAction should always be used with a generator function (recognizable as `function*` or `*name` syntax)
 * - Each yield statement should return a Promise. The generator function will continue as soon as the promise settles, with the settled value
 * - When the generator function finishes, you can return a normal value. The `asyncAction` wrapped function will always produce a promise delivering that value.
 *
 * When using the mobx devTools, an asyncAction will emit `action` events with names like:
 * * `"fetchUsers - runid: 6 - init"`
 * * `"fetchUsers - runid: 6 - yield 0"`
 * * `"fetchUsers - runid: 6 - yield 1"`
 *
 * The `runId` represents the generator instance. In other words, if `fetchUsers` is invoked multiple times concurrently, the events with the same `runid` belong together.
 * The `yield` number indicates the progress of the generator. `init` indicates spawning (it won't do anything, but you can find the original arguments of the `asyncAction` here).
 * `yield 0` ... `yield n` indicates the code block that is now being executed. `yield 0` is before the first `yield`, `yield 1` after the first one etc. Note that yield numbers are not determined lexically but by the runtime flow.
 *
 * `asyncActions` requires `Promise` and `generators` to be available on the target environment. Polyfill `Promise` if needed. Both TypeScript and Babel can compile generator functions down to ES5.
 *
 *  N.B. due to a [babel limitation](https://github.com/loganfsmyth/babel-plugin-transform-decorators-legacy/issues/26), in Babel generatos cannot be combined with decorators. See also [#70](https://github.com/mobxjs/mobx-utils/issues/70)
 *
 *
 * @example
 * import {asyncAction} from "mobx-utils"
 *
 * let users = []
 *
 * const fetchUsers = asyncAction("fetchUsers", function* (url) {
 *   const start = Date.now()
 *   const data = yield window.fetch(url)
 *   users = yield data.json()
 *   return start - Date.now()
 * })
 *
 * fetchUsers("http://users.com").then(time => {
 *   console.dir("Got users", users, "in ", time, "ms")
 * })
 *
 * @example
 * import {asyncAction} from "mobx-utils"
 *
 * mobx.configure({ enforceActions: "observed" }) // don't allow state modifications outside actions
 *
 * class Store {
 * 	\@observable githubProjects = []
 * 	\@observable = "pending" // "pending" / "done" / "error"
 *
 * 	\@asyncAction
 * 	*fetchProjects() { // <- note the star, this a generator function!
 * 		this.githubProjects = []
 * 		this.state = "pending"
 * 		try {
 * 			const projects = yield fetchGithubProjectsSomehow() // yield instead of await
 * 			const filteredProjects = somePreprocessing(projects)
 * 			// the asynchronous blocks will automatically be wrapped actions
 * 			this.state = "done"
 * 			this.githubProjects = filteredProjects
 * 		} catch (error) {
 * 			this.state = "error"
 * 		}
 * 	}
 * }
 *
 * @export
 * @returns {Promise}
 */
function asyncAction(arg1, arg2) {
    // decorator
    if (typeof arguments[1] === "string") {
        var name_1 = arguments[1];
        var descriptor_1 = arguments[2];
        if (descriptor_1 && descriptor_1.value) {
            return Object.assign({}, descriptor_1, {
                value: Object(mobx__WEBPACK_IMPORTED_MODULE_0__["flow"])(descriptor_1.value),
            });
        }
        else {
            return Object.assign({}, descriptor_1, {
                set: function (v) {
                    Object.defineProperty(this, name_1, __assign$1(__assign$1({}, descriptor_1), { value: Object(mobx__WEBPACK_IMPORTED_MODULE_0__["flow"])(v) }));
                },
            });
        }
    }
    // direct invocation
    var generator = typeof arg1 === "string" ? arg2 : arg1;
    var name = typeof arg1 === "string" ? arg1 : generator.name || "<unnamed async action>";
    deprecated("asyncAction is deprecated. use mobx.flow instead");
    return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["flow"])(generator); // name get's dropped..
}

/**
 * _deprecated_ whenAsync is deprecated, use mobx.when without effect instead.
 *
 * Like normal `when`, except that this `when` will return a promise that resolves when the expression becomes truthy
 *
 * @example
 * await whenAsync(() => !state.someBoolean)
 *
 * @export
 * @param {() => boolean} fn see when, the expression to await
 * @param {number} timeout maximum amount of time to wait, before the promise rejects
 * @returns Promise for when an observable eventually matches some condition. Rejects if timeout is provided and has expired
 */
function whenAsync(fn, timeout) {
    if (timeout === void 0) { timeout = 0; }
    deprecated("whenAsync is deprecated, use mobx.when without effect instead");
    return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["when"])(fn, {
        timeout: timeout,
    });
}

/**
 * expr can be used to create temporarily views inside views.
 * This can be improved to improve performance if a value changes often, but usually doesn't affect the outcome of an expression.
 *
 * In the following example the expression prevents that a component is rerender _each time_ the selection changes;
 * instead it will only rerenders when the current todo is (de)selected.
 *
 * @example
 * const Todo = observer((props) => {
 *     const todo = props.todo;
 *     const isSelected = mobxUtils.expr(() => props.viewState.selection === todo);
 *     return <div className={isSelected ? "todo todo-selected" : "todo"}>{todo.title}</div>
 * });
 *
 */
function expr(expr) {
    if (!Object(mobx__WEBPACK_IMPORTED_MODULE_0__["_isComputingDerivation"])())
        console.warn("'expr' should only be used inside other reactive functions.");
    // optimization: would be more efficient if the expr itself wouldn't be evaluated first on the next change, but just a 'changed' signal would be fired
    return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["computed"])(expr).get();
}

var __assign$2 = (undefined && undefined.__assign) || function () {
    __assign$2 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};
var memoizationId = 0;
function createTransformer(transformer, arg2) {
    invariant(typeof transformer === "function" && transformer.length < 2, "createTransformer expects a function that accepts one argument");
    // Memoizes: object id -> reactive view that applies transformer to the object
    var views = {};
    var onCleanup = undefined;
    var keepAlive = false;
    var debugNameGenerator = undefined;
    if (typeof arg2 === "object") {
        onCleanup = arg2.onCleanup;
        keepAlive = arg2.keepAlive !== undefined ? arg2.keepAlive : false;
        debugNameGenerator = arg2.debugNameGenerator;
    }
    else if (typeof arg2 === "function") {
        onCleanup = arg2;
    }
    function createView(sourceIdentifier, sourceObject) {
        var latestValue;
        var computedValueOptions = {};
        if (typeof arg2 === "object") {
            onCleanup = arg2.onCleanup;
            debugNameGenerator = arg2.debugNameGenerator;
            computedValueOptions = arg2;
        }
        else if (typeof arg2 === "function") {
            onCleanup = arg2;
        }
        else {
            onCleanup = undefined;
            debugNameGenerator = undefined;
        }
        var prettifiedName = debugNameGenerator
            ? debugNameGenerator(sourceObject)
            : "Transformer-" + transformer.name + "-" + sourceIdentifier;
        var expr = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["computed"])(function () {
            return (latestValue = transformer(sourceObject));
        }, __assign$2(__assign$2({}, computedValueOptions), { name: prettifiedName }));
        if (!keepAlive) {
            var disposer_1 = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["onBecomeUnobserved"])(expr, function () {
                delete views[sourceIdentifier];
                disposer_1();
                if (onCleanup)
                    onCleanup(latestValue, sourceObject);
            });
        }
        return expr;
    }
    var memoWarned = false;
    return function (object) {
        var identifier = getMemoizationId(object);
        var reactiveView = views[identifier];
        if (reactiveView)
            return reactiveView.get();
        if (!keepAlive && !Object(mobx__WEBPACK_IMPORTED_MODULE_0__["_isComputingDerivation"])()) {
            if (!memoWarned) {
                console.warn("invoking a transformer from outside a reactive context won't memorized " +
                    "and is cleaned up immediately, unless keepAlive is set");
                memoWarned = true;
            }
            var value = transformer(object);
            if (onCleanup)
                onCleanup(value, object);
            return value;
        }
        // Not in cache; create a reactive view
        reactiveView = views[identifier] = createView(identifier, object);
        return reactiveView.get();
    };
}
function getMemoizationId(object) {
    var objectType = typeof object;
    if (objectType === "string")
        return "string:" + object;
    if (objectType === "number")
        return "number:" + object;
    if (object === null || (objectType !== "object" && objectType !== "function"))
        throw new Error("[mobx-utils] transform expected an object, function, string or number, got: " + String(object));
    var tid = object.$transformId;
    if (tid === undefined) {
        tid = "memoizationId:" + ++memoizationId;
        addHiddenProp(object, "$transformId", tid);
    }
    return tid;
}

function buildPath(entry) {
    if (!entry)
        return "ROOT";
    var res = [];
    while (entry.parent) {
        res.push(entry.path);
        entry = entry.parent;
    }
    return res.reverse().join("/");
}
function isRecursivelyObservable(thing) {
    return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["isObservableObject"])(thing) || Object(mobx__WEBPACK_IMPORTED_MODULE_0__["isObservableArray"])(thing) || Object(mobx__WEBPACK_IMPORTED_MODULE_0__["isObservableMap"])(thing);
}
/**
 * Given an object, deeply observes the given object.
 * It is like `observe` from mobx, but applied recursively, including all future children.
 *
 * Note that the given object cannot ever contain cycles and should be a tree.
 *
 * As benefit: path and root will be provided in the callback, so the signature of the listener is
 * (change, path, root) => void
 *
 * The returned disposer can be invoked to clean up the listener
 *
 * deepObserve cannot be used on computed values.
 *
 * @example
 * const disposer = deepObserve(target, (change, path) => {
 *    console.dir(change)
 * })
 */
function deepObserve(target, listener) {
    var entrySet = new WeakMap();
    function genericListener(change) {
        var entry = entrySet.get(change.object);
        processChange(change, entry);
        listener(change, buildPath(entry), target);
    }
    function processChange(change, parent) {
        switch (change.type) {
            // Object changes
            case "add": // also for map
                observeRecursively(change.newValue, parent, change.name);
                break;
            case "update": // also for array and map
                unobserveRecursively(change.oldValue);
                observeRecursively(change.newValue, parent, change.name || "" + change.index);
                break;
            case "remove": // object
            case "delete": // map
                unobserveRecursively(change.oldValue);
                break;
            // Array changes
            case "splice":
                change.removed.map(unobserveRecursively);
                change.added.forEach(function (value, idx) {
                    return observeRecursively(value, parent, "" + (change.index + idx));
                });
                // update paths
                for (var i = change.index + change.addedCount; i < change.object.length; i++) {
                    if (isRecursivelyObservable(change.object[i])) {
                        var entry = entrySet.get(change.object[i]);
                        if (entry)
                            entry.path = "" + i;
                    }
                }
                break;
        }
    }
    function observeRecursively(thing, parent, path) {
        if (isRecursivelyObservable(thing)) {
            var entry = entrySet.get(thing);
            if (entry) {
                if (entry.parent !== parent || entry.path !== path)
                    // MWE: this constraint is artificial, and this tool could be made to work with cycles,
                    // but it increases administration complexity, has tricky edge cases and the meaning of 'path'
                    // would become less clear. So doesn't seem to be needed for now
                    throw new Error("The same observable object cannot appear twice in the same tree," +
                        (" trying to assign it to '" + buildPath(parent) + "/" + path + "',") +
                        (" but it already exists at '" + buildPath(entry.parent) + "/" + entry.path + "'"));
            }
            else {
                var entry_1 = {
                    parent: parent,
                    path: path,
                    dispose: Object(mobx__WEBPACK_IMPORTED_MODULE_0__["observe"])(thing, genericListener),
                };
                entrySet.set(thing, entry_1);
                Object(mobx__WEBPACK_IMPORTED_MODULE_0__["entries"])(thing).forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    return observeRecursively(value, entry_1, key);
                });
            }
        }
    }
    function unobserveRecursively(thing) {
        if (isRecursivelyObservable(thing)) {
            var entry = entrySet.get(thing);
            if (!entry)
                return;
            entrySet.delete(thing);
            entry.dispose();
            Object(mobx__WEBPACK_IMPORTED_MODULE_0__["values"])(thing).forEach(unobserveRecursively);
        }
    }
    observeRecursively(target, undefined, "");
    return function () {
        unobserveRecursively(target);
    };
}

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Reactively sorts a base observable array into multiple observable arrays based on the value of a
 * `groupBy: (item: T) => G` function.
 *
 * This observes the individual computed groupBy values and only updates the source and dest arrays
 * when there is an actual change, so this is far more efficient than, for example
 * `base.filter(i => groupBy(i) === 'we')`. Call #dispose() to stop tracking.
 *
 * No guarantees are made about the order of items in the grouped arrays.
 *
 * The resulting map of arrays is read-only. clear(), set(), delete() are not supported and
 * modifying the group arrays will lead to undefined behavior.
 *
 * NB: ObservableGroupMap relies on `Symbol`s. If you are targeting a platform which doesn't
 * support these natively, you will need to provide a polyfill.
 *
 * @param {array} base The array to sort into groups.
 * @param {function} groupBy The function used for grouping.
 * @param options Object with properties:
 *  `name`: Debug name of this ObservableGroupMap.
 *  `keyToName`: Function to create the debug names of the observable group arrays.
 *
 * @example
 * const slices = observable([
 *     { day: "mo", hours: 12 },
 *     { day: "tu", hours: 2 },
 * ])
 * const slicesByDay = new ObservableGroupMap(slices, (slice) => slice.day)
 * autorun(() => console.log(
 *     slicesByDay.get("mo")?.length ?? 0,
 *     slicesByDay.get("we"))) // outputs 1, undefined
 * slices[0].day = "we" // outputs 0, [{ day: "we", hours: 12 }]
 */
var ObservableGroupMap = /** @class */ (function (_super) {
    __extends(ObservableGroupMap, _super);
    function ObservableGroupMap(base, groupBy, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.name, name = _c === void 0 ? "ogm" + ((Math.random() * 1000) | 0) : _c, _d = _b.keyToName, keyToName = _d === void 0 ? function (x) { return "" + x; } : _d;
        var _this = _super.call(this) || this;
        _this._keyToName = keyToName;
        _this._groupBy = groupBy;
        _this._ogmInfoKey = Symbol("ogmInfo" + name);
        _this._base = base;
        for (var i = 0; i < base.length; i++) {
            _this._addItem(base[i]);
        }
        _this._disposeBaseObserver = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["observe"])(_this._base, function (change) {
            if ("splice" === change.type) {
                Object(mobx__WEBPACK_IMPORTED_MODULE_0__["transaction"])(function () {
                    for (var _i = 0, _a = change.removed; _i < _a.length; _i++) {
                        var removed = _a[_i];
                        _this._removeItem(removed);
                    }
                    for (var _b = 0, _c = change.added; _b < _c.length; _b++) {
                        var added = _c[_b];
                        _this._addItem(added);
                    }
                });
            }
            else if ("update" === change.type) {
                Object(mobx__WEBPACK_IMPORTED_MODULE_0__["transaction"])(function () {
                    _this._removeItem(change.oldValue);
                    _this._addItem(change.newValue);
                });
            }
            else {
                throw new Error("illegal state");
            }
        });
        return _this;
    }
    ObservableGroupMap.prototype.clear = function () {
        throw new Error("not supported");
    };
    ObservableGroupMap.prototype.delete = function (_key) {
        throw new Error("not supported");
    };
    ObservableGroupMap.prototype.set = function (_key, _value) {
        throw new Error("not supported");
    };
    /**
     * Disposes all observers created during construction and removes state added to base array
     * items.
     */
    ObservableGroupMap.prototype.dispose = function () {
        this._disposeBaseObserver();
        for (var i = 0; i < this._base.length; i++) {
            var item = this._base[i];
            var grouperItemInfo = item[this._ogmInfoKey];
            grouperItemInfo.reaction();
            delete item[this._ogmInfoKey];
        }
    };
    ObservableGroupMap.prototype._getGroupArr = function (key) {
        var result = _super.prototype.get.call(this, key);
        if (undefined === result) {
            result = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["observable"])([], { name: "GroupArray[" + this._keyToName(key) + "]", deep: false });
            _super.prototype.set.call(this, key, result);
        }
        return result;
    };
    ObservableGroupMap.prototype._removeFromGroupArr = function (key, itemIndex) {
        var arr = _super.prototype.get.call(this, key);
        if (1 === arr.length) {
            _super.prototype.delete.call(this, key);
        }
        else if (itemIndex === arr.length - 1) {
            // last position in array
            arr.length--;
        }
        else {
            arr[itemIndex] = arr[arr.length - 1];
            arr[itemIndex][this._ogmInfoKey].groupArrIndex = itemIndex;
            arr.length--;
        }
    };
    ObservableGroupMap.prototype._addItem = function (item) {
        var _this = this;
        var groupByValue = this._groupBy(item);
        var groupArr = this._getGroupArr(groupByValue);
        var value = {
            groupByValue: groupByValue,
            groupArrIndex: groupArr.length,
            reaction: Object(mobx__WEBPACK_IMPORTED_MODULE_0__["reaction"])(function () { return _this._groupBy(item); }, function (newGroupByValue, _r) {
                var grouperItemInfo = item[_this._ogmInfoKey];
                _this._removeFromGroupArr(grouperItemInfo.groupByValue, grouperItemInfo.groupArrIndex);
                var newGroupArr = _this._getGroupArr(newGroupByValue);
                var newGroupArrIndex = newGroupArr.length;
                newGroupArr.push(item);
                grouperItemInfo.groupByValue = newGroupByValue;
                grouperItemInfo.groupArrIndex = newGroupArrIndex;
            }),
        };
        Object.defineProperty(item, this._ogmInfoKey, {
            configurable: true,
            enumerable: false,
            value: value,
        });
        groupArr.push(item);
    };
    ObservableGroupMap.prototype._removeItem = function (item) {
        var grouperItemInfo = item[this._ogmInfoKey];
        this._removeFromGroupArr(grouperItemInfo.groupByValue, grouperItemInfo.groupArrIndex);
        grouperItemInfo.reaction();
        delete item[this._ogmInfoKey];
    };
    return ObservableGroupMap;
}(mobx__WEBPACK_IMPORTED_MODULE_0__["ObservableMap"]));

/**
 * @private
 */
var DeepMapEntry = /** @class */ (function () {
    function DeepMapEntry(base, args) {
        this.base = base;
        this.args = args;
        this.closestIdx = 0;
        this.isDisposed = false;
        var current = (this.closest = this.root = base);
        var i = 0;
        for (; i < this.args.length - 1; i++) {
            current = current.get(args[i]);
            if (current)
                this.closest = current;
            else
                break;
        }
        this.closestIdx = i;
    }
    DeepMapEntry.prototype.exists = function () {
        this.assertNotDisposed();
        var l = this.args.length;
        return this.closestIdx >= l - 1 && this.closest.has(this.args[l - 1]);
    };
    DeepMapEntry.prototype.get = function () {
        this.assertNotDisposed();
        if (!this.exists())
            throw new Error("Entry doesn't exist");
        return this.closest.get(this.args[this.args.length - 1]);
    };
    DeepMapEntry.prototype.set = function (value) {
        this.assertNotDisposed();
        var l = this.args.length;
        var current = this.closest;
        // create remaining maps
        for (var i = this.closestIdx; i < l - 1; i++) {
            var m = new Map();
            current.set(this.args[i], m);
            current = m;
        }
        this.closestIdx = l - 1;
        this.closest = current;
        current.set(this.args[l - 1], value);
    };
    DeepMapEntry.prototype.delete = function () {
        this.assertNotDisposed();
        if (!this.exists())
            throw new Error("Entry doesn't exist");
        var l = this.args.length;
        this.closest.delete(this.args[l - 1]);
        // clean up remaining maps if needed (reconstruct stack first)
        var c = this.root;
        var maps = [c];
        for (var i = 0; i < l - 1; i++) {
            c = c.get(this.args[i]);
            maps.push(c);
        }
        for (var i = maps.length - 1; i > 0; i--) {
            if (maps[i].size === 0)
                maps[i - 1].delete(this.args[i - 1]);
        }
        this.isDisposed = true;
    };
    DeepMapEntry.prototype.assertNotDisposed = function () {
        // TODO: once this becomes annoying, we should introduce a reset method to re-run the constructor logic
        if (this.isDisposed)
            throw new Error("Concurrent modification exception");
    };
    return DeepMapEntry;
}());
/**
 * @private
 */
var DeepMap = /** @class */ (function () {
    function DeepMap() {
        this.store = new Map();
        this.argsLength = -1;
    }
    DeepMap.prototype.entry = function (args) {
        if (this.argsLength === -1)
            this.argsLength = args.length;
        else if (this.argsLength !== args.length)
            throw new Error("DeepMap should be used with functions with a consistent length, expected: " + this.argsLength + ", got: " + args.length);
        if (this.last)
            this.last.isDisposed = true;
        return (this.last = new DeepMapEntry(this.store, args));
    };
    return DeepMap;
}());

var __assign$3 = (undefined && undefined.__assign) || function () {
    __assign$3 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};
/**
 * computedFn takes a function with an arbitrary amount of arguments,
 * and memoizes the output of the function based on the arguments passed in.
 *
 * computedFn(fn) returns a function with the very same signature. There is no limit on the amount of arguments
 * that is accepted. However, the amount of arguments must be constant and default arguments are not supported.
 *
 * By default the output of a function call will only be memoized as long as the
 * output is being observed.
 *
 * The function passes into `computedFn` should be pure, not be an action and only be relying on
 * observables.
 *
 * Setting `keepAlive` to `true` will cause the output to be forcefully cached forever.
 * Note that this might introduce memory leaks!
 *
 * @example
 * const store = observable({
    a: 1,
    b: 2,
    c: 3,
    m: computedFn(function(x) {
      return this.a * this.b * x
    })
  })

  const d = autorun(() => {
    // store.m(3) will be cached as long as this autorun is running
    console.log(store.m(3) * store.c)
  })
 *
 * @param fn
 * @param keepAliveOrOptions
 */
function computedFn(fn, keepAliveOrOptions) {
    if (keepAliveOrOptions === void 0) { keepAliveOrOptions = false; }
    if (Object(mobx__WEBPACK_IMPORTED_MODULE_0__["isAction"])(fn))
        throw new Error("computedFn shouldn't be used on actions");
    var memoWarned = false;
    var i = 0;
    var opts = typeof keepAliveOrOptions === "boolean"
        ? { keepAlive: keepAliveOrOptions }
        : keepAliveOrOptions;
    var d = new DeepMap();
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var entry = d.entry(args);
        // cache hit, return
        if (entry.exists())
            return entry.get().get();
        // if function is invoked, and its a cache miss without reactive, there is no point in caching...
        if (!opts.keepAlive && !Object(mobx__WEBPACK_IMPORTED_MODULE_0__["_isComputingDerivation"])()) {
            if (!memoWarned) {
                console.warn("invoking a computedFn from outside an reactive context won't be memoized, unless keepAlive is set");
                memoWarned = true;
            }
            return fn.apply(this, args);
        }
        // create new entry
        var c = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["computed"])(function () {
            return fn.apply(_this, args);
        }, __assign$3(__assign$3({}, opts), { name: "computedFn(" + fn.name + "#" + ++i + ")" }));
        entry.set(c);
        // clean up if no longer observed
        if (!opts.keepAlive)
            Object(mobx__WEBPACK_IMPORTED_MODULE_0__["onBecomeUnobserved"])(c, function () {
                d.entry(args).delete();
            });
        // return current val
        return c.get();
    };
}

function decorateMethodOrField(decoratorName, decorateFn, target, prop, descriptor) {
    if (descriptor) {
        return decorateMethod(decoratorName, decorateFn, prop, descriptor);
    }
    else {
        decorateField(decorateFn, target, prop);
    }
}
function decorateMethod(decoratorName, decorateFn, prop, descriptor) {
    if (descriptor.get !== undefined) {
        return fail(decoratorName + " cannot be used with getters");
    }
    // babel / typescript
    // @action method() { }
    if (descriptor.value) {
        // typescript
        return {
            value: decorateFn(prop, descriptor.value),
            enumerable: false,
            configurable: true,
            writable: true,
        };
    }
    // babel only: @action method = () => {}
    var initializer = descriptor.initializer;
    return {
        enumerable: false,
        configurable: true,
        writable: true,
        initializer: function () {
            // N.B: we can't immediately invoke initializer; this would be wrong
            return decorateFn(prop, initializer.call(this));
        },
    };
}
function decorateField(decorateFn, target, prop) {
    // Simple property that writes on first invocation to the current instance
    Object.defineProperty(target, prop, {
        configurable: true,
        enumerable: false,
        get: function () {
            return undefined;
        },
        set: function (value) {
            addHiddenProp(this, prop, decorateFn(prop, value));
        },
    });
}

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var runId = 0;
var unfinishedIds = new Set();
var currentlyActiveIds = new Set();
var inOrderExecution;
{
    var taskOrderPromise_1 = Promise.resolve();
    var queueMicrotaskPolyfill_1;
    if (typeof queueMicrotask !== "undefined") {
        // use real implementation if possible in modern browsers/node
        queueMicrotaskPolyfill_1 = queueMicrotask;
    }
    else if (typeof process !== "undefined" && process.nextTick) {
        // fallback to node's process.nextTick in node <= 10
        queueMicrotaskPolyfill_1 = function (cb) {
            process.nextTick(cb);
        };
    }
    else {
        // use setTimeout for old browsers
        queueMicrotaskPolyfill_1 = function (cb) {
            setTimeout(cb, 0);
        };
    }
    var idle_1 = function () {
        return new Promise(function (r) {
            queueMicrotaskPolyfill_1(r);
        });
    };
    // we use this trick to force a proper order of execution
    // even for immediately resolved promises
    inOrderExecution = function () {
        taskOrderPromise_1 = taskOrderPromise_1.then(idle_1);
        return taskOrderPromise_1;
    };
}
var actionAsyncContextStack = [];
function task(value) {
    return __awaiter(this, void 0, void 0, function () {
        var ctx, runId, actionName, args, scope, actionRunInfo, step, nextStep, ret, err_1, actionRunInfo_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ctx = actionAsyncContextStack[actionAsyncContextStack.length - 1];
                    if (!ctx) {
                        fail$1("'actionAsync' context not present when running 'task'. did you await inside an 'actionAsync' without using 'task(promise)'? did you forget to await the task?");
                    }
                    runId = ctx.runId, actionName = ctx.actionName, args = ctx.args, scope = ctx.scope, actionRunInfo = ctx.actionRunInfo, step = ctx.step;
                    nextStep = step + 1;
                    actionAsyncContextStack.pop();
                    Object(mobx__WEBPACK_IMPORTED_MODULE_0__["_endAction"])(actionRunInfo);
                    currentlyActiveIds.delete(runId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 6, 7]);
                    return [4 /*yield*/, value];
                case 2:
                    ret = _a.sent();
                    return [4 /*yield*/, inOrderExecution()];
                case 3:
                    _a.sent();
                    return [2 /*return*/, ret];
                case 4:
                    err_1 = _a.sent();
                    return [4 /*yield*/, inOrderExecution()];
                case 5:
                    _a.sent();
                    throw err_1;
                case 6:
                    // only restart if it not a dangling promise (the action is not yet finished)
                    if (unfinishedIds.has(runId)) {
                        actionRunInfo_1 = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["_startAction"])(getActionAsyncName(actionName, runId, nextStep), this, args);
                        actionAsyncContextStack.push({
                            runId: runId,
                            step: nextStep,
                            actionRunInfo: actionRunInfo_1,
                            actionName: actionName,
                            args: args,
                            scope: scope,
                        });
                        currentlyActiveIds.add(runId);
                    }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    });
}
// base
/**
 * Alternative syntax for async actions, similar to `flow` but more compatible with
 * Typescript typings. Not to be confused with `asyncAction`, which is deprecated.
 *
 * `actionAsync` can be used either as a decorator or as a function.
 * It takes an async function that internally must use `await task(promise)` rather than
 * the standard `await promise`.
 *
 * When using the mobx devTools, an asyncAction will emit `action` events with names like:
 * * `"fetchUsers - runid 6 - step 0"`
 * * `"fetchUsers - runid 6 - step 1"`
 * * `"fetchUsers - runid 6 - step 2"`
 *
 * The `runId` represents the action instance. In other words, if `fetchUsers` is invoked
 * multiple times concurrently, the events with the same `runid` belong together.
 * The `step` number indicates the code block that is now being executed.
 *
 * @example
 * import {actionAsync, task} from "mobx-utils"
 *
 * let users = []
 *
 * const fetchUsers = actionAsync("fetchUsers", async (url) => {
 *   const start = Date.now()
 *   // note the use of task when awaiting!
 *   const data = await task(window.fetch(url))
 *   users = await task(data.json())
 *   return start - Date.now()
 * })
 *
 * const time = await fetchUsers("http://users.com")
 * console.log("Got users", users, "in ", time, "ms")
 *
 * @example
 * import {actionAsync, task} from "mobx-utils"
 *
 * mobx.configure({ enforceActions: "observed" }) // don't allow state modifications outside actions
 *
 * class Store {
 *   \@observable githubProjects = []
 *   \@observable = "pending" // "pending" / "done" / "error"
 *
 *   \@actionAsync
 *   async fetchProjects() {
 *     this.githubProjects = []
 *     this.state = "pending"
 *     try {
 *       // note the use of task when awaiting!
 *       const projects = await task(fetchGithubProjectsSomehow())
 *       const filteredProjects = somePreprocessing(projects)
 *       // the asynchronous blocks will automatically be wrapped actions
 *       this.state = "done"
 *       this.githubProjects = filteredProjects
 *     } catch (error) {
 *        this.state = "error"
 *     }
 *   }
 * }
 */
function actionAsync(arg1, arg2, arg3) {
    // decorator
    if (typeof arguments[1] === "string") {
        return decorateMethodOrField("@actionAsync", function (prop, v) {
            return actionAsyncFn(prop, v);
        }, arg1, arg2, arg3);
    }
    // direct invocation
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    return actionAsyncFn(actionName, fn);
}
function actionAsyncFn(actionName, fn) {
    if (!mobx__WEBPACK_IMPORTED_MODULE_0__["_startAction"] || !mobx__WEBPACK_IMPORTED_MODULE_0__["_endAction"]) {
        fail$1("'actionAsync' requires mobx >=5.13.1 or >=4.13.1");
    }
    invariant(typeof fn === "function", "'asyncAction' expects a function");
    if (typeof actionName !== "string" || !actionName)
        fail$1("actions should have valid names, got: '" + actionName + "'");
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var nextRunId, actionRunInfo, finish, promise, ret, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nextRunId = runId++;
                        unfinishedIds.add(nextRunId);
                        actionRunInfo = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["_startAction"])(getActionAsyncName(actionName, nextRunId, 0), this, args);
                        actionAsyncContextStack.push({
                            runId: nextRunId,
                            step: 0,
                            actionRunInfo: actionRunInfo,
                            actionName: actionName,
                            args: args,
                            scope: this,
                        });
                        currentlyActiveIds.add(nextRunId);
                        finish = function (err) {
                            unfinishedIds.delete(nextRunId);
                            var ctx = actionAsyncContextStack.pop();
                            if (!ctx || ctx.runId !== nextRunId) {
                                // push it back if invalid
                                if (ctx) {
                                    actionAsyncContextStack.push(ctx);
                                }
                                var msg = "invalid 'actionAsync' context when finishing action '" + actionName + "'.";
                                if (!ctx) {
                                    msg += " no action context could be found instead.";
                                }
                                else {
                                    msg += " an action context for '" + ctx.actionName + "' was found instead.";
                                }
                                msg +=
                                    " did you await inside an 'actionAsync' without using 'task(promise)'? did you forget to await the task?";
                                fail$1(msg);
                            }
                            ctx.actionRunInfo.error = err;
                            Object(mobx__WEBPACK_IMPORTED_MODULE_0__["_endAction"])(ctx.actionRunInfo);
                            currentlyActiveIds.delete(nextRunId);
                            if (err) {
                                throw err;
                            }
                        };
                        try {
                            promise = fn.apply(this, args);
                        }
                        catch (err) {
                            finish(err);
                        }
                        // are we done sync? (no task run)
                        if (currentlyActiveIds.has(nextRunId)) {
                            finish(undefined);
                            return [2 /*return*/, promise];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, promise];
                    case 2:
                        ret = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        finish(err_2);
                        return [3 /*break*/, 4];
                    case 4:
                        finish(undefined);
                        return [2 /*return*/, ret];
                }
            });
        });
    };
}
function getActionAsyncName(actionName, runId, step) {
    return actionName + " - runid " + runId + " - step " + step;
}



/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(50)))

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
// At least one export needed otherwise:
// Augmentations for the global scope can only be directly nested in external modules or ambient module declarations.
exports.default = true;
Array.prototype.sorted = function (sortf) {
    const copy = this.slice();
    copy.sort(sortf);
    return copy;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterBar = exports.MobxFilter = exports.recommendedDefaultState = void 0;
const mobx_1 = __webpack_require__(3);
const mobx_react_1 = __webpack_require__(67);
const React = __webpack_require__(0);
const Dropdown_1 = __webpack_require__(210);
const FilterBar_1 = __webpack_require__(258);
const TextFilterBarItem_1 = __webpack_require__(260);
const DropdownSelection_1 = __webpack_require__(46);
const Filter_1 = __webpack_require__(33);
exports.recommendedDefaultState = {
    Baseline: { value: ['new', 'unchanged', 'updated'] },
    Suppression: { value: ['unsuppressed'] },
};
class MobxFilter extends Filter_1.Filter {
    constructor(defaultState, startingState) {
        super();
        this.atom = (0, mobx_1.createAtom)('MobxFilter');
        this.setDefaultState(defaultState || exports.recommendedDefaultState);
        this.setState(startingState || defaultState || exports.recommendedDefaultState, true);
        this.subscribe(() => {
            this.atom.reportChanged();
        }, Filter_1.FILTER_CHANGE_EVENT);
    }
    getState() {
        this.atom.reportObserved();
        return super.getState();
    }
}
exports.MobxFilter = MobxFilter;
let FilterBar = class FilterBar extends React.Component {
    constructor() {
        super(...arguments);
        this.ms1 = new DropdownSelection_1.DropdownMultiSelection();
        this.ms2 = new DropdownSelection_1.DropdownMultiSelection();
        this.msSuppression = new DropdownSelection_1.DropdownMultiSelection();
        this.msAge = new DropdownSelection_1.DropdownMultiSelection();
    }
    render() {
        const { filter, groupByAge, hideBaseline, hideLevel, showSuppression, showAge } = this.props;
        return React.createElement(FilterBar_1.FilterBar, { filter: filter },
            React.createElement(TextFilterBarItem_1.KeywordFilterBarItem, { filterItemKey: "Keywords", placeholder: "Filter by keyword" }),
            !hideBaseline && React.createElement(Dropdown_1.DropdownFilterBarItem, { filterItemKey: "Baseline", placeholder: "Baseline", showPlaceholderAsLabel: true, items: ['New', 'Unchanged', 'Updated', 'Absent'].map(text => ({ id: text.toLowerCase(), text })), selection: this.ms1 }),
            !hideLevel && React.createElement(Dropdown_1.DropdownFilterBarItem, { filterItemKey: "Level", placeholder: "Level", showPlaceholderAsLabel: true, items: ['Error', 'Warning', 'Note', 'None'].map(text => ({ id: text.toLowerCase(), text })), selection: this.ms2 }),
            showSuppression && React.createElement(Dropdown_1.DropdownFilterBarItem, { filterItemKey: "Suppression", placeholder: "Suppression", showPlaceholderAsLabel: true, items: ['Unsuppressed', 'Suppressed'].map(text => ({ id: text.toLowerCase(), text })), selection: this.msSuppression }),
            showAge && !groupByAge && React.createElement(Dropdown_1.DropdownFilterBarItem, { filterItemKey: "Age", placeholder: "Age", showPlaceholderAsLabel: true, items: ['Past SLA', 'Within SLA'].map(text => ({ id: text.toLowerCase(), text })), selection: this.msAge }));
    }
};
FilterBar = __decorate([
    mobx_react_1.observer
], FilterBar);
exports.FilterBar = FilterBar;


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Components_Dropdown_Dropdown__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Dropdown", function() { return _Components_Dropdown_Dropdown__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "filterItemByText", function() { return _Components_Dropdown_Dropdown__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderDropdownSelectedItemText", function() { return _Components_Dropdown_Dropdown__WEBPACK_IMPORTED_MODULE_0__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "filterItems", function() { return _Components_Dropdown_Dropdown__WEBPACK_IMPORTED_MODULE_0__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "filterTreeItems", function() { return _Components_Dropdown_Dropdown__WEBPACK_IMPORTED_MODULE_0__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "filterMatchedItemByListboxType", function() { return _Components_Dropdown_Dropdown__WEBPACK_IMPORTED_MODULE_0__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderHighlightedText", function() { return _Components_Dropdown_Dropdown__WEBPACK_IMPORTED_MODULE_0__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getHighlightedText", function() { return _Components_Dropdown_Dropdown__WEBPACK_IMPORTED_MODULE_0__["f"]; });

/* harmony import */ var _Components_Dropdown_Dropdown_Props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(167);
/* harmony import */ var _Components_Dropdown_Dropdown_Props__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Components_Dropdown_Dropdown_Props__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_Dropdown_Dropdown_Props__WEBPACK_IMPORTED_MODULE_1__) if(["default","Dropdown","filterItemByText","renderDropdownSelectedItemText","filterItems","filterTreeItems","filterMatchedItemByListboxType","renderHighlightedText","getHighlightedText"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_Dropdown_Dropdown_Props__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _Components_Dropdown_DropdownCallout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownCallout", function() { return _Components_Dropdown_DropdownCallout__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownCalloutComponent", function() { return _Components_Dropdown_DropdownCallout__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony import */ var _Components_Dropdown_DropdownCallout_Props__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(168);
/* harmony import */ var _Components_Dropdown_DropdownCallout_Props__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Components_Dropdown_DropdownCallout_Props__WEBPACK_IMPORTED_MODULE_3__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_Dropdown_DropdownCallout_Props__WEBPACK_IMPORTED_MODULE_3__) if(["default","Dropdown","filterItemByText","renderDropdownSelectedItemText","filterItems","filterTreeItems","filterMatchedItemByListboxType","renderHighlightedText","getHighlightedText","DropdownCallout","DropdownCalloutComponent"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_Dropdown_DropdownCallout_Props__WEBPACK_IMPORTED_MODULE_3__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _Components_Dropdown_DropdownExpandable_Props__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var _Components_Dropdown_DropdownExpandable_Props__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Components_Dropdown_DropdownExpandable_Props__WEBPACK_IMPORTED_MODULE_4__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_Dropdown_DropdownExpandable_Props__WEBPACK_IMPORTED_MODULE_4__) if(["default","Dropdown","filterItemByText","renderDropdownSelectedItemText","filterItems","filterTreeItems","filterMatchedItemByListboxType","renderHighlightedText","getHighlightedText","DropdownCallout","DropdownCalloutComponent"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_Dropdown_DropdownExpandable_Props__WEBPACK_IMPORTED_MODULE_4__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _Components_Dropdown_DropdownExpandableButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownExpandableButton", function() { return _Components_Dropdown_DropdownExpandableButton__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony import */ var _Components_Dropdown_DropdownExpandableTextField__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownExpandableTextField", function() { return _Components_Dropdown_DropdownExpandableTextField__WEBPACK_IMPORTED_MODULE_6__["a"]; });

/* harmony import */ var _Components_Dropdown_DropdownFilterBarItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(197);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownFilterBarItem", function() { return _Components_Dropdown_DropdownFilterBarItem__WEBPACK_IMPORTED_MODULE_7__["a"]; });

/* harmony import */ var _Components_Dropdown_WithPivots__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(172);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WithPivots", function() { return _Components_Dropdown_WithPivots__WEBPACK_IMPORTED_MODULE_8__["a"]; });

/* harmony import */ var _Components_Dropdown_WithPivots_Props__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(173);
/* harmony import */ var _Components_Dropdown_WithPivots_Props__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Components_Dropdown_WithPivots_Props__WEBPACK_IMPORTED_MODULE_9__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_Dropdown_WithPivots_Props__WEBPACK_IMPORTED_MODULE_9__) if(["default","Dropdown","filterItemByText","renderDropdownSelectedItemText","filterItems","filterTreeItems","filterMatchedItemByListboxType","renderHighlightedText","getHighlightedText","DropdownCallout","DropdownCalloutComponent","DropdownExpandableButton","DropdownExpandableTextField","DropdownFilterBarItem","WithPivots"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_Dropdown_WithPivots_Props__WEBPACK_IMPORTED_MODULE_9__[key]; }) }(__WEBPACK_IMPORT_KEY__));












/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');

module.exports = __webpack_require__(212).polyfill();


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	undefined;
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    var then$$1 = void 0;
    try {
      then$$1 = value.then;
    } catch (error) {
      reject(promise, error);
      return;
    }
    handleMaybeThenable(promise, value, then$$1);
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = true;

  if (hasCallback) {
    try {
      value = callback(detail);
    } catch (e) {
      succeeded = false;
      error = e;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (succeeded === false) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = void 0;
      var error = void 0;
      var didError = false;
      try {
        _then = entry.then;
      } catch (e) {
        didError = true;
        error = e;
      }

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        if (didError) {
          reject(promise, error);
        } else {
          handleMaybeThenable(promise, entry, _then);
        }
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(50), __webpack_require__(95)))

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(214).polyfill();


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */



function assign(target, firstSource) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }

  var to = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }
  return to;
}

function polyfill() {
  if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: assign
    });
  }
}

module.exports = {
  assign: assign,
  polyfill: polyfill
};


/***/ }),
/* 215 */
/***/ (function(module, exports) {

!function(){"use strict";function r(r){for(var t=[],e=0;e<r.length;e++)t.push(r[e]);return t}String.prototype.codePointAt||!function(){var r=function(){try{var r={},t=Object.defineProperty,e=t(r,r,r)&&t}catch(r){}return e}(),t=function(r){if(null==this)throw TypeError();var t=this+"",e=t.length,n=r?+r:0;if(n!=n&&(n=0),!(n<0||n>=e)){var o,i=t.charCodeAt(n);return i>=55296&&i<=56319&&e>n+1&&(o=t.charCodeAt(n+1),o>=56320&&o<=57343)?1024*(i-55296)+o-56320+65536:i}};r?r(String.prototype,"codePointAt",{value:t,configurable:!0,writable:!0}):String.prototype.codePointAt=t}(),String.prototype.repeat||!function(){var r=function(){try{var r={},t=Object.defineProperty,e=t(r,r,r)&&t}catch(r){}return e}(),t=function(r){if(null==this)throw TypeError();var t=this+"",e=r?+r:0;if(e!=e&&(e=0),e<0||e==1/0)throw RangeError();for(var n="";e;)e%2==1&&(n+=t),e>1&&(t+=t),e>>=1;return n};r?r(String.prototype,"repeat",{value:t,configurable:!0,writable:!0}):String.prototype.repeat=t}(),String.prototype.includes||!function(){var r={}.toString,t=function(){try{var r={},t=Object.defineProperty,e=t(r,r,r)&&t}catch(r){}return e}(),e="".indexOf,n=function(t){if(null==this)throw TypeError();var n=this+"";if(t&&"[object RegExp]"==r.call(t))throw TypeError();var o=n.length,i=t+"",a=i.length,c=arguments.length>1?arguments[1]:void 0,u=c?+c:0;return u!=u&&(u=0),!(a+Math.min(Math.max(u,0),o)>o)&&e.call(n,i,u)!=-1};t?t(String.prototype,"includes",{value:n,configurable:!0,writable:!0}):String.prototype.includes=n}(),String.prototype.startsWith||!function(){var r=function(){try{var r={},t=Object.defineProperty,e=t(r,r,r)&&t}catch(r){}return e}(),t={}.toString,e=function(r){if(null==this)throw TypeError();var e=this+"";if(r&&"[object RegExp]"==t.call(r))throw TypeError();var n=e.length,o=r+"",i=o.length,a=arguments.length>1?arguments[1]:void 0,c=a?+a:0;c!=c&&(c=0);var u=Math.min(Math.max(c,0),n);if(i+u>n)return!1;for(var l=-1;++l<i;)if(e.charCodeAt(u+l)!=o.charCodeAt(l))return!1;return!0};r?r(String.prototype,"startsWith",{value:e,configurable:!0,writable:!0}):String.prototype.startsWith=e}(),String.prototype.endsWith||!function(){var r=function(){try{var r={},t=Object.defineProperty,e=t(r,r,r)&&t}catch(r){}return e}(),t={}.toString,e=function(r){if(null==this)throw TypeError();var e=this+"";if(r&&"[object RegExp]"==t.call(r))throw TypeError();var n=e.length,o=r+"",i=o.length,a=n;if(arguments.length>1){var c=arguments[1];void 0!==c&&(a=c?+c:0,a!=a&&(a=0))}var u=Math.min(Math.max(a,0),n),l=u-i;if(l<0)return!1;for(var h=-1;++h<i;)if(e.charCodeAt(l+h)!=o.charCodeAt(h))return!1;return!0};r?r(String.prototype,"endsWith",{value:e,configurable:!0,writable:!0}):String.prototype.endsWith=e}(),String.fromCodePoint||!function(){var r=function(){try{var r={},t=Object.defineProperty,e=t(r,r,r)&&t}catch(r){}return e}(),t=String.fromCharCode,e=Math.floor,n=function(r){var n,o,i=16384,a=[],c=-1,u=arguments.length;if(!u)return"";for(var l="";++c<u;){var h=+arguments[c];if(!isFinite(h)||h<0||h>1114111||e(h)!=h)throw RangeError("Invalid code point: "+h);h<=65535?a.push(h):(h-=65536,n=(h>>10)+55296,o=h%1024+56320,a.push(n,o)),(c+1==u||a.length>i)&&(l+=t.apply(null,a),a.length=0)}return l};r?r(String,"fromCodePoint",{value:n,configurable:!0,writable:!0}):String.fromCodePoint=n}(),Object.defineProperty(String,"raw",{configurable:!0,enumerable:!1,writable:!0,value:function(t,e){var n;t=null!=t?t:{},e=arguments.length>1?r(arguments).slice(1):[];try{n=r(t.raw)}catch(r){throw new TypeError("Cannot convert undefined or null to object")}return n.map(function(r,n){return t.raw.length<=n?r:null!=e[n-1]?e[n-1]+r:r}).join("")}})}();


/***/ }),
/* 216 */
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

(function(window, document) {
'use strict';


// Exits early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}


/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = entry.rootBounds;
  this.boundingClientRect = entry.boundingClientRect;
  this.intersectionRect = entry.intersectionRect || getEmptyRect();
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (options.root && options.root.nodeType != 1) {
    throw new Error('root must be an Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections();
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {

    return item.element != target;
  });
  if (!this._observationTargets.length) {
    this._unmonitorIntersections();
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function() {
  if (!this._monitoringIntersections) {
    this._monitoringIntersections = true;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      this._monitoringInterval = setInterval(
          this._checkForIntersections, this.POLL_INTERVAL);
    }
    else {
      addEvent(window, 'resize', this._checkForIntersections, true);
      addEvent(document, 'scroll', this._checkForIntersections, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
        this._domObserver = new MutationObserver(this._checkForIntersections);
        this._domObserver.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function() {
  if (this._monitoringIntersections) {
    this._monitoringIntersections = false;

    clearInterval(this._monitoringInterval);
    this._monitoringInterval = null;

    removeEvent(window, 'resize', this._checkForIntersections, true);
    removeEvent(document, 'scroll', this._checkForIntersections, true);

    if (this._domObserver) {
      this._domObserver.disconnect();
      this._domObserver = null;
    }
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, rootRect);

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootRect,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, rootRect) {

  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var targetRect = getBoundingClientRect(target);
  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return;

    if (parent == this.root || parent == document) {
      atRoot = true;
      parentRect = rootRect;
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      if (parent != document.body &&
          parent != document.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);

      if (!intersectionRect) break;
    }
    parent = getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {Object} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var html = document.documentElement;
    var body = document.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {Object} rect The rect object to expand.
 * @return {Object} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  return containsDeep(this.root || document, target);
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object} The intersection rect or undefined if no intersection
 *     is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  };
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {Object} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {Object} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}

/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }
  return parent;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}(window, document));


/***/ }),
/* 217 */
/***/ (function(module, exports) {


// Polyfill Array.findIndex
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return k.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return -1.
            return -1;
        }
    });
}

// Polyfill Array.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var i = this.findIndex(predicate);
            if (i === -1) {
                return undefined;
            }
            else {
                return this[i];
            }
        }
    });
}


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, "*{box-sizing:inherit}body{box-sizing:border-box}.absolute-fill{position:absolute;bottom:0;left:0;right:0;top:0}.absolute{position:absolute}.relative{position:relative}.no-events{pointer-events:none}.scroll-hidden{overflow:hidden}.v-scroll-hidden{overflow-y:hidden}.h-scroll-hidden{overflow-x:hidden}.scroll-auto{overflow:auto}@media screen and (max-width: 600px){.scroll-auto{-webkit-overflow-scrolling:touch}}.v-scroll-auto{overflow-y:auto}@media screen and (max-width: 600px){.v-scroll-auto{-webkit-overflow-scrolling:touch}}.h-scroll-auto{overflow-x:auto}@media screen and (max-width: 600px){.h-scroll-auto{-webkit-overflow-scrolling:touch}}.full-height{height:100%}.full-size{display:flex;flex-grow:1;overflow:hidden}.full-width{width:100%}.flex-column{display:flex;flex-direction:column}.flex-row{display:flex;flex-direction:row}.inline-flex-column{display:inline-flex;flex-direction:column}.inline-flex-row{display:inline-flex;flex-direction:row}.flex-center{align-items:center}.flex-end{align-items:flex-end}.flex-start{align-items:flex-start}.flex-stretch{align-items:stretch}.flex-baseline{align-items:baseline}.justify-start{justify-content:flex-start}.justify-center{justify-content:center}.justify-end{justify-content:flex-end}.justify-space-between{justify-content:space-between}.flex-wrap{flex-wrap:wrap}.flex-grow{flex-grow:1}.flex-noshrink{flex-shrink:0}.flex-self-center{align-self:center}.flex-self-end{align-self:flex-end}.flex-self-start{align-self:flex-start}.flex-self-stretch{align-self:stretch}.flex-cell{align-items:center;align-self:stretch;display:flex;flex-direction:row;margin:0;padding:0;position:relative}.title-l{font-size:1.75rem;font-weight:bold;letter-spacing:-0.04em}.title-m{font-size:1.3125rem;font-weight:600;letter-spacing:-0.02em}.title-s{font-size:1.0625rem;font-weight:600}.title-xs{font-size:0.9375rem;font-weight:600}.body-xl{font-size:1.0625rem}.body-l{font-size:0.9375rem}.body-m{font-size:0.875rem}.body-s{font-size:0.75rem}.body-xs{font-size:0.6875rem}.monospaced-m{font-family:Menlo, Consolas, Courier New, monospace;font-size:0.8125rem}.monospaced-s{font-family:Menlo, Consolas, Courier New, monospace;font-size:0.75rem}.monospaced-xs{font-family:Menlo, Consolas, Courier New, monospace;font-size:0.6875rem}.font-size-xxs{font-size:0.5625rem}.font-size-xs{font-size:0.625rem}.font-size-s{font-size:0.6875rem}.font-size{font-size:0.75rem}.font-size-ms{font-size:0.8125rem}.font-size-m{font-size:0.875rem}.font-size-mm{font-size:0.9375rem}.font-size-ml{font-size:1rem}.font-size-l{font-size:1.125rem}.font-size-ll{font-size:1.5rem}.font-size-lll{font-size:1.75rem}.font-size-xl{font-size:2.25rem}.font-size-xxl{font-size:2.5rem}.font-size-xxxl{font-size:3.5rem}.font-size-xxxxl{font-size:4.5rem}.font-weight-light{font-weight:200}.font-weight-normal{font-weight:normal}.font-weight-semibold{font-weight:600}.font-weight-heavy{font-weight:bold}.secondary-text{color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55))}@media (forced-colors: active){.secondary-text{color:graytext}}.monospaced-text{font-family:Menlo, Consolas, Courier New, monospace}.error-text{color:#da0a00;color:var(--status-error-text, #da0a00)}.error-text-important{color:#da0a00 !important;color:var(--status-error-text, #da0a00) !important}.themed{background-color:#fff;background-color:var(--background-color, #fff);color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9))}.v-align-middle{vertical-align:middle}.depth-0{box-shadow:0 0 0 0 transparent}.depth-4{box-shadow:0 1.6px 3.6px 0 rgba(0,0,0,0.132),0 0.3px 0.9px 0 rgba(0,0,0,0.108);box-shadow:0 1.6px 3.6px 0 var(--callout-shadow-color, rgba(0,0,0,0.132)),0 0.3px 0.9px 0 var(--callout-shadow-secondary-color, rgba(0,0,0,0.108))}.depth-8{box-shadow:0 3.2px 7.2px 0 rgba(0,0,0,0.132),0 0.6px 1.8px 0 rgba(0,0,0,0.108);box-shadow:0 3.2px 7.2px 0 var(--callout-shadow-color, rgba(0,0,0,0.132)),0 0.6px 1.8px 0 var(--callout-shadow-secondary-color, rgba(0,0,0,0.108))}.depth-16{box-shadow:0 6.4px 14.4px 0 rgba(0,0,0,0.132),0 1.2px 3.6px 0 rgba(0,0,0,0.108);box-shadow:0 6.4px 14.4px 0 var(--callout-shadow-color, rgba(0,0,0,0.132)),0 1.2px 3.6px 0 var(--callout-shadow-secondary-color, rgba(0,0,0,0.108))}.depth-64{box-shadow:0 25.6px 57.6px 0 rgba(0,0,0,0.132),0 4.8px 14.4px 0 rgba(0,0,0,0.108);box-shadow:0 25.6px 57.6px 0 var(--callout-shadow-color, rgba(0,0,0,0.132)),0 4.8px 14.4px 0 var(--callout-shadow-secondary-color, rgba(0,0,0,0.108))}.sub-layer{z-index:10}.cursor-default{cursor:default}.cursor-pointer{cursor:pointer}.text-ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.white-space-nowrap{white-space:nowrap}.word-break{word-break:break-all;word-break:break-word}.selectable-text{user-select:text;cursor:text}.link-icon{padding:2px 2px}.link-text{padding:0 2px}.no-outline{outline:none}.icon-margin{margin-right:6px}.icon-large-margin{margin-right:12px}.contributed-icon-image{background-size:contain}.contributed-icon-image.non-themed{filter:none;filter:var(--third-party-icon-filter, none)}.shadow-padding{margin:-4px;padding:4px}.margin-0,.no-margin{margin:0px !important}.margin-4{margin:4px}.margin-8{margin:8px}.margin-16{margin:16px}.margin-bottom-4{margin-bottom:4px}.margin-bottom-8{margin-bottom:8px}.margin-bottom-16{margin-bottom:16px}.margin-horizontal-0,.no-h-margin{margin-left:0px !important;margin-right:0px !important}.margin-horizontal-4{margin-left:4px;margin-right:4px}.margin-horizontal-8{margin-left:8px;margin-right:8px}.margin-horizontal-16{margin-left:16px;margin-right:16px}.margin-horizontal-20{margin-left:20px;margin-right:20px}.margin-left-4{margin-left:4px}.margin-left-8{margin-left:8px}.margin-left-16{margin-left:16px}.margin-right-4{margin-right:4px}.margin-right-8{margin-right:8px}.margin-right-16{margin-right:16px}.margin-top-4{margin-top:4px}.margin-top-8{margin-top:8px}.margin-top-16{margin-top:16px}.margin-vertical-0,.no-v-margin{margin-bottom:0px !important;margin-top:0px !important}.margin-vertical-4{margin-bottom:4px;margin-top:4px}.margin-vertical-8{margin-bottom:8px;margin-top:8px}.margin-vertical-16{margin-bottom:16px;margin-top:16px}.margin-vertical-20{margin-bottom:20px;margin-top:20px}.padding-0,.no-padding{padding:0px !important}.padding-4{padding:4px}.padding-8{padding:8px}.padding-16{padding:16px}.padding-bottom-0,.no-bottom-padding{padding-bottom:0px !important}.padding-bottom-4{padding-bottom:4px}.padding-bottom-8{padding-bottom:8px}.padding-bottom-16{padding-bottom:16px}.padding-horizontal-0,.no-h-padding{padding-left:0px !important;padding-right:0px !important}.padding-horizontal-4{padding-left:4px;padding-right:4px}.padding-horizontal-8{padding-left:8px;padding-right:8px}.padding-horizontal-16{padding-left:16px;padding-right:16px}.padding-horizontal-20{padding-left:20px;padding-right:20px}.padding-left-4{padding-left:4px}.padding-left-8{padding-left:8px}.padding-left-16{padding-left:16px}.padding-right-4{padding-right:4px}.padding-right-8{padding-right:8px}.padding-right-16{padding-right:16px}.padding-top-0,.no-top-padding{padding-top:0px !important}.padding-top-4{padding-top:4px}.padding-top-8{padding-top:8px}.padding-top-16{padding-top:16px}.padding-vertical-0,.no-v-padding{padding-bottom:0px !important;padding-top:0px !important}.padding-vertical-4{padding-bottom:4px;padding-top:4px}.padding-vertical-8{padding-bottom:8px;padding-top:8px}.padding-vertical-16{padding-bottom:16px;padding-top:16px}.padding-vertical-20{padding-bottom:20px;padding-top:20px}.rhythm-horizontal-4>:not(:first-child){margin-left:4px}.rhythm-horizontal-8>:not(:first-child){margin-left:8px}.rhythm-horizontal-16>:not(:first-child){margin-left:16px}.rhythm-vertical-4>:not(:first-child){margin-top:4px}.rhythm-vertical-8>:not(:first-child){margin-top:8px}.rhythm-vertical-16>:not(:first-child){margin-top:16px}.rhythm-vertical-20>:not(:first-child){margin-top:20px}.rhythm-vertical-24>:not(:first-child){margin-top:24px}.rhythm-vertical-32>:not(:first-child){margin-top:32px}.visually-hidden{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.hidden{display:none}.invisible{visibility:hidden}.rotate-180{transform:rotate(180deg)}.separator-line-top{border-top:1px solid;border-top-color:#eaeaea;border-top-color:rgba(var(--palette-neutral-8, 234, 234, 234), 1)}.separator-line-bottom{border-bottom:1px solid;border-bottom-color:#eaeaea;border-bottom-color:rgba(var(--palette-neutral-8, 234, 234, 234), 1)}.subtle-border{border:1px solid;border-color:#eaeaea;border-color:rgba(var(--palette-neutral-8, 234, 234, 234), 1)}.shimmer{animation-duration:4s;animation-timing-function:ease-in-out;animation-direction:normal;animation-iteration-count:infinite;background:linear-gradient(to right, #f4f4f4 0%, #eaeaea 50%, #f4f4f4 100%) 0px 0px/90% 100% no-repeat #f4f4f4;background:linear-gradient(to right, rgba(var(--palette-neutral-4, 244, 244, 244), 1) 0%, rgba(var(--palette-neutral-8, 234, 234, 234), 1) 50%, rgba(var(--palette-neutral-4, 244, 244, 244), 1) 100%) 0px 0px/90% 100% no-repeat rgba(var(--palette-neutral-4, 244, 244, 244), 1);transition:opacity 200ms ease 0s}@keyframes shimmer-wide{0%{background-position:-500px}100%{background-position:500px}}@keyframes shimmer-thin{0%{background-position:-200px}100%{background-position:200px}}.shimmer-line{animation-name:shimmer-wide;border-radius:0.5em}.shimmer-circle-small{animation-name:shimmer-thin;border-radius:50%;height:1.3em;margin-right:4px;width:1.3em}.shimmer-circle-large{animation-name:shimmer-thin;border-radius:50%;height:2.3em;margin-right:4px;width:2.3em}.custom-scrollbar{scrollbar-color:rgba(0,0,0,0.2) transparent;scrollbar-color:var(--palette-black-alpha-20, rgba(0,0,0,0.2)) transparent;scrollbar-width:thin}.custom-scrollbar.scroll-auto-hide{scrollbar-color:transparent transparent}.custom-scrollbar.scroll-auto-hide:hover{scrollbar-color:rgba(0,0,0,0.2) transparent;scrollbar-color:var(--palette-black-alpha-20, rgba(0,0,0,0.2)) transparent}.custom-scrollbar::-webkit-scrollbar{width:18px;height:18px}.custom-scrollbar::-webkit-scrollbar-thumb{border:6px solid transparent;background:rgba(0,0,0,0.2);background:var(--palette-black-alpha-20, rgba(0,0,0,0.2));border-radius:10px;background-clip:padding-box}.custom-scrollbar::-webkit-scrollbar-corner{background:transparent}.custom-scrollbar::-webkit-scrollbar-thumb:vertical{min-height:30px}.custom-scrollbar::-webkit-scrollbar-thumb:horizontal{min-width:30px}.custom-scrollbar.scroll-auto-hide::-webkit-scrollbar-thumb{background:transparent;background-clip:padding-box}.custom-scrollbar.scroll-auto-hide:hover::-webkit-scrollbar-thumb{background:rgba(0,0,0,0.2);background:var(--palette-black-alpha-20, rgba(0,0,0,0.2));background-clip:padding-box}.custom-scrollbar::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,0.3);background:var(--palette-black-alpha-30, rgba(0,0,0,0.3));background-clip:padding-box;border:4px solid transparent}.custom-scrollbar-hidden{-ms-overflow-style:none;scrollbar-width:none}.custom-scrollbar-hidden::-webkit-scrollbar{width:0}.grayscale{filter:grayscale(100%)}.screen-reader-only{user-select:none;position:absolute;height:1px;width:1px;clip:rect(1px, 1px, 1px, 1px);clip-path:inset(50%);-webkit-clip-path:inset(50%);overflow:hidden !important;white-space:nowrap;padding:0 !important;margin:0 !important}\n", ""]);



/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-dropdown{border-radius:4px;padding-top:8px}.bolt-dropdown .bolt-list-row.selected .bolt-list-cell:first-child{border-left:0px none transparent}.bolt-dropdown-list-box-container{max-height:270px;padding-bottom:8px}.bolt-dropdown .bolt-dropdown-list-box-container{overflow-x:hidden;overflow-y:auto}.bolt-dropdown-filter.bolt-textfield{background:rgba(0,0,0,0.06);background:var(--palette-black-alpha-6, rgba(0,0,0,0.06));border-radius:2px;border-color:transparent}.bolt-dropdown-filter.bolt-textfield .bolt-textfield-input{background:transparent}.bolt-dropdown-filter-container{padding-left:8px;padding-right:8px;padding-bottom:8px}.bolt-actions-container{border-top:1px solid;border-top-color:rgba(0,0,0,0.06);border-top-color:var(--palette-black-alpha-6, rgba(0,0,0,0.06));padding:8px;align-items:flex-start}.bolt-dropdown-no-items{padding:6px 10px;color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55));text-align:center}.bolt-focus-visible .bolt-dropdown .bolt-table-row.focused{outline:none;animation:focus-shadow-pulse-inset 4s ease-in-out infinite;box-shadow:inset 0 0 0 3px rgba(0,120,212,0.23),inset 0 0 0 1px #0078d4;box-shadow:inset 0 0 0 3px var(--focus-pulse-max-color, rgba(0,120,212,0.23)),inset 0 0 0 1px var(--focus-border-color, #0078d4)}@media (forced-colors: active){.bolt-focus-visible .bolt-dropdown .bolt-table-row.focused{animation:none}}_::-webkit-full-page-media,_:future,:root .bolt-focus-visible .bolt-dropdown .bolt-table-row.focused{outline-style:auto}.bolt-dropdown-action-right-button{margin:8px 4px 0px 0px;align-self:flex-end}.bolt-dropdown-expandable-textfield-input{text-align:left;min-width:0}.bolt-dropdown-expandable-textfield-input::-moz-focus-inner{border:0}.bolt-dropdown-expandable-textfield-input.bolt-textfield-input{background-color:transparent}.bolt-dropdown-expandable-button-label{text-align:left}.bolt-dropdown-filter-bar-item{max-width:100%}.bolt-dropdown-filter-bar-item .bolt-button{max-width:100%}.bolt-dropdown-filter-bar-item .bolt-dropdown-expandable-button-label{max-width:340px;font-weight:normal}.bolt-dropdown-filter-bar-item .bolt-dropdown-expandable-button-label .bolt-dropdown-filter-bar-item-selected-text{color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9))}@media (forced-colors: active){.bolt-dropdown-filter-bar-item .bolt-dropdown-expandable-button-label .bolt-dropdown-filter-bar-item-selected-text{color:windowText}}.bolt-dropdown-filter-bar-item-selected-text{font-weight:600}.bolt-dropdown-filter-bar-item-placeholder{white-space:pre}.bolt-dropdown-filter-bar-item .bolt-button{background:transparent;color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55))}.bolt-dropdown-filter-bar-item .bolt-button.active{color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9))}.bolt-dropdown-pivot.bolt-button.subtle{font-weight:normal}.bolt-dropdown-pivot.bolt-button.subtle:hover{background:transparent}.bolt-dropdown-pivot-selected{border-bottom:2px solid #0078d4;border-bottom:2px solid var(--communication-background, #0078d4);font-weight:600}.bolt-dropdown-header{padding:0 4px 4px 12px}.bolt-dropdown-header-text{padding:6px 0}.bolt-dropdown-header-container{border-bottom:1px solid;border-bottom-color:rgba(0,0,0,0.06);border-bottom-color:var(--palette-black-alpha-6, rgba(0,0,0,0.06))}.bolt-dropdown-expandable-text-field:not(.disabled){cursor:pointer}.bolt-dropdown-expandable-text-field:not(.disabled) .bolt-dropdown-expandable-textfield-input{cursor:pointer}\n", ""]);



/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-list{border-spacing:0 0;color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9));cursor:default;display:table;table-layout:fixed;user-select:none;-ms-user-select:none;-moz-user-select:none;-webkit-user-select:none}@media screen and (min-width: 0\\0){.bolt-list{max-width:100vw}}.bolt-list.bolt-list{border-collapse:separate}.bolt-fixed-height-list-row{width:100%}.bolt-list-row{color:inherit;display:table-row;outline:none;text-decoration:none;transition:background 80ms linear}.bolt-list-row:hover{background-color:rgba(0,0,0,0.02);background-color:var(--component-grid-row-hover-color, rgba(0,0,0,0.02))}.bolt-list-row:hover .bolt-list-cell-content-reveal{visibility:visible}@media (forced-colors: active){.bolt-list-row:hover{background:Highlight;forced-color-adjust:none}.bolt-list-row:hover td{forced-color-adjust:auto}}.bolt-list-row.focused .bolt-list-cell-content-reveal{visibility:visible}.bolt-list-row.selected{background-color:#deecf9;background-color:var(--component-grid-selected-row-color, #deecf9);outline:none}@media (forced-colors: active){.bolt-list-row.selected{background:Highlight;forced-color-adjust:none}.bolt-list-row.selected td{forced-color-adjust:auto}}@media (forced-colors: active){.bolt-list-row.selected .bolt-button.bolt-focus-treatment:focus,.bolt-list-row.selected .bolt-checkbox.bolt-focus-treatment:focus .bolt-checkmark{border-color:Background}}.bolt-list-row.selected .bolt-list-cell:first-child{border-left:2px solid #0078d4;border-left:2px solid var(--component-grid-focus-border-color, #0078d4)}.bolt-list-row:hover.selected{background-color:#deecf9;background-color:var(--component-grid-action-selected-cell-hover-color, #deecf9)}@media (forced-colors: active){.bolt-list-row:hover.selected{background-color:Highlight}}.bolt-list-row.single-click-activation{cursor:pointer}.bolt-list-row-no-hover:hover{background-color:initial}.bolt-list-row-header:hover,.bolt-list-row-loading:hover{background-color:initial;cursor:default}.bolt-list-cell{border-top:1px solid transparent;border-bottom:1px solid transparent;color:inherit;display:table-cell;overflow:hidden;padding:0;position:relative;text-align:left;text-decoration:none;white-space:nowrap}.bolt-list-cell:first-child{border-left:2px solid transparent}.bolt-list-cell:last-child{border-right:1px solid transparent}.bolt-list-cell-content-reveal{visibility:hidden}.bolt-list-cell-spacer{padding:0}.bolt-list-cell-text{overflow:hidden}.bolt-focus-visible .bolt-list-row:focus .bolt-list-cell{border-color:#0078d4;border-color:var(--component-grid-focus-border-color, #0078d4)}@media (forced-colors: active){.bolt-focus-visible .bolt-list-row:focus .bolt-list-cell{background-color:highlight}}@media (forced-colors: active){.bolt-focus-visible .bolt-list-row:focus{forced-color-adjust:none;border-color:highlight}}@media screen and (-ms-high-contrast: black-on-white){.bolt-focus-visible .bolt-list-row:focus{outline:3px double highlight;outline-offset:1px}}@media (forced-colors: active){.bolt-focus-visible .bolt-list-row:focus{forced-color-adjust:none}.bolt-focus-visible .bolt-list-row:focus a{forced-color-adjust:auto}.bolt-focus-visible .bolt-list-row:focus>td>*{forced-color-adjust:auto}}.bolt-list-row-marked .bolt-list-cell:first-child{border-left:2px solid;border-left-color:#2b88d8;border-left-color:rgba(var(--palette-primary-tint-10, 43, 136, 216), 1)}.bolt-list-overlay-container{width:100%}.bolt-list-overlay{pointer-events:none;width:100%}.bolt-list-drag-source-item{background-color:rgba(255,255,255,0.4);background-color:var(--component-grid-drag-source-color, rgba(255,255,255,0.4))}.bolt-drag-image-portal{z-index:100}.bolt-drag-image{background-color:#fff;background-color:var(--callout-background-color, #fff);height:40px;width:320px;padding:0px 8px}\n", ""]);



/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-list-drop-indicator-circle{background-color:#2b88d8;background-color:rgba(var(--palette-primary-tint-10, 43, 136, 216), 1);border-radius:50%;height:9px;width:9px}.bolt-list-drop-indicator-circle.top{top:-4px}.bolt-list-drop-indicator-circle.bottom{bottom:-4px}.bolt-list-drop-indicator-line{background-color:#c7e0f4;background-color:rgba(var(--palette-primary-tint-20, 199, 224, 244), 1);height:3px;right:0px}.bolt-list-drop-indicator-line.top{top:-1px}.bolt-list-drop-indicator-line.bottom{bottom:-1px}.bolt-list-tree-drop-target{border:1px solid #0078d4;border:1px solid var(--component-grid-focus-border-color, #0078d4)}\n", ""]);



/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(223);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Imports
var urlEscape = __webpack_require__(224);
var ___CSS_LOADER_URL___0___ = urlEscape(__webpack_require__(225));

// Module
exports.push([module.i, "@font-face{font-family:\"AzureDevOpsMDL2Assets\";src:url(" + ___CSS_LOADER_URL___0___ + ") format(\"woff\")}.fabric-icon{align-self:center;display:inline-flex;font-family:\"AzureDevOpsMDL2Assets\";-webkit-font-smoothing:antialiased}.fabric-icon.small{font-size:0.75rem;line-height:0.75rem}.fabric-icon.medium{font-size:1rem;line-height:1rem}.fabric-icon.large{font-size:1.5rem;line-height:1.5rem}.ms-Icon--FabricFolder,.ms-Icon--FabricFolderFill{transform:translateY(1px)}.ms-Icon--Tag{transform:translateY(1px)}.ms-Icon--Insights:before{content:\"\\E3AF\"}.ms-Icon--GlobalNavButton:before{content:\"\\E700\"}.ms-Icon--Airplane:before{content:\"\\E709\"}.ms-Icon--ChevronDown:before{content:\"\\E70D\"}.ms-Icon--ChevronUp:before{content:\"\\E70E\"}.ms-Icon--Edit:before{content:\"\\E70F\"}.ms-Icon--Add:before{content:\"\\E710\"}.ms-Icon--Cancel:before{content:\"\\E711\"}.ms-Icon--More:before{content:\"\\E712\"}.ms-Icon--Settings:before{content:\"\\E713\"}.ms-Icon--Video:before{content:\"\\E714\"}.ms-Icon--Mail:before{content:\"\\E715\"}.ms-Icon--People:before{content:\"\\E716\"}.ms-Icon--Phone:before{content:\"\\E717\"}.ms-Icon--Pin:before{content:\"\\E718\"}.ms-Icon--Shop:before{content:\"\\E719\"}.ms-Icon--Link:before{content:\"\\E71B\"}.ms-Icon--Filter:before{content:\"\\E71C\"}.ms-Icon--Zoom:before{content:\"\\E71E\"}.ms-Icon--ZoomOut:before{content:\"\\E71F\"}.ms-Icon--Search:before{content:\"\\E721\"}.ms-Icon--Attach:before{content:\"\\E723\"}.ms-Icon--Send:before{content:\"\\E724\"}.ms-Icon--FavoriteList:before{content:\"\\E728\"}.ms-Icon--Forward:before{content:\"\\E72A\"}.ms-Icon--Back:before{content:\"\\E72B\"}.ms-Icon--Refresh:before{content:\"\\E72C\"}.ms-Icon--Share:before{content:\"\\E72D\"}.ms-Icon--Lock:before{content:\"\\E72E\"}.ms-Icon--BlockedSite:before{content:\"\\E72F\"}.ms-Icon--ReportHacked:before{content:\"\\E730\"}.ms-Icon--EMI:before{content:\"\\E731\"}.ms-Icon--Blocked:before{content:\"\\E733\"}.ms-Icon--FavoriteStar:before{content:\"\\E734\"}.ms-Icon--FavoriteStarFill:before{content:\"\\E735\"}.ms-Icon--ReadingMode:before{content:\"\\E736\"}.ms-Icon--Remove:before{content:\"\\E738\"}.ms-Icon--CheckboxComposite:before{content:\"\\E73A\"}.ms-Icon--CheckboxCompositeReversed:before{content:\"\\E73D\"}.ms-Icon--CheckMark:before{content:\"\\E73E\"}.ms-Icon--BackToWindow:before{content:\"\\E73F\"}.ms-Icon--FullScreen:before{content:\"\\E740\"}.ms-Icon--Print:before{content:\"\\E749\"}.ms-Icon--Up:before{content:\"\\E74A\"}.ms-Icon--Down:before{content:\"\\E74B\"}.ms-Icon--OEM:before{content:\"\\E74C\"}.ms-Icon--Delete:before{content:\"\\E74D\"}.ms-Icon--Save:before{content:\"\\E74E\"}.ms-Icon--Flashlight:before{content:\"\\E754\"}.ms-Icon--Sad:before{content:\"\\E757\"}.ms-Icon--MultiSelect:before{content:\"\\E762\"}.ms-Icon--KeyboardClassic:before{content:\"\\E765\"}.ms-Icon--Play:before{content:\"\\E768\"}.ms-Icon--Pause:before{content:\"\\E769\"}.ms-Icon--ChevronLeft:before{content:\"\\E76B\"}.ms-Icon--ChevronRight:before{content:\"\\E76C\"}.ms-Icon--Emoji2:before{content:\"\\E76E\"}.ms-Icon--SearchAndApps:before{content:\"\\E773\"}.ms-Icon--Globe:before{content:\"\\E774\"}.ms-Icon--ContactInfo:before{content:\"\\E779\"}.ms-Icon--Unpin:before{content:\"\\E77A\"}.ms-Icon--Contact:before{content:\"\\E77B\"}.ms-Icon--Paste:before{content:\"\\E77F\"}.ms-Icon--WindowsLogo:before{content:\"\\E782\"}.ms-Icon--Error:before{content:\"\\E783\"}.ms-Icon--Unlock:before{content:\"\\E785\"}.ms-Icon--Calendar:before{content:\"\\E787\"}.ms-Icon--Megaphone:before{content:\"\\E789\"}.ms-Icon--Color:before{content:\"\\E790\"}.ms-Icon--SaveAs:before{content:\"\\E792\"}.ms-Icon--Undo:before{content:\"\\E7A7\"}.ms-Icon--RedEye:before{content:\"\\E7B3\"}.ms-Icon--Package:before{content:\"\\E7B8\"}.ms-Icon--Warning:before{content:\"\\E7BA\"}.ms-Icon--ShoppingCart:before{content:\"\\E7BF\"}.ms-Icon--Flag:before{content:\"\\E7C1\"}.ms-Icon--Page:before{content:\"\\E7C3\"}.ms-Icon--Car:before{content:\"\\E804\"}.ms-Icon--EatDrink:before{content:\"\\E807\"}.ms-Icon--Home:before{content:\"\\E80F\"}.ms-Icon--SwitcherStartEnd:before{content:\"\\E810\"}.ms-Icon--IncidentTriangle:before{content:\"\\E814\"}.ms-Icon--History:before{content:\"\\E81C\"}.ms-Icon--Work:before{content:\"\\E821\"}.ms-Icon--Recent:before{content:\"\\E823\"}.ms-Icon--LocationDot:before{content:\"\\E827\"}.ms-Icon--Dictionary:before{content:\"\\E82D\"}.ms-Icon--Pinned:before{content:\"\\E840\"}.ms-Icon--RevToggleKey:before{content:\"\\E845\"}.ms-Icon--View:before{content:\"\\E890\"}.ms-Icon--Previous:before{content:\"\\E892\"}.ms-Icon--Next:before{content:\"\\E893\"}.ms-Icon--Clear:before{content:\"\\E894\"}.ms-Icon--Download:before{content:\"\\E896\"}.ms-Icon--Help:before{content:\"\\E897\"}.ms-Icon--Upload:before{content:\"\\E898\"}.ms-Icon--Emoji:before{content:\"\\E899\"}.ms-Icon--ClosePane:before{content:\"\\E89F\"}.ms-Icon--OpenPane:before{content:\"\\E8A0\"}.ms-Icon--PreviewLink:before{content:\"\\E8A1\"}.ms-Icon--ZoomIn:before{content:\"\\E8A3\"}.ms-Icon--ViewAll:before{content:\"\\E8A9\"}.ms-Icon--Switch:before{content:\"\\E8AB\"}.ms-Icon--Rename:before{content:\"\\E8AC\"}.ms-Icon--Import:before{content:\"\\E8B5\"}.ms-Icon--Folder:before{content:\"\\E8B7\"}.ms-Icon--ChromeClose:before{content:\"\\E8BB\"}.ms-Icon--ShowResults:before{content:\"\\E8BC\"}.ms-Icon--PaymentCard:before{content:\"\\E8C7\"}.ms-Icon--Copy:before{content:\"\\E8C8\"}.ms-Icon--FontColor:before{content:\"\\E8D3\"}.ms-Icon--Permissions:before{content:\"\\E8D7\"}.ms-Icon--Italic:before{content:\"\\E8DB\"}.ms-Icon--Underline:before{content:\"\\E8DC\"}.ms-Icon--Bold:before{content:\"\\E8DD\"}.ms-Icon--Like:before{content:\"\\E8E1\"}.ms-Icon--FontSize:before{content:\"\\E8E9\"}.ms-Icon--Tag:before{content:\"\\E8EC\"}.ms-Icon--Library:before{content:\"\\E8F1\"}.ms-Icon--BlockContact:before{content:\"\\E8F8\"}.ms-Icon--AddFriend:before{content:\"\\E8FA\"}.ms-Icon--Accept:before{content:\"\\E8FB\"}.ms-Icon--BulletedList:before{content:\"\\E8FD\"}.ms-Icon--Preview:before{content:\"\\E8FF\"}.ms-Icon--Chat:before{content:\"\\E901\"}.ms-Icon--Group:before{content:\"\\E902\"}.ms-Icon--World:before{content:\"\\E909\"}.ms-Icon--Comment:before{content:\"\\E90A\"}.ms-Icon--Repair:before{content:\"\\E90F\"}.ms-Icon--Accounts:before{content:\"\\E910\"}.ms-Icon--Stopwatch:before{content:\"\\E916\"}.ms-Icon--Clock:before{content:\"\\E917\"}.ms-Icon--WorldClock:before{content:\"\\E918\"}.ms-Icon--Completed:before{content:\"\\E930\"}.ms-Icon--MiniExpand:before{content:\"\\E93A\"}.ms-Icon--Code:before{content:\"\\E943\"}.ms-Icon--Streaming:before{content:\"\\E93E\"}.ms-Icon--LightningBolt:before{content:\"\\E945\"}.ms-Icon--Info:before{content:\"\\E946\"}.ms-Icon--CalculatorAddition:before{content:\"\\E948\"}.ms-Icon--MediaStorageTower:before{content:\"\\E965\"}.ms-Icon--ChevronUpSmall:before{content:\"\\E96D\"}.ms-Icon--ChevronDownSmall:before{content:\"\\E96E\"}.ms-Icon--ChevronLeftSmall:before{content:\"\\E96F\"}.ms-Icon--ChevronRightSmall:before{content:\"\\E970\"}.ms-Icon--ChevronUpMed:before{content:\"\\E971\"}.ms-Icon--ChevronDownMed:before{content:\"\\E972\"}.ms-Icon--ChevronLeftMed:before{content:\"\\E973\"}.ms-Icon--ChevronRightMed:before{content:\"\\E974\"}.ms-Icon--PC1:before{content:\"\\E977\"}.ms-Icon--Reply:before{content:\"\\E97A\"}.ms-Icon--Chart:before{content:\"\\E999\"}.ms-Icon--LockSolid:before{content:\"\\E9A2\"}.ms-Icon--DashKey:before{content:\"\\E9AE\"}.ms-Icon--CloudWeather:before{content:\"\\E9BE\"}.ms-Icon--Cloudy:before{content:\"\\E9BF\"}.ms-Icon--Unknown:before{content:\"\\E9CE\"}.ms-Icon--SortLines:before{content:\"\\E9D0\"}.ms-Icon--Ribbon:before{content:\"\\E9D1\"}.ms-Icon--Assign:before{content:\"\\E9D3\"}.ms-Icon--FlowChart:before{content:\"\\E9D4\"}.ms-Icon--CheckList:before{content:\"\\E9D5\"}.ms-Icon--Diagnostic:before{content:\"\\E9D9\"}.ms-Icon--Equalizer:before{content:\"\\E9E9\"}.ms-Icon--Processing:before{content:\"\\E9F5\"}.ms-Icon--WorkFlow:before{content:\"\\EA01\"}.ms-Icon--Diamond2Solid:before{content:\"\\EA0A\"}.ms-Icon--Teamwork:before{content:\"\\EA12\"}.ms-Icon--PeopleAdd:before{content:\"\\EA15\"}.ms-Icon--DateTime2:before{content:\"\\EA17\"}.ms-Icon--Shield:before{content:\"\\EA18\"}.ms-Icon--PageAdd:before{content:\"\\EA1A\"}.ms-Icon--NumberedList:before{content:\"\\EA1C\"}.ms-Icon--PowerBILogo:before{content:\"\\EA1E\"}.ms-Icon--MusicInCollectionFill:before{content:\"\\EA36\"}.ms-Icon--List:before{content:\"\\EA37\"}.ms-Icon--ErrorBadge:before{content:\"\\EA39\"}.ms-Icon--CircleRing:before{content:\"\\EA3A\"}.ms-Icon--CircleFill:before{content:\"\\EA3B\"}.ms-Icon--Lightbulb:before{content:\"\\EA80\"}.ms-Icon--Puzzle:before{content:\"\\EA86\"}.ms-Icon--Ringer:before{content:\"\\EA8F\"}.ms-Icon--PDF:before{content:\"\\EA90\"}.ms-Icon--CirclePlus:before{content:\"\\EAEE\"}.ms-Icon--StockDown:before{content:\"\\EB0F\"}.ms-Icon--StockUp:before{content:\"\\EB11\"}.ms-Icon--MSNVideos:before{content:\"\\EB1C\"}.ms-Icon--Soccer:before{content:\"\\EB21\"}.ms-Icon--CollegeFootball:before{content:\"\\EB26\"}.ms-Icon--ProFootball:before{content:\"\\EB27\"}.ms-Icon--Snowflake:before{content:\"\\EB46\"}.ms-Icon--AirplaneSolid:before{content:\"\\EB4C\"}.ms-Icon--Heart:before{content:\"\\EB51\"}.ms-Icon--HeartFill:before{content:\"\\EB52\"}.ms-Icon--AzureLogo:before{content:\"\\EB6A\"}.ms-Icon--OfficeLogo:before{content:\"\\EB6E\"}.ms-Icon--SkypeLogo:before{content:\"\\EB6F\"}.ms-Icon--StatusErrorFull:before{content:\"\\EB90\"}.ms-Icon--Certificate:before{content:\"\\EB95\"}.ms-Icon--Rewind:before{content:\"\\EB9E\"}.ms-Icon--Photo2:before{content:\"\\EB9F\"}.ms-Icon--OpenSource:before{content:\"\\EBC2\"}.ms-Icon--Project:before{content:\"\\EBC6\"}.ms-Icon--CloudDownload:before{content:\"\\EBD3\"}.ms-Icon--CityNext:before{content:\"\\EC06\"}.ms-Icon--Documentation:before{content:\"\\EC17\"}.ms-Icon--Giftbox:before{content:\"\\EC1F\"}.ms-Icon--VisualStudioLogo:before{content:\"\\EC22\"}.ms-Icon--CompletedSolid:before{content:\"\\EC61\"}.ms-Icon--MicrosoftLogo:before{content:\"\\EC6A\"}.ms-Icon--CloudUpload:before{content:\"\\EC8E\"}.ms-Icon--ScrollUpDown:before{content:\"\\EC8F\"}.ms-Icon--Tiles:before{content:\"\\ECA5\"}.ms-Icon--Org:before{content:\"\\ECA6\"}.ms-Icon--PartyLeader:before{content:\"\\ECA7\"}.ms-Icon--AppIconDefault:before{content:\"\\ECAA\"}.ms-Icon--POI:before{content:\"\\ECAF\"}.ms-Icon--AddTo:before{content:\"\\ECC8\"}.ms-Icon--RadioBtnOff:before{content:\"\\ECCA\"}.ms-Icon--RadioBtnOn:before{content:\"\\ECCB\"}.ms-Icon--ExploreContent:before{content:\"\\ECCD\"}.ms-Icon--Embed:before{content:\"\\ECCE\"}.ms-Icon--Product:before{content:\"\\ECDC\"}.ms-Icon--ProgressLoopOuter:before{content:\"\\ECDF\"}.ms-Icon--Blocked2:before{content:\"\\ECE4\"}.ms-Icon--FangBody:before{content:\"\\ECEB\"}.ms-Icon--ChatInviteFriend:before{content:\"\\ECFE\"}.ms-Icon--Feedback:before{content:\"\\ED15\"}.ms-Icon--YammerLogo:before{content:\"\\ED19\"}.ms-Icon--AADLogo:before{content:\"\\ED68\"}.ms-Icon--AccessLogo:before{content:\"\\ED69\"}.ms-Icon--SecurityGroup:before{content:\"\\ED85\"}.ms-Icon--Table:before{content:\"\\ED86\"}.ms-Icon--Waffle:before{content:\"\\ED89\"}.ms-Icon--RemoveLink:before{content:\"\\ED90\"}.ms-Icon--EditNote:before{content:\"\\ED9D\"}.ms-Icon--DoubleChevronUp:before{content:\"\\EDBD\"}.ms-Icon--DoubleChevronLeft:before{content:\"\\EDBE\"}.ms-Icon--DoubleChevronRight:before{content:\"\\EDBF\"}.ms-Icon--Ascending:before{content:\"\\EDC0\"}.ms-Icon--Descending:before{content:\"\\EDC1\"}.ms-Icon--TextField:before{content:\"\\EDC3\"}.ms-Icon--Dynamics365Logo:before{content:\"\\EDCC\"}.ms-Icon--ClearFormatting:before{content:\"\\EDDD\"}.ms-Icon--Strikethrough:before{content:\"\\EDE0\"}.ms-Icon--Export:before{content:\"\\EDE1\"}.ms-Icon--ExportMirrored:before{content:\"\\EDE2\"}.ms-Icon--DoubleChevronDown:before{content:\"\\EE04\"}.ms-Icon--ReplyMirrored:before{content:\"\\EE35\"}.ms-Icon--AddGroup:before{content:\"\\EE3D\"}.ms-Icon--SortUp:before{content:\"\\EE68\"}.ms-Icon--SortDown:before{content:\"\\EE69\"}.ms-Icon--AwayStatus:before{content:\"\\EE6A\"}.ms-Icon--MyMoviesTV:before{content:\"\\EE6C\"}.ms-Icon--CPU:before{content:\"\\EEA1\"}.ms-Icon--ContactCard:before{content:\"\\EEBD\"}.ms-Icon--CustomList:before{content:\"\\EEBE\"}.ms-Icon--OfflineOneDriveParachute:before{content:\"\\EEC8\"}.ms-Icon--OfflineOneDriveParachuteDisabled:before{content:\"\\EEC9\"}.ms-Icon--TriangleSolidUp12:before{content:\"\\EECC\"}.ms-Icon--TriangleSolidDown12:before{content:\"\\EECD\"}.ms-Icon--TriangleSolidRight12:before{content:\"\\EECF\"}.ms-Icon--TriangleRight12:before{content:\"\\EED3\"}.ms-Icon--ArrowUpRight8:before{content:\"\\EED4\"}.ms-Icon--DocumentSet:before{content:\"\\EED6\"}.ms-Icon--ArrowDownRightMirrored8:before{content:\"\\EEF0\"}.ms-Icon--ViewAll2:before{content:\"\\EF56\"}.ms-Icon--PlayerSettings:before{content:\"\\EF58\"}.ms-Icon--ReceiptCheck:before{content:\"\\EF5B\"}.ms-Icon--EditStyle:before{content:\"\\EF60\"}.ms-Icon--Lifesaver:before{content:\"\\EF62\"}.ms-Icon--DocumentSearch:before{content:\"\\EF6C\"}.ms-Icon--ExcelDocument:before{content:\"\\EF73\"}.ms-Icon--Starburst:before{content:\"\\EF78\"}.ms-Icon--SkypeCircleCheck:before{content:\"\\EF7D\"}.ms-Icon--SkypeCircleMinus:before{content:\"\\EF7F\"}.ms-Icon--SkypeMinus:before{content:\"\\EF82\"}.ms-Icon--Hide2:before{content:\"\\EF89\"}.ms-Icon--ClearFilter:before{content:\"\\EF8F\"}.ms-Icon--TimeEntry:before{content:\"\\EF95\"}.ms-Icon--PageEdit:before{content:\"\\EFB6\"}.ms-Icon--PageArrowRight:before{content:\"\\EFB8\"}.ms-Icon--Database:before{content:\"\\EFC7\"}.ms-Icon--ConnectContacts:before{content:\"\\EFD4\"}.ms-Icon--ActivateOrders:before{content:\"\\EFE0\"}.ms-Icon--ZipFolder:before{content:\"\\F012\"}.ms-Icon--Configuration:before{content:\"\\F01E\"}.ms-Icon--TextDocument:before{content:\"\\F029\"}.ms-Icon--Script:before{content:\"\\F03A\"}.ms-Icon--ActivityFeed:before{content:\"\\F056\"}.ms-Icon--CaretSolidDown:before{content:\"\\F08E\"}.ms-Icon--FabricFolder:before{content:\"\\F0A9\"}.ms-Icon--FabricFolderFill:before{content:\"\\F0AA\"}.ms-Icon--FabricNewFolder:before{content:\"\\F0AB\"}.ms-Icon--PublishContent:before{content:\"\\F0D4\"}.ms-Icon--CannedChat:before{content:\"\\F0F2\"}.ms-Icon--SettingsApp:before{content:\"\\F0FF\"}.ms-Icon--FolderHorizontal:before{content:\"\\F12B\"}.ms-Icon--GiftboxOpen:before{content:\"\\F133\"}.ms-Icon--StatusCircleInner:before{content:\"\\F137\"}.ms-Icon--StatusCircleRing:before{content:\"\\F138\"}.ms-Icon--StatusCircleErrorX:before{content:\"\\F13D\"}.ms-Icon--StatusCircleCheckmark:before{content:\"\\F13E\"}.ms-Icon--InfoSolid:before{content:\"\\F167\"}.ms-Icon--ProgressRingDots:before{content:\"\\F16A\"}.ms-Icon--WordLogo:before{content:\"\\F1E3\"}.ms-Icon--ExcelLogo:before{content:\"\\F1E5\"}.ms-Icon--OneNoteLogo:before{content:\"\\F1E7\"}.ms-Icon--OutlookLogo:before{content:\"\\F1E9\"}.ms-Icon--PowerPointLogo:before{content:\"\\F1EB\"}.ms-Icon--ScheduleEventAction:before{content:\"\\F1EF\"}.ms-Icon--FlameSolid:before{content:\"\\F1F3\"}.ms-Icon--ServerProcesses:before{content:\"\\F1FE\"}.ms-Icon--Server:before{content:\"\\F201\"}.ms-Icon--SaveAll:before{content:\"\\F203\"}.ms-Icon--TwoKeys:before{content:\"\\F229\"}.ms-Icon--GridViewSmall:before{content:\"\\F232\"}.ms-Icon--ViewDashboard:before{content:\"\\F246\"}.ms-Icon--ViewList:before{content:\"\\F247\"}.ms-Icon--ViewListGroup:before{content:\"\\F248\"}.ms-Icon--ViewListTree:before{content:\"\\F249\"}.ms-Icon--TriggerAuto:before{content:\"\\F24A\"}.ms-Icon--TriggerUser:before{content:\"\\F24B\"}.ms-Icon--StackedBarChart:before{content:\"\\F24D\"}.ms-Icon--StackedLineChart:before{content:\"\\F24E\"}.ms-Icon--BuildQueue:before{content:\"\\F24F\"}.ms-Icon--BuildQueueNew:before{content:\"\\F250\"}.ms-Icon--UserFollowed:before{content:\"\\F25C\"}.ms-Icon--Clicked:before{content:\"\\F268\"}.ms-Icon--Signin:before{content:\"\\F286\"}.ms-Icon--CloneToDesktop:before{content:\"\\F28C\"}.ms-Icon--Build:before{content:\"\\F28F\"}.ms-Icon--BranchFork2:before{content:\"\\F291\"}.ms-Icon--BranchCommit:before{content:\"\\F293\"}.ms-Icon--BranchMerge:before{content:\"\\F295\"}.ms-Icon--BranchPullRequest:before{content:\"\\F296\"}.ms-Icon--BranchShelveset:before{content:\"\\F298\"}.ms-Icon--RawSource:before{content:\"\\F299\"}.ms-Icon--RowsGroup:before{content:\"\\F29B\"}.ms-Icon--Deploy:before{content:\"\\F29D\"}.ms-Icon--ServerEnviroment:before{content:\"\\F29F\"}.ms-Icon--VisioLogo:before{content:\"\\F2A7\"}.ms-Icon--Backlog:before{content:\"\\F2AC\"}.ms-Icon--TeamFavorite:before{content:\"\\F2AD\"}.ms-Icon--TaskGroup:before{content:\"\\F2AE\"}.ms-Icon--CommentAdd:before{content:\"\\F2B3\"}.ms-Icon--ShopServer:before{content:\"\\F2B6\"}.ms-Icon--QueryList:before{content:\"\\F2B8\"}.ms-Icon--StreamingOff:before{content:\"\\F2BB\"}.ms-Icon--MoreVertical:before{content:\"\\F2BC\"}.ms-Icon--ArrowTallUpRight:before{content:\"\\F2BE\"}.ms-Icon--RingerOff:before{content:\"\\F2C5\"}.ms-Icon--PlayResume:before{content:\"\\F2C6\"}.ms-Icon--Repo:before{content:\"\\F2CB\"}.ms-Icon--FolderQuery:before{content:\"\\F2CD\"}.ms-Icon--FolderList:before{content:\"\\F2CE\"}.ms-Icon--CirclePauseSolid:before{content:\"\\F2D8\"}.ms-Icon--CirclePause:before{content:\"\\F2D9\"}.ms-Icon--MSNVideosSolid:before{content:\"\\F2DA\"}.ms-Icon--CircleStopSolid:before{content:\"\\F2DB\"}.ms-Icon--CircleStop:before{content:\"\\F2DC\"}.ms-Icon--NavigateForward:before{content:\"\\F2DF\"}.ms-Icon--FileTemplate:before{content:\"\\F2E6\"}.ms-Icon--FileJAVA:before{content:\"\\F2E8\"}.ms-Icon--FileCSS:before{content:\"\\F2EA\"}.ms-Icon--FileSass:before{content:\"\\F2EB\"}.ms-Icon--FileHTML:before{content:\"\\F2ED\"}.ms-Icon--JavaScriptLanguage:before{content:\"\\F2EE\"}.ms-Icon--CSharpLanguage:before{content:\"\\F2EF\"}.ms-Icon--TypeScriptLanguage:before{content:\"\\F2F7\"}.ms-Icon--MarkDownLanguage:before{content:\"\\F2FB\"}.ms-Icon--PlugConnected:before{content:\"\\F302\"}.ms-Icon--PlugDisconnected:before{content:\"\\F303\"}.ms-Icon--UnlockSolid:before{content:\"\\F304\"}.ms-Icon--Variable:before{content:\"\\F305\"}.ms-Icon--FileBug:before{content:\"\\F30D\"}.ms-Icon--FileCode:before{content:\"\\F30E\"}.ms-Icon--FileImage:before{content:\"\\F311\"}.ms-Icon--AutoFillTemplate:before{content:\"\\F313\"}.ms-Icon--WorkItem:before{content:\"\\F314\"}.ms-Icon--FullHistory:before{content:\"\\F31C\"}.ms-Icon--TripleColumnEdit:before{content:\"\\F323\"}.ms-Icon--AlertSolid:before{content:\"\\F331\"}.ms-Icon--MegaphoneSolid:before{content:\"\\F332\"}.ms-Icon--TaskSolid:before{content:\"\\F333\"}.ms-Icon--CrownSolid:before{content:\"\\F336\"}.ms-Icon--Trophy2Solid:before{content:\"\\F337\"}.ms-Icon--QuickNoteSolid:before{content:\"\\F338\"}.ms-Icon--ConstructionConeSolid:before{content:\"\\F339\"}.ms-Icon--PageListSolid:before{content:\"\\F33A\"}.ms-Icon--StarburstSolid:before{content:\"\\F33C\"}.ms-Icon--ReadingModeSolid:before{content:\"\\F33D\"}.ms-Icon--ShieldSolid:before{content:\"\\F340\"}.ms-Icon--GiftBoxSolid:before{content:\"\\F341\"}.ms-Icon--RibbonSolid:before{content:\"\\F345\"}.ms-Icon--FinancialSolid:before{content:\"\\F346\"}.ms-Icon--HeadsetSolid:before{content:\"\\F348\"}.ms-Icon--PermissionsSolid:before{content:\"\\F349\"}.ms-Icon--ParkingSolid:before{content:\"\\F34A\"}.ms-Icon--DiamondSolid:before{content:\"\\F34C\"}.ms-Icon--AsteriskSolid:before{content:\"\\F34D\"}.ms-Icon--OfflineStorageSolid:before{content:\"\\F34E\"}.ms-Icon--BankSolid:before{content:\"\\F34F\"}.ms-Icon--DecisionSolid:before{content:\"\\F350\"}.ms-Icon--ParachuteSolid:before{content:\"\\F352\"}.ms-Icon--FiltersSolid:before{content:\"\\F353\"}.ms-Icon--ColorSolid:before{content:\"\\F354\"}.ms-Icon--ReviewSolid:before{content:\"\\F355\"}.ms-Icon--ReviewRequestSolid:before{content:\"\\F356\"}.ms-Icon--ReviewResponseSolid:before{content:\"\\F358\"}.ms-Icon--FeedbackRequestSolid:before{content:\"\\F359\"}.ms-Icon--FeedbackResponseSolid:before{content:\"\\F35B\"}.ms-Icon--NavigateExternalInline:before{content:\"\\F35F\"}.ms-Icon--PlanView:before{content:\"\\F360\"}.ms-Icon--EngineeringGroup:before{content:\"\\F362\"}.ms-Icon--ProjectCollection:before{content:\"\\F363\"}.ms-Icon--ChevronUnfold10:before{content:\"\\F369\"}.ms-Icon--ChevronFold10:before{content:\"\\F36A\"}.ms-Icon--VSTSLogo:before{content:\"\\F381\"}.ms-Icon--TestBeaker:before{content:\"\\F3A5\"}.ms-Icon--TestBeakerSolid:before{content:\"\\F3A6\"}.ms-Icon--TestAutoSolid:before{content:\"\\F3A8\"}.ms-Icon--TestPlan:before{content:\"\\F3AB\"}.ms-Icon--TestStep:before{content:\"\\F3AC\"}.ms-Icon--TestParameter:before{content:\"\\F3AD\"}.ms-Icon--TestSuite:before{content:\"\\F3AE\"}.ms-Icon--TestCase:before{content:\"\\F3AF\"}.ms-Icon--Sprint:before{content:\"\\F3B0\"}.ms-Icon--TriggerApproval:before{content:\"\\F3B2\"}.ms-Icon--Rocket:before{content:\"\\F3B3\"}.ms-Icon--AzureKeyVault:before{content:\"\\F3B4\"}.ms-Icon--LikeSolid:before{content:\"\\F3BF\"}.ms-Icon--CRMCustomerInsightsApp:before{content:\"\\F3C8\"}.ms-Icon--FilterSolid:before{content:\"\\F412\"}.ms-Icon--Inbox:before{content:\"\\F41C\"}.ms-Icon--NotExecuted:before{content:\"\\F440\"}.ms-Icon--NotImpactedSolid:before{content:\"\\F441\"}.ms-Icon--BacklogBoard:before{content:\"\\F444\"}.ms-Icon--IssueSolid:before{content:\"\\F448\"}.ms-Icon--DefectSolid:before{content:\"\\F449\"}.ms-Icon--LadybugSolid:before{content:\"\\F44A\"}.ms-Icon--NugetLogo:before{content:\"\\F44C\"}.ms-Icon--TFVCLogo:before{content:\"\\F44D\"}.ms-Icon--ProjectLogo32:before{content:\"\\F47E\"}.ms-Icon--WaffleOffice365:before{content:\"\\F4E0\"}.ms-Icon--FontColorA:before{content:\"\\F4EC\"}.ms-Icon--FontColorSwatch:before{content:\"\\F4ED\"}.ms-Icon--SemiboldWeight:before{content:\"\\F4F0\"}.ms-Icon--ChartSeries:before{content:\"\\F513\"}.ms-Icon--AlignJustify:before{content:\"\\F51E\"}.ms-Icon--BlockedSolid:before{content:\"\\F531\"}.ms-Icon--DownloadDocument:before{content:\"\\F549\"}.ms-Icon--WaitlistConfirm:before{content:\"\\F550\"}.ms-Icon--LaptopSecure:before{content:\"\\F552\"}.ms-Icon--EntryView:before{content:\"\\F554\"}.ms-Icon--AccountManagement:before{content:\"\\F55C\"}.ms-Icon--ExploreData:before{content:\"\\F5B6\"}.ms-Icon--BitbucketLogo32:before{content:\"\\F5D2\"}.ms-Icon--GradleLogo32:before{content:\"\\F5D4\"}.ms-Icon--PasteAsCode:before{content:\"\\F5D6\"}.ms-Icon--FileYML:before{content:\"\\F5DA\"}.ms-Icon--ClipboardSolid:before{content:\"\\F5DC\"}.ms-Icon--AnalyticsView:before{content:\"\\F5F1\"}.ms-Icon--Trending12:before{content:\"\\F62D\"}.ms-Icon--CircleShapeSolid:before{content:\"\\F63C\"}.ms-Icon--GitLogo:before{content:\"\\F65D\"}.ms-Icon--GitHubLogo:before{content:\"\\F65E\"}.ms-Icon--ApacheMavenLogo:before{content:\"\\F65F\"}.ms-Icon--NPMLogo:before{content:\"\\F660\"}.ms-Icon--GitFork:before{content:\"\\F661\"}.ms-Icon--SVNLogo:before{content:\"\\F662\"}.ms-Icon--JenkinsLogo:before{content:\"\\F663\"}.ms-Icon--ExternalGit:before{content:\"\\F665\"}.ms-Icon--QuadColumn:before{content:\"\\F66F\"}.ms-Icon--DictionaryRemove:before{content:\"\\F69A\"}.ms-Icon--UserRemove:before{content:\"\\F69B\"}.ms-Icon--OpenInNewTab:before{content:\"\\F6AB\"}.ms-Icon--VerifiedBrandSolid:before{content:\"\\F6AD\"}.ms-Icon--AuthenticatorApp:before{content:\"\\F6B1\"}.ms-Icon--BacklogList:before{content:\"\\F6BF\"}.ms-Icon--ButtonControl:before{content:\"\\F6C0\"}.ms-Icon--UserGauge:before{content:\"\\F6ED\"}.ms-Icon--PeopleSettings:before{content:\"\\F72C\"}.ms-Icon--Blocked2Solid:before{content:\"\\F737\"}.ms-Icon--BulletedListText:before{content:\"\\F792\"}.ms-Icon--BulletedListBullet:before{content:\"\\F793\"}.ms-Icon--NumberedListText:before{content:\"\\F796\"}.ms-Icon--NumberedListNumber:before{content:\"\\F797\"}.ms-Icon--RemoveLinkChain:before{content:\"\\F79A\"}.ms-Icon--RemoveLinkX:before{content:\"\\F79B\"}.ms-Icon--FabricTextHighlight:before{content:\"\\F79C\"}.ms-Icon--ClearFormattingA:before{content:\"\\F79D\"}.ms-Icon--ClearFormattingEraser:before{content:\"\\F79E\"}.ms-Icon--Photo2Fill:before{content:\"\\F79F\"}.ms-Icon--IncreaseIndentText:before{content:\"\\F7A0\"}.ms-Icon--IncreaseIndentArrow:before{content:\"\\F7A1\"}.ms-Icon--DecreaseIndentText:before{content:\"\\F7A2\"}.ms-Icon--DecreaseIndentArrow:before{content:\"\\F7A3\"}.ms-Icon--CheckListText:before{content:\"\\F7A8\"}.ms-Icon--CheckListCheck:before{content:\"\\F7A9\"}.ms-Icon--NumberSymbol:before{content:\"\\F7AC\"}.ms-Icon--VerifiedBrand:before{content:\"\\F7BD\"}.ms-Icon--ReleaseGate:before{content:\"\\F7BE\"}.ms-Icon--ReleaseGateCheck:before{content:\"\\F7BF\"}.ms-Icon--ReleaseGateError:before{content:\"\\F7C0\"}.ms-Icon--FabricTextHighlightComposite:before{content:\"\\F7DA\"}.ms-Icon--SkypeCircleSlash:before{content:\"\\F825\"}.ms-Icon--PythonLogoBlue:before{content:\"\\F84D\"}.ms-Icon--PythonLogoYellow:before{content:\"\\F84E\"}.ms-Icon--RustLanguageLogo:before{content:\"\\F84F\"}.ms-Icon--RubyGemsLogo:before{content:\"\\F850\"}.ms-Icon--AddReaction:before{content:\"\\F85D\"}.ms-Icon--DecreaseIndentLegacy:before{content:\"\\E290\"}.ms-Icon--IncreaseIndentLegacy:before{content:\"\\E291\"}.ms-Icon--SurveyQuestions:before{content:\"\\F01B\"}.ms-Icon--BranchCompare:before{content:\"\\F294\"}.ms-Icon--DiffInline:before{content:\"\\F309\"}.ms-Icon--DiffSideBySide:before{content:\"\\F30A\"}.ms-Icon--ImageDiff:before{content:\"\\F30B\"}.ms-Icon--GitGraph:before{content:\"\\F2CA\"}.ms-Icon--WordDocument:before{content:\"\\EF71\"}.ms-Icon--PowerPointDocument:before{content:\"\\EF72\"}.ms-Icon--PowerShell:before{content:\"\\F1FD\"}.ms-Icon--FilePDB:before{content:\"\\F2E5\"}.ms-Icon--FileSQL:before{content:\"\\F2E7\"}.ms-Icon--FileASPX:before{content:\"\\F2E9\"}.ms-Icon--FileSass:before{content:\"\\F2EB\"}.ms-Icon--FileLess:before{content:\"\\F2EC\"}.ms-Icon--CSharpLanguage:before{content:\"\\F2EF\"}.ms-Icon--VisualBasicLanguage:before{content:\"\\F2F1\"}.ms-Icon--CPlusPlusLanguage:before{content:\"\\F2F3\"}.ms-Icon--FSharpLanguage:before{content:\"\\F2F5\"}.ms-Icon--PythonLanguage:before{content:\"\\F2F8\"}.ms-Icon--CoffeeScript:before{content:\"\\F2FA\"}.ms-Icon--RowsChild:before{content:\"\\F29C\"}.ms-Icon--SemanticZoom:before{content:\"\\E833\"}.ms-Icon--FileTypeSolution:before{content:\"\\F387\"}.ms-Icon--FileYML:before{content:\"\\F5DA\"}.ms-Icon--Camera:before{content:\"\\E722\"}.ms-Icon--GripperResize:before{content:\"\\E788\"}.ms-Icon--UngroupList:before{content:\"\\E61C\"}.ms-Icon--GripperDotsVertical:before{content:\"\\F772\"}.ms-Icon--BugWarning:before{content:\"\\E357\"}.ms-Icon--DockRight:before{content:\"\\E90D\"}\n", ""]);



/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function escape(url, needQuotes) {
  if (typeof url !== 'string') {
    return url;
  } // If url is already wrapped in quotes, remove them


  if (/^['"].*['"]$/.test(url)) {
    url = url.slice(1, -1);
  } // Should url be wrapped?
  // See https://drafts.csswg.org/css-values-3/#urls


  if (/["'() \t\n]/.test(url) || needQuotes) {
    return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"';
  }

  return url;
};

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports = "data:font/woff;base64,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"

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(227);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-tooltip{max-width:320px;animation:tooltip-fade-in 300ms ease-in}.bolt-tooltip .bolt-callout-content{background-color:transparent}.bolt-tooltip-content{background-color:rgba(51,51,51,0.95);background-color:rgba(var(--palette-neutral-80, 51, 51, 51), 0.95);border-radius:2px;color:#fff;color:rgba(var(--palette-neutral-0, 255, 255, 255), 1);padding:8px 12px;text-align:left;word-break:break-all;word-break:break-word}.bolt-tooltip-fade-out{animation:tooltip-fade-out 300ms ease-in}.bolt-tooltip-fade-out.bolt-callout{pointer-events:none}@keyframes tooltip-fade-in{from{opacity:0}to{opacity:1}}@keyframes tooltip-fade-out{from{opacity:1}to{opacity:0}}\n", ""]);



/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(229);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-callout{background-color:transparent;pointer-events:auto}.bolt-portal.bolt-layout-relative{bottom:-5000px;left:-5000px;right:-5000px;top:-5000px}.bolt-light-dismiss{pointer-events:auto}.bolt-callout-modal{background-color:rgba(0,0,0,0.2);background-color:var(--palette-black-alpha-20, rgba(0,0,0,0.2))}@media (forced-colors: active){.bolt-callout-modal{background:transparent}}.bolt-callout-content{background-color:#fff;background-color:var(--callout-background-color, #fff);z-index:1}.bolt-callout-shadow{box-shadow:0px 6px 12px rgba(0,0,0,0.132);box-shadow:0px 6px 12px var(--callout-shadow-color, rgba(0,0,0,0.132))}.bolt-callout-extra-large{width:800px}.bolt-callout-large{width:640px}.bolt-callout-medium{width:480px}.bolt-callout-small{width:320px}.bolt-callout-auto{width:auto}\n", ""]);



/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(231);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-portal-host{position:fixed;z-index:1000000}.bolt-portal{overflow:hidden;pointer-events:none;z-index:10}\n", ""]);



/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(233);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-condensed-horizontal-spacing{padding-left:16px;padding-right:16px}.bolt-default-horizontal-spacing{padding-left:20px;padding-right:20px}.bolt-relaxed-horizontal-spacing{padding-left:32px;padding-right:32px}\n", ""]);



/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(235);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-link{border-radius:2px;color:#005a9e;color:var(--communication-foreground, #005a9e);cursor:pointer;outline:transparent;text-decoration:none;transition:color 80ms cubic-bezier(0.165, 0.84, 0.44, 1),background 80ms linear}.bolt-link:hover{color:#004578;color:rgba(var(--palette-primary-shade-30, 0, 69, 120), 1)}.bolt-focus-visible .bolt-link:focus{animation:ms-focus-shadow-with-border-pulse 4s ease-in-out infinite;box-shadow:0 0 0 3px rgba(0,120,212,0.23),0 0 0 1px #0078d4;box-shadow:0 0 0 3px var(--focus-pulse-max-color, rgba(0,120,212,0.23)),0 0 0 1px var(--focus-border-color, #0078d4)}@media (forced-colors: active){.bolt-focus-visible .bolt-link:focus{animation:none}}.bolt-link.subtle{border-radius:4px;color:inherit;padding:3px 6px}.bolt-link.subtle:hover{color:#005a9e;color:var(--communication-foreground, #005a9e);background-color:rgba(0,0,0,0.06);background-color:var(--palette-black-alpha-6, rgba(0,0,0,0.06))}.bolt-link.disabled{cursor:default}.bolt-link.underline{text-decoration:underline}.bolt-focus-visible .bolt-link.subtle:focus{background-color:rgba(0,0,0,0.06);background-color:var(--palette-black-alpha-6, rgba(0,0,0,0.06));color:#005a9e;color:var(--communication-foreground, #005a9e);outline:none}@media (forced-colors: active){.bolt-focus-visible .bolt-link:focus{outline:1px solid highlight !important}}\n", ""]);



/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(237);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-list-box-multi-select-row.bolt-list-row.selected{background:transparent}.bolt-list-box-multi-select-row.bolt-list-row.selected:hover{background:rgba(0,0,0,0.02);background:var(--component-grid-row-hover-color, rgba(0,0,0,0.02))}@media (forced-colors: active){.bolt-list-box-multi-select-row.bolt-list-row.selected{background:transparent}}.bolt-list-box-header-row{font-weight:600;cursor:text}.bolt-list-box-header-row.bolt-list-row:hover{background:transparent}.bolt-list-box-text .bolt-table-cell-content{padding:5px 0}.bolt-list-box-text-single-select.bolt-list-cell{padding:0 12px}.bolt-list-box-text-multi-select{padding-right:12px}.bolt-list-box-divider-multi-select{padding-left:12px}.bolt-list-box-divider-row,.bolt-list-box-loading-row{cursor:text}.bolt-list-box-divider-row.bolt-list-row:hover,.bolt-list-box-loading-row.bolt-list-row:hover{background:transparent}.bolt-list-box-divider{margin-bottom:1px;background-color:rgba(0,0,0,0.1);background-color:var(--palette-black-alpha-10, rgba(0,0,0,0.1));height:1px}.bolt-focus-visible .bolt-table.bolt-list-box .bolt-list-row:focus .bolt-list-cell{border-color:transparent}.bolt-list-box-loading{padding:8px 0px}.bolt-list-box-loading .bolt-spinner{flex-direction:row}.bolt-list-box-loading .bolt-spinner-circle{margin-right:10px}.bolt-list-box-loading .bolt-spinner-label{margin-top:0px}.bolt-list-box-item-disabled{color:rgba(0,0,0,0.38);color:var(--text-disabled-color, rgba(0,0,0,0.38))}.bolt-list-row.bolt-list-box-item-disabled:hover{background:transparent;cursor:text}.bolt-list-box-cell-container{width:100%}@media (forced-colors: active){.bolt-focus-visible .bolt-list-box-row:focus{font-weight:bold;color:highlight}.bolt-focus-visible .bolt-list-box-row:focus .bolt-table-cell-select,.bolt-focus-visible .bolt-list-box-row:focus .bolt-list-box-text:not(.bolt-list-box-text-multi-select){border-left:2px solid highlight}.bolt-focus-visible .bolt-list-box-row:focus .bolt-list-box-text{border-right:2px solid highlight}}@media (forced-colors: active){.bolt-list-box-row .bolt-table-cell-select,.bolt-list-box-row .bolt-list-box-text:not(.bolt-list-box-text-multi-select){border-left:2px solid transparent}.bolt-list-box-row .bolt-list-box-text{border-right:2px solid transparent}}@media (forced-colors: active){.bolt-list-box{border:1px solid windowText}}\n", ""]);



/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(239);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-spinner{align-items:center;justify-content:center}@keyframes spinner-anim{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}.bolt-spinner-circle{border:1.5px solid;border-color:#c8c8c8;border-color:rgba(var(--palette-neutral-20, 200, 200, 200), 1);border-top-color:#005a9e;border-top-color:var(--communication-foreground, #005a9e);border-radius:50%;animation-name:spinner-anim;animation-duration:1.3s;animation-iteration-count:infinite;animation-timing-function:cubic-bezier(0.53, 0.21, 0.29, 0.67)}.bolt-spinner-circle.xsmall{width:0.75rem;height:0.75rem}.bolt-spinner-circle.small{width:1rem;height:1rem}.bolt-spinner-circle.medium{width:1.25rem;height:1.25rem}.bolt-spinner-circle.large{width:1.75rem;height:1.75rem}.bolt-spinner-label{color:#005a9e;color:var(--communication-foreground, #005a9e)}\n", ""]);



/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-table-header-cell{outline:none;padding:0;border-bottom:1px solid #eaeaea;border-bottom:1px solid var(--component-grid-cell-bottom-border-color, #eaeaea)}.bolt-table-header-border{border-bottom:1px solid #eaeaea;border-bottom:1px solid var(--component-grid-cell-bottom-border-color, #eaeaea)}.bolt-table-header-cell-content{border:1px solid transparent;border-radius:4px;color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55));font-weight:600;margin:7px 0px;outline:none;padding:0.375rem 0.6875rem;position:relative;text-align:left}@media (forced-colors: active){.bolt-table-header-cell-content{border-color:transparent}}.bolt-table-header-cell-actionable>.bolt-table-header-cell-content{cursor:pointer}.bolt-table-header-cell-actionable>.bolt-table-header-cell-content:hover{background-color:rgba(0,0,0,0.02);background-color:var(--component-grid-row-hover-color, rgba(0,0,0,0.02))}.bolt-focus-visible .bolt-table-header-cell-actionable:focus>.bolt-table-header-cell-content{background-color:#deecf9;background-color:var(--component-grid-selected-row-color, #deecf9)}.bolt-table-header-cell-empty:hover{background-color:inherit}.bolt-table-header-sort-icon{padding:0 4px}.bolt-table-header-sizer{bottom:0px;position:absolute;right:0px;top:0px}.bolt-table-header-row.focused .bolt-table-cell-content-reveal,.bolt-table-header-row:hover .bolt-table-cell-content-reveal,.bolt-table-row.focused .bolt-table-cell-content-reveal,.bolt-table-row:hover .bolt-table-cell-content-reveal{visibility:visible}.bolt-table-two-line-cell-item{padding:1px}.bolt-table-two-line-cell-item .bolt-table-link:focus{animation:focus-shadow-pulse-inset 4s ease-in-out infinite;box-shadow:inset 0 0 0 3px rgba(0,120,212,0.23),inset 0 0 0 1px #0078d4;box-shadow:inset 0 0 0 3px var(--focus-pulse-max-color, rgba(0,120,212,0.23)),inset 0 0 0 1px var(--focus-border-color, #0078d4)}@media (forced-colors: active){.bolt-table-two-line-cell-item .bolt-table-link:focus{animation:none}}.bolt-table-two-line-cell-icon{margin-right:12px}.bolt-table-cell-compact{padding:0px}.bolt-table-show-lines .bolt-table-row:not(.first-row) .bolt-table-cell{border-top:1px solid #eaeaea;border-top:1px solid var(--component-grid-cell-bottom-border-color, #eaeaea)}.bolt-table-cell-primary{font-weight:600}.bolt-table-cell-tertiary{color:rgba(0,0,0,0.55)}.justify-cell-start .bolt-list-cell-child{justify-content:flex-start}.justify-cell-end .bolt-list-cell-child{justify-content:flex-end}.bolt-table-cell-content{padding:0.5625rem 0.75rem}.bolt-table-cell-content .bolt-list-cell-child:not(:last-child){margin-right:4px}.bolt-table-cell-content .bolt-list-cell-text{flex-grow:1;overflow:hidden}.bolt-table-cell-content-with-link{padding:0.375rem 0.375rem}.bolt-table-cell-content-with-inline-link{padding:0.375rem 0.5rem}.bolt-table-cell-content-with-button{padding-top:0.125rem;padding-bottom:0.125rem}.bolt-table-inline-link-left-padding{padding-left:0.25rem}.bolt-table-inline-link-right-padding{padding-right:0.25rem}.bolt-table-link.bolt-link{padding:0.1875rem 0.375rem;text-decoration:underline;color:inherit;border-radius:4px}.bolt-table-link.bolt-link:focus,.bolt-table-link.bolt-link:active{outline:none}.bolt-table-link.bolt-link:hover{color:#005a9e;color:var(--communication-foreground, #005a9e);background-color:rgba(0,0,0,0.06);background-color:var(--palette-black-alpha-6, rgba(0,0,0,0.06))}.bolt-table-inline-link.bolt-table-link{padding:0.1875rem 0.25rem}.bolt-table-cell-content-reveal{visibility:hidden}@media screen and (max-width: 600px){.bolt-table-cell-content-reveal{visibility:visible}}.bolt-table-cell-select .bolt-table-header-cell-content:hover{background-color:inherit}.bolt-table-cell-select{padding:2px 0px 0px 0px;font-weight:normal}.bolt-table-spacer-cell{z-index:1}.bolt-gripper-container{margin-left:5px;width:0.625rem;cursor:move;cursor:grab;cursor:-moz-grab;cursor:-webkit-grab}.bolt-gripper{background-image:url(\"data:image/svg+xml;utf8,<svg width='6' height='20' viewBox='0 0 6 20' fill='black' opacity='0.3' xmlns='http://www.w3.org/2000/svg'><circle cx='1' cy='7' r='1'/><circle cx='1' cy='13' r='1'/><circle cx='1' cy='19' r='1'/><circle cx='5' cy='7' r='1'/><circle cx='1' cy='1' r='1'/><circle cx='5' cy='1' r='1'/><circle cx='5' cy='13' r='1'/><circle cx='5' cy='19' r='1'/></svg>\");height:1.25rem;width:0.625rem}.bolt-focus-visible .bolt-table-header-cell:focus>.bolt-table-header-cell-content{animation:ms-focus-shadow-pulse 4s ease-in-out infinite;box-shadow:0 0 0 3px rgba(0,120,212,0.23);box-shadow:0 0 0 3px var(--focus-pulse-max-color, rgba(0,120,212,0.23));border-color:#0078d4;border-color:var(--communication-background, #0078d4);z-index:1}@media (forced-colors: active){.bolt-focus-visible .bolt-table-header-cell:focus>.bolt-table-header-cell-content{animation:none}}@media (forced-colors: active){.bolt-focus-visible .bolt-table-header-cell:focus>.bolt-table-header-cell-content{border-color:highlight;forced-color-adjust:none;background:transparent;color:windowtext}}.bolt-focus-visible .bolt-table .bolt-list-row:focus .bolt-list-cell{border-color:#0078d4;border-color:var(--component-grid-focus-border-color, #0078d4)}.bolt-focus-visible .bolt-table-link:focus{color:#005a9e;color:var(--communication-foreground, #005a9e);background-color:rgba(0,0,0,0.06);background-color:var(--palette-black-alpha-6, rgba(0,0,0,0.06))}.bolt-focus-visible .bolt-table-header-sizer:focus{border:1px solid #0078d4;border:1px solid var(--communication-background, #0078d4)}.bolt-table-container.sticky-table{display:inline-block;overflow:auto}.bolt-table.sticky-table th{position:-webkit-sticky;position:sticky;background:#fff;background:var(--background-color, #fff);top:0;z-index:1}\n", ""]);



/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-button{align-items:center;border-radius:2px;border:1px solid transparent;cursor:pointer;display:inline-flex;flex-direction:row;flex-shrink:0;font-family:inherit;font-size:inherit;font-weight:600;justify-content:center;line-height:inherit;outline:none;overflow:visible;padding:6px 12px;position:relative;transition:background 80ms linear}@media (forced-colors: active){.bolt-button{border:1px solid windowtext}}button.bolt-button{height:auto}.bolt-button::-moz-focus-inner{border:0}.bolt-button.danger{background-color:#e81123;background-color:var(--palette-error, #e81123);color:#fff;color:var(--text-on-communication-background, #fff)}.bolt-button.danger:hover{background-color:#cb0f1f;background-color:var(--palette-error-6, #cb0f1f)}.bolt-button.danger:active,.bolt-button.danger.active{background-color:#b80e1c;background-color:var(--palette-error-10, #b80e1c)}.bolt-button.primary{background-color:#0078d4;background-color:var(--communication-background, #0078d4);color:#fff;color:var(--text-on-communication-background, #fff)}.bolt-button.primary:hover{background-color:#0067b5;background-color:rgba(var(--palette-primary-darkened-6, 0, 103, 181), 1)}.bolt-button.primary:active,.bolt-button.primary.active{background-color:#005ba1;background-color:rgba(var(--palette-primary-darkened-10, 0, 91, 161), 1)}@media (forced-colors: active){.bolt-button:not(.disabled):hover{color:HighLight}}.bolt-button.disabled,.bolt-button.disabled:hover,.bolt-button.disabled:focus{background-color:rgba(0,0,0,0.06);background-color:var(--palette-black-alpha-6, rgba(0,0,0,0.06));color:rgba(0,0,0,0.38);color:var(--text-disabled-color, rgba(0,0,0,0.38));cursor:default}@media (forced-colors: active){.bolt-button.disabled,.bolt-button.disabled:hover,.bolt-button.disabled:focus{color:GrayText;forced-color-adjust:none}}.bolt-button.subtle,.bolt-button.subtle.disabled:hover,.bolt-button.subtle.disabled:focus{background-color:transparent}.bolt-button.subtle:hover{background-color:rgba(0,0,0,0.06);background-color:var(--palette-black-alpha-6, rgba(0,0,0,0.06))}.bolt-button.subtle:active{background-color:rgba(0,0,0,0.2);background-color:var(--palette-black-alpha-20, rgba(0,0,0,0.2))}.bolt-button{background-color:rgba(0,0,0,0.06);background-color:var(--palette-black-alpha-6, rgba(0,0,0,0.06));color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9));margin:0}.bolt-button:focus{z-index:1}.bolt-button:hover{background-color:rgba(0,0,0,0.1);background-color:var(--palette-black-alpha-10, rgba(0,0,0,0.1))}.bolt-button:active,.bolt-button.active{background-color:rgba(0,0,0,0.2);background-color:var(--palette-black-alpha-20, rgba(0,0,0,0.2))}.bolt-link-button{text-decoration:none}.bolt-button.icon-only{padding:8px 22px;font-weight:normal}.bolt-button.icon-only.subtle{padding:8px}.bolt-button:not(.icon-only)>.left-icon{font-weight:normal;padding-right:10px}.bolt-button.bolt-link-button{color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9))}.bolt-button.bolt-link-button:hover{color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9));text-decoration:none}.bolt-button.bolt-link-button:visited{color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9))}.bolt-button.bolt-link-button:active,.bolt-button.bolt-link-button.active{color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9))}.bolt-button.bolt-link-button.disabled{color:rgba(0,0,0,0.38);color:var(--text-disabled-color, rgba(0,0,0,0.38))}@media (forced-colors: active){.bolt-button.bolt-link-button.disabled{color:GrayText;forced-color-adjust:none}}.bolt-button.bolt-link-button.primary{color:#fff;color:var(--text-on-communication-background, #fff)}.bolt-button.bolt-link-button.primary:hover{color:#fff;color:var(--text-on-communication-background, #fff)}.bolt-button.bolt-link-button.primary:visited{color:#fff;color:var(--text-on-communication-background, #fff)}.bolt-button.bolt-link-button.primary:active,.bolt-button.bolt-link-button.primary.active{color:#fff;color:var(--text-on-communication-background, #fff)}.bolt-focus-visible .bolt-button.bolt-focus-treatment:focus{animation:ms-focus-shadow-pulse 4s ease-in-out infinite;box-shadow:0 0 0 3px rgba(0,120,212,0.23);box-shadow:0 0 0 3px var(--focus-pulse-max-color, rgba(0,120,212,0.23));border-color:#0078d4;border-color:var(--focus-border-color, #0078d4)}@media (forced-colors: active){.bolt-focus-visible .bolt-button.bolt-focus-treatment:focus{animation:none}}@media (forced-colors: active){.bolt-focus-visible .bolt-button.bolt-focus-treatment:focus{forced-color-adjust:none;border-color:highlight}}@media screen and (-ms-high-contrast: black-on-white){.bolt-focus-visible .bolt-button.bolt-focus-treatment:focus{outline:1px solid highlight;outline-offset:1px}}@media (forced-colors: active){.bolt-focus-visible .bolt-button.bolt-focus-treatment:focus{background:window;color:windowtext}}.bolt-focus-visible .bolt-button.bolt-focus-treatment:focus.primary{animation:ms-focus-shadow-with-border-pulse 4s ease-in-out infinite;box-shadow:0 0 0 3px rgba(0,120,212,0.23),0 0 0 1px #0078d4;box-shadow:0 0 0 3px var(--focus-pulse-max-color, rgba(0,120,212,0.23)),0 0 0 1px var(--focus-border-color, #0078d4);border-color:#fff;border-color:var(--text-on-communication-background, #fff)}@media (forced-colors: active){.bolt-focus-visible .bolt-button.bolt-focus-treatment:focus.primary{animation:none}}@media (forced-colors: active){.bolt-focus-visible .bolt-button.bolt-focus-treatment:focus.primary{border-color:highlight;box-shadow:none}}.bolt-focus-visible .bolt-button.bolt-focus-treatment:focus:after{content:none !important}.ms-Dialog-action .bolt-button{font-size:0.875rem}\n", ""]);



/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-expandable-button .icon-right{padding-left:10px}.bolt-expandable-button .subtle.active{background-color:rgba(0,0,0,0.2);background-color:var(--palette-black-alpha-20, rgba(0,0,0,0.2))}\n", ""]);



/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-contextual-menu{border-radius:4px;max-width:320px;overflow-x:hidden;overflow-y:auto}@media (forced-colors: active){.bolt-contextual-menu{border:1px solid}}@media screen and (max-width: 600px){.bolt-contextual-submenu{min-width:200px}}.overflow .bolt-contextual-menu{overflow-y:scroll}.bolt-menu{border-collapse:separate;color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9));display:table;table-layout:auto;font-size:0.875rem}.bolt-menuitem-row{background-color:transparent;border-radius:3px;color:inherit;display:table-row;outline:none;overflow:hidden;text-decoration:none;white-space:nowrap}@media (forced-colors: active){.bolt-menuitem-row{border:1px solid transparent}}.bolt-menuitem-row.focused{background-color:transparent;outline:none}@media (forced-colors: active){.bolt-menuitem-row.focused{border-color:windowtext}}.bolt-menuitem-row:hover,.bolt-menuitem-row.expanded{background-color:rgba(0,0,0,0.04);background-color:var(--palette-black-alpha-4, rgba(0,0,0,0.04))}@media (forced-colors: active){.bolt-menuitem-row.expanded{border-color:windowtext}.bolt-menuitem-row:hover{background-color:highlight}}.bolt-menuitem-row.disabled{color:rgba(0,0,0,0.38);color:var(--text-disabled-color, rgba(0,0,0,0.38))}.bolt-menuitem-row.disabled:hover{background-color:transparent}.bolt-focus-visible .bolt-menuitem-row.focused{animation:focus-shadow-pulse-inset 4s ease-in-out infinite;background-color:rgba(0,0,0,0.04);background-color:var(--palette-black-alpha-4, rgba(0,0,0,0.04));outline:none}a.bolt-menuitem-row:not(.ms-Button),a.bolt-menuitem-row:not(.ms-Button):visited,a.bolt-menuitem-row:not(.ms-Button):hover{color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9));text-decoration:none}@media (forced-colors: active){a.bolt-menuitem-row:not(.ms-Button),a.bolt-menuitem-row:not(.ms-Button):visited,a.bolt-menuitem-row:not(.ms-Button):hover{color:windowtext}}@media (forced-colors: active){a.bolt-menuitem-row:not(.ms-Button):hover,a.bolt-menuitem-row:not(.ms-Button):focus{color:highlighttext}}@media (forced-colors: active){a.bolt-menuitem-row .bolt-list-cell{border-color:transparent}}@media (forced-colors: active){a.bolt-menuitem-row:hover .bolt-list-cell{border-color:highlight}}@media (forced-colors: active){.bolt-focus-visible a.bolt-menuitem-row:focus .bolt-list-cell{border-color:highlight}}.bolt-menuitem-header{font-weight:600}.bolt-menuitem-divider:hover,.bolt-menuitem-header:hover{background-color:transparent}@media (forced-colors: active){.bolt-menuitem-divider:hover,.bolt-menuitem-header:hover{border:1px solid transparent}}.bolt-menuitem-cell{padding:0;vertical-align:middle}.bolt-menuitem-cell:first-child .bolt-menuitem-cell-content{padding-right:0px}.bolt-menuitem-cell:last-child .bolt-menuitem-cell-content{padding-left:0px}.bolt-menuitem-cell-content{justify-content:center;padding:6px}.bolt-menuitem-cell-text{justify-content:flex-start;max-width:225px;min-width:180px}.bolt-menuitem-cell-secondary{color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55))}.bolt-menuitem-divider-content{background-color:rgba(0,0,0,0.2);background-color:var(--palette-black-alpha-20, rgba(0,0,0,0.2));height:1px;margin:6px 6px;padding:0px}.bolt-menu-spacer{padding:4px}\n", ""]);



/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-dropdown-button{display:inline-flex}.bolt-dropdown-button .icon-right{font-size:0.75rem;padding-left:10px}\n", ""]);



/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(246);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-checkbox{border-radius:4px;color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9));display:inline-flex;align-items:center}.bolt-checkbox:focus{outline:none}.bolt-checkbox.disabled{color:rgba(0,0,0,0.38);color:var(--text-disabled-color, rgba(0,0,0,0.38));cursor:default}@media (forced-colors: active){.bolt-checkbox.disabled{forced-color-adjust:none;color:graytext}}@media (forced-colors: active){.bolt-checkbox.disabled .bolt-checkmark{border-color:graytext;color:graytext}}.bolt-checkbox.disabled.checked .bolt-checkmark{background-color:#c8c8c8;background-color:rgba(var(--palette-neutral-20, 200, 200, 200), 1)}@media (forced-colors: active){.bolt-checkbox.disabled.checked .bolt-checkmark{background-color:transparent;border-color:graytext}}.bolt-checkbox.disabled:not(.checked) .bolt-checkmark{border:1px solid;border-color:#c8c8c8;border-color:rgba(var(--palette-neutral-20, 200, 200, 200), 1)}@media (forced-colors: active){.bolt-checkbox.disabled:not(.checked) .bolt-checkmark{border-color:graytext}}.bolt-checkbox.labelled{padding:2px 4px 2px 5px}.bolt-checkbox:not(.labelled){margin:2px}.bolt-checkbox.checked .bolt-checkmark{border:1px solid transparent;background-color:#0078d4;background-color:var(--communication-background, #0078d4);color:#fff;color:var(--text-on-communication-background, #fff)}@media (forced-colors: active){.bolt-checkbox.checked .bolt-checkmark{background-color:transparent}}.bolt-checkbox:not(.checked):not(.disabled) .bolt-checkmark{border:1px solid rgba(0,0,0,0.55);border:1px solid var(--text-secondary-color, rgba(0,0,0,0.55))}@media (forced-colors: active){.bolt-checkbox:not(.checked):not(.disabled) .bolt-checkmark{color:windowtext;border-color:windowtext}}.bolt-checkbox:not(.checked):not(.disabled) .bolt-checkmark>.fabric-icon{visibility:hidden}.bolt-checkmark{border-radius:0.25rem;color:transparent;padding:1px;height:1rem;width:1rem}.bolt-checkbox-label{padding-left:10px;padding-bottom:1px}.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus{animation:ms-focus-shadow-with-border-pulse 4s ease-in-out infinite;box-shadow:0 0 0 3px rgba(0,120,212,0.23),0 0 0 1px #0078d4;box-shadow:0 0 0 3px var(--focus-pulse-max-color, rgba(0,120,212,0.23)),0 0 0 1px var(--focus-border-color, #0078d4)}@media (forced-colors: active){.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus{animation:none}}.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus:not(.checked):not(.labelled) .bolt-checkmark{border:1px solid #0078d4;border:1px solid var(--communication-background, #0078d4)}@media (forced-colors: active){.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus:not(.checked):not(.labelled) .bolt-checkmark{forced-color-adjust:none;border-color:highlight}}@media screen and (-ms-high-contrast: black-on-white){.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus:not(.checked):not(.labelled) .bolt-checkmark{outline:1px solid highlight;outline-offset:1px}}@media (forced-colors: active){.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus:not(.checked):not(.labelled) .bolt-checkmark{color:windowtext}}.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus.checked:not(.labelled) .bolt-checkmark{border:1px solid #fff;border:1px solid var(--background-color, #fff)}@media (forced-colors: active){.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus.checked:not(.labelled) .bolt-checkmark{forced-color-adjust:none;border-color:highlight}}@media screen and (-ms-high-contrast: black-on-white){.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus.checked:not(.labelled) .bolt-checkmark{outline:1px solid highlight;outline-offset:1px}}@media (forced-colors: active){.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus.checked:not(.labelled) .bolt-checkmark{color:windowtext}}@media (forced-colors: active){.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus .bolt-checkmark{forced-color-adjust:none;border-color:highlight}}@media screen and (-ms-high-contrast: black-on-white){.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus .bolt-checkmark{outline:1px solid highlight;outline-offset:1px}}@media (forced-colors: active){.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus .bolt-checkmark{color:windowtext}}\n", ""]);



/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(248);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-sizer{outline-width:0;user-select:none;z-index:1}.bolt-focus-visible .bolt-sizer{outline-width:1px}.bolt-sizer-column{cursor:ns-resize;padding:2px 0}.bolt-sizer-column.divider::before{background-color:#eaeaea;background-color:rgba(var(--palette-neutral-8, 234, 234, 234), 1);content:\"\";height:1px}.bolt-sizer-row{cursor:ew-resize;padding:0 2px}.bolt-sizer-row.divider::before{background-color:#eaeaea;background-color:rgba(var(--palette-neutral-8, 234, 234, 234), 1);content:\"\";width:1px}.bolt-sizer-portal{background-color:transparent;pointer-events:auto;z-index:100}.bolt-sizer-portal-column{cursor:ns-resize}.bolt-sizer-portal-row{cursor:ew-resize}\n", ""]);



/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(250);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-breakpoint{pointer-events:none}.bolt-breakpoint-container{height:2px}.bolt-breakpoint-observation{bottom:0;left:0;top:0}\n", ""]);



/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-tree-cell .bolt-table-cell-content{padding-bottom:6px;padding-left:6px;padding-top:6px}.bolt-tree-cell .bolt-tree-cell-content-with-button{padding-top:0.125rem;padding-bottom:0.125rem}\n", ""]);



/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-tree-expand-button{border-radius:2px;margin-right:4px;padding:6px}.bolt-tree-expand-button:hover{background-color:#eaeaea;background-color:rgba(var(--palette-neutral-8, 234, 234, 234), 1)}@media (forced-colors: active){.bolt-tree-expand-button:not(.disabled):hover{color:HighLight}}\n", ""]);



/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-textfield{color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9));border-radius:2px;border:1px solid rgba(0,0,0,0.55);border:1px solid var(--text-secondary-color, rgba(0,0,0,0.55));background-color:#fff;background-color:var(--background-color, #fff);overflow:hidden;min-width:64px}.bolt-textfield.disabled{color:rgba(0,0,0,0.38);color:var(--text-disabled-color, rgba(0,0,0,0.38));background-color:#f4f4f4;background-color:rgba(var(--palette-neutral-4, 244, 244, 244), 1)}@media (forced-colors: active){.bolt-textfield.disabled{color:graytext;background-color:window;forced-color-adjust:none;border:1px solid graytext}.bolt-textfield.disabled input{background-color:window}}.bolt-textfield.focused.focus-treatment{border-color:#0078d4;border-color:var(--communication-background, #0078d4);animation:ms-focus-shadow-with-border-pulse 4s ease-in-out infinite;box-shadow:0 0 0 3px rgba(0,120,212,0.23),0 0 0 1px #0078d4;box-shadow:0 0 0 3px var(--focus-pulse-max-color, rgba(0,120,212,0.23)),0 0 0 1px var(--focus-border-color, #0078d4)}@media (forced-colors: active){.bolt-textfield.focused.focus-treatment{animation:none}}@media (forced-colors: active){.bolt-textfield.focused.focus-treatment{forced-color-adjust:none;border-color:highlight}}@media screen and (-ms-high-contrast: black-on-white){.bolt-textfield.focused.focus-treatment{outline:1px solid highlight;outline-offset:1px}}@media (forced-colors: active){.bolt-textfield.focused.focus-treatment{color:windowtext;background-color:window}}@media (forced-colors: active){.bolt-textfield.focused.focus-treatment>*{forced-color-adjust:auto}}.bolt-textfield .prefix{padding-left:4px;margin-left:7px}.bolt-textfield .suffix{padding-right:4px;margin-right:7px}.subtle.bolt-textfield:not(.focused):not(.disabled){background-color:inherit}.hide-border.bolt-textfield:not(.focused):not(:hover){border-color:transparent}.bolt-textfield-error.bolt-textfield,.bolt-textfield-error .bolt-textfield{border-color:#da0a00;border-color:var(--status-error-text, #da0a00)}.bolt-textfield-auto-adjust{overflow:hidden}.bolt-textfield-auto-adjust-hidden{position:absolute;visibility:hidden;width:100%}.bolt-textfield-auto-unresizable{resize:none}.bolt-textfield-input{border:none;outline:none;background-color:inherit;padding:5px 11px;resize:none}.bolt-textfield-input::placeholder{color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55))}.bolt-textfield-input:-ms-input-placeholder{color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55))}.bolt-textfield-input::-ms-input-placeholder{color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55))}.bolt-textfield-input::-webkit-input-placeholder{color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55))}.bolt-textfield-input:-moz-placeholder{color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55))}.bolt-textfield-input::-ms-clear{display:none}.bolt-textfield-input:-moz-ui-invalid{box-shadow:none}.bolt-textfield-input.activatable{cursor:pointer;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.bolt-textfield-input.activatable::-moz-selection{background:transparent}.bolt-textfield-input.activatable::selection{background:transparent}.bolt-textfield-input-with-prefix{padding-left:8px}.bolt-textfield-input-with-suffix{padding-right:8px}.bolt-textfield-no-text{color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55))}.bolt-textfield-message{margin-top:8px;font-size:0.75rem;color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55))}.bolt-textfield-message-error{color:#da0a00;color:var(--status-error-text, #da0a00)}.bolt-textfield-label{margin-bottom:8px}.bolt-text-filterbaritem{background-color:transparent;border:none}.bolt-text-filterbaritem-input{background-color:transparent}.bolt-text-filterbaritem-input::placeholder{color:rgba(0,0,0,0.6);color:var(--palette-black-alpha-60, rgba(0,0,0,0.6))}.bolt-text-filterbaritem-input:-ms-input-placeholder{color:rgba(0,0,0,0.6);color:var(--palette-black-alpha-60, rgba(0,0,0,0.6))}.bolt-text-filterbaritem-input::-ms-input-placeholder{color:rgba(0,0,0,0.6);color:var(--palette-black-alpha-60, rgba(0,0,0,0.6))}.bolt-text-filterbaritem-input::-webkit-input-placeholder{color:rgba(0,0,0,0.6);color:var(--palette-black-alpha-60, rgba(0,0,0,0.6))}.bolt-text-filterbaritem-input:-moz-placeholder{color:rgba(0,0,0,0.6);color:var(--palette-black-alpha-60, rgba(0,0,0,0.6))}.bolt-text-filterbaritem-clear.bolt-button:not(:hover){background-color:transparent}.bolt-text-filterbaritem-clear.bolt-button.icon-only{padding:4px;font-size:1rem;border-color:transparent}.bolt-focus-visible .bolt-text-filterbaritem-clear.bolt-button.bolt-focus-treatment:focus{animation:none;box-shadow:none;background-color:rgba(0,0,0,0.1);background-color:var(--palette-black-alpha-10, rgba(0,0,0,0.1))}.bolt-textfield-inline{background-color:rgba(0,0,0,0.06);background-color:var(--palette-black-alpha-6, rgba(0,0,0,0.06))}.bolt-textfield-inline:not(.disabled){border-color:transparent}.bolt-textfield-inline .bolt-textfield-input{background-color:transparent}.bolt-textfield-inline:hover:not(.disabled):not(.focused){background-color:rgba(0,0,0,0.1);background-color:var(--palette-black-alpha-10, rgba(0,0,0,0.1))}.bolt-textfield-inline:hover:not(.disabled){cursor:text}.bolt-textfield-default-width{width:296px}.bolt-textfield-inline-tabbar-width{width:244px}@media screen and (max-width: 600px){.bolt-inline-keyword-filter-bar{flex-grow:1;margin-top:16px}}.bolt-focus-visible .bolt-textfield.focused.focus-keyboard-only{border-color:#0078d4;border-color:var(--communication-background, #0078d4);animation:ms-focus-shadow-with-border-pulse 4s ease-in-out infinite;box-shadow:0 0 0 3px rgba(0,120,212,0.23),0 0 0 1px #0078d4;box-shadow:0 0 0 3px var(--focus-pulse-max-color, rgba(0,120,212,0.23)),0 0 0 1px var(--focus-border-color, #0078d4)}@media (forced-colors: active){.bolt-focus-visible .bolt-textfield.focused.focus-keyboard-only{animation:none}}@media (forced-colors: active){.bolt-focus-visible .bolt-textfield.focused.focus-keyboard-only{forced-color-adjust:none;border-color:highlight}}@media screen and (-ms-high-contrast: black-on-white){.bolt-focus-visible .bolt-textfield.focused.focus-keyboard-only{outline:1px solid highlight;outline-offset:1px}}@media (forced-colors: active){.bolt-focus-visible .bolt-textfield.focused.focus-keyboard-only{background:window;color:windowtext}}\n", ""]);



/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(255);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-formitem-label{color:inherit;margin-bottom:8px}.bolt-formitem-message{color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55));margin-top:8px}.bolt-formitem-message-error{color:#da0a00;color:var(--status-error-text, #da0a00)}\n", ""]);



/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(257);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-expandable-textfield-icon:not(.disabled){color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9))}\n", ""]);



/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Components_FilterBar_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(174);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_FilterBar_index__WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_FilterBar_index__WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));



/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".vss-FilterBar{display:flex;flex-shrink:1;background:rgba(0,0,0,0.06);background:var(--palette-black-alpha-6, rgba(0,0,0,0.06));padding:8px;border-radius:4px;margin-top:8px;margin-bottom:8px;overflow:hidden}@media (forced-colors: active){.vss-FilterBar{border:1px solid windowtext}}.vss-FilterBar .filter-bar-button{padding-left:8px;padding-right:8px}.vss-FilterBar .filter-bar-button.disabled{background-color:transparent}.vss-FilterBar .vss-FilterBar--list{display:flex;align-items:center;flex-wrap:nowrap;padding-left:0;width:100%}.vss-FilterBar .vss-FilterBar--list.justify-right{justify-content:flex-end}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item{flex-shrink:0;max-width:100%}@media screen and (max-width: 600px){.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item{max-width:130px}}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .bolt-textfield{background-color:transparent}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item.max-width-small .vss-PickListDropdown--title .vss-PickListDropdown--title-textContainer,.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item.max-width-small .bolt-filter-dropdown-label{max-width:150px}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item.vss-FilterBar--item-keyword-container{flex-grow:1;margin-right:8px;min-width:220px;display:flex;max-width:100%}@media screen and (max-width: 600px){.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item.vss-FilterBar--item-keyword-container{min-width:100px;width:100px}}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item input::-ms-clear{display:none}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .vss-PickListDropdown{border-radius:2px}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .vss-PickListDropdown:hover{background:rgba(0,0,0,0.06);background:var(--palette-black-alpha-6, rgba(0,0,0,0.06))}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .vss-PickListDropdown .vss-PickListDropdown--title-text-withSelections{font-weight:600}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .vss-FilterBar--item-keyword input{padding:0}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .vss-PickListDropdown--title{border:0;background:transparent;padding:6px 12px;overflow:visible;border-radius:2px}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .vss-PickListDropdown--title .vss-PickListDropdown--title-textContainer{margin:0;max-width:340px}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .vss-PickListDropdown--title .vss-Icon{margin-left:10px;margin-right:0;color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55))}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items{display:flex;flex-shrink:0;margin-left:8px}@media screen and (max-width: 600px){.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items{margin-left:0px}}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--action.vss-FilterBar--action-clear{display:flex;justify-content:center}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--action.vss-FilterBar--action-clear .filter-bar-button:not([disabled]):hover{background-color:transparent}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--action.vss-FilterBar--action-apply{align-items:center;display:flex}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--action .filter-bar-button{overflow:visible}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container{display:flex}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container .vss-FilterBar-page-button{width:32px;min-width:32px;margin-right:10px;background-color:transparent;color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9))}@media screen and (max-width: 600px){.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container .vss-FilterBar-page-button{margin-right:0px}}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container .vss-FilterBar-page-button:hover:not(.disabled){background-color:rgba(0,0,0,0.06);background-color:var(--palette-black-alpha-6, rgba(0,0,0,0.06))}@media (forced-colors: active){.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container .vss-FilterBar-page-button:hover:not(.disabled){background:highlight;color:highlighttext}}.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container .vss-FilterBar-page-button.disabled{color:rgba(0,0,0,0.38);color:var(--text-disabled-color, rgba(0,0,0,0.38))}@media (forced-colors: active){.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container .vss-FilterBar-page-button.disabled{color:grayText;background:window}}@media (forced-colors: active){.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container .vss-FilterBar-page-button:focus{background:highlight;color:highlighttext}}.bolt-filterbar-white{background:#fff;background:var(--callout-background-color, #fff)}\n", ""]);



/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Components_TextFilterBarItem_TextFilterBarItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextFilterBarItem", function() { return _Components_TextFilterBarItem_TextFilterBarItem__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _Components_TextFilterBarItem_KeywordFilterBarItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(177);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "KeywordFilterBarItem", function() { return _Components_TextFilterBarItem_KeywordFilterBarItem__WEBPACK_IMPORTED_MODULE_1__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InlineKeywordFilterBarItem", function() { return _Components_TextFilterBarItem_KeywordFilterBarItem__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _Components_TextFilterBarItem_TextFilterBarItem_Props__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(178);
/* harmony import */ var _Components_TextFilterBarItem_TextFilterBarItem_Props__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Components_TextFilterBarItem_TextFilterBarItem_Props__WEBPACK_IMPORTED_MODULE_2__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Components_TextFilterBarItem_TextFilterBarItem_Props__WEBPACK_IMPORTED_MODULE_2__) if(["default","TextFilterBarItem","KeywordFilterBarItem","InlineKeywordFilterBarItem"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Components_TextFilterBarItem_TextFilterBarItem_Props__WEBPACK_IMPORTED_MODULE_2__[key]; }) }(__WEBPACK_IMPORT_KEY__));


// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present



/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunCard = void 0;
__webpack_require__(262);
const React = __webpack_require__(0);
const react_1 = __webpack_require__(0);
const mobx_1 = __webpack_require__(3);
const mobx_react_1 = __webpack_require__(67);
const Hi_1 = __webpack_require__(70);
const RunCard_renderCell_1 = __webpack_require__(264);
const RunStore_1 = __webpack_require__(185);
const RunCard_TreeColumnSorting_1 = __webpack_require__(382);
const try_1 = __webpack_require__(59);
const Card_1 = __webpack_require__(84);
const Observer_1 = __webpack_require__(8);
const Observable_1 = __webpack_require__(4);
const Menu_1 = __webpack_require__(56);
const Pill_1 = __webpack_require__(63);
const TreeEx_1 = __webpack_require__(60);
const TreeItemProvider_1 = __webpack_require__(107);
const TooltipEx_1 = __webpack_require__(19);
let RunCard = class RunCard extends react_1.Component {
    get sortRuleByMenuItems() {
        const { runStore } = this.props;
        const sortRuleBy = (0, mobx_1.untracked)(() => runStore.sortRuleBy);
        const onActivate = menuItem => {
            runStore.sortRuleBy = menuItem.data;
            this.sortRuleByMenuItems.forEach(item => item.checked.value = item.id === menuItem.id);
        };
        return [
            {
                data: RunStore_1.SortRuleBy.Count,
                id: 'sortByRuleCount',
                text: 'Sort by rule count',
                ariaLabel: 'Sort by rule count',
                onActivate,
                important: false,
                checked: new Observable_1.ObservableValue(sortRuleBy === RunStore_1.SortRuleBy.Count),
            },
            {
                data: RunStore_1.SortRuleBy.Name,
                id: 'sortByRuleName',
                text: 'Sort by rule name',
                ariaLabel: 'Sort by rule name',
                onActivate,
                important: false,
                checked: new Observable_1.ObservableValue(sortRuleBy === RunStore_1.SortRuleBy.Name),
            },
        ];
    }
    get columns() {
        const { runStore } = this.props;
        return runStore.columns.map((col, i) => {
            const { id, width } = col;
            if (!this.columnCache.has(id)) {
                const observableWidth = new Observable_1.ObservableValue(width);
                this.columnCache.set(id, {
                    id: id.replace(/ /g, ''),
                    name: id,
                    width: observableWidth,
                    onSize: (e, i, newWidth) => observableWidth.value = newWidth,
                    renderCell: RunCard_renderCell_1.renderCell,
                    sortProps: {
                        ariaLabelAscending: "Sorted A to Z",
                        ariaLabelDescending: "Sorted Z to A",
                        sortOrder: i === runStore.sortColumnIndex ? runStore.sortOrder : undefined
                    },
                });
            }
            return this.columnCache.get(id);
        });
    }
    constructor(props) {
        super(props);
        this.show = true;
        this.groupByMenuItems = [];
        this.itemProvider = new TreeItemProvider_1.TreeItemProvider([]);
        this.columnCache = new Map();
        this.sortingBehavior = new RunCard_TreeColumnSorting_1.TreeColumnSorting((columnIndex, proposedSortOrder, event) => {
            for (let index = 0; index < this.columns.length; index++) {
                const column = this.columns[index];
                if (column.sortProps) {
                    column.sortProps.sortOrder = index === columnIndex ? proposedSortOrder : undefined;
                }
            }
            (0, mobx_1.runInAction)(() => {
                this.props.runStore.sortColumnIndex = columnIndex;
                this.props.runStore.sortOrder = proposedSortOrder;
            });
        });
        const { runStore } = this.props;
        if (runStore.showAge) {
            const onActivateGroupBy = menuItem => {
                runStore.groupByAge.set(menuItem.data);
                this.groupByMenuItems
                    .filter(item => item.itemType !== Menu_1.MenuItemType.Divider)
                    .forEach(item => item.checked.value = item.id === menuItem.id);
            };
            this.groupByMenuItems = [
                {
                    data: true,
                    id: 'groupByAge',
                    text: 'Group by age',
                    ariaLabel: 'Group by age',
                    onActivate: onActivateGroupBy,
                    important: false,
                    checked: new Observable_1.ObservableValue(runStore.groupByAge.get()),
                },
                {
                    data: false,
                    id: 'groupByRule',
                    text: 'Group by rule',
                    ariaLabel: 'Group by rule',
                    onActivate: onActivateGroupBy,
                    important: false,
                    checked: new Observable_1.ObservableValue(!runStore.groupByAge.get()),
                },
                { id: "separator", important: false, itemType: Menu_1.MenuItemType.Divider },
            ];
        }
        (0, mobx_1.autorun)(() => {
            this.itemProvider.clear();
            this.itemProvider.splice(undefined, undefined, [{ items: this.props.runStore.rulesTruncated }]);
        });
        (0, mobx_1.autorun)(() => this.show = this.props.index === 0);
    }
    render() {
        const { show, itemProvider } = this;
        const { runStore, runCount } = this.props;
        return React.createElement(Observer_1.Observer, { renderChildren: itemProvider }, (observedProps) => {
            const qualityDomain = (0, try_1.tryOr)(() => runStore.run.tool.driver.properties['microsoft/qualityDomain']);
            return React.createElement(Card_1.Card, { titleProps: {
                    ariaLevel: 2,
                    text: React.createElement(TooltipEx_1.Tooltip, { text: React.createElement(React.Fragment, null,
                            React.createElement("div", null, (0, try_1.tryOr)(() => runStore.run.tool.driver.fullName, () => `${runStore.run.tool.driver.name} ${runStore.run.tool.driver.semanticVersion || ''}`)),
                            (0, try_1.tryOr)(() => React.createElement("div", null, runStore.run.tool.driver.fullDescription.text), () => React.createElement("div", null, runStore.run.tool.driver.shortDescription.text))) },
                        React.createElement("span", { className: 'swcRunTitle' },
                            React.createElement(Hi_1.Hi, null, runStore.driverName),
                            qualityDomain && ` (${qualityDomain})`,
                            React.createElement(Pill_1.Pill, { size: Pill_1.PillSize.compact }, runStore.filteredCount)))
                }, contentProps: { contentPadding: false }, headerCommandBarItems: [
                    runCount > 1
                        ? {
                            id: 'hide',
                            text: '',
                            ariaLabel: 'Show/Hide',
                            onActivate: () => this.show = !this.show,
                            iconProps: { iconName: this.show ? 'ChevronDown' : 'ChevronUp' },
                            important: runCount > 1
                        }
                        : undefined,
                    ...this.groupByMenuItems,
                    ...this.sortRuleByMenuItems,
                ].filter(item => item), className: "flex-grow bolt-card-no-vertical-padding" }, show && (itemProvider.length
                ? React.createElement(TreeEx_1.Tree, { className: "swcTree", columns: this.columns, itemProvider: itemProvider, onToggle: (event, treeItem) => {
                        itemProvider.toggle(treeItem.underlyingItem);
                    }, onActivate: (event, treeRow) => {
                        const treeItem = treeRow.data.underlyingItem;
                        const more = treeItem.data;
                        if (more.onClick) {
                            more.onClick(); // Handle "Show All"
                        }
                        else {
                            itemProvider.toggle(treeItem);
                        }
                    }, behaviors: [this.sortingBehavior], selectableText: true })
                : React.createElement("div", { className: "swcRunEmpty" }, "No Results")));
        });
    }
};
__decorate([
    mobx_1.observable
], RunCard.prototype, "show", void 0);
__decorate([
    (0, mobx_1.computed)({ keepAlive: true })
], RunCard.prototype, "sortRuleByMenuItems", null);
__decorate([
    mobx_1.computed
], RunCard.prototype, "columns", null);
RunCard = __decorate([
    mobx_react_1.observer
], RunCard);
exports.RunCard = RunCard;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(263);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".swcRunTitle{display:flex;align-items:center}.swcRunTitle .bolt-pill{margin-left:8px}.bolt-table-cell .bolt-dropdown-expandable{display:block}.bolt-table-cell .bolt-dropdown-expandable .bolt-button{width:100%}.swcRunEmpty{color:var(--text-disabled-color);text-align:center;margin-bottom:32px}\n", ""]);



/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderCell = void 0;
__webpack_require__(98);
const React = __webpack_require__(0);
const react_1 = __webpack_require__(0);
const ReactMarkdown = __webpack_require__(266);
const Hi_1 = __webpack_require__(70);
const try_1 = __webpack_require__(59);
const Snippet_1 = __webpack_require__(351);
const Util_1 = __webpack_require__(1);
const Link_1 = __webpack_require__(30);
const Observable_1 = __webpack_require__(4);
const Status_1 = __webpack_require__(399);
const Pill_1 = __webpack_require__(63);
const Table_1 = __webpack_require__(24);
const TreeEx_1 = __webpack_require__(60);
const Icon_1 = __webpack_require__(9);
const RunCard_renderPathCell_1 = __webpack_require__(365);
const RunCard_renderActionsCell_1 = __webpack_require__(378);
const getRepoUri_1 = __webpack_require__(105);
const colspan = 99; // No easy way to parameterize this, however extra does not hurt, so using an arbitrarily large value.
function renderCell(rowIndex, columnIndex, treeColumn, treeItem) {
    const data = Observable_1.ObservableLike.getValue(treeItem.underlyingItem.data);
    const commonProps = {
        className: treeColumn.className,
        columnIndex,
        treeItem,
        treeColumn,
    };
    // ROW AGE
    const isAge = (item => item.isAge);
    if (isAge(data)) {
        const age = data;
        return columnIndex === 0
            ? (0, TreeEx_1.ExpandableTreeCell)(Object.assign({ children: React.createElement("div", { className: "swcRowRule" },
                    age.name,
                    React.createElement(Pill_1.Pill, { size: Pill_1.PillSize.compact }, age.treeItem.childItemsAll.length)), colspan }, commonProps))
            : null;
    }
    // ROW RULE
    const isRule = (item => item.isRule);
    if (isRule(data)) {
        const rule = data;
        return columnIndex === 0
            ? (0, TreeEx_1.ExpandableTreeCell)(Object.assign({ children: React.createElement("div", { className: "swcRowRule" },
                    (0, try_1.tryLink)(() => rule.helpUri, React.createElement(Hi_1.Hi, null, rule.id || rule.guid)),
                    (0, try_1.tryOr)(() => rule.name && React.createElement(React.Fragment, null,
                        ": ",
                        React.createElement(Hi_1.Hi, null, rule.name))),
                    (0, try_1.tryOr)(() => rule.relationships.map((rel, i) => {
                        const taxon = rule.run.taxonomies[rel.target.toolComponent.index].taxa[rel.target.index];
                        return React.createElement(react_1.Fragment, { key: rel.target.id },
                            i > 0 ? ',' : '',
                            " ",
                            (0, try_1.tryLink)(() => taxon.helpUri, taxon.name));
                    })),
                    React.createElement(Pill_1.Pill, { size: Pill_1.PillSize.compact }, rule.treeItem.childItemsAll.length)), colspan }, commonProps))
            : null;
    }
    // ROW RESULT
    const capitalize = str => `${str[0].toUpperCase()}${str.slice(1)}`;
    const isResult = (item => item.message !== undefined);
    if (isResult(data)) {
        const result = data;
        const status = {
            none: result.kind === 'pass' ? Status_1.Statuses.Success : Status_1.Statuses.Queued,
            note: Status_1.Statuses.Information,
            error: Status_1.Statuses.Failed,
        }[result.level] || Status_1.Statuses.Warning;
        return columnIndex === 0
            // ExpandableTreeCell (td div.bolt-table-cell-content.flex-row.flex-center TreeExpand children)
            // calls SimpleTableCell - adds an extra div
            // calls TableCell
            ? (0, TreeEx_1.ExpandableTreeCell)(Object.assign({ children: React.createElement(React.Fragment, null,
                    React.createElement(Status_1.Status, Object.assign({}, status, { className: "bolt-table-two-line-cell-icon flex-noshrink bolt-table-status-icon", size: Status_1.StatusSize.m, ariaLabel: result.level || 'warning' })),
                    (0, RunCard_renderPathCell_1.renderPathCell)(result)) }, commonProps))
            : (0, Table_1.TableCell)({
                children: (() => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    const rule = result._rule;
                    switch (treeColumn.id) {
                        case 'Actions':
                            return React.createElement(React.Fragment, null,
                                " ",
                                (0, RunCard_renderActionsCell_1.renderActionsCell)(result),
                                " ");
                        case 'Details':
                            const messageFromRule = (_d = (_b = (_a = result._rule) === null || _a === void 0 ? void 0 : _a.messageStrings) === null || _b === void 0 ? void 0 : _b[(_c = result.message.id) !== null && _c !== void 0 ? _c : -1]) !== null && _d !== void 0 ? _d : result.message;
                            const formattedMessage = (_f = format(messageFromRule.text || ((_e = result.message) === null || _e === void 0 ? void 0 : _e.text), result.message.arguments)) !== null && _f !== void 0 ? _f : '';
                            const formattedMarkdown = format(messageFromRule.markdown || ((_g = result.message) === null || _g === void 0 ? void 0 : _g.markdown), result.message.arguments); // No '—', leave undefined if empty.
                            return React.createElement(React.Fragment, null,
                                formattedMarkdown
                                    ? React.createElement("div", { className: "swcMarkDown" },
                                        React.createElement(ReactMarkdown, { source: formattedMarkdown, renderers: { link: ({ href, children }) => React.createElement("a", { href: href, target: "_blank" }, children) } })) // Div to cancel out containers display flex row.
                                    : React.createElement("span", { style: { whiteSpace: 'pre-line' } },
                                        React.createElement(Hi_1.Hi, null, renderMessageWithEmbeddedLinks(result, formattedMessage))) || '',
                                React.createElement(Snippet_1.Snippet, { ploc: (_j = (_h = result.locations) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.physicalLocation }));
                        case 'Rule':
                            return React.createElement(React.Fragment, null,
                                (0, try_1.tryLink)(() => rule.helpUri, React.createElement(Hi_1.Hi, null, rule.id || rule.guid)),
                                (0, try_1.tryOr)(() => rule.name && React.createElement(React.Fragment, null,
                                    ": ",
                                    React.createElement(Hi_1.Hi, null, rule.name))));
                        case 'Baseline':
                            return React.createElement(Hi_1.Hi, null, result.baselineState && capitalize(result.baselineState) || 'New');
                        case 'Bug':
                            return (0, try_1.tryOr)(() => React.createElement(Link_1.Link, { href: result.workItemUris[0], target: "_blank" },
                                React.createElement(Icon_1.Icon, { iconName: "LadybugSolid", size: Icon_1.IconSize.medium, style: { color: '#E81123' } })));
                        case 'Age':
                            return React.createElement(Hi_1.Hi, null, result.sla);
                        case 'FirstObserved':
                            return React.createElement(Hi_1.Hi, null, result.firstDetection.toLocaleDateString());
                    }
                })(),
                className: (0, Util_1.css)(treeColumn.className, 'font-size'),
                columnIndex,
            });
    }
    // ROW MORE
    const isMore = (item => item.onClick !== undefined);
    if (isMore(data)) {
        return columnIndex === 0
            ? (0, TreeEx_1.ExpandableTreeCell)(Object.assign({ children: React.createElement(Link_1.Link, { onClick: data.onClick, tabIndex: -1 }, "Show All"), colspan }, commonProps))
            : null;
    }
    return null;
}
exports.renderCell = renderCell;
// Replace [text](relatedIndex) with <a href />
function renderMessageWithEmbeddedLinks(result, message) {
    const rxLink = /\[([^\]]*)\]\(([^\)]+)\)/; // Matches [text](id). Similar to below, but with an extra grouping around the id part.
    return message.match(rxLink)
        ? message
            .split(/(\[[^\]]*\]\([^\)]+\))/g)
            .map((item, i) => {
            if (i % 2 === 0)
                return item;
            const [_, text, id] = item.match(rxLink);
            const href = (() => {
                var _a, _b, _c;
                if (isNaN(id))
                    return id; // `id` is a URI string
                // Else `id` is a number
                // TODO: search other location collections
                // RelatedLocations is typically [{ id: 1, ...}, { id: 2, ...}]
                const physicalLocation = (_b = (_a = result.relatedLocations) === null || _a === void 0 ? void 0 : _a.find(location => location.id === +id)) === null || _b === void 0 ? void 0 : _b.physicalLocation;
                return (0, getRepoUri_1.getRepoUri)((_c = physicalLocation === null || physicalLocation === void 0 ? void 0 : physicalLocation.artifactLocation) === null || _c === void 0 ? void 0 : _c.uri, result.run, physicalLocation === null || physicalLocation === void 0 ? void 0 : physicalLocation.region);
            })();
            return href
                ? React.createElement("a", { key: i, href: href, target: "_blank" }, text)
                : text;
        })
        : message;
}
// Borrowed from sarif-vscode-extension.
function format(template, args) {
    if (!template)
        return undefined;
    if (!args)
        return template;
    return template.replace(/{(\d+)}/g, (_, group) => args[group]);
}


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".swcTree .bolt-list-cell{white-space:normal}.swcMarkDown li{list-style:unset;list-style-position:inside}.swcMarkDown>:first-child{margin-top:0}.swcMarkDown>:last-child{margin-bottom:0}.swcMarkDown+.swcSnippet{margin-top:12px}.swcColorUnset{color:unset}.swcWidth100{width:100%}.swcRowRule{display:flex;flex-direction:row;align-items:center}.swcRowRule .bolt-pill{margin-left:8px}.midEllipsis{display:flex;white-space:nowrap}.midEllipsis :first-child{overflow:hidden;text-overflow:ellipsis}.action{display:flex}.action a{display:flex;flex-direction:row;justify-content:center;margin:4px 0px}.action img{height:16px;width:16px;margin:0;margin-right:10px}\n", ""]);



/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var xtend = __webpack_require__(37);

var unified = __webpack_require__(267);

var parse = __webpack_require__(280);

var PropTypes = __webpack_require__(336);

var addListMetadata = __webpack_require__(339);

var naiveHtml = __webpack_require__(341);

var disallowNode = __webpack_require__(342);

var astToReact = __webpack_require__(343);

var wrapTableRows = __webpack_require__(346);

var getDefinitions = __webpack_require__(347);

var uriTransformer = __webpack_require__(348);

var defaultRenderers = __webpack_require__(349);

var symbols = __webpack_require__(350);

var allTypes = Object.keys(defaultRenderers);

var ReactMarkdown = function ReactMarkdown(props) {
  var src = props.source || props.children || '';
  var parserOptions = props.parserOptions;

  if (props.allowedTypes && props.disallowedTypes) {
    throw new Error('Only one of `allowedTypes` and `disallowedTypes` should be defined');
  }

  var renderers = xtend(defaultRenderers, props.renderers);
  var plugins = [[parse, parserOptions]].concat(props.plugins || []);
  var parser = plugins.reduce(applyParserPlugin, unified());
  var rawAst = parser.parse(src);
  var renderProps = xtend(props, {
    renderers: renderers,
    definitions: getDefinitions(rawAst)
  });
  var astPlugins = determineAstPlugins(props); // eslint-disable-next-line no-sync

  var transformedAst = parser.runSync(rawAst);
  var ast = astPlugins.reduce(function (node, plugin) {
    return plugin(node, renderProps);
  }, transformedAst);
  return astToReact(ast, renderProps);
};

function applyParserPlugin(parser, plugin) {
  return Array.isArray(plugin) ? parser.use.apply(parser, _toConsumableArray(plugin)) : parser.use(plugin);
}

function determineAstPlugins(props) {
  var plugins = [wrapTableRows, addListMetadata()];
  var disallowedTypes = props.disallowedTypes;

  if (props.allowedTypes) {
    disallowedTypes = allTypes.filter(function (type) {
      return type !== 'root' && props.allowedTypes.indexOf(type) === -1;
    });
  }

  var removalMethod = props.unwrapDisallowed ? 'unwrap' : 'remove';

  if (disallowedTypes && disallowedTypes.length > 0) {
    plugins.push(disallowNode.ofType(disallowedTypes, removalMethod));
  }

  if (props.allowNode) {
    plugins.push(disallowNode.ifNotMatch(props.allowNode, removalMethod));
  }

  var renderHtml = !props.escapeHtml && !props.skipHtml;
  var hasHtmlParser = (props.astPlugins || []).some(function (item) {
    var plugin = Array.isArray(item) ? item[0] : item;
    return plugin.identity === symbols.HtmlParser;
  });

  if (renderHtml && !hasHtmlParser) {
    plugins.push(naiveHtml);
  }

  return props.astPlugins ? plugins.concat(props.astPlugins) : plugins;
}

ReactMarkdown.defaultProps = {
  renderers: {},
  escapeHtml: true,
  skipHtml: false,
  sourcePos: false,
  rawSourcePos: false,
  transformLinkUri: uriTransformer,
  astPlugins: [],
  plugins: [],
  parserOptions: {}
};
ReactMarkdown.propTypes = {
  className: PropTypes.string,
  source: PropTypes.string,
  children: PropTypes.string,
  sourcePos: PropTypes.bool,
  rawSourcePos: PropTypes.bool,
  escapeHtml: PropTypes.bool,
  skipHtml: PropTypes.bool,
  allowNode: PropTypes.func,
  allowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
  disallowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
  transformLinkUri: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  linkTarget: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  transformImageUri: PropTypes.func,
  astPlugins: PropTypes.arrayOf(PropTypes.func),
  unwrapDisallowed: PropTypes.bool,
  renderers: PropTypes.object,
  plugins: PropTypes.array,
  parserOptions: PropTypes.object
};
ReactMarkdown.types = allTypes;
ReactMarkdown.renderers = defaultRenderers;
ReactMarkdown.uriTransformer = uriTransformer;
module.exports = ReactMarkdown;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* Dependencies. */
var extend = __webpack_require__(268)
var bail = __webpack_require__(269)
var vfile = __webpack_require__(270)
var trough = __webpack_require__(276)
var string = __webpack_require__(278)
var plain = __webpack_require__(279)

/* Expose a frozen processor. */
module.exports = unified().freeze()

var slice = [].slice
var own = {}.hasOwnProperty

/* Process pipeline. */
var pipeline = trough()
  .use(pipelineParse)
  .use(pipelineRun)
  .use(pipelineStringify)

function pipelineParse(p, ctx) {
  ctx.tree = p.parse(ctx.file)
}

function pipelineRun(p, ctx, next) {
  p.run(ctx.tree, ctx.file, done)

  function done(err, tree, file) {
    if (err) {
      next(err)
    } else {
      ctx.tree = tree
      ctx.file = file
      next()
    }
  }
}

function pipelineStringify(p, ctx) {
  ctx.file.contents = p.stringify(ctx.tree, ctx.file)
}

/* Function to create the first processor. */
function unified() {
  var attachers = []
  var transformers = trough()
  var namespace = {}
  var frozen = false
  var freezeIndex = -1

  /* Data management. */
  processor.data = data

  /* Lock. */
  processor.freeze = freeze

  /* Plug-ins. */
  processor.attachers = attachers
  processor.use = use

  /* API. */
  processor.parse = parse
  processor.stringify = stringify
  processor.run = run
  processor.runSync = runSync
  processor.process = process
  processor.processSync = processSync

  /* Expose. */
  return processor

  /* Create a new processor based on the processor
   * in the current scope. */
  function processor() {
    var destination = unified()
    var length = attachers.length
    var index = -1

    while (++index < length) {
      destination.use.apply(null, attachers[index])
    }

    destination.data(extend(true, {}, namespace))

    return destination
  }

  /* Freeze: used to signal a processor that has finished
   * configuration.
   *
   * For example, take unified itself.  It’s frozen.
   * Plug-ins should not be added to it.  Rather, it should
   * be extended, by invoking it, before modifying it.
   *
   * In essence, always invoke this when exporting a
   * processor. */
  function freeze() {
    var values
    var plugin
    var options
    var transformer

    if (frozen) {
      return processor
    }

    while (++freezeIndex < attachers.length) {
      values = attachers[freezeIndex]
      plugin = values[0]
      options = values[1]
      transformer = null

      if (options === false) {
        continue
      }

      if (options === true) {
        values[1] = undefined
      }

      transformer = plugin.apply(processor, values.slice(1))

      if (typeof transformer === 'function') {
        transformers.use(transformer)
      }
    }

    frozen = true
    freezeIndex = Infinity

    return processor
  }

  /* Data management.
   * Getter / setter for processor-specific informtion. */
  function data(key, value) {
    if (string(key)) {
      /* Set `key`. */
      if (arguments.length === 2) {
        assertUnfrozen('data', frozen)

        namespace[key] = value

        return processor
      }

      /* Get `key`. */
      return (own.call(namespace, key) && namespace[key]) || null
    }

    /* Set space. */
    if (key) {
      assertUnfrozen('data', frozen)
      namespace = key
      return processor
    }

    /* Get space. */
    return namespace
  }

  /* Plug-in management.
   *
   * Pass it:
   * *   an attacher and options,
   * *   a preset,
   * *   a list of presets, attachers, and arguments (list
   *     of attachers and options). */
  function use(value) {
    var settings

    assertUnfrozen('use', frozen)

    if (value === null || value === undefined) {
      /* Empty */
    } else if (typeof value === 'function') {
      addPlugin.apply(null, arguments)
    } else if (typeof value === 'object') {
      if ('length' in value) {
        addList(value)
      } else {
        addPreset(value)
      }
    } else {
      throw new Error('Expected usable value, not `' + value + '`')
    }

    if (settings) {
      namespace.settings = extend(namespace.settings || {}, settings)
    }

    return processor

    function addPreset(result) {
      addList(result.plugins)

      if (result.settings) {
        settings = extend(settings || {}, result.settings)
      }
    }

    function add(value) {
      if (typeof value === 'function') {
        addPlugin(value)
      } else if (typeof value === 'object') {
        if ('length' in value) {
          addPlugin.apply(null, value)
        } else {
          addPreset(value)
        }
      } else {
        throw new Error('Expected usable value, not `' + value + '`')
      }
    }

    function addList(plugins) {
      var length
      var index

      if (plugins === null || plugins === undefined) {
        /* Empty */
      } else if (typeof plugins === 'object' && 'length' in plugins) {
        length = plugins.length
        index = -1

        while (++index < length) {
          add(plugins[index])
        }
      } else {
        throw new Error('Expected a list of plugins, not `' + plugins + '`')
      }
    }

    function addPlugin(plugin, value) {
      var entry = find(plugin)

      if (entry) {
        if (plain(entry[1]) && plain(value)) {
          value = extend(entry[1], value)
        }

        entry[1] = value
      } else {
        attachers.push(slice.call(arguments))
      }
    }
  }

  function find(plugin) {
    var length = attachers.length
    var index = -1
    var entry

    while (++index < length) {
      entry = attachers[index]

      if (entry[0] === plugin) {
        return entry
      }
    }
  }

  /* Parse a file (in string or VFile representation)
   * into a Unist node using the `Parser` on the
   * processor. */
  function parse(doc) {
    var file = vfile(doc)
    var Parser

    freeze()
    Parser = processor.Parser
    assertParser('parse', Parser)

    if (newable(Parser)) {
      return new Parser(String(file), file).parse()
    }

    return Parser(String(file), file) // eslint-disable-line new-cap
  }

  /* Run transforms on a Unist node representation of a file
   * (in string or VFile representation), async. */
  function run(node, file, cb) {
    assertNode(node)
    freeze()

    if (!cb && typeof file === 'function') {
      cb = file
      file = null
    }

    if (!cb) {
      return new Promise(executor)
    }

    executor(null, cb)

    function executor(resolve, reject) {
      transformers.run(node, vfile(file), done)

      function done(err, tree, file) {
        tree = tree || node
        if (err) {
          reject(err)
        } else if (resolve) {
          resolve(tree)
        } else {
          cb(null, tree, file)
        }
      }
    }
  }

  /* Run transforms on a Unist node representation of a file
   * (in string or VFile representation), sync. */
  function runSync(node, file) {
    var complete = false
    var result

    run(node, file, done)

    assertDone('runSync', 'run', complete)

    return result

    function done(err, tree) {
      complete = true
      bail(err)
      result = tree
    }
  }

  /* Stringify a Unist node representation of a file
   * (in string or VFile representation) into a string
   * using the `Compiler` on the processor. */
  function stringify(node, doc) {
    var file = vfile(doc)
    var Compiler

    freeze()
    Compiler = processor.Compiler
    assertCompiler('stringify', Compiler)
    assertNode(node)

    if (newable(Compiler)) {
      return new Compiler(node, file).compile()
    }

    return Compiler(node, file) // eslint-disable-line new-cap
  }

  /* Parse a file (in string or VFile representation)
   * into a Unist node using the `Parser` on the processor,
   * then run transforms on that node, and compile the
   * resulting node using the `Compiler` on the processor,
   * and store that result on the VFile. */
  function process(doc, cb) {
    freeze()
    assertParser('process', processor.Parser)
    assertCompiler('process', processor.Compiler)

    if (!cb) {
      return new Promise(executor)
    }

    executor(null, cb)

    function executor(resolve, reject) {
      var file = vfile(doc)

      pipeline.run(processor, {file: file}, done)

      function done(err) {
        if (err) {
          reject(err)
        } else if (resolve) {
          resolve(file)
        } else {
          cb(null, file)
        }
      }
    }
  }

  /* Process the given document (in string or VFile
   * representation), sync. */
  function processSync(doc) {
    var complete = false
    var file

    freeze()
    assertParser('processSync', processor.Parser)
    assertCompiler('processSync', processor.Compiler)
    file = vfile(doc)

    process(file, done)

    assertDone('processSync', 'process', complete)

    return file

    function done(err) {
      complete = true
      bail(err)
    }
  }
}

/* Check if `func` is a constructor. */
function newable(value) {
  return typeof value === 'function' && keys(value.prototype)
}

/* Check if `value` is an object with keys. */
function keys(value) {
  var key
  for (key in value) {
    return true
  }
  return false
}

/* Assert a parser is available. */
function assertParser(name, Parser) {
  if (typeof Parser !== 'function') {
    throw new Error('Cannot `' + name + '` without `Parser`')
  }
}

/* Assert a compiler is available. */
function assertCompiler(name, Compiler) {
  if (typeof Compiler !== 'function') {
    throw new Error('Cannot `' + name + '` without `Compiler`')
  }
}

/* Assert the processor is not frozen. */
function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error(
      [
        'Cannot invoke `' + name + '` on a frozen processor.\nCreate a new ',
        'processor first, by invoking it: use `processor()` instead of ',
        '`processor`.'
      ].join('')
    )
  }
}

/* Assert `node` is a Unist node. */
function assertNode(node) {
  if (!node || !string(node.type)) {
    throw new Error('Expected node, got `' + node + '`')
  }
}

/* Assert that `complete` is `true`. */
function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error(
      '`' + name + '` finished async. Use `' + asyncName + '` instead'
    )
  }
}


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = bail

function bail(err) {
  if (err) {
    throw err
  }
}


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var VMessage = __webpack_require__(271);
var VFile = __webpack_require__(273);

module.exports = VFile;

var proto = VFile.prototype;

proto.message = message;
proto.info = info;
proto.fail = fail;

/* Slight backwards compatibility.  Remove in the future. */
proto.warn = message;

/* Create a message with `reason` at `position`.
 * When an error is passed in as `reason`, copies the stack. */
function message(reason, position, origin) {
  var filePath = this.path;
  var message = new VMessage(reason, position, origin);

  if (filePath) {
    message.name = filePath + ':' + message.name;
    message.file = filePath;
  }

  message.fatal = false;

  this.messages.push(message);

  return message;
}

/* Fail. Creates a vmessage, associates it with the file,
 * and throws it. */
function fail() {
  var message = this.message.apply(this, arguments);

  message.fatal = true;

  throw message;
}

/* Info. Creates a vmessage, associates it with the file,
 * and marks the fatality as null. */
function info() {
  var message = this.message.apply(this, arguments);

  message.fatal = null;

  return message;
}


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(272)

module.exports = VMessage

// Inherit from `Error#`.
function VMessagePrototype() {}
VMessagePrototype.prototype = Error.prototype
VMessage.prototype = new VMessagePrototype()

// Message properties.
var proto = VMessage.prototype

proto.file = ''
proto.name = ''
proto.reason = ''
proto.message = ''
proto.stack = ''
proto.fatal = null
proto.column = null
proto.line = null

// Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.
function VMessage(reason, position, origin) {
  var parts
  var range
  var location

  if (typeof position === 'string') {
    origin = position
    position = null
  }

  parts = parseOrigin(origin)
  range = stringify(position) || '1:1'

  location = {
    start: {line: null, column: null},
    end: {line: null, column: null}
  }

  // Node.
  if (position && position.position) {
    position = position.position
  }

  if (position) {
    // Position.
    if (position.start) {
      location = position
      position = position.start
    } else {
      // Point.
      location.start = position
    }
  }

  if (reason.stack) {
    this.stack = reason.stack
    reason = reason.message
  }

  this.message = reason
  this.name = range
  this.reason = reason
  this.line = position ? position.line : null
  this.column = position ? position.column : null
  this.location = location
  this.source = parts[0]
  this.ruleId = parts[1]
}

function parseOrigin(origin) {
  var result = [null, null]
  var index

  if (typeof origin === 'string') {
    index = origin.indexOf(':')

    if (index === -1) {
      result[1] = origin
    } else {
      result[0] = origin.slice(0, index)
      result[1] = origin.slice(index + 1)
    }
  }

  return result
}


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var own = {}.hasOwnProperty

module.exports = stringify

function stringify(value) {
  /* Nothing. */
  if (!value || typeof value !== 'object') {
    return null
  }

  /* Node. */
  if (own.call(value, 'position') || own.call(value, 'type')) {
    return position(value.position)
  }

  /* Position. */
  if (own.call(value, 'start') || own.call(value, 'end')) {
    return position(value)
  }

  /* Point. */
  if (own.call(value, 'line') || own.call(value, 'column')) {
    return point(value)
  }

  /* ? */
  return null
}

function point(point) {
  if (!point || typeof point !== 'object') {
    point = {}
  }

  return index(point.line) + ':' + index(point.column)
}

function position(pos) {
  if (!pos || typeof pos !== 'object') {
    pos = {}
  }

  return point(pos.start) + '-' + point(pos.end)
}

function index(value) {
  return value && typeof value === 'number' ? value : 1
}


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var path = __webpack_require__(99);
var replace = __webpack_require__(274);
var buffer = __webpack_require__(275);

module.exports = VFile;

var own = {}.hasOwnProperty;
var proto = VFile.prototype;

proto.toString = toString;

/* Order of setting (least specific to most), we need this because
 * otherwise `{stem: 'a', path: '~/b.js'}` would throw, as a path
 * is needed before a stem can be set. */
var order = [
  'history',
  'path',
  'basename',
  'stem',
  'extname',
  'dirname'
];

/* Construct a new file. */
function VFile(options) {
  var prop;
  var index;
  var length;

  if (!options) {
    options = {};
  } else if (typeof options === 'string' || buffer(options)) {
    options = {contents: options};
  } else if ('message' in options && 'messages' in options) {
    return options;
  }

  if (!(this instanceof VFile)) {
    return new VFile(options);
  }

  this.data = {};
  this.messages = [];
  this.history = [];
  this.cwd = process.cwd();

  /* Set path related properties in the correct order. */
  index = -1;
  length = order.length;

  while (++index < length) {
    prop = order[index];

    if (own.call(options, prop)) {
      this[prop] = options[prop];
    }
  }

  /* Set non-path related properties. */
  for (prop in options) {
    if (order.indexOf(prop) === -1) {
      this[prop] = options[prop];
    }
  }
}

/* Access full path (`~/index.min.js`). */
Object.defineProperty(proto, 'path', {
  get: function () {
    return this.history[this.history.length - 1];
  },
  set: function (path) {
    assertNonEmpty(path, 'path');

    if (path !== this.path) {
      this.history.push(path);
    }
  }
});

/* Access parent path (`~`). */
Object.defineProperty(proto, 'dirname', {
  get: function () {
    return typeof this.path === 'string' ? path.dirname(this.path) : undefined;
  },
  set: function (dirname) {
    assertPath(this.path, 'dirname');
    this.path = path.join(dirname || '', this.basename);
  }
});

/* Access basename (`index.min.js`). */
Object.defineProperty(proto, 'basename', {
  get: function () {
    return typeof this.path === 'string' ? path.basename(this.path) : undefined;
  },
  set: function (basename) {
    assertNonEmpty(basename, 'basename');
    assertPart(basename, 'basename');
    this.path = path.join(this.dirname || '', basename);
  }
});

/* Access extname (`.js`). */
Object.defineProperty(proto, 'extname', {
  get: function () {
    return typeof this.path === 'string' ? path.extname(this.path) : undefined;
  },
  set: function (extname) {
    var ext = extname || '';

    assertPart(ext, 'extname');
    assertPath(this.path, 'extname');

    if (ext) {
      if (ext.charAt(0) !== '.') {
        throw new Error('`extname` must start with `.`');
      }

      if (ext.indexOf('.', 1) !== -1) {
        throw new Error('`extname` cannot contain multiple dots');
      }
    }

    this.path = replace(this.path, ext);
  }
});

/* Access stem (`index.min`). */
Object.defineProperty(proto, 'stem', {
  get: function () {
    return typeof this.path === 'string' ? path.basename(this.path, this.extname) : undefined;
  },
  set: function (stem) {
    assertNonEmpty(stem, 'stem');
    assertPart(stem, 'stem');
    this.path = path.join(this.dirname || '', stem + (this.extname || ''));
  }
});

/* Get the value of the file. */
function toString(encoding) {
  var value = this.contents || '';
  return buffer(value) ? value.toString(encoding) : String(value);
}

/* Assert that `part` is not a path (i.e., does
 * not contain `path.sep`). */
function assertPart(part, name) {
  if (part.indexOf(path.sep) !== -1) {
    throw new Error('`' + name + '` cannot be a path: did not expect `' + path.sep + '`');
  }
}

/* Assert that `part` is not empty. */
function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty');
  }
}

/* Assert `path` exists. */
function assertPath(path, name) {
  if (!path) {
    throw new Error('Setting `' + name + '` requires `path` to be set too');
  }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(50)))

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var path = __webpack_require__(99);

function replaceExt(npath, ext) {
  if (typeof npath !== 'string') {
    return npath;
  }

  if (npath.length === 0) {
    return npath;
  }

  var nFileName = path.basename(npath, path.extname(npath)) + ext;
  return path.join(path.dirname(npath), nFileName);
}

module.exports = replaceExt;


/***/ }),
/* 275 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wrap = __webpack_require__(277)

module.exports = trough

trough.wrap = wrap

var slice = [].slice

// Create new middleware.
function trough() {
  var fns = []
  var middleware = {}

  middleware.run = run
  middleware.use = use

  return middleware

  // Run `fns`.  Last argument must be a completion handler.
  function run() {
    var index = -1
    var input = slice.call(arguments, 0, -1)
    var done = arguments[arguments.length - 1]

    if (typeof done !== 'function') {
      throw new Error('Expected function as last argument, not ' + done)
    }

    next.apply(null, [null].concat(input))

    // Run the next `fn`, if any.
    function next(err) {
      var fn = fns[++index]
      var params = slice.call(arguments, 0)
      var values = params.slice(1)
      var length = input.length
      var pos = -1

      if (err) {
        done(err)
        return
      }

      // Copy non-nully input into values.
      while (++pos < length) {
        if (values[pos] === null || values[pos] === undefined) {
          values[pos] = input[pos]
        }
      }

      input = values

      // Next or done.
      if (fn) {
        wrap(fn, next).apply(null, input)
      } else {
        done.apply(null, [null].concat(input))
      }
    }
  }

  // Add `fn` to the list.
  function use(fn) {
    if (typeof fn !== 'function') {
      throw new Error('Expected `fn` to be a function, not ' + fn)
    }

    fns.push(fn)

    return middleware
  }
}


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = [].slice

module.exports = wrap

// Wrap `fn`.
// Can be sync or async; return a promise, receive a completion handler, return
// new values and errors.
function wrap(fn, callback) {
  var invoked

  return wrapped

  function wrapped() {
    var params = slice.call(arguments, 0)
    var callback = fn.length > params.length
    var result

    if (callback) {
      params.push(done)
    }

    try {
      result = fn.apply(null, params)
    } catch (error) {
      // Well, this is quite the pickle.
      // `fn` received a callback and invoked it (thus continuing the pipeline),
      // but later also threw an error.
      // We’re not about to restart the pipeline again, so the only thing left
      // to do is to throw the thing instead.
      if (callback && invoked) {
        throw error
      }

      return done(error)
    }

    if (!callback) {
      if (result && typeof result.then === 'function') {
        result.then(then, done)
      } else if (result instanceof Error) {
        done(result)
      } else {
        then(result)
      }
    }
  }

  // Invoke `next`, only once.
  function done() {
    if (!invoked) {
      invoked = true

      callback.apply(null, arguments)
    }
  }

  // Invoke `done` with one value.
  // Tracks if an error is passed, too.
  function then(value) {
    done(null, value)
  }
}


/***/ }),
/* 278 */
/***/ (function(module, exports) {

var toString = Object.prototype.toString

module.exports = isString

function isString(obj) {
    return toString.call(obj) === "[object String]"
}


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toString = Object.prototype.toString;

module.exports = function (x) {
	var prototype;
	return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var unherit = __webpack_require__(281);
var xtend = __webpack_require__(37);
var Parser = __webpack_require__(283);

module.exports = parse;
parse.Parser = Parser;

function parse(options) {
  var Local = unherit(Parser);
  Local.prototype.options = xtend(Local.prototype.options, this.data('settings'), options);
  this.Parser = Local;
}


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(37)
var inherits = __webpack_require__(282)

module.exports = unherit

// Create a custom constructor which can be modified without affecting the
// original class.
function unherit(Super) {
  var result
  var key
  var value

  inherits(Of, Super)
  inherits(From, Of)

  // Clone values.
  result = Of.prototype

  for (key in result) {
    value = result[key]

    if (value && typeof value === 'object') {
      result[key] = 'concat' in value ? value.concat() : xtend(value)
    }
  }

  return Of

  // Constructor accepting a single argument, which itself is an `arguments`
  // object.
  function From(parameters) {
    return Super.apply(this, parameters)
  }

  // Constructor accepting variadic arguments.
  function Of() {
    if (!(this instanceof Of)) {
      return new From(arguments)
    }

    return Super.apply(this, arguments)
  }
}


/***/ }),
/* 282 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(37);
var toggle = __webpack_require__(284);
var vfileLocation = __webpack_require__(285);
var unescape = __webpack_require__(286);
var decode = __webpack_require__(287);
var tokenizer = __webpack_require__(293);

module.exports = Parser;

function Parser(doc, file) {
  this.file = file;
  this.offset = {};
  this.options = xtend(this.options);
  this.setOptions({});

  this.inList = false;
  this.inBlock = false;
  this.inLink = false;
  this.atStart = true;

  this.toOffset = vfileLocation(file).toOffset;
  this.unescape = unescape(this, 'escape');
  this.decode = decode(this);
}

var proto = Parser.prototype;

/* Expose core. */
proto.setOptions = __webpack_require__(294);
proto.parse = __webpack_require__(297);

/* Expose `defaults`. */
proto.options = __webpack_require__(180);

/* Enter and exit helpers. */
proto.exitStart = toggle('atStart', true);
proto.enterList = toggle('inList', false);
proto.enterLink = toggle('inLink', false);
proto.enterBlock = toggle('inBlock', false);

/* Nodes that can interupt a paragraph:
 *
 * ```markdown
 * A paragraph, followed by a thematic break.
 * ___
 * ```
 *
 * In the above example, the thematic break “interupts”
 * the paragraph. */
proto.interruptParagraph = [
  ['thematicBreak'],
  ['atxHeading'],
  ['fencedCode'],
  ['blockquote'],
  ['html'],
  ['setextHeading', {commonmark: false}],
  ['definition', {commonmark: false}],
  ['footnote', {commonmark: false}]
];

/* Nodes that can interupt a list:
 *
 * ```markdown
 * - One
 * ___
 * ```
 *
 * In the above example, the thematic break “interupts”
 * the list. */
proto.interruptList = [
  ['atxHeading', {pedantic: false}],
  ['fencedCode', {pedantic: false}],
  ['thematicBreak', {pedantic: false}],
  ['definition', {commonmark: false}],
  ['footnote', {commonmark: false}]
];

/* Nodes that can interupt a blockquote:
 *
 * ```markdown
 * > A paragraph.
 * ___
 * ```
 *
 * In the above example, the thematic break “interupts”
 * the blockquote. */
proto.interruptBlockquote = [
  ['indentedCode', {commonmark: true}],
  ['fencedCode', {commonmark: true}],
  ['atxHeading', {commonmark: true}],
  ['setextHeading', {commonmark: true}],
  ['thematicBreak', {commonmark: true}],
  ['html', {commonmark: true}],
  ['list', {commonmark: true}],
  ['definition', {commonmark: false}],
  ['footnote', {commonmark: false}]
];

/* Handlers. */
proto.blockTokenizers = {
  newline: __webpack_require__(301),
  indentedCode: __webpack_require__(302),
  fencedCode: __webpack_require__(303),
  blockquote: __webpack_require__(304),
  atxHeading: __webpack_require__(305),
  thematicBreak: __webpack_require__(306),
  list: __webpack_require__(307),
  setextHeading: __webpack_require__(309),
  html: __webpack_require__(310),
  footnote: __webpack_require__(311),
  definition: __webpack_require__(313),
  table: __webpack_require__(314),
  paragraph: __webpack_require__(315)
};

proto.inlineTokenizers = {
  escape: __webpack_require__(316),
  autoLink: __webpack_require__(318),
  url: __webpack_require__(319),
  html: __webpack_require__(321),
  link: __webpack_require__(322),
  reference: __webpack_require__(323),
  strong: __webpack_require__(324),
  emphasis: __webpack_require__(326),
  deletion: __webpack_require__(329),
  code: __webpack_require__(331),
  break: __webpack_require__(333),
  text: __webpack_require__(335)
};

/* Expose precedence. */
proto.blockMethods = keys(proto.blockTokenizers);
proto.inlineMethods = keys(proto.inlineTokenizers);

/* Tokenizers. */
proto.tokenizeBlock = tokenizer('block');
proto.tokenizeInline = tokenizer('inline');
proto.tokenizeFactory = tokenizer;

/* Get all keys in `value`. */
function keys(value) {
  var result = [];
  var key;

  for (key in value) {
    result.push(key);
  }

  return result;
}


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = factory

// Construct a state `toggler`: a function which inverses `property` in context
// based on its current value.
// The by `toggler` returned function restores that value.
function factory(key, state, ctx) {
  return enter

  function enter() {
    var context = ctx || this
    var current = context[key]

    context[key] = !state

    return exit

    function exit() {
      context[key] = current
    }
  }
}


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = factory

function factory(file) {
  var contents = indices(String(file))

  return {
    toPosition: offsetToPositionFactory(contents),
    toOffset: positionToOffsetFactory(contents)
  }
}

// Factory to get the line and column-based `position` for `offset` in the bound
// indices.
function offsetToPositionFactory(indices) {
  return offsetToPosition

  // Get the line and column-based `position` for `offset` in the bound indices.
  function offsetToPosition(offset) {
    var index = -1
    var length = indices.length

    if (offset < 0) {
      return {}
    }

    while (++index < length) {
      if (indices[index] > offset) {
        return {
          line: index + 1,
          column: offset - (indices[index - 1] || 0) + 1,
          offset: offset
        }
      }
    }

    return {}
  }
}

// Factory to get the `offset` for a line and column-based `position` in the
// bound indices.
function positionToOffsetFactory(indices) {
  return positionToOffset

  // Get the `offset` for a line and column-based `position` in the bound
  // indices.
  function positionToOffset(position) {
    var line = position && position.line
    var column = position && position.column

    if (!isNaN(line) && !isNaN(column) && line - 1 in indices) {
      return (indices[line - 2] || 0) + column - 1 || 0
    }

    return -1
  }
}

// Get indices of line-breaks in `value`.
function indices(value) {
  var result = []
  var index = value.indexOf('\n')

  while (index !== -1) {
    result.push(index + 1)
    index = value.indexOf('\n', index + 1)
  }

  result.push(value.length + 1)

  return result
}


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = factory;

/* Factory to de-escape a value, based on a list at `key`
 * in `ctx`. */
function factory(ctx, key) {
  return unescape;

  /* De-escape a string using the expression at `key`
   * in `ctx`. */
  function unescape(value) {
    var prev = 0;
    var index = value.indexOf('\\');
    var escape = ctx[key];
    var queue = [];
    var character;

    while (index !== -1) {
      queue.push(value.slice(prev, index));
      prev = index + 1;
      character = value.charAt(prev);

      /* If the following character is not a valid escape,
       * add the slash. */
      if (!character || escape.indexOf(character) === -1) {
        queue.push('\\');
      }

      index = value.indexOf('\\', prev);
    }

    queue.push(value.slice(prev));

    return queue.join('');
  }
}


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(37);
var entities = __webpack_require__(100);

module.exports = factory;

/* Factory to create an entity decoder. */
function factory(ctx) {
  decoder.raw = decodeRaw;

  return decoder;

  /* Normalize `position` to add an `indent`. */
  function normalize(position) {
    var offsets = ctx.offset;
    var line = position.line;
    var result = [];

    while (++line) {
      if (!(line in offsets)) {
        break;
      }

      result.push((offsets[line] || 0) + 1);
    }

    return {
      start: position,
      indent: result
    };
  }

  /* Handle a warning.
   * See https://github.com/wooorm/parse-entities
   * for the warnings. */
  function handleWarning(reason, position, code) {
    if (code === 3) {
      return;
    }

    ctx.file.message(reason, position);
  }

  /* Decode `value` (at `position`) into text-nodes. */
  function decoder(value, position, handler) {
    entities(value, {
      position: normalize(position),
      warning: handleWarning,
      text: handler,
      reference: handler,
      textContext: ctx,
      referenceContext: ctx
    });
  }

  /* Decode `value` (at `position`) into a string. */
  function decodeRaw(value, position, options) {
    return entities(value, xtend(options, {
      position: normalize(position),
      warning: handleWarning
    }));
  }
}


/***/ }),
/* 288 */
/***/ (function(module) {

module.exports = JSON.parse("{\"AElig\":\"Æ\",\"AMP\":\"&\",\"Aacute\":\"Á\",\"Acirc\":\"Â\",\"Agrave\":\"À\",\"Aring\":\"Å\",\"Atilde\":\"Ã\",\"Auml\":\"Ä\",\"COPY\":\"©\",\"Ccedil\":\"Ç\",\"ETH\":\"Ð\",\"Eacute\":\"É\",\"Ecirc\":\"Ê\",\"Egrave\":\"È\",\"Euml\":\"Ë\",\"GT\":\">\",\"Iacute\":\"Í\",\"Icirc\":\"Î\",\"Igrave\":\"Ì\",\"Iuml\":\"Ï\",\"LT\":\"<\",\"Ntilde\":\"Ñ\",\"Oacute\":\"Ó\",\"Ocirc\":\"Ô\",\"Ograve\":\"Ò\",\"Oslash\":\"Ø\",\"Otilde\":\"Õ\",\"Ouml\":\"Ö\",\"QUOT\":\"\\\"\",\"REG\":\"®\",\"THORN\":\"Þ\",\"Uacute\":\"Ú\",\"Ucirc\":\"Û\",\"Ugrave\":\"Ù\",\"Uuml\":\"Ü\",\"Yacute\":\"Ý\",\"aacute\":\"á\",\"acirc\":\"â\",\"acute\":\"´\",\"aelig\":\"æ\",\"agrave\":\"à\",\"amp\":\"&\",\"aring\":\"å\",\"atilde\":\"ã\",\"auml\":\"ä\",\"brvbar\":\"¦\",\"ccedil\":\"ç\",\"cedil\":\"¸\",\"cent\":\"¢\",\"copy\":\"©\",\"curren\":\"¤\",\"deg\":\"°\",\"divide\":\"÷\",\"eacute\":\"é\",\"ecirc\":\"ê\",\"egrave\":\"è\",\"eth\":\"ð\",\"euml\":\"ë\",\"frac12\":\"½\",\"frac14\":\"¼\",\"frac34\":\"¾\",\"gt\":\">\",\"iacute\":\"í\",\"icirc\":\"î\",\"iexcl\":\"¡\",\"igrave\":\"ì\",\"iquest\":\"¿\",\"iuml\":\"ï\",\"laquo\":\"«\",\"lt\":\"<\",\"macr\":\"¯\",\"micro\":\"µ\",\"middot\":\"·\",\"nbsp\":\" \",\"not\":\"¬\",\"ntilde\":\"ñ\",\"oacute\":\"ó\",\"ocirc\":\"ô\",\"ograve\":\"ò\",\"ordf\":\"ª\",\"ordm\":\"º\",\"oslash\":\"ø\",\"otilde\":\"õ\",\"ouml\":\"ö\",\"para\":\"¶\",\"plusmn\":\"±\",\"pound\":\"£\",\"quot\":\"\\\"\",\"raquo\":\"»\",\"reg\":\"®\",\"sect\":\"§\",\"shy\":\"­\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"szlig\":\"ß\",\"thorn\":\"þ\",\"times\":\"×\",\"uacute\":\"ú\",\"ucirc\":\"û\",\"ugrave\":\"ù\",\"uml\":\"¨\",\"uuml\":\"ü\",\"yacute\":\"ý\",\"yen\":\"¥\",\"yuml\":\"ÿ\"}");

/***/ }),
/* 289 */
/***/ (function(module) {

module.exports = JSON.parse("{\"0\":\"�\",\"128\":\"€\",\"130\":\"‚\",\"131\":\"ƒ\",\"132\":\"„\",\"133\":\"…\",\"134\":\"†\",\"135\":\"‡\",\"136\":\"ˆ\",\"137\":\"‰\",\"138\":\"Š\",\"139\":\"‹\",\"140\":\"Œ\",\"142\":\"Ž\",\"145\":\"‘\",\"146\":\"’\",\"147\":\"“\",\"148\":\"”\",\"149\":\"•\",\"150\":\"–\",\"151\":\"—\",\"152\":\"˜\",\"153\":\"™\",\"154\":\"š\",\"155\":\"›\",\"156\":\"œ\",\"158\":\"ž\",\"159\":\"Ÿ\"}");

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = hexadecimal

// Check if the given character code, or the character code at the first
// character, is hexadecimal.
function hexadecimal(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character

  return (
    (code >= 97 /* a */ && code <= 102) /* z */ ||
    (code >= 65 /* A */ && code <= 70) /* Z */ ||
    (code >= 48 /* A */ && code <= 57) /* Z */
  )
}


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabetical = __webpack_require__(179)
var decimal = __webpack_require__(71)

module.exports = alphanumerical

// Check if the given character code, or the character code at the first
// character, is alphanumerical.
function alphanumerical(character) {
  return alphabetical(character) || decimal(character)
}


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-env browser */

var el

var semicolon = 59 //  ';'

module.exports = decodeEntity

function decodeEntity(characters) {
  var entity = '&' + characters + ';'
  var char

  el = el || document.createElement('i')
  el.innerHTML = entity
  char = el.textContent

  // Some entities do not require the closing semicolon (`&not` - for instance),
  // which leads to situations where parsing the assumed entity of &notit; will
  // result in the string `¬it;`.  When we encounter a trailing semicolon after
  // parsing and the entity to decode was not a semicolon (`&semi;`), we can
  // assume that the matching was incomplete
  if (char.charCodeAt(char.length - 1) === semicolon && characters !== 'semi') {
    return false
  }

  // If the decoded string is equal to the input, the entity was not valid
  return char === entity ? false : char
}


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = factory;

var MERGEABLE_NODES = {
  text: mergeText,
  blockquote: mergeBlockquote
};

/* Check whether a node is mergeable with adjacent nodes. */
function mergeable(node) {
  var start;
  var end;

  if (node.type !== 'text' || !node.position) {
    return true;
  }

  start = node.position.start;
  end = node.position.end;

  /* Only merge nodes which occupy the same size as their
   * `value`. */
  return start.line !== end.line ||
      end.column - start.column === node.value.length;
}

/* Merge two text nodes: `node` into `prev`. */
function mergeText(prev, node) {
  prev.value += node.value;

  return prev;
}

/* Merge two blockquotes: `node` into `prev`, unless in
 * CommonMark mode. */
function mergeBlockquote(prev, node) {
  if (this.options.commonmark) {
    return node;
  }

  prev.children = prev.children.concat(node.children);

  return prev;
}

/* Construct a tokenizer.  This creates both
 * `tokenizeInline` and `tokenizeBlock`. */
function factory(type) {
  return tokenize;

  /* Tokenizer for a bound `type`. */
  function tokenize(value, location) {
    var self = this;
    var offset = self.offset;
    var tokens = [];
    var methods = self[type + 'Methods'];
    var tokenizers = self[type + 'Tokenizers'];
    var line = location.line;
    var column = location.column;
    var index;
    var length;
    var method;
    var name;
    var matched;
    var valueLength;

    /* Trim white space only lines. */
    if (!value) {
      return tokens;
    }

    /* Expose on `eat`. */
    eat.now = now;
    eat.file = self.file;

    /* Sync initial offset. */
    updatePosition('');

    /* Iterate over `value`, and iterate over all
     * tokenizers.  When one eats something, re-iterate
     * with the remaining value.  If no tokenizer eats,
     * something failed (should not happen) and an
     * exception is thrown. */
    while (value) {
      index = -1;
      length = methods.length;
      matched = false;

      while (++index < length) {
        name = methods[index];
        method = tokenizers[name];

        if (
          method &&
          /* istanbul ignore next */ (!method.onlyAtStart || self.atStart) &&
          (!method.notInList || !self.inList) &&
          (!method.notInBlock || !self.inBlock) &&
          (!method.notInLink || !self.inLink)
        ) {
          valueLength = value.length;

          method.apply(self, [eat, value]);

          matched = valueLength !== value.length;

          if (matched) {
            break;
          }
        }
      }

      /* istanbul ignore if */
      if (!matched) {
        self.file.fail(new Error('Infinite loop'), eat.now());
      }
    }

    self.eof = now();

    return tokens;

    /* Update line, column, and offset based on
     * `value`. */
    function updatePosition(subvalue) {
      var lastIndex = -1;
      var index = subvalue.indexOf('\n');

      while (index !== -1) {
        line++;
        lastIndex = index;
        index = subvalue.indexOf('\n', index + 1);
      }

      if (lastIndex === -1) {
        column += subvalue.length;
      } else {
        column = subvalue.length - lastIndex;
      }

      if (line in offset) {
        if (lastIndex !== -1) {
          column += offset[line];
        } else if (column <= offset[line]) {
          column = offset[line] + 1;
        }
      }
    }

    /* Get offset.  Called before the first character is
     * eaten to retrieve the range's offsets. */
    function getOffset() {
      var indentation = [];
      var pos = line + 1;

      /* Done.  Called when the last character is
       * eaten to retrieve the range’s offsets. */
      return function () {
        var last = line + 1;

        while (pos < last) {
          indentation.push((offset[pos] || 0) + 1);

          pos++;
        }

        return indentation;
      };
    }

    /* Get the current position. */
    function now() {
      var pos = {line: line, column: column};

      pos.offset = self.toOffset(pos);

      return pos;
    }

    /* Store position information for a node. */
    function Position(start) {
      this.start = start;
      this.end = now();
    }

    /* Throw when a value is incorrectly eaten.
     * This shouldn’t happen but will throw on new,
     * incorrect rules. */
    function validateEat(subvalue) {
      /* istanbul ignore if */
      if (value.substring(0, subvalue.length) !== subvalue) {
        /* Capture stack-trace. */
        self.file.fail(
          new Error(
            'Incorrectly eaten value: please report this ' +
            'warning on http://git.io/vg5Ft'
          ),
          now()
        );
      }
    }

    /* Mark position and patch `node.position`. */
    function position() {
      var before = now();

      return update;

      /* Add the position to a node. */
      function update(node, indent) {
        var prev = node.position;
        var start = prev ? prev.start : before;
        var combined = [];
        var n = prev && prev.end.line;
        var l = before.line;

        node.position = new Position(start);

        /* If there was already a `position`, this
         * node was merged.  Fixing `start` wasn’t
         * hard, but the indent is different.
         * Especially because some information, the
         * indent between `n` and `l` wasn’t
         * tracked.  Luckily, that space is
         * (should be?) empty, so we can safely
         * check for it now. */
        if (prev && indent && prev.indent) {
          combined = prev.indent;

          if (n < l) {
            while (++n < l) {
              combined.push((offset[n] || 0) + 1);
            }

            combined.push(before.column);
          }

          indent = combined.concat(indent);
        }

        node.position.indent = indent || [];

        return node;
      }
    }

    /* Add `node` to `parent`s children or to `tokens`.
     * Performs merges where possible. */
    function add(node, parent) {
      var children = parent ? parent.children : tokens;
      var prev = children[children.length - 1];

      if (
        prev &&
        node.type === prev.type &&
        node.type in MERGEABLE_NODES &&
        mergeable(prev) &&
        mergeable(node)
      ) {
        node = MERGEABLE_NODES[node.type].call(self, prev, node);
      }

      if (node !== prev) {
        children.push(node);
      }

      if (self.atStart && tokens.length !== 0) {
        self.exitStart();
      }

      return node;
    }

    /* Remove `subvalue` from `value`.
     * `subvalue` must be at the start of `value`. */
    function eat(subvalue) {
      var indent = getOffset();
      var pos = position();
      var current = now();

      validateEat(subvalue);

      apply.reset = reset;
      reset.test = test;
      apply.test = test;

      value = value.substring(subvalue.length);

      updatePosition(subvalue);

      indent = indent();

      return apply;

      /* Add the given arguments, add `position` to
       * the returned node, and return the node. */
      function apply(node, parent) {
        return pos(add(pos(node), parent), indent);
      }

      /* Functions just like apply, but resets the
       * content:  the line and column are reversed,
       * and the eaten value is re-added.
       * This is useful for nodes with a single
       * type of content, such as lists and tables.
       * See `apply` above for what parameters are
       * expected. */
      function reset() {
        var node = apply.apply(null, arguments);

        line = current.line;
        column = current.column;
        value = subvalue + value;

        return node;
      }

      /* Test the position, after eating, and reverse
       * to a not-eaten state. */
      function test() {
        var result = pos({});

        line = current.line;
        column = current.column;
        value = subvalue + value;

        return result.position;
      }
    }
  }
}


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(37);
var escapes = __webpack_require__(295);
var defaults = __webpack_require__(180);

module.exports = setOptions;

function setOptions(options) {
  var self = this;
  var current = self.options;
  var key;
  var value;

  if (options == null) {
    options = {};
  } else if (typeof options === 'object') {
    options = xtend(options);
  } else {
    throw new Error(
      'Invalid value `' + options + '` ' +
      'for setting `options`'
    );
  }

  for (key in defaults) {
    value = options[key];

    if (value == null) {
      value = current[key];
    }

    if (
      (key !== 'blocks' && typeof value !== 'boolean') ||
      (key === 'blocks' && typeof value !== 'object')
    ) {
      throw new Error('Invalid value `' + value + '` for setting `options.' + key + '`');
    }

    options[key] = value;
  }

  self.options = options;
  self.escape = escapes(options);

  return self;
}


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = escapes

var defaults = [
  '\\',
  '`',
  '*',
  '{',
  '}',
  '[',
  ']',
  '(',
  ')',
  '#',
  '+',
  '-',
  '.',
  '!',
  '_',
  '>'
]

var gfm = defaults.concat(['~', '|'])

var commonmark = gfm.concat([
  '\n',
  '"',
  '$',
  '%',
  '&',
  "'",
  ',',
  '/',
  ':',
  ';',
  '<',
  '=',
  '?',
  '@',
  '^'
])

escapes.default = defaults
escapes.gfm = gfm
escapes.commonmark = commonmark

// Get markdown escapes.
function escapes(options) {
  var settings = options || {}

  if (settings.commonmark) {
    return commonmark
  }

  return settings.gfm ? gfm : defaults
}


/***/ }),
/* 296 */
/***/ (function(module) {

module.exports = JSON.parse("[\"address\",\"article\",\"aside\",\"base\",\"basefont\",\"blockquote\",\"body\",\"caption\",\"center\",\"col\",\"colgroup\",\"dd\",\"details\",\"dialog\",\"dir\",\"div\",\"dl\",\"dt\",\"fieldset\",\"figcaption\",\"figure\",\"footer\",\"form\",\"frame\",\"frameset\",\"h1\",\"h2\",\"h3\",\"h4\",\"h5\",\"h6\",\"head\",\"header\",\"hgroup\",\"hr\",\"html\",\"iframe\",\"legend\",\"li\",\"link\",\"main\",\"menu\",\"menuitem\",\"meta\",\"nav\",\"noframes\",\"ol\",\"optgroup\",\"option\",\"p\",\"param\",\"pre\",\"section\",\"source\",\"title\",\"summary\",\"table\",\"tbody\",\"td\",\"tfoot\",\"th\",\"thead\",\"title\",\"tr\",\"track\",\"ul\"]");

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(37);
var removePosition = __webpack_require__(298);

module.exports = parse;

var C_NEWLINE = '\n';
var EXPRESSION_LINE_BREAKS = /\r\n|\r/g;

/* Parse the bound file. */
function parse() {
  var self = this;
  var value = String(self.file);
  var start = {line: 1, column: 1, offset: 0};
  var content = xtend(start);
  var node;

  /* Clean non-unix newlines: `\r\n` and `\r` are all
   * changed to `\n`.  This should not affect positional
   * information. */
  value = value.replace(EXPRESSION_LINE_BREAKS, C_NEWLINE);

  if (value.charCodeAt(0) === 0xFEFF) {
    value = value.slice(1);

    content.column++;
    content.offset++;
  }

  node = {
    type: 'root',
    children: self.tokenizeBlock(value, content),
    position: {
      start: start,
      end: self.eof || xtend(start)
    }
  };

  if (!self.options.position) {
    removePosition(node, true);
  }

  return node;
}


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var visit = __webpack_require__(72)

module.exports = removePosition

function removePosition(node, force) {
  visit(node, force ? hard : soft)
  return node
}

function hard(node) {
  delete node.position
}

function soft(node) {
  node.position = undefined
}


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = visitParents

var convert = __webpack_require__(300)

var CONTINUE = true
var SKIP = 'skip'
var EXIT = false

visitParents.CONTINUE = CONTINUE
visitParents.SKIP = SKIP
visitParents.EXIT = EXIT

function visitParents(tree, test, visitor, reverse) {
  var is

  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor
    visitor = test
    test = null
  }

  is = convert(test)

  one(tree, null, [])

  // Visit a single node.
  function one(node, index, parents) {
    var result = []
    var subresult

    if (!test || is(node, index, parents[parents.length - 1] || null)) {
      result = toResult(visitor(node, parents))

      if (result[0] === EXIT) {
        return result
      }
    }

    if (node.children && result[0] !== SKIP) {
      subresult = toResult(all(node.children, parents.concat(node)))
      return subresult[0] === EXIT ? subresult : result
    }

    return result
  }

  // Visit children in `parent`.
  function all(children, parents) {
    var min = -1
    var step = reverse ? -1 : 1
    var index = (reverse ? children.length : min) + step
    var result

    while (index > min && index < children.length) {
      result = one(children[index], index, parents)

      if (result[0] === EXIT) {
        return result
      }

      index = typeof result[1] === 'number' ? result[1] : index + step
    }
  }
}

function toResult(value) {
  if (value !== null && typeof value === 'object' && 'length' in value) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return [value]
}


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = convert

function convert(test) {
  if (typeof test === 'string') {
    return typeFactory(test)
  }

  if (test === null || test === undefined) {
    return ok
  }

  if (typeof test === 'object') {
    return ('length' in test ? anyFactory : matchesFactory)(test)
  }

  if (typeof test === 'function') {
    return test
  }

  throw new Error('Expected function, string, or object as test')
}

function convertAll(tests) {
  var results = []
  var length = tests.length
  var index = -1

  while (++index < length) {
    results[index] = convert(tests[index])
  }

  return results
}

// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function matchesFactory(test) {
  return matches

  function matches(node) {
    var key

    for (key in test) {
      if (node[key] !== test[key]) {
        return false
      }
    }

    return true
  }
}

function anyFactory(tests) {
  var checks = convertAll(tests)
  var length = checks.length

  return matches

  function matches() {
    var index = -1

    while (++index < length) {
      if (checks[index].apply(this, arguments)) {
        return true
      }
    }

    return false
  }
}

// Utility to convert a string into a function which checks a given node’s type
// for said string.
function typeFactory(test) {
  return type

  function type(node) {
    return Boolean(node && node.type === test)
  }
}

// Utility to return true.
function ok() {
  return true
}


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(29);

module.exports = newline;

/* Tokenise newline. */
function newline(eat, value, silent) {
  var character = value.charAt(0);
  var length;
  var subvalue;
  var queue;
  var index;

  if (character !== '\n') {
    return;
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  index = 1;
  length = value.length;
  subvalue = character;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (!whitespace(character)) {
      break;
    }

    queue += character;

    if (character === '\n') {
      subvalue += queue;
      queue = '';
    }

    index++;
  }

  eat(subvalue);
}


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var repeat = __webpack_require__(101);
var trim = __webpack_require__(102);

module.exports = indentedCode;

var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';

var CODE_INDENT_COUNT = 4;
var CODE_INDENT = repeat(C_SPACE, CODE_INDENT_COUNT);

/* Tokenise indented code. */
function indentedCode(eat, value, silent) {
  var index = -1;
  var length = value.length;
  var subvalue = '';
  var content = '';
  var subvalueQueue = '';
  var contentQueue = '';
  var character;
  var blankQueue;
  var indent;

  while (++index < length) {
    character = value.charAt(index);

    if (indent) {
      indent = false;

      subvalue += subvalueQueue;
      content += contentQueue;
      subvalueQueue = '';
      contentQueue = '';

      if (character === C_NEWLINE) {
        subvalueQueue = character;
        contentQueue = character;
      } else {
        subvalue += character;
        content += character;

        while (++index < length) {
          character = value.charAt(index);

          if (!character || character === C_NEWLINE) {
            contentQueue = character;
            subvalueQueue = character;
            break;
          }

          subvalue += character;
          content += character;
        }
      }
    } else if (
      character === C_SPACE &&
      value.charAt(index + 1) === character &&
      value.charAt(index + 2) === character &&
      value.charAt(index + 3) === character
    ) {
      subvalueQueue += CODE_INDENT;
      index += 3;
      indent = true;
    } else if (character === C_TAB) {
      subvalueQueue += character;
      indent = true;
    } else {
      blankQueue = '';

      while (character === C_TAB || character === C_SPACE) {
        blankQueue += character;
        character = value.charAt(++index);
      }

      if (character !== C_NEWLINE) {
        break;
      }

      subvalueQueue += blankQueue + character;
      contentQueue += character;
    }
  }

  if (content) {
    if (silent) {
      return true;
    }

    return eat(subvalue)({
      type: 'code',
      lang: null,
      value: trim(content)
    });
  }
}


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(102);

module.exports = fencedCode;

var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var C_TILDE = '~';
var C_TICK = '`';

var MIN_FENCE_COUNT = 3;
var CODE_INDENT_COUNT = 4;

function fencedCode(eat, value, silent) {
  var self = this;
  var settings = self.options;
  var length = value.length + 1;
  var index = 0;
  var subvalue = '';
  var fenceCount;
  var marker;
  var character;
  var flag;
  var queue;
  var content;
  var exdentedContent;
  var closing;
  var exdentedClosing;
  var indent;
  var now;

  if (!settings.gfm) {
    return;
  }

  /* Eat initial spacing. */
  while (index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE && character !== C_TAB) {
      break;
    }

    subvalue += character;
    index++;
  }

  indent = index;

  /* Eat the fence. */
  character = value.charAt(index);

  if (character !== C_TILDE && character !== C_TICK) {
    return;
  }

  index++;
  marker = character;
  fenceCount = 1;
  subvalue += character;

  while (index < length) {
    character = value.charAt(index);

    if (character !== marker) {
      break;
    }

    subvalue += character;
    fenceCount++;
    index++;
  }

  if (fenceCount < MIN_FENCE_COUNT) {
    return;
  }

  /* Eat spacing before flag. */
  while (index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE && character !== C_TAB) {
      break;
    }

    subvalue += character;
    index++;
  }

  /* Eat flag. */
  flag = '';
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (
      character === C_NEWLINE ||
      character === C_TILDE ||
      character === C_TICK
    ) {
      break;
    }

    if (character === C_SPACE || character === C_TAB) {
      queue += character;
    } else {
      flag += queue + character;
      queue = '';
    }

    index++;
  }

  character = value.charAt(index);

  if (character && character !== C_NEWLINE) {
    return;
  }

  if (silent) {
    return true;
  }

  now = eat.now();
  now.column += subvalue.length;
  now.offset += subvalue.length;

  subvalue += flag;
  flag = self.decode.raw(self.unescape(flag), now);

  if (queue) {
    subvalue += queue;
  }

  queue = '';
  closing = '';
  exdentedClosing = '';
  content = '';
  exdentedContent = '';

  /* Eat content. */
  while (index < length) {
    character = value.charAt(index);
    content += closing;
    exdentedContent += exdentedClosing;
    closing = '';
    exdentedClosing = '';

    if (character !== C_NEWLINE) {
      content += character;
      exdentedClosing += character;
      index++;
      continue;
    }

    /* Add the newline to `subvalue` if its the first
     * character.  Otherwise, add it to the `closing`
     * queue. */
    if (content) {
      closing += character;
      exdentedClosing += character;
    } else {
      subvalue += character;
    }

    queue = '';
    index++;

    while (index < length) {
      character = value.charAt(index);

      if (character !== C_SPACE) {
        break;
      }

      queue += character;
      index++;
    }

    closing += queue;
    exdentedClosing += queue.slice(indent);

    if (queue.length >= CODE_INDENT_COUNT) {
      continue;
    }

    queue = '';

    while (index < length) {
      character = value.charAt(index);

      if (character !== marker) {
        break;
      }

      queue += character;
      index++;
    }

    closing += queue;
    exdentedClosing += queue;

    if (queue.length < fenceCount) {
      continue;
    }

    queue = '';

    while (index < length) {
      character = value.charAt(index);

      if (character !== C_SPACE && character !== C_TAB) {
        break;
      }

      closing += character;
      exdentedClosing += character;
      index++;
    }

    if (!character || character === C_NEWLINE) {
      break;
    }
  }

  subvalue += content + closing;

  return eat(subvalue)({
    type: 'code',
    lang: flag || null,
    value: trim(exdentedContent)
  });
}


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(52);
var interrupt = __webpack_require__(103);

module.exports = blockquote;

var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var C_GT = '>';

/* Tokenise a blockquote. */
function blockquote(eat, value, silent) {
  var self = this;
  var offsets = self.offset;
  var tokenizers = self.blockTokenizers;
  var interruptors = self.interruptBlockquote;
  var now = eat.now();
  var currentLine = now.line;
  var length = value.length;
  var values = [];
  var contents = [];
  var indents = [];
  var add;
  var index = 0;
  var character;
  var rest;
  var nextIndex;
  var content;
  var line;
  var startIndex;
  var prefixed;
  var exit;

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE && character !== C_TAB) {
      break;
    }

    index++;
  }

  if (value.charAt(index) !== C_GT) {
    return;
  }

  if (silent) {
    return true;
  }

  index = 0;

  while (index < length) {
    nextIndex = value.indexOf(C_NEWLINE, index);
    startIndex = index;
    prefixed = false;

    if (nextIndex === -1) {
      nextIndex = length;
    }

    while (index < length) {
      character = value.charAt(index);

      if (character !== C_SPACE && character !== C_TAB) {
        break;
      }

      index++;
    }

    if (value.charAt(index) === C_GT) {
      index++;
      prefixed = true;

      if (value.charAt(index) === C_SPACE) {
        index++;
      }
    } else {
      index = startIndex;
    }

    content = value.slice(index, nextIndex);

    if (!prefixed && !trim(content)) {
      index = startIndex;
      break;
    }

    if (!prefixed) {
      rest = value.slice(index);

      /* Check if the following code contains a possible
       * block. */
      if (interrupt(interruptors, tokenizers, self, [eat, rest, true])) {
        break;
      }
    }

    line = startIndex === index ? content : value.slice(startIndex, nextIndex);

    indents.push(index - startIndex);
    values.push(line);
    contents.push(content);

    index = nextIndex + 1;
  }

  index = -1;
  length = indents.length;
  add = eat(values.join(C_NEWLINE));

  while (++index < length) {
    offsets[currentLine] = (offsets[currentLine] || 0) + indents[index];
    currentLine++;
  }

  exit = self.enterBlock();
  contents = self.tokenizeBlock(contents.join(C_NEWLINE), now);
  exit();

  return add({
    type: 'blockquote',
    children: contents
  });
}


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = atxHeading;

var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var C_HASH = '#';

var MAX_ATX_COUNT = 6;

function atxHeading(eat, value, silent) {
  var self = this;
  var settings = self.options;
  var length = value.length + 1;
  var index = -1;
  var now = eat.now();
  var subvalue = '';
  var content = '';
  var character;
  var queue;
  var depth;

  /* Eat initial spacing. */
  while (++index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE && character !== C_TAB) {
      index--;
      break;
    }

    subvalue += character;
  }

  /* Eat hashes. */
  depth = 0;

  while (++index <= length) {
    character = value.charAt(index);

    if (character !== C_HASH) {
      index--;
      break;
    }

    subvalue += character;
    depth++;
  }

  if (depth > MAX_ATX_COUNT) {
    return;
  }

  if (
    !depth ||
    (!settings.pedantic && value.charAt(index + 1) === C_HASH)
  ) {
    return;
  }

  length = value.length + 1;

  /* Eat intermediate white-space. */
  queue = '';

  while (++index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE && character !== C_TAB) {
      index--;
      break;
    }

    queue += character;
  }

  /* Exit when not in pedantic mode without spacing. */
  if (
    !settings.pedantic &&
    queue.length === 0 &&
    character &&
    character !== C_NEWLINE
  ) {
    return;
  }

  if (silent) {
    return true;
  }

  /* Eat content. */
  subvalue += queue;
  queue = '';
  content = '';

  while (++index < length) {
    character = value.charAt(index);

    if (!character || character === C_NEWLINE) {
      break;
    }

    if (
      character !== C_SPACE &&
      character !== C_TAB &&
      character !== C_HASH
    ) {
      content += queue + character;
      queue = '';
      continue;
    }

    while (character === C_SPACE || character === C_TAB) {
      queue += character;
      character = value.charAt(++index);
    }

    while (character === C_HASH) {
      queue += character;
      character = value.charAt(++index);
    }

    while (character === C_SPACE || character === C_TAB) {
      queue += character;
      character = value.charAt(++index);
    }

    index--;
  }

  now.column += subvalue.length;
  now.offset += subvalue.length;
  subvalue += content + queue;

  return eat(subvalue)({
    type: 'heading',
    depth: depth,
    children: self.tokenizeInline(content, now)
  });
}


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = thematicBreak;

var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var C_ASTERISK = '*';
var C_UNDERSCORE = '_';
var C_DASH = '-';

var THEMATIC_BREAK_MARKER_COUNT = 3;

function thematicBreak(eat, value, silent) {
  var index = -1;
  var length = value.length + 1;
  var subvalue = '';
  var character;
  var marker;
  var markerCount;
  var queue;

  while (++index < length) {
    character = value.charAt(index);

    if (character !== C_TAB && character !== C_SPACE) {
      break;
    }

    subvalue += character;
  }

  if (
    character !== C_ASTERISK &&
    character !== C_DASH &&
    character !== C_UNDERSCORE
  ) {
    return;
  }

  marker = character;
  subvalue += character;
  markerCount = 1;
  queue = '';

  while (++index < length) {
    character = value.charAt(index);

    if (character === marker) {
      markerCount++;
      subvalue += queue + marker;
      queue = '';
    } else if (character === C_SPACE) {
      queue += character;
    } else if (
      markerCount >= THEMATIC_BREAK_MARKER_COUNT &&
      (!character || character === C_NEWLINE)
    ) {
      subvalue += queue;

      if (silent) {
        return true;
      }

      return eat(subvalue)({type: 'thematicBreak'});
    } else {
      return;
    }
  }
}


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable max-params */

var trim = __webpack_require__(52);
var repeat = __webpack_require__(101);
var decimal = __webpack_require__(71);
var getIndent = __webpack_require__(181);
var removeIndent = __webpack_require__(308);
var interrupt = __webpack_require__(103);

module.exports = list;

var C_ASTERISK = '*';
var C_UNDERSCORE = '_';
var C_PLUS = '+';
var C_DASH = '-';
var C_DOT = '.';
var C_SPACE = ' ';
var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_PAREN_CLOSE = ')';
var C_X_LOWER = 'x';

var TAB_SIZE = 4;
var EXPRESSION_LOOSE_LIST_ITEM = /\n\n(?!\s*$)/;
var EXPRESSION_TASK_ITEM = /^\[([ \t]|x|X)][ \t]/;
var EXPRESSION_BULLET = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/;
var EXPRESSION_PEDANTIC_BULLET = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
var EXPRESSION_INITIAL_INDENT = /^( {1,4}|\t)?/gm;

/* Map of characters which can be used to mark
 * list-items. */
var LIST_UNORDERED_MARKERS = {};

LIST_UNORDERED_MARKERS[C_ASTERISK] = true;
LIST_UNORDERED_MARKERS[C_PLUS] = true;
LIST_UNORDERED_MARKERS[C_DASH] = true;

/* Map of characters which can be used to mark
 * list-items after a digit. */
var LIST_ORDERED_MARKERS = {};

LIST_ORDERED_MARKERS[C_DOT] = true;

/* Map of characters which can be used to mark
 * list-items after a digit. */
var LIST_ORDERED_COMMONMARK_MARKERS = {};

LIST_ORDERED_COMMONMARK_MARKERS[C_DOT] = true;
LIST_ORDERED_COMMONMARK_MARKERS[C_PAREN_CLOSE] = true;

function list(eat, value, silent) {
  var self = this;
  var commonmark = self.options.commonmark;
  var pedantic = self.options.pedantic;
  var tokenizers = self.blockTokenizers;
  var interuptors = self.interruptList;
  var markers;
  var index = 0;
  var length = value.length;
  var start = null;
  var size = 0;
  var queue;
  var ordered;
  var character;
  var marker;
  var nextIndex;
  var startIndex;
  var prefixed;
  var currentMarker;
  var content;
  var line;
  var prevEmpty;
  var empty;
  var items;
  var allLines;
  var emptyLines;
  var item;
  var enterTop;
  var exitBlockquote;
  var isLoose;
  var node;
  var now;
  var end;
  var indented;

  while (index < length) {
    character = value.charAt(index);

    if (character === C_TAB) {
      size += TAB_SIZE - (size % TAB_SIZE);
    } else if (character === C_SPACE) {
      size++;
    } else {
      break;
    }

    index++;
  }

  if (size >= TAB_SIZE) {
    return;
  }

  character = value.charAt(index);

  markers = commonmark ?
    LIST_ORDERED_COMMONMARK_MARKERS :
    LIST_ORDERED_MARKERS;

  if (LIST_UNORDERED_MARKERS[character] === true) {
    marker = character;
    ordered = false;
  } else {
    ordered = true;
    queue = '';

    while (index < length) {
      character = value.charAt(index);

      if (!decimal(character)) {
        break;
      }

      queue += character;
      index++;
    }

    character = value.charAt(index);

    if (!queue || markers[character] !== true) {
      return;
    }

    start = parseInt(queue, 10);
    marker = character;
  }

  character = value.charAt(++index);

  if (character !== C_SPACE && character !== C_TAB) {
    return;
  }

  if (silent) {
    return true;
  }

  index = 0;
  items = [];
  allLines = [];
  emptyLines = [];

  while (index < length) {
    nextIndex = value.indexOf(C_NEWLINE, index);
    startIndex = index;
    prefixed = false;
    indented = false;

    if (nextIndex === -1) {
      nextIndex = length;
    }

    end = index + TAB_SIZE;
    size = 0;

    while (index < length) {
      character = value.charAt(index);

      if (character === C_TAB) {
        size += TAB_SIZE - (size % TAB_SIZE);
      } else if (character === C_SPACE) {
        size++;
      } else {
        break;
      }

      index++;
    }

    if (size >= TAB_SIZE) {
      indented = true;
    }

    if (item && size >= item.indent) {
      indented = true;
    }

    character = value.charAt(index);
    currentMarker = null;

    if (!indented) {
      if (LIST_UNORDERED_MARKERS[character] === true) {
        currentMarker = character;
        index++;
        size++;
      } else {
        queue = '';

        while (index < length) {
          character = value.charAt(index);

          if (!decimal(character)) {
            break;
          }

          queue += character;
          index++;
        }

        character = value.charAt(index);
        index++;

        if (queue && markers[character] === true) {
          currentMarker = character;
          size += queue.length + 1;
        }
      }

      if (currentMarker) {
        character = value.charAt(index);

        if (character === C_TAB) {
          size += TAB_SIZE - (size % TAB_SIZE);
          index++;
        } else if (character === C_SPACE) {
          end = index + TAB_SIZE;

          while (index < end) {
            if (value.charAt(index) !== C_SPACE) {
              break;
            }

            index++;
            size++;
          }

          if (index === end && value.charAt(index) === C_SPACE) {
            index -= TAB_SIZE - 1;
            size -= TAB_SIZE - 1;
          }
        } else if (character !== C_NEWLINE && character !== '') {
          currentMarker = null;
        }
      }
    }

    if (currentMarker) {
      if (!pedantic && marker !== currentMarker) {
        break;
      }

      prefixed = true;
    } else {
      if (!commonmark && !indented && value.charAt(startIndex) === C_SPACE) {
        indented = true;
      } else if (commonmark && item) {
        indented = size >= item.indent || size > TAB_SIZE;
      }

      prefixed = false;
      index = startIndex;
    }

    line = value.slice(startIndex, nextIndex);
    content = startIndex === index ? line : value.slice(index, nextIndex);

    if (
      currentMarker === C_ASTERISK ||
      currentMarker === C_UNDERSCORE ||
      currentMarker === C_DASH
    ) {
      if (tokenizers.thematicBreak.call(self, eat, line, true)) {
        break;
      }
    }

    prevEmpty = empty;
    empty = !trim(content).length;

    if (indented && item) {
      item.value = item.value.concat(emptyLines, line);
      allLines = allLines.concat(emptyLines, line);
      emptyLines = [];
    } else if (prefixed) {
      if (emptyLines.length !== 0) {
        item.value.push('');
        item.trail = emptyLines.concat();
      }

      item = {
        value: [line],
        indent: size,
        trail: []
      };

      items.push(item);
      allLines = allLines.concat(emptyLines, line);
      emptyLines = [];
    } else if (empty) {
      if (prevEmpty) {
        break;
      }

      emptyLines.push(line);
    } else {
      if (prevEmpty) {
        break;
      }

      if (interrupt(interuptors, tokenizers, self, [eat, line, true])) {
        break;
      }

      item.value = item.value.concat(emptyLines, line);
      allLines = allLines.concat(emptyLines, line);
      emptyLines = [];
    }

    index = nextIndex + 1;
  }

  node = eat(allLines.join(C_NEWLINE)).reset({
    type: 'list',
    ordered: ordered,
    start: start,
    loose: null,
    children: []
  });

  enterTop = self.enterList();
  exitBlockquote = self.enterBlock();
  isLoose = false;
  index = -1;
  length = items.length;

  while (++index < length) {
    item = items[index].value.join(C_NEWLINE);
    now = eat.now();

    item = eat(item)(listItem(self, item, now), node);

    if (item.loose) {
      isLoose = true;
    }

    item = items[index].trail.join(C_NEWLINE);

    if (index !== length - 1) {
      item += C_NEWLINE;
    }

    eat(item);
  }

  enterTop();
  exitBlockquote();

  node.loose = isLoose;

  return node;
}

function listItem(ctx, value, position) {
  var offsets = ctx.offset;
  var fn = ctx.options.pedantic ? pedanticListItem : normalListItem;
  var checked = null;
  var task;
  var indent;

  value = fn.apply(null, arguments);

  if (ctx.options.gfm) {
    task = value.match(EXPRESSION_TASK_ITEM);

    if (task) {
      indent = task[0].length;
      checked = task[1].toLowerCase() === C_X_LOWER;
      offsets[position.line] += indent;
      value = value.slice(indent);
    }
  }

  return {
    type: 'listItem',
    loose: EXPRESSION_LOOSE_LIST_ITEM.test(value) ||
      value.charAt(value.length - 1) === C_NEWLINE,
    checked: checked,
    children: ctx.tokenizeBlock(value, position)
  };
}

/* Create a list-item using overly simple mechanics. */
function pedanticListItem(ctx, value, position) {
  var offsets = ctx.offset;
  var line = position.line;

  /* Remove the list-item’s bullet. */
  value = value.replace(EXPRESSION_PEDANTIC_BULLET, replacer);

  /* The initial line was also matched by the below, so
   * we reset the `line`. */
  line = position.line;

  return value.replace(EXPRESSION_INITIAL_INDENT, replacer);

  /* A simple replacer which removed all matches,
   * and adds their length to `offset`. */
  function replacer($0) {
    offsets[line] = (offsets[line] || 0) + $0.length;
    line++;

    return '';
  }
}

/* Create a list-item using sane mechanics. */
function normalListItem(ctx, value, position) {
  var offsets = ctx.offset;
  var line = position.line;
  var max;
  var bullet;
  var rest;
  var lines;
  var trimmedLines;
  var index;
  var length;

  /* Remove the list-item’s bullet. */
  value = value.replace(EXPRESSION_BULLET, replacer);

  lines = value.split(C_NEWLINE);

  trimmedLines = removeIndent(value, getIndent(max).indent).split(C_NEWLINE);

  /* We replaced the initial bullet with something
   * else above, which was used to trick
   * `removeIndentation` into removing some more
   * characters when possible.  However, that could
   * result in the initial line to be stripped more
   * than it should be. */
  trimmedLines[0] = rest;

  offsets[line] = (offsets[line] || 0) + bullet.length;
  line++;

  index = 0;
  length = lines.length;

  while (++index < length) {
    offsets[line] = (offsets[line] || 0) +
      lines[index].length - trimmedLines[index].length;
    line++;
  }

  return trimmedLines.join(C_NEWLINE);

  function replacer($0, $1, $2, $3, $4) {
    bullet = $1 + $2 + $3;
    rest = $4;

    /* Make sure that the first nine numbered list items
     * can indent with an extra space.  That is, when
     * the bullet did not receive an extra final space. */
    if (Number($2) < 10 && bullet.length % 2 === 1) {
      $2 = C_SPACE + $2;
    }

    max = $1 + repeat(C_SPACE, $2.length) + $3;

    return max + rest;
  }
}


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(52);
var repeat = __webpack_require__(101);
var getIndent = __webpack_require__(181);

module.exports = indentation;

var C_SPACE = ' ';
var C_NEWLINE = '\n';
var C_TAB = '\t';

/* Remove the minimum indent from every line in `value`.
 * Supports both tab, spaced, and mixed indentation (as
 * well as possible). */
function indentation(value, maximum) {
  var values = value.split(C_NEWLINE);
  var position = values.length + 1;
  var minIndent = Infinity;
  var matrix = [];
  var index;
  var indentation;
  var stops;
  var padding;

  values.unshift(repeat(C_SPACE, maximum) + '!');

  while (position--) {
    indentation = getIndent(values[position]);

    matrix[position] = indentation.stops;

    if (trim(values[position]).length === 0) {
      continue;
    }

    if (indentation.indent) {
      if (indentation.indent > 0 && indentation.indent < minIndent) {
        minIndent = indentation.indent;
      }
    } else {
      minIndent = Infinity;

      break;
    }
  }

  if (minIndent !== Infinity) {
    position = values.length;

    while (position--) {
      stops = matrix[position];
      index = minIndent;

      while (index && !(index in stops)) {
        index--;
      }

      if (
        trim(values[position]).length !== 0 &&
        minIndent &&
        index !== minIndent
      ) {
        padding = C_TAB;
      } else {
        padding = '';
      }

      values[position] = padding + values[position].slice(
        index in stops ? stops[index] + 1 : 0
      );
    }
  }

  values.shift();

  return values.join(C_NEWLINE);
}


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = setextHeading;

var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var C_EQUALS = '=';
var C_DASH = '-';

var MAX_HEADING_INDENT = 3;

/* Map of characters which can be used to mark setext
 * headers, mapping to their corresponding depth. */
var SETEXT_MARKERS = {};

SETEXT_MARKERS[C_EQUALS] = 1;
SETEXT_MARKERS[C_DASH] = 2;

function setextHeading(eat, value, silent) {
  var self = this;
  var now = eat.now();
  var length = value.length;
  var index = -1;
  var subvalue = '';
  var content;
  var queue;
  var character;
  var marker;
  var depth;

  /* Eat initial indentation. */
  while (++index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE || index >= MAX_HEADING_INDENT) {
      index--;
      break;
    }

    subvalue += character;
  }

  /* Eat content. */
  content = '';
  queue = '';

  while (++index < length) {
    character = value.charAt(index);

    if (character === C_NEWLINE) {
      index--;
      break;
    }

    if (character === C_SPACE || character === C_TAB) {
      queue += character;
    } else {
      content += queue + character;
      queue = '';
    }
  }

  now.column += subvalue.length;
  now.offset += subvalue.length;
  subvalue += content + queue;

  /* Ensure the content is followed by a newline and a
   * valid marker. */
  character = value.charAt(++index);
  marker = value.charAt(++index);

  if (character !== C_NEWLINE || !SETEXT_MARKERS[marker]) {
    return;
  }

  subvalue += character;

  /* Eat Setext-line. */
  queue = marker;
  depth = SETEXT_MARKERS[marker];

  while (++index < length) {
    character = value.charAt(index);

    if (character !== marker) {
      if (character !== C_NEWLINE) {
        return;
      }

      index--;
      break;
    }

    queue += character;
  }

  if (silent) {
    return true;
  }

  return eat(subvalue + queue)({
    type: 'heading',
    depth: depth,
    children: self.tokenizeInline(content, now)
  });
}


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var openCloseTag = __webpack_require__(182).openCloseTag;

module.exports = blockHTML;

var C_TAB = '\t';
var C_SPACE = ' ';
var C_NEWLINE = '\n';
var C_LT = '<';

function blockHTML(eat, value, silent) {
  var self = this;
  var blocks = self.options.blocks;
  var length = value.length;
  var index = 0;
  var next;
  var line;
  var offset;
  var character;
  var count;
  var sequence;
  var subvalue;

  var sequences = [
    [/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true],
    [/^<!--/, /-->/, true],
    [/^<\?/, /\?>/, true],
    [/^<![A-Za-z]/, />/, true],
    [/^<!\[CDATA\[/, /\]\]>/, true],
    [new RegExp('^</?(' + blocks.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true],
    [new RegExp(openCloseTag.source + '\\s*$'), /^$/, false]
  ];

  /* Eat initial spacing. */
  while (index < length) {
    character = value.charAt(index);

    if (character !== C_TAB && character !== C_SPACE) {
      break;
    }

    index++;
  }

  if (value.charAt(index) !== C_LT) {
    return;
  }

  next = value.indexOf(C_NEWLINE, index + 1);
  next = next === -1 ? length : next;
  line = value.slice(index, next);
  offset = -1;
  count = sequences.length;

  while (++offset < count) {
    if (sequences[offset][0].test(line)) {
      sequence = sequences[offset];
      break;
    }
  }

  if (!sequence) {
    return;
  }

  if (silent) {
    return sequence[2];
  }

  index = next;

  if (!sequence[1].test(line)) {
    while (index < length) {
      next = value.indexOf(C_NEWLINE, index + 1);
      next = next === -1 ? length : next;
      line = value.slice(index + 1, next);

      if (sequence[1].test(line)) {
        if (line) {
          index = next;
        }

        break;
      }

      index = next;
    }
  }

  subvalue = value.slice(0, index);

  return eat(subvalue)({type: 'html', value: subvalue});
}


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(29);
var normalize = __webpack_require__(104);

module.exports = footnoteDefinition;
footnoteDefinition.notInList = true;
footnoteDefinition.notInBlock = true;

var C_BACKSLASH = '\\';
var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var C_BRACKET_OPEN = '[';
var C_BRACKET_CLOSE = ']';
var C_CARET = '^';
var C_COLON = ':';

var EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;

function footnoteDefinition(eat, value, silent) {
  var self = this;
  var offsets = self.offset;
  var index;
  var length;
  var subvalue;
  var now;
  var currentLine;
  var content;
  var queue;
  var subqueue;
  var character;
  var identifier;
  var add;
  var exit;

  if (!self.options.footnotes) {
    return;
  }

  index = 0;
  length = value.length;
  subvalue = '';
  now = eat.now();
  currentLine = now.line;

  while (index < length) {
    character = value.charAt(index);

    if (!whitespace(character)) {
      break;
    }

    subvalue += character;
    index++;
  }

  if (
    value.charAt(index) !== C_BRACKET_OPEN ||
    value.charAt(index + 1) !== C_CARET
  ) {
    return;
  }

  subvalue += C_BRACKET_OPEN + C_CARET;
  index = subvalue.length;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (character === C_BRACKET_CLOSE) {
      break;
    } else if (character === C_BACKSLASH) {
      queue += character;
      index++;
      character = value.charAt(index);
    }

    queue += character;
    index++;
  }

  if (
    !queue ||
    value.charAt(index) !== C_BRACKET_CLOSE ||
    value.charAt(index + 1) !== C_COLON
  ) {
    return;
  }

  if (silent) {
    return true;
  }

  identifier = normalize(queue);
  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
  index = subvalue.length;

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_TAB && character !== C_SPACE) {
      break;
    }

    subvalue += character;
    index++;
  }

  now.column += subvalue.length;
  now.offset += subvalue.length;
  queue = '';
  content = '';
  subqueue = '';

  while (index < length) {
    character = value.charAt(index);

    if (character === C_NEWLINE) {
      subqueue = character;
      index++;

      while (index < length) {
        character = value.charAt(index);

        if (character !== C_NEWLINE) {
          break;
        }

        subqueue += character;
        index++;
      }

      queue += subqueue;
      subqueue = '';

      while (index < length) {
        character = value.charAt(index);

        if (character !== C_SPACE) {
          break;
        }

        subqueue += character;
        index++;
      }

      if (subqueue.length === 0) {
        break;
      }

      queue += subqueue;
    }

    if (queue) {
      content += queue;
      queue = '';
    }

    content += character;
    index++;
  }

  subvalue += content;

  content = content.replace(EXPRESSION_INITIAL_TAB, function (line) {
    offsets[currentLine] = (offsets[currentLine] || 0) + line.length;
    currentLine++;

    return '';
  });

  add = eat(subvalue);

  exit = self.enterBlock();
  content = self.tokenizeBlock(content, now);
  exit();

  return add({
    type: 'footnoteDefinition',
    identifier: identifier,
    children: content
  });
}


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = collapse

// `collapse(' \t\nbar \nbaz\t') // ' bar baz '`
function collapse(value) {
  return String(value).replace(/\s+/g, ' ')
}


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(29);
var normalize = __webpack_require__(104);

module.exports = definition;
definition.notInList = true;
definition.notInBlock = true;

var C_DOUBLE_QUOTE = '"';
var C_SINGLE_QUOTE = '\'';
var C_BACKSLASH = '\\';
var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var C_BRACKET_OPEN = '[';
var C_BRACKET_CLOSE = ']';
var C_PAREN_OPEN = '(';
var C_PAREN_CLOSE = ')';
var C_COLON = ':';
var C_LT = '<';
var C_GT = '>';

function definition(eat, value, silent) {
  var self = this;
  var commonmark = self.options.commonmark;
  var index = 0;
  var length = value.length;
  var subvalue = '';
  var beforeURL;
  var beforeTitle;
  var queue;
  var character;
  var test;
  var identifier;
  var url;
  var title;

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE && character !== C_TAB) {
      break;
    }

    subvalue += character;
    index++;
  }

  character = value.charAt(index);

  if (character !== C_BRACKET_OPEN) {
    return;
  }

  index++;
  subvalue += character;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (character === C_BRACKET_CLOSE) {
      break;
    } else if (character === C_BACKSLASH) {
      queue += character;
      index++;
      character = value.charAt(index);
    }

    queue += character;
    index++;
  }

  if (
    !queue ||
    value.charAt(index) !== C_BRACKET_CLOSE ||
    value.charAt(index + 1) !== C_COLON
  ) {
    return;
  }

  identifier = queue;
  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
  index = subvalue.length;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (
      character !== C_TAB &&
      character !== C_SPACE &&
      character !== C_NEWLINE
    ) {
      break;
    }

    subvalue += character;
    index++;
  }

  character = value.charAt(index);
  queue = '';
  beforeURL = subvalue;

  if (character === C_LT) {
    index++;

    while (index < length) {
      character = value.charAt(index);

      if (!isEnclosedURLCharacter(character)) {
        break;
      }

      queue += character;
      index++;
    }

    character = value.charAt(index);

    if (character === isEnclosedURLCharacter.delimiter) {
      subvalue += C_LT + queue + character;
      index++;
    } else {
      if (commonmark) {
        return;
      }

      index -= queue.length + 1;
      queue = '';
    }
  }

  if (!queue) {
    while (index < length) {
      character = value.charAt(index);

      if (!isUnclosedURLCharacter(character)) {
        break;
      }

      queue += character;
      index++;
    }

    subvalue += queue;
  }

  if (!queue) {
    return;
  }

  url = queue;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (
      character !== C_TAB &&
      character !== C_SPACE &&
      character !== C_NEWLINE
    ) {
      break;
    }

    queue += character;
    index++;
  }

  character = value.charAt(index);
  test = null;

  if (character === C_DOUBLE_QUOTE) {
    test = C_DOUBLE_QUOTE;
  } else if (character === C_SINGLE_QUOTE) {
    test = C_SINGLE_QUOTE;
  } else if (character === C_PAREN_OPEN) {
    test = C_PAREN_CLOSE;
  }

  if (!test) {
    queue = '';
    index = subvalue.length;
  } else if (queue) {
    subvalue += queue + character;
    index = subvalue.length;
    queue = '';

    while (index < length) {
      character = value.charAt(index);

      if (character === test) {
        break;
      }

      if (character === C_NEWLINE) {
        index++;
        character = value.charAt(index);

        if (character === C_NEWLINE || character === test) {
          return;
        }

        queue += C_NEWLINE;
      }

      queue += character;
      index++;
    }

    character = value.charAt(index);

    if (character !== test) {
      return;
    }

    beforeTitle = subvalue;
    subvalue += queue + character;
    index++;
    title = queue;
    queue = '';
  } else {
    return;
  }

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_TAB && character !== C_SPACE) {
      break;
    }

    subvalue += character;
    index++;
  }

  character = value.charAt(index);

  if (!character || character === C_NEWLINE) {
    if (silent) {
      return true;
    }

    beforeURL = eat(beforeURL).test().end;
    url = self.decode.raw(self.unescape(url), beforeURL, {nonTerminated: false});

    if (title) {
      beforeTitle = eat(beforeTitle).test().end;
      title = self.decode.raw(self.unescape(title), beforeTitle);
    }

    return eat(subvalue)({
      type: 'definition',
      identifier: normalize(identifier),
      title: title || null,
      url: url
    });
  }
}

/* Check if `character` can be inside an enclosed URI. */
function isEnclosedURLCharacter(character) {
  return character !== C_GT &&
    character !== C_BRACKET_OPEN &&
    character !== C_BRACKET_CLOSE;
}

isEnclosedURLCharacter.delimiter = C_GT;

/* Check if `character` can be inside an unclosed URI. */
function isUnclosedURLCharacter(character) {
  return character !== C_BRACKET_OPEN &&
    character !== C_BRACKET_CLOSE &&
    !whitespace(character);
}


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(29);

module.exports = table;

var C_BACKSLASH = '\\';
var C_TICK = '`';
var C_DASH = '-';
var C_PIPE = '|';
var C_COLON = ':';
var C_SPACE = ' ';
var C_NEWLINE = '\n';
var C_TAB = '\t';

var MIN_TABLE_COLUMNS = 1;
var MIN_TABLE_ROWS = 2;

var TABLE_ALIGN_LEFT = 'left';
var TABLE_ALIGN_CENTER = 'center';
var TABLE_ALIGN_RIGHT = 'right';
var TABLE_ALIGN_NONE = null;

function table(eat, value, silent) {
  var self = this;
  var index;
  var alignments;
  var alignment;
  var subvalue;
  var row;
  var length;
  var lines;
  var queue;
  var character;
  var hasDash;
  var align;
  var cell;
  var preamble;
  var count;
  var opening;
  var now;
  var position;
  var lineCount;
  var line;
  var rows;
  var table;
  var lineIndex;
  var pipeIndex;
  var first;

  /* Exit when not in gfm-mode. */
  if (!self.options.gfm) {
    return;
  }

  /* Get the rows.
   * Detecting tables soon is hard, so there are some
   * checks for performance here, such as the minimum
   * number of rows, and allowed characters in the
   * alignment row. */
  index = 0;
  lineCount = 0;
  length = value.length + 1;
  lines = [];

  while (index < length) {
    lineIndex = value.indexOf(C_NEWLINE, index);
    pipeIndex = value.indexOf(C_PIPE, index + 1);

    if (lineIndex === -1) {
      lineIndex = value.length;
    }

    if (pipeIndex === -1 || pipeIndex > lineIndex) {
      if (lineCount < MIN_TABLE_ROWS) {
        return;
      }

      break;
    }

    lines.push(value.slice(index, lineIndex));
    lineCount++;
    index = lineIndex + 1;
  }

  /* Parse the alignment row. */
  subvalue = lines.join(C_NEWLINE);
  alignments = lines.splice(1, 1)[0] || [];
  index = 0;
  length = alignments.length;
  lineCount--;
  alignment = false;
  align = [];

  while (index < length) {
    character = alignments.charAt(index);

    if (character === C_PIPE) {
      hasDash = null;

      if (alignment === false) {
        if (first === false) {
          return;
        }
      } else {
        align.push(alignment);
        alignment = false;
      }

      first = false;
    } else if (character === C_DASH) {
      hasDash = true;
      alignment = alignment || TABLE_ALIGN_NONE;
    } else if (character === C_COLON) {
      if (alignment === TABLE_ALIGN_LEFT) {
        alignment = TABLE_ALIGN_CENTER;
      } else if (hasDash && alignment === TABLE_ALIGN_NONE) {
        alignment = TABLE_ALIGN_RIGHT;
      } else {
        alignment = TABLE_ALIGN_LEFT;
      }
    } else if (!whitespace(character)) {
      return;
    }

    index++;
  }

  if (alignment !== false) {
    align.push(alignment);
  }

  /* Exit when without enough columns. */
  if (align.length < MIN_TABLE_COLUMNS) {
    return;
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  /* Parse the rows. */
  position = -1;
  rows = [];

  table = eat(subvalue).reset({
    type: 'table',
    align: align,
    children: rows
  });

  while (++position < lineCount) {
    line = lines[position];
    row = {type: 'tableRow', children: []};

    /* Eat a newline character when this is not the
     * first row. */
    if (position) {
      eat(C_NEWLINE);
    }

    /* Eat the row. */
    eat(line).reset(row, table);

    length = line.length + 1;
    index = 0;
    queue = '';
    cell = '';
    preamble = true;
    count = null;
    opening = null;

    while (index < length) {
      character = line.charAt(index);

      if (character === C_TAB || character === C_SPACE) {
        if (cell) {
          queue += character;
        } else {
          eat(character);
        }

        index++;
        continue;
      }

      if (character === '' || character === C_PIPE) {
        if (preamble) {
          eat(character);
        } else {
          if (character && opening) {
            queue += character;
            index++;
            continue;
          }

          if ((cell || character) && !preamble) {
            subvalue = cell;

            if (queue.length > 1) {
              if (character) {
                subvalue += queue.slice(0, queue.length - 1);
                queue = queue.charAt(queue.length - 1);
              } else {
                subvalue += queue;
                queue = '';
              }
            }

            now = eat.now();

            eat(subvalue)({
              type: 'tableCell',
              children: self.tokenizeInline(cell, now)
            }, row);
          }

          eat(queue + character);

          queue = '';
          cell = '';
        }
      } else {
        if (queue) {
          cell += queue;
          queue = '';
        }

        cell += character;

        if (character === C_BACKSLASH && index !== length - 2) {
          cell += line.charAt(index + 1);
          index++;
        }

        if (character === C_TICK) {
          count = 1;

          while (line.charAt(index + 1) === character) {
            cell += character;
            index++;
            count++;
          }

          if (!opening) {
            opening = count;
          } else if (count >= opening) {
            opening = 0;
          }
        }
      }

      preamble = false;
      index++;
    }

    /* Eat the alignment row. */
    if (!position) {
      eat(C_NEWLINE + alignments);
    }
  }

  return table;
}


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(52);
var decimal = __webpack_require__(71);
var trimTrailingLines = __webpack_require__(102);
var interrupt = __webpack_require__(103);

module.exports = paragraph;

var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';

var TAB_SIZE = 4;

/* Tokenise paragraph. */
function paragraph(eat, value, silent) {
  var self = this;
  var settings = self.options;
  var commonmark = settings.commonmark;
  var gfm = settings.gfm;
  var tokenizers = self.blockTokenizers;
  var interruptors = self.interruptParagraph;
  var index = value.indexOf(C_NEWLINE);
  var length = value.length;
  var position;
  var subvalue;
  var character;
  var size;
  var now;

  while (index < length) {
    /* Eat everything if there’s no following newline. */
    if (index === -1) {
      index = length;
      break;
    }

    /* Stop if the next character is NEWLINE. */
    if (value.charAt(index + 1) === C_NEWLINE) {
      break;
    }

    /* In commonmark-mode, following indented lines
     * are part of the paragraph. */
    if (commonmark) {
      size = 0;
      position = index + 1;

      while (position < length) {
        character = value.charAt(position);

        if (character === C_TAB) {
          size = TAB_SIZE;
          break;
        } else if (character === C_SPACE) {
          size++;
        } else {
          break;
        }

        position++;
      }

      if (size >= TAB_SIZE) {
        index = value.indexOf(C_NEWLINE, index + 1);
        continue;
      }
    }

    subvalue = value.slice(index + 1);

    /* Check if the following code contains a possible
     * block. */
    if (interrupt(interruptors, tokenizers, self, [eat, subvalue, true])) {
      break;
    }

    /* Break if the following line starts a list, when
     * already in a list, or when in commonmark, or when
     * in gfm mode and the bullet is *not* numeric. */
    if (
      tokenizers.list.call(self, eat, subvalue, true) &&
      (
        self.inList ||
        commonmark ||
        (gfm && !decimal(trim.left(subvalue).charAt(0)))
      )
    ) {
      break;
    }

    position = index;
    index = value.indexOf(C_NEWLINE, index + 1);

    if (index !== -1 && trim(value.slice(position, index)) === '') {
      index = position;
      break;
    }
  }

  subvalue = value.slice(0, index);

  if (trim(subvalue) === '') {
    eat(subvalue);

    return null;
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  now = eat.now();
  subvalue = trimTrailingLines(subvalue);

  return eat(subvalue)({
    type: 'paragraph',
    children: self.tokenizeInline(subvalue, now)
  });
}


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var locate = __webpack_require__(317);

module.exports = escape;
escape.locator = locate;

function escape(eat, value, silent) {
  var self = this;
  var character;
  var node;

  if (value.charAt(0) === '\\') {
    character = value.charAt(1);

    if (self.escape.indexOf(character) !== -1) {
      /* istanbul ignore if - never used (yet) */
      if (silent) {
        return true;
      }

      if (character === '\n') {
        node = {type: 'break'};
      } else {
        node = {
          type: 'text',
          value: character
        };
      }

      return eat('\\' + character)(node);
    }
  }
}


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('\\', fromIndex);
}


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(29);
var decode = __webpack_require__(100);
var locate = __webpack_require__(183);

module.exports = autoLink;
autoLink.locator = locate;
autoLink.notInLink = true;

var C_LT = '<';
var C_GT = '>';
var C_AT_SIGN = '@';
var C_SLASH = '/';
var MAILTO = 'mailto:';
var MAILTO_LENGTH = MAILTO.length;

/* Tokenise a link. */
function autoLink(eat, value, silent) {
  var self;
  var subvalue;
  var length;
  var index;
  var queue;
  var character;
  var hasAtCharacter;
  var link;
  var now;
  var content;
  var tokenizers;
  var exit;

  if (value.charAt(0) !== C_LT) {
    return;
  }

  self = this;
  subvalue = '';
  length = value.length;
  index = 0;
  queue = '';
  hasAtCharacter = false;
  link = '';

  index++;
  subvalue = C_LT;

  while (index < length) {
    character = value.charAt(index);

    if (
      whitespace(character) ||
      character === C_GT ||
      character === C_AT_SIGN ||
      (character === ':' && value.charAt(index + 1) === C_SLASH)
    ) {
      break;
    }

    queue += character;
    index++;
  }

  if (!queue) {
    return;
  }

  link += queue;
  queue = '';

  character = value.charAt(index);
  link += character;
  index++;

  if (character === C_AT_SIGN) {
    hasAtCharacter = true;
  } else {
    if (
      character !== ':' ||
      value.charAt(index + 1) !== C_SLASH
    ) {
      return;
    }

    link += C_SLASH;
    index++;
  }

  while (index < length) {
    character = value.charAt(index);

    if (whitespace(character) || character === C_GT) {
      break;
    }

    queue += character;
    index++;
  }

  character = value.charAt(index);

  if (!queue || character !== C_GT) {
    return;
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  link += queue;
  content = link;
  subvalue += link + character;
  now = eat.now();
  now.column++;
  now.offset++;

  if (hasAtCharacter) {
    if (link.slice(0, MAILTO_LENGTH).toLowerCase() === MAILTO) {
      content = content.substr(MAILTO_LENGTH);
      now.column += MAILTO_LENGTH;
      now.offset += MAILTO_LENGTH;
    } else {
      link = MAILTO + link;
    }
  }

  /* Temporarily remove all tokenizers except text in autolinks. */
  tokenizers = self.inlineTokenizers;
  self.inlineTokenizers = {text: tokenizers.text};

  exit = self.enterLink();

  content = self.tokenizeInline(content, now);

  self.inlineTokenizers = tokenizers;
  exit();

  return eat(subvalue)({
    type: 'link',
    title: null,
    url: decode(link, {nonTerminated: false}),
    children: content
  });
}


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var decode = __webpack_require__(100);
var whitespace = __webpack_require__(29);
var locate = __webpack_require__(320);

module.exports = url;
url.locator = locate;
url.notInLink = true;

var C_BRACKET_OPEN = '[';
var C_BRACKET_CLOSE = ']';
var C_PAREN_OPEN = '(';
var C_PAREN_CLOSE = ')';
var C_LT = '<';
var C_AT_SIGN = '@';

var HTTP_PROTOCOL = 'http://';
var HTTPS_PROTOCOL = 'https://';
var MAILTO_PROTOCOL = 'mailto:';

var PROTOCOLS = [
  HTTP_PROTOCOL,
  HTTPS_PROTOCOL,
  MAILTO_PROTOCOL
];

var PROTOCOLS_LENGTH = PROTOCOLS.length;

function url(eat, value, silent) {
  var self = this;
  var subvalue;
  var content;
  var character;
  var index;
  var position;
  var protocol;
  var match;
  var length;
  var queue;
  var parenCount;
  var nextCharacter;
  var exit;

  if (!self.options.gfm) {
    return;
  }

  subvalue = '';
  index = -1;
  length = PROTOCOLS_LENGTH;

  while (++index < length) {
    protocol = PROTOCOLS[index];
    match = value.slice(0, protocol.length);

    if (match.toLowerCase() === protocol) {
      subvalue = match;
      break;
    }
  }

  if (!subvalue) {
    return;
  }

  index = subvalue.length;
  length = value.length;
  queue = '';
  parenCount = 0;

  while (index < length) {
    character = value.charAt(index);

    if (whitespace(character) || character === C_LT) {
      break;
    }

    if (
      character === '.' ||
      character === ',' ||
      character === ':' ||
      character === ';' ||
      character === '"' ||
      character === '\'' ||
      character === ')' ||
      character === ']'
    ) {
      nextCharacter = value.charAt(index + 1);

      if (!nextCharacter || whitespace(nextCharacter)) {
        break;
      }
    }

    if (character === C_PAREN_OPEN || character === C_BRACKET_OPEN) {
      parenCount++;
    }

    if (character === C_PAREN_CLOSE || character === C_BRACKET_CLOSE) {
      parenCount--;

      if (parenCount < 0) {
        break;
      }
    }

    queue += character;
    index++;
  }

  if (!queue) {
    return;
  }

  subvalue += queue;
  content = subvalue;

  if (protocol === MAILTO_PROTOCOL) {
    position = queue.indexOf(C_AT_SIGN);

    if (position === -1 || position === length - 1) {
      return;
    }

    content = content.substr(MAILTO_PROTOCOL.length);
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  exit = self.enterLink();
  content = self.tokenizeInline(content, eat.now());
  exit();

  return eat(subvalue)({
    type: 'link',
    title: null,
    url: decode(subvalue, {nonTerminated: false}),
    children: content
  });
}


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

var PROTOCOLS = ['https://', 'http://', 'mailto:'];

function locate(value, fromIndex) {
  var length = PROTOCOLS.length;
  var index = -1;
  var min = -1;
  var position;

  if (!this.options.gfm) {
    return -1;
  }

  while (++index < length) {
    position = value.indexOf(PROTOCOLS[index], fromIndex);

    if (position !== -1 && (position < min || min === -1)) {
      min = position;
    }
  }

  return min;
}


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabetical = __webpack_require__(179);
var locate = __webpack_require__(183);
var tag = __webpack_require__(182).tag;

module.exports = inlineHTML;
inlineHTML.locator = locate;

var EXPRESSION_HTML_LINK_OPEN = /^<a /i;
var EXPRESSION_HTML_LINK_CLOSE = /^<\/a>/i;

function inlineHTML(eat, value, silent) {
  var self = this;
  var length = value.length;
  var character;
  var subvalue;

  if (value.charAt(0) !== '<' || length < 3) {
    return;
  }

  character = value.charAt(1);

  if (
    !alphabetical(character) &&
    character !== '?' &&
    character !== '!' &&
    character !== '/'
  ) {
    return;
  }

  subvalue = value.match(tag);

  if (!subvalue) {
    return;
  }

  /* istanbul ignore if - not used yet. */
  if (silent) {
    return true;
  }

  subvalue = subvalue[0];

  if (!self.inLink && EXPRESSION_HTML_LINK_OPEN.test(subvalue)) {
    self.inLink = true;
  } else if (self.inLink && EXPRESSION_HTML_LINK_CLOSE.test(subvalue)) {
    self.inLink = false;
  }

  return eat(subvalue)({type: 'html', value: subvalue});
}


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(29);
var locate = __webpack_require__(184);

module.exports = link;
link.locator = locate;

var own = {}.hasOwnProperty;

var C_BACKSLASH = '\\';
var C_BRACKET_OPEN = '[';
var C_BRACKET_CLOSE = ']';
var C_PAREN_OPEN = '(';
var C_PAREN_CLOSE = ')';
var C_LT = '<';
var C_GT = '>';
var C_TICK = '`';
var C_DOUBLE_QUOTE = '"';
var C_SINGLE_QUOTE = '\'';

/* Map of characters, which can be used to mark link
 * and image titles. */
var LINK_MARKERS = {};

LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;

/* Map of characters, which can be used to mark link
 * and image titles in commonmark-mode. */
var COMMONMARK_LINK_MARKERS = {};

COMMONMARK_LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
COMMONMARK_LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
COMMONMARK_LINK_MARKERS[C_PAREN_OPEN] = C_PAREN_CLOSE;

function link(eat, value, silent) {
  var self = this;
  var subvalue = '';
  var index = 0;
  var character = value.charAt(0);
  var pedantic = self.options.pedantic;
  var commonmark = self.options.commonmark;
  var gfm = self.options.gfm;
  var closed;
  var count;
  var opening;
  var beforeURL;
  var beforeTitle;
  var subqueue;
  var hasMarker;
  var markers;
  var isImage;
  var content;
  var marker;
  var length;
  var title;
  var depth;
  var queue;
  var url;
  var now;
  var exit;
  var node;

  /* Detect whether this is an image. */
  if (character === '!') {
    isImage = true;
    subvalue = character;
    character = value.charAt(++index);
  }

  /* Eat the opening. */
  if (character !== C_BRACKET_OPEN) {
    return;
  }

  /* Exit when this is a link and we’re already inside
   * a link. */
  if (!isImage && self.inLink) {
    return;
  }

  subvalue += character;
  queue = '';
  index++;

  /* Eat the content. */
  length = value.length;
  now = eat.now();
  depth = 0;

  now.column += index;
  now.offset += index;

  while (index < length) {
    character = value.charAt(index);
    subqueue = character;

    if (character === C_TICK) {
      /* Inline-code in link content. */
      count = 1;

      while (value.charAt(index + 1) === C_TICK) {
        subqueue += character;
        index++;
        count++;
      }

      if (!opening) {
        opening = count;
      } else if (count >= opening) {
        opening = 0;
      }
    } else if (character === C_BACKSLASH) {
      /* Allow brackets to be escaped. */
      index++;
      subqueue += value.charAt(index);
    /* In GFM mode, brackets in code still count.
     * In all other modes, they don’t.  This empty
     * block prevents the next statements are
     * entered. */
    } else if ((!opening || gfm) && character === C_BRACKET_OPEN) {
      depth++;
    } else if ((!opening || gfm) && character === C_BRACKET_CLOSE) {
      if (depth) {
        depth--;
      } else {
        /* Allow white-space between content and
         * url in GFM mode. */
        if (!pedantic) {
          while (index < length) {
            character = value.charAt(index + 1);

            if (!whitespace(character)) {
              break;
            }

            subqueue += character;
            index++;
          }
        }

        if (value.charAt(index + 1) !== C_PAREN_OPEN) {
          return;
        }

        subqueue += C_PAREN_OPEN;
        closed = true;
        index++;

        break;
      }
    }

    queue += subqueue;
    subqueue = '';
    index++;
  }

  /* Eat the content closing. */
  if (!closed) {
    return;
  }

  content = queue;
  subvalue += queue + subqueue;
  index++;

  /* Eat white-space. */
  while (index < length) {
    character = value.charAt(index);

    if (!whitespace(character)) {
      break;
    }

    subvalue += character;
    index++;
  }

  /* Eat the URL. */
  character = value.charAt(index);
  markers = commonmark ? COMMONMARK_LINK_MARKERS : LINK_MARKERS;
  queue = '';
  beforeURL = subvalue;

  if (character === C_LT) {
    index++;
    beforeURL += C_LT;

    while (index < length) {
      character = value.charAt(index);

      if (character === C_GT) {
        break;
      }

      if (commonmark && character === '\n') {
        return;
      }

      queue += character;
      index++;
    }

    if (value.charAt(index) !== C_GT) {
      return;
    }

    subvalue += C_LT + queue + C_GT;
    url = queue;
    index++;
  } else {
    character = null;
    subqueue = '';

    while (index < length) {
      character = value.charAt(index);

      if (subqueue && own.call(markers, character)) {
        break;
      }

      if (whitespace(character)) {
        if (!pedantic) {
          break;
        }

        subqueue += character;
      } else {
        if (character === C_PAREN_OPEN) {
          depth++;
        } else if (character === C_PAREN_CLOSE) {
          if (depth === 0) {
            break;
          }

          depth--;
        }

        queue += subqueue;
        subqueue = '';

        if (character === C_BACKSLASH) {
          queue += C_BACKSLASH;
          character = value.charAt(++index);
        }

        queue += character;
      }

      index++;
    }

    subvalue += queue;
    url = queue;
    index = subvalue.length;
  }

  /* Eat white-space. */
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (!whitespace(character)) {
      break;
    }

    queue += character;
    index++;
  }

  character = value.charAt(index);
  subvalue += queue;

  /* Eat the title. */
  if (queue && own.call(markers, character)) {
    index++;
    subvalue += character;
    queue = '';
    marker = markers[character];
    beforeTitle = subvalue;

    /* In commonmark-mode, things are pretty easy: the
     * marker cannot occur inside the title.
     *
     * Non-commonmark does, however, support nested
     * delimiters. */
    if (commonmark) {
      while (index < length) {
        character = value.charAt(index);

        if (character === marker) {
          break;
        }

        if (character === C_BACKSLASH) {
          queue += C_BACKSLASH;
          character = value.charAt(++index);
        }

        index++;
        queue += character;
      }

      character = value.charAt(index);

      if (character !== marker) {
        return;
      }

      title = queue;
      subvalue += queue + character;
      index++;

      while (index < length) {
        character = value.charAt(index);

        if (!whitespace(character)) {
          break;
        }

        subvalue += character;
        index++;
      }
    } else {
      subqueue = '';

      while (index < length) {
        character = value.charAt(index);

        if (character === marker) {
          if (hasMarker) {
            queue += marker + subqueue;
            subqueue = '';
          }

          hasMarker = true;
        } else if (!hasMarker) {
          queue += character;
        } else if (character === C_PAREN_CLOSE) {
          subvalue += queue + marker + subqueue;
          title = queue;
          break;
        } else if (whitespace(character)) {
          subqueue += character;
        } else {
          queue += marker + subqueue + character;
          subqueue = '';
          hasMarker = false;
        }

        index++;
      }
    }
  }

  if (value.charAt(index) !== C_PAREN_CLOSE) {
    return;
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  subvalue += C_PAREN_CLOSE;

  url = self.decode.raw(self.unescape(url), eat(beforeURL).test().end, {nonTerminated: false});

  if (title) {
    beforeTitle = eat(beforeTitle).test().end;
    title = self.decode.raw(self.unescape(title), beforeTitle);
  }

  node = {
    type: isImage ? 'image' : 'link',
    title: title || null,
    url: url
  };

  if (isImage) {
    node.alt = self.decode.raw(self.unescape(content), now) || null;
  } else {
    exit = self.enterLink();
    node.children = self.tokenizeInline(content, now);
    exit();
  }

  return eat(subvalue)(node);
}


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(29);
var locate = __webpack_require__(184);
var normalize = __webpack_require__(104);

module.exports = reference;
reference.locator = locate;

var T_LINK = 'link';
var T_IMAGE = 'image';
var T_FOOTNOTE = 'footnote';
var REFERENCE_TYPE_SHORTCUT = 'shortcut';
var REFERENCE_TYPE_COLLAPSED = 'collapsed';
var REFERENCE_TYPE_FULL = 'full';
var C_CARET = '^';
var C_BACKSLASH = '\\';
var C_BRACKET_OPEN = '[';
var C_BRACKET_CLOSE = ']';

function reference(eat, value, silent) {
  var self = this;
  var character = value.charAt(0);
  var index = 0;
  var length = value.length;
  var subvalue = '';
  var intro = '';
  var type = T_LINK;
  var referenceType = REFERENCE_TYPE_SHORTCUT;
  var content;
  var identifier;
  var now;
  var node;
  var exit;
  var queue;
  var bracketed;
  var depth;

  /* Check whether we’re eating an image. */
  if (character === '!') {
    type = T_IMAGE;
    intro = character;
    character = value.charAt(++index);
  }

  if (character !== C_BRACKET_OPEN) {
    return;
  }

  index++;
  intro += character;
  queue = '';

  /* Check whether we’re eating a footnote. */
  if (self.options.footnotes && value.charAt(index) === C_CARET) {
    /* Exit if `![^` is found, so the `!` will be seen as text after this,
     * and we’ll enter this function again when `[^` is found. */
    if (type === T_IMAGE) {
      return;
    }

    intro += C_CARET;
    index++;
    type = T_FOOTNOTE;
  }

  /* Eat the text. */
  depth = 0;

  while (index < length) {
    character = value.charAt(index);

    if (character === C_BRACKET_OPEN) {
      bracketed = true;
      depth++;
    } else if (character === C_BRACKET_CLOSE) {
      if (!depth) {
        break;
      }

      depth--;
    }

    if (character === C_BACKSLASH) {
      queue += C_BACKSLASH;
      character = value.charAt(++index);
    }

    queue += character;
    index++;
  }

  subvalue = queue;
  content = queue;
  character = value.charAt(index);

  if (character !== C_BRACKET_CLOSE) {
    return;
  }

  index++;
  subvalue += character;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (!whitespace(character)) {
      break;
    }

    queue += character;
    index++;
  }

  character = value.charAt(index);

  /* Inline footnotes cannot have an identifier. */
  if (type !== T_FOOTNOTE && character === C_BRACKET_OPEN) {
    identifier = '';
    queue += character;
    index++;

    while (index < length) {
      character = value.charAt(index);

      if (character === C_BRACKET_OPEN || character === C_BRACKET_CLOSE) {
        break;
      }

      if (character === C_BACKSLASH) {
        identifier += C_BACKSLASH;
        character = value.charAt(++index);
      }

      identifier += character;
      index++;
    }

    character = value.charAt(index);

    if (character === C_BRACKET_CLOSE) {
      referenceType = identifier ? REFERENCE_TYPE_FULL : REFERENCE_TYPE_COLLAPSED;
      queue += identifier + character;
      index++;
    } else {
      identifier = '';
    }

    subvalue += queue;
    queue = '';
  } else {
    if (!content) {
      return;
    }

    identifier = content;
  }

  /* Brackets cannot be inside the identifier. */
  if (referenceType !== REFERENCE_TYPE_FULL && bracketed) {
    return;
  }

  subvalue = intro + subvalue;

  if (type === T_LINK && self.inLink) {
    return null;
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  if (type === T_FOOTNOTE && content.indexOf(' ') !== -1) {
    return eat(subvalue)({
      type: 'footnote',
      children: this.tokenizeInline(content, eat.now())
    });
  }

  now = eat.now();
  now.column += intro.length;
  now.offset += intro.length;
  identifier = referenceType === REFERENCE_TYPE_FULL ? identifier : content;

  node = {
    type: type + 'Reference',
    identifier: normalize(identifier)
  };

  if (type === T_LINK || type === T_IMAGE) {
    node.referenceType = referenceType;
  }

  if (type === T_LINK) {
    exit = self.enterLink();
    node.children = self.tokenizeInline(content, now);
    exit();
  } else if (type === T_IMAGE) {
    node.alt = self.decode.raw(self.unescape(content), now) || null;
  }

  return eat(subvalue)(node);
}


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(52);
var whitespace = __webpack_require__(29);
var locate = __webpack_require__(325);

module.exports = strong;
strong.locator = locate;

var C_ASTERISK = '*';
var C_UNDERSCORE = '_';

function strong(eat, value, silent) {
  var self = this;
  var index = 0;
  var character = value.charAt(index);
  var now;
  var pedantic;
  var marker;
  var queue;
  var subvalue;
  var length;
  var prev;

  if (
    (character !== C_ASTERISK && character !== C_UNDERSCORE) ||
    value.charAt(++index) !== character
  ) {
    return;
  }

  pedantic = self.options.pedantic;
  marker = character;
  subvalue = marker + marker;
  length = value.length;
  index++;
  queue = '';
  character = '';

  if (pedantic && whitespace(value.charAt(index))) {
    return;
  }

  while (index < length) {
    prev = character;
    character = value.charAt(index);

    if (
      character === marker &&
      value.charAt(index + 1) === marker &&
      (!pedantic || !whitespace(prev))
    ) {
      character = value.charAt(index + 2);

      if (character !== marker) {
        if (!trim(queue)) {
          return;
        }

        /* istanbul ignore if - never used (yet) */
        if (silent) {
          return true;
        }

        now = eat.now();
        now.column += 2;
        now.offset += 2;

        return eat(subvalue + queue + subvalue)({
          type: 'strong',
          children: self.tokenizeInline(queue, now)
        });
      }
    }

    if (!pedantic && character === '\\') {
      queue += character;
      character = value.charAt(++index);
    }

    queue += character;
    index++;
  }
}


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  var asterisk = value.indexOf('**', fromIndex);
  var underscore = value.indexOf('__', fromIndex);

  if (underscore === -1) {
    return asterisk;
  }

  if (asterisk === -1) {
    return underscore;
  }

  return underscore < asterisk ? underscore : asterisk;
}


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(52);
var word = __webpack_require__(327);
var whitespace = __webpack_require__(29);
var locate = __webpack_require__(328);

module.exports = emphasis;
emphasis.locator = locate;

var C_ASTERISK = '*';
var C_UNDERSCORE = '_';

function emphasis(eat, value, silent) {
  var self = this;
  var index = 0;
  var character = value.charAt(index);
  var now;
  var pedantic;
  var marker;
  var queue;
  var subvalue;
  var length;
  var prev;

  if (character !== C_ASTERISK && character !== C_UNDERSCORE) {
    return;
  }

  pedantic = self.options.pedantic;
  subvalue = character;
  marker = character;
  length = value.length;
  index++;
  queue = '';
  character = '';

  if (pedantic && whitespace(value.charAt(index))) {
    return;
  }

  while (index < length) {
    prev = character;
    character = value.charAt(index);

    if (character === marker && (!pedantic || !whitespace(prev))) {
      character = value.charAt(++index);

      if (character !== marker) {
        if (!trim(queue) || prev === marker) {
          return;
        }

        if (!pedantic && marker === C_UNDERSCORE && word(character)) {
          queue += marker;
          continue;
        }

        /* istanbul ignore if - never used (yet) */
        if (silent) {
          return true;
        }

        now = eat.now();
        now.column++;
        now.offset++;

        return eat(subvalue + queue + marker)({
          type: 'emphasis',
          children: self.tokenizeInline(queue, now)
        });
      }

      queue += marker;
    }

    if (!pedantic && character === '\\') {
      queue += character;
      character = value.charAt(++index);
    }

    queue += character;
    index++;
  }
}


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = wordCharacter

var fromCode = String.fromCharCode
var re = /\w/

// Check if the given character code, or the character code at the first
// character, is a word character.
function wordCharacter(character) {
  return re.test(
    typeof character === 'number' ? fromCode(character) : character.charAt(0)
  )
}


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  var asterisk = value.indexOf('*', fromIndex);
  var underscore = value.indexOf('_', fromIndex);

  if (underscore === -1) {
    return asterisk;
  }

  if (asterisk === -1) {
    return underscore;
  }

  return underscore < asterisk ? underscore : asterisk;
}


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(29);
var locate = __webpack_require__(330);

module.exports = strikethrough;
strikethrough.locator = locate;

var C_TILDE = '~';
var DOUBLE = '~~';

function strikethrough(eat, value, silent) {
  var self = this;
  var character = '';
  var previous = '';
  var preceding = '';
  var subvalue = '';
  var index;
  var length;
  var now;

  if (
    !self.options.gfm ||
    value.charAt(0) !== C_TILDE ||
    value.charAt(1) !== C_TILDE ||
    whitespace(value.charAt(2))
  ) {
    return;
  }

  index = 1;
  length = value.length;
  now = eat.now();
  now.column += 2;
  now.offset += 2;

  while (++index < length) {
    character = value.charAt(index);

    if (
      character === C_TILDE &&
      previous === C_TILDE &&
      (!preceding || !whitespace(preceding))
    ) {
      /* istanbul ignore if - never used (yet) */
      if (silent) {
        return true;
      }

      return eat(DOUBLE + subvalue + DOUBLE)({
        type: 'delete',
        children: self.tokenizeInline(subvalue, now)
      });
    }

    subvalue += previous;
    preceding = previous;
    previous = character;
  }
}


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('~~', fromIndex);
}


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(29);
var locate = __webpack_require__(332);

module.exports = inlineCode;
inlineCode.locator = locate;

var C_TICK = '`';

/* Tokenise inline code. */
function inlineCode(eat, value, silent) {
  var length = value.length;
  var index = 0;
  var queue = '';
  var tickQueue = '';
  var contentQueue;
  var subqueue;
  var count;
  var openingCount;
  var subvalue;
  var character;
  var found;
  var next;

  while (index < length) {
    if (value.charAt(index) !== C_TICK) {
      break;
    }

    queue += C_TICK;
    index++;
  }

  if (!queue) {
    return;
  }

  subvalue = queue;
  openingCount = index;
  queue = '';
  next = value.charAt(index);
  count = 0;

  while (index < length) {
    character = next;
    next = value.charAt(index + 1);

    if (character === C_TICK) {
      count++;
      tickQueue += character;
    } else {
      count = 0;
      queue += character;
    }

    if (count && next !== C_TICK) {
      if (count === openingCount) {
        subvalue += queue + tickQueue;
        found = true;
        break;
      }

      queue += tickQueue;
      tickQueue = '';
    }

    index++;
  }

  if (!found) {
    if (openingCount % 2 !== 0) {
      return;
    }

    queue = '';
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  contentQueue = '';
  subqueue = '';
  length = queue.length;
  index = -1;

  while (++index < length) {
    character = queue.charAt(index);

    if (whitespace(character)) {
      subqueue += character;
      continue;
    }

    if (subqueue) {
      if (contentQueue) {
        contentQueue += subqueue;
      }

      subqueue = '';
    }

    contentQueue += character;
  }

  return eat(subvalue)({
    type: 'inlineCode',
    value: contentQueue
  });
}


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('`', fromIndex);
}


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var locate = __webpack_require__(334);

module.exports = hardBreak;
hardBreak.locator = locate;

var MIN_BREAK_LENGTH = 2;

function hardBreak(eat, value, silent) {
  var length = value.length;
  var index = -1;
  var queue = '';
  var character;

  while (++index < length) {
    character = value.charAt(index);

    if (character === '\n') {
      if (index < MIN_BREAK_LENGTH) {
        return;
      }

      /* istanbul ignore if - never used (yet) */
      if (silent) {
        return true;
      }

      queue += character;

      return eat(queue)({type: 'break'});
    }

    if (character !== ' ') {
      return;
    }

    queue += character;
  }
}


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  var index = value.indexOf('\n', fromIndex);

  while (index > fromIndex) {
    if (value.charAt(index - 1) !== ' ') {
      break;
    }

    index--;
  }

  return index;
}


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = text;

function text(eat, value, silent) {
  var self = this;
  var methods;
  var tokenizers;
  var index;
  var length;
  var subvalue;
  var position;
  var tokenizer;
  var name;
  var min;
  var now;

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  methods = self.inlineMethods;
  length = methods.length;
  tokenizers = self.inlineTokenizers;
  index = -1;
  min = value.length;

  while (++index < length) {
    name = methods[index];

    if (name === 'text' || !tokenizers[name]) {
      continue;
    }

    tokenizer = tokenizers[name].locator;

    if (!tokenizer) {
      eat.file.fail('Missing locator: `' + name + '`');
    }

    position = tokenizer.call(self, value, 1);

    if (position !== -1 && position < min) {
      min = position;
    }
  }

  subvalue = value.slice(0, min);
  now = eat.now();

  self.decode(subvalue, now, function (content, position, source) {
    eat(source || content)({
      type: 'text',
      value: content
    });
  });
}


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(337)();
}


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(338);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var visitWithParents = __webpack_require__(340);

function addListMetadata() {
  return function (ast) {
    visitWithParents(ast, 'list', function (listNode, parents) {
      var depth = 0, i, n;
      for (i = 0, n = parents.length; i < n; i++) {
        if (parents[i].type === 'list') depth += 1;
      }
      for (i = 0, n = listNode.children.length; i < n; i++) {
        var child = listNode.children[i];
        child.index = i;
        child.ordered = listNode.ordered;
      }
      listNode.depth = depth;
    });
    return ast;
  };
}

module.exports = addListMetadata;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* Expose. */
module.exports = visitParents

/* Visit. */
function visitParents(tree, type, visitor) {
  var stack = []

  if (typeof type === 'function') {
    visitor = type
    type = null
  }

  one(tree)

  /* Visit a single node. */
  function one(node) {
    var result

    if (!type || node.type === type) {
      result = visitor(node, stack.concat())
    }

    if (node.children && result !== false) {
      return all(node.children, node)
    }

    return result
  }

  /* Visit children in `parent`. */
  function all(children, parent) {
    var length = children.length
    var index = -1
    var child

    stack.push(parent)

    while (++index < length) {
      child = children[index]

      if (child && one(child) === false) {
        return false
      }
    }

    stack.pop()

    return true
  }
}


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Naive, simple plugin to match inline nodes without attributes
 * This allows say <strong>foo</strong>, but not <strong class="very">foo</strong>
 * For proper HTML support, you'll want a different plugin
 **/
var visit = __webpack_require__(72);

var type = 'virtualHtml';
var selfClosingRe = /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i;
var simpleTagRe = /^<(\/?)([a-z]+)\s*>$/;

module.exports = function (tree) {
  var open;
  var currentParent;
  visit(tree, 'html', function (node, index, parent) {
    if (currentParent !== parent) {
      open = [];
      currentParent = parent;
    }

    var selfClosing = getSelfClosing(node);

    if (selfClosing) {
      parent.children.splice(index, 1, {
        type: type,
        tag: selfClosing,
        position: node.position
      });
      return true;
    }

    var current = getSimpleTag(node, parent);

    if (!current) {
      return true;
    }

    var matching = findAndPull(open, current.tag);

    if (matching) {
      parent.children.splice(index, 0, virtual(current, matching, parent));
    } else if (!current.opening) {
      open.push(current);
    }

    return true;
  }, true // Iterate in reverse
  );
  return tree;
};

function findAndPull(open, matchingTag) {
  var i = open.length;

  while (i--) {
    if (open[i].tag === matchingTag) {
      return open.splice(i, 1)[0];
    }
  }

  return false;
}

function getSimpleTag(node, parent) {
  var match = node.value.match(simpleTagRe);
  return match ? {
    tag: match[2],
    opening: !match[1],
    node: node
  } : false;
}

function getSelfClosing(node) {
  var match = node.value.match(selfClosingRe);
  return match ? match[1] : false;
}

function virtual(fromNode, toNode, parent) {
  var fromIndex = parent.children.indexOf(fromNode.node);
  var toIndex = parent.children.indexOf(toNode.node);
  var extracted = parent.children.splice(fromIndex, toIndex - fromIndex + 1);
  var children = extracted.slice(1, -1);
  return {
    type: type,
    children: children,
    tag: fromNode.tag,
    position: {
      start: fromNode.node.position.start,
      end: toNode.node.position.end,
      indent: []
    }
  };
}

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var visit = __webpack_require__(72);

exports.ofType = function (types, mode) {
  return function (node) {
    types.forEach(function (type) {
      return visit(node, type, disallow, true);
    });
    return node;
  };

  function disallow(node, index, parent) {
    if (parent) {
      untangle(node, index, parent, mode);
    }
  }
};

exports.ifNotMatch = function (allowNode, mode) {
  return function (node) {
    visit(node, disallow, true);
    return node;
  };

  function disallow(node, index, parent) {
    if (parent && !allowNode(node, index, parent)) {
      untangle(node, index, parent, mode);
    }
  }
};

function untangle(node, index, parent, mode) {
  if (mode === 'remove') {
    parent.children.splice(index, 1);
  } else if (mode === 'unwrap') {
    var args = [index, 1];

    if (node.children) {
      args = args.concat(node.children);
    }

    Array.prototype.splice.apply(parent.children, args);
  }
}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

var xtend = __webpack_require__(37);

var ReactIs = __webpack_require__(344);

var defaultNodePosition = {
  start: {
    line: 1,
    column: 1,
    offset: 0
  },
  end: {
    line: 1,
    column: 1,
    offset: 0
  }
};

function astToReact(node, options) {
  var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var renderer = options.renderers[node.type]; // nodes generated by plugins may not have position data
  // much of the code after this point will attempt to access properties of the node.position
  // this will set the node position to the parent node's position to prevent errors

  if (node.position === undefined) {
    node.position = parent.node && parent.node.position || defaultNodePosition;
  }

  var pos = node.position.start;
  var key = [node.type, pos.line, pos.column, index].join('-');

  if (!ReactIs.isValidElementType(renderer)) {
    throw new Error("Renderer for type `".concat(node.type, "` not defined or is not renderable"));
  }

  var nodeProps = getNodeProps(node, key, options, renderer, parent, index);
  return React.createElement(renderer, nodeProps, nodeProps.children || resolveChildren() || undefined);

  function resolveChildren() {
    return node.children && node.children.map(function (childNode, i) {
      return astToReact(childNode, options, {
        node: node,
        props: nodeProps
      }, i);
    });
  }
} // eslint-disable-next-line max-params, complexity


function getNodeProps(node, key, opts, renderer, parent, index) {
  var props = {
    key: key
  };
  var isTagRenderer = typeof renderer === 'string'; // `sourcePos` is true if the user wants source information (line/column info from markdown source)

  if (opts.sourcePos && node.position) {
    props['data-sourcepos'] = flattenPosition(node.position);
  }

  if (opts.rawSourcePos && !isTagRenderer) {
    props.sourcePosition = node.position;
  } // If `includeNodeIndex` is true, pass node index info to all non-tag renderers


  if (opts.includeNodeIndex && parent.node && parent.node.children && !isTagRenderer) {
    props.index = parent.node.children.indexOf(node);
    props.parentChildCount = parent.node.children.length;
  }

  var ref = node.identifier !== null && node.identifier !== undefined ? opts.definitions[node.identifier] || {} : null;

  switch (node.type) {
    case 'root':
      assignDefined(props, {
        className: opts.className
      });
      break;

    case 'text':
      props.nodeKey = key;
      props.children = node.value;
      break;

    case 'heading':
      props.level = node.depth;
      break;

    case 'list':
      props.start = node.start;
      props.ordered = node.ordered;
      props.tight = !node.loose;
      props.depth = node.depth;
      break;

    case 'listItem':
      props.checked = node.checked;
      props.tight = !node.loose;
      props.ordered = node.ordered;
      props.index = node.index;
      props.children = getListItemChildren(node, parent).map(function (childNode, i) {
        return astToReact(childNode, opts, {
          node: node,
          props: props
        }, i);
      });
      break;

    case 'definition':
      assignDefined(props, {
        identifier: node.identifier,
        title: node.title,
        url: node.url
      });
      break;

    case 'code':
      assignDefined(props, {
        language: node.lang && node.lang.split(/\s/, 1)[0]
      });
      break;

    case 'inlineCode':
      props.children = node.value;
      props.inline = true;
      break;

    case 'link':
      assignDefined(props, {
        title: node.title || undefined,
        target: typeof opts.linkTarget === 'function' ? opts.linkTarget(node.url, node.children, node.title) : opts.linkTarget,
        href: opts.transformLinkUri ? opts.transformLinkUri(node.url, node.children, node.title) : node.url
      });
      break;

    case 'image':
      assignDefined(props, {
        alt: node.alt || undefined,
        title: node.title || undefined,
        src: opts.transformImageUri ? opts.transformImageUri(node.url, node.children, node.title, node.alt) : node.url
      });
      break;

    case 'linkReference':
      assignDefined(props, xtend(ref, {
        href: opts.transformLinkUri ? opts.transformLinkUri(ref.href) : ref.href
      }));
      break;

    case 'imageReference':
      assignDefined(props, {
        src: opts.transformImageUri && ref.href ? opts.transformImageUri(ref.href, node.children, ref.title, node.alt) : ref.href,
        title: ref.title || undefined,
        alt: node.alt || undefined
      });
      break;

    case 'table':
    case 'tableHead':
    case 'tableBody':
      props.columnAlignment = node.align;
      break;

    case 'tableRow':
      props.isHeader = parent.node.type === 'tableHead';
      props.columnAlignment = parent.props.columnAlignment;
      break;

    case 'tableCell':
      assignDefined(props, {
        isHeader: parent.props.isHeader,
        align: parent.props.columnAlignment[index]
      });
      break;

    case 'virtualHtml':
      props.tag = node.tag;
      break;

    case 'html':
      // @todo find a better way than this
      props.isBlock = node.position.start.line !== node.position.end.line;
      props.escapeHtml = opts.escapeHtml;
      props.skipHtml = opts.skipHtml;
      break;

    case 'parsedHtml':
      {
        var parsedChildren;

        if (node.children) {
          parsedChildren = node.children.map(function (child, i) {
            return astToReact(child, opts, {
              node: node,
              props: props
            }, i);
          });
        }

        props.escapeHtml = opts.escapeHtml;
        props.skipHtml = opts.skipHtml;
        props.element = mergeNodeChildren(node, parsedChildren);
        break;
      }

    default:
      assignDefined(props, xtend(node, {
        type: undefined,
        position: undefined,
        children: undefined
      }));
  }

  if (!isTagRenderer && node.value) {
    props.value = node.value;
  }

  return props;
}

function assignDefined(target, attrs) {
  for (var key in attrs) {
    if (typeof attrs[key] !== 'undefined') {
      target[key] = attrs[key];
    }
  }
}

function mergeNodeChildren(node, parsedChildren) {
  var el = node.element;

  if (Array.isArray(el)) {
    var Fragment = React.Fragment || 'div';
    return React.createElement(Fragment, null, el);
  }

  if (el.props.children || parsedChildren) {
    var children = React.Children.toArray(el.props.children).concat(parsedChildren);
    return React.cloneElement(el, null, children);
  }

  return React.cloneElement(el, null);
}

function flattenPosition(pos) {
  return [pos.start.line, ':', pos.start.column, '-', pos.end.line, ':', pos.end.column].map(String).join('');
}

function getListItemChildren(node, parent) {
  if (node.loose) {
    return node.children;
  }

  if (parent.node && node.index > 0 && parent.node.children[node.index - 1].loose) {
    return node.children;
  }

  return unwrapParagraphs(node);
}

function unwrapParagraphs(node) {
  return node.children.reduce(function (array, child) {
    return array.concat(child.type === 'paragraph' ? child.children || [] : [child]);
  }, []);
}

module.exports = astToReact;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(345);
} else {}


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var visit = __webpack_require__(72);

module.exports = function (node) {
  visit(node, 'table', wrap);
  return node;
};

function wrap(table) {
  var children = table.children;
  table.children = [{
    type: 'tableHead',
    align: table.align,
    children: [children[0]],
    position: children[0].position
  }];

  if (children.length > 1) {
    table.children.push({
      type: 'tableBody',
      align: table.align,
      children: children.slice(1),
      position: {
        start: children[1].position.start,
        end: children[children.length - 1].position.end
      }
    });
  }
}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function getDefinitions(node) {
  var defs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (node.children || []).reduce(function (definitions, child) {
    if (child.type === 'definition') {
      definitions[child.identifier] = {
        href: child.url,
        title: child.title
      };
    }

    return getDefinitions(child, definitions);
  }, defs);
};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var protocols = ['http', 'https', 'mailto', 'tel'];

module.exports = function uriTransformer(uri) {
  var url = (uri || '').trim();
  var first = url.charAt(0);

  if (first === '#' || first === '/') {
    return url;
  }

  var colon = url.indexOf(':');

  if (colon === -1) {
    return url;
  }

  var length = protocols.length;
  var index = -1;

  while (++index < length) {
    var protocol = protocols[index];

    if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) {
      return url;
    }
  }

  index = url.indexOf('?');

  if (index !== -1 && colon > index) {
    return url;
  }

  index = url.indexOf('#');

  if (index !== -1 && colon > index) {
    return url;
  } // eslint-disable-next-line no-script-url


  return 'javascript:void(0)';
};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable react/prop-types, react/no-multi-comp */


var xtend = __webpack_require__(37);

var React = __webpack_require__(0);

var supportsStringRender = parseInt((React.version || '16').slice(0, 2), 10) >= 16;
var createElement = React.createElement;
module.exports = {
  break: 'br',
  paragraph: 'p',
  emphasis: 'em',
  strong: 'strong',
  thematicBreak: 'hr',
  blockquote: 'blockquote',
  delete: 'del',
  link: 'a',
  image: 'img',
  linkReference: 'a',
  imageReference: 'img',
  table: SimpleRenderer.bind(null, 'table'),
  tableHead: SimpleRenderer.bind(null, 'thead'),
  tableBody: SimpleRenderer.bind(null, 'tbody'),
  tableRow: SimpleRenderer.bind(null, 'tr'),
  tableCell: TableCell,
  root: Root,
  text: TextRenderer,
  list: List,
  listItem: ListItem,
  definition: NullRenderer,
  heading: Heading,
  inlineCode: InlineCode,
  code: CodeBlock,
  html: Html,
  virtualHtml: VirtualHtml,
  parsedHtml: ParsedHtml
};

function TextRenderer(props) {
  return supportsStringRender ? props.children : createElement('span', null, props.children);
}

function Root(props) {
  var useFragment = !props.className;
  var root = useFragment ? React.Fragment || 'div' : 'div';
  return createElement(root, useFragment ? null : props, props.children);
}

function SimpleRenderer(tag, props) {
  return createElement(tag, getCoreProps(props), props.children);
}

function TableCell(props) {
  var style = props.align ? {
    textAlign: props.align
  } : undefined;
  var coreProps = getCoreProps(props);
  return createElement(props.isHeader ? 'th' : 'td', style ? xtend({
    style: style
  }, coreProps) : coreProps, props.children);
}

function Heading(props) {
  return createElement("h".concat(props.level), getCoreProps(props), props.children);
}

function List(props) {
  var attrs = getCoreProps(props);

  if (props.start !== null && props.start !== 1 && props.start !== undefined) {
    attrs.start = props.start.toString();
  }

  return createElement(props.ordered ? 'ol' : 'ul', attrs, props.children);
}

function ListItem(props) {
  var checkbox = null;

  if (props.checked !== null && props.checked !== undefined) {
    var checked = props.checked;
    checkbox = createElement('input', {
      type: 'checkbox',
      checked: checked,
      readOnly: true
    });
  }

  return createElement('li', getCoreProps(props), checkbox, props.children);
}

function CodeBlock(props) {
  var className = props.language && "language-".concat(props.language);
  var code = createElement('code', className ? {
    className: className
  } : null, props.value);
  return createElement('pre', getCoreProps(props), code);
}

function InlineCode(props) {
  return createElement('code', getCoreProps(props), props.children);
}

function Html(props) {
  if (props.skipHtml) {
    return null;
  }

  var tag = props.isBlock ? 'div' : 'span';

  if (props.escapeHtml) {
    var comp = React.Fragment || tag;
    return createElement(comp, null, props.value);
  }

  var nodeProps = {
    dangerouslySetInnerHTML: {
      __html: props.value
    }
  };
  return createElement(tag, nodeProps);
}

function ParsedHtml(props) {
  return props['data-sourcepos'] ? React.cloneElement(props.element, {
    'data-sourcepos': props['data-sourcepos']
  }) : props.element;
}

function VirtualHtml(props) {
  return createElement(props.tag, getCoreProps(props), props.children);
}

function NullRenderer() {
  return null;
}

function getCoreProps(props) {
  return props['data-sourcepos'] ? {
    'data-sourcepos': props['data-sourcepos']
  } : {};
}

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var HtmlParser = '__RMD_HTML_PARSER__';
exports.HtmlParser = typeof Symbol === 'undefined' ? HtmlParser : Symbol(HtmlParser);

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnippetTest = exports.Snippet = void 0;
__webpack_require__(352);
const React = __webpack_require__(0);
const mobx_1 = __webpack_require__(3);
const mobx_react_1 = __webpack_require__(67);
const hljs = __webpack_require__(354);
__webpack_require__(355);
hljs.registerLanguage('csharp', __webpack_require__(357));
hljs.registerLanguage('java', __webpack_require__(358));
hljs.registerLanguage('typescript', __webpack_require__(359));
hljs.registerLanguage('xml', __webpack_require__(360));
const Viewer_1 = __webpack_require__(94);
const Hi_1 = __webpack_require__(70);
const try_1 = __webpack_require__(59);
let Snippet = class Snippet extends React.Component {
    constructor() {
        super(...arguments);
        this.showAll = false;
    }
    render() {
        var _a, _b, _c, _d;
        const { ploc } = this.props;
        if (!ploc)
            return null;
        if (!ploc.region)
            return null;
        let term = this.context;
        let body = (0, try_1.tryOr)(() => {
            const { region, contextRegion } = ploc;
            if (!contextRegion)
                return undefined; // tryOr fallthrough.
            const crst = contextRegion.snippet.text;
            // Search/Filter highlighting is active so bypass snippet highlighting and return plain text.
            if (term)
                return crst;
            // Carriage returns (\n) causing hljs colorization off-by-one errors, thus stripping them here.
            let lines = crst.replace(/\r/g, '').split('\n');
            const minLeadingWhitespace = Math.min(...lines
                .filter(line => line.trimLeft().length) // Blank lines often have indent 0, so throwing these out.
                .map(line => line.match(/^ */)[0].length));
            lines = lines.map(line => line.slice(minLeadingWhitespace));
            // Per 3.30.2 SARIF line and columns are 1-based.
            let { startLine, startColumn = 1, endLine = startLine, endColumn = Number.MAX_SAFE_INTEGER } = region;
            // "3.30.5 startLine property - When a region object represents a text region specified by line/column properties, it SHALL contain .. startLine..."
            // If startLine is undefined, then it not line/column-specified and likely offset/length-specified. The later is not currently supported.
            if (startLine === undefined)
                return undefined; // tryOr fallthrough.
            // Convert region to 0-based for ease of calculations.
            startLine -= 1;
            startColumn -= 1;
            endLine -= 1;
            endColumn -= 1;
            // Same comments from above apply to the contextRegion.
            let { startLine: crStartLine = 1, startColumn: crStartColumn = 1 } = contextRegion;
            crStartLine -= 1;
            crStartColumn -= 1;
            // Map region from document coordinates to contextRegion coordinates.
            startLine -= crStartLine;
            startColumn = Math.max(0, startColumn - crStartColumn - minLeadingWhitespace);
            endLine -= crStartLine;
            endColumn = Math.max(0, endColumn - crStartColumn - minLeadingWhitespace);
            // Insert start stop markers.
            const marker = '\u200B';
            // Endline marker must be inserted first. Otherwise if startLine=endLine, the marker char will make the slice off by one.
            lines[endLine]
                = lines[endLine].slice(0, endColumn) + marker + lines[endLine].slice(endColumn);
            lines[startLine]
                = lines[startLine].slice(0, startColumn) + marker + lines[startLine].slice(startColumn);
            const [pre, hi, post] = lines.join('\n').split(marker);
            return React.createElement(React.Fragment, null,
                pre,
                React.createElement("span", { className: "swcRegion" }, hi),
                post);
        }, () => ploc.region.snippet.text);
        if (!body)
            return null; // May no longer be needed.
        if (term)
            body = React.createElement(Hi_1.Hi, null, body);
        const lineNumbersAndCode = React.createElement(React.Fragment, null,
            (0, try_1.tryOr)(() => {
                var _a;
                const region = ploc.contextRegion || ploc.region;
                if (!region.startLine)
                    return undefined; // Don't take up left margin space if there's nothing to show.
                const endLine = (_a = region.endLine) !== null && _a !== void 0 ? _a : region.startLine;
                let lineNos = '';
                for (let i = region.startLine; i <= endLine; i++) {
                    lineNos += `${i}\n`;
                }
                return React.createElement("code", { className: "lineNumber" }, lineNos);
            }),
            React.createElement("code", { className: `hljs flex-grow ${(_d = (_c = (_b = (_a = ploc.artifactLocation) === null || _a === void 0 ? void 0 : _a.uri) === null || _b === void 0 ? void 0 : _b.match(/\.(\w+)$/)) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : ''}`, style: {}, ref: code => {
                    if (!code)
                        return;
                    try {
                        hljs.highlightBlock(code);
                    }
                    catch (e) {
                        // Commonly throws if the language is not loaded. Will add telemetry here to track.
                        console.log(code, e);
                    }
                } }, body));
        // title={JSON.stringify(ploc, null, '  ')}
        return React.createElement(React.Fragment, null,
            React.createElement("pre", { className: "swcSnippet", style: Object.assign(Object.assign({}, this.props.style), { maxHeight: this.showAll ? undefined : 108 }), key: Date.now(), onClick: () => this.showAll = !this.showAll, ref: pre => {
                    if (!pre)
                        return;
                    const isClipped = pre.scrollHeight > pre.clientHeight;
                    if (isClipped)
                        pre.classList.add('clipped');
                    else
                        pre.classList.remove('clipped');
                } }, lineNumbersAndCode));
    }
};
Snippet.contextType = Viewer_1.FilterKeywordContext;
__decorate([
    mobx_1.observable
], Snippet.prototype, "showAll", void 0);
Snippet = __decorate([
    mobx_react_1.observer
], Snippet);
exports.Snippet = Snippet;
class SnippetTest extends React.Component {
    render() {
        return React.createElement("div", { style: { padding: 15 } },
            React.createElement(Snippet, null),
            React.createElement(Snippet, { ploc: {} }),
            React.createElement(Snippet, { ploc: {
                    artifactLocation: {
                        uri: "https://github.com/Microsoft/sarif-sdk/blob/jeff/src/Sarif/Baseline/ResultMatching/SarifLogMatcher.cs",
                        index: 30
                    },
                    region: {
                        startLine: 186,
                        endLine: 196,
                        snippet: {
                            text: "        private ReportingDescriptor GetRuleFromResources(Result result, IDictionary<string, ReportingDescriptor> rules)\r\n        {\r\n            if (!string.IsNullOrEmpty(result.RuleId))\r\n            {\r\n                if (rules.ContainsKey(result.RuleId))\r\n                {\r\n                    return rules[result.RuleId];\r\n                }\r\n            }\r\n            return null;\r\n        }"
                        }
                    },
                    contextRegion: {
                        startLine: 183,
                        endLine: 199,
                        snippet: {
                            text: "            return results;\n        }\n        \n        private ReportingDescriptor GetRuleFromResources(Result result, IDictionary<string, ReportingDescriptor> rules)\n        {\n            if (!string.IsNullOrEmpty(result.RuleId))\n            {\n                if (rules.ContainsKey(result.RuleId))\n                {\n                    return rules[result.RuleId];\n                }\n            }\n            return null;\n        }\n\n        private SarifLog ConstructSarifLogFromMatchedResults(\n            IEnumerable<MatchedResults> results, \n"
                        }
                    }
                } }),
            React.createElement(Snippet, { ploc: {
                    artifactLocation: { uri: 'folder/file.txt' },
                    region: {
                        snippet: { text: 'Basic.' },
                    },
                } }),
            React.createElement(Snippet, { ploc: {
                    artifactLocation: { uri: 'folder/file.txt' },
                    region: {
                        snippet: { text: 'Content region.' },
                        charOffset: 13 // charOffset currently ignored by snippet rendering.
                    },
                    contextRegion: {
                        snippet: { text: 'Surrounding. Content region. Surrounding. Currently not rendered if no startLine.' },
                    }
                } }),
            React.createElement(Snippet, { ploc: {
                    artifactLocation: {
                        uri: "https://github.com/Microsoft/sarif-sdk/blob/jeff/src/Sarif.UnitTests/FileRegionsCacheTests.cs",
                        index: 15,
                    },
                    region: {
                        startLine: 107,
                        endLine: 107,
                    },
                    contextRegion: {
                        startLine: 106,
                        startColumn: 1,
                        endLine: 108,
                        endColumn: 91,
                        charOffset: 5693,
                        charLength: 157,
                        snippet: {
                            text: "\r\n        private readonly static Region s_Interior_Characters = \r\n            new Region() { Snippet = new ArtifactContent() { Text = INTERIOR_CHARACTERS },"
                        },
                    },
                } }),
            React.createElement(Snippet, { ploc: {
                    artifactLocation: {
                        uri: "https://github.com/Microsoft/sarif-sdk/blob/jeff/src/Sarif/Visitors/SarifCurrentToVersionOneVisitor.cs",
                        index: 0,
                    },
                    region: {
                        startLine: 780,
                        endLine: 780,
                        snippet: {
                            text: "                    (result.Fixes as List<FixVersionOne>).RemoveAll(f => f == null);"
                        },
                    },
                    contextRegion: {
                        startLine: 777,
                        endLine: 783,
                        snippet: {
                            text: "                if (result.Fixes != null)\n                {\n                    // Null Fixes will be present in the case of unsupported encoding\n                    (result.Fixes as List<FixVersionOne>).RemoveAll(f => f == null);\n\n                    if (result.Fixes.Count == 0)\n                    {\n"
                        },
                    }
                } }),
            React.createElement(Snippet, { ploc: {
                    artifactLocation: { uri: 'folder/file1.txt' },
                    region: {
                        snippet: { text: 'Line 1\nLine 2\nLine 3\nLine 4\nLine 5\nLine 6\nLine 7 (Last line before fold) \nLine 8\nLine 9\nLine 10' },
                    },
                } }),
            React.createElement(Snippet, { ploc: {
                    artifactLocation: { uri: 'folder/file1.txt' },
                    contextRegion: {
                        snippet: { text: '    Normalize indent: Typical\n    All lines have a least a 4 space indent\n\n    Except for empty lines (like above)\n    highlighted\n        Some lines have 8 spaces' },
                    },
                    region: {
                        startLine: 4,
                        startColumn: 5,
                        snippet: {
                            text: 'highlighted'
                        },
                    },
                } }),
            React.createElement(Snippet, { ploc: {
                    artifactLocation: { uri: 'folder/file1.txt' },
                    region: {
                        snippet: { text: '    Normalize indent: Currently does not apply if no context region (but maybe it should)' },
                    },
                } }),
            React.createElement(Snippet, { ploc: {
                    artifactLocation: {
                        uri: "https://github.com/Microsoft/sarif-sdk/blob/jeff/src/Sarif/Visitors/SarifCurrentToVersionOneVisitor.cs",
                        index: 0,
                    },
                    contextRegion: {
                        startLine: 100,
                        startColumn: 1,
                        snippet: {
                            text: "aaabbbaaa"
                        },
                    },
                    region: {
                        startLine: 100,
                        startColumn: 4,
                        endColumn: 7,
                        snippet: {
                            text: "bbb"
                        },
                    },
                } }),
            React.createElement(Snippet, { ploc: {
                    "artifactLocation": {
                        "uri": "https://dev.azure.com/org/_workitems/edit/12345"
                    },
                    "region": {
                        "startLine": 122,
                        "startColumn": 875,
                        "endLine": 122,
                        "endColumn": 895,
                        "charOffset": 9478,
                        "charLength": 20,
                        "snippet": {
                            "text": "789</span></div><div"
                        }
                    },
                    "contextRegion": {
                        "startLine": 122,
                        "startColumn": 747,
                        "endLine": 122,
                        "endColumn": 1023,
                        "charOffset": 9350,
                        "charLength": 276,
                        "snippet": {
                            "text": "le=\\\"box-sizing:border-box;\\\"><span style=\\\"box-sizing:border-box;\\\">1. Sign into Houston POS with username 123456 and password 789</span></div><div style=\\\"box-sizing:border-box;\\\"><span style=\\\"box-sizing:border-box;\\\">2. Do an exchange for item 0001</span></div><div style="
                        }
                    }
                } }));
    }
}
exports.SnippetTest = SnippetTest;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(353);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".swcSnippet{margin:4px 0;padding-right:4px;font-size:12px;overflow:hidden;position:relative;display:flex}.swcSnippet code{font-family:SFMono-Regular, monospace}.swcSnippet.clipped::before{content:\"\";width:100%;height:108px;position:absolute;left:0;top:0;background:linear-gradient(transparent 75px, var(--palette-black-alpha-6))}.swcSnippet .swcRegion{background-color:rgba(255,230,0,0.5)}code.lineNumber{width:36px;color:#999;flex:0 0 auto}.swcSnippet .hljs{color:inherit;display:initial;overflow-x:initial;padding:initial;background:initial}\n", ""]);



/***/ }),
/* 354 */
/***/ (function(module, exports) {

function deepFreeze(obj) {
    if (obj instanceof Map) {
        obj.clear = obj.delete = obj.set = function () {
            throw new Error('map is read-only');
        };
    } else if (obj instanceof Set) {
        obj.add = obj.clear = obj.delete = function () {
            throw new Error('set is read-only');
        };
    }

    // Freeze self
    Object.freeze(obj);

    Object.getOwnPropertyNames(obj).forEach(function (name) {
        var prop = obj[name];

        // Freeze prop if it is an object
        if (typeof prop == 'object' && !Object.isFrozen(prop)) {
            deepFreeze(prop);
        }
    });

    return obj;
}

var deepFreezeEs6 = deepFreeze;
var _default = deepFreeze;
deepFreezeEs6.default = _default;

/** @implements CallbackResponse */
class Response {
  /**
   * @param {CompiledMode} mode
   */
  constructor(mode) {
    // eslint-disable-next-line no-undefined
    if (mode.data === undefined) mode.data = {};

    this.data = mode.data;
    this.isMatchIgnored = false;
  }

  ignoreMatch() {
    this.isMatchIgnored = true;
  }
}

/**
 * @param {string} value
 * @returns {string}
 */
function escapeHTML(value) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;');
}

/**
 * performs a shallow merge of multiple objects into one
 *
 * @template T
 * @param {T} original
 * @param {Record<string,any>[]} objects
 * @returns {T} a single new object
 */
function inherit(original, ...objects) {
  /** @type Record<string,any> */
  const result = Object.create(null);

  for (const key in original) {
    result[key] = original[key];
  }
  objects.forEach(function(obj) {
    for (const key in obj) {
      result[key] = obj[key];
    }
  });
  return /** @type {T} */ (result);
}

/**
 * @typedef {object} Renderer
 * @property {(text: string) => void} addText
 * @property {(node: Node) => void} openNode
 * @property {(node: Node) => void} closeNode
 * @property {() => string} value
 */

/** @typedef {{kind?: string, sublanguage?: boolean}} Node */
/** @typedef {{walk: (r: Renderer) => void}} Tree */
/** */

const SPAN_CLOSE = '</span>';

/**
 * Determines if a node needs to be wrapped in <span>
 *
 * @param {Node} node */
const emitsWrappingTags = (node) => {
  return !!node.kind;
};

/** @type {Renderer} */
class HTMLRenderer {
  /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */
  constructor(parseTree, options) {
    this.buffer = "";
    this.classPrefix = options.classPrefix;
    parseTree.walk(this);
  }

  /**
   * Adds texts to the output stream
   *
   * @param {string} text */
  addText(text) {
    this.buffer += escapeHTML(text);
  }

  /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */
  openNode(node) {
    if (!emitsWrappingTags(node)) return;

    let className = node.kind;
    if (!node.sublanguage) {
      className = `${this.classPrefix}${className}`;
    }
    this.span(className);
  }

  /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */
  closeNode(node) {
    if (!emitsWrappingTags(node)) return;

    this.buffer += SPAN_CLOSE;
  }

  /**
   * returns the accumulated buffer
  */
  value() {
    return this.buffer;
  }

  // helpers

  /**
   * Builds a span element
   *
   * @param {string} className */
  span(className) {
    this.buffer += `<span class="${className}">`;
  }
}

/** @typedef {{kind?: string, sublanguage?: boolean, children: Node[]} | string} Node */
/** @typedef {{kind?: string, sublanguage?: boolean, children: Node[]} } DataNode */
/**  */

class TokenTree {
  constructor() {
    /** @type DataNode */
    this.rootNode = { children: [] };
    this.stack = [this.rootNode];
  }

  get top() {
    return this.stack[this.stack.length - 1];
  }

  get root() { return this.rootNode; }

  /** @param {Node} node */
  add(node) {
    this.top.children.push(node);
  }

  /** @param {string} kind */
  openNode(kind) {
    /** @type Node */
    const node = { kind, children: [] };
    this.add(node);
    this.stack.push(node);
  }

  closeNode() {
    if (this.stack.length > 1) {
      return this.stack.pop();
    }
    // eslint-disable-next-line no-undefined
    return undefined;
  }

  closeAllNodes() {
    while (this.closeNode());
  }

  toJSON() {
    return JSON.stringify(this.rootNode, null, 4);
  }

  /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */
  walk(builder) {
    // this does not
    return this.constructor._walk(builder, this.rootNode);
    // this works
    // return TokenTree._walk(builder, this.rootNode);
  }

  /**
   * @param {Renderer} builder
   * @param {Node} node
   */
  static _walk(builder, node) {
    if (typeof node === "string") {
      builder.addText(node);
    } else if (node.children) {
      builder.openNode(node);
      node.children.forEach((child) => this._walk(builder, child));
      builder.closeNode(node);
    }
    return builder;
  }

  /**
   * @param {Node} node
   */
  static _collapse(node) {
    if (typeof node === "string") return;
    if (!node.children) return;

    if (node.children.every(el => typeof el === "string")) {
      // node.text = node.children.join("");
      // delete node.children;
      node.children = [node.children.join("")];
    } else {
      node.children.forEach((child) => {
        TokenTree._collapse(child);
      });
    }
  }
}

/**
  Currently this is all private API, but this is the minimal API necessary
  that an Emitter must implement to fully support the parser.

  Minimal interface:

  - addKeyword(text, kind)
  - addText(text)
  - addSublanguage(emitter, subLanguageName)
  - finalize()
  - openNode(kind)
  - closeNode()
  - closeAllNodes()
  - toHTML()

*/

/**
 * @implements {Emitter}
 */
class TokenTreeEmitter extends TokenTree {
  /**
   * @param {*} options
   */
  constructor(options) {
    super();
    this.options = options;
  }

  /**
   * @param {string} text
   * @param {string} kind
   */
  addKeyword(text, kind) {
    if (text === "") { return; }

    this.openNode(kind);
    this.addText(text);
    this.closeNode();
  }

  /**
   * @param {string} text
   */
  addText(text) {
    if (text === "") { return; }

    this.add(text);
  }

  /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */
  addSublanguage(emitter, name) {
    /** @type DataNode */
    const node = emitter.root;
    node.kind = name;
    node.sublanguage = true;
    this.add(node);
  }

  toHTML() {
    const renderer = new HTMLRenderer(this, this.options);
    return renderer.value();
  }

  finalize() {
    return true;
  }
}

/**
 * @param {string} value
 * @returns {RegExp}
 * */
function escape(value) {
  return new RegExp(value.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'm');
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;

  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat(...args) {
  const joined = args.map((x) => source(x)).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either(...args) {
  const joined = '(' + args.map((x) => source(x)).join("|") + ")";
  return joined;
}

/**
 * @param {RegExp} re
 * @returns {number}
 */
function countMatchGroups(re) {
  return (new RegExp(re.toString() + '|')).exec('').length - 1;
}

/**
 * Does lexeme start with a regular expression match at the beginning
 * @param {RegExp} re
 * @param {string} lexeme
 */
function startsWith(re, lexeme) {
  const match = re && re.exec(lexeme);
  return match && match.index === 0;
}

// BACKREF_RE matches an open parenthesis or backreference. To avoid
// an incorrect parse, it additionally matches the following:
// - [...] elements, where the meaning of parentheses and escapes change
// - other escape sequences, so we do not misparse escape sequences as
//   interesting elements
// - non-matching or lookahead parentheses, which do not capture. These
//   follow the '(' with a '?'.
const BACKREF_RE = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;

// join logically computes regexps.join(separator), but fixes the
// backreferences so they continue to match.
// it also places each individual regular expression into it's own
// match group, keeping track of the sequencing of those match groups
// is currently an exercise for the caller. :-)
/**
 * @param {(string | RegExp)[]} regexps
 * @param {string} separator
 * @returns {string}
 */
function join(regexps, separator = "|") {
  let numCaptures = 0;

  return regexps.map((regex) => {
    numCaptures += 1;
    const offset = numCaptures;
    let re = source(regex);
    let out = '';

    while (re.length > 0) {
      const match = BACKREF_RE.exec(re);
      if (!match) {
        out += re;
        break;
      }
      out += re.substring(0, match.index);
      re = re.substring(match.index + match[0].length);
      if (match[0][0] === '\\' && match[1]) {
        // Adjust the backreference.
        out += '\\' + String(Number(match[1]) + offset);
      } else {
        out += match[0];
        if (match[0] === '(') {
          numCaptures++;
        }
      }
    }
    return out;
  }).map(re => `(${re})`).join(separator);
}

// Common regexps
const MATCH_NOTHING_RE = /\b\B/;
const IDENT_RE = '[a-zA-Z]\\w*';
const UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
const NUMBER_RE = '\\b\\d+(\\.\\d+)?';
const C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
const BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
const RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';

/**
* @param { Partial<Mode> & {binary?: string | RegExp} } opts
*/
const SHEBANG = (opts = {}) => {
  const beginShebang = /^#![ ]*\//;
  if (opts.binary) {
    opts.begin = concat(
      beginShebang,
      /.*\b/,
      opts.binary,
      /\b.*/);
  }
  return inherit({
    className: 'meta',
    begin: beginShebang,
    end: /$/,
    relevance: 0,
    /** @type {ModeCallback} */
    "on:begin": (m, resp) => {
      if (m.index !== 0) resp.ignoreMatch();
    }
  }, opts);
};

// Common modes
const BACKSLASH_ESCAPE = {
  begin: '\\\\[\\s\\S]', relevance: 0
};
const APOS_STRING_MODE = {
  className: 'string',
  begin: '\'',
  end: '\'',
  illegal: '\\n',
  contains: [BACKSLASH_ESCAPE]
};
const QUOTE_STRING_MODE = {
  className: 'string',
  begin: '"',
  end: '"',
  illegal: '\\n',
  contains: [BACKSLASH_ESCAPE]
};
const PHRASAL_WORDS_MODE = {
  begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
};
/**
 * Creates a comment mode
 *
 * @param {string | RegExp} begin
 * @param {string | RegExp} end
 * @param {Mode | {}} [modeOptions]
 * @returns {Partial<Mode>}
 */
const COMMENT = function(begin, end, modeOptions = {}) {
  const mode = inherit(
    {
      className: 'comment',
      begin,
      end,
      contains: []
    },
    modeOptions
  );
  mode.contains.push(PHRASAL_WORDS_MODE);
  mode.contains.push({
    className: 'doctag',
    begin: '(?:TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):',
    relevance: 0
  });
  return mode;
};
const C_LINE_COMMENT_MODE = COMMENT('//', '$');
const C_BLOCK_COMMENT_MODE = COMMENT('/\\*', '\\*/');
const HASH_COMMENT_MODE = COMMENT('#', '$');
const NUMBER_MODE = {
  className: 'number',
  begin: NUMBER_RE,
  relevance: 0
};
const C_NUMBER_MODE = {
  className: 'number',
  begin: C_NUMBER_RE,
  relevance: 0
};
const BINARY_NUMBER_MODE = {
  className: 'number',
  begin: BINARY_NUMBER_RE,
  relevance: 0
};
const CSS_NUMBER_MODE = {
  className: 'number',
  begin: NUMBER_RE + '(' +
    '%|em|ex|ch|rem' +
    '|vw|vh|vmin|vmax' +
    '|cm|mm|in|pt|pc|px' +
    '|deg|grad|rad|turn' +
    '|s|ms' +
    '|Hz|kHz' +
    '|dpi|dpcm|dppx' +
    ')?',
  relevance: 0
};
const REGEXP_MODE = {
  // this outer rule makes sure we actually have a WHOLE regex and not simply
  // an expression such as:
  //
  //     3 / something
  //
  // (which will then blow up when regex's `illegal` sees the newline)
  begin: /(?=\/[^/\n]*\/)/,
  contains: [{
    className: 'regexp',
    begin: /\//,
    end: /\/[gimuy]*/,
    illegal: /\n/,
    contains: [
      BACKSLASH_ESCAPE,
      {
        begin: /\[/,
        end: /\]/,
        relevance: 0,
        contains: [BACKSLASH_ESCAPE]
      }
    ]
  }]
};
const TITLE_MODE = {
  className: 'title',
  begin: IDENT_RE,
  relevance: 0
};
const UNDERSCORE_TITLE_MODE = {
  className: 'title',
  begin: UNDERSCORE_IDENT_RE,
  relevance: 0
};
const METHOD_GUARD = {
  // excludes method names from keyword processing
  begin: '\\.\\s*' + UNDERSCORE_IDENT_RE,
  relevance: 0
};

/**
 * Adds end same as begin mechanics to a mode
 *
 * Your mode must include at least a single () match group as that first match
 * group is what is used for comparison
 * @param {Partial<Mode>} mode
 */
const END_SAME_AS_BEGIN = function(mode) {
  return Object.assign(mode,
    {
      /** @type {ModeCallback} */
      'on:begin': (m, resp) => { resp.data._beginMatch = m[1]; },
      /** @type {ModeCallback} */
      'on:end': (m, resp) => { if (resp.data._beginMatch !== m[1]) resp.ignoreMatch(); }
    });
};

var MODES = /*#__PURE__*/Object.freeze({
    __proto__: null,
    MATCH_NOTHING_RE: MATCH_NOTHING_RE,
    IDENT_RE: IDENT_RE,
    UNDERSCORE_IDENT_RE: UNDERSCORE_IDENT_RE,
    NUMBER_RE: NUMBER_RE,
    C_NUMBER_RE: C_NUMBER_RE,
    BINARY_NUMBER_RE: BINARY_NUMBER_RE,
    RE_STARTERS_RE: RE_STARTERS_RE,
    SHEBANG: SHEBANG,
    BACKSLASH_ESCAPE: BACKSLASH_ESCAPE,
    APOS_STRING_MODE: APOS_STRING_MODE,
    QUOTE_STRING_MODE: QUOTE_STRING_MODE,
    PHRASAL_WORDS_MODE: PHRASAL_WORDS_MODE,
    COMMENT: COMMENT,
    C_LINE_COMMENT_MODE: C_LINE_COMMENT_MODE,
    C_BLOCK_COMMENT_MODE: C_BLOCK_COMMENT_MODE,
    HASH_COMMENT_MODE: HASH_COMMENT_MODE,
    NUMBER_MODE: NUMBER_MODE,
    C_NUMBER_MODE: C_NUMBER_MODE,
    BINARY_NUMBER_MODE: BINARY_NUMBER_MODE,
    CSS_NUMBER_MODE: CSS_NUMBER_MODE,
    REGEXP_MODE: REGEXP_MODE,
    TITLE_MODE: TITLE_MODE,
    UNDERSCORE_TITLE_MODE: UNDERSCORE_TITLE_MODE,
    METHOD_GUARD: METHOD_GUARD,
    END_SAME_AS_BEGIN: END_SAME_AS_BEGIN
});

// Grammar extensions / plugins
// See: https://github.com/highlightjs/highlight.js/issues/2833

// Grammar extensions allow "syntactic sugar" to be added to the grammar modes
// without requiring any underlying changes to the compiler internals.

// `compileMatch` being the perfect small example of now allowing a grammar
// author to write `match` when they desire to match a single expression rather
// than being forced to use `begin`.  The extension then just moves `match` into
// `begin` when it runs.  Ie, no features have been added, but we've just made
// the experience of writing (and reading grammars) a little bit nicer.

// ------

// TODO: We need negative look-behind support to do this properly
/**
 * Skip a match if it has a preceding dot
 *
 * This is used for `beginKeywords` to prevent matching expressions such as
 * `bob.keyword.do()`. The mode compiler automatically wires this up as a
 * special _internal_ 'on:begin' callback for modes with `beginKeywords`
 * @param {RegExpMatchArray} match
 * @param {CallbackResponse} response
 */
function skipIfhasPrecedingDot(match, response) {
  const before = match.input[match.index - 1];
  if (before === ".") {
    response.ignoreMatch();
  }
}


/**
 * `beginKeywords` syntactic sugar
 * @type {CompilerExt}
 */
function beginKeywords(mode, parent) {
  if (!parent) return;
  if (!mode.beginKeywords) return;

  // for languages with keywords that include non-word characters checking for
  // a word boundary is not sufficient, so instead we check for a word boundary
  // or whitespace - this does no harm in any case since our keyword engine
  // doesn't allow spaces in keywords anyways and we still check for the boundary
  // first
  mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')(?!\\.)(?=\\b|\\s)';
  mode.__beforeBegin = skipIfhasPrecedingDot;
  mode.keywords = mode.keywords || mode.beginKeywords;
  delete mode.beginKeywords;

  // prevents double relevance, the keywords themselves provide
  // relevance, the mode doesn't need to double it
  // eslint-disable-next-line no-undefined
  if (mode.relevance === undefined) mode.relevance = 0;
}

/**
 * Allow `illegal` to contain an array of illegal values
 * @type {CompilerExt}
 */
function compileIllegal(mode, _parent) {
  if (!Array.isArray(mode.illegal)) return;

  mode.illegal = either(...mode.illegal);
}

/**
 * `match` to match a single expression for readability
 * @type {CompilerExt}
 */
function compileMatch(mode, _parent) {
  if (!mode.match) return;
  if (mode.begin || mode.end) throw new Error("begin & end are not supported with match");

  mode.begin = mode.match;
  delete mode.match;
}

/**
 * provides the default 1 relevance to all modes
 * @type {CompilerExt}
 */
function compileRelevance(mode, _parent) {
  // eslint-disable-next-line no-undefined
  if (mode.relevance === undefined) mode.relevance = 1;
}

// keywords that should have no default relevance value
const COMMON_KEYWORDS = [
  'of',
  'and',
  'for',
  'in',
  'not',
  'or',
  'if',
  'then',
  'parent', // common variable name
  'list', // common variable name
  'value' // common variable name
];

const DEFAULT_KEYWORD_CLASSNAME = "keyword";

/**
 * Given raw keywords from a language definition, compile them.
 *
 * @param {string | Record<string,string|string[]> | Array<string>} rawKeywords
 * @param {boolean} caseInsensitive
 */
function compileKeywords(rawKeywords, caseInsensitive, className = DEFAULT_KEYWORD_CLASSNAME) {
  /** @type KeywordDict */
  const compiledKeywords = {};

  // input can be a string of keywords, an array of keywords, or a object with
  // named keys representing className (which can then point to a string or array)
  if (typeof rawKeywords === 'string') {
    compileList(className, rawKeywords.split(" "));
  } else if (Array.isArray(rawKeywords)) {
    compileList(className, rawKeywords);
  } else {
    Object.keys(rawKeywords).forEach(function(className) {
      // collapse all our objects back into the parent object
      Object.assign(
        compiledKeywords,
        compileKeywords(rawKeywords[className], caseInsensitive, className)
      );
    });
  }
  return compiledKeywords;

  // ---

  /**
   * Compiles an individual list of keywords
   *
   * Ex: "for if when while|5"
   *
   * @param {string} className
   * @param {Array<string>} keywordList
   */
  function compileList(className, keywordList) {
    if (caseInsensitive) {
      keywordList = keywordList.map(x => x.toLowerCase());
    }
    keywordList.forEach(function(keyword) {
      const pair = keyword.split('|');
      compiledKeywords[pair[0]] = [className, scoreForKeyword(pair[0], pair[1])];
    });
  }
}

/**
 * Returns the proper score for a given keyword
 *
 * Also takes into account comment keywords, which will be scored 0 UNLESS
 * another score has been manually assigned.
 * @param {string} keyword
 * @param {string} [providedScore]
 */
function scoreForKeyword(keyword, providedScore) {
  // manual scores always win over common keywords
  // so you can force a score of 1 if you really insist
  if (providedScore) {
    return Number(providedScore);
  }

  return commonKeyword(keyword) ? 0 : 1;
}

/**
 * Determines if a given keyword is common or not
 *
 * @param {string} keyword */
function commonKeyword(keyword) {
  return COMMON_KEYWORDS.includes(keyword.toLowerCase());
}

// compilation

/**
 * Compiles a language definition result
 *
 * Given the raw result of a language definition (Language), compiles this so
 * that it is ready for highlighting code.
 * @param {Language} language
 * @param {{plugins: HLJSPlugin[]}} opts
 * @returns {CompiledLanguage}
 */
function compileLanguage(language, { plugins }) {
  /**
   * Builds a regex with the case sensativility of the current language
   *
   * @param {RegExp | string} value
   * @param {boolean} [global]
   */
  function langRe(value, global) {
    return new RegExp(
      source(value),
      'm' + (language.case_insensitive ? 'i' : '') + (global ? 'g' : '')
    );
  }

  /**
    Stores multiple regular expressions and allows you to quickly search for
    them all in a string simultaneously - returning the first match.  It does
    this by creating a huge (a|b|c) regex - each individual item wrapped with ()
    and joined by `|` - using match groups to track position.  When a match is
    found checking which position in the array has content allows us to figure
    out which of the original regexes / match groups triggered the match.

    The match object itself (the result of `Regex.exec`) is returned but also
    enhanced by merging in any meta-data that was registered with the regex.
    This is how we keep track of which mode matched, and what type of rule
    (`illegal`, `begin`, end, etc).
  */
  class MultiRegex {
    constructor() {
      this.matchIndexes = {};
      // @ts-ignore
      this.regexes = [];
      this.matchAt = 1;
      this.position = 0;
    }

    // @ts-ignore
    addRule(re, opts) {
      opts.position = this.position++;
      // @ts-ignore
      this.matchIndexes[this.matchAt] = opts;
      this.regexes.push([opts, re]);
      this.matchAt += countMatchGroups(re) + 1;
    }

    compile() {
      if (this.regexes.length === 0) {
        // avoids the need to check length every time exec is called
        // @ts-ignore
        this.exec = () => null;
      }
      const terminators = this.regexes.map(el => el[1]);
      this.matcherRe = langRe(join(terminators), true);
      this.lastIndex = 0;
    }

    /** @param {string} s */
    exec(s) {
      this.matcherRe.lastIndex = this.lastIndex;
      const match = this.matcherRe.exec(s);
      if (!match) { return null; }

      // eslint-disable-next-line no-undefined
      const i = match.findIndex((el, i) => i > 0 && el !== undefined);
      // @ts-ignore
      const matchData = this.matchIndexes[i];
      // trim off any earlier non-relevant match groups (ie, the other regex
      // match groups that make up the multi-matcher)
      match.splice(0, i);

      return Object.assign(match, matchData);
    }
  }

  /*
    Created to solve the key deficiently with MultiRegex - there is no way to
    test for multiple matches at a single location.  Why would we need to do
    that?  In the future a more dynamic engine will allow certain matches to be
    ignored.  An example: if we matched say the 3rd regex in a large group but
    decided to ignore it - we'd need to started testing again at the 4th
    regex... but MultiRegex itself gives us no real way to do that.

    So what this class creates MultiRegexs on the fly for whatever search
    position they are needed.

    NOTE: These additional MultiRegex objects are created dynamically.  For most
    grammars most of the time we will never actually need anything more than the
    first MultiRegex - so this shouldn't have too much overhead.

    Say this is our search group, and we match regex3, but wish to ignore it.

      regex1 | regex2 | regex3 | regex4 | regex5    ' ie, startAt = 0

    What we need is a new MultiRegex that only includes the remaining
    possibilities:

      regex4 | regex5                               ' ie, startAt = 3

    This class wraps all that complexity up in a simple API... `startAt` decides
    where in the array of expressions to start doing the matching. It
    auto-increments, so if a match is found at position 2, then startAt will be
    set to 3.  If the end is reached startAt will return to 0.

    MOST of the time the parser will be setting startAt manually to 0.
  */
  class ResumableMultiRegex {
    constructor() {
      // @ts-ignore
      this.rules = [];
      // @ts-ignore
      this.multiRegexes = [];
      this.count = 0;

      this.lastIndex = 0;
      this.regexIndex = 0;
    }

    // @ts-ignore
    getMatcher(index) {
      if (this.multiRegexes[index]) return this.multiRegexes[index];

      const matcher = new MultiRegex();
      this.rules.slice(index).forEach(([re, opts]) => matcher.addRule(re, opts));
      matcher.compile();
      this.multiRegexes[index] = matcher;
      return matcher;
    }

    resumingScanAtSamePosition() {
      return this.regexIndex !== 0;
    }

    considerAll() {
      this.regexIndex = 0;
    }

    // @ts-ignore
    addRule(re, opts) {
      this.rules.push([re, opts]);
      if (opts.type === "begin") this.count++;
    }

    /** @param {string} s */
    exec(s) {
      const m = this.getMatcher(this.regexIndex);
      m.lastIndex = this.lastIndex;
      let result = m.exec(s);

      // The following is because we have no easy way to say "resume scanning at the
      // existing position but also skip the current rule ONLY". What happens is
      // all prior rules are also skipped which can result in matching the wrong
      // thing. Example of matching "booger":

      // our matcher is [string, "booger", number]
      //
      // ....booger....

      // if "booger" is ignored then we'd really need a regex to scan from the
      // SAME position for only: [string, number] but ignoring "booger" (if it
      // was the first match), a simple resume would scan ahead who knows how
      // far looking only for "number", ignoring potential string matches (or
      // future "booger" matches that might be valid.)

      // So what we do: We execute two matchers, one resuming at the same
      // position, but the second full matcher starting at the position after:

      //     /--- resume first regex match here (for [number])
      //     |/---- full match here for [string, "booger", number]
      //     vv
      // ....booger....

      // Which ever results in a match first is then used. So this 3-4 step
      // process essentially allows us to say "match at this position, excluding
      // a prior rule that was ignored".
      //
      // 1. Match "booger" first, ignore. Also proves that [string] does non match.
      // 2. Resume matching for [number]
      // 3. Match at index + 1 for [string, "booger", number]
      // 4. If #2 and #3 result in matches, which came first?
      if (this.resumingScanAtSamePosition()) {
        if (result && result.index === this.lastIndex) ; else { // use the second matcher result
          const m2 = this.getMatcher(0);
          m2.lastIndex = this.lastIndex + 1;
          result = m2.exec(s);
        }
      }

      if (result) {
        this.regexIndex += result.position + 1;
        if (this.regexIndex === this.count) {
          // wrap-around to considering all matches again
          this.considerAll();
        }
      }

      return result;
    }
  }

  /**
   * Given a mode, builds a huge ResumableMultiRegex that can be used to walk
   * the content and find matches.
   *
   * @param {CompiledMode} mode
   * @returns {ResumableMultiRegex}
   */
  function buildModeRegex(mode) {
    const mm = new ResumableMultiRegex();

    mode.contains.forEach(term => mm.addRule(term.begin, { rule: term, type: "begin" }));

    if (mode.terminatorEnd) {
      mm.addRule(mode.terminatorEnd, { type: "end" });
    }
    if (mode.illegal) {
      mm.addRule(mode.illegal, { type: "illegal" });
    }

    return mm;
  }

  /** skip vs abort vs ignore
   *
   * @skip   - The mode is still entered and exited normally (and contains rules apply),
   *           but all content is held and added to the parent buffer rather than being
   *           output when the mode ends.  Mostly used with `sublanguage` to build up
   *           a single large buffer than can be parsed by sublanguage.
   *
   *             - The mode begin ands ends normally.
   *             - Content matched is added to the parent mode buffer.
   *             - The parser cursor is moved forward normally.
   *
   * @abort  - A hack placeholder until we have ignore.  Aborts the mode (as if it
   *           never matched) but DOES NOT continue to match subsequent `contains`
   *           modes.  Abort is bad/suboptimal because it can result in modes
   *           farther down not getting applied because an earlier rule eats the
   *           content but then aborts.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is added to the mode buffer.
   *             - The parser cursor is moved forward accordingly.
   *
   * @ignore - Ignores the mode (as if it never matched) and continues to match any
   *           subsequent `contains` modes.  Ignore isn't technically possible with
   *           the current parser implementation.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is ignored.
   *             - The parser cursor is not moved forward.
   */

  /**
   * Compiles an individual mode
   *
   * This can raise an error if the mode contains certain detectable known logic
   * issues.
   * @param {Mode} mode
   * @param {CompiledMode | null} [parent]
   * @returns {CompiledMode | never}
   */
  function compileMode(mode, parent) {
    const cmode = /** @type CompiledMode */ (mode);
    if (mode.isCompiled) return cmode;

    [
      // do this early so compiler extensions generally don't have to worry about
      // the distinction between match/begin
      compileMatch
    ].forEach(ext => ext(mode, parent));

    language.compilerExtensions.forEach(ext => ext(mode, parent));

    // __beforeBegin is considered private API, internal use only
    mode.__beforeBegin = null;

    [
      beginKeywords,
      // do this later so compiler extensions that come earlier have access to the
      // raw array if they wanted to perhaps manipulate it, etc.
      compileIllegal,
      // default to 1 relevance if not specified
      compileRelevance
    ].forEach(ext => ext(mode, parent));

    mode.isCompiled = true;

    let keywordPattern = null;
    if (typeof mode.keywords === "object") {
      keywordPattern = mode.keywords.$pattern;
      delete mode.keywords.$pattern;
    }

    if (mode.keywords) {
      mode.keywords = compileKeywords(mode.keywords, language.case_insensitive);
    }

    // both are not allowed
    if (mode.lexemes && keywordPattern) {
      throw new Error("ERR: Prefer `keywords.$pattern` to `mode.lexemes`, BOTH are not allowed. (see mode reference) ");
    }

    // `mode.lexemes` was the old standard before we added and now recommend
    // using `keywords.$pattern` to pass the keyword pattern
    keywordPattern = keywordPattern || mode.lexemes || /\w+/;
    cmode.keywordPatternRe = langRe(keywordPattern, true);

    if (parent) {
      if (!mode.begin) mode.begin = /\B|\b/;
      cmode.beginRe = langRe(mode.begin);
      if (mode.endSameAsBegin) mode.end = mode.begin;
      if (!mode.end && !mode.endsWithParent) mode.end = /\B|\b/;
      if (mode.end) cmode.endRe = langRe(mode.end);
      cmode.terminatorEnd = source(mode.end) || '';
      if (mode.endsWithParent && parent.terminatorEnd) {
        cmode.terminatorEnd += (mode.end ? '|' : '') + parent.terminatorEnd;
      }
    }
    if (mode.illegal) cmode.illegalRe = langRe(/** @type {RegExp | string} */ (mode.illegal));
    if (!mode.contains) mode.contains = [];

    mode.contains = [].concat(...mode.contains.map(function(c) {
      return expandOrCloneMode(c === 'self' ? mode : c);
    }));
    mode.contains.forEach(function(c) { compileMode(/** @type Mode */ (c), cmode); });

    if (mode.starts) {
      compileMode(mode.starts, parent);
    }

    cmode.matcher = buildModeRegex(cmode);
    return cmode;
  }

  if (!language.compilerExtensions) language.compilerExtensions = [];

  // self is not valid at the top-level
  if (language.contains && language.contains.includes('self')) {
    throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
  }

  // we need a null object, which inherit will guarantee
  language.classNameAliases = inherit(language.classNameAliases || {});

  return compileMode(/** @type Mode */ (language));
}

/**
 * Determines if a mode has a dependency on it's parent or not
 *
 * If a mode does have a parent dependency then often we need to clone it if
 * it's used in multiple places so that each copy points to the correct parent,
 * where-as modes without a parent can often safely be re-used at the bottom of
 * a mode chain.
 *
 * @param {Mode | null} mode
 * @returns {boolean} - is there a dependency on the parent?
 * */
function dependencyOnParent(mode) {
  if (!mode) return false;

  return mode.endsWithParent || dependencyOnParent(mode.starts);
}

/**
 * Expands a mode or clones it if necessary
 *
 * This is necessary for modes with parental dependenceis (see notes on
 * `dependencyOnParent`) and for nodes that have `variants` - which must then be
 * exploded into their own individual modes at compile time.
 *
 * @param {Mode} mode
 * @returns {Mode | Mode[]}
 * */
function expandOrCloneMode(mode) {
  if (mode.variants && !mode.cachedVariants) {
    mode.cachedVariants = mode.variants.map(function(variant) {
      return inherit(mode, { variants: null }, variant);
    });
  }

  // EXPAND
  // if we have variants then essentially "replace" the mode with the variants
  // this happens in compileMode, where this function is called from
  if (mode.cachedVariants) {
    return mode.cachedVariants;
  }

  // CLONE
  // if we have dependencies on parents then we need a unique
  // instance of ourselves, so we can be reused with many
  // different parents without issue
  if (dependencyOnParent(mode)) {
    return inherit(mode, { starts: mode.starts ? inherit(mode.starts) : null });
  }

  if (Object.isFrozen(mode)) {
    return inherit(mode);
  }

  // no special dependency issues, just return ourselves
  return mode;
}

var version = "10.7.3";

// @ts-nocheck

function hasValueOrEmptyAttribute(value) {
  return Boolean(value || value === "");
}

function BuildVuePlugin(hljs) {
  const Component = {
    props: ["language", "code", "autodetect"],
    data: function() {
      return {
        detectedLanguage: "",
        unknownLanguage: false
      };
    },
    computed: {
      className() {
        if (this.unknownLanguage) return "";

        return "hljs " + this.detectedLanguage;
      },
      highlighted() {
        // no idea what language to use, return raw code
        if (!this.autoDetect && !hljs.getLanguage(this.language)) {
          console.warn(`The language "${this.language}" you specified could not be found.`);
          this.unknownLanguage = true;
          return escapeHTML(this.code);
        }

        let result = {};
        if (this.autoDetect) {
          result = hljs.highlightAuto(this.code);
          this.detectedLanguage = result.language;
        } else {
          result = hljs.highlight(this.language, this.code, this.ignoreIllegals);
          this.detectedLanguage = this.language;
        }
        return result.value;
      },
      autoDetect() {
        return !this.language || hasValueOrEmptyAttribute(this.autodetect);
      },
      ignoreIllegals() {
        return true;
      }
    },
    // this avoids needing to use a whole Vue compilation pipeline just
    // to build Highlight.js
    render(createElement) {
      return createElement("pre", {}, [
        createElement("code", {
          class: this.className,
          domProps: { innerHTML: this.highlighted }
        })
      ]);
    }
    // template: `<pre><code :class="className" v-html="highlighted"></code></pre>`
  };

  const VuePlugin = {
    install(Vue) {
      Vue.component('highlightjs', Component);
    }
  };

  return { Component, VuePlugin };
}

/* plugin itself */

/** @type {HLJSPlugin} */
const mergeHTMLPlugin = {
  "after:highlightElement": ({ el, result, text }) => {
    const originalStream = nodeStream(el);
    if (!originalStream.length) return;

    const resultNode = document.createElement('div');
    resultNode.innerHTML = result.value;
    result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
  }
};

/* Stream merging support functions */

/**
 * @typedef Event
 * @property {'start'|'stop'} event
 * @property {number} offset
 * @property {Node} node
 */

/**
 * @param {Node} node
 */
function tag(node) {
  return node.nodeName.toLowerCase();
}

/**
 * @param {Node} node
 */
function nodeStream(node) {
  /** @type Event[] */
  const result = [];
  (function _nodeStream(node, offset) {
    for (let child = node.firstChild; child; child = child.nextSibling) {
      if (child.nodeType === 3) {
        offset += child.nodeValue.length;
      } else if (child.nodeType === 1) {
        result.push({
          event: 'start',
          offset: offset,
          node: child
        });
        offset = _nodeStream(child, offset);
        // Prevent void elements from having an end tag that would actually
        // double them in the output. There are more void elements in HTML
        // but we list only those realistically expected in code display.
        if (!tag(child).match(/br|hr|img|input/)) {
          result.push({
            event: 'stop',
            offset: offset,
            node: child
          });
        }
      }
    }
    return offset;
  })(node, 0);
  return result;
}

/**
 * @param {any} original - the original stream
 * @param {any} highlighted - stream of the highlighted source
 * @param {string} value - the original source itself
 */
function mergeStreams(original, highlighted, value) {
  let processed = 0;
  let result = '';
  const nodeStack = [];

  function selectStream() {
    if (!original.length || !highlighted.length) {
      return original.length ? original : highlighted;
    }
    if (original[0].offset !== highlighted[0].offset) {
      return (original[0].offset < highlighted[0].offset) ? original : highlighted;
    }

    /*
    To avoid starting the stream just before it should stop the order is
    ensured that original always starts first and closes last:

    if (event1 == 'start' && event2 == 'start')
      return original;
    if (event1 == 'start' && event2 == 'stop')
      return highlighted;
    if (event1 == 'stop' && event2 == 'start')
      return original;
    if (event1 == 'stop' && event2 == 'stop')
      return highlighted;

    ... which is collapsed to:
    */
    return highlighted[0].event === 'start' ? original : highlighted;
  }

  /**
   * @param {Node} node
   */
  function open(node) {
    /** @param {Attr} attr */
    function attributeString(attr) {
      return ' ' + attr.nodeName + '="' + escapeHTML(attr.value) + '"';
    }
    // @ts-ignore
    result += '<' + tag(node) + [].map.call(node.attributes, attributeString).join('') + '>';
  }

  /**
   * @param {Node} node
   */
  function close(node) {
    result += '</' + tag(node) + '>';
  }

  /**
   * @param {Event} event
   */
  function render(event) {
    (event.event === 'start' ? open : close)(event.node);
  }

  while (original.length || highlighted.length) {
    let stream = selectStream();
    result += escapeHTML(value.substring(processed, stream[0].offset));
    processed = stream[0].offset;
    if (stream === original) {
      /*
      On any opening or closing tag of the original markup we first close
      the entire highlighted node stack, then render the original tag along
      with all the following original tags at the same offset and then
      reopen all the tags on the highlighted stack.
      */
      nodeStack.reverse().forEach(close);
      do {
        render(stream.splice(0, 1)[0]);
        stream = selectStream();
      } while (stream === original && stream.length && stream[0].offset === processed);
      nodeStack.reverse().forEach(open);
    } else {
      if (stream[0].event === 'start') {
        nodeStack.push(stream[0].node);
      } else {
        nodeStack.pop();
      }
      render(stream.splice(0, 1)[0]);
    }
  }
  return result + escapeHTML(value.substr(processed));
}

/*

For the reasoning behind this please see:
https://github.com/highlightjs/highlight.js/issues/2880#issuecomment-747275419

*/

/**
 * @type {Record<string, boolean>}
 */
const seenDeprecations = {};

/**
 * @param {string} message
 */
const error = (message) => {
  console.error(message);
};

/**
 * @param {string} message
 * @param {any} args
 */
const warn = (message, ...args) => {
  console.log(`WARN: ${message}`, ...args);
};

/**
 * @param {string} version
 * @param {string} message
 */
const deprecated = (version, message) => {
  if (seenDeprecations[`${version}/${message}`]) return;

  console.log(`Deprecated as of ${version}. ${message}`);
  seenDeprecations[`${version}/${message}`] = true;
};

/*
Syntax highlighting with language autodetection.
https://highlightjs.org/
*/

const escape$1 = escapeHTML;
const inherit$1 = inherit;
const NO_MATCH = Symbol("nomatch");

/**
 * @param {any} hljs - object that is extended (legacy)
 * @returns {HLJSApi}
 */
const HLJS = function(hljs) {
  // Global internal variables used within the highlight.js library.
  /** @type {Record<string, Language>} */
  const languages = Object.create(null);
  /** @type {Record<string, string>} */
  const aliases = Object.create(null);
  /** @type {HLJSPlugin[]} */
  const plugins = [];

  // safe/production mode - swallows more errors, tries to keep running
  // even if a single syntax or parse hits a fatal error
  let SAFE_MODE = true;
  const fixMarkupRe = /(^(<[^>]+>|\t|)+|\n)/gm;
  const LANGUAGE_NOT_FOUND = "Could not find the language '{}', did you forget to load/include a language module?";
  /** @type {Language} */
  const PLAINTEXT_LANGUAGE = { disableAutodetect: true, name: 'Plain text', contains: [] };

  // Global options used when within external APIs. This is modified when
  // calling the `hljs.configure` function.
  /** @type HLJSOptions */
  let options = {
    noHighlightRe: /^(no-?highlight)$/i,
    languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
    classPrefix: 'hljs-',
    tabReplace: null,
    useBR: false,
    languages: null,
    // beta configuration options, subject to change, welcome to discuss
    // https://github.com/highlightjs/highlight.js/issues/1086
    __emitter: TokenTreeEmitter
  };

  /* Utility functions */

  /**
   * Tests a language name to see if highlighting should be skipped
   * @param {string} languageName
   */
  function shouldNotHighlight(languageName) {
    return options.noHighlightRe.test(languageName);
  }

  /**
   * @param {HighlightedHTMLElement} block - the HTML element to determine language for
   */
  function blockLanguage(block) {
    let classes = block.className + ' ';

    classes += block.parentNode ? block.parentNode.className : '';

    // language-* takes precedence over non-prefixed class names.
    const match = options.languageDetectRe.exec(classes);
    if (match) {
      const language = getLanguage(match[1]);
      if (!language) {
        warn(LANGUAGE_NOT_FOUND.replace("{}", match[1]));
        warn("Falling back to no-highlight mode for this block.", block);
      }
      return language ? match[1] : 'no-highlight';
    }

    return classes
      .split(/\s+/)
      .find((_class) => shouldNotHighlight(_class) || getLanguage(_class));
  }

  /**
   * Core highlighting function.
   *
   * OLD API
   * highlight(lang, code, ignoreIllegals, continuation)
   *
   * NEW API
   * highlight(code, {lang, ignoreIllegals})
   *
   * @param {string} codeOrlanguageName - the language to use for highlighting
   * @param {string | HighlightOptions} optionsOrCode - the code to highlight
   * @param {boolean} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode} [continuation] - current continuation mode, if any
   *
   * @returns {HighlightResult} Result - an object that represents the result
   * @property {string} language - the language name
   * @property {number} relevance - the relevance score
   * @property {string} value - the highlighted HTML code
   * @property {string} code - the original raw code
   * @property {CompiledMode} top - top of the current mode stack
   * @property {boolean} illegal - indicates whether any illegal matches were found
  */
  function highlight(codeOrlanguageName, optionsOrCode, ignoreIllegals, continuation) {
    let code = "";
    let languageName = "";
    if (typeof optionsOrCode === "object") {
      code = codeOrlanguageName;
      ignoreIllegals = optionsOrCode.ignoreIllegals;
      languageName = optionsOrCode.language;
      // continuation not supported at all via the new API
      // eslint-disable-next-line no-undefined
      continuation = undefined;
    } else {
      // old API
      deprecated("10.7.0", "highlight(lang, code, ...args) has been deprecated.");
      deprecated("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277");
      languageName = codeOrlanguageName;
      code = optionsOrCode;
    }

    /** @type {BeforeHighlightContext} */
    const context = {
      code,
      language: languageName
    };
    // the plugin can change the desired language or the code to be highlighted
    // just be changing the object it was passed
    fire("before:highlight", context);

    // a before plugin can usurp the result completely by providing it's own
    // in which case we don't even need to call highlight
    const result = context.result
      ? context.result
      : _highlight(context.language, context.code, ignoreIllegals, continuation);

    result.code = context.code;
    // the plugin can change anything in result to suite it
    fire("after:highlight", result);

    return result;
  }

  /**
   * private highlight that's used internally and does not fire callbacks
   *
   * @param {string} languageName - the language to use for highlighting
   * @param {string} codeToHighlight - the code to highlight
   * @param {boolean?} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode?} [continuation] - current continuation mode, if any
   * @returns {HighlightResult} - result of the highlight operation
  */
  function _highlight(languageName, codeToHighlight, ignoreIllegals, continuation) {
    /**
     * Return keyword data if a match is a keyword
     * @param {CompiledMode} mode - current mode
     * @param {RegExpMatchArray} match - regexp match data
     * @returns {KeywordData | false}
     */
    function keywordData(mode, match) {
      const matchText = language.case_insensitive ? match[0].toLowerCase() : match[0];
      return Object.prototype.hasOwnProperty.call(mode.keywords, matchText) && mode.keywords[matchText];
    }

    function processKeywords() {
      if (!top.keywords) {
        emitter.addText(modeBuffer);
        return;
      }

      let lastIndex = 0;
      top.keywordPatternRe.lastIndex = 0;
      let match = top.keywordPatternRe.exec(modeBuffer);
      let buf = "";

      while (match) {
        buf += modeBuffer.substring(lastIndex, match.index);
        const data = keywordData(top, match);
        if (data) {
          const [kind, keywordRelevance] = data;
          emitter.addText(buf);
          buf = "";

          relevance += keywordRelevance;
          if (kind.startsWith("_")) {
            // _ implied for relevance only, do not highlight
            // by applying a class name
            buf += match[0];
          } else {
            const cssClass = language.classNameAliases[kind] || kind;
            emitter.addKeyword(match[0], cssClass);
          }
        } else {
          buf += match[0];
        }
        lastIndex = top.keywordPatternRe.lastIndex;
        match = top.keywordPatternRe.exec(modeBuffer);
      }
      buf += modeBuffer.substr(lastIndex);
      emitter.addText(buf);
    }

    function processSubLanguage() {
      if (modeBuffer === "") return;
      /** @type HighlightResult */
      let result = null;

      if (typeof top.subLanguage === 'string') {
        if (!languages[top.subLanguage]) {
          emitter.addText(modeBuffer);
          return;
        }
        result = _highlight(top.subLanguage, modeBuffer, true, continuations[top.subLanguage]);
        continuations[top.subLanguage] = /** @type {CompiledMode} */ (result.top);
      } else {
        result = highlightAuto(modeBuffer, top.subLanguage.length ? top.subLanguage : null);
      }

      // Counting embedded language score towards the host language may be disabled
      // with zeroing the containing mode relevance. Use case in point is Markdown that
      // allows XML everywhere and makes every XML snippet to have a much larger Markdown
      // score.
      if (top.relevance > 0) {
        relevance += result.relevance;
      }
      emitter.addSublanguage(result.emitter, result.language);
    }

    function processBuffer() {
      if (top.subLanguage != null) {
        processSubLanguage();
      } else {
        processKeywords();
      }
      modeBuffer = '';
    }

    /**
     * @param {Mode} mode - new mode to start
     */
    function startNewMode(mode) {
      if (mode.className) {
        emitter.openNode(language.classNameAliases[mode.className] || mode.className);
      }
      top = Object.create(mode, { parent: { value: top } });
      return top;
    }

    /**
     * @param {CompiledMode } mode - the mode to potentially end
     * @param {RegExpMatchArray} match - the latest match
     * @param {string} matchPlusRemainder - match plus remainder of content
     * @returns {CompiledMode | void} - the next mode, or if void continue on in current mode
     */
    function endOfMode(mode, match, matchPlusRemainder) {
      let matched = startsWith(mode.endRe, matchPlusRemainder);

      if (matched) {
        if (mode["on:end"]) {
          const resp = new Response(mode);
          mode["on:end"](match, resp);
          if (resp.isMatchIgnored) matched = false;
        }

        if (matched) {
          while (mode.endsParent && mode.parent) {
            mode = mode.parent;
          }
          return mode;
        }
      }
      // even if on:end fires an `ignore` it's still possible
      // that we might trigger the end node because of a parent mode
      if (mode.endsWithParent) {
        return endOfMode(mode.parent, match, matchPlusRemainder);
      }
    }

    /**
     * Handle matching but then ignoring a sequence of text
     *
     * @param {string} lexeme - string containing full match text
     */
    function doIgnore(lexeme) {
      if (top.matcher.regexIndex === 0) {
        // no more regexs to potentially match here, so we move the cursor forward one
        // space
        modeBuffer += lexeme[0];
        return 1;
      } else {
        // no need to move the cursor, we still have additional regexes to try and
        // match at this very spot
        resumeScanAtSamePosition = true;
        return 0;
      }
    }

    /**
     * Handle the start of a new potential mode match
     *
     * @param {EnhancedMatch} match - the current match
     * @returns {number} how far to advance the parse cursor
     */
    function doBeginMatch(match) {
      const lexeme = match[0];
      const newMode = match.rule;

      const resp = new Response(newMode);
      // first internal before callbacks, then the public ones
      const beforeCallbacks = [newMode.__beforeBegin, newMode["on:begin"]];
      for (const cb of beforeCallbacks) {
        if (!cb) continue;
        cb(match, resp);
        if (resp.isMatchIgnored) return doIgnore(lexeme);
      }

      if (newMode && newMode.endSameAsBegin) {
        newMode.endRe = escape(lexeme);
      }

      if (newMode.skip) {
        modeBuffer += lexeme;
      } else {
        if (newMode.excludeBegin) {
          modeBuffer += lexeme;
        }
        processBuffer();
        if (!newMode.returnBegin && !newMode.excludeBegin) {
          modeBuffer = lexeme;
        }
      }
      startNewMode(newMode);
      // if (mode["after:begin"]) {
      //   let resp = new Response(mode);
      //   mode["after:begin"](match, resp);
      // }
      return newMode.returnBegin ? 0 : lexeme.length;
    }

    /**
     * Handle the potential end of mode
     *
     * @param {RegExpMatchArray} match - the current match
     */
    function doEndMatch(match) {
      const lexeme = match[0];
      const matchPlusRemainder = codeToHighlight.substr(match.index);

      const endMode = endOfMode(top, match, matchPlusRemainder);
      if (!endMode) { return NO_MATCH; }

      const origin = top;
      if (origin.skip) {
        modeBuffer += lexeme;
      } else {
        if (!(origin.returnEnd || origin.excludeEnd)) {
          modeBuffer += lexeme;
        }
        processBuffer();
        if (origin.excludeEnd) {
          modeBuffer = lexeme;
        }
      }
      do {
        if (top.className) {
          emitter.closeNode();
        }
        if (!top.skip && !top.subLanguage) {
          relevance += top.relevance;
        }
        top = top.parent;
      } while (top !== endMode.parent);
      if (endMode.starts) {
        if (endMode.endSameAsBegin) {
          endMode.starts.endRe = endMode.endRe;
        }
        startNewMode(endMode.starts);
      }
      return origin.returnEnd ? 0 : lexeme.length;
    }

    function processContinuations() {
      const list = [];
      for (let current = top; current !== language; current = current.parent) {
        if (current.className) {
          list.unshift(current.className);
        }
      }
      list.forEach(item => emitter.openNode(item));
    }

    /** @type {{type?: MatchType, index?: number, rule?: Mode}}} */
    let lastMatch = {};

    /**
     *  Process an individual match
     *
     * @param {string} textBeforeMatch - text preceeding the match (since the last match)
     * @param {EnhancedMatch} [match] - the match itself
     */
    function processLexeme(textBeforeMatch, match) {
      const lexeme = match && match[0];

      // add non-matched text to the current mode buffer
      modeBuffer += textBeforeMatch;

      if (lexeme == null) {
        processBuffer();
        return 0;
      }

      // we've found a 0 width match and we're stuck, so we need to advance
      // this happens when we have badly behaved rules that have optional matchers to the degree that
      // sometimes they can end up matching nothing at all
      // Ref: https://github.com/highlightjs/highlight.js/issues/2140
      if (lastMatch.type === "begin" && match.type === "end" && lastMatch.index === match.index && lexeme === "") {
        // spit the "skipped" character that our regex choked on back into the output sequence
        modeBuffer += codeToHighlight.slice(match.index, match.index + 1);
        if (!SAFE_MODE) {
          /** @type {AnnotatedError} */
          const err = new Error('0 width match regex');
          err.languageName = languageName;
          err.badRule = lastMatch.rule;
          throw err;
        }
        return 1;
      }
      lastMatch = match;

      if (match.type === "begin") {
        return doBeginMatch(match);
      } else if (match.type === "illegal" && !ignoreIllegals) {
        // illegal match, we do not continue processing
        /** @type {AnnotatedError} */
        const err = new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || '<unnamed>') + '"');
        err.mode = top;
        throw err;
      } else if (match.type === "end") {
        const processed = doEndMatch(match);
        if (processed !== NO_MATCH) {
          return processed;
        }
      }

      // edge case for when illegal matches $ (end of line) which is technically
      // a 0 width match but not a begin/end match so it's not caught by the
      // first handler (when ignoreIllegals is true)
      if (match.type === "illegal" && lexeme === "") {
        // advance so we aren't stuck in an infinite loop
        return 1;
      }

      // infinite loops are BAD, this is a last ditch catch all. if we have a
      // decent number of iterations yet our index (cursor position in our
      // parsing) still 3x behind our index then something is very wrong
      // so we bail
      if (iterations > 100000 && iterations > match.index * 3) {
        const err = new Error('potential infinite loop, way more iterations than matches');
        throw err;
      }

      /*
      Why might be find ourselves here?  Only one occasion now.  An end match that was
      triggered but could not be completed.  When might this happen?  When an `endSameasBegin`
      rule sets the end rule to a specific match.  Since the overall mode termination rule that's
      being used to scan the text isn't recompiled that means that any match that LOOKS like
      the end (but is not, because it is not an exact match to the beginning) will
      end up here.  A definite end match, but when `doEndMatch` tries to "reapply"
      the end rule and fails to match, we wind up here, and just silently ignore the end.

      This causes no real harm other than stopping a few times too many.
      */

      modeBuffer += lexeme;
      return lexeme.length;
    }

    const language = getLanguage(languageName);
    if (!language) {
      error(LANGUAGE_NOT_FOUND.replace("{}", languageName));
      throw new Error('Unknown language: "' + languageName + '"');
    }

    const md = compileLanguage(language, { plugins });
    let result = '';
    /** @type {CompiledMode} */
    let top = continuation || md;
    /** @type Record<string,CompiledMode> */
    const continuations = {}; // keep continuations for sub-languages
    const emitter = new options.__emitter(options);
    processContinuations();
    let modeBuffer = '';
    let relevance = 0;
    let index = 0;
    let iterations = 0;
    let resumeScanAtSamePosition = false;

    try {
      top.matcher.considerAll();

      for (;;) {
        iterations++;
        if (resumeScanAtSamePosition) {
          // only regexes not matched previously will now be
          // considered for a potential match
          resumeScanAtSamePosition = false;
        } else {
          top.matcher.considerAll();
        }
        top.matcher.lastIndex = index;

        const match = top.matcher.exec(codeToHighlight);
        // console.log("match", match[0], match.rule && match.rule.begin)

        if (!match) break;

        const beforeMatch = codeToHighlight.substring(index, match.index);
        const processedCount = processLexeme(beforeMatch, match);
        index = match.index + processedCount;
      }
      processLexeme(codeToHighlight.substr(index));
      emitter.closeAllNodes();
      emitter.finalize();
      result = emitter.toHTML();

      return {
        // avoid possible breakage with v10 clients expecting
        // this to always be an integer
        relevance: Math.floor(relevance),
        value: result,
        language: languageName,
        illegal: false,
        emitter: emitter,
        top: top
      };
    } catch (err) {
      if (err.message && err.message.includes('Illegal')) {
        return {
          illegal: true,
          illegalBy: {
            msg: err.message,
            context: codeToHighlight.slice(index - 100, index + 100),
            mode: err.mode
          },
          sofar: result,
          relevance: 0,
          value: escape$1(codeToHighlight),
          emitter: emitter
        };
      } else if (SAFE_MODE) {
        return {
          illegal: false,
          relevance: 0,
          value: escape$1(codeToHighlight),
          emitter: emitter,
          language: languageName,
          top: top,
          errorRaised: err
        };
      } else {
        throw err;
      }
    }
  }

  /**
   * returns a valid highlight result, without actually doing any actual work,
   * auto highlight starts with this and it's possible for small snippets that
   * auto-detection may not find a better match
   * @param {string} code
   * @returns {HighlightResult}
   */
  function justTextHighlightResult(code) {
    const result = {
      relevance: 0,
      emitter: new options.__emitter(options),
      value: escape$1(code),
      illegal: false,
      top: PLAINTEXT_LANGUAGE
    };
    result.emitter.addText(code);
    return result;
  }

  /**
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:

  - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - second_best (object with the same structure for second-best heuristically
    detected language, may be absent)

    @param {string} code
    @param {Array<string>} [languageSubset]
    @returns {AutoHighlightResult}
  */
  function highlightAuto(code, languageSubset) {
    languageSubset = languageSubset || options.languages || Object.keys(languages);
    const plaintext = justTextHighlightResult(code);

    const results = languageSubset.filter(getLanguage).filter(autoDetection).map(name =>
      _highlight(name, code, false)
    );
    results.unshift(plaintext); // plaintext is always an option

    const sorted = results.sort((a, b) => {
      // sort base on relevance
      if (a.relevance !== b.relevance) return b.relevance - a.relevance;

      // always award the tie to the base language
      // ie if C++ and Arduino are tied, it's more likely to be C++
      if (a.language && b.language) {
        if (getLanguage(a.language).supersetOf === b.language) {
          return 1;
        } else if (getLanguage(b.language).supersetOf === a.language) {
          return -1;
        }
      }

      // otherwise say they are equal, which has the effect of sorting on
      // relevance while preserving the original ordering - which is how ties
      // have historically been settled, ie the language that comes first always
      // wins in the case of a tie
      return 0;
    });

    const [best, secondBest] = sorted;

    /** @type {AutoHighlightResult} */
    const result = best;
    result.second_best = secondBest;

    return result;
  }

  /**
  Post-processing of the highlighted markup:

  - replace TABs with something more useful
  - replace real line-breaks with '<br>' for non-pre containers

    @param {string} html
    @returns {string}
  */
  function fixMarkup(html) {
    if (!(options.tabReplace || options.useBR)) {
      return html;
    }

    return html.replace(fixMarkupRe, match => {
      if (match === '\n') {
        return options.useBR ? '<br>' : match;
      } else if (options.tabReplace) {
        return match.replace(/\t/g, options.tabReplace);
      }
      return match;
    });
  }

  /**
   * Builds new class name for block given the language name
   *
   * @param {HTMLElement} element
   * @param {string} [currentLang]
   * @param {string} [resultLang]
   */
  function updateClassName(element, currentLang, resultLang) {
    const language = currentLang ? aliases[currentLang] : resultLang;

    element.classList.add("hljs");
    if (language) element.classList.add(language);
  }

  /** @type {HLJSPlugin} */
  const brPlugin = {
    "before:highlightElement": ({ el }) => {
      if (options.useBR) {
        el.innerHTML = el.innerHTML.replace(/\n/g, '').replace(/<br[ /]*>/g, '\n');
      }
    },
    "after:highlightElement": ({ result }) => {
      if (options.useBR) {
        result.value = result.value.replace(/\n/g, "<br>");
      }
    }
  };

  const TAB_REPLACE_RE = /^(<[^>]+>|\t)+/gm;
  /** @type {HLJSPlugin} */
  const tabReplacePlugin = {
    "after:highlightElement": ({ result }) => {
      if (options.tabReplace) {
        result.value = result.value.replace(TAB_REPLACE_RE, (m) =>
          m.replace(/\t/g, options.tabReplace)
        );
      }
    }
  };

  /**
   * Applies highlighting to a DOM node containing code. Accepts a DOM node and
   * two optional parameters for fixMarkup.
   *
   * @param {HighlightedHTMLElement} element - the HTML element to highlight
  */
  function highlightElement(element) {
    /** @type HTMLElement */
    let node = null;
    const language = blockLanguage(element);

    if (shouldNotHighlight(language)) return;

    // support for v10 API
    fire("before:highlightElement",
      { el: element, language: language });

    node = element;
    const text = node.textContent;
    const result = language ? highlight(text, { language, ignoreIllegals: true }) : highlightAuto(text);

    // support for v10 API
    fire("after:highlightElement", { el: element, result, text });

    element.innerHTML = result.value;
    updateClassName(element, language, result.language);
    element.result = {
      language: result.language,
      // TODO: remove with version 11.0
      re: result.relevance,
      relavance: result.relevance
    };
    if (result.second_best) {
      element.second_best = {
        language: result.second_best.language,
        // TODO: remove with version 11.0
        re: result.second_best.relevance,
        relavance: result.second_best.relevance
      };
    }
  }

  /**
   * Updates highlight.js global options with the passed options
   *
   * @param {Partial<HLJSOptions>} userOptions
   */
  function configure(userOptions) {
    if (userOptions.useBR) {
      deprecated("10.3.0", "'useBR' will be removed entirely in v11.0");
      deprecated("10.3.0", "Please see https://github.com/highlightjs/highlight.js/issues/2559");
    }
    options = inherit$1(options, userOptions);
  }

  /**
   * Highlights to all <pre><code> blocks on a page
   *
   * @type {Function & {called?: boolean}}
   */
  // TODO: remove v12, deprecated
  const initHighlighting = () => {
    if (initHighlighting.called) return;
    initHighlighting.called = true;

    deprecated("10.6.0", "initHighlighting() is deprecated.  Use highlightAll() instead.");

    const blocks = document.querySelectorAll('pre code');
    blocks.forEach(highlightElement);
  };

  // Higlights all when DOMContentLoaded fires
  // TODO: remove v12, deprecated
  function initHighlightingOnLoad() {
    deprecated("10.6.0", "initHighlightingOnLoad() is deprecated.  Use highlightAll() instead.");
    wantsHighlight = true;
  }

  let wantsHighlight = false;

  /**
   * auto-highlights all pre>code elements on the page
   */
  function highlightAll() {
    // if we are called too early in the loading process
    if (document.readyState === "loading") {
      wantsHighlight = true;
      return;
    }

    const blocks = document.querySelectorAll('pre code');
    blocks.forEach(highlightElement);
  }

  function boot() {
    // if a highlight was requested before DOM was loaded, do now
    if (wantsHighlight) highlightAll();
  }

  // make sure we are in the browser environment
  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('DOMContentLoaded', boot, false);
  }

  /**
   * Register a language grammar module
   *
   * @param {string} languageName
   * @param {LanguageFn} languageDefinition
   */
  function registerLanguage(languageName, languageDefinition) {
    let lang = null;
    try {
      lang = languageDefinition(hljs);
    } catch (error$1) {
      error("Language definition for '{}' could not be registered.".replace("{}", languageName));
      // hard or soft error
      if (!SAFE_MODE) { throw error$1; } else { error(error$1); }
      // languages that have serious errors are replaced with essentially a
      // "plaintext" stand-in so that the code blocks will still get normal
      // css classes applied to them - and one bad language won't break the
      // entire highlighter
      lang = PLAINTEXT_LANGUAGE;
    }
    // give it a temporary name if it doesn't have one in the meta-data
    if (!lang.name) lang.name = languageName;
    languages[languageName] = lang;
    lang.rawDefinition = languageDefinition.bind(null, hljs);

    if (lang.aliases) {
      registerAliases(lang.aliases, { languageName });
    }
  }

  /**
   * Remove a language grammar module
   *
   * @param {string} languageName
   */
  function unregisterLanguage(languageName) {
    delete languages[languageName];
    for (const alias of Object.keys(aliases)) {
      if (aliases[alias] === languageName) {
        delete aliases[alias];
      }
    }
  }

  /**
   * @returns {string[]} List of language internal names
   */
  function listLanguages() {
    return Object.keys(languages);
  }

  /**
    intended usage: When one language truly requires another

    Unlike `getLanguage`, this will throw when the requested language
    is not available.

    @param {string} name - name of the language to fetch/require
    @returns {Language | never}
  */
  function requireLanguage(name) {
    deprecated("10.4.0", "requireLanguage will be removed entirely in v11.");
    deprecated("10.4.0", "Please see https://github.com/highlightjs/highlight.js/pull/2844");

    const lang = getLanguage(name);
    if (lang) { return lang; }

    const err = new Error('The \'{}\' language is required, but not loaded.'.replace('{}', name));
    throw err;
  }

  /**
   * @param {string} name - name of the language to retrieve
   * @returns {Language | undefined}
   */
  function getLanguage(name) {
    name = (name || '').toLowerCase();
    return languages[name] || languages[aliases[name]];
  }

  /**
   *
   * @param {string|string[]} aliasList - single alias or list of aliases
   * @param {{languageName: string}} opts
   */
  function registerAliases(aliasList, { languageName }) {
    if (typeof aliasList === 'string') {
      aliasList = [aliasList];
    }
    aliasList.forEach(alias => { aliases[alias.toLowerCase()] = languageName; });
  }

  /**
   * Determines if a given language has auto-detection enabled
   * @param {string} name - name of the language
   */
  function autoDetection(name) {
    const lang = getLanguage(name);
    return lang && !lang.disableAutodetect;
  }

  /**
   * Upgrades the old highlightBlock plugins to the new
   * highlightElement API
   * @param {HLJSPlugin} plugin
   */
  function upgradePluginAPI(plugin) {
    // TODO: remove with v12
    if (plugin["before:highlightBlock"] && !plugin["before:highlightElement"]) {
      plugin["before:highlightElement"] = (data) => {
        plugin["before:highlightBlock"](
          Object.assign({ block: data.el }, data)
        );
      };
    }
    if (plugin["after:highlightBlock"] && !plugin["after:highlightElement"]) {
      plugin["after:highlightElement"] = (data) => {
        plugin["after:highlightBlock"](
          Object.assign({ block: data.el }, data)
        );
      };
    }
  }

  /**
   * @param {HLJSPlugin} plugin
   */
  function addPlugin(plugin) {
    upgradePluginAPI(plugin);
    plugins.push(plugin);
  }

  /**
   *
   * @param {PluginEvent} event
   * @param {any} args
   */
  function fire(event, args) {
    const cb = event;
    plugins.forEach(function(plugin) {
      if (plugin[cb]) {
        plugin[cb](args);
      }
    });
  }

  /**
  Note: fixMarkup is deprecated and will be removed entirely in v11

  @param {string} arg
  @returns {string}
  */
  function deprecateFixMarkup(arg) {
    deprecated("10.2.0", "fixMarkup will be removed entirely in v11.0");
    deprecated("10.2.0", "Please see https://github.com/highlightjs/highlight.js/issues/2534");

    return fixMarkup(arg);
  }

  /**
   *
   * @param {HighlightedHTMLElement} el
   */
  function deprecateHighlightBlock(el) {
    deprecated("10.7.0", "highlightBlock will be removed entirely in v12.0");
    deprecated("10.7.0", "Please use highlightElement now.");

    return highlightElement(el);
  }

  /* Interface definition */
  Object.assign(hljs, {
    highlight,
    highlightAuto,
    highlightAll,
    fixMarkup: deprecateFixMarkup,
    highlightElement,
    // TODO: Remove with v12 API
    highlightBlock: deprecateHighlightBlock,
    configure,
    initHighlighting,
    initHighlightingOnLoad,
    registerLanguage,
    unregisterLanguage,
    listLanguages,
    getLanguage,
    registerAliases,
    requireLanguage,
    autoDetection,
    inherit: inherit$1,
    addPlugin,
    // plugins for frameworks
    vuePlugin: BuildVuePlugin(hljs).VuePlugin
  });

  hljs.debugMode = function() { SAFE_MODE = false; };
  hljs.safeMode = function() { SAFE_MODE = true; };
  hljs.versionString = version;

  for (const key in MODES) {
    // @ts-ignore
    if (typeof MODES[key] === "object") {
      // @ts-ignore
      deepFreezeEs6(MODES[key]);
    }
  }

  // merge all the modes/regexs into our main object
  Object.assign(hljs, MODES);

  // built-in plugins, likely to be moved out of core in the future
  hljs.addPlugin(brPlugin); // slated to be removed in v11
  hljs.addPlugin(mergeHTMLPlugin);
  hljs.addPlugin(tabReplacePlugin);
  return hljs;
};

// export an "instance" of the highlighter
var highlight = HLJS({});

module.exports = highlight;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(356);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, "/*\n\nVisual Studio-like style based on original C# coloring by Jason Diamond <jason@diamond.name>\n\n*/\n.hljs {\n  display: block;\n  overflow-x: auto;\n  padding: 0.5em;\n  background: white;\n  color: black;\n}\n\n.hljs-comment,\n.hljs-quote,\n.hljs-variable {\n  color: #008000;\n}\n\n.hljs-keyword,\n.hljs-selector-tag,\n.hljs-built_in,\n.hljs-name,\n.hljs-tag {\n  color: #00f;\n}\n\n.hljs-string,\n.hljs-title,\n.hljs-section,\n.hljs-attribute,\n.hljs-literal,\n.hljs-template-tag,\n.hljs-template-variable,\n.hljs-type,\n.hljs-addition {\n  color: #a31515;\n}\n\n.hljs-deletion,\n.hljs-selector-attr,\n.hljs-selector-pseudo,\n.hljs-meta {\n  color: #2b91af;\n}\n\n.hljs-doctag {\n  color: #808080;\n}\n\n.hljs-attr {\n  color: #f00;\n}\n\n.hljs-symbol,\n.hljs-bullet,\n.hljs-link {\n  color: #00b0e8;\n}\n\n\n.hljs-emphasis {\n  font-style: italic;\n}\n\n.hljs-strong {\n  font-weight: bold;\n}\n", ""]);



/***/ }),
/* 357 */
/***/ (function(module, exports) {

/*
Language: C#
Author: Jason Diamond <jason@diamond.name>
Contributor: Nicolas LLOBERA <nllobera@gmail.com>, Pieter Vantorre <pietervantorre@gmail.com>, David Pine <david.pine@microsoft.com>
Website: https://docs.microsoft.com/en-us/dotnet/csharp/
Category: common
*/

/** @type LanguageFn */
function csharp(hljs) {
  const BUILT_IN_KEYWORDS = [
    'bool',
    'byte',
    'char',
    'decimal',
    'delegate',
    'double',
    'dynamic',
    'enum',
    'float',
    'int',
    'long',
    'nint',
    'nuint',
    'object',
    'sbyte',
    'short',
    'string',
    'ulong',
    'uint',
    'ushort'
  ];
  const FUNCTION_MODIFIERS = [
    'public',
    'private',
    'protected',
    'static',
    'internal',
    'protected',
    'abstract',
    'async',
    'extern',
    'override',
    'unsafe',
    'virtual',
    'new',
    'sealed',
    'partial'
  ];
  const LITERAL_KEYWORDS = [
    'default',
    'false',
    'null',
    'true'
  ];
  const NORMAL_KEYWORDS = [
    'abstract',
    'as',
    'base',
    'break',
    'case',
    'class',
    'const',
    'continue',
    'do',
    'else',
    'event',
    'explicit',
    'extern',
    'finally',
    'fixed',
    'for',
    'foreach',
    'goto',
    'if',
    'implicit',
    'in',
    'interface',
    'internal',
    'is',
    'lock',
    'namespace',
    'new',
    'operator',
    'out',
    'override',
    'params',
    'private',
    'protected',
    'public',
    'readonly',
    'record',
    'ref',
    'return',
    'sealed',
    'sizeof',
    'stackalloc',
    'static',
    'struct',
    'switch',
    'this',
    'throw',
    'try',
    'typeof',
    'unchecked',
    'unsafe',
    'using',
    'virtual',
    'void',
    'volatile',
    'while'
  ];
  const CONTEXTUAL_KEYWORDS = [
    'add',
    'alias',
    'and',
    'ascending',
    'async',
    'await',
    'by',
    'descending',
    'equals',
    'from',
    'get',
    'global',
    'group',
    'init',
    'into',
    'join',
    'let',
    'nameof',
    'not',
    'notnull',
    'on',
    'or',
    'orderby',
    'partial',
    'remove',
    'select',
    'set',
    'unmanaged',
    'value|0',
    'var',
    'when',
    'where',
    'with',
    'yield'
  ];

  const KEYWORDS = {
    keyword: NORMAL_KEYWORDS.concat(CONTEXTUAL_KEYWORDS),
    built_in: BUILT_IN_KEYWORDS,
    literal: LITERAL_KEYWORDS
  };
  const TITLE_MODE = hljs.inherit(hljs.TITLE_MODE, {
    begin: '[a-zA-Z](\\.?\\w)*'
  });
  const NUMBERS = {
    className: 'number',
    variants: [
      {
        begin: '\\b(0b[01\']+)'
      },
      {
        begin: '(-?)\\b([\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)(u|U|l|L|ul|UL|f|F|b|B)'
      },
      {
        begin: '(-?)(\\b0[xX][a-fA-F0-9\']+|(\\b[\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)([eE][-+]?[\\d\']+)?)'
      }
    ],
    relevance: 0
  };
  const VERBATIM_STRING = {
    className: 'string',
    begin: '@"',
    end: '"',
    contains: [
      {
        begin: '""'
      }
    ]
  };
  const VERBATIM_STRING_NO_LF = hljs.inherit(VERBATIM_STRING, {
    illegal: /\n/
  });
  const SUBST = {
    className: 'subst',
    begin: /\{/,
    end: /\}/,
    keywords: KEYWORDS
  };
  const SUBST_NO_LF = hljs.inherit(SUBST, {
    illegal: /\n/
  });
  const INTERPOLATED_STRING = {
    className: 'string',
    begin: /\$"/,
    end: '"',
    illegal: /\n/,
    contains: [
      {
        begin: /\{\{/
      },
      {
        begin: /\}\}/
      },
      hljs.BACKSLASH_ESCAPE,
      SUBST_NO_LF
    ]
  };
  const INTERPOLATED_VERBATIM_STRING = {
    className: 'string',
    begin: /\$@"/,
    end: '"',
    contains: [
      {
        begin: /\{\{/
      },
      {
        begin: /\}\}/
      },
      {
        begin: '""'
      },
      SUBST
    ]
  };
  const INTERPOLATED_VERBATIM_STRING_NO_LF = hljs.inherit(INTERPOLATED_VERBATIM_STRING, {
    illegal: /\n/,
    contains: [
      {
        begin: /\{\{/
      },
      {
        begin: /\}\}/
      },
      {
        begin: '""'
      },
      SUBST_NO_LF
    ]
  });
  SUBST.contains = [
    INTERPOLATED_VERBATIM_STRING,
    INTERPOLATED_STRING,
    VERBATIM_STRING,
    hljs.APOS_STRING_MODE,
    hljs.QUOTE_STRING_MODE,
    NUMBERS,
    hljs.C_BLOCK_COMMENT_MODE
  ];
  SUBST_NO_LF.contains = [
    INTERPOLATED_VERBATIM_STRING_NO_LF,
    INTERPOLATED_STRING,
    VERBATIM_STRING_NO_LF,
    hljs.APOS_STRING_MODE,
    hljs.QUOTE_STRING_MODE,
    NUMBERS,
    hljs.inherit(hljs.C_BLOCK_COMMENT_MODE, {
      illegal: /\n/
    })
  ];
  const STRING = {
    variants: [
      INTERPOLATED_VERBATIM_STRING,
      INTERPOLATED_STRING,
      VERBATIM_STRING,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE
    ]
  };

  const GENERIC_MODIFIER = {
    begin: "<",
    end: ">",
    contains: [
      {
        beginKeywords: "in out"
      },
      TITLE_MODE
    ]
  };
  const TYPE_IDENT_RE = hljs.IDENT_RE + '(<' + hljs.IDENT_RE + '(\\s*,\\s*' + hljs.IDENT_RE + ')*>)?(\\[\\])?';
  const AT_IDENTIFIER = {
    // prevents expressions like `@class` from incorrect flagging
    // `class` as a keyword
    begin: "@" + hljs.IDENT_RE,
    relevance: 0
  };

  return {
    name: 'C#',
    aliases: [
      'cs',
      'c#'
    ],
    keywords: KEYWORDS,
    illegal: /::/,
    contains: [
      hljs.COMMENT(
        '///',
        '$',
        {
          returnBegin: true,
          contains: [
            {
              className: 'doctag',
              variants: [
                {
                  begin: '///',
                  relevance: 0
                },
                {
                  begin: '<!--|-->'
                },
                {
                  begin: '</?',
                  end: '>'
                }
              ]
            }
          ]
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'meta',
        begin: '#',
        end: '$',
        keywords: {
          'meta-keyword': 'if else elif endif define undef warning error line region endregion pragma checksum'
        }
      },
      STRING,
      NUMBERS,
      {
        beginKeywords: 'class interface',
        relevance: 0,
        end: /[{;=]/,
        illegal: /[^\s:,]/,
        contains: [
          {
            beginKeywords: "where class"
          },
          TITLE_MODE,
          GENERIC_MODIFIER,
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        beginKeywords: 'namespace',
        relevance: 0,
        end: /[{;=]/,
        illegal: /[^\s:]/,
        contains: [
          TITLE_MODE,
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        beginKeywords: 'record',
        relevance: 0,
        end: /[{;=]/,
        illegal: /[^\s:]/,
        contains: [
          TITLE_MODE,
          GENERIC_MODIFIER,
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        // [Attributes("")]
        className: 'meta',
        begin: '^\\s*\\[',
        excludeBegin: true,
        end: '\\]',
        excludeEnd: true,
        contains: [
          {
            className: 'meta-string',
            begin: /"/,
            end: /"/
          }
        ]
      },
      {
        // Expression keywords prevent 'keyword Name(...)' from being
        // recognized as a function definition
        beginKeywords: 'new return throw await else',
        relevance: 0
      },
      {
        className: 'function',
        begin: '(' + TYPE_IDENT_RE + '\\s+)+' + hljs.IDENT_RE + '\\s*(<.+>\\s*)?\\(',
        returnBegin: true,
        end: /\s*[{;=]/,
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          // prevents these from being highlighted `title`
          {
            beginKeywords: FUNCTION_MODIFIERS.join(" "),
            relevance: 0
          },
          {
            begin: hljs.IDENT_RE + '\\s*(<.+>\\s*)?\\(',
            returnBegin: true,
            contains: [
              hljs.TITLE_MODE,
              GENERIC_MODIFIER
            ],
            relevance: 0
          },
          {
            className: 'params',
            begin: /\(/,
            end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            keywords: KEYWORDS,
            relevance: 0,
            contains: [
              STRING,
              NUMBERS,
              hljs.C_BLOCK_COMMENT_MODE
            ]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      AT_IDENTIFIER
    ]
  };
}

module.exports = csharp;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

// https://docs.oracle.com/javase/specs/jls/se15/html/jls-3.html#jls-3.10
var decimalDigits = '[0-9](_*[0-9])*';
var frac = `\\.(${decimalDigits})`;
var hexDigits = '[0-9a-fA-F](_*[0-9a-fA-F])*';
var NUMERIC = {
  className: 'number',
  variants: [
    // DecimalFloatingPointLiteral
    // including ExponentPart
    { begin: `(\\b(${decimalDigits})((${frac})|\\.)?|(${frac}))` +
      `[eE][+-]?(${decimalDigits})[fFdD]?\\b` },
    // excluding ExponentPart
    { begin: `\\b(${decimalDigits})((${frac})[fFdD]?\\b|\\.([fFdD]\\b)?)` },
    { begin: `(${frac})[fFdD]?\\b` },
    { begin: `\\b(${decimalDigits})[fFdD]\\b` },

    // HexadecimalFloatingPointLiteral
    { begin: `\\b0[xX]((${hexDigits})\\.?|(${hexDigits})?\\.(${hexDigits}))` +
      `[pP][+-]?(${decimalDigits})[fFdD]?\\b` },

    // DecimalIntegerLiteral
    { begin: '\\b(0|[1-9](_*[0-9])*)[lL]?\\b' },

    // HexIntegerLiteral
    { begin: `\\b0[xX](${hexDigits})[lL]?\\b` },

    // OctalIntegerLiteral
    { begin: '\\b0(_*[0-7])*[lL]?\\b' },

    // BinaryIntegerLiteral
    { begin: '\\b0[bB][01](_*[01])*[lL]?\\b' },
  ],
  relevance: 0
};

/*
Language: Java
Author: Vsevolod Solovyov <vsevolod.solovyov@gmail.com>
Category: common, enterprise
Website: https://www.java.com/
*/

function java(hljs) {
  var JAVA_IDENT_RE = '[\u00C0-\u02B8a-zA-Z_$][\u00C0-\u02B8a-zA-Z_$0-9]*';
  var GENERIC_IDENT_RE = JAVA_IDENT_RE + '(<' + JAVA_IDENT_RE + '(\\s*,\\s*' + JAVA_IDENT_RE + ')*>)?';
  var KEYWORDS = 'false synchronized int abstract float private char boolean var static null if const ' +
    'for true while long strictfp finally protected import native final void ' +
    'enum else break transient catch instanceof byte super volatile case assert short ' +
    'package default double public try this switch continue throws protected public private ' +
    'module requires exports do';

  var ANNOTATION = {
    className: 'meta',
    begin: '@' + JAVA_IDENT_RE,
    contains: [
      {
        begin: /\(/,
        end: /\)/,
        contains: ["self"] // allow nested () inside our annotation
      },
    ]
  };
  const NUMBER = NUMERIC;

  return {
    name: 'Java',
    aliases: ['jsp'],
    keywords: KEYWORDS,
    illegal: /<\/|#/,
    contains: [
      hljs.COMMENT(
        '/\\*\\*',
        '\\*/',
        {
          relevance: 0,
          contains: [
            {
              // eat up @'s in emails to prevent them to be recognized as doctags
              begin: /\w+@/, relevance: 0
            },
            {
              className: 'doctag',
              begin: '@[A-Za-z]+'
            }
          ]
        }
      ),
      // relevance boost
      {
        begin: /import java\.[a-z]+\./,
        keywords: "import",
        relevance: 2
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'class',
        beginKeywords: 'class interface enum', end: /[{;=]/, excludeEnd: true,
        // TODO: can this be removed somehow?
        // an extra boost because Java is more popular than other languages with
        // this same syntax feature (this is just to preserve our tests passing
        // for now)
        relevance: 1,
        keywords: 'class interface enum',
        illegal: /[:"\[\]]/,
        contains: [
          { beginKeywords: 'extends implements' },
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        // Expression keywords prevent 'keyword Name(...)' from being
        // recognized as a function definition
        beginKeywords: 'new throw return else',
        relevance: 0
      },
      {
        className: 'class',
        begin: 'record\\s+' + hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
        returnBegin: true,
        excludeEnd: true,
        end: /[{;=]/,
        keywords: KEYWORDS,
        contains: [
          { beginKeywords: "record" },
          {
            begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
            returnBegin: true,
            relevance: 0,
            contains: [hljs.UNDERSCORE_TITLE_MODE]
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            keywords: KEYWORDS,
            relevance: 0,
            contains: [
              hljs.C_BLOCK_COMMENT_MODE
            ]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        className: 'function',
        begin: '(' + GENERIC_IDENT_RE + '\\s+)+' + hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true, end: /[{;=]/,
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          {
            begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true,
            relevance: 0,
            contains: [hljs.UNDERSCORE_TITLE_MODE]
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            keywords: KEYWORDS,
            relevance: 0,
            contains: [
              ANNOTATION,
              hljs.APOS_STRING_MODE,
              hljs.QUOTE_STRING_MODE,
              NUMBER,
              hljs.C_BLOCK_COMMENT_MODE
            ]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      NUMBER,
      ANNOTATION
    ]
  };
}

module.exports = java;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

const IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
const KEYWORDS = [
  "as", // for exports
  "in",
  "of",
  "if",
  "for",
  "while",
  "finally",
  "var",
  "new",
  "function",
  "do",
  "return",
  "void",
  "else",
  "break",
  "catch",
  "instanceof",
  "with",
  "throw",
  "case",
  "default",
  "try",
  "switch",
  "continue",
  "typeof",
  "delete",
  "let",
  "yield",
  "const",
  "class",
  // JS handles these with a special rule
  // "get",
  // "set",
  "debugger",
  "async",
  "await",
  "static",
  "import",
  "from",
  "export",
  "extends"
];
const LITERALS = [
  "true",
  "false",
  "null",
  "undefined",
  "NaN",
  "Infinity"
];

const TYPES = [
  "Intl",
  "DataView",
  "Number",
  "Math",
  "Date",
  "String",
  "RegExp",
  "Object",
  "Function",
  "Boolean",
  "Error",
  "Symbol",
  "Set",
  "Map",
  "WeakSet",
  "WeakMap",
  "Proxy",
  "Reflect",
  "JSON",
  "Promise",
  "Float64Array",
  "Int16Array",
  "Int32Array",
  "Int8Array",
  "Uint16Array",
  "Uint32Array",
  "Float32Array",
  "Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "ArrayBuffer",
  "BigInt64Array",
  "BigUint64Array",
  "BigInt"
];

const ERROR_TYPES = [
  "EvalError",
  "InternalError",
  "RangeError",
  "ReferenceError",
  "SyntaxError",
  "TypeError",
  "URIError"
];

const BUILT_IN_GLOBALS = [
  "setInterval",
  "setTimeout",
  "clearInterval",
  "clearTimeout",

  "require",
  "exports",

  "eval",
  "isFinite",
  "isNaN",
  "parseFloat",
  "parseInt",
  "decodeURI",
  "decodeURIComponent",
  "encodeURI",
  "encodeURIComponent",
  "escape",
  "unescape"
];

const BUILT_IN_VARIABLES = [
  "arguments",
  "this",
  "super",
  "console",
  "window",
  "document",
  "localStorage",
  "module",
  "global" // Node.js
];

const BUILT_INS = [].concat(
  BUILT_IN_GLOBALS,
  BUILT_IN_VARIABLES,
  TYPES,
  ERROR_TYPES
);

/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;

  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat(...args) {
  const joined = args.map((x) => source(x)).join("");
  return joined;
}

/*
Language: JavaScript
Description: JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions.
Category: common, scripting
Website: https://developer.mozilla.org/en-US/docs/Web/JavaScript
*/

/** @type LanguageFn */
function javascript(hljs) {
  /**
   * Takes a string like "<Booger" and checks to see
   * if we can find a matching "</Booger" later in the
   * content.
   * @param {RegExpMatchArray} match
   * @param {{after:number}} param1
   */
  const hasClosingTag = (match, { after }) => {
    const tag = "</" + match[0].slice(1);
    const pos = match.input.indexOf(tag, after);
    return pos !== -1;
  };

  const IDENT_RE$1 = IDENT_RE;
  const FRAGMENT = {
    begin: '<>',
    end: '</>'
  };
  const XML_TAG = {
    begin: /<[A-Za-z0-9\\._:-]+/,
    end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
    /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */
    isTrulyOpeningTag: (match, response) => {
      const afterMatchIndex = match[0].length + match.index;
      const nextChar = match.input[afterMatchIndex];
      // nested type?
      // HTML should not include another raw `<` inside a tag
      // But a type might: `<Array<Array<number>>`, etc.
      if (nextChar === "<") {
        response.ignoreMatch();
        return;
      }
      // <something>
      // This is now either a tag or a type.
      if (nextChar === ">") {
        // if we cannot find a matching closing tag, then we
        // will ignore it
        if (!hasClosingTag(match, { after: afterMatchIndex })) {
          response.ignoreMatch();
        }
      }
    }
  };
  const KEYWORDS$1 = {
    $pattern: IDENT_RE,
    keyword: KEYWORDS,
    literal: LITERALS,
    built_in: BUILT_INS
  };

  // https://tc39.es/ecma262/#sec-literals-numeric-literals
  const decimalDigits = '[0-9](_?[0-9])*';
  const frac = `\\.(${decimalDigits})`;
  // DecimalIntegerLiteral, including Annex B NonOctalDecimalIntegerLiteral
  // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
  const decimalInteger = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`;
  const NUMBER = {
    className: 'number',
    variants: [
      // DecimalLiteral
      { begin: `(\\b(${decimalInteger})((${frac})|\\.)?|(${frac}))` +
        `[eE][+-]?(${decimalDigits})\\b` },
      { begin: `\\b(${decimalInteger})\\b((${frac})\\b|\\.)?|(${frac})\\b` },

      // DecimalBigIntegerLiteral
      { begin: `\\b(0|[1-9](_?[0-9])*)n\\b` },

      // NonDecimalIntegerLiteral
      { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
      { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
      { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },

      // LegacyOctalIntegerLiteral (does not include underscore separators)
      // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
      { begin: "\\b0[0-7]+n?\\b" },
    ],
    relevance: 0
  };

  const SUBST = {
    className: 'subst',
    begin: '\\$\\{',
    end: '\\}',
    keywords: KEYWORDS$1,
    contains: [] // defined later
  };
  const HTML_TEMPLATE = {
    begin: 'html`',
    end: '',
    starts: {
      end: '`',
      returnEnd: false,
      contains: [
        hljs.BACKSLASH_ESCAPE,
        SUBST
      ],
      subLanguage: 'xml'
    }
  };
  const CSS_TEMPLATE = {
    begin: 'css`',
    end: '',
    starts: {
      end: '`',
      returnEnd: false,
      contains: [
        hljs.BACKSLASH_ESCAPE,
        SUBST
      ],
      subLanguage: 'css'
    }
  };
  const TEMPLATE_STRING = {
    className: 'string',
    begin: '`',
    end: '`',
    contains: [
      hljs.BACKSLASH_ESCAPE,
      SUBST
    ]
  };
  const JSDOC_COMMENT = hljs.COMMENT(
    /\/\*\*(?!\/)/,
    '\\*/',
    {
      relevance: 0,
      contains: [
        {
          className: 'doctag',
          begin: '@[A-Za-z]+',
          contains: [
            {
              className: 'type',
              begin: '\\{',
              end: '\\}',
              relevance: 0
            },
            {
              className: 'variable',
              begin: IDENT_RE$1 + '(?=\\s*(-)|$)',
              endsParent: true,
              relevance: 0
            },
            // eat spaces (not newlines) so we can find
            // types or variables
            {
              begin: /(?=[^\n])\s/,
              relevance: 0
            }
          ]
        }
      ]
    }
  );
  const COMMENT = {
    className: "comment",
    variants: [
      JSDOC_COMMENT,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_LINE_COMMENT_MODE
    ]
  };
  const SUBST_INTERNALS = [
    hljs.APOS_STRING_MODE,
    hljs.QUOTE_STRING_MODE,
    HTML_TEMPLATE,
    CSS_TEMPLATE,
    TEMPLATE_STRING,
    NUMBER,
    hljs.REGEXP_MODE
  ];
  SUBST.contains = SUBST_INTERNALS
    .concat({
      // we need to pair up {} inside our subst to prevent
      // it from ending too early by matching another }
      begin: /\{/,
      end: /\}/,
      keywords: KEYWORDS$1,
      contains: [
        "self"
      ].concat(SUBST_INTERNALS)
    });
  const SUBST_AND_COMMENTS = [].concat(COMMENT, SUBST.contains);
  const PARAMS_CONTAINS = SUBST_AND_COMMENTS.concat([
    // eat recursive parens in sub expressions
    {
      begin: /\(/,
      end: /\)/,
      keywords: KEYWORDS$1,
      contains: ["self"].concat(SUBST_AND_COMMENTS)
    }
  ]);
  const PARAMS = {
    className: 'params',
    begin: /\(/,
    end: /\)/,
    excludeBegin: true,
    excludeEnd: true,
    keywords: KEYWORDS$1,
    contains: PARAMS_CONTAINS
  };

  return {
    name: 'Javascript',
    aliases: ['js', 'jsx', 'mjs', 'cjs'],
    keywords: KEYWORDS$1,
    // this will be extended by TypeScript
    exports: { PARAMS_CONTAINS },
    illegal: /#(?![$_A-z])/,
    contains: [
      hljs.SHEBANG({
        label: "shebang",
        binary: "node",
        relevance: 5
      }),
      {
        label: "use_strict",
        className: 'meta',
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      HTML_TEMPLATE,
      CSS_TEMPLATE,
      TEMPLATE_STRING,
      COMMENT,
      NUMBER,
      { // object attr container
        begin: concat(/[{,\n]\s*/,
          // we need to look ahead to make sure that we actually have an
          // attribute coming up so we don't steal a comma from a potential
          // "value" container
          //
          // NOTE: this might not work how you think.  We don't actually always
          // enter this mode and stay.  Instead it might merely match `,
          // <comments up next>` and then immediately end after the , because it
          // fails to find any actual attrs. But this still does the job because
          // it prevents the value contain rule from grabbing this instead and
          // prevening this rule from firing when we actually DO have keys.
          lookahead(concat(
            // we also need to allow for multiple possible comments inbetween
            // the first key:value pairing
            /(((\/\/.*$)|(\/\*(\*[^/]|[^*])*\*\/))\s*)*/,
            IDENT_RE$1 + '\\s*:'))),
        relevance: 0,
        contains: [
          {
            className: 'attr',
            begin: IDENT_RE$1 + lookahead('\\s*:'),
            relevance: 0
          }
        ]
      },
      { // "value" container
        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
        keywords: 'return throw case',
        contains: [
          COMMENT,
          hljs.REGEXP_MODE,
          {
            className: 'function',
            // we have to count the parens to make sure we actually have the
            // correct bounding ( ) before the =>.  There could be any number of
            // sub-expressions inside also surrounded by parens.
            begin: '(\\(' +
            '[^()]*(\\(' +
            '[^()]*(\\(' +
            '[^()]*' +
            '\\)[^()]*)*' +
            '\\)[^()]*)*' +
            '\\)|' + hljs.UNDERSCORE_IDENT_RE + ')\\s*=>',
            returnBegin: true,
            end: '\\s*=>',
            contains: [
              {
                className: 'params',
                variants: [
                  {
                    begin: hljs.UNDERSCORE_IDENT_RE,
                    relevance: 0
                  },
                  {
                    className: null,
                    begin: /\(\s*\)/,
                    skip: true
                  },
                  {
                    begin: /\(/,
                    end: /\)/,
                    excludeBegin: true,
                    excludeEnd: true,
                    keywords: KEYWORDS$1,
                    contains: PARAMS_CONTAINS
                  }
                ]
              }
            ]
          },
          { // could be a comma delimited list of params to a function call
            begin: /,/, relevance: 0
          },
          {
            className: '',
            begin: /\s/,
            end: /\s*/,
            skip: true
          },
          { // JSX
            variants: [
              { begin: FRAGMENT.begin, end: FRAGMENT.end },
              {
                begin: XML_TAG.begin,
                // we carefully check the opening tag to see if it truly
                // is a tag and not a false positive
                'on:begin': XML_TAG.isTrulyOpeningTag,
                end: XML_TAG.end
              }
            ],
            subLanguage: 'xml',
            contains: [
              {
                begin: XML_TAG.begin,
                end: XML_TAG.end,
                skip: true,
                contains: ['self']
              }
            ]
          }
        ],
        relevance: 0
      },
      {
        className: 'function',
        beginKeywords: 'function',
        end: /[{;]/,
        excludeEnd: true,
        keywords: KEYWORDS$1,
        contains: [
          'self',
          hljs.inherit(hljs.TITLE_MODE, { begin: IDENT_RE$1 }),
          PARAMS
        ],
        illegal: /%/
      },
      {
        // prevent this from getting swallowed up by function
        // since they appear "function like"
        beginKeywords: "while if switch catch for"
      },
      {
        className: 'function',
        // we have to count the parens to make sure we actually have the correct
        // bounding ( ).  There could be any number of sub-expressions inside
        // also surrounded by parens.
        begin: hljs.UNDERSCORE_IDENT_RE +
          '\\(' + // first parens
          '[^()]*(\\(' +
            '[^()]*(\\(' +
              '[^()]*' +
            '\\)[^()]*)*' +
          '\\)[^()]*)*' +
          '\\)\\s*\\{', // end parens
        returnBegin:true,
        contains: [
          PARAMS,
          hljs.inherit(hljs.TITLE_MODE, { begin: IDENT_RE$1 }),
        ]
      },
      // hack: prevents detection of keywords in some circumstances
      // .keyword()
      // $keyword = x
      {
        variants: [
          { begin: '\\.' + IDENT_RE$1 },
          { begin: '\\$' + IDENT_RE$1 }
        ],
        relevance: 0
      },
      { // ES6 class
        className: 'class',
        beginKeywords: 'class',
        end: /[{;=]/,
        excludeEnd: true,
        illegal: /[:"[\]]/,
        contains: [
          { beginKeywords: 'extends' },
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        begin: /\b(?=constructor)/,
        end: /[{;]/,
        excludeEnd: true,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, { begin: IDENT_RE$1 }),
          'self',
          PARAMS
        ]
      },
      {
        begin: '(get|set)\\s+(?=' + IDENT_RE$1 + '\\()',
        end: /\{/,
        keywords: "get set",
        contains: [
          hljs.inherit(hljs.TITLE_MODE, { begin: IDENT_RE$1 }),
          { begin: /\(\)/ }, // eat to avoid empty params
          PARAMS
        ]
      },
      {
        begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
      }
    ]
  };
}

/*
Language: TypeScript
Author: Panu Horsmalahti <panu.horsmalahti@iki.fi>
Contributors: Ike Ku <dempfi@yahoo.com>
Description: TypeScript is a strict superset of JavaScript
Website: https://www.typescriptlang.org
Category: common, scripting
*/

/** @type LanguageFn */
function typescript(hljs) {
  const IDENT_RE$1 = IDENT_RE;
  const NAMESPACE = {
    beginKeywords: 'namespace', end: /\{/, excludeEnd: true
  };
  const INTERFACE = {
    beginKeywords: 'interface', end: /\{/, excludeEnd: true,
    keywords: 'interface extends'
  };
  const USE_STRICT = {
    className: 'meta',
    relevance: 10,
    begin: /^\s*['"]use strict['"]/
  };
  const TYPES = [
    "any",
    "void",
    "number",
    "boolean",
    "string",
    "object",
    "never",
    "enum"
  ];
  const TS_SPECIFIC_KEYWORDS = [
    "type",
    "namespace",
    "typedef",
    "interface",
    "public",
    "private",
    "protected",
    "implements",
    "declare",
    "abstract",
    "readonly"
  ];
  const KEYWORDS$1 = {
    $pattern: IDENT_RE,
    keyword: KEYWORDS.concat(TS_SPECIFIC_KEYWORDS),
    literal: LITERALS,
    built_in: BUILT_INS.concat(TYPES)
  };
  const DECORATOR = {
    className: 'meta',
    begin: '@' + IDENT_RE$1,
  };

  const swapMode = (mode, label, replacement) => {
    const indx = mode.contains.findIndex(m => m.label === label);
    if (indx === -1) { throw new Error("can not find mode to replace"); }
    mode.contains.splice(indx, 1, replacement);
  };

  const tsLanguage = javascript(hljs);

  // this should update anywhere keywords is used since
  // it will be the same actual JS object
  Object.assign(tsLanguage.keywords, KEYWORDS$1);

  tsLanguage.exports.PARAMS_CONTAINS.push(DECORATOR);
  tsLanguage.contains = tsLanguage.contains.concat([
    DECORATOR,
    NAMESPACE,
    INTERFACE,
  ]);

  // TS gets a simpler shebang rule than JS
  swapMode(tsLanguage, "shebang", hljs.SHEBANG());
  // JS use strict rule purposely excludes `asm` which makes no sense
  swapMode(tsLanguage, "use_strict", USE_STRICT);

  const functionDeclaration = tsLanguage.contains.find(m => m.className === "function");
  functionDeclaration.relevance = 0; // () => {} is more typical in TypeScript

  Object.assign(tsLanguage, {
    name: 'TypeScript',
    aliases: ['ts', 'tsx']
  });

  return tsLanguage;
}

module.exports = typescript;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;

  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function optional(re) {
  return concat('(', re, ')?');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat(...args) {
  const joined = args.map((x) => source(x)).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either(...args) {
  const joined = '(' + args.map((x) => source(x)).join("|") + ")";
  return joined;
}

/*
Language: HTML, XML
Website: https://www.w3.org/XML/
Category: common
Audit: 2020
*/

/** @type LanguageFn */
function xml(hljs) {
  // Element names can contain letters, digits, hyphens, underscores, and periods
  const TAG_NAME_RE = concat(/[A-Z_]/, optional(/[A-Z0-9_.-]*:/), /[A-Z0-9_.-]*/);
  const XML_IDENT_RE = /[A-Za-z0-9._:-]+/;
  const XML_ENTITIES = {
    className: 'symbol',
    begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
  };
  const XML_META_KEYWORDS = {
    begin: /\s/,
    contains: [
      {
        className: 'meta-keyword',
        begin: /#?[a-z_][a-z1-9_-]+/,
        illegal: /\n/
      }
    ]
  };
  const XML_META_PAR_KEYWORDS = hljs.inherit(XML_META_KEYWORDS, {
    begin: /\(/,
    end: /\)/
  });
  const APOS_META_STRING_MODE = hljs.inherit(hljs.APOS_STRING_MODE, {
    className: 'meta-string'
  });
  const QUOTE_META_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, {
    className: 'meta-string'
  });
  const TAG_INTERNALS = {
    endsWithParent: true,
    illegal: /</,
    relevance: 0,
    contains: [
      {
        className: 'attr',
        begin: XML_IDENT_RE,
        relevance: 0
      },
      {
        begin: /=\s*/,
        relevance: 0,
        contains: [
          {
            className: 'string',
            endsParent: true,
            variants: [
              {
                begin: /"/,
                end: /"/,
                contains: [ XML_ENTITIES ]
              },
              {
                begin: /'/,
                end: /'/,
                contains: [ XML_ENTITIES ]
              },
              {
                begin: /[^\s"'=<>`]+/
              }
            ]
          }
        ]
      }
    ]
  };
  return {
    name: 'HTML, XML',
    aliases: [
      'html',
      'xhtml',
      'rss',
      'atom',
      'xjb',
      'xsd',
      'xsl',
      'plist',
      'wsf',
      'svg'
    ],
    case_insensitive: true,
    contains: [
      {
        className: 'meta',
        begin: /<![a-z]/,
        end: />/,
        relevance: 10,
        contains: [
          XML_META_KEYWORDS,
          QUOTE_META_STRING_MODE,
          APOS_META_STRING_MODE,
          XML_META_PAR_KEYWORDS,
          {
            begin: /\[/,
            end: /\]/,
            contains: [
              {
                className: 'meta',
                begin: /<![a-z]/,
                end: />/,
                contains: [
                  XML_META_KEYWORDS,
                  XML_META_PAR_KEYWORDS,
                  QUOTE_META_STRING_MODE,
                  APOS_META_STRING_MODE
                ]
              }
            ]
          }
        ]
      },
      hljs.COMMENT(
        /<!--/,
        /-->/,
        {
          relevance: 10
        }
      ),
      {
        begin: /<!\[CDATA\[/,
        end: /\]\]>/,
        relevance: 10
      },
      XML_ENTITIES,
      {
        className: 'meta',
        begin: /<\?xml/,
        end: /\?>/,
        relevance: 10
      },
      {
        className: 'tag',
        /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending braket. The '$' is needed for the lexeme to be recognized
        by hljs.subMode() that tests lexemes outside the stream.
        */
        begin: /<style(?=\s|>)/,
        end: />/,
        keywords: {
          name: 'style'
        },
        contains: [ TAG_INTERNALS ],
        starts: {
          end: /<\/style>/,
          returnEnd: true,
          subLanguage: [
            'css',
            'xml'
          ]
        }
      },
      {
        className: 'tag',
        // See the comment in the <style tag about the lookahead pattern
        begin: /<script(?=\s|>)/,
        end: />/,
        keywords: {
          name: 'script'
        },
        contains: [ TAG_INTERNALS ],
        starts: {
          end: /<\/script>/,
          returnEnd: true,
          subLanguage: [
            'javascript',
            'handlebars',
            'xml'
          ]
        }
      },
      // we need this for now for jSX
      {
        className: 'tag',
        begin: /<>|<\/>/
      },
      // open tag
      {
        className: 'tag',
        begin: concat(
          /</,
          lookahead(concat(
            TAG_NAME_RE,
            // <tag/>
            // <tag>
            // <tag ...
            either(/\/>/, />/, /\s/)
          ))
        ),
        end: /\/?>/,
        contains: [
          {
            className: 'name',
            begin: TAG_NAME_RE,
            relevance: 0,
            starts: TAG_INTERNALS
          }
        ]
      },
      // close tag
      {
        className: 'tag',
        begin: concat(
          /<\//,
          lookahead(concat(
            TAG_NAME_RE, />/
          ))
        ),
        contains: [
          {
            className: 'name',
            begin: TAG_NAME_RE,
            relevance: 0
          },
          {
            begin: />/,
            relevance: 0,
            endsParent: true
          }
        ]
      }
    ]
  };
}

module.exports = xml;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(362);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, "@keyframes runningAnimation{100%{transform:rotate(360deg)}}.bolt-status{fill:currentColor}.bolt-status.success{color:#55a362;color:var(--component-status-success, #55a362)}@media (forced-colors: active){.bolt-status.success{fill:#55a362;fill:var(--component-status-success, #55a362)}}.bolt-status.failed{color:#cd4a45;color:var(--component-status-error, #cd4a45)}@media (forced-colors: active){.bolt-status.failed{fill:#cd4a45;fill:var(--component-status-error, #cd4a45)}}.bolt-status.warning{color:#d67f3c;color:var(--component-status-warning, #d67f3c)}@media (forced-colors: active){.bolt-status.warning{fill:#d67f3c;fill:var(--component-status-warning, #d67f3c)}}.bolt-status.active{color:#0078d4;color:var(--component-status-info, #0078d4)}@media (forced-colors: active){.bolt-status.active{fill:#0078d4;fill:var(--component-status-info, #0078d4)}}.bolt-status.neutral{color:#666;color:var(--component-status-neutral, #666)}@media (forced-colors: active){.bolt-status.neutral{fill:#666;fill:var(--component-status-neutral, #666)}}.bolt-status.animate{animation:runningAnimation 8s infinite linear}.bolt-status.small-animate{animation:runningAnimation 4s infinite linear}.bolt-status.rotate{transform:rotate(180deg)}.bolt-status-text{padding-right:12px;padding-top:3px;padding-bottom:5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.bolt-status-text.xl{padding-right:16px;padding-top:5px;padding-bottom:7px}.bolt-status-text-extra-padding{padding-left:8px}.bolt-status-extended{color:#fff;color:rgba(var(--palette-neutral-0, 255, 255, 255), 1);height:24px;border-radius:15px}.bolt-status-extended.xl{border-radius:48px;height:32px}.bolt-status-extended.success{background-color:#55a362;background-color:var(--component-status-success, #55a362)}.bolt-status-extended.failed{background-color:#cd4a45;background-color:var(--component-status-error, #cd4a45)}.bolt-status-extended.warning{background-color:#d67f3c;background-color:var(--component-status-warning, #d67f3c)}.bolt-status-extended.active{background-color:#0078d4;background-color:var(--component-status-info, #0078d4)}.bolt-status-extended.neutral{background-color:#666;background-color:var(--component-status-neutral, #666)}\n", ""]);



/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(364);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-pill{border-radius:120px;border:1px solid transparent;white-space:nowrap}.bolt-pill.clickable{cursor:pointer}.bolt-pill.count .bolt-pill-content{font-weight:600}.bolt-pill .bolt-pill-content{margin:0px 0.5rem;padding:2px 0}.bolt-pill .bolt-pill-icon{margin-left:0.25rem;margin-right:0.375rem}.bolt-pill.compact.has-filled-visual .bolt-pill-content,.bolt-pill.compact.has-icon .bolt-pill-content,.bolt-pill.regular.has-filled-visual .bolt-pill-content,.bolt-pill.regular.has-icon .bolt-pill-content,.bolt-pill.large.has-filled-visual .bolt-pill-content,.bolt-pill.large.has-icon .bolt-pill-content{margin-left:0}.bolt-pill.compact.has-remove-button .bolt-pill-content,.bolt-pill.regular.has-remove-button .bolt-pill-content,.bolt-pill.large.has-remove-button .bolt-pill-content{margin-right:0.375rem}.bolt-pill.compact{font-size:0.6875rem}.bolt-pill.regular{font-size:0.75rem}.bolt-pill.regular .bolt-pill-filled-visual{width:1.25rem}.bolt-pill.large{font-size:0.875rem}.bolt-pill.large .bolt-pill-filled-visual{width:1.5rem}.bolt-pill.standard{background-color:rgba(0,0,0,0.06);background-color:var(--palette-black-alpha-6, rgba(0,0,0,0.06))}.bolt-pill.standard.clickable.hover{background-color:rgba(0,0,0,0.1);background-color:var(--palette-black-alpha-10, rgba(0,0,0,0.1))}.bolt-pill.outlined{background-color:transparent;border-color:rgba(0,0,0,0.2);border-color:var(--palette-black-alpha-20, rgba(0,0,0,0.2))}.bolt-pill.outlined.clickable.hover{background-color:rgba(0,0,0,0.06);background-color:var(--palette-black-alpha-6, rgba(0,0,0,0.06))}.bolt-pill.outlined .bolt-pill-button{border:1px solid transparent}.bolt-pill.colored.dark{color:white}.bolt-pill.colored.light{color:black}.bolt-focus-visible .bolt-pill:focus{border-color:#0078d4;border-color:var(--communication-background, #0078d4);animation:ms-focus-shadow-pulse 4s ease-in-out infinite;box-shadow:0 0 0 3px rgba(0,120,212,0.23);box-shadow:0 0 0 3px var(--focus-pulse-max-color, rgba(0,120,212,0.23));outline:none}@media (forced-colors: active){.bolt-focus-visible .bolt-pill:focus{animation:none}}@media (forced-colors: active){.bolt-focus-visible .bolt-pill:focus{forced-color-adjust:none;border-color:highlight}}@media screen and (-ms-high-contrast: black-on-white){.bolt-focus-visible .bolt-pill:focus{outline:1px solid highlight;outline-offset:1px}}@media (forced-colors: active){.bolt-focus-visible .bolt-pill:focus{background:transparent !important;color:windowtext}}.bolt-pill-icon{padding:2px}.bolt-pill-filled-visual{overflow:hidden;border-radius:50%;margin-right:4px}button.bolt-pill-button.bolt-button.icon-only{border-radius:50%;color:inherit;margin-left:auto;padding:2px}button.bolt-pill-button.bolt-button.icon-only:hover{background-color:rgba(0,0,0,0.06);background-color:var(--palette-black-alpha-6, rgba(0,0,0,0.06))}\n", ""]);



/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPathCell = void 0;
const TooltipEx_1 = __webpack_require__(19);
const React = __webpack_require__(0);
const getRepoUri_1 = __webpack_require__(105);
const Hi_1 = __webpack_require__(70);
__webpack_require__(98);
const TooltipSpan_1 = __webpack_require__(377);
const try_1 = __webpack_require__(59);
function isValidURL(url) {
    try {
        return !!new URL(url);
    }
    catch (error) {
        return false;
    }
}
function openInNewTab(fileName, text, region) {
    var _a, _b, _c;
    const line = (_a = region === null || region === void 0 ? void 0 : region.startLine) !== null && _a !== void 0 ? _a : 1;
    const col = (_b = region === null || region === void 0 ? void 0 : region.startColumn) !== null && _b !== void 0 ? _b : 1;
    const length = ((_c = region === null || region === void 0 ? void 0 : region.endColumn) !== null && _c !== void 0 ? _c : 1) - col;
    const [_, pre, hi, post] = new RegExp(`((?:.*?\\n){${line - 1}}.{${col - 1}})(.{${length}})((?:.|\\n)*)`, 's').exec(text);
    const escape = unsafe => unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    const { document } = window.open();
    document.title = fileName;
    document.body.innerHTML = `<pre>${escape(pre)}<mark>${escape(hi)}</mark>${escape(post)}</pre>`;
    setTimeout(() => document.body.querySelector('mark').scrollIntoView({ block: 'center' }));
}
// TODO:
// Unify runArt vs resultArt.
// Distinguish uri and text.
function renderPathCell(result) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const ploc = (_b = (_a = result.locations) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.physicalLocation;
    const resArtLoc = (_c = ploc === null || ploc === void 0 ? void 0 : ploc.artifactLocation) !== null && _c !== void 0 ? _c : result.analysisTarget;
    const runArt = (_d = result.run.artifacts) === null || _d === void 0 ? void 0 : _d[(_e = resArtLoc === null || resArtLoc === void 0 ? void 0 : resArtLoc.index) !== null && _e !== void 0 ? _e : -1];
    const runArtLoc = runArt === null || runArt === void 0 ? void 0 : runArt.location;
    const uri = (_k = (_j = (_g = (_f = resArtLoc === null || resArtLoc === void 0 ? void 0 : resArtLoc.description) === null || _f === void 0 ? void 0 : _f.text) !== null && _g !== void 0 ? _g : (_h = runArtLoc === null || runArtLoc === void 0 ? void 0 : runArtLoc.description) === null || _h === void 0 ? void 0 : _h.text // vs runArt?.description?.text?
    ) !== null && _j !== void 0 ? _j : resArtLoc === null || resArtLoc === void 0 ? void 0 : resArtLoc.uri) !== null && _k !== void 0 ? _k : runArtLoc === null || runArtLoc === void 0 ? void 0 : runArtLoc.uri; // Commonly a relative URI.
    const [path, fileName] = (() => {
        if (!uri)
            return ['—'];
        const index = uri.lastIndexOf('/');
        return index >= 0
            ? [uri.slice(0, index), uri.slice(index + 1)]
            : [uri];
    })();
    const uriWithEllipsis = fileName // This is what ultimately gets displayed
        ? React.createElement("span", { className: "midEllipsis" },
            React.createElement("span", null,
                React.createElement(Hi_1.Hi, null, path)),
            React.createElement("span", null,
                React.createElement(Hi_1.Hi, null,
                    "/",
                    fileName)))
        : React.createElement(Hi_1.Hi, null, uri !== null && uri !== void 0 ? uri : '—');
    // Example of href scenario:
    // uri  = src\Prototypes\README.md
    // href = https://org.visualstudio.com/project/_git/repo?path=%2Fsrc%2FPrototypes%2FREADME.md&_a=preview
    const href = (_l = resArtLoc === null || resArtLoc === void 0 ? void 0 : resArtLoc.properties) === null || _l === void 0 ? void 0 : _l['href'];
    const runArtContentsText = (_m = runArt === null || runArt === void 0 ? void 0 : runArt.contents) === null || _m === void 0 ? void 0 : _m.text;
    const repoUri = (_o = (0, getRepoUri_1.getRepoUri)(uri, result.run, ploc === null || ploc === void 0 ? void 0 : ploc.region)) !== null && _o !== void 0 ? _o : uri;
    const getHref = () => {
        if (uri === null || uri === void 0 ? void 0 : uri.endsWith('.dll'))
            return undefined;
        if (href)
            return href;
        if (runArtContentsText)
            return '#';
        if (!isValidURL(repoUri))
            return undefined; // uri as artDesc case takes this code path.
        return repoUri;
    };
    const region = ploc === null || ploc === void 0 ? void 0 : ploc.region;
    const onClick = event => {
        if (href)
            return; // TODO: Test precedence.
        if (!runArtContentsText)
            return;
        event.preventDefault();
        event.stopPropagation();
        openInNewTab(fileName, runArtContentsText, region); // BUG: if uri is "aaa", then fileName will be empty
    };
    const rowClasses = 'bolt-table-two-line-cell-item flex-row scroll-hidden';
    return (0, try_1.tryOr)(() => React.createElement("div", { className: "flex-column scroll-hidden" },
        React.createElement("div", { className: rowClasses },
            React.createElement("div", { className: "fontsize font-size swcWidth100" },
                React.createElement(TooltipEx_1.Tooltip, { overflowOnly: true },
                    React.createElement("pre", { style: { margin: 0 } },
                        React.createElement("code", null,
                            React.createElement(Hi_1.Hi, null, result.locations[0].logicalLocations[0].fullyQualifiedName)))))),
        (0, try_1.tryOr)(() => {
            if (!uri)
                throw undefined;
            return React.createElement("div", { className: rowClasses },
                React.createElement(TooltipSpan_1.TooltipSpan, { overflowOnly: true, text: href !== null && href !== void 0 ? href : uri }, (0, try_1.tryLink)(getHref, uriWithEllipsis, 'fontSize font-size secondary-text swcColorUnset swcWidth100' /* Override .bolt-list-cell */, onClick)));
        })), () => React.createElement("div", { className: "flex-row scroll-hidden" },
        React.createElement(TooltipSpan_1.TooltipSpan, { text: href !== null && href !== void 0 ? href : uri }, (0, try_1.tryLink)(getHref, uriWithEllipsis, 'swcColorUnset', onClick))));
}
exports.renderPathCell = renderPathCell;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var path = __webpack_require__(99),
    util = __webpack_require__(367);

var url = __webpack_require__(370);

module.exports = function uriJoin() {
  if(arguments.length == 0) { return null; }
  if(arguments.length == 1) { return arguments[0]; }
  var head = arguments[0] + '';
  var tail = [];
  for(var i = 1; i < arguments.length; i += 1) {
    tail.push(arguments[i] + '');
  }

  var urlParsed = url.parse(head);
  if(urlParsed.protocol) {
    var joined = path.join.apply(null, [urlParsed.hostname, urlParsed.path].concat(tail));
    return util.format("%s//%s", urlParsed.protocol, joined);
  } else {
    return path.join.apply(null, [urlParsed.path].concat(tail));
  }
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(368);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(369);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(50)))

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(371);
var util = __webpack_require__(373);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(374);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.3.2 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports =  true && exports &&
		!exports.nodeType && exports;
	var freeModule =  true && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}(this));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(372)(module), __webpack_require__(95)))

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(375);
exports.encode = exports.stringify = __webpack_require__(376);


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipSpan = void 0;
const React = __webpack_require__(0);
const TooltipEx_1 = __webpack_require__(19);
// Bridges two common gaps in azure-devops-ui/TooltipEx/Tooltip:
// - Tooltips with plain text. React.Children.only() rejects string.
// - Tooltips with a child that does not support onMouseEnter/Leave.
class TooltipSpan extends React.Component {
    render() {
        return React.createElement(TooltipEx_1.Tooltip, Object.assign({}, this.props),
            React.createElement("span", { style: { overflow: 'hidden' } }, this.props.children));
    }
}
exports.TooltipSpan = TooltipSpan;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderActionsCell = void 0;
const Link_1 = __webpack_require__(30);
const React = __webpack_require__(0);
__webpack_require__(98);
const emptyPng = __webpack_require__(379);
const vsCodePng = __webpack_require__(380);
const images = {
    empty: emptyPng,
    vscode: vsCodePng,
};
function renderAction(props) {
    const { text, linkUrl, imageName, className } = props;
    return React.createElement(Link_1.Link, { href: linkUrl, target: "_blank", className: className },
        React.createElement("img", { src: images[imageName !== null && imageName !== void 0 ? imageName : 'empty'], alt: text }),
        text);
}
function renderActionsCell(result) {
    var _a;
    return (_a = result.actions) === null || _a === void 0 ? void 0 : _a.map(actionProps => React.createElement("div", { className: "action" }, renderAction(actionProps)));
}
exports.renderActionsCell = renderActionsCell;


/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAADUlEQVQImWP4//8/AwAI/AL+hc2rNAAAAABJRU5ErkJggg=="

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAE72lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgOS4wLWMwMDAgMTM3LmRhNGE3ZTUsIDIwMjIvMTEvMjctMDk6MzU6MDMgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIiB4bWxuczpwaG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdEV2dD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlRXZlbnQjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyNC4xIChXaW5kb3dzKSIgeG1wOkNyZWF0ZURhdGU9IjIwMjMtMDItMTJUMTE6MzY6NTgtMTA6MDAiIHhtcDpNb2RpZnlEYXRlPSIyMDIzLTAyLTE3VDEzOjE1OjE0LTEwOjAwIiB4bXA6TWV0YWRhdGFEYXRlPSIyMDIzLTAyLTE3VDEzOjE1OjE0LTEwOjAwIiBkYzpmb3JtYXQ9ImltYWdlL3BuZyIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpkMGY5ZGQ5MS0xNDVjLWE1NDctYTBhMC01MGE4NDdjMmFlMWMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ZDBmOWRkOTEtMTQ1Yy1hNTQ3LWEwYTAtNTBhODQ3YzJhZTFjIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6ZDBmOWRkOTEtMTQ1Yy1hNTQ3LWEwYTAtNTBhODQ3YzJhZTFjIj4gPHhtcE1NOkhpc3Rvcnk+IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDpkMGY5ZGQ5MS0xNDVjLWE1NDctYTBhMC01MGE4NDdjMmFlMWMiIHN0RXZ0OndoZW49IjIwMjMtMDItMTJUMTE6MzY6NTgtMTA6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyNC4xIChXaW5kb3dzKSIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7++LN0AAAIKUlEQVRYw8WXe3BU5RnGf9+57W7uV3KBkGgSIc0GCIoGsdW2qEOtGbBeWkXbylRGnM60SnWKdrRItZ0O3kbtTLVBR2GmWrRUK1qktmhrOwQC5kq4JBiSTcgm2WSzl3P2nPP1j80VtDOKM34z7x97dvd7n/M+z/t87yeklHyZSwOora2dejAJSAjxmTaSElTdQI8MMmZJzJLKIv1kZ8A72o8+txzHSMF1bGbu2tTUhPJFvYmi63hjQ4SCg3TX3PzI0PVb3jJ/8MiTofJl5413H0E93YWhaSBmpxRSynOugNAMfOP9BIZCdH3r0V34r64nMsqCa5fimhDb+9rLyp5tT3gPvnUgIzsbCs7DdlyaDh44twpICYpukBLuo3dwhK7VT+zh4tX1DB5FiQRxuobRo5BRf91afesbjeF7djScLqj2x3s60dxEsnLnklzzePAMf0xXWGafXPtiE9VXrKS3JfmlECAUZMIk0R1GG4iRteamH+p/+GfzwLX3bw73n/r8ACSgeww8A50cN735fbe+2Eqpfwn9nUmOZRKhlEksSIFrO9hdYYxR8K7Z+IuRtOLsWQCkUFAFeMcHMOwYqDryU5J7dB21r50OrcR/+tZtbeQUFTFwfCK5nBGAO/EnCSBwY8DYSMJVVN8UAKmoeF0TayjAx/MvuzCYUA1P8AS64ZkFQgJeXcPtbaM1q/bK4dteaCYjJ49gd3IrV06EC4oGiIkSzFQs4Dq2As4UAJ9rEjnZQceydQ8EfvpqY9f3X2jt1osq1O4mvKpACgWJwKcJ7J4W2vMvvWb8u8/8DcWB4VMTySaE4TqQWYjUvGDFwijK/yFyAsDoUFBt/favn07cuOVhuo9AycKKgfveO9pcc8u6aHcLPjuKz1CI9XTQUvGdOyM3PfEmiTCMngahTiR2kxQULoC29/4jXtpwuXCsIakZs1mZihkAAqSnya/fcRexMYjHYKAb7BjROxqeb65//Peh3i7izQdoWXz7z836zc8SDUJkZJpzxwZfOhQthL0NO7VX7l2eOXx0n+PJKnIdkI6cESDdaZ/RANJGPh4NPbvuHu7esZXMguSbRUIQG4cr1/+oIzO3QBzed0Qu+d7PGOkG25x2NMeG/FKwLHhu/caM1t1bK+fnM5BRVmiaUUdLz/hU/5oCULzQj9X4p8dOP9Dbzy//vh3VgKFTgAOnWqHmqnq56Bpo+TcMDUNGOqhaksd5NXC8sZeGO1fPtQYb5y9bCvEwZjQqDSkQk5mmrHf2ZwXAQaH8kmUUdn24g00rrscVkF8Gtg1Cg6E+GO2DsgqYMxfGwuBIKLgAPtj+tvLM9f4KX6SxtO5SLKlgxk1ASHFmG06GO61CBcBOWJi25PzldZQNHtyp3b2wiu6POsgqBsdN/jSRADMOBXOhYhGYVkg8e8vNWa/dv6qmsjSUX1VLNBLFdRyEEAhFTPrRWdYgJUh3hgiFEDh2goQrKD1/LmnmcAdtBy1MCzzepMIlSTDxKKRnQNkCqSl28/mZkJWTSzQW/0xeKhQxDUBKMDwelIEjtMYzFoR+/GaA8gsXcfh9GA+DNyUJYnKNBsHjy07c/35z69VbfhU41k7qeABFn2lcUkg3qfhZ4YCUYtIGkgAMj4Hoa6VdP+/S4A3PtZKaU0gsCIYOx1ohZkNuKThOsgpChfAwBE9irrpvU+ftuz7sihl5nt7DGLqORCBd5Fncz4hZPuCGArRnX7xybPXj/0ITKiOnQArweGB+NRzYfYIP/7iX4qqk+qULippsx75mWLCiLrDh7Y72gsu+4XQfJAUToerqpNpmZ5+gQMygoMf0pIWvenAPHgNGA8nG0T0wpxJa39lj7Lzbn7Jt/Ur+8psGiqpA9SSr4QJSgb42SM3IDa1/fe9HKzY9PNwbQB89FUAx9E92wTPbcLjXou3d90nNSRpMeh5kFsOuR570vLbpqq9UlsVqFleT8vqD63j53t9RXAXe9KTvJ+cxCAUg1EOi/qEH2tY8/dKokpZrmKOBswowVQg57YQlxUVWZPeWr8XjY6+wauMN9ByO0rDhtvyBlp2li/0ovjRcCdWLqjm6Z+uGUKg/wB3Pb0b0w3hw4jBSwIpDTxPUXrc2Mr+uPk/oFlacs45UOWWESQBGTiH+ao3Ofzx149jRD9Yog53NZb7EscLldVi2gxmLAWD40qi6qJZj+7c/PDjc08PGv25DNSDUN338CgEjvQgtLcMxslATNnJGA011w0wRmtEIIi2byiVLKI+1vV41L+fYnKqlxOImCctKGosQWPE4CaFRcckyCo7ve4FHV96C0CGnFGxrNsGJKMJxkmI+0wWFqgpVU2YZkRWP4wqF3PJF+LLnEItGkVLOmo6FECQsC8uRlC+vo6T3vzt4aNnlhIfj5FeCnTjDbuVZg6RQQfGmGW7CTMwayYQQSNfFsixs2/7UsVwIgZ1IEDct5tetoCx2ch+bl9cRCkQpqkqCmLDZqQnJdsEV6PmZaPNg5N2GV+Wp9uDnHkqFELiuSzQapfiiFVSkRA7z0FI/x/d3UeSfaFF3YjpW0Auz0IrSGT2wb/+xO+vXiu133Tiv/IJzG8snLzHRSISCmkuoytO7eOybflr2tFJyIS4+tKJctJIURg7s23/iJ19dNfLg5RfP7Xhju3/JYozM7E++GX3e5UtNY6y7gyO9Qa+95vE/p1xx3RW+/pbGsd1P/VY99M6uOamQX1mD4UsjHo/jui6HDh364gAAeFNTiQ720XOiCyuvsEj09wfy0hXyK/yo3lQs08SZOK4nL6fiy76e/w+PEBeEhosX9AAAAABJRU5ErkJggg=="

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getRepositoryDetailsFromRemoteUrl = exports.isRepositoryDetailsComplete = void 0;
// https://dev.azure.com/ OR https://org@dev.azure.com/
const AzureReposUrl = 'dev.azure.com/';
// git@ssh.dev.azure.com:v3/
const SSHAzureReposUrl = 'ssh.dev.azure.com:v3/';
// https://org.visualstudio.com/
const VSOUrl = '.visualstudio.com/';
// org@vs-ssh.visualstudio.com:v3/
const SSHVsoReposUrl = 'vs-ssh.visualstudio.com:v3/';
const failedToDetermineAzureRepoDetails = 'Failed to determine Azure Repo details from remote url. Please ensure that the remote points to a valid Azure Repos url.';
const notAzureRepoUrl = 'The repo isn\'t hosted with Azure Repos.';
function isRepositoryDetailsComplete(repositoryDetails) {
    return repositoryDetails
        && repositoryDetails.organizationName
        && repositoryDetails.projectName
        && repositoryDetails.repositoryName
        && !repositoryDetails.errorMessage;
}
exports.isRepositoryDetailsComplete = isRepositoryDetailsComplete;
function getRepositoryDetailsFromRemoteUrl(remoteUrl) {
    if (remoteUrl.indexOf(AzureReposUrl) >= 0) {
        const part = remoteUrl.substring(remoteUrl.indexOf(AzureReposUrl) + AzureReposUrl.length);
        const parts = part.split('/');
        if (parts.length !== 4) {
            return { errorMessage: failedToDetermineAzureRepoDetails };
        }
        return {
            organizationName: parts[0].trim(),
            projectName: parts[1].trim(),
            repositoryName: parts[3].split('?')[0].trim()
        };
    }
    else if (remoteUrl.indexOf(VSOUrl) >= 0) {
        const part = remoteUrl.substring(remoteUrl.indexOf(VSOUrl) + VSOUrl.length);
        const organizationName = remoteUrl.substring(remoteUrl.indexOf('https://') + 'https://'.length, remoteUrl.indexOf('.visualstudio.com'));
        const parts = part.split('/');
        if (parts.length === 4 && parts[0].toLowerCase() === 'defaultcollection') {
            // Handle scenario where part is 'DefaultCollection/<project>/_git/<repository>'
            parts.shift();
        }
        if (parts.length !== 3) {
            return { errorMessage: failedToDetermineAzureRepoDetails };
        }
        return {
            organizationName: organizationName,
            projectName: parts[0].trim(),
            repositoryName: parts[2].split('?')[0].trim()
        };
    }
    else if (remoteUrl.indexOf(SSHAzureReposUrl) >= 0 || remoteUrl.indexOf(SSHVsoReposUrl) >= 0) {
        const urlFormat = remoteUrl.indexOf(SSHAzureReposUrl) >= 0 ? SSHAzureReposUrl : SSHVsoReposUrl;
        const part = remoteUrl.substring(remoteUrl.indexOf(urlFormat) + urlFormat.length);
        const parts = part.split('/');
        if (parts.length !== 3) {
            return { errorMessage: failedToDetermineAzureRepoDetails };
        }
        return {
            organizationName: parts[0].trim(),
            projectName: parts[1].trim(),
            repositoryName: parts[2].split('?')[0].trim()
        };
    }
    else {
        return { errorMessage: notAzureRepoUrl };
    }
}
exports.getRepositoryDetailsFromRemoteUrl = getRepositoryDetailsFromRemoteUrl;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeColumnSorting = void 0;
const List_1 = __webpack_require__(21);
const Util_1 = __webpack_require__(1);
const Table_1 = __webpack_require__(24);
// Derived from azure-devops-ui ColumnSorting.ts
class TreeColumnSorting {
    constructor(onSort) {
        this.initialize = (props, table, eventDispatch) => {
            this.props = props;
            eventDispatch.addEventListener("click", this.onClick);
            eventDispatch.addEventListener("keydown", this.onKeyDown);
        };
        this.onClick = (event) => {
            if (!event.defaultPrevented) {
                this.processSortEvent(event);
            }
        };
        this.onKeyDown = (event) => {
            if (!event.defaultPrevented) {
                if (event.which === Util_1.KeyCode.enter || event.which === Util_1.KeyCode.space) {
                    this.processSortEvent(event);
                }
            }
        };
        this.onSort = onSort;
    }
    processSortEvent(event) {
        const clickedCell = (0, List_1.cellFromEvent)(event);
        if (clickedCell.rowIndex === -1) {
            const column = this.props.columns[clickedCell.cellIndex];
            // If the column is currently sorted ascending then we need to invert the sort.
            if (column && column.sortProps) {
                this.onSort(clickedCell.cellIndex, column.sortProps.sortOrder === Table_1.SortOrder.ascending ? Table_1.SortOrder.descending : Table_1.SortOrder.ascending, event);
                event.preventDefault();
            }
        }
    }
}
exports.TreeColumnSorting = TreeColumnSorting;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-card{border-radius:4px;overflow:hidden;padding:20px 0px}@media screen and (min-width: 0\\0){.bolt-card{border-radius:0}}@media (forced-colors: active){.bolt-card{border:solid 1px}}@media screen and (max-width: 600px){.bolt-card{border-radius:0}}.bolt-card-with-header{padding-top:0px}.bolt-card-content{overflow:auto}.bolt-card-footer{padding-top:12px}.bolt-card-no-vertical-padding{padding-top:0px;padding-bottom:0px}.bolt-card-white{background-color:#fff;background-color:var(--callout-background-color, #fff)}.bolt-table-card{padding-bottom:0px;padding-top:0px}.bolt-table-card .bolt-card-header{padding-bottom:0px}.bolt-table-card.no-column-headers .bolt-card-header{padding-bottom:20px;border-bottom:1px solid;border-bottom-color:#eaeaea;border-bottom-color:rgba(var(--palette-neutral-8, 234, 234, 234), 1)}.bolt-table-card .bolt-card-content{padding:0px}.bolt-table-card .bolt-header-commandbar{flex:auto;overflow:auto}.bolt-button.bolt-card-expand-button{margin-left:12px;margin-top:16px;margin-right:4px}.bolt-card-header-collapsible{padding-left:8px}.bolt-card-expandable-header.bolt-card-expandable-header{padding-left:8px}.bolt-card-header-collapsed.bolt-card-header-collapsed{padding-bottom:0px}\n", ""]);



/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-header-no-spacing-defined{padding-left:20px;padding-top:16px;padding-right:20px}.bolt-header-condensed{padding-top:8px;padding-bottom:8px}.bolt-header-default{padding-top:16px;padding-bottom:16px}.bolt-header-relaxed{padding-top:24px;padding-bottom:24px}.bolt-header-with-commandbar.bolt-header-condensed{padding-right:12px}.bolt-header-with-commandbar.bolt-header-default{padding-right:16px}.bolt-header-with-commandbar.bolt-header-relaxed{padding-right:28px}.bolt-header-with-commandbar{padding-right:16px}@media screen and (max-width: 600px){.bolt-header-with-commandbar{padding-right:20px}}.bolt-header-with-back-button{padding-left:16px}@media screen and (max-width: 600px){.bolt-header-with-back-button{flex-direction:column;padding-left:20px}}.bolt-header-title-area{flex-shrink:25}.bolt-header-content-area{min-width:0px}.bolt-header-title{padding-top:4px;padding-bottom:4px;margin-right:8px}.bolt-header-title.l{padding-top:0px;padding-bottom:0px}.bolt-header-title.s{padding-top:6px;padding-bottom:6px}@media screen and (max-width: 600px){.bolt-header-title{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}}.bolt-header-icon{font-size:1rem;margin-right:8px;margin-top:8px}.bolt-header-icon.l{margin-top:10px}.bolt-header-icon.s{margin-top:6px}.bolt-header-separator{height:1px;background-color:#f4f4f4;background-color:rgba(var(--palette-neutral-4, 244, 244, 244), 1)}.bolt-button.bolt-header-back-button{background-color:transparent;font-size:1rem;margin-right:8px}@media screen and (max-width: 600px){.bolt-button.bolt-header-back-button{padding:0px}.bolt-button.bolt-header-back-button .bolt-button-text{font-size:0.75rem;color:rgba(0,0,0,0.55);color:var(--text-secondary-color, rgba(0,0,0,0.55));font-weight:normal}}\n", ""]);



/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-header-commandbar{margin-left:16px;padding-right:4px}.bolt-header-commandbar .responsive-placeholder{margin:0}.bolt-header-command-item-button .bolt-button.icon-only{padding:8px}.bolt-header-commandbar-no-right-padding{padding-right:0px}.bolt-header-command-item-separator{background-color:rgba(0,0,0,0.2);background-color:var(--palette-black-alpha-20, rgba(0,0,0,0.2));width:1px;margin:4px 8px}\n", ""]);



/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".focus-treatment:focus{outline:none}.bolt-focus-visible .bolt-tab.focus-treatment:focus,.bolt-focus-visible .bolt-tab.focus-treatment.focused{border-radius:3px;animation:ms-focus-shadow-with-border-pulse 4s ease-in-out infinite;box-shadow:0 0 0 3px rgba(0,120,212,0.23),0 0 0 1px #0078d4;box-shadow:0 0 0 3px var(--focus-pulse-max-color, rgba(0,120,212,0.23)),0 0 0 1px var(--focus-border-color, #0078d4)}@media (forced-colors: active){.bolt-focus-visible .bolt-tab.focus-treatment:focus,.bolt-focus-visible .bolt-tab.focus-treatment.focused{animation:none}}@media (forced-colors: active){.bolt-focus-visible .bolt-tab.focus-treatment:focus,.bolt-focus-visible .bolt-tab.focus-treatment.focused{border:1px solid Highlight;forced-color-adjust:none;color:windowtext}.bolt-focus-visible .bolt-tab.focus-treatment:focus>*,.bolt-focus-visible .bolt-tab.focus-treatment.focused>*{forced-color-adjust:auto}}.bolt-tab{color:inherit}.bolt-tabbar .vss-FilterBar{margin-top:0px;margin-bottom:0px;margin-left:8px;height:32px}.bolt-tabbar .vss-FilterBar .vss-FilterBar--list{align-items:center}.bolt-tabbar .vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item.vss-FilterBar--item-keyword-container{margin-right:0px}.bolt-tabbar .vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--action{display:none}.bolt-tabbar.sticky{position:sticky;background-color:#fff;background-color:var(--background-color, #fff);z-index:2;top:0px}.bolt-tabbar-grey.sticky{background-color:#f8f8f8;background-color:rgba(var(--palette-neutral-2, 248, 248, 248), 1)}.bolt-tabbar-on-callout.sticky{background-color:#fff;background-color:var(--callout-background-color, #fff)}@supports (-ms-ime-align: auto){.bolt-tabbar.sticky.sticky{position:relative}}@media screen and (max-width: 600px){.bolt-tabbar-tabs{overflow-x:auto}}.bolt-tabbar-tabs.compact .bolt-tab{height:2rem;text-decoration:none;cursor:pointer;background-color:transparent;color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9));display:inline-block;margin-right:0px;padding:0 8px;text-align:center;position:relative;border:0;overflow:visible}.bolt-tabbar-tabs.compact .bolt-tab .bolt-tab-text{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.bolt-tabbar-tabs.compact .bolt-tab .bolt-tab-inner-container{height:100%;display:flex;align-items:center}.bolt-tabbar-tabs.compact .bolt-tab .bolt-tab-badge{margin-left:4px;max-width:80px;cursor:pointer}.bolt-tabbar-tabs.compact .bolt-tab .bolt-tab-badge .bolt-pill-focusable{overflow:hidden}.bolt-tabbar-tabs.compact .bolt-tab:last-child{margin-right:0}@media (forced-colors: active){.bolt-tabbar-tabs.compact .bolt-tab{border:1px solid transparent}}.bolt-tabbar-tabs.compact .bolt-tab:hover{color:inherit}@media (forced-colors: active){.bolt-tabbar-tabs.compact .bolt-tab:hover{border-color:Highlight}}.bolt-tabbar-tabs.compact .bolt-tab .bolt-tab-text::before{content:attr(data-content);display:block;font-weight:normal;height:0px;visibility:hidden}.bolt-tabbar-tabs.compact .bolt-tab .bolt-tab-text::after{content:attr(data-content);display:block;font-weight:600;height:0px;visibility:hidden}.bolt-tabbar-tabs.compact .bolt-tab .bolt-tab-icon+.bolt-tab-text{margin-left:4px}.bolt-tabbar-tabs.compact .bolt-tab.selected .bolt-tab-inner-container{font-weight:600;padding-top:2px;border-bottom:2px solid #0078d4;border-bottom:2px solid var(--communication-background, #0078d4)}.bolt-tabbar-tabs.tall .bolt-tab{height:3rem;text-decoration:none;cursor:pointer;background-color:transparent;color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9));display:inline-block;margin-right:0px;padding:0 8px;text-align:center;position:relative;border:0;overflow:visible}.bolt-tabbar-tabs.tall .bolt-tab .bolt-tab-text{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.bolt-tabbar-tabs.tall .bolt-tab .bolt-tab-inner-container{height:100%;display:flex;align-items:center}.bolt-tabbar-tabs.tall .bolt-tab .bolt-tab-badge{margin-left:4px;max-width:80px;cursor:pointer}.bolt-tabbar-tabs.tall .bolt-tab .bolt-tab-badge .bolt-pill-focusable{overflow:hidden}.bolt-tabbar-tabs.tall .bolt-tab:last-child{margin-right:0}@media (forced-colors: active){.bolt-tabbar-tabs.tall .bolt-tab{border:1px solid transparent}}.bolt-tabbar-tabs.tall .bolt-tab:hover{color:inherit}@media (forced-colors: active){.bolt-tabbar-tabs.tall .bolt-tab:hover{border-color:Highlight}}.bolt-tabbar-tabs.tall .bolt-tab .bolt-tab-text::before{content:attr(data-content);display:block;font-weight:normal;height:0px;visibility:hidden}.bolt-tabbar-tabs.tall .bolt-tab .bolt-tab-text::after{content:attr(data-content);display:block;font-weight:600;height:0px;visibility:hidden}.bolt-tabbar-tabs.tall .bolt-tab .bolt-tab-icon+.bolt-tab-text{margin-left:4px}.bolt-tabbar-tabs.tall .bolt-tab.selected .bolt-tab-inner-container{font-weight:600;padding-top:2px;border-bottom:2px solid #0078d4;border-bottom:2px solid var(--communication-background, #0078d4)}.bolt-tabbar-tabs.large-link .bolt-tab{height:2.5rem;text-decoration:none;cursor:pointer;background-color:transparent;color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9));display:inline-block;margin-right:0px;padding:0 8px;text-align:center;position:relative;border:0;overflow:visible}.bolt-tabbar-tabs.large-link .bolt-tab .bolt-tab-text{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.bolt-tabbar-tabs.large-link .bolt-tab .bolt-tab-inner-container{height:100%;display:flex;align-items:center}.bolt-tabbar-tabs.large-link .bolt-tab .bolt-tab-badge{margin-left:4px;max-width:80px;cursor:pointer}.bolt-tabbar-tabs.large-link .bolt-tab .bolt-tab-badge .bolt-pill-focusable{overflow:hidden}.bolt-tabbar-tabs.large-link .bolt-tab:last-child{margin-right:0}@media (forced-colors: active){.bolt-tabbar-tabs.large-link .bolt-tab{border:1px solid transparent}}.bolt-tabbar-tabs.large-link .bolt-tab:hover{color:inherit}@media (forced-colors: active){.bolt-tabbar-tabs.large-link .bolt-tab:hover{border-color:Highlight}}.bolt-tabbar-tabs.large-link .bolt-tab .bolt-tab-text::before{content:attr(data-content);display:block;font-weight:normal;height:0px;visibility:hidden}.bolt-tabbar-tabs.large-link .bolt-tab .bolt-tab-text::after{content:attr(data-content);display:block;font-weight:600;height:0px;visibility:hidden}.bolt-tabbar-tabs.large-link .bolt-tab .bolt-tab-icon+.bolt-tab-text{margin-left:4px}.bolt-tabbar-tabs.large-link .bolt-tab.selected .bolt-tab-inner-container{font-weight:600;padding-top:2px;border-bottom:2px solid #0078d4;border-bottom:2px solid var(--communication-background, #0078d4)}.bolt-tablist{border-right:1px solid rgba(0,0,0,0.2);border-right:1px solid var(--palette-black-alpha-20, rgba(0,0,0,0.2));overflow:auto}.bolt-tablist-tabs .bolt-tab{height:32px;text-decoration:none;cursor:pointer;background-color:transparent;color:rgba(0,0,0,0.9);color:var(--text-primary-color, rgba(0,0,0,0.9));display:inline-block;padding-left:32px}.bolt-tablist-tabs .bolt-tab .bolt-tab-text{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.bolt-tablist-tabs .bolt-tab .bolt-tab-inner-container{height:100%;display:flex;align-items:center}.bolt-tablist-tabs .bolt-tab .bolt-tab-badge{margin-left:4px;max-width:80px;cursor:pointer}.bolt-tablist-tabs .bolt-tab .bolt-tab-badge .bolt-pill-focusable{overflow:hidden}.bolt-tablist-tabs .bolt-tab.selected{background-color:#eaeaea;background-color:rgba(var(--palette-neutral-8, 234, 234, 234), 1)}@media (forced-colors: active){.bolt-tablist-tabs .bolt-tab.selected{background:highlight;forced-color-adjust:none}.bolt-tablist-tabs .bolt-tab.selected .bolt-tab-text{color:windowtext;background:window}}.bolt-tablist-tabs a.bolt-tab{color:inherit}.bolt-tablist-heading{align-items:center;height:32px;margin-top:16px;padding-left:32px}.bolt-tablist-title{height:48px;align-items:center;display:flex;padding-left:32px}.bolt-tablist-subtitle{padding-left:32px}\n", ""]);



/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(390);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-messagecard.bolt-card{padding:0}.bolt-messagecard .bolt-messagebar{padding:0}.bolt-messagecard .bolt-messagebar.severity-info{background-color:#fff;background-color:rgba(var(--palette-neutral-0, 255, 255, 255), 1)}.bolt-messagecard .bolt-messagebar-content{padding:16px 20px 16px 12px;border-radius:4px}\n", ""]);



/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(392);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-messagebar{padding:8px 16px}.bolt-messagebar.severity-info{background-color:rgba(0,0,0,0.02);background-color:var(--palette-black-alpha-2, rgba(0,0,0,0.02))}.bolt-messagebar.severity-success{background-color:#dff6dd;background-color:var(--status-success-background, #dff6dd)}.bolt-messagebar.severity-warning{background-color:#fbf2ec;background-color:var(--status-warning-background, #fbf2ec)}.bolt-messagebar.severity-error{background-color:#f9ebeb;background-color:var(--status-error-background, #f9ebeb)}.bolt-messagebar-icons,.bolt-messagebar-buttons{max-height:50px}.bolt-messagebar-icon{margin-left:8px;margin-right:16px}.severity-info .bolt-messagebar-icon{color:#0078d4;color:var(--status-info-foreground, #0078d4)}.severity-success .bolt-messagebar-icon{color:#107c10;color:var(--status-success-foreground, #107c10)}.severity-warning .bolt-messagebar-icon{color:#b18525;color:var(--status-warning-icon-foreground, #b18525)}.severity-error .bolt-messagebar-icon{color:#cd4a45;color:var(--status-error-foreground, #cd4a45)}.bolt-messagebar-message{align-items:center;min-height:32px}.bolt-messagebar-message:not(:last-child){margin-right:90px}.bolt-messagebar-buttons{margin-left:auto}.bolt-messagebar-buttons .bolt-button:first-child{margin-left:8px}.bolt-messagebar-buttons .bolt-button:not(:last-child){margin-right:8px}.bolt-messagebar-close-button.bolt-button.icon-only{font-size:1rem;padding:0px;margin-right:-4px}.bolt-messagebar.mobile .bolt-messagebar-content{padding:10px 20px 10px 10px}.bolt-messagebar.mobile .bolt-messagebar-icon{align-self:flex-start;margin:0px;padding:6px 8px}.bolt-messagebar.mobile .bolt-messagebar-message{margin:0px 0px 6px 8px;min-height:0px}.bolt-messagebar.mobile .bolt-messagebar-buttons{margin-bottom:6px;margin-top:2px}.bolt-messagebar.mobile .bolt-messagebar-close-button{margin-left:8px;margin-right:-10px}\n", ""]);



/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(394);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".bolt-page>.bolt-tabbar{padding:0 32px 0 24px}@media screen and (max-width: 600px){.bolt-page>.bolt-tabbar{padding-left:12px;padding-right:20px}}.bolt-page>.bolt-header{padding-top:24px;padding-bottom:0px;margin-left:12px;margin-right:12px;z-index:3}@media screen and (max-width: 600px){.bolt-page>.bolt-header{padding-top:16px;margin-left:0;margin-right:0}}.bolt-page>.bolt-header .bolt-header-commandbar-no-right-padding{padding-right:4px}@media screen and (max-width: 600px){.bolt-page>.bolt-header .bolt-header-commandbar-no-right-padding{padding-right:0}}.bolt-page>.vss-FilterBar{margin-left:32px;margin-right:32px}.bolt-page .page-content{padding-left:32px;padding-right:32px;padding-bottom:16px}@media screen and (max-width: 600px){.bolt-page .page-content{padding-left:0;padding-right:0}}.bolt-page .page-content-top{padding-top:16px}.bolt-page .page-content-bottom{padding-bottom:16px}.bolt-page .page-content-left{padding-left:32px}@media screen and (max-width: 600px){.bolt-page .page-content-left{padding-left:0}}.bolt-page .page-content-right{padding-right:32px}@media screen and (max-width: 600px){.bolt-page .page-content-right{padding-right:0}}.bolt-page-grey{background-color:#f8f8f8;background-color:rgba(var(--palette-neutral-2, 248, 248, 248), 1)}.bolt-page-white{background-color:#fff;background-color:var(--background-color, #fff)}\n", ""]);



/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// Module
exports.push([module.i, ".vss-ZeroData{flex-wrap:wrap;margin-top:35px}.vss-ZeroData .vss-ZeroDataItem{text-align:center}.vss-ZeroData .vss-ZeroDataItem .vss-ZeroDataItem--image,.vss-ZeroData .vss-ZeroDataItem .vss-ZeroDataItem--primary,.vss-ZeroData .vss-ZeroDataItem .vss-ZeroDataItem--secondary{margin-bottom:15px;max-width:100%}.vss-ZeroData .vss-ZeroDataItem .vss-ZeroDataItem--image:last-child,.vss-ZeroData .vss-ZeroDataItem .vss-ZeroDataItem--primary:last-child,.vss-ZeroData .vss-ZeroDataItem .vss-ZeroDataItem--secondary:last-child{margin-bottom:0}.vss-ZeroData.single .vss-ZeroDataItem{max-width:520px;min-width:10px}.vss-ZeroData.single .vss-ZeroDataItem .vss-ZeroDataItem--image{height:160px}.vss-ZeroData.single .vss-ZeroDataItem .vss-ZeroDataItem--icon-image{font-size:160px}.vss-ZeroData.multiple .vss-ZeroDataItem{max-width:235px;margin:0 20px}.vss-ZeroData.multiple .vss-ZeroDataItem .vss-ZeroDataItem--image{height:75px}.vss-ZeroData.multiple .vss-ZeroDataItem .vss-ZeroDataItem--action{margin-top:auto}\n", ""]);



/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "MessageCard", function() { return /* reexport */ MessageCard_MessageCard; });
__webpack_require__.d(__webpack_exports__, "MessageCardSeverity", function() { return /* reexport */ MessageCardSeverity; });

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/MessageCard/MessageCard.css
var MessageCard = __webpack_require__(389);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Card.js
var Card = __webpack_require__(84);

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/MessageBar/MessageBar.css
var MessageBar = __webpack_require__(391);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Util/Screen.js
var Screen = __webpack_require__(32);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Util/String.js
var Util_String = __webpack_require__(16);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Breakpoint.js
var Breakpoint = __webpack_require__(57);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Button.js
var Button = __webpack_require__(14);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/FocusZone.js + 2 modules
var FocusZone = __webpack_require__(7);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Icon.js + 2 modules
var Icon = __webpack_require__(9);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Resources.MessageBar.js
var DismissButtonLabel = "Dismiss {0} message";
var Error = "error";
var Info = "info";
var Success = "success";
var Warning = "warning";

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/MessageBar/MessageBar.Props.js
/**
 * Used to regulate the MessageBar's background color and default icon
 */
var MessageBarSeverity;
(function (MessageBarSeverity) {
    MessageBarSeverity["Info"] = "Info";
    MessageBarSeverity["Warning"] = "Warning";
    MessageBarSeverity["Error"] = "Error";
    MessageBarSeverity["Success"] = "Success";
})(MessageBarSeverity || (MessageBarSeverity = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/MessageBar/MessageBar.js














var MessageBar_MessageBar = function (props) {
    var buttonProps = props.buttonProps, className = props.className, messageClassName = props.messageClassName, iconProps = props.iconProps, onDismiss = props.onDismiss, _a = props.severity, severity = _a === void 0 ? MessageBarSeverity.Info : _a;
    var severityProps = MessageBarSeverityInternal[severity];
    var severityClassName = severityProps.className;
    var renderIconProps = iconProps || severityProps.defaultIconProps;
    var screenSize = external_commonjs_react_commonjs2_react_amd_React_root_React_["useContext"](Screen["b" /* ScreenContext */]);
    var _b = external_commonjs_react_commonjs2_react_amd_React_root_React_["useState"](screenSize.size.value === Screen["c" /* ScreenSize */].xsmall), mobile = _b[0], setMobile = _b[1];
    var dismissButtonLabel = Object(Util_String["a" /* format */])(DismissButtonLabel, getSeverityString(severity));
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])(className, "bolt-messagebar", severityClassName, mobile && "mobile") },
        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Breakpoint["Breakpoint"], { breakpoints: [1, Screen["a" /* ScreenBreakpoints */].small], onBreakpoint: function (index) { return setMobile(index === 0); } }),
        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](FocusZone["a" /* FocusZone */], { direction: FocusZone["c" /* FocusZoneDirection */].Horizontal },
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])("bolt-messagebar-content flex-grow", mobile ? "flex-column" : "flex-row") },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])("flex-row", messageClassName) },
                    external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-messagebar-icons flex-row" },
                        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Icon["Icon"], Object(tslib_es6["a" /* __assign */])({}, renderIconProps, { className: Object(Util["css"])(renderIconProps.className, "bolt-messagebar-icon medium") }))),
                    external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-messagebar-message flex-row flex-wrap flex-grow flex-shrink flex-center body-m word-break", role: severity === MessageBarSeverity.Error || severity === MessageBarSeverity.Warning ? "alert" : undefined }, props.children),
                    onDismiss && mobile && (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Button["Button"], { ariaLabel: dismissButtonLabel, className: "bolt-messagebar-close-button relative flex-self-start", iconProps: { iconName: "Cancel" }, key: "closeButton", onClick: onDismiss, subtle: true }))),
                ((onDismiss && !mobile) || (buttonProps && buttonProps.length > 0)) && (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "bolt-messagebar-buttons flex-noshrink flex-row flex-center flex-self-stretch" },
                    buttonProps && buttonProps.map(function (value, index) { return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Button["Button"], Object(tslib_es6["a" /* __assign */])({ key: index }, value)); }),
                    onDismiss && !mobile && (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Button["Button"], { ariaLabel: dismissButtonLabel, className: "bolt-messagebar-close-button", iconProps: { iconName: "Cancel" }, key: "closeButton", onClick: onDismiss, subtle: true }))))))));
};
function getSeverityString(severity) {
    switch (severity) {
        case MessageBarSeverity.Info:
            return Info;
        case MessageBarSeverity.Error:
            return Error;
        case MessageBarSeverity.Success:
            return Success;
        case MessageBarSeverity.Warning:
            return Warning;
    }
    return "";
}
// Set the function component's name so that Enzyme can recognize it
MessageBar_MessageBar.displayName = "MessageBar";
/**
 * Internal backing struct maps MessageBarSeverity to the necessary data
 */
var MessageBarSeverityInternal = {
    Info: {
        className: "severity-info",
        defaultIconProps: {
            iconName: "Info"
        }
    },
    Success: {
        className: "severity-success",
        defaultIconProps: { iconName: "Completed" }
    },
    Warning: {
        className: "severity-warning",
        defaultIconProps: { iconName: "Warning" }
    },
    Error: {
        className: "severity-error",
        defaultIconProps: { iconName: "ErrorBadge" }
    }
};

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/MessageBar.js



// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/MessageCard/MessageCard.js







var MessageCard_MessageCard = function (props) {
    var buttonProps = props.buttonProps, children = props.children, className = props.className, severity = props.severity, iconProps = props.iconProps, messageBarClassName = props.messageBarClassName, onDismiss = props.onDismiss;
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Card["CustomCard"], { className: Object(Util["css"])(className, "bolt-messagecard") },
        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](MessageBar_MessageBar, { buttonProps: buttonProps, children: children, className: messageBarClassName, iconProps: iconProps, onDismiss: onDismiss, severity: severity })));
};
MessageCard_MessageCard.displayName = "MessageCard";

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/MessageCard/MessageCard.Props.js
/**
 * Used to regulate the MessageBar's background color and default icon
 */
var MessageCardSeverity;
(function (MessageCardSeverity) {
    MessageCardSeverity["Info"] = "Info";
    MessageCardSeverity["Warning"] = "Warning";
    MessageCardSeverity["Error"] = "Error";
})(MessageCardSeverity || (MessageCardSeverity = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/MessageCard.js





/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "ZeroData", function() { return /* reexport */ ZeroData_ZeroData; });
__webpack_require__.d(__webpack_exports__, "ZeroDataActionType", function() { return /* reexport */ ZeroDataActionType; });

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/ZeroData/ZeroData.css
var ZeroData = __webpack_require__(194);

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Icon.js + 2 modules
var Icon = __webpack_require__(9);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Button.js
var Button = __webpack_require__(14);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Link.js
var Link = __webpack_require__(30);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/ZeroData/ZeroData.Props.js
/**
 * Defines options for displaying actions in ZeroData component.
 */
var ZeroDataActionType;
(function (ZeroDataActionType) {
    ZeroDataActionType[ZeroDataActionType["ctaButton"] = 0] = "ctaButton";
    ZeroDataActionType[ZeroDataActionType["link"] = 2] = "link";
})(ZeroDataActionType || (ZeroDataActionType = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/ZeroData/ZeroData.js










/**
 * Component for displaying helpful information when there is no data to show.
 */
var ZeroData_ZeroData = function (props) {
    return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](ZeroDataMultiple, { items: [props], className: props.className });
};
/**
 * Component for displaying helpful information when there is no data to show. This one displays
 * multiple (or one) ZeroDataItems.
 *
 * THIS CLASS IS NOT EXPORTED presently because no design for multiple ZeroDataItems has yet been
 * approved.
 */
var ZeroDataMultiple = function (props) {
    var multiple = props.items.length > 1;
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])("vss-ZeroData flex-row justify-center", multiple ? "multiple" : "single", props.className) }, props.items.map(function (item, index) { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](ZeroData_ZeroDataItem, { item: item, key: index, multiple: multiple })); })));
};
/**
 * Represents a single item for the ZeroData component.
 */
var ZeroData_ZeroDataItem = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(ZeroDataItem, _super);
    function ZeroDataItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZeroDataItem.prototype.render = function () {
        var item = this.props.item;
        var secondary;
        if (typeof item.secondaryText === "string") {
            secondary = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("span", null, item.secondaryText);
        }
        else {
            secondary = item.secondaryText;
        }
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])("vss-ZeroDataItem flex-column flex-center", this.props.multiple && "flex-grow") },
            item.iconProps ? (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Icon["Icon"], Object(tslib_es6["a" /* __assign */])({ className: "vss-ZeroDataItem--icon-image" }, item.iconProps))) : (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("img", { className: "vss-ZeroDataItem--image", src: item.imagePath, alt: item.imageAltText })),
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: Object(Util["css"])("vss-ZeroDataItem--primary margin-horizontal-16", this.props.multiple ? "title-m" : "title-l") }, item.primaryText),
            secondary && external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "vss-ZeroDataItem--secondary margin-horizontal-16" }, secondary),
            this.renderAction(item)));
    };
    ZeroDataItem.prototype.renderAction = function (item) {
        if (!item.actionText) {
            return null;
        }
        // actionType === 1 is for back-compat where it used to be button type
        // button type is rendered same as ctaButton now
        // we can remove actionType === 1 in 143
        if (item.actionType === ZeroDataActionType.ctaButton || item.actionType === 1) {
            var onActionClick = function (ev) {
                if (item.onActionClick) {
                    item.onActionClick.call(null, ev, item);
                }
            };
            var buttonProps = {
                className: "vss-ZeroDataItem--action",
                text: item.actionText,
                onClick: onActionClick,
                href: item.actionHref,
                role: item.actionHref ? "link" : undefined
            };
            return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Button["Button"], Object(tslib_es6["a" /* __assign */])({}, buttonProps, { primary: true }));
        }
        else {
            return external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Link["Link"], { href: item.actionHref }, item.actionText);
        }
    };
    return ZeroDataItem;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/ZeroData/index.js




// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/ZeroData.js



/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Page", function() { return /* reexport */ Page_Page_Page; });
__webpack_require__.d(__webpack_exports__, "Orientation", function() { return /* reexport */ Orientation; });

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Page/Page.css
var Page_Page = __webpack_require__(393);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Page/Page.Props.js
var Orientation;
(function (Orientation) {
    Orientation[Orientation["Vertical"] = 0] = "Vertical";
    Orientation[Orientation["Horizontal"] = 1] = "Horizontal";
})(Orientation || (Orientation = {}));

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/Observable.js
var Observable = __webpack_require__(4);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Intersection.js
var Intersection = __webpack_require__(34);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Surface.js + 2 modules
var Surface = __webpack_require__(18);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Tabs.js + 10 modules
var Tabs = __webpack_require__(66);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Page/Page.js











/**
 * Component for stitching together the various components that make a up a page.
 * Renders all children in a column-based flexbox.
 * If passed an observable selected tab id and contributed tab providers, will
 * wrap with a TabProvider component to provide context to consuming children.
 */
var Page_Page_Page = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(Page, _super);
    function Page() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Page.prototype.render = function () {
        var _this = this;
        var _a = this.props, tabProviders = _a.tabProviders, selectedTabId = _a.selectedTabId, tabGroups = _a.tabGroups, _b = _a.orientation, orientation = _b === void 0 ? Orientation.Vertical : _b, scrollableContainerRef = _a.scrollableContainerRef;
        var orientationClass = orientation === Orientation.Vertical ? "flex-column" : "flex-row";
        var page = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Surface["SurfaceContext"].Consumer, null, function (surfaceContext) { return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Intersection["Intersection"], null,
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { ref: scrollableContainerRef, className: Object(Util["css"])(_this.props.className, "bolt-page v-scroll-auto", orientationClass, surfaceContext.background === Surface["SurfaceBackground"].neutral && "bolt-page-grey", surfaceContext.background === Surface["SurfaceBackground"].normal && "bolt-page-white") }, _this.props.children))); }));
        if (selectedTabId) {
            page = (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Tabs["b" /* TabProvider */], { providers: tabProviders || new Observable["ObservableArray"]([]), selectedTabId: selectedTabId }, page));
        }
        if (tabGroups) {
            page = external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Tabs["a" /* TabGroupProvider */], { providers: tabGroups }, page);
        }
        return page;
    };
    return Page;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]));


// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Page.js




/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Status", function() { return /* reexport */ Status_Status; });
__webpack_require__.d(__webpack_exports__, "Statuses", function() { return /* reexport */ Statuses; });
__webpack_require__.d(__webpack_exports__, "StatusSize", function() { return /* reexport */ StatusSize; });

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/CommonImports.js
var CommonImports = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Core/core.css
var core = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Components/Status/Status.css
var Status = __webpack_require__(361);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/TooltipEx.js
var TooltipEx = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/azure-devops-ui/Util.js
var Util = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Status/Status.Props.js
var StatusSize;
(function (StatusSize) {
    StatusSize["s"] = "12";
    StatusSize["m"] = "16";
    StatusSize["l"] = "24";
    StatusSize["xl"] = "32";
})(StatusSize || (StatusSize = {}));

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Components/Status/Status.js







var xlViewBoxSize = "0 0 32 32";
var mViewBoxSize = "0 0 16 16";
var sViewBoxSize = "0 0 12 12";
var statusId = 1;
/**
 * Meant to be used in conjunction with the Statuses object:
 *
 * <Status {...Statuses.Success} size={StatusSize.m} />
 * <Status {...Statuses.Success} ariaLabel="Success" size={StatusSize.m} />
 * <Status {...Statuses.Success} size={StatusSize.l} text="Something important" />
 */
function Status_Status(props) {
    var animated = props.animated, ariaLabel = props.ariaLabel, className = props.className, color = props.color, onRenderIcon = props.onRenderIcon, text = props.text, tooltipContent = props.tooltipContent;
    var size = props.size === undefined ? StatusSize.xl : props.size;
    if (text) {
        return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](TooltipEx["Tooltip"], { renderContent: tooltipContent },
            external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { "aria-label": text, className: Object(Util["css"])("bolt-status-extended flex-row flex-center", color, className, size === StatusSize.xl && "xl") },
                onRenderIcon(Object(Util["css"])("bolt-status", color), size, animated),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("span", { className: Object(Util["css"])("bolt-status-text", size !== StatusSize.l ? "font-size-mm xl" : "font-size", color === "neutral" && "bolt-status-text-extra-padding") }, text))));
    }
    else {
        return onRenderIcon(Object(Util["css"])("bolt-status flex-noshrink", color, className), size, animated, ariaLabel);
    }
}
function Success(props) {
    switch (props.size) {
        case StatusSize.xl:
        case StatusSize.l: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: xlViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "16", cy: "16", r: "16" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { d: "M12.799 20.83l-.005-.003L9.94 17.97a1.5 1.5 0 1 1 2.121-2.12l1.8 1.798 6.209-6.21a1.5 1.5 0 1 1 2.12 2.122l-7.264 7.264-.005.006a1.5 1.5 0 0 1-2.121 0z", fill: "#fff" })));
        }
        case StatusSize.m: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: mViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "8", cy: "8", r: "8" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { d: "M6.062 11.144l-.003-.002-1.784-1.785A.937.937 0 1 1 5.6 8.031l1.125 1.124 3.88-3.88A.937.937 0 1 1 11.931 6.6l-4.54 4.54-.004.004a.938.938 0 0 1-1.325 0z", fill: "#fff" })));
        }
        case StatusSize.s:
        default: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: sViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "6", cy: "6", r: "6" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { d: "M4.74 8.19l-.002-.002-1.29-1.29a.677.677 0 1 1 .958-.957l.813.812 2.804-2.805a.678.678 0 0 1 .959.958L5.7 8.188l-.002.002a.678.678 0 0 1-.958 0z", fill: "#fff" })));
        }
    }
}
function Failed(props) {
    switch (props.size) {
        case StatusSize.xl:
        case StatusSize.l: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: xlViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "16", cy: "16", r: "16" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { d: "M21.99 9.99a1.5 1.5 0 0 0-2.122 0L16 13.856 12.132 9.99a1.5 1.5 0 0 0-2.121 2.122l3.868 3.868-3.89 3.889a1.5 1.5 0 0 0 2.122 2.121L16 18.1l3.89 3.89a1.5 1.5 0 0 0 2.12-2.122l-3.889-3.89 3.868-3.867a1.5 1.5 0 0 0 0-2.122z", fill: "#fff" })));
        }
        case StatusSize.m: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: mViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "8", cy: "8", r: "8" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { d: "M10.984 5.004a.9.9 0 0 1 0 1.272L9.27 7.99l1.74 1.741a.9.9 0 1 1-1.272 1.273l-1.74-1.741-1.742 1.74a.9.9 0 1 1-1.272-1.272l1.74-1.74-1.713-1.714a.9.9 0 0 1 1.273-1.273l1.713 1.713 1.714-1.713a.9.9 0 0 1 1.273 0z", fill: "#fff" })));
        }
        case StatusSize.s:
        default: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: sViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "6", cy: "6", r: "6" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { d: "M3.64 3.64a.75.75 0 0 1 1.06 0l1.294 1.294L7.288 3.64a.75.75 0 0 1 1.06 1.06L7.056 5.994l1.292 1.292a.75.75 0 0 1-1.06 1.06l-1.295-1.29-1.291 1.291a.75.75 0 1 1-1.06-1.06l1.292-1.293L3.64 4.7a.75.75 0 0 1 0-1.06z", fill: "#fff" })));
        }
    }
}
function Warning(props) {
    switch (props.size) {
        case StatusSize.xl:
        case StatusSize.l: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: xlViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "16", cy: "16", r: "16" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { d: "M16 7a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-3 0v-9A1.5 1.5 0 0 1 16 7zm-1.5 16a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0z", fill: "#fff" })));
        }
        case StatusSize.m: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: mViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "8", cy: "8", r: "8" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.91 3.9a.9.9 0 0 0-1.8 0v4.7a.9.9 0 1 0 1.8 0V3.9zm-.95 8.65a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8z", fill: "#fff" })));
        }
        case StatusSize.s:
        default: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: sViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "6", cy: "6", r: "6" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.75 2.75a.75.75 0 1 0-1.5 0v3.5a.75.75 0 1 0 1.5 0v-3.5zM6 9.5A.75.75 0 1 0 6 8a.75.75 0 0 0 0 1.5z", fill: "#fff" })));
        }
    }
}
function Running(props) {
    var className = Object(Util["css"])(props.className, props.animated !== false ? (props.size === StatusSize.s ? "small-animate" : "animate") : "");
    switch (props.size) {
        case StatusSize.xl:
        case StatusSize.l: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: className, size: props.size, viewBox: xlViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "16", cy: "16", r: "16" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { d: "M23 16c0 .325-.022.645-.065.959-.07.509.137 1.031.582 1.289.622.36 1.42.058 1.545-.65a9.204 9.204 0 0 0-6.27-10.367c-.664-.21-1.292.324-1.292 1.02 0 .532.374.982.873 1.162A7.003 7.003 0 0 1 23 16zM9 16a7.003 7.003 0 0 1 4.627-6.587c.5-.18.873-.63.873-1.161 0-.697-.628-1.232-1.292-1.02a9.204 9.204 0 0 0-6.27 10.367c.124.707.924 1.008 1.545.649.445-.258.652-.78.582-1.29A7.062 7.062 0 0 1 9 16zm7 7a6.975 6.975 0 0 0 4.728-1.838c.403-.37.999-.484 1.472-.21.586.339.744 1.121.261 1.597A9.17 9.17 0 0 1 16 25.2a9.17 9.17 0 0 1-6.461-2.65c-.482-.477-.325-1.26.261-1.599.473-.273 1.069-.159 1.472.21A6.975 6.975 0 0 0 16 23z", fill: "#fff" })));
        }
        case StatusSize.m: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: className, size: props.size, viewBox: mViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "8", cy: "8", r: "8" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { d: "M4.75 8a3.25 3.25 0 0 1 1.917-2.965c.33-.148.583-.453.583-.814 0-.479-.432-.848-.881-.683A4.752 4.752 0 0 0 3.29 8.62c.064.49.616.697 1.043.45.303-.175.443-.528.423-.877A3.304 3.304 0 0 1 4.75 8zm6.5 0c0 .065-.002.13-.006.194-.02.349.12.702.422.877.428.247.98.04 1.044-.45a4.752 4.752 0 0 0-3.078-5.084c-.45-.164-.882.205-.882.684 0 .36.253.666.583.814A3.25 3.25 0 0 1 11.25 8zM8 11.25c.758 0 1.455-.26 2.008-.694.293-.23.696-.31 1.019-.123.402.233.51.77.167 1.083A4.733 4.733 0 0 1 8 12.75c-1.23 0-2.35-.467-3.194-1.234-.344-.312-.235-.85.168-1.083.322-.186.725-.108 1.018.123.553.435 1.25.694 2.008.694z", fill: "#fff" })));
        }
        case StatusSize.s:
        default: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: className, size: props.size, viewBox: sViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "6", cy: "6", r: "6" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { d: "M7.768 4.232a2.5 2.5 0 0 1 .63 2.477c-.081.276-.042.586.161.79.295.294.79.243.94-.145a3.75 3.75 0 0 0-4.853-4.852c-.388.15-.439.644-.144.939.203.203.513.242.79.161a2.5 2.5 0 0 1 2.476.63zm-4.42 4.42a3.75 3.75 0 0 1-.846-4.006c.15-.388.644-.439.939-.145.203.204.242.514.161.79A2.5 2.5 0 0 0 6.71 8.398c.276-.081.586-.042.79.161.294.295.243.79-.145.94a3.75 3.75 0 0 1-4.006-.847z", fill: "#fff" })));
        }
    }
}
function Waiting(props) {
    switch (props.size) {
        case StatusSize.xl:
        case StatusSize.l: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: xlViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "16", cy: "16", r: "16" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { d: "M16 7a1.5 1.5 0 0 1 1.5 1.5v7.377l4.026 4.027a1.5 1.5 0 0 1-2.12 2.121l-4.428-4.427A1.496 1.496 0 0 1 14.5 16.5v-8A1.5 1.5 0 0 1 16 7z", fill: "#fff" })));
        }
        case StatusSize.m: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: mViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "8", cy: "8", r: "8" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { d: "M8 3.5a.9.9 0 0 1 .9.9v3.325l2.002 2.001A.9.9 0 1 1 9.629 11L7.408 8.778A.898.898 0 0 1 7.1 8.1V4.4a.9.9 0 0 1 .9-.9z", fill: "#fff" })));
        }
        case StatusSize.s:
        default: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: sViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "6", cy: "6", r: "6" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { d: "M6 2.6a.75.75 0 0 1 .75.75v2.439L8.122 7.16a.75.75 0 1 1-1.06 1.06L5.487 6.648A.747.747 0 0 1 5.25 6.1V3.35A.75.75 0 0 1 6 2.6z", fill: "#fff" })));
        }
    }
}
function Queued(props) {
    switch (props.size) {
        case StatusSize.xl:
        case StatusSize.l: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: xlViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "16", cy: "16", r: "15", fill: "#fff" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 32c8.836 0 16-7.163 16-16S24.836 0 16 0 0 7.163 0 16s7.164 16 16 16zm0-2c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14z" })));
        }
        case StatusSize.m: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: mViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "8", cy: "8", r: "7", fill: "#fff" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13z" })));
        }
        case StatusSize.s:
        default: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: sViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "6", cy: "6", r: "5", fill: "#fff" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12zm0-1.25a4.75 4.75 0 1 0 0-9.5 4.75 4.75 0 0 0 0 9.5z" })));
        }
    }
}
function Canceled(props) {
    switch (props.size) {
        case StatusSize.xl:
        case StatusSize.l: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: xlViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "16", cy: "16", r: "15", fill: "#fff" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16zm-2 0c0 7.732-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2s14 6.268 14 14zm-17.618-5.81a1.5 1.5 0 1 0-2.121 2.12l9.192 9.193a1.5 1.5 0 1 0 2.121-2.121l-9.192-9.193z" })));
        }
        case StatusSize.m: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: mViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "8", cy: "8", r: "7", fill: "#fff" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-1.5 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0zM6.41 5.124a.9.9 0 1 0-1.274 1.272l4.385 4.385a.9.9 0 1 0 1.272-1.273L6.41 5.124z" })));
        }
        case StatusSize.s:
        default: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: sViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "6", cy: "6", r: "5", fill: "#fff" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0zm-1.25 0a4.75 4.75 0 1 1-9.5 0 4.75 4.75 0 0 1 9.5 0zM4.941 3.89a.75.75 0 0 0-1.06 1.06l3.182 3.182a.75.75 0 1 0 1.06-1.06L4.941 3.89z" })));
        }
    }
}
function Skipped(props) {
    switch (props.size) {
        case StatusSize.xl:
        case StatusSize.l: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: xlViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "16", cy: "16", r: "15", fill: "#fff" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16zm-2 0c0 7.732-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2s14 6.268 14 14zM13.44 8.94a1.5 1.5 0 0 1 2.12 0l5.88 5.878A1.5 1.5 0 0 1 21.874 16c.034.423-.11.858-.434 1.182l-5.88 5.879a1.5 1.5 0 1 1-2.12-2.122L18.379 16l-4.94-4.94a1.5 1.5 0 0 1 0-2.12z" })));
        }
        case StatusSize.m: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: mViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "8", cy: "8", r: "7", fill: "#fff" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-1.5 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0zM6.752 4.372a.861.861 0 0 1 1.218 0l3.005 3.005a.86.86 0 0 1 .252.62.859.859 0 0 1-.252.626L7.97 11.628a.861.861 0 1 1-1.218-1.218L9.162 8l-2.41-2.41a.861.861 0 0 1 0-1.218z" })));
        }
        case StatusSize.s:
        default: {
            return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](Svg, { ariaLabel: props.ariaLabel, className: props.className, size: props.size, viewBox: sViewBoxSize },
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("circle", { cx: "6", cy: "6", r: "5", fill: "#fff" }),
                external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0zm-1.25 0a4.75 4.75 0 1 1-9.5 0 4.75 4.75 0 0 1 9.5 0zM4.97 3.47a.75.75 0 0 1 1.06 0l1.94 1.94c.162.16.234.378.217.59a.748.748 0 0 1-.217.59L6.03 8.53a.75.75 0 0 1-1.06-1.06L6.44 6 4.97 4.53a.75.75 0 0 1 0-1.06z" })));
        }
    }
}
function Svg(props) {
    var role = props.ariaLabel ? "img" : "presentation";
    var descId = props.ariaLabel ? Object(Util["getSafeId"])("status-" + statusId++ + "-desc") : undefined;
    return (external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("svg", { "aria-labelledby": descId, className: props.className, height: props.size, role: role, viewBox: props.viewBox, width: props.size, xmlns: "http://www.w3.org/2000/svg" },
        props.ariaLabel && external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("desc", { id: descId }, props.ariaLabel),
        props.children));
}
var Statuses = {
    Success: {
        color: "success",
        onRenderIcon: function (className, size, animated, ariaLabel) { return Success({ ariaLabel: ariaLabel, className: className, size: size }); }
    },
    Failed: {
        color: "failed",
        onRenderIcon: function (className, size, animated, ariaLabel) { return Failed({ ariaLabel: ariaLabel, className: className, size: size }); }
    },
    Warning: {
        color: "warning",
        onRenderIcon: function (className, size, animated, ariaLabel) { return Warning({ ariaLabel: ariaLabel, className: className, size: size }); }
    },
    Information: {
        color: "active",
        onRenderIcon: function (className, size, animated, ariaLabel) {
            return Warning({ ariaLabel: ariaLabel, className: Object(Util["css"])("rotate", className), size: size });
        }
    },
    Running: {
        color: "active",
        onRenderIcon: function (className, size, animated, ariaLabel) {
            return Running({ animated: animated, ariaLabel: ariaLabel, className: className, size: size });
        }
    },
    Waiting: {
        color: "active",
        onRenderIcon: function (className, size, animated, ariaLabel) { return Waiting({ ariaLabel: ariaLabel, className: className, size: size }); }
    },
    Queued: {
        color: "neutral",
        onRenderIcon: function (className, size, animated, ariaLabel) { return Queued({ ariaLabel: ariaLabel, className: className, size: size }); }
    },
    Canceled: {
        color: "neutral",
        onRenderIcon: function (className, size, animated, ariaLabel) { return Canceled({ ariaLabel: ariaLabel, className: className, size: size }); }
    },
    Skipped: {
        color: "neutral",
        onRenderIcon: function (className, size, animated, ariaLabel) { return Skipped({ ariaLabel: ariaLabel, className: className, size: size }); }
    }
};

// CONCATENATED MODULE: ./node_modules/azure-devops-ui/Status.js




/***/ })
/******/ ]);
});